webpackJsonp([1,0,2],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(57);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueRouter = __webpack_require__(226);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _vueResource = __webpack_require__(225);
	
	var _vueResource2 = _interopRequireDefault(_vueResource);
	
	var _sweetalert = __webpack_require__(95);
	
	var _sweetalert2 = _interopRequireDefault(_sweetalert);
	
	var _vueFilter = __webpack_require__(177);
	
	var _vueFilter2 = _interopRequireDefault(_vueFilter);
	
	var _mintUi = __webpack_require__(165);
	
	var _mintUi2 = _interopRequireDefault(_mintUi);
	
	__webpack_require__(135);
	
	__webpack_require__(157);
	
	__webpack_require__(158);
	
	__webpack_require__(156);
	
	__webpack_require__(159);
	
	__webpack_require__(160);
	
	__webpack_require__(162);
	
	__webpack_require__(161);
	
	var _auth_interceptor = __webpack_require__(94);
	
	var _auth_interceptor2 = _interopRequireDefault(_auth_interceptor);
	
	var _registerComponent = __webpack_require__(93);
	
	var _registerComponent2 = _interopRequireDefault(_registerComponent);
	
	__webpack_require__(83);
	
	__webpack_require__(86);
	
	__webpack_require__(84);
	
	__webpack_require__(90);
	
	__webpack_require__(85);
	
	__webpack_require__(87);
	
	__webpack_require__(88);
	
	var _App = __webpack_require__(190);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _Main = __webpack_require__(191);
	
	var _Main2 = _interopRequireDefault(_Main);
	
	var _gowhere = __webpack_require__(197);
	
	var _gowhere2 = _interopRequireDefault(_gowhere);
	
	var _card_qrcode = __webpack_require__(196);
	
	var _card_qrcode2 = _interopRequireDefault(_card_qrcode);
	
	var _card_choose = __webpack_require__(194);
	
	var _card_choose2 = _interopRequireDefault(_card_choose);
	
	var _card_online = __webpack_require__(195);
	
	var _card_online2 = _interopRequireDefault(_card_online);
	
	var _card_bind = __webpack_require__(193);
	
	var _card_bind2 = _interopRequireDefault(_card_bind);
	
	var _login = __webpack_require__(198);
	
	var _login2 = _interopRequireDefault(_login);
	
	var _loginPage = __webpack_require__(199);
	
	var _loginPage2 = _interopRequireDefault(_loginPage);
	
	var _recharge = __webpack_require__(200);
	
	var _recharge2 = _interopRequireDefault(_recharge);
	
	var _setup = __webpack_require__(201);
	
	var _setup2 = _interopRequireDefault(_setup);
	
	var _bill = __webpack_require__(192);
	
	var _bill2 = _interopRequireDefault(_bill);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueRouter2.default);
	_vue2.default.use(_vueResource2.default);
	_vue2.default.use(_sweetalert2.default);
	_vue2.default.use(_vueFilter2.default);
	_vue2.default.use(_mintUi2.default);
	
	(0, _auth_interceptor2.default)(_vue2.default);
	
	(0, _registerComponent2.default)(_vue2.default);
	
	_vue2.default.component(_mintUi.DatetimePicker.name, _mintUi.DatetimePicker);
	
	var router = new _vueRouter2.default({
	  routes: [{ path: '/main', component: _Main2.default }, { path: '/gowhere', component: _gowhere2.default }, { path: '/card_qrcode', component: _card_qrcode2.default }, { path: '/card_choose', component: _card_choose2.default }, { path: '/card_bind', component: _card_bind2.default }, { path: '/card_online', component: _card_online2.default }, { path: '/recharge', component: _recharge2.default }, { path: '/setup', component: _setup2.default }, { path: '/bill', component: _bill2.default }, { path: '/login', component: _login2.default }, { path: '/loginPage', component: _loginPage2.default }]
	});
	
	window.router = router;
	
	new _vue2.default({
	  router: router,
	  template: '<App/>',
	  components: {
	    App: _App2.default
	  },
	  data: {
	    eventHub: new _vue2.default()
	  }
	}).$mount('#app');

/***/ }),
/* 1 */
/***/ (function(module, exports) {

	// this module is a runtime utility for cleaner component module output and will
	// be included in the final webpack user bundle
	
	module.exports = function normalizeComponent (
	  rawScriptExports,
	  compiledTemplate,
	  scopeId,
	  cssModules
	) {
	  var esModule
	  var scriptExports = rawScriptExports = rawScriptExports || {}
	
	  // ES6 modules interop
	  var type = typeof rawScriptExports.default
	  if (type === 'object' || type === 'function') {
	    esModule = rawScriptExports
	    scriptExports = rawScriptExports.default
	  }
	
	  // Vue.extend constructor export interop
	  var options = typeof scriptExports === 'function'
	    ? scriptExports.options
	    : scriptExports
	
	  // render functions
	  if (compiledTemplate) {
	    options.render = compiledTemplate.render
	    options.staticRenderFns = compiledTemplate.staticRenderFns
	  }
	
	  // scopedId
	  if (scopeId) {
	    options._scopeId = scopeId
	  }
	
	  // inject cssModules
	  if (cssModules) {
	    var computed = Object.create(options.computed || null)
	    Object.keys(cssModules).forEach(function (key) {
	      var module = cssModules[key]
	      computed[key] = function () { return module }
	    })
	    options.computed = computed
	  }
	
	  return {
	    esModule: esModule,
	    exports: scriptExports,
	    options: options
	  }
	}


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * jQuery JavaScript Library v3.6.0
	 * https://jquery.com/
	 *
	 * Includes Sizzle.js
	 * https://sizzlejs.com/
	 *
	 * Copyright OpenJS Foundation and other contributors
	 * Released under the MIT license
	 * https://jquery.org/license
	 *
	 * Date: 2021-03-02T17:08Z
	 */
	( function( global, factory ) {
	
		"use strict";
	
		if ( typeof module === "object" && typeof module.exports === "object" ) {
	
			// For CommonJS and CommonJS-like environments where a proper `window`
			// is present, execute the factory and get jQuery.
			// For environments that do not have a `window` with a `document`
			// (such as Node.js), expose a factory as module.exports.
			// This accentuates the need for the creation of a real `window`.
			// e.g. var jQuery = require("jquery")(window);
			// See ticket #14549 for more info.
			module.exports = global.document ?
				factory( global, true ) :
				function( w ) {
					if ( !w.document ) {
						throw new Error( "jQuery requires a window with a document" );
					}
					return factory( w );
				};
		} else {
			factory( global );
		}
	
	// Pass this if window is not defined yet
	} )( typeof window !== "undefined" ? window : this, function( window, noGlobal ) {
	
	// Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
	// throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
	// arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
	// enough that all such attempts are guarded in a try block.
	"use strict";
	
	var arr = [];
	
	var getProto = Object.getPrototypeOf;
	
	var slice = arr.slice;
	
	var flat = arr.flat ? function( array ) {
		return arr.flat.call( array );
	} : function( array ) {
		return arr.concat.apply( [], array );
	};
	
	
	var push = arr.push;
	
	var indexOf = arr.indexOf;
	
	var class2type = {};
	
	var toString = class2type.toString;
	
	var hasOwn = class2type.hasOwnProperty;
	
	var fnToString = hasOwn.toString;
	
	var ObjectFunctionString = fnToString.call( Object );
	
	var support = {};
	
	var isFunction = function isFunction( obj ) {
	
			// Support: Chrome <=57, Firefox <=52
			// In some browsers, typeof returns "function" for HTML <object> elements
			// (i.e., `typeof document.createElement( "object" ) === "function"`).
			// We don't want to classify *any* DOM node as a function.
			// Support: QtWeb <=3.8.5, WebKit <=534.34, wkhtmltopdf tool <=0.12.5
			// Plus for old WebKit, typeof returns "function" for HTML collections
			// (e.g., `typeof document.getElementsByTagName("div") === "function"`). (gh-4756)
			return typeof obj === "function" && typeof obj.nodeType !== "number" &&
				typeof obj.item !== "function";
		};
	
	
	var isWindow = function isWindow( obj ) {
			return obj != null && obj === obj.window;
		};
	
	
	var document = window.document;
	
	
	
		var preservedScriptAttributes = {
			type: true,
			src: true,
			nonce: true,
			noModule: true
		};
	
		function DOMEval( code, node, doc ) {
			doc = doc || document;
	
			var i, val,
				script = doc.createElement( "script" );
	
			script.text = code;
			if ( node ) {
				for ( i in preservedScriptAttributes ) {
	
					// Support: Firefox 64+, Edge 18+
					// Some browsers don't support the "nonce" property on scripts.
					// On the other hand, just using `getAttribute` is not enough as
					// the `nonce` attribute is reset to an empty string whenever it
					// becomes browsing-context connected.
					// See https://github.com/whatwg/html/issues/2369
					// See https://html.spec.whatwg.org/#nonce-attributes
					// The `node.getAttribute` check was added for the sake of
					// `jQuery.globalEval` so that it can fake a nonce-containing node
					// via an object.
					val = node[ i ] || node.getAttribute && node.getAttribute( i );
					if ( val ) {
						script.setAttribute( i, val );
					}
				}
			}
			doc.head.appendChild( script ).parentNode.removeChild( script );
		}
	
	
	function toType( obj ) {
		if ( obj == null ) {
			return obj + "";
		}
	
		// Support: Android <=2.3 only (functionish RegExp)
		return typeof obj === "object" || typeof obj === "function" ?
			class2type[ toString.call( obj ) ] || "object" :
			typeof obj;
	}
	/* global Symbol */
	// Defining this global in .eslintrc.json would create a danger of using the global
	// unguarded in another place, it seems safer to define global only for this module
	
	
	
	var
		version = "3.6.0",
	
		// Define a local copy of jQuery
		jQuery = function( selector, context ) {
	
			// The jQuery object is actually just the init constructor 'enhanced'
			// Need init if jQuery is called (just allow error to be thrown if not included)
			return new jQuery.fn.init( selector, context );
		};
	
	jQuery.fn = jQuery.prototype = {
	
		// The current version of jQuery being used
		jquery: version,
	
		constructor: jQuery,
	
		// The default length of a jQuery object is 0
		length: 0,
	
		toArray: function() {
			return slice.call( this );
		},
	
		// Get the Nth element in the matched element set OR
		// Get the whole matched element set as a clean array
		get: function( num ) {
	
			// Return all the elements in a clean array
			if ( num == null ) {
				return slice.call( this );
			}
	
			// Return just the one element from the set
			return num < 0 ? this[ num + this.length ] : this[ num ];
		},
	
		// Take an array of elements and push it onto the stack
		// (returning the new matched element set)
		pushStack: function( elems ) {
	
			// Build a new jQuery matched element set
			var ret = jQuery.merge( this.constructor(), elems );
	
			// Add the old object onto the stack (as a reference)
			ret.prevObject = this;
	
			// Return the newly-formed element set
			return ret;
		},
	
		// Execute a callback for every element in the matched set.
		each: function( callback ) {
			return jQuery.each( this, callback );
		},
	
		map: function( callback ) {
			return this.pushStack( jQuery.map( this, function( elem, i ) {
				return callback.call( elem, i, elem );
			} ) );
		},
	
		slice: function() {
			return this.pushStack( slice.apply( this, arguments ) );
		},
	
		first: function() {
			return this.eq( 0 );
		},
	
		last: function() {
			return this.eq( -1 );
		},
	
		even: function() {
			return this.pushStack( jQuery.grep( this, function( _elem, i ) {
				return ( i + 1 ) % 2;
			} ) );
		},
	
		odd: function() {
			return this.pushStack( jQuery.grep( this, function( _elem, i ) {
				return i % 2;
			} ) );
		},
	
		eq: function( i ) {
			var len = this.length,
				j = +i + ( i < 0 ? len : 0 );
			return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
		},
	
		end: function() {
			return this.prevObject || this.constructor();
		},
	
		// For internal use only.
		// Behaves like an Array's method, not like a jQuery method.
		push: push,
		sort: arr.sort,
		splice: arr.splice
	};
	
	jQuery.extend = jQuery.fn.extend = function() {
		var options, name, src, copy, copyIsArray, clone,
			target = arguments[ 0 ] || {},
			i = 1,
			length = arguments.length,
			deep = false;
	
		// Handle a deep copy situation
		if ( typeof target === "boolean" ) {
			deep = target;
	
			// Skip the boolean and the target
			target = arguments[ i ] || {};
			i++;
		}
	
		// Handle case when target is a string or something (possible in deep copy)
		if ( typeof target !== "object" && !isFunction( target ) ) {
			target = {};
		}
	
		// Extend jQuery itself if only one argument is passed
		if ( i === length ) {
			target = this;
			i--;
		}
	
		for ( ; i < length; i++ ) {
	
			// Only deal with non-null/undefined values
			if ( ( options = arguments[ i ] ) != null ) {
	
				// Extend the base object
				for ( name in options ) {
					copy = options[ name ];
	
					// Prevent Object.prototype pollution
					// Prevent never-ending loop
					if ( name === "__proto__" || target === copy ) {
						continue;
					}
	
					// Recurse if we're merging plain objects or arrays
					if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
						( copyIsArray = Array.isArray( copy ) ) ) ) {
						src = target[ name ];
	
						// Ensure proper type for the source value
						if ( copyIsArray && !Array.isArray( src ) ) {
							clone = [];
						} else if ( !copyIsArray && !jQuery.isPlainObject( src ) ) {
							clone = {};
						} else {
							clone = src;
						}
						copyIsArray = false;
	
						// Never move original objects, clone them
						target[ name ] = jQuery.extend( deep, clone, copy );
	
					// Don't bring in undefined values
					} else if ( copy !== undefined ) {
						target[ name ] = copy;
					}
				}
			}
		}
	
		// Return the modified object
		return target;
	};
	
	jQuery.extend( {
	
		// Unique for each copy of jQuery on the page
		expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),
	
		// Assume jQuery is ready without the ready module
		isReady: true,
	
		error: function( msg ) {
			throw new Error( msg );
		},
	
		noop: function() {},
	
		isPlainObject: function( obj ) {
			var proto, Ctor;
	
			// Detect obvious negatives
			// Use toString instead of jQuery.type to catch host objects
			if ( !obj || toString.call( obj ) !== "[object Object]" ) {
				return false;
			}
	
			proto = getProto( obj );
	
			// Objects with no prototype (e.g., `Object.create( null )`) are plain
			if ( !proto ) {
				return true;
			}
	
			// Objects with prototype are plain iff they were constructed by a global Object function
			Ctor = hasOwn.call( proto, "constructor" ) && proto.constructor;
			return typeof Ctor === "function" && fnToString.call( Ctor ) === ObjectFunctionString;
		},
	
		isEmptyObject: function( obj ) {
			var name;
	
			for ( name in obj ) {
				return false;
			}
			return true;
		},
	
		// Evaluates a script in a provided context; falls back to the global one
		// if not specified.
		globalEval: function( code, options, doc ) {
			DOMEval( code, { nonce: options && options.nonce }, doc );
		},
	
		each: function( obj, callback ) {
			var length, i = 0;
	
			if ( isArrayLike( obj ) ) {
				length = obj.length;
				for ( ; i < length; i++ ) {
					if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
						break;
					}
				}
			} else {
				for ( i in obj ) {
					if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
						break;
					}
				}
			}
	
			return obj;
		},
	
		// results is for internal usage only
		makeArray: function( arr, results ) {
			var ret = results || [];
	
			if ( arr != null ) {
				if ( isArrayLike( Object( arr ) ) ) {
					jQuery.merge( ret,
						typeof arr === "string" ?
							[ arr ] : arr
					);
				} else {
					push.call( ret, arr );
				}
			}
	
			return ret;
		},
	
		inArray: function( elem, arr, i ) {
			return arr == null ? -1 : indexOf.call( arr, elem, i );
		},
	
		// Support: Android <=4.0 only, PhantomJS 1 only
		// push.apply(_, arraylike) throws on ancient WebKit
		merge: function( first, second ) {
			var len = +second.length,
				j = 0,
				i = first.length;
	
			for ( ; j < len; j++ ) {
				first[ i++ ] = second[ j ];
			}
	
			first.length = i;
	
			return first;
		},
	
		grep: function( elems, callback, invert ) {
			var callbackInverse,
				matches = [],
				i = 0,
				length = elems.length,
				callbackExpect = !invert;
	
			// Go through the array, only saving the items
			// that pass the validator function
			for ( ; i < length; i++ ) {
				callbackInverse = !callback( elems[ i ], i );
				if ( callbackInverse !== callbackExpect ) {
					matches.push( elems[ i ] );
				}
			}
	
			return matches;
		},
	
		// arg is for internal usage only
		map: function( elems, callback, arg ) {
			var length, value,
				i = 0,
				ret = [];
	
			// Go through the array, translating each of the items to their new values
			if ( isArrayLike( elems ) ) {
				length = elems.length;
				for ( ; i < length; i++ ) {
					value = callback( elems[ i ], i, arg );
	
					if ( value != null ) {
						ret.push( value );
					}
				}
	
			// Go through every key on the object,
			} else {
				for ( i in elems ) {
					value = callback( elems[ i ], i, arg );
	
					if ( value != null ) {
						ret.push( value );
					}
				}
			}
	
			// Flatten any nested arrays
			return flat( ret );
		},
	
		// A global GUID counter for objects
		guid: 1,
	
		// jQuery.support is not used in Core but other projects attach their
		// properties to it so it needs to exist.
		support: support
	} );
	
	if ( typeof Symbol === "function" ) {
		jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
	}
	
	// Populate the class2type map
	jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
		function( _i, name ) {
			class2type[ "[object " + name + "]" ] = name.toLowerCase();
		} );
	
	function isArrayLike( obj ) {
	
		// Support: real iOS 8.2 only (not reproducible in simulator)
		// `in` check used to prevent JIT error (gh-2145)
		// hasOwn isn't used here due to false negatives
		// regarding Nodelist length in IE
		var length = !!obj && "length" in obj && obj.length,
			type = toType( obj );
	
		if ( isFunction( obj ) || isWindow( obj ) ) {
			return false;
		}
	
		return type === "array" || length === 0 ||
			typeof length === "number" && length > 0 && ( length - 1 ) in obj;
	}
	var Sizzle =
	/*!
	 * Sizzle CSS Selector Engine v2.3.6
	 * https://sizzlejs.com/
	 *
	 * Copyright JS Foundation and other contributors
	 * Released under the MIT license
	 * https://js.foundation/
	 *
	 * Date: 2021-02-16
	 */
	( function( window ) {
	var i,
		support,
		Expr,
		getText,
		isXML,
		tokenize,
		compile,
		select,
		outermostContext,
		sortInput,
		hasDuplicate,
	
		// Local document vars
		setDocument,
		document,
		docElem,
		documentIsHTML,
		rbuggyQSA,
		rbuggyMatches,
		matches,
		contains,
	
		// Instance-specific data
		expando = "sizzle" + 1 * new Date(),
		preferredDoc = window.document,
		dirruns = 0,
		done = 0,
		classCache = createCache(),
		tokenCache = createCache(),
		compilerCache = createCache(),
		nonnativeSelectorCache = createCache(),
		sortOrder = function( a, b ) {
			if ( a === b ) {
				hasDuplicate = true;
			}
			return 0;
		},
	
		// Instance methods
		hasOwn = ( {} ).hasOwnProperty,
		arr = [],
		pop = arr.pop,
		pushNative = arr.push,
		push = arr.push,
		slice = arr.slice,
	
		// Use a stripped-down indexOf as it's faster than native
		// https://jsperf.com/thor-indexof-vs-for/5
		indexOf = function( list, elem ) {
			var i = 0,
				len = list.length;
			for ( ; i < len; i++ ) {
				if ( list[ i ] === elem ) {
					return i;
				}
			}
			return -1;
		},
	
		booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|" +
			"ismap|loop|multiple|open|readonly|required|scoped",
	
		// Regular expressions
	
		// http://www.w3.org/TR/css3-selectors/#whitespace
		whitespace = "[\\x20\\t\\r\\n\\f]",
	
		// https://www.w3.org/TR/css-syntax-3/#ident-token-diagram
		identifier = "(?:\\\\[\\da-fA-F]{1,6}" + whitespace +
			"?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+",
	
		// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
		attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +
	
			// Operator (capture 2)
			"*([*^$|!~]?=)" + whitespace +
	
			// "Attribute values must be CSS identifiers [capture 5]
			// or strings [capture 3 or capture 4]"
			"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" +
			whitespace + "*\\]",
	
		pseudos = ":(" + identifier + ")(?:\\((" +
	
			// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
			// 1. quoted (capture 3; capture 4 or capture 5)
			"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
	
			// 2. simple (capture 6)
			"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +
	
			// 3. anything else (capture 2)
			".*" +
			")\\)|)",
	
		// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
		rwhitespace = new RegExp( whitespace + "+", "g" ),
		rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" +
			whitespace + "+$", "g" ),
	
		rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
		rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace +
			"*" ),
		rdescend = new RegExp( whitespace + "|>" ),
	
		rpseudo = new RegExp( pseudos ),
		ridentifier = new RegExp( "^" + identifier + "$" ),
	
		matchExpr = {
			"ID": new RegExp( "^#(" + identifier + ")" ),
			"CLASS": new RegExp( "^\\.(" + identifier + ")" ),
			"TAG": new RegExp( "^(" + identifier + "|[*])" ),
			"ATTR": new RegExp( "^" + attributes ),
			"PSEUDO": new RegExp( "^" + pseudos ),
			"CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" +
				whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" +
				whitespace + "*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
			"bool": new RegExp( "^(?:" + booleans + ")$", "i" ),
	
			// For use in libraries implementing .is()
			// We use this for POS matching in `select`
			"needsContext": new RegExp( "^" + whitespace +
				"*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace +
				"*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
		},
	
		rhtml = /HTML$/i,
		rinputs = /^(?:input|select|textarea|button)$/i,
		rheader = /^h\d$/i,
	
		rnative = /^[^{]+\{\s*\[native \w/,
	
		// Easily-parseable/retrievable ID or TAG or CLASS selectors
		rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
	
		rsibling = /[+~]/,
	
		// CSS escapes
		// http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
		runescape = new RegExp( "\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\([^\\r\\n\\f])", "g" ),
		funescape = function( escape, nonHex ) {
			var high = "0x" + escape.slice( 1 ) - 0x10000;
	
			return nonHex ?
	
				// Strip the backslash prefix from a non-hex escape sequence
				nonHex :
	
				// Replace a hexadecimal escape sequence with the encoded Unicode code point
				// Support: IE <=11+
				// For values outside the Basic Multilingual Plane (BMP), manually construct a
				// surrogate pair
				high < 0 ?
					String.fromCharCode( high + 0x10000 ) :
					String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
		},
	
		// CSS string/identifier serialization
		// https://drafts.csswg.org/cssom/#common-serializing-idioms
		rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
		fcssescape = function( ch, asCodePoint ) {
			if ( asCodePoint ) {
	
				// U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
				if ( ch === "\0" ) {
					return "\uFFFD";
				}
	
				// Control characters and (dependent upon position) numbers get escaped as code points
				return ch.slice( 0, -1 ) + "\\" +
					ch.charCodeAt( ch.length - 1 ).toString( 16 ) + " ";
			}
	
			// Other potentially-special ASCII characters get backslash-escaped
			return "\\" + ch;
		},
	
		// Used for iframes
		// See setDocument()
		// Removing the function wrapper causes a "Permission Denied"
		// error in IE
		unloadHandler = function() {
			setDocument();
		},
	
		inDisabledFieldset = addCombinator(
			function( elem ) {
				return elem.disabled === true && elem.nodeName.toLowerCase() === "fieldset";
			},
			{ dir: "parentNode", next: "legend" }
		);
	
	// Optimize for push.apply( _, NodeList )
	try {
		push.apply(
			( arr = slice.call( preferredDoc.childNodes ) ),
			preferredDoc.childNodes
		);
	
		// Support: Android<4.0
		// Detect silently failing push.apply
		// eslint-disable-next-line no-unused-expressions
		arr[ preferredDoc.childNodes.length ].nodeType;
	} catch ( e ) {
		push = { apply: arr.length ?
	
			// Leverage slice if possible
			function( target, els ) {
				pushNative.apply( target, slice.call( els ) );
			} :
	
			// Support: IE<9
			// Otherwise append directly
			function( target, els ) {
				var j = target.length,
					i = 0;
	
				// Can't trust NodeList.length
				while ( ( target[ j++ ] = els[ i++ ] ) ) {}
				target.length = j - 1;
			}
		};
	}
	
	function Sizzle( selector, context, results, seed ) {
		var m, i, elem, nid, match, groups, newSelector,
			newContext = context && context.ownerDocument,
	
			// nodeType defaults to 9, since context defaults to document
			nodeType = context ? context.nodeType : 9;
	
		results = results || [];
	
		// Return early from calls with invalid selector or context
		if ( typeof selector !== "string" || !selector ||
			nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {
	
			return results;
		}
	
		// Try to shortcut find operations (as opposed to filters) in HTML documents
		if ( !seed ) {
			setDocument( context );
			context = context || document;
	
			if ( documentIsHTML ) {
	
				// If the selector is sufficiently simple, try using a "get*By*" DOM method
				// (excepting DocumentFragment context, where the methods don't exist)
				if ( nodeType !== 11 && ( match = rquickExpr.exec( selector ) ) ) {
	
					// ID selector
					if ( ( m = match[ 1 ] ) ) {
	
						// Document context
						if ( nodeType === 9 ) {
							if ( ( elem = context.getElementById( m ) ) ) {
	
								// Support: IE, Opera, Webkit
								// TODO: identify versions
								// getElementById can match elements by name instead of ID
								if ( elem.id === m ) {
									results.push( elem );
									return results;
								}
							} else {
								return results;
							}
	
						// Element context
						} else {
	
							// Support: IE, Opera, Webkit
							// TODO: identify versions
							// getElementById can match elements by name instead of ID
							if ( newContext && ( elem = newContext.getElementById( m ) ) &&
								contains( context, elem ) &&
								elem.id === m ) {
	
								results.push( elem );
								return results;
							}
						}
	
					// Type selector
					} else if ( match[ 2 ] ) {
						push.apply( results, context.getElementsByTagName( selector ) );
						return results;
	
					// Class selector
					} else if ( ( m = match[ 3 ] ) && support.getElementsByClassName &&
						context.getElementsByClassName ) {
	
						push.apply( results, context.getElementsByClassName( m ) );
						return results;
					}
				}
	
				// Take advantage of querySelectorAll
				if ( support.qsa &&
					!nonnativeSelectorCache[ selector + " " ] &&
					( !rbuggyQSA || !rbuggyQSA.test( selector ) ) &&
	
					// Support: IE 8 only
					// Exclude object elements
					( nodeType !== 1 || context.nodeName.toLowerCase() !== "object" ) ) {
	
					newSelector = selector;
					newContext = context;
	
					// qSA considers elements outside a scoping root when evaluating child or
					// descendant combinators, which is not what we want.
					// In such cases, we work around the behavior by prefixing every selector in the
					// list with an ID selector referencing the scope context.
					// The technique has to be used as well when a leading combinator is used
					// as such selectors are not recognized by querySelectorAll.
					// Thanks to Andrew Dupont for this technique.
					if ( nodeType === 1 &&
						( rdescend.test( selector ) || rcombinators.test( selector ) ) ) {
	
						// Expand context for sibling selectors
						newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
							context;
	
						// We can use :scope instead of the ID hack if the browser
						// supports it & if we're not changing the context.
						if ( newContext !== context || !support.scope ) {
	
							// Capture the context ID, setting it first if necessary
							if ( ( nid = context.getAttribute( "id" ) ) ) {
								nid = nid.replace( rcssescape, fcssescape );
							} else {
								context.setAttribute( "id", ( nid = expando ) );
							}
						}
	
						// Prefix every selector in the list
						groups = tokenize( selector );
						i = groups.length;
						while ( i-- ) {
							groups[ i ] = ( nid ? "#" + nid : ":scope" ) + " " +
								toSelector( groups[ i ] );
						}
						newSelector = groups.join( "," );
					}
	
					try {
						push.apply( results,
							newContext.querySelectorAll( newSelector )
						);
						return results;
					} catch ( qsaError ) {
						nonnativeSelectorCache( selector, true );
					} finally {
						if ( nid === expando ) {
							context.removeAttribute( "id" );
						}
					}
				}
			}
		}
	
		// All others
		return select( selector.replace( rtrim, "$1" ), context, results, seed );
	}
	
	/**
	 * Create key-value caches of limited size
	 * @returns {function(string, object)} Returns the Object data after storing it on itself with
	 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
	 *	deleting the oldest entry
	 */
	function createCache() {
		var keys = [];
	
		function cache( key, value ) {
	
			// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
			if ( keys.push( key + " " ) > Expr.cacheLength ) {
	
				// Only keep the most recent entries
				delete cache[ keys.shift() ];
			}
			return ( cache[ key + " " ] = value );
		}
		return cache;
	}
	
	/**
	 * Mark a function for special use by Sizzle
	 * @param {Function} fn The function to mark
	 */
	function markFunction( fn ) {
		fn[ expando ] = true;
		return fn;
	}
	
	/**
	 * Support testing using an element
	 * @param {Function} fn Passed the created element and returns a boolean result
	 */
	function assert( fn ) {
		var el = document.createElement( "fieldset" );
	
		try {
			return !!fn( el );
		} catch ( e ) {
			return false;
		} finally {
	
			// Remove from its parent by default
			if ( el.parentNode ) {
				el.parentNode.removeChild( el );
			}
	
			// release memory in IE
			el = null;
		}
	}
	
	/**
	 * Adds the same handler for all of the specified attrs
	 * @param {String} attrs Pipe-separated list of attributes
	 * @param {Function} handler The method that will be applied
	 */
	function addHandle( attrs, handler ) {
		var arr = attrs.split( "|" ),
			i = arr.length;
	
		while ( i-- ) {
			Expr.attrHandle[ arr[ i ] ] = handler;
		}
	}
	
	/**
	 * Checks document order of two siblings
	 * @param {Element} a
	 * @param {Element} b
	 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
	 */
	function siblingCheck( a, b ) {
		var cur = b && a,
			diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
				a.sourceIndex - b.sourceIndex;
	
		// Use IE sourceIndex if available on both nodes
		if ( diff ) {
			return diff;
		}
	
		// Check if b follows a
		if ( cur ) {
			while ( ( cur = cur.nextSibling ) ) {
				if ( cur === b ) {
					return -1;
				}
			}
		}
	
		return a ? 1 : -1;
	}
	
	/**
	 * Returns a function to use in pseudos for input types
	 * @param {String} type
	 */
	function createInputPseudo( type ) {
		return function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return name === "input" && elem.type === type;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for buttons
	 * @param {String} type
	 */
	function createButtonPseudo( type ) {
		return function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return ( name === "input" || name === "button" ) && elem.type === type;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for :enabled/:disabled
	 * @param {Boolean} disabled true for :disabled; false for :enabled
	 */
	function createDisabledPseudo( disabled ) {
	
		// Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
		return function( elem ) {
	
			// Only certain elements can match :enabled or :disabled
			// https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
			// https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
			if ( "form" in elem ) {
	
				// Check for inherited disabledness on relevant non-disabled elements:
				// * listed form-associated elements in a disabled fieldset
				//   https://html.spec.whatwg.org/multipage/forms.html#category-listed
				//   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
				// * option elements in a disabled optgroup
				//   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
				// All such elements have a "form" property.
				if ( elem.parentNode && elem.disabled === false ) {
	
					// Option elements defer to a parent optgroup if present
					if ( "label" in elem ) {
						if ( "label" in elem.parentNode ) {
							return elem.parentNode.disabled === disabled;
						} else {
							return elem.disabled === disabled;
						}
					}
	
					// Support: IE 6 - 11
					// Use the isDisabled shortcut property to check for disabled fieldset ancestors
					return elem.isDisabled === disabled ||
	
						// Where there is no isDisabled, check manually
						/* jshint -W018 */
						elem.isDisabled !== !disabled &&
						inDisabledFieldset( elem ) === disabled;
				}
	
				return elem.disabled === disabled;
	
			// Try to winnow out elements that can't be disabled before trusting the disabled property.
			// Some victims get caught in our net (label, legend, menu, track), but it shouldn't
			// even exist on them, let alone have a boolean value.
			} else if ( "label" in elem ) {
				return elem.disabled === disabled;
			}
	
			// Remaining elements are neither :enabled nor :disabled
			return false;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for positionals
	 * @param {Function} fn
	 */
	function createPositionalPseudo( fn ) {
		return markFunction( function( argument ) {
			argument = +argument;
			return markFunction( function( seed, matches ) {
				var j,
					matchIndexes = fn( [], seed.length, argument ),
					i = matchIndexes.length;
	
				// Match elements found at the specified indexes
				while ( i-- ) {
					if ( seed[ ( j = matchIndexes[ i ] ) ] ) {
						seed[ j ] = !( matches[ j ] = seed[ j ] );
					}
				}
			} );
		} );
	}
	
	/**
	 * Checks a node for validity as a Sizzle context
	 * @param {Element|Object=} context
	 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
	 */
	function testContext( context ) {
		return context && typeof context.getElementsByTagName !== "undefined" && context;
	}
	
	// Expose support vars for convenience
	support = Sizzle.support = {};
	
	/**
	 * Detects XML nodes
	 * @param {Element|Object} elem An element or a document
	 * @returns {Boolean} True iff elem is a non-HTML XML node
	 */
	isXML = Sizzle.isXML = function( elem ) {
		var namespace = elem && elem.namespaceURI,
			docElem = elem && ( elem.ownerDocument || elem ).documentElement;
	
		// Support: IE <=8
		// Assume HTML when documentElement doesn't yet exist, such as inside loading iframes
		// https://bugs.jquery.com/ticket/4833
		return !rhtml.test( namespace || docElem && docElem.nodeName || "HTML" );
	};
	
	/**
	 * Sets document-related variables once based on the current document
	 * @param {Element|Object} [doc] An element or document object to use to set the document
	 * @returns {Object} Returns the current document
	 */
	setDocument = Sizzle.setDocument = function( node ) {
		var hasCompare, subWindow,
			doc = node ? node.ownerDocument || node : preferredDoc;
	
		// Return early if doc is invalid or already selected
		// Support: IE 11+, Edge 17 - 18+
		// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
		// two documents; shallow comparisons work.
		// eslint-disable-next-line eqeqeq
		if ( doc == document || doc.nodeType !== 9 || !doc.documentElement ) {
			return document;
		}
	
		// Update global variables
		document = doc;
		docElem = document.documentElement;
		documentIsHTML = !isXML( document );
	
		// Support: IE 9 - 11+, Edge 12 - 18+
		// Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
		// Support: IE 11+, Edge 17 - 18+
		// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
		// two documents; shallow comparisons work.
		// eslint-disable-next-line eqeqeq
		if ( preferredDoc != document &&
			( subWindow = document.defaultView ) && subWindow.top !== subWindow ) {
	
			// Support: IE 11, Edge
			if ( subWindow.addEventListener ) {
				subWindow.addEventListener( "unload", unloadHandler, false );
	
			// Support: IE 9 - 10 only
			} else if ( subWindow.attachEvent ) {
				subWindow.attachEvent( "onunload", unloadHandler );
			}
		}
	
		// Support: IE 8 - 11+, Edge 12 - 18+, Chrome <=16 - 25 only, Firefox <=3.6 - 31 only,
		// Safari 4 - 5 only, Opera <=11.6 - 12.x only
		// IE/Edge & older browsers don't support the :scope pseudo-class.
		// Support: Safari 6.0 only
		// Safari 6.0 supports :scope but it's an alias of :root there.
		support.scope = assert( function( el ) {
			docElem.appendChild( el ).appendChild( document.createElement( "div" ) );
			return typeof el.querySelectorAll !== "undefined" &&
				!el.querySelectorAll( ":scope fieldset div" ).length;
		} );
	
		/* Attributes
		---------------------------------------------------------------------- */
	
		// Support: IE<8
		// Verify that getAttribute really returns attributes and not properties
		// (excepting IE8 booleans)
		support.attributes = assert( function( el ) {
			el.className = "i";
			return !el.getAttribute( "className" );
		} );
	
		/* getElement(s)By*
		---------------------------------------------------------------------- */
	
		// Check if getElementsByTagName("*") returns only elements
		support.getElementsByTagName = assert( function( el ) {
			el.appendChild( document.createComment( "" ) );
			return !el.getElementsByTagName( "*" ).length;
		} );
	
		// Support: IE<9
		support.getElementsByClassName = rnative.test( document.getElementsByClassName );
	
		// Support: IE<10
		// Check if getElementById returns elements by name
		// The broken getElementById methods don't pick up programmatically-set names,
		// so use a roundabout getElementsByName test
		support.getById = assert( function( el ) {
			docElem.appendChild( el ).id = expando;
			return !document.getElementsByName || !document.getElementsByName( expando ).length;
		} );
	
		// ID filter and find
		if ( support.getById ) {
			Expr.filter[ "ID" ] = function( id ) {
				var attrId = id.replace( runescape, funescape );
				return function( elem ) {
					return elem.getAttribute( "id" ) === attrId;
				};
			};
			Expr.find[ "ID" ] = function( id, context ) {
				if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
					var elem = context.getElementById( id );
					return elem ? [ elem ] : [];
				}
			};
		} else {
			Expr.filter[ "ID" ] =  function( id ) {
				var attrId = id.replace( runescape, funescape );
				return function( elem ) {
					var node = typeof elem.getAttributeNode !== "undefined" &&
						elem.getAttributeNode( "id" );
					return node && node.value === attrId;
				};
			};
	
			// Support: IE 6 - 7 only
			// getElementById is not reliable as a find shortcut
			Expr.find[ "ID" ] = function( id, context ) {
				if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
					var node, i, elems,
						elem = context.getElementById( id );
	
					if ( elem ) {
	
						// Verify the id attribute
						node = elem.getAttributeNode( "id" );
						if ( node && node.value === id ) {
							return [ elem ];
						}
	
						// Fall back on getElementsByName
						elems = context.getElementsByName( id );
						i = 0;
						while ( ( elem = elems[ i++ ] ) ) {
							node = elem.getAttributeNode( "id" );
							if ( node && node.value === id ) {
								return [ elem ];
							}
						}
					}
	
					return [];
				}
			};
		}
	
		// Tag
		Expr.find[ "TAG" ] = support.getElementsByTagName ?
			function( tag, context ) {
				if ( typeof context.getElementsByTagName !== "undefined" ) {
					return context.getElementsByTagName( tag );
	
				// DocumentFragment nodes don't have gEBTN
				} else if ( support.qsa ) {
					return context.querySelectorAll( tag );
				}
			} :
	
			function( tag, context ) {
				var elem,
					tmp = [],
					i = 0,
	
					// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
					results = context.getElementsByTagName( tag );
	
				// Filter out possible comments
				if ( tag === "*" ) {
					while ( ( elem = results[ i++ ] ) ) {
						if ( elem.nodeType === 1 ) {
							tmp.push( elem );
						}
					}
	
					return tmp;
				}
				return results;
			};
	
		// Class
		Expr.find[ "CLASS" ] = support.getElementsByClassName && function( className, context ) {
			if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
				return context.getElementsByClassName( className );
			}
		};
	
		/* QSA/matchesSelector
		---------------------------------------------------------------------- */
	
		// QSA and matchesSelector support
	
		// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
		rbuggyMatches = [];
	
		// qSa(:focus) reports false when true (Chrome 21)
		// We allow this because of a bug in IE8/9 that throws an error
		// whenever `document.activeElement` is accessed on an iframe
		// So, we allow :focus to pass through QSA all the time to avoid the IE error
		// See https://bugs.jquery.com/ticket/13378
		rbuggyQSA = [];
	
		if ( ( support.qsa = rnative.test( document.querySelectorAll ) ) ) {
	
			// Build QSA regex
			// Regex strategy adopted from Diego Perini
			assert( function( el ) {
	
				var input;
	
				// Select is set to empty string on purpose
				// This is to test IE's treatment of not explicitly
				// setting a boolean content attribute,
				// since its presence should be enough
				// https://bugs.jquery.com/ticket/12359
				docElem.appendChild( el ).innerHTML = "<a id='" + expando + "'></a>" +
					"<select id='" + expando + "-\r\\' msallowcapture=''>" +
					"<option selected=''></option></select>";
	
				// Support: IE8, Opera 11-12.16
				// Nothing should be selected when empty strings follow ^= or $= or *=
				// The test attribute must be unknown in Opera but "safe" for WinRT
				// https://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
				if ( el.querySelectorAll( "[msallowcapture^='']" ).length ) {
					rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
				}
	
				// Support: IE8
				// Boolean attributes and "value" are not treated correctly
				if ( !el.querySelectorAll( "[selected]" ).length ) {
					rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
				}
	
				// Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
				if ( !el.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
					rbuggyQSA.push( "~=" );
				}
	
				// Support: IE 11+, Edge 15 - 18+
				// IE 11/Edge don't find elements on a `[name='']` query in some cases.
				// Adding a temporary attribute to the document before the selection works
				// around the issue.
				// Interestingly, IE 10 & older don't seem to have the issue.
				input = document.createElement( "input" );
				input.setAttribute( "name", "" );
				el.appendChild( input );
				if ( !el.querySelectorAll( "[name='']" ).length ) {
					rbuggyQSA.push( "\\[" + whitespace + "*name" + whitespace + "*=" +
						whitespace + "*(?:''|\"\")" );
				}
	
				// Webkit/Opera - :checked should return selected option elements
				// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
				// IE8 throws error here and will not see later tests
				if ( !el.querySelectorAll( ":checked" ).length ) {
					rbuggyQSA.push( ":checked" );
				}
	
				// Support: Safari 8+, iOS 8+
				// https://bugs.webkit.org/show_bug.cgi?id=136851
				// In-page `selector#id sibling-combinator selector` fails
				if ( !el.querySelectorAll( "a#" + expando + "+*" ).length ) {
					rbuggyQSA.push( ".#.+[+~]" );
				}
	
				// Support: Firefox <=3.6 - 5 only
				// Old Firefox doesn't throw on a badly-escaped identifier.
				el.querySelectorAll( "\\\f" );
				rbuggyQSA.push( "[\\r\\n\\f]" );
			} );
	
			assert( function( el ) {
				el.innerHTML = "<a href='' disabled='disabled'></a>" +
					"<select disabled='disabled'><option/></select>";
	
				// Support: Windows 8 Native Apps
				// The type and name attributes are restricted during .innerHTML assignment
				var input = document.createElement( "input" );
				input.setAttribute( "type", "hidden" );
				el.appendChild( input ).setAttribute( "name", "D" );
	
				// Support: IE8
				// Enforce case-sensitivity of name attribute
				if ( el.querySelectorAll( "[name=d]" ).length ) {
					rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
				}
	
				// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
				// IE8 throws error here and will not see later tests
				if ( el.querySelectorAll( ":enabled" ).length !== 2 ) {
					rbuggyQSA.push( ":enabled", ":disabled" );
				}
	
				// Support: IE9-11+
				// IE's :disabled selector does not pick up the children of disabled fieldsets
				docElem.appendChild( el ).disabled = true;
				if ( el.querySelectorAll( ":disabled" ).length !== 2 ) {
					rbuggyQSA.push( ":enabled", ":disabled" );
				}
	
				// Support: Opera 10 - 11 only
				// Opera 10-11 does not throw on post-comma invalid pseudos
				el.querySelectorAll( "*,:x" );
				rbuggyQSA.push( ",.*:" );
			} );
		}
	
		if ( ( support.matchesSelector = rnative.test( ( matches = docElem.matches ||
			docElem.webkitMatchesSelector ||
			docElem.mozMatchesSelector ||
			docElem.oMatchesSelector ||
			docElem.msMatchesSelector ) ) ) ) {
	
			assert( function( el ) {
	
				// Check to see if it's possible to do matchesSelector
				// on a disconnected node (IE 9)
				support.disconnectedMatch = matches.call( el, "*" );
	
				// This should fail with an exception
				// Gecko does not error, returns false instead
				matches.call( el, "[s!='']:x" );
				rbuggyMatches.push( "!=", pseudos );
			} );
		}
	
		rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join( "|" ) );
		rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join( "|" ) );
	
		/* Contains
		---------------------------------------------------------------------- */
		hasCompare = rnative.test( docElem.compareDocumentPosition );
	
		// Element contains another
		// Purposefully self-exclusive
		// As in, an element does not contain itself
		contains = hasCompare || rnative.test( docElem.contains ) ?
			function( a, b ) {
				var adown = a.nodeType === 9 ? a.documentElement : a,
					bup = b && b.parentNode;
				return a === bup || !!( bup && bup.nodeType === 1 && (
					adown.contains ?
						adown.contains( bup ) :
						a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
				) );
			} :
			function( a, b ) {
				if ( b ) {
					while ( ( b = b.parentNode ) ) {
						if ( b === a ) {
							return true;
						}
					}
				}
				return false;
			};
	
		/* Sorting
		---------------------------------------------------------------------- */
	
		// Document order sorting
		sortOrder = hasCompare ?
		function( a, b ) {
	
			// Flag for duplicate removal
			if ( a === b ) {
				hasDuplicate = true;
				return 0;
			}
	
			// Sort on method existence if only one input has compareDocumentPosition
			var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
			if ( compare ) {
				return compare;
			}
	
			// Calculate position if both inputs belong to the same document
			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			// eslint-disable-next-line eqeqeq
			compare = ( a.ownerDocument || a ) == ( b.ownerDocument || b ) ?
				a.compareDocumentPosition( b ) :
	
				// Otherwise we know they are disconnected
				1;
	
			// Disconnected nodes
			if ( compare & 1 ||
				( !support.sortDetached && b.compareDocumentPosition( a ) === compare ) ) {
	
				// Choose the first element that is related to our preferred document
				// Support: IE 11+, Edge 17 - 18+
				// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
				// two documents; shallow comparisons work.
				// eslint-disable-next-line eqeqeq
				if ( a == document || a.ownerDocument == preferredDoc &&
					contains( preferredDoc, a ) ) {
					return -1;
				}
	
				// Support: IE 11+, Edge 17 - 18+
				// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
				// two documents; shallow comparisons work.
				// eslint-disable-next-line eqeqeq
				if ( b == document || b.ownerDocument == preferredDoc &&
					contains( preferredDoc, b ) ) {
					return 1;
				}
	
				// Maintain original order
				return sortInput ?
					( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
					0;
			}
	
			return compare & 4 ? -1 : 1;
		} :
		function( a, b ) {
	
			// Exit early if the nodes are identical
			if ( a === b ) {
				hasDuplicate = true;
				return 0;
			}
	
			var cur,
				i = 0,
				aup = a.parentNode,
				bup = b.parentNode,
				ap = [ a ],
				bp = [ b ];
	
			// Parentless nodes are either documents or disconnected
			if ( !aup || !bup ) {
	
				// Support: IE 11+, Edge 17 - 18+
				// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
				// two documents; shallow comparisons work.
				/* eslint-disable eqeqeq */
				return a == document ? -1 :
					b == document ? 1 :
					/* eslint-enable eqeqeq */
					aup ? -1 :
					bup ? 1 :
					sortInput ?
					( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
					0;
	
			// If the nodes are siblings, we can do a quick check
			} else if ( aup === bup ) {
				return siblingCheck( a, b );
			}
	
			// Otherwise we need full lists of their ancestors for comparison
			cur = a;
			while ( ( cur = cur.parentNode ) ) {
				ap.unshift( cur );
			}
			cur = b;
			while ( ( cur = cur.parentNode ) ) {
				bp.unshift( cur );
			}
	
			// Walk down the tree looking for a discrepancy
			while ( ap[ i ] === bp[ i ] ) {
				i++;
			}
	
			return i ?
	
				// Do a sibling check if the nodes have a common ancestor
				siblingCheck( ap[ i ], bp[ i ] ) :
	
				// Otherwise nodes in our document sort first
				// Support: IE 11+, Edge 17 - 18+
				// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
				// two documents; shallow comparisons work.
				/* eslint-disable eqeqeq */
				ap[ i ] == preferredDoc ? -1 :
				bp[ i ] == preferredDoc ? 1 :
				/* eslint-enable eqeqeq */
				0;
		};
	
		return document;
	};
	
	Sizzle.matches = function( expr, elements ) {
		return Sizzle( expr, null, null, elements );
	};
	
	Sizzle.matchesSelector = function( elem, expr ) {
		setDocument( elem );
	
		if ( support.matchesSelector && documentIsHTML &&
			!nonnativeSelectorCache[ expr + " " ] &&
			( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
			( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {
	
			try {
				var ret = matches.call( elem, expr );
	
				// IE 9's matchesSelector returns false on disconnected nodes
				if ( ret || support.disconnectedMatch ||
	
					// As well, disconnected nodes are said to be in a document
					// fragment in IE 9
					elem.document && elem.document.nodeType !== 11 ) {
					return ret;
				}
			} catch ( e ) {
				nonnativeSelectorCache( expr, true );
			}
		}
	
		return Sizzle( expr, document, null, [ elem ] ).length > 0;
	};
	
	Sizzle.contains = function( context, elem ) {
	
		// Set document vars if needed
		// Support: IE 11+, Edge 17 - 18+
		// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
		// two documents; shallow comparisons work.
		// eslint-disable-next-line eqeqeq
		if ( ( context.ownerDocument || context ) != document ) {
			setDocument( context );
		}
		return contains( context, elem );
	};
	
	Sizzle.attr = function( elem, name ) {
	
		// Set document vars if needed
		// Support: IE 11+, Edge 17 - 18+
		// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
		// two documents; shallow comparisons work.
		// eslint-disable-next-line eqeqeq
		if ( ( elem.ownerDocument || elem ) != document ) {
			setDocument( elem );
		}
	
		var fn = Expr.attrHandle[ name.toLowerCase() ],
	
			// Don't get fooled by Object.prototype properties (jQuery #13807)
			val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
				fn( elem, name, !documentIsHTML ) :
				undefined;
	
		return val !== undefined ?
			val :
			support.attributes || !documentIsHTML ?
				elem.getAttribute( name ) :
				( val = elem.getAttributeNode( name ) ) && val.specified ?
					val.value :
					null;
	};
	
	Sizzle.escape = function( sel ) {
		return ( sel + "" ).replace( rcssescape, fcssescape );
	};
	
	Sizzle.error = function( msg ) {
		throw new Error( "Syntax error, unrecognized expression: " + msg );
	};
	
	/**
	 * Document sorting and removing duplicates
	 * @param {ArrayLike} results
	 */
	Sizzle.uniqueSort = function( results ) {
		var elem,
			duplicates = [],
			j = 0,
			i = 0;
	
		// Unless we *know* we can detect duplicates, assume their presence
		hasDuplicate = !support.detectDuplicates;
		sortInput = !support.sortStable && results.slice( 0 );
		results.sort( sortOrder );
	
		if ( hasDuplicate ) {
			while ( ( elem = results[ i++ ] ) ) {
				if ( elem === results[ i ] ) {
					j = duplicates.push( i );
				}
			}
			while ( j-- ) {
				results.splice( duplicates[ j ], 1 );
			}
		}
	
		// Clear input after sorting to release objects
		// See https://github.com/jquery/sizzle/pull/225
		sortInput = null;
	
		return results;
	};
	
	/**
	 * Utility function for retrieving the text value of an array of DOM nodes
	 * @param {Array|Element} elem
	 */
	getText = Sizzle.getText = function( elem ) {
		var node,
			ret = "",
			i = 0,
			nodeType = elem.nodeType;
	
		if ( !nodeType ) {
	
			// If no nodeType, this is expected to be an array
			while ( ( node = elem[ i++ ] ) ) {
	
				// Do not traverse comment nodes
				ret += getText( node );
			}
		} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {
	
			// Use textContent for elements
			// innerText usage removed for consistency of new lines (jQuery #11153)
			if ( typeof elem.textContent === "string" ) {
				return elem.textContent;
			} else {
	
				// Traverse its children
				for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
					ret += getText( elem );
				}
			}
		} else if ( nodeType === 3 || nodeType === 4 ) {
			return elem.nodeValue;
		}
	
		// Do not include comment or processing instruction nodes
	
		return ret;
	};
	
	Expr = Sizzle.selectors = {
	
		// Can be adjusted by the user
		cacheLength: 50,
	
		createPseudo: markFunction,
	
		match: matchExpr,
	
		attrHandle: {},
	
		find: {},
	
		relative: {
			">": { dir: "parentNode", first: true },
			" ": { dir: "parentNode" },
			"+": { dir: "previousSibling", first: true },
			"~": { dir: "previousSibling" }
		},
	
		preFilter: {
			"ATTR": function( match ) {
				match[ 1 ] = match[ 1 ].replace( runescape, funescape );
	
				// Move the given value to match[3] whether quoted or unquoted
				match[ 3 ] = ( match[ 3 ] || match[ 4 ] ||
					match[ 5 ] || "" ).replace( runescape, funescape );
	
				if ( match[ 2 ] === "~=" ) {
					match[ 3 ] = " " + match[ 3 ] + " ";
				}
	
				return match.slice( 0, 4 );
			},
	
			"CHILD": function( match ) {
	
				/* matches from matchExpr["CHILD"]
					1 type (only|nth|...)
					2 what (child|of-type)
					3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
					4 xn-component of xn+y argument ([+-]?\d*n|)
					5 sign of xn-component
					6 x of xn-component
					7 sign of y-component
					8 y of y-component
				*/
				match[ 1 ] = match[ 1 ].toLowerCase();
	
				if ( match[ 1 ].slice( 0, 3 ) === "nth" ) {
	
					// nth-* requires argument
					if ( !match[ 3 ] ) {
						Sizzle.error( match[ 0 ] );
					}
	
					// numeric x and y parameters for Expr.filter.CHILD
					// remember that false/true cast respectively to 0/1
					match[ 4 ] = +( match[ 4 ] ?
						match[ 5 ] + ( match[ 6 ] || 1 ) :
						2 * ( match[ 3 ] === "even" || match[ 3 ] === "odd" ) );
					match[ 5 ] = +( ( match[ 7 ] + match[ 8 ] ) || match[ 3 ] === "odd" );
	
					// other types prohibit arguments
				} else if ( match[ 3 ] ) {
					Sizzle.error( match[ 0 ] );
				}
	
				return match;
			},
	
			"PSEUDO": function( match ) {
				var excess,
					unquoted = !match[ 6 ] && match[ 2 ];
	
				if ( matchExpr[ "CHILD" ].test( match[ 0 ] ) ) {
					return null;
				}
	
				// Accept quoted arguments as-is
				if ( match[ 3 ] ) {
					match[ 2 ] = match[ 4 ] || match[ 5 ] || "";
	
				// Strip excess characters from unquoted arguments
				} else if ( unquoted && rpseudo.test( unquoted ) &&
	
					// Get excess from tokenize (recursively)
					( excess = tokenize( unquoted, true ) ) &&
	
					// advance to the next closing parenthesis
					( excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length ) ) {
	
					// excess is a negative index
					match[ 0 ] = match[ 0 ].slice( 0, excess );
					match[ 2 ] = unquoted.slice( 0, excess );
				}
	
				// Return only captures needed by the pseudo filter method (type and argument)
				return match.slice( 0, 3 );
			}
		},
	
		filter: {
	
			"TAG": function( nodeNameSelector ) {
				var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
				return nodeNameSelector === "*" ?
					function() {
						return true;
					} :
					function( elem ) {
						return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
					};
			},
	
			"CLASS": function( className ) {
				var pattern = classCache[ className + " " ];
	
				return pattern ||
					( pattern = new RegExp( "(^|" + whitespace +
						")" + className + "(" + whitespace + "|$)" ) ) && classCache(
							className, function( elem ) {
								return pattern.test(
									typeof elem.className === "string" && elem.className ||
									typeof elem.getAttribute !== "undefined" &&
										elem.getAttribute( "class" ) ||
									""
								);
					} );
			},
	
			"ATTR": function( name, operator, check ) {
				return function( elem ) {
					var result = Sizzle.attr( elem, name );
	
					if ( result == null ) {
						return operator === "!=";
					}
					if ( !operator ) {
						return true;
					}
	
					result += "";
	
					/* eslint-disable max-len */
	
					return operator === "=" ? result === check :
						operator === "!=" ? result !== check :
						operator === "^=" ? check && result.indexOf( check ) === 0 :
						operator === "*=" ? check && result.indexOf( check ) > -1 :
						operator === "$=" ? check && result.slice( -check.length ) === check :
						operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
						operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
						false;
					/* eslint-enable max-len */
	
				};
			},
	
			"CHILD": function( type, what, _argument, first, last ) {
				var simple = type.slice( 0, 3 ) !== "nth",
					forward = type.slice( -4 ) !== "last",
					ofType = what === "of-type";
	
				return first === 1 && last === 0 ?
	
					// Shortcut for :nth-*(n)
					function( elem ) {
						return !!elem.parentNode;
					} :
	
					function( elem, _context, xml ) {
						var cache, uniqueCache, outerCache, node, nodeIndex, start,
							dir = simple !== forward ? "nextSibling" : "previousSibling",
							parent = elem.parentNode,
							name = ofType && elem.nodeName.toLowerCase(),
							useCache = !xml && !ofType,
							diff = false;
	
						if ( parent ) {
	
							// :(first|last|only)-(child|of-type)
							if ( simple ) {
								while ( dir ) {
									node = elem;
									while ( ( node = node[ dir ] ) ) {
										if ( ofType ?
											node.nodeName.toLowerCase() === name :
											node.nodeType === 1 ) {
	
											return false;
										}
									}
	
									// Reverse direction for :only-* (if we haven't yet done so)
									start = dir = type === "only" && !start && "nextSibling";
								}
								return true;
							}
	
							start = [ forward ? parent.firstChild : parent.lastChild ];
	
							// non-xml :nth-child(...) stores cache data on `parent`
							if ( forward && useCache ) {
	
								// Seek `elem` from a previously-cached index
	
								// ...in a gzip-friendly way
								node = parent;
								outerCache = node[ expando ] || ( node[ expando ] = {} );
	
								// Support: IE <9 only
								// Defend against cloned attroperties (jQuery gh-1709)
								uniqueCache = outerCache[ node.uniqueID ] ||
									( outerCache[ node.uniqueID ] = {} );
	
								cache = uniqueCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex && cache[ 2 ];
								node = nodeIndex && parent.childNodes[ nodeIndex ];
	
								while ( ( node = ++nodeIndex && node && node[ dir ] ||
	
									// Fallback to seeking `elem` from the start
									( diff = nodeIndex = 0 ) || start.pop() ) ) {
	
									// When found, cache indexes on `parent` and break
									if ( node.nodeType === 1 && ++diff && node === elem ) {
										uniqueCache[ type ] = [ dirruns, nodeIndex, diff ];
										break;
									}
								}
	
							} else {
	
								// Use previously-cached element index if available
								if ( useCache ) {
	
									// ...in a gzip-friendly way
									node = elem;
									outerCache = node[ expando ] || ( node[ expando ] = {} );
	
									// Support: IE <9 only
									// Defend against cloned attroperties (jQuery gh-1709)
									uniqueCache = outerCache[ node.uniqueID ] ||
										( outerCache[ node.uniqueID ] = {} );
	
									cache = uniqueCache[ type ] || [];
									nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
									diff = nodeIndex;
								}
	
								// xml :nth-child(...)
								// or :nth-last-child(...) or :nth(-last)?-of-type(...)
								if ( diff === false ) {
	
									// Use the same loop as above to seek `elem` from the start
									while ( ( node = ++nodeIndex && node && node[ dir ] ||
										( diff = nodeIndex = 0 ) || start.pop() ) ) {
	
										if ( ( ofType ?
											node.nodeName.toLowerCase() === name :
											node.nodeType === 1 ) &&
											++diff ) {
	
											// Cache the index of each encountered element
											if ( useCache ) {
												outerCache = node[ expando ] ||
													( node[ expando ] = {} );
	
												// Support: IE <9 only
												// Defend against cloned attroperties (jQuery gh-1709)
												uniqueCache = outerCache[ node.uniqueID ] ||
													( outerCache[ node.uniqueID ] = {} );
	
												uniqueCache[ type ] = [ dirruns, diff ];
											}
	
											if ( node === elem ) {
												break;
											}
										}
									}
								}
							}
	
							// Incorporate the offset, then check against cycle size
							diff -= last;
							return diff === first || ( diff % first === 0 && diff / first >= 0 );
						}
					};
			},
	
			"PSEUDO": function( pseudo, argument ) {
	
				// pseudo-class names are case-insensitive
				// http://www.w3.org/TR/selectors/#pseudo-classes
				// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
				// Remember that setFilters inherits from pseudos
				var args,
					fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
						Sizzle.error( "unsupported pseudo: " + pseudo );
	
				// The user may use createPseudo to indicate that
				// arguments are needed to create the filter function
				// just as Sizzle does
				if ( fn[ expando ] ) {
					return fn( argument );
				}
	
				// But maintain support for old signatures
				if ( fn.length > 1 ) {
					args = [ pseudo, pseudo, "", argument ];
					return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
						markFunction( function( seed, matches ) {
							var idx,
								matched = fn( seed, argument ),
								i = matched.length;
							while ( i-- ) {
								idx = indexOf( seed, matched[ i ] );
								seed[ idx ] = !( matches[ idx ] = matched[ i ] );
							}
						} ) :
						function( elem ) {
							return fn( elem, 0, args );
						};
				}
	
				return fn;
			}
		},
	
		pseudos: {
	
			// Potentially complex pseudos
			"not": markFunction( function( selector ) {
	
				// Trim the selector passed to compile
				// to avoid treating leading and trailing
				// spaces as combinators
				var input = [],
					results = [],
					matcher = compile( selector.replace( rtrim, "$1" ) );
	
				return matcher[ expando ] ?
					markFunction( function( seed, matches, _context, xml ) {
						var elem,
							unmatched = matcher( seed, null, xml, [] ),
							i = seed.length;
	
						// Match elements unmatched by `matcher`
						while ( i-- ) {
							if ( ( elem = unmatched[ i ] ) ) {
								seed[ i ] = !( matches[ i ] = elem );
							}
						}
					} ) :
					function( elem, _context, xml ) {
						input[ 0 ] = elem;
						matcher( input, null, xml, results );
	
						// Don't keep the element (issue #299)
						input[ 0 ] = null;
						return !results.pop();
					};
			} ),
	
			"has": markFunction( function( selector ) {
				return function( elem ) {
					return Sizzle( selector, elem ).length > 0;
				};
			} ),
	
			"contains": markFunction( function( text ) {
				text = text.replace( runescape, funescape );
				return function( elem ) {
					return ( elem.textContent || getText( elem ) ).indexOf( text ) > -1;
				};
			} ),
	
			// "Whether an element is represented by a :lang() selector
			// is based solely on the element's language value
			// being equal to the identifier C,
			// or beginning with the identifier C immediately followed by "-".
			// The matching of C against the element's language value is performed case-insensitively.
			// The identifier C does not have to be a valid language name."
			// http://www.w3.org/TR/selectors/#lang-pseudo
			"lang": markFunction( function( lang ) {
	
				// lang value must be a valid identifier
				if ( !ridentifier.test( lang || "" ) ) {
					Sizzle.error( "unsupported lang: " + lang );
				}
				lang = lang.replace( runescape, funescape ).toLowerCase();
				return function( elem ) {
					var elemLang;
					do {
						if ( ( elemLang = documentIsHTML ?
							elem.lang :
							elem.getAttribute( "xml:lang" ) || elem.getAttribute( "lang" ) ) ) {
	
							elemLang = elemLang.toLowerCase();
							return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
						}
					} while ( ( elem = elem.parentNode ) && elem.nodeType === 1 );
					return false;
				};
			} ),
	
			// Miscellaneous
			"target": function( elem ) {
				var hash = window.location && window.location.hash;
				return hash && hash.slice( 1 ) === elem.id;
			},
	
			"root": function( elem ) {
				return elem === docElem;
			},
	
			"focus": function( elem ) {
				return elem === document.activeElement &&
					( !document.hasFocus || document.hasFocus() ) &&
					!!( elem.type || elem.href || ~elem.tabIndex );
			},
	
			// Boolean properties
			"enabled": createDisabledPseudo( false ),
			"disabled": createDisabledPseudo( true ),
	
			"checked": function( elem ) {
	
				// In CSS3, :checked should return both checked and selected elements
				// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
				var nodeName = elem.nodeName.toLowerCase();
				return ( nodeName === "input" && !!elem.checked ) ||
					( nodeName === "option" && !!elem.selected );
			},
	
			"selected": function( elem ) {
	
				// Accessing this property makes selected-by-default
				// options in Safari work properly
				if ( elem.parentNode ) {
					// eslint-disable-next-line no-unused-expressions
					elem.parentNode.selectedIndex;
				}
	
				return elem.selected === true;
			},
	
			// Contents
			"empty": function( elem ) {
	
				// http://www.w3.org/TR/selectors/#empty-pseudo
				// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
				//   but not by others (comment: 8; processing instruction: 7; etc.)
				// nodeType < 6 works because attributes (2) do not appear as children
				for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
					if ( elem.nodeType < 6 ) {
						return false;
					}
				}
				return true;
			},
	
			"parent": function( elem ) {
				return !Expr.pseudos[ "empty" ]( elem );
			},
	
			// Element/input types
			"header": function( elem ) {
				return rheader.test( elem.nodeName );
			},
	
			"input": function( elem ) {
				return rinputs.test( elem.nodeName );
			},
	
			"button": function( elem ) {
				var name = elem.nodeName.toLowerCase();
				return name === "input" && elem.type === "button" || name === "button";
			},
	
			"text": function( elem ) {
				var attr;
				return elem.nodeName.toLowerCase() === "input" &&
					elem.type === "text" &&
	
					// Support: IE<8
					// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
					( ( attr = elem.getAttribute( "type" ) ) == null ||
						attr.toLowerCase() === "text" );
			},
	
			// Position-in-collection
			"first": createPositionalPseudo( function() {
				return [ 0 ];
			} ),
	
			"last": createPositionalPseudo( function( _matchIndexes, length ) {
				return [ length - 1 ];
			} ),
	
			"eq": createPositionalPseudo( function( _matchIndexes, length, argument ) {
				return [ argument < 0 ? argument + length : argument ];
			} ),
	
			"even": createPositionalPseudo( function( matchIndexes, length ) {
				var i = 0;
				for ( ; i < length; i += 2 ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			} ),
	
			"odd": createPositionalPseudo( function( matchIndexes, length ) {
				var i = 1;
				for ( ; i < length; i += 2 ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			} ),
	
			"lt": createPositionalPseudo( function( matchIndexes, length, argument ) {
				var i = argument < 0 ?
					argument + length :
					argument > length ?
						length :
						argument;
				for ( ; --i >= 0; ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			} ),
	
			"gt": createPositionalPseudo( function( matchIndexes, length, argument ) {
				var i = argument < 0 ? argument + length : argument;
				for ( ; ++i < length; ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			} )
		}
	};
	
	Expr.pseudos[ "nth" ] = Expr.pseudos[ "eq" ];
	
	// Add button/input type pseudos
	for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
		Expr.pseudos[ i ] = createInputPseudo( i );
	}
	for ( i in { submit: true, reset: true } ) {
		Expr.pseudos[ i ] = createButtonPseudo( i );
	}
	
	// Easy API for creating new setFilters
	function setFilters() {}
	setFilters.prototype = Expr.filters = Expr.pseudos;
	Expr.setFilters = new setFilters();
	
	tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
		var matched, match, tokens, type,
			soFar, groups, preFilters,
			cached = tokenCache[ selector + " " ];
	
		if ( cached ) {
			return parseOnly ? 0 : cached.slice( 0 );
		}
	
		soFar = selector;
		groups = [];
		preFilters = Expr.preFilter;
	
		while ( soFar ) {
	
			// Comma and first run
			if ( !matched || ( match = rcomma.exec( soFar ) ) ) {
				if ( match ) {
	
					// Don't consume trailing commas as valid
					soFar = soFar.slice( match[ 0 ].length ) || soFar;
				}
				groups.push( ( tokens = [] ) );
			}
	
			matched = false;
	
			// Combinators
			if ( ( match = rcombinators.exec( soFar ) ) ) {
				matched = match.shift();
				tokens.push( {
					value: matched,
	
					// Cast descendant combinators to space
					type: match[ 0 ].replace( rtrim, " " )
				} );
				soFar = soFar.slice( matched.length );
			}
	
			// Filters
			for ( type in Expr.filter ) {
				if ( ( match = matchExpr[ type ].exec( soFar ) ) && ( !preFilters[ type ] ||
					( match = preFilters[ type ]( match ) ) ) ) {
					matched = match.shift();
					tokens.push( {
						value: matched,
						type: type,
						matches: match
					} );
					soFar = soFar.slice( matched.length );
				}
			}
	
			if ( !matched ) {
				break;
			}
		}
	
		// Return the length of the invalid excess
		// if we're just parsing
		// Otherwise, throw an error or return tokens
		return parseOnly ?
			soFar.length :
			soFar ?
				Sizzle.error( selector ) :
	
				// Cache the tokens
				tokenCache( selector, groups ).slice( 0 );
	};
	
	function toSelector( tokens ) {
		var i = 0,
			len = tokens.length,
			selector = "";
		for ( ; i < len; i++ ) {
			selector += tokens[ i ].value;
		}
		return selector;
	}
	
	function addCombinator( matcher, combinator, base ) {
		var dir = combinator.dir,
			skip = combinator.next,
			key = skip || dir,
			checkNonElements = base && key === "parentNode",
			doneName = done++;
	
		return combinator.first ?
	
			// Check against closest ancestor/preceding element
			function( elem, context, xml ) {
				while ( ( elem = elem[ dir ] ) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						return matcher( elem, context, xml );
					}
				}
				return false;
			} :
	
			// Check against all ancestor/preceding elements
			function( elem, context, xml ) {
				var oldCache, uniqueCache, outerCache,
					newCache = [ dirruns, doneName ];
	
				// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
				if ( xml ) {
					while ( ( elem = elem[ dir ] ) ) {
						if ( elem.nodeType === 1 || checkNonElements ) {
							if ( matcher( elem, context, xml ) ) {
								return true;
							}
						}
					}
				} else {
					while ( ( elem = elem[ dir ] ) ) {
						if ( elem.nodeType === 1 || checkNonElements ) {
							outerCache = elem[ expando ] || ( elem[ expando ] = {} );
	
							// Support: IE <9 only
							// Defend against cloned attroperties (jQuery gh-1709)
							uniqueCache = outerCache[ elem.uniqueID ] ||
								( outerCache[ elem.uniqueID ] = {} );
	
							if ( skip && skip === elem.nodeName.toLowerCase() ) {
								elem = elem[ dir ] || elem;
							} else if ( ( oldCache = uniqueCache[ key ] ) &&
								oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {
	
								// Assign to newCache so results back-propagate to previous elements
								return ( newCache[ 2 ] = oldCache[ 2 ] );
							} else {
	
								// Reuse newcache so results back-propagate to previous elements
								uniqueCache[ key ] = newCache;
	
								// A match means we're done; a fail means we have to keep checking
								if ( ( newCache[ 2 ] = matcher( elem, context, xml ) ) ) {
									return true;
								}
							}
						}
					}
				}
				return false;
			};
	}
	
	function elementMatcher( matchers ) {
		return matchers.length > 1 ?
			function( elem, context, xml ) {
				var i = matchers.length;
				while ( i-- ) {
					if ( !matchers[ i ]( elem, context, xml ) ) {
						return false;
					}
				}
				return true;
			} :
			matchers[ 0 ];
	}
	
	function multipleContexts( selector, contexts, results ) {
		var i = 0,
			len = contexts.length;
		for ( ; i < len; i++ ) {
			Sizzle( selector, contexts[ i ], results );
		}
		return results;
	}
	
	function condense( unmatched, map, filter, context, xml ) {
		var elem,
			newUnmatched = [],
			i = 0,
			len = unmatched.length,
			mapped = map != null;
	
		for ( ; i < len; i++ ) {
			if ( ( elem = unmatched[ i ] ) ) {
				if ( !filter || filter( elem, context, xml ) ) {
					newUnmatched.push( elem );
					if ( mapped ) {
						map.push( i );
					}
				}
			}
		}
	
		return newUnmatched;
	}
	
	function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
		if ( postFilter && !postFilter[ expando ] ) {
			postFilter = setMatcher( postFilter );
		}
		if ( postFinder && !postFinder[ expando ] ) {
			postFinder = setMatcher( postFinder, postSelector );
		}
		return markFunction( function( seed, results, context, xml ) {
			var temp, i, elem,
				preMap = [],
				postMap = [],
				preexisting = results.length,
	
				// Get initial elements from seed or context
				elems = seed || multipleContexts(
					selector || "*",
					context.nodeType ? [ context ] : context,
					[]
				),
	
				// Prefilter to get matcher input, preserving a map for seed-results synchronization
				matcherIn = preFilter && ( seed || !selector ) ?
					condense( elems, preMap, preFilter, context, xml ) :
					elems,
	
				matcherOut = matcher ?
	
					// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
					postFinder || ( seed ? preFilter : preexisting || postFilter ) ?
	
						// ...intermediate processing is necessary
						[] :
	
						// ...otherwise use results directly
						results :
					matcherIn;
	
			// Find primary matches
			if ( matcher ) {
				matcher( matcherIn, matcherOut, context, xml );
			}
	
			// Apply postFilter
			if ( postFilter ) {
				temp = condense( matcherOut, postMap );
				postFilter( temp, [], context, xml );
	
				// Un-match failing elements by moving them back to matcherIn
				i = temp.length;
				while ( i-- ) {
					if ( ( elem = temp[ i ] ) ) {
						matcherOut[ postMap[ i ] ] = !( matcherIn[ postMap[ i ] ] = elem );
					}
				}
			}
	
			if ( seed ) {
				if ( postFinder || preFilter ) {
					if ( postFinder ) {
	
						// Get the final matcherOut by condensing this intermediate into postFinder contexts
						temp = [];
						i = matcherOut.length;
						while ( i-- ) {
							if ( ( elem = matcherOut[ i ] ) ) {
	
								// Restore matcherIn since elem is not yet a final match
								temp.push( ( matcherIn[ i ] = elem ) );
							}
						}
						postFinder( null, ( matcherOut = [] ), temp, xml );
					}
	
					// Move matched elements from seed to results to keep them synchronized
					i = matcherOut.length;
					while ( i-- ) {
						if ( ( elem = matcherOut[ i ] ) &&
							( temp = postFinder ? indexOf( seed, elem ) : preMap[ i ] ) > -1 ) {
	
							seed[ temp ] = !( results[ temp ] = elem );
						}
					}
				}
	
			// Add elements to results, through postFinder if defined
			} else {
				matcherOut = condense(
					matcherOut === results ?
						matcherOut.splice( preexisting, matcherOut.length ) :
						matcherOut
				);
				if ( postFinder ) {
					postFinder( null, results, matcherOut, xml );
				} else {
					push.apply( results, matcherOut );
				}
			}
		} );
	}
	
	function matcherFromTokens( tokens ) {
		var checkContext, matcher, j,
			len = tokens.length,
			leadingRelative = Expr.relative[ tokens[ 0 ].type ],
			implicitRelative = leadingRelative || Expr.relative[ " " ],
			i = leadingRelative ? 1 : 0,
	
			// The foundational matcher ensures that elements are reachable from top-level context(s)
			matchContext = addCombinator( function( elem ) {
				return elem === checkContext;
			}, implicitRelative, true ),
			matchAnyContext = addCombinator( function( elem ) {
				return indexOf( checkContext, elem ) > -1;
			}, implicitRelative, true ),
			matchers = [ function( elem, context, xml ) {
				var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
					( checkContext = context ).nodeType ?
						matchContext( elem, context, xml ) :
						matchAnyContext( elem, context, xml ) );
	
				// Avoid hanging onto element (issue #299)
				checkContext = null;
				return ret;
			} ];
	
		for ( ; i < len; i++ ) {
			if ( ( matcher = Expr.relative[ tokens[ i ].type ] ) ) {
				matchers = [ addCombinator( elementMatcher( matchers ), matcher ) ];
			} else {
				matcher = Expr.filter[ tokens[ i ].type ].apply( null, tokens[ i ].matches );
	
				// Return special upon seeing a positional matcher
				if ( matcher[ expando ] ) {
	
					// Find the next relative operator (if any) for proper handling
					j = ++i;
					for ( ; j < len; j++ ) {
						if ( Expr.relative[ tokens[ j ].type ] ) {
							break;
						}
					}
					return setMatcher(
						i > 1 && elementMatcher( matchers ),
						i > 1 && toSelector(
	
						// If the preceding token was a descendant combinator, insert an implicit any-element `*`
						tokens
							.slice( 0, i - 1 )
							.concat( { value: tokens[ i - 2 ].type === " " ? "*" : "" } )
						).replace( rtrim, "$1" ),
						matcher,
						i < j && matcherFromTokens( tokens.slice( i, j ) ),
						j < len && matcherFromTokens( ( tokens = tokens.slice( j ) ) ),
						j < len && toSelector( tokens )
					);
				}
				matchers.push( matcher );
			}
		}
	
		return elementMatcher( matchers );
	}
	
	function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
		var bySet = setMatchers.length > 0,
			byElement = elementMatchers.length > 0,
			superMatcher = function( seed, context, xml, results, outermost ) {
				var elem, j, matcher,
					matchedCount = 0,
					i = "0",
					unmatched = seed && [],
					setMatched = [],
					contextBackup = outermostContext,
	
					// We must always have either seed elements or outermost context
					elems = seed || byElement && Expr.find[ "TAG" ]( "*", outermost ),
	
					// Use integer dirruns iff this is the outermost matcher
					dirrunsUnique = ( dirruns += contextBackup == null ? 1 : Math.random() || 0.1 ),
					len = elems.length;
	
				if ( outermost ) {
	
					// Support: IE 11+, Edge 17 - 18+
					// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
					// two documents; shallow comparisons work.
					// eslint-disable-next-line eqeqeq
					outermostContext = context == document || context || outermost;
				}
	
				// Add elements passing elementMatchers directly to results
				// Support: IE<9, Safari
				// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
				for ( ; i !== len && ( elem = elems[ i ] ) != null; i++ ) {
					if ( byElement && elem ) {
						j = 0;
	
						// Support: IE 11+, Edge 17 - 18+
						// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
						// two documents; shallow comparisons work.
						// eslint-disable-next-line eqeqeq
						if ( !context && elem.ownerDocument != document ) {
							setDocument( elem );
							xml = !documentIsHTML;
						}
						while ( ( matcher = elementMatchers[ j++ ] ) ) {
							if ( matcher( elem, context || document, xml ) ) {
								results.push( elem );
								break;
							}
						}
						if ( outermost ) {
							dirruns = dirrunsUnique;
						}
					}
	
					// Track unmatched elements for set filters
					if ( bySet ) {
	
						// They will have gone through all possible matchers
						if ( ( elem = !matcher && elem ) ) {
							matchedCount--;
						}
	
						// Lengthen the array for every element, matched or not
						if ( seed ) {
							unmatched.push( elem );
						}
					}
				}
	
				// `i` is now the count of elements visited above, and adding it to `matchedCount`
				// makes the latter nonnegative.
				matchedCount += i;
	
				// Apply set filters to unmatched elements
				// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
				// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
				// no element matchers and no seed.
				// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
				// case, which will result in a "00" `matchedCount` that differs from `i` but is also
				// numerically zero.
				if ( bySet && i !== matchedCount ) {
					j = 0;
					while ( ( matcher = setMatchers[ j++ ] ) ) {
						matcher( unmatched, setMatched, context, xml );
					}
	
					if ( seed ) {
	
						// Reintegrate element matches to eliminate the need for sorting
						if ( matchedCount > 0 ) {
							while ( i-- ) {
								if ( !( unmatched[ i ] || setMatched[ i ] ) ) {
									setMatched[ i ] = pop.call( results );
								}
							}
						}
	
						// Discard index placeholder values to get only actual matches
						setMatched = condense( setMatched );
					}
	
					// Add matches to results
					push.apply( results, setMatched );
	
					// Seedless set matches succeeding multiple successful matchers stipulate sorting
					if ( outermost && !seed && setMatched.length > 0 &&
						( matchedCount + setMatchers.length ) > 1 ) {
	
						Sizzle.uniqueSort( results );
					}
				}
	
				// Override manipulation of globals by nested matchers
				if ( outermost ) {
					dirruns = dirrunsUnique;
					outermostContext = contextBackup;
				}
	
				return unmatched;
			};
	
		return bySet ?
			markFunction( superMatcher ) :
			superMatcher;
	}
	
	compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
		var i,
			setMatchers = [],
			elementMatchers = [],
			cached = compilerCache[ selector + " " ];
	
		if ( !cached ) {
	
			// Generate a function of recursive functions that can be used to check each element
			if ( !match ) {
				match = tokenize( selector );
			}
			i = match.length;
			while ( i-- ) {
				cached = matcherFromTokens( match[ i ] );
				if ( cached[ expando ] ) {
					setMatchers.push( cached );
				} else {
					elementMatchers.push( cached );
				}
			}
	
			// Cache the compiled function
			cached = compilerCache(
				selector,
				matcherFromGroupMatchers( elementMatchers, setMatchers )
			);
	
			// Save selector and tokenization
			cached.selector = selector;
		}
		return cached;
	};
	
	/**
	 * A low-level selection function that works with Sizzle's compiled
	 *  selector functions
	 * @param {String|Function} selector A selector or a pre-compiled
	 *  selector function built with Sizzle.compile
	 * @param {Element} context
	 * @param {Array} [results]
	 * @param {Array} [seed] A set of elements to match against
	 */
	select = Sizzle.select = function( selector, context, results, seed ) {
		var i, tokens, token, type, find,
			compiled = typeof selector === "function" && selector,
			match = !seed && tokenize( ( selector = compiled.selector || selector ) );
	
		results = results || [];
	
		// Try to minimize operations if there is only one selector in the list and no seed
		// (the latter of which guarantees us context)
		if ( match.length === 1 ) {
	
			// Reduce context if the leading compound selector is an ID
			tokens = match[ 0 ] = match[ 0 ].slice( 0 );
			if ( tokens.length > 2 && ( token = tokens[ 0 ] ).type === "ID" &&
				context.nodeType === 9 && documentIsHTML && Expr.relative[ tokens[ 1 ].type ] ) {
	
				context = ( Expr.find[ "ID" ]( token.matches[ 0 ]
					.replace( runescape, funescape ), context ) || [] )[ 0 ];
				if ( !context ) {
					return results;
	
				// Precompiled matchers will still verify ancestry, so step up a level
				} else if ( compiled ) {
					context = context.parentNode;
				}
	
				selector = selector.slice( tokens.shift().value.length );
			}
	
			// Fetch a seed set for right-to-left matching
			i = matchExpr[ "needsContext" ].test( selector ) ? 0 : tokens.length;
			while ( i-- ) {
				token = tokens[ i ];
	
				// Abort if we hit a combinator
				if ( Expr.relative[ ( type = token.type ) ] ) {
					break;
				}
				if ( ( find = Expr.find[ type ] ) ) {
	
					// Search, expanding context for leading sibling combinators
					if ( ( seed = find(
						token.matches[ 0 ].replace( runescape, funescape ),
						rsibling.test( tokens[ 0 ].type ) && testContext( context.parentNode ) ||
							context
					) ) ) {
	
						// If seed is empty or no tokens remain, we can return early
						tokens.splice( i, 1 );
						selector = seed.length && toSelector( tokens );
						if ( !selector ) {
							push.apply( results, seed );
							return results;
						}
	
						break;
					}
				}
			}
		}
	
		// Compile and execute a filtering function if one is not provided
		// Provide `match` to avoid retokenization if we modified the selector above
		( compiled || compile( selector, match ) )(
			seed,
			context,
			!documentIsHTML,
			results,
			!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
		);
		return results;
	};
	
	// One-time assignments
	
	// Sort stability
	support.sortStable = expando.split( "" ).sort( sortOrder ).join( "" ) === expando;
	
	// Support: Chrome 14-35+
	// Always assume duplicates if they aren't passed to the comparison function
	support.detectDuplicates = !!hasDuplicate;
	
	// Initialize against the default document
	setDocument();
	
	// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
	// Detached nodes confoundingly follow *each other*
	support.sortDetached = assert( function( el ) {
	
		// Should return 1, but returns 4 (following)
		return el.compareDocumentPosition( document.createElement( "fieldset" ) ) & 1;
	} );
	
	// Support: IE<8
	// Prevent attribute/property "interpolation"
	// https://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
	if ( !assert( function( el ) {
		el.innerHTML = "<a href='#'></a>";
		return el.firstChild.getAttribute( "href" ) === "#";
	} ) ) {
		addHandle( "type|href|height|width", function( elem, name, isXML ) {
			if ( !isXML ) {
				return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
			}
		} );
	}
	
	// Support: IE<9
	// Use defaultValue in place of getAttribute("value")
	if ( !support.attributes || !assert( function( el ) {
		el.innerHTML = "<input/>";
		el.firstChild.setAttribute( "value", "" );
		return el.firstChild.getAttribute( "value" ) === "";
	} ) ) {
		addHandle( "value", function( elem, _name, isXML ) {
			if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
				return elem.defaultValue;
			}
		} );
	}
	
	// Support: IE<9
	// Use getAttributeNode to fetch booleans when getAttribute lies
	if ( !assert( function( el ) {
		return el.getAttribute( "disabled" ) == null;
	} ) ) {
		addHandle( booleans, function( elem, name, isXML ) {
			var val;
			if ( !isXML ) {
				return elem[ name ] === true ? name.toLowerCase() :
					( val = elem.getAttributeNode( name ) ) && val.specified ?
						val.value :
						null;
			}
		} );
	}
	
	return Sizzle;
	
	} )( window );
	
	
	
	jQuery.find = Sizzle;
	jQuery.expr = Sizzle.selectors;
	
	// Deprecated
	jQuery.expr[ ":" ] = jQuery.expr.pseudos;
	jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
	jQuery.text = Sizzle.getText;
	jQuery.isXMLDoc = Sizzle.isXML;
	jQuery.contains = Sizzle.contains;
	jQuery.escapeSelector = Sizzle.escape;
	
	
	
	
	var dir = function( elem, dir, until ) {
		var matched = [],
			truncate = until !== undefined;
	
		while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
			if ( elem.nodeType === 1 ) {
				if ( truncate && jQuery( elem ).is( until ) ) {
					break;
				}
				matched.push( elem );
			}
		}
		return matched;
	};
	
	
	var siblings = function( n, elem ) {
		var matched = [];
	
		for ( ; n; n = n.nextSibling ) {
			if ( n.nodeType === 1 && n !== elem ) {
				matched.push( n );
			}
		}
	
		return matched;
	};
	
	
	var rneedsContext = jQuery.expr.match.needsContext;
	
	
	
	function nodeName( elem, name ) {
	
		return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
	
	}
	var rsingleTag = ( /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i );
	
	
	
	// Implement the identical functionality for filter and not
	function winnow( elements, qualifier, not ) {
		if ( isFunction( qualifier ) ) {
			return jQuery.grep( elements, function( elem, i ) {
				return !!qualifier.call( elem, i, elem ) !== not;
			} );
		}
	
		// Single element
		if ( qualifier.nodeType ) {
			return jQuery.grep( elements, function( elem ) {
				return ( elem === qualifier ) !== not;
			} );
		}
	
		// Arraylike of elements (jQuery, arguments, Array)
		if ( typeof qualifier !== "string" ) {
			return jQuery.grep( elements, function( elem ) {
				return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
			} );
		}
	
		// Filtered directly for both simple and complex selectors
		return jQuery.filter( qualifier, elements, not );
	}
	
	jQuery.filter = function( expr, elems, not ) {
		var elem = elems[ 0 ];
	
		if ( not ) {
			expr = ":not(" + expr + ")";
		}
	
		if ( elems.length === 1 && elem.nodeType === 1 ) {
			return jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [];
		}
	
		return jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
			return elem.nodeType === 1;
		} ) );
	};
	
	jQuery.fn.extend( {
		find: function( selector ) {
			var i, ret,
				len = this.length,
				self = this;
	
			if ( typeof selector !== "string" ) {
				return this.pushStack( jQuery( selector ).filter( function() {
					for ( i = 0; i < len; i++ ) {
						if ( jQuery.contains( self[ i ], this ) ) {
							return true;
						}
					}
				} ) );
			}
	
			ret = this.pushStack( [] );
	
			for ( i = 0; i < len; i++ ) {
				jQuery.find( selector, self[ i ], ret );
			}
	
			return len > 1 ? jQuery.uniqueSort( ret ) : ret;
		},
		filter: function( selector ) {
			return this.pushStack( winnow( this, selector || [], false ) );
		},
		not: function( selector ) {
			return this.pushStack( winnow( this, selector || [], true ) );
		},
		is: function( selector ) {
			return !!winnow(
				this,
	
				// If this is a positional/relative selector, check membership in the returned set
				// so $("p:first").is("p:last") won't return true for a doc with two "p".
				typeof selector === "string" && rneedsContext.test( selector ) ?
					jQuery( selector ) :
					selector || [],
				false
			).length;
		}
	} );
	
	
	// Initialize a jQuery object
	
	
	// A central reference to the root jQuery(document)
	var rootjQuery,
	
		// A simple way to check for HTML strings
		// Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
		// Strict HTML recognition (#11290: must start with <)
		// Shortcut simple #id case for speed
		rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,
	
		init = jQuery.fn.init = function( selector, context, root ) {
			var match, elem;
	
			// HANDLE: $(""), $(null), $(undefined), $(false)
			if ( !selector ) {
				return this;
			}
	
			// Method init() accepts an alternate rootjQuery
			// so migrate can support jQuery.sub (gh-2101)
			root = root || rootjQuery;
	
			// Handle HTML strings
			if ( typeof selector === "string" ) {
				if ( selector[ 0 ] === "<" &&
					selector[ selector.length - 1 ] === ">" &&
					selector.length >= 3 ) {
	
					// Assume that strings that start and end with <> are HTML and skip the regex check
					match = [ null, selector, null ];
	
				} else {
					match = rquickExpr.exec( selector );
				}
	
				// Match html or make sure no context is specified for #id
				if ( match && ( match[ 1 ] || !context ) ) {
	
					// HANDLE: $(html) -> $(array)
					if ( match[ 1 ] ) {
						context = context instanceof jQuery ? context[ 0 ] : context;
	
						// Option to run scripts is true for back-compat
						// Intentionally let the error be thrown if parseHTML is not present
						jQuery.merge( this, jQuery.parseHTML(
							match[ 1 ],
							context && context.nodeType ? context.ownerDocument || context : document,
							true
						) );
	
						// HANDLE: $(html, props)
						if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
							for ( match in context ) {
	
								// Properties of context are called as methods if possible
								if ( isFunction( this[ match ] ) ) {
									this[ match ]( context[ match ] );
	
								// ...and otherwise set as attributes
								} else {
									this.attr( match, context[ match ] );
								}
							}
						}
	
						return this;
	
					// HANDLE: $(#id)
					} else {
						elem = document.getElementById( match[ 2 ] );
	
						if ( elem ) {
	
							// Inject the element directly into the jQuery object
							this[ 0 ] = elem;
							this.length = 1;
						}
						return this;
					}
	
				// HANDLE: $(expr, $(...))
				} else if ( !context || context.jquery ) {
					return ( context || root ).find( selector );
	
				// HANDLE: $(expr, context)
				// (which is just equivalent to: $(context).find(expr)
				} else {
					return this.constructor( context ).find( selector );
				}
	
			// HANDLE: $(DOMElement)
			} else if ( selector.nodeType ) {
				this[ 0 ] = selector;
				this.length = 1;
				return this;
	
			// HANDLE: $(function)
			// Shortcut for document ready
			} else if ( isFunction( selector ) ) {
				return root.ready !== undefined ?
					root.ready( selector ) :
	
					// Execute immediately if ready is not present
					selector( jQuery );
			}
	
			return jQuery.makeArray( selector, this );
		};
	
	// Give the init function the jQuery prototype for later instantiation
	init.prototype = jQuery.fn;
	
	// Initialize central reference
	rootjQuery = jQuery( document );
	
	
	var rparentsprev = /^(?:parents|prev(?:Until|All))/,
	
		// Methods guaranteed to produce a unique set when starting from a unique set
		guaranteedUnique = {
			children: true,
			contents: true,
			next: true,
			prev: true
		};
	
	jQuery.fn.extend( {
		has: function( target ) {
			var targets = jQuery( target, this ),
				l = targets.length;
	
			return this.filter( function() {
				var i = 0;
				for ( ; i < l; i++ ) {
					if ( jQuery.contains( this, targets[ i ] ) ) {
						return true;
					}
				}
			} );
		},
	
		closest: function( selectors, context ) {
			var cur,
				i = 0,
				l = this.length,
				matched = [],
				targets = typeof selectors !== "string" && jQuery( selectors );
	
			// Positional selectors never match, since there's no _selection_ context
			if ( !rneedsContext.test( selectors ) ) {
				for ( ; i < l; i++ ) {
					for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {
	
						// Always skip document fragments
						if ( cur.nodeType < 11 && ( targets ?
							targets.index( cur ) > -1 :
	
							// Don't pass non-elements to Sizzle
							cur.nodeType === 1 &&
								jQuery.find.matchesSelector( cur, selectors ) ) ) {
	
							matched.push( cur );
							break;
						}
					}
				}
			}
	
			return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
		},
	
		// Determine the position of an element within the set
		index: function( elem ) {
	
			// No argument, return index in parent
			if ( !elem ) {
				return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
			}
	
			// Index in selector
			if ( typeof elem === "string" ) {
				return indexOf.call( jQuery( elem ), this[ 0 ] );
			}
	
			// Locate the position of the desired element
			return indexOf.call( this,
	
				// If it receives a jQuery object, the first element is used
				elem.jquery ? elem[ 0 ] : elem
			);
		},
	
		add: function( selector, context ) {
			return this.pushStack(
				jQuery.uniqueSort(
					jQuery.merge( this.get(), jQuery( selector, context ) )
				)
			);
		},
	
		addBack: function( selector ) {
			return this.add( selector == null ?
				this.prevObject : this.prevObject.filter( selector )
			);
		}
	} );
	
	function sibling( cur, dir ) {
		while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
		return cur;
	}
	
	jQuery.each( {
		parent: function( elem ) {
			var parent = elem.parentNode;
			return parent && parent.nodeType !== 11 ? parent : null;
		},
		parents: function( elem ) {
			return dir( elem, "parentNode" );
		},
		parentsUntil: function( elem, _i, until ) {
			return dir( elem, "parentNode", until );
		},
		next: function( elem ) {
			return sibling( elem, "nextSibling" );
		},
		prev: function( elem ) {
			return sibling( elem, "previousSibling" );
		},
		nextAll: function( elem ) {
			return dir( elem, "nextSibling" );
		},
		prevAll: function( elem ) {
			return dir( elem, "previousSibling" );
		},
		nextUntil: function( elem, _i, until ) {
			return dir( elem, "nextSibling", until );
		},
		prevUntil: function( elem, _i, until ) {
			return dir( elem, "previousSibling", until );
		},
		siblings: function( elem ) {
			return siblings( ( elem.parentNode || {} ).firstChild, elem );
		},
		children: function( elem ) {
			return siblings( elem.firstChild );
		},
		contents: function( elem ) {
			if ( elem.contentDocument != null &&
	
				// Support: IE 11+
				// <object> elements with no `data` attribute has an object
				// `contentDocument` with a `null` prototype.
				getProto( elem.contentDocument ) ) {
	
				return elem.contentDocument;
			}
	
			// Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
			// Treat the template element as a regular one in browsers that
			// don't support it.
			if ( nodeName( elem, "template" ) ) {
				elem = elem.content || elem;
			}
	
			return jQuery.merge( [], elem.childNodes );
		}
	}, function( name, fn ) {
		jQuery.fn[ name ] = function( until, selector ) {
			var matched = jQuery.map( this, fn, until );
	
			if ( name.slice( -5 ) !== "Until" ) {
				selector = until;
			}
	
			if ( selector && typeof selector === "string" ) {
				matched = jQuery.filter( selector, matched );
			}
	
			if ( this.length > 1 ) {
	
				// Remove duplicates
				if ( !guaranteedUnique[ name ] ) {
					jQuery.uniqueSort( matched );
				}
	
				// Reverse order for parents* and prev-derivatives
				if ( rparentsprev.test( name ) ) {
					matched.reverse();
				}
			}
	
			return this.pushStack( matched );
		};
	} );
	var rnothtmlwhite = ( /[^\x20\t\r\n\f]+/g );
	
	
	
	// Convert String-formatted options into Object-formatted ones
	function createOptions( options ) {
		var object = {};
		jQuery.each( options.match( rnothtmlwhite ) || [], function( _, flag ) {
			object[ flag ] = true;
		} );
		return object;
	}
	
	/*
	 * Create a callback list using the following parameters:
	 *
	 *	options: an optional list of space-separated options that will change how
	 *			the callback list behaves or a more traditional option object
	 *
	 * By default a callback list will act like an event callback list and can be
	 * "fired" multiple times.
	 *
	 * Possible options:
	 *
	 *	once:			will ensure the callback list can only be fired once (like a Deferred)
	 *
	 *	memory:			will keep track of previous values and will call any callback added
	 *					after the list has been fired right away with the latest "memorized"
	 *					values (like a Deferred)
	 *
	 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
	 *
	 *	stopOnFalse:	interrupt callings when a callback returns false
	 *
	 */
	jQuery.Callbacks = function( options ) {
	
		// Convert options from String-formatted to Object-formatted if needed
		// (we check in cache first)
		options = typeof options === "string" ?
			createOptions( options ) :
			jQuery.extend( {}, options );
	
		var // Flag to know if list is currently firing
			firing,
	
			// Last fire value for non-forgettable lists
			memory,
	
			// Flag to know if list was already fired
			fired,
	
			// Flag to prevent firing
			locked,
	
			// Actual callback list
			list = [],
	
			// Queue of execution data for repeatable lists
			queue = [],
	
			// Index of currently firing callback (modified by add/remove as needed)
			firingIndex = -1,
	
			// Fire callbacks
			fire = function() {
	
				// Enforce single-firing
				locked = locked || options.once;
	
				// Execute callbacks for all pending executions,
				// respecting firingIndex overrides and runtime changes
				fired = firing = true;
				for ( ; queue.length; firingIndex = -1 ) {
					memory = queue.shift();
					while ( ++firingIndex < list.length ) {
	
						// Run callback and check for early termination
						if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
							options.stopOnFalse ) {
	
							// Jump to end and forget the data so .add doesn't re-fire
							firingIndex = list.length;
							memory = false;
						}
					}
				}
	
				// Forget the data if we're done with it
				if ( !options.memory ) {
					memory = false;
				}
	
				firing = false;
	
				// Clean up if we're done firing for good
				if ( locked ) {
	
					// Keep an empty list if we have data for future add calls
					if ( memory ) {
						list = [];
	
					// Otherwise, this object is spent
					} else {
						list = "";
					}
				}
			},
	
			// Actual Callbacks object
			self = {
	
				// Add a callback or a collection of callbacks to the list
				add: function() {
					if ( list ) {
	
						// If we have memory from a past run, we should fire after adding
						if ( memory && !firing ) {
							firingIndex = list.length - 1;
							queue.push( memory );
						}
	
						( function add( args ) {
							jQuery.each( args, function( _, arg ) {
								if ( isFunction( arg ) ) {
									if ( !options.unique || !self.has( arg ) ) {
										list.push( arg );
									}
								} else if ( arg && arg.length && toType( arg ) !== "string" ) {
	
									// Inspect recursively
									add( arg );
								}
							} );
						} )( arguments );
	
						if ( memory && !firing ) {
							fire();
						}
					}
					return this;
				},
	
				// Remove a callback from the list
				remove: function() {
					jQuery.each( arguments, function( _, arg ) {
						var index;
						while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
							list.splice( index, 1 );
	
							// Handle firing indexes
							if ( index <= firingIndex ) {
								firingIndex--;
							}
						}
					} );
					return this;
				},
	
				// Check if a given callback is in the list.
				// If no argument is given, return whether or not list has callbacks attached.
				has: function( fn ) {
					return fn ?
						jQuery.inArray( fn, list ) > -1 :
						list.length > 0;
				},
	
				// Remove all callbacks from the list
				empty: function() {
					if ( list ) {
						list = [];
					}
					return this;
				},
	
				// Disable .fire and .add
				// Abort any current/pending executions
				// Clear all callbacks and values
				disable: function() {
					locked = queue = [];
					list = memory = "";
					return this;
				},
				disabled: function() {
					return !list;
				},
	
				// Disable .fire
				// Also disable .add unless we have memory (since it would have no effect)
				// Abort any pending executions
				lock: function() {
					locked = queue = [];
					if ( !memory && !firing ) {
						list = memory = "";
					}
					return this;
				},
				locked: function() {
					return !!locked;
				},
	
				// Call all callbacks with the given context and arguments
				fireWith: function( context, args ) {
					if ( !locked ) {
						args = args || [];
						args = [ context, args.slice ? args.slice() : args ];
						queue.push( args );
						if ( !firing ) {
							fire();
						}
					}
					return this;
				},
	
				// Call all the callbacks with the given arguments
				fire: function() {
					self.fireWith( this, arguments );
					return this;
				},
	
				// To know if the callbacks have already been called at least once
				fired: function() {
					return !!fired;
				}
			};
	
		return self;
	};
	
	
	function Identity( v ) {
		return v;
	}
	function Thrower( ex ) {
		throw ex;
	}
	
	function adoptValue( value, resolve, reject, noValue ) {
		var method;
	
		try {
	
			// Check for promise aspect first to privilege synchronous behavior
			if ( value && isFunction( ( method = value.promise ) ) ) {
				method.call( value ).done( resolve ).fail( reject );
	
			// Other thenables
			} else if ( value && isFunction( ( method = value.then ) ) ) {
				method.call( value, resolve, reject );
	
			// Other non-thenables
			} else {
	
				// Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
				// * false: [ value ].slice( 0 ) => resolve( value )
				// * true: [ value ].slice( 1 ) => resolve()
				resolve.apply( undefined, [ value ].slice( noValue ) );
			}
	
		// For Promises/A+, convert exceptions into rejections
		// Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
		// Deferred#then to conditionally suppress rejection.
		} catch ( value ) {
	
			// Support: Android 4.0 only
			// Strict mode functions invoked without .call/.apply get global-object context
			reject.apply( undefined, [ value ] );
		}
	}
	
	jQuery.extend( {
	
		Deferred: function( func ) {
			var tuples = [
	
					// action, add listener, callbacks,
					// ... .then handlers, argument index, [final state]
					[ "notify", "progress", jQuery.Callbacks( "memory" ),
						jQuery.Callbacks( "memory" ), 2 ],
					[ "resolve", "done", jQuery.Callbacks( "once memory" ),
						jQuery.Callbacks( "once memory" ), 0, "resolved" ],
					[ "reject", "fail", jQuery.Callbacks( "once memory" ),
						jQuery.Callbacks( "once memory" ), 1, "rejected" ]
				],
				state = "pending",
				promise = {
					state: function() {
						return state;
					},
					always: function() {
						deferred.done( arguments ).fail( arguments );
						return this;
					},
					"catch": function( fn ) {
						return promise.then( null, fn );
					},
	
					// Keep pipe for back-compat
					pipe: function( /* fnDone, fnFail, fnProgress */ ) {
						var fns = arguments;
	
						return jQuery.Deferred( function( newDefer ) {
							jQuery.each( tuples, function( _i, tuple ) {
	
								// Map tuples (progress, done, fail) to arguments (done, fail, progress)
								var fn = isFunction( fns[ tuple[ 4 ] ] ) && fns[ tuple[ 4 ] ];
	
								// deferred.progress(function() { bind to newDefer or newDefer.notify })
								// deferred.done(function() { bind to newDefer or newDefer.resolve })
								// deferred.fail(function() { bind to newDefer or newDefer.reject })
								deferred[ tuple[ 1 ] ]( function() {
									var returned = fn && fn.apply( this, arguments );
									if ( returned && isFunction( returned.promise ) ) {
										returned.promise()
											.progress( newDefer.notify )
											.done( newDefer.resolve )
											.fail( newDefer.reject );
									} else {
										newDefer[ tuple[ 0 ] + "With" ](
											this,
											fn ? [ returned ] : arguments
										);
									}
								} );
							} );
							fns = null;
						} ).promise();
					},
					then: function( onFulfilled, onRejected, onProgress ) {
						var maxDepth = 0;
						function resolve( depth, deferred, handler, special ) {
							return function() {
								var that = this,
									args = arguments,
									mightThrow = function() {
										var returned, then;
	
										// Support: Promises/A+ section 2.3.3.3.3
										// https://promisesaplus.com/#point-59
										// Ignore double-resolution attempts
										if ( depth < maxDepth ) {
											return;
										}
	
										returned = handler.apply( that, args );
	
										// Support: Promises/A+ section 2.3.1
										// https://promisesaplus.com/#point-48
										if ( returned === deferred.promise() ) {
											throw new TypeError( "Thenable self-resolution" );
										}
	
										// Support: Promises/A+ sections 2.3.3.1, 3.5
										// https://promisesaplus.com/#point-54
										// https://promisesaplus.com/#point-75
										// Retrieve `then` only once
										then = returned &&
	
											// Support: Promises/A+ section 2.3.4
											// https://promisesaplus.com/#point-64
											// Only check objects and functions for thenability
											( typeof returned === "object" ||
												typeof returned === "function" ) &&
											returned.then;
	
										// Handle a returned thenable
										if ( isFunction( then ) ) {
	
											// Special processors (notify) just wait for resolution
											if ( special ) {
												then.call(
													returned,
													resolve( maxDepth, deferred, Identity, special ),
													resolve( maxDepth, deferred, Thrower, special )
												);
	
											// Normal processors (resolve) also hook into progress
											} else {
	
												// ...and disregard older resolution values
												maxDepth++;
	
												then.call(
													returned,
													resolve( maxDepth, deferred, Identity, special ),
													resolve( maxDepth, deferred, Thrower, special ),
													resolve( maxDepth, deferred, Identity,
														deferred.notifyWith )
												);
											}
	
										// Handle all other returned values
										} else {
	
											// Only substitute handlers pass on context
											// and multiple values (non-spec behavior)
											if ( handler !== Identity ) {
												that = undefined;
												args = [ returned ];
											}
	
											// Process the value(s)
											// Default process is resolve
											( special || deferred.resolveWith )( that, args );
										}
									},
	
									// Only normal processors (resolve) catch and reject exceptions
									process = special ?
										mightThrow :
										function() {
											try {
												mightThrow();
											} catch ( e ) {
	
												if ( jQuery.Deferred.exceptionHook ) {
													jQuery.Deferred.exceptionHook( e,
														process.stackTrace );
												}
	
												// Support: Promises/A+ section 2.3.3.3.4.1
												// https://promisesaplus.com/#point-61
												// Ignore post-resolution exceptions
												if ( depth + 1 >= maxDepth ) {
	
													// Only substitute handlers pass on context
													// and multiple values (non-spec behavior)
													if ( handler !== Thrower ) {
														that = undefined;
														args = [ e ];
													}
	
													deferred.rejectWith( that, args );
												}
											}
										};
	
								// Support: Promises/A+ section 2.3.3.3.1
								// https://promisesaplus.com/#point-57
								// Re-resolve promises immediately to dodge false rejection from
								// subsequent errors
								if ( depth ) {
									process();
								} else {
	
									// Call an optional hook to record the stack, in case of exception
									// since it's otherwise lost when execution goes async
									if ( jQuery.Deferred.getStackHook ) {
										process.stackTrace = jQuery.Deferred.getStackHook();
									}
									window.setTimeout( process );
								}
							};
						}
	
						return jQuery.Deferred( function( newDefer ) {
	
							// progress_handlers.add( ... )
							tuples[ 0 ][ 3 ].add(
								resolve(
									0,
									newDefer,
									isFunction( onProgress ) ?
										onProgress :
										Identity,
									newDefer.notifyWith
								)
							);
	
							// fulfilled_handlers.add( ... )
							tuples[ 1 ][ 3 ].add(
								resolve(
									0,
									newDefer,
									isFunction( onFulfilled ) ?
										onFulfilled :
										Identity
								)
							);
	
							// rejected_handlers.add( ... )
							tuples[ 2 ][ 3 ].add(
								resolve(
									0,
									newDefer,
									isFunction( onRejected ) ?
										onRejected :
										Thrower
								)
							);
						} ).promise();
					},
	
					// Get a promise for this deferred
					// If obj is provided, the promise aspect is added to the object
					promise: function( obj ) {
						return obj != null ? jQuery.extend( obj, promise ) : promise;
					}
				},
				deferred = {};
	
			// Add list-specific methods
			jQuery.each( tuples, function( i, tuple ) {
				var list = tuple[ 2 ],
					stateString = tuple[ 5 ];
	
				// promise.progress = list.add
				// promise.done = list.add
				// promise.fail = list.add
				promise[ tuple[ 1 ] ] = list.add;
	
				// Handle state
				if ( stateString ) {
					list.add(
						function() {
	
							// state = "resolved" (i.e., fulfilled)
							// state = "rejected"
							state = stateString;
						},
	
						// rejected_callbacks.disable
						// fulfilled_callbacks.disable
						tuples[ 3 - i ][ 2 ].disable,
	
						// rejected_handlers.disable
						// fulfilled_handlers.disable
						tuples[ 3 - i ][ 3 ].disable,
	
						// progress_callbacks.lock
						tuples[ 0 ][ 2 ].lock,
	
						// progress_handlers.lock
						tuples[ 0 ][ 3 ].lock
					);
				}
	
				// progress_handlers.fire
				// fulfilled_handlers.fire
				// rejected_handlers.fire
				list.add( tuple[ 3 ].fire );
	
				// deferred.notify = function() { deferred.notifyWith(...) }
				// deferred.resolve = function() { deferred.resolveWith(...) }
				// deferred.reject = function() { deferred.rejectWith(...) }
				deferred[ tuple[ 0 ] ] = function() {
					deferred[ tuple[ 0 ] + "With" ]( this === deferred ? undefined : this, arguments );
					return this;
				};
	
				// deferred.notifyWith = list.fireWith
				// deferred.resolveWith = list.fireWith
				// deferred.rejectWith = list.fireWith
				deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
			} );
	
			// Make the deferred a promise
			promise.promise( deferred );
	
			// Call given func if any
			if ( func ) {
				func.call( deferred, deferred );
			}
	
			// All done!
			return deferred;
		},
	
		// Deferred helper
		when: function( singleValue ) {
			var
	
				// count of uncompleted subordinates
				remaining = arguments.length,
	
				// count of unprocessed arguments
				i = remaining,
	
				// subordinate fulfillment data
				resolveContexts = Array( i ),
				resolveValues = slice.call( arguments ),
	
				// the primary Deferred
				primary = jQuery.Deferred(),
	
				// subordinate callback factory
				updateFunc = function( i ) {
					return function( value ) {
						resolveContexts[ i ] = this;
						resolveValues[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
						if ( !( --remaining ) ) {
							primary.resolveWith( resolveContexts, resolveValues );
						}
					};
				};
	
			// Single- and empty arguments are adopted like Promise.resolve
			if ( remaining <= 1 ) {
				adoptValue( singleValue, primary.done( updateFunc( i ) ).resolve, primary.reject,
					!remaining );
	
				// Use .then() to unwrap secondary thenables (cf. gh-3000)
				if ( primary.state() === "pending" ||
					isFunction( resolveValues[ i ] && resolveValues[ i ].then ) ) {
	
					return primary.then();
				}
			}
	
			// Multiple arguments are aggregated like Promise.all array elements
			while ( i-- ) {
				adoptValue( resolveValues[ i ], updateFunc( i ), primary.reject );
			}
	
			return primary.promise();
		}
	} );
	
	
	// These usually indicate a programmer mistake during development,
	// warn about them ASAP rather than swallowing them by default.
	var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
	
	jQuery.Deferred.exceptionHook = function( error, stack ) {
	
		// Support: IE 8 - 9 only
		// Console exists when dev tools are open, which can happen at any time
		if ( window.console && window.console.warn && error && rerrorNames.test( error.name ) ) {
			window.console.warn( "jQuery.Deferred exception: " + error.message, error.stack, stack );
		}
	};
	
	
	
	
	jQuery.readyException = function( error ) {
		window.setTimeout( function() {
			throw error;
		} );
	};
	
	
	
	
	// The deferred used on DOM ready
	var readyList = jQuery.Deferred();
	
	jQuery.fn.ready = function( fn ) {
	
		readyList
			.then( fn )
	
			// Wrap jQuery.readyException in a function so that the lookup
			// happens at the time of error handling instead of callback
			// registration.
			.catch( function( error ) {
				jQuery.readyException( error );
			} );
	
		return this;
	};
	
	jQuery.extend( {
	
		// Is the DOM ready to be used? Set to true once it occurs.
		isReady: false,
	
		// A counter to track how many items to wait for before
		// the ready event fires. See #6781
		readyWait: 1,
	
		// Handle when the DOM is ready
		ready: function( wait ) {
	
			// Abort if there are pending holds or we're already ready
			if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
				return;
			}
	
			// Remember that the DOM is ready
			jQuery.isReady = true;
	
			// If a normal DOM Ready event fired, decrement, and wait if need be
			if ( wait !== true && --jQuery.readyWait > 0 ) {
				return;
			}
	
			// If there are functions bound, to execute
			readyList.resolveWith( document, [ jQuery ] );
		}
	} );
	
	jQuery.ready.then = readyList.then;
	
	// The ready event handler and self cleanup method
	function completed() {
		document.removeEventListener( "DOMContentLoaded", completed );
		window.removeEventListener( "load", completed );
		jQuery.ready();
	}
	
	// Catch cases where $(document).ready() is called
	// after the browser event has already occurred.
	// Support: IE <=9 - 10 only
	// Older IE sometimes signals "interactive" too soon
	if ( document.readyState === "complete" ||
		( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {
	
		// Handle it asynchronously to allow scripts the opportunity to delay ready
		window.setTimeout( jQuery.ready );
	
	} else {
	
		// Use the handy event callback
		document.addEventListener( "DOMContentLoaded", completed );
	
		// A fallback to window.onload, that will always work
		window.addEventListener( "load", completed );
	}
	
	
	
	
	// Multifunctional method to get and set values of a collection
	// The value/s can optionally be executed if it's a function
	var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
		var i = 0,
			len = elems.length,
			bulk = key == null;
	
		// Sets many values
		if ( toType( key ) === "object" ) {
			chainable = true;
			for ( i in key ) {
				access( elems, fn, i, key[ i ], true, emptyGet, raw );
			}
	
		// Sets one value
		} else if ( value !== undefined ) {
			chainable = true;
	
			if ( !isFunction( value ) ) {
				raw = true;
			}
	
			if ( bulk ) {
	
				// Bulk operations run against the entire set
				if ( raw ) {
					fn.call( elems, value );
					fn = null;
	
				// ...except when executing function values
				} else {
					bulk = fn;
					fn = function( elem, _key, value ) {
						return bulk.call( jQuery( elem ), value );
					};
				}
			}
	
			if ( fn ) {
				for ( ; i < len; i++ ) {
					fn(
						elems[ i ], key, raw ?
							value :
							value.call( elems[ i ], i, fn( elems[ i ], key ) )
					);
				}
			}
		}
	
		if ( chainable ) {
			return elems;
		}
	
		// Gets
		if ( bulk ) {
			return fn.call( elems );
		}
	
		return len ? fn( elems[ 0 ], key ) : emptyGet;
	};
	
	
	// Matches dashed string for camelizing
	var rmsPrefix = /^-ms-/,
		rdashAlpha = /-([a-z])/g;
	
	// Used by camelCase as callback to replace()
	function fcamelCase( _all, letter ) {
		return letter.toUpperCase();
	}
	
	// Convert dashed to camelCase; used by the css and data modules
	// Support: IE <=9 - 11, Edge 12 - 15
	// Microsoft forgot to hump their vendor prefix (#9572)
	function camelCase( string ) {
		return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
	}
	var acceptData = function( owner ) {
	
		// Accepts only:
		//  - Node
		//    - Node.ELEMENT_NODE
		//    - Node.DOCUMENT_NODE
		//  - Object
		//    - Any
		return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
	};
	
	
	
	
	function Data() {
		this.expando = jQuery.expando + Data.uid++;
	}
	
	Data.uid = 1;
	
	Data.prototype = {
	
		cache: function( owner ) {
	
			// Check if the owner object already has a cache
			var value = owner[ this.expando ];
	
			// If not, create one
			if ( !value ) {
				value = {};
	
				// We can accept data for non-element nodes in modern browsers,
				// but we should not, see #8335.
				// Always return an empty object.
				if ( acceptData( owner ) ) {
	
					// If it is a node unlikely to be stringify-ed or looped over
					// use plain assignment
					if ( owner.nodeType ) {
						owner[ this.expando ] = value;
	
					// Otherwise secure it in a non-enumerable property
					// configurable must be true to allow the property to be
					// deleted when data is removed
					} else {
						Object.defineProperty( owner, this.expando, {
							value: value,
							configurable: true
						} );
					}
				}
			}
	
			return value;
		},
		set: function( owner, data, value ) {
			var prop,
				cache = this.cache( owner );
	
			// Handle: [ owner, key, value ] args
			// Always use camelCase key (gh-2257)
			if ( typeof data === "string" ) {
				cache[ camelCase( data ) ] = value;
	
			// Handle: [ owner, { properties } ] args
			} else {
	
				// Copy the properties one-by-one to the cache object
				for ( prop in data ) {
					cache[ camelCase( prop ) ] = data[ prop ];
				}
			}
			return cache;
		},
		get: function( owner, key ) {
			return key === undefined ?
				this.cache( owner ) :
	
				// Always use camelCase key (gh-2257)
				owner[ this.expando ] && owner[ this.expando ][ camelCase( key ) ];
		},
		access: function( owner, key, value ) {
	
			// In cases where either:
			//
			//   1. No key was specified
			//   2. A string key was specified, but no value provided
			//
			// Take the "read" path and allow the get method to determine
			// which value to return, respectively either:
			//
			//   1. The entire cache object
			//   2. The data stored at the key
			//
			if ( key === undefined ||
					( ( key && typeof key === "string" ) && value === undefined ) ) {
	
				return this.get( owner, key );
			}
	
			// When the key is not a string, or both a key and value
			// are specified, set or extend (existing objects) with either:
			//
			//   1. An object of properties
			//   2. A key and value
			//
			this.set( owner, key, value );
	
			// Since the "set" path can have two possible entry points
			// return the expected data based on which path was taken[*]
			return value !== undefined ? value : key;
		},
		remove: function( owner, key ) {
			var i,
				cache = owner[ this.expando ];
	
			if ( cache === undefined ) {
				return;
			}
	
			if ( key !== undefined ) {
	
				// Support array or space separated string of keys
				if ( Array.isArray( key ) ) {
	
					// If key is an array of keys...
					// We always set camelCase keys, so remove that.
					key = key.map( camelCase );
				} else {
					key = camelCase( key );
	
					// If a key with the spaces exists, use it.
					// Otherwise, create an array by matching non-whitespace
					key = key in cache ?
						[ key ] :
						( key.match( rnothtmlwhite ) || [] );
				}
	
				i = key.length;
	
				while ( i-- ) {
					delete cache[ key[ i ] ];
				}
			}
	
			// Remove the expando if there's no more data
			if ( key === undefined || jQuery.isEmptyObject( cache ) ) {
	
				// Support: Chrome <=35 - 45
				// Webkit & Blink performance suffers when deleting properties
				// from DOM nodes, so set to undefined instead
				// https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
				if ( owner.nodeType ) {
					owner[ this.expando ] = undefined;
				} else {
					delete owner[ this.expando ];
				}
			}
		},
		hasData: function( owner ) {
			var cache = owner[ this.expando ];
			return cache !== undefined && !jQuery.isEmptyObject( cache );
		}
	};
	var dataPriv = new Data();
	
	var dataUser = new Data();
	
	
	
	//	Implementation Summary
	//
	//	1. Enforce API surface and semantic compatibility with 1.9.x branch
	//	2. Improve the module's maintainability by reducing the storage
	//		paths to a single mechanism.
	//	3. Use the same single mechanism to support "private" and "user" data.
	//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
	//	5. Avoid exposing implementation details on user objects (eg. expando properties)
	//	6. Provide a clear path for implementation upgrade to WeakMap in 2014
	
	var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
		rmultiDash = /[A-Z]/g;
	
	function getData( data ) {
		if ( data === "true" ) {
			return true;
		}
	
		if ( data === "false" ) {
			return false;
		}
	
		if ( data === "null" ) {
			return null;
		}
	
		// Only convert to a number if it doesn't change the string
		if ( data === +data + "" ) {
			return +data;
		}
	
		if ( rbrace.test( data ) ) {
			return JSON.parse( data );
		}
	
		return data;
	}
	
	function dataAttr( elem, key, data ) {
		var name;
	
		// If nothing was found internally, try to fetch any
		// data from the HTML5 data-* attribute
		if ( data === undefined && elem.nodeType === 1 ) {
			name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
			data = elem.getAttribute( name );
	
			if ( typeof data === "string" ) {
				try {
					data = getData( data );
				} catch ( e ) {}
	
				// Make sure we set the data so it isn't changed later
				dataUser.set( elem, key, data );
			} else {
				data = undefined;
			}
		}
		return data;
	}
	
	jQuery.extend( {
		hasData: function( elem ) {
			return dataUser.hasData( elem ) || dataPriv.hasData( elem );
		},
	
		data: function( elem, name, data ) {
			return dataUser.access( elem, name, data );
		},
	
		removeData: function( elem, name ) {
			dataUser.remove( elem, name );
		},
	
		// TODO: Now that all calls to _data and _removeData have been replaced
		// with direct calls to dataPriv methods, these can be deprecated.
		_data: function( elem, name, data ) {
			return dataPriv.access( elem, name, data );
		},
	
		_removeData: function( elem, name ) {
			dataPriv.remove( elem, name );
		}
	} );
	
	jQuery.fn.extend( {
		data: function( key, value ) {
			var i, name, data,
				elem = this[ 0 ],
				attrs = elem && elem.attributes;
	
			// Gets all values
			if ( key === undefined ) {
				if ( this.length ) {
					data = dataUser.get( elem );
	
					if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
						i = attrs.length;
						while ( i-- ) {
	
							// Support: IE 11 only
							// The attrs elements can be null (#14894)
							if ( attrs[ i ] ) {
								name = attrs[ i ].name;
								if ( name.indexOf( "data-" ) === 0 ) {
									name = camelCase( name.slice( 5 ) );
									dataAttr( elem, name, data[ name ] );
								}
							}
						}
						dataPriv.set( elem, "hasDataAttrs", true );
					}
				}
	
				return data;
			}
	
			// Sets multiple values
			if ( typeof key === "object" ) {
				return this.each( function() {
					dataUser.set( this, key );
				} );
			}
	
			return access( this, function( value ) {
				var data;
	
				// The calling jQuery object (element matches) is not empty
				// (and therefore has an element appears at this[ 0 ]) and the
				// `value` parameter was not undefined. An empty jQuery object
				// will result in `undefined` for elem = this[ 0 ] which will
				// throw an exception if an attempt to read a data cache is made.
				if ( elem && value === undefined ) {
	
					// Attempt to get data from the cache
					// The key will always be camelCased in Data
					data = dataUser.get( elem, key );
					if ( data !== undefined ) {
						return data;
					}
	
					// Attempt to "discover" the data in
					// HTML5 custom data-* attrs
					data = dataAttr( elem, key );
					if ( data !== undefined ) {
						return data;
					}
	
					// We tried really hard, but the data doesn't exist.
					return;
				}
	
				// Set the data...
				this.each( function() {
	
					// We always store the camelCased key
					dataUser.set( this, key, value );
				} );
			}, null, value, arguments.length > 1, null, true );
		},
	
		removeData: function( key ) {
			return this.each( function() {
				dataUser.remove( this, key );
			} );
		}
	} );
	
	
	jQuery.extend( {
		queue: function( elem, type, data ) {
			var queue;
	
			if ( elem ) {
				type = ( type || "fx" ) + "queue";
				queue = dataPriv.get( elem, type );
	
				// Speed up dequeue by getting out quickly if this is just a lookup
				if ( data ) {
					if ( !queue || Array.isArray( data ) ) {
						queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
					} else {
						queue.push( data );
					}
				}
				return queue || [];
			}
		},
	
		dequeue: function( elem, type ) {
			type = type || "fx";
	
			var queue = jQuery.queue( elem, type ),
				startLength = queue.length,
				fn = queue.shift(),
				hooks = jQuery._queueHooks( elem, type ),
				next = function() {
					jQuery.dequeue( elem, type );
				};
	
			// If the fx queue is dequeued, always remove the progress sentinel
			if ( fn === "inprogress" ) {
				fn = queue.shift();
				startLength--;
			}
	
			if ( fn ) {
	
				// Add a progress sentinel to prevent the fx queue from being
				// automatically dequeued
				if ( type === "fx" ) {
					queue.unshift( "inprogress" );
				}
	
				// Clear up the last queue stop function
				delete hooks.stop;
				fn.call( elem, next, hooks );
			}
	
			if ( !startLength && hooks ) {
				hooks.empty.fire();
			}
		},
	
		// Not public - generate a queueHooks object, or return the current one
		_queueHooks: function( elem, type ) {
			var key = type + "queueHooks";
			return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
				empty: jQuery.Callbacks( "once memory" ).add( function() {
					dataPriv.remove( elem, [ type + "queue", key ] );
				} )
			} );
		}
	} );
	
	jQuery.fn.extend( {
		queue: function( type, data ) {
			var setter = 2;
	
			if ( typeof type !== "string" ) {
				data = type;
				type = "fx";
				setter--;
			}
	
			if ( arguments.length < setter ) {
				return jQuery.queue( this[ 0 ], type );
			}
	
			return data === undefined ?
				this :
				this.each( function() {
					var queue = jQuery.queue( this, type, data );
	
					// Ensure a hooks for this queue
					jQuery._queueHooks( this, type );
	
					if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
						jQuery.dequeue( this, type );
					}
				} );
		},
		dequeue: function( type ) {
			return this.each( function() {
				jQuery.dequeue( this, type );
			} );
		},
		clearQueue: function( type ) {
			return this.queue( type || "fx", [] );
		},
	
		// Get a promise resolved when queues of a certain type
		// are emptied (fx is the type by default)
		promise: function( type, obj ) {
			var tmp,
				count = 1,
				defer = jQuery.Deferred(),
				elements = this,
				i = this.length,
				resolve = function() {
					if ( !( --count ) ) {
						defer.resolveWith( elements, [ elements ] );
					}
				};
	
			if ( typeof type !== "string" ) {
				obj = type;
				type = undefined;
			}
			type = type || "fx";
	
			while ( i-- ) {
				tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
				if ( tmp && tmp.empty ) {
					count++;
					tmp.empty.add( resolve );
				}
			}
			resolve();
			return defer.promise( obj );
		}
	} );
	var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;
	
	var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );
	
	
	var cssExpand = [ "Top", "Right", "Bottom", "Left" ];
	
	var documentElement = document.documentElement;
	
	
	
		var isAttached = function( elem ) {
				return jQuery.contains( elem.ownerDocument, elem );
			},
			composed = { composed: true };
	
		// Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
		// Check attachment across shadow DOM boundaries when possible (gh-3504)
		// Support: iOS 10.0-10.2 only
		// Early iOS 10 versions support `attachShadow` but not `getRootNode`,
		// leading to errors. We need to check for `getRootNode`.
		if ( documentElement.getRootNode ) {
			isAttached = function( elem ) {
				return jQuery.contains( elem.ownerDocument, elem ) ||
					elem.getRootNode( composed ) === elem.ownerDocument;
			};
		}
	var isHiddenWithinTree = function( elem, el ) {
	
			// isHiddenWithinTree might be called from jQuery#filter function;
			// in that case, element will be second argument
			elem = el || elem;
	
			// Inline style trumps all
			return elem.style.display === "none" ||
				elem.style.display === "" &&
	
				// Otherwise, check computed style
				// Support: Firefox <=43 - 45
				// Disconnected elements can have computed display: none, so first confirm that elem is
				// in the document.
				isAttached( elem ) &&
	
				jQuery.css( elem, "display" ) === "none";
		};
	
	
	
	function adjustCSS( elem, prop, valueParts, tween ) {
		var adjusted, scale,
			maxIterations = 20,
			currentValue = tween ?
				function() {
					return tween.cur();
				} :
				function() {
					return jQuery.css( elem, prop, "" );
				},
			initial = currentValue(),
			unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),
	
			// Starting value computation is required for potential unit mismatches
			initialInUnit = elem.nodeType &&
				( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
				rcssNum.exec( jQuery.css( elem, prop ) );
	
		if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {
	
			// Support: Firefox <=54
			// Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
			initial = initial / 2;
	
			// Trust units reported by jQuery.css
			unit = unit || initialInUnit[ 3 ];
	
			// Iteratively approximate from a nonzero starting point
			initialInUnit = +initial || 1;
	
			while ( maxIterations-- ) {
	
				// Evaluate and update our best guess (doubling guesses that zero out).
				// Finish if the scale equals or crosses 1 (making the old*new product non-positive).
				jQuery.style( elem, prop, initialInUnit + unit );
				if ( ( 1 - scale ) * ( 1 - ( scale = currentValue() / initial || 0.5 ) ) <= 0 ) {
					maxIterations = 0;
				}
				initialInUnit = initialInUnit / scale;
	
			}
	
			initialInUnit = initialInUnit * 2;
			jQuery.style( elem, prop, initialInUnit + unit );
	
			// Make sure we update the tween properties later on
			valueParts = valueParts || [];
		}
	
		if ( valueParts ) {
			initialInUnit = +initialInUnit || +initial || 0;
	
			// Apply relative offset (+=/-=) if specified
			adjusted = valueParts[ 1 ] ?
				initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
				+valueParts[ 2 ];
			if ( tween ) {
				tween.unit = unit;
				tween.start = initialInUnit;
				tween.end = adjusted;
			}
		}
		return adjusted;
	}
	
	
	var defaultDisplayMap = {};
	
	function getDefaultDisplay( elem ) {
		var temp,
			doc = elem.ownerDocument,
			nodeName = elem.nodeName,
			display = defaultDisplayMap[ nodeName ];
	
		if ( display ) {
			return display;
		}
	
		temp = doc.body.appendChild( doc.createElement( nodeName ) );
		display = jQuery.css( temp, "display" );
	
		temp.parentNode.removeChild( temp );
	
		if ( display === "none" ) {
			display = "block";
		}
		defaultDisplayMap[ nodeName ] = display;
	
		return display;
	}
	
	function showHide( elements, show ) {
		var display, elem,
			values = [],
			index = 0,
			length = elements.length;
	
		// Determine new display value for elements that need to change
		for ( ; index < length; index++ ) {
			elem = elements[ index ];
			if ( !elem.style ) {
				continue;
			}
	
			display = elem.style.display;
			if ( show ) {
	
				// Since we force visibility upon cascade-hidden elements, an immediate (and slow)
				// check is required in this first loop unless we have a nonempty display value (either
				// inline or about-to-be-restored)
				if ( display === "none" ) {
					values[ index ] = dataPriv.get( elem, "display" ) || null;
					if ( !values[ index ] ) {
						elem.style.display = "";
					}
				}
				if ( elem.style.display === "" && isHiddenWithinTree( elem ) ) {
					values[ index ] = getDefaultDisplay( elem );
				}
			} else {
				if ( display !== "none" ) {
					values[ index ] = "none";
	
					// Remember what we're overwriting
					dataPriv.set( elem, "display", display );
				}
			}
		}
	
		// Set the display of the elements in a second loop to avoid constant reflow
		for ( index = 0; index < length; index++ ) {
			if ( values[ index ] != null ) {
				elements[ index ].style.display = values[ index ];
			}
		}
	
		return elements;
	}
	
	jQuery.fn.extend( {
		show: function() {
			return showHide( this, true );
		},
		hide: function() {
			return showHide( this );
		},
		toggle: function( state ) {
			if ( typeof state === "boolean" ) {
				return state ? this.show() : this.hide();
			}
	
			return this.each( function() {
				if ( isHiddenWithinTree( this ) ) {
					jQuery( this ).show();
				} else {
					jQuery( this ).hide();
				}
			} );
		}
	} );
	var rcheckableType = ( /^(?:checkbox|radio)$/i );
	
	var rtagName = ( /<([a-z][^\/\0>\x20\t\r\n\f]*)/i );
	
	var rscriptType = ( /^$|^module$|\/(?:java|ecma)script/i );
	
	
	
	( function() {
		var fragment = document.createDocumentFragment(),
			div = fragment.appendChild( document.createElement( "div" ) ),
			input = document.createElement( "input" );
	
		// Support: Android 4.0 - 4.3 only
		// Check state lost if the name is set (#11217)
		// Support: Windows Web Apps (WWA)
		// `name` and `type` must use .setAttribute for WWA (#14901)
		input.setAttribute( "type", "radio" );
		input.setAttribute( "checked", "checked" );
		input.setAttribute( "name", "t" );
	
		div.appendChild( input );
	
		// Support: Android <=4.1 only
		// Older WebKit doesn't clone checked state correctly in fragments
		support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;
	
		// Support: IE <=11 only
		// Make sure textarea (and checkbox) defaultValue is properly cloned
		div.innerHTML = "<textarea>x</textarea>";
		support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;
	
		// Support: IE <=9 only
		// IE <=9 replaces <option> tags with their contents when inserted outside of
		// the select element.
		div.innerHTML = "<option></option>";
		support.option = !!div.lastChild;
	} )();
	
	
	// We have to close these tags to support XHTML (#13200)
	var wrapMap = {
	
		// XHTML parsers do not magically insert elements in the
		// same way that tag soup parsers do. So we cannot shorten
		// this by omitting <tbody> or other required elements.
		thead: [ 1, "<table>", "</table>" ],
		col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
		tr: [ 2, "<table><tbody>", "</tbody></table>" ],
		td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],
	
		_default: [ 0, "", "" ]
	};
	
	wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
	wrapMap.th = wrapMap.td;
	
	// Support: IE <=9 only
	if ( !support.option ) {
		wrapMap.optgroup = wrapMap.option = [ 1, "<select multiple='multiple'>", "</select>" ];
	}
	
	
	function getAll( context, tag ) {
	
		// Support: IE <=9 - 11 only
		// Use typeof to avoid zero-argument method invocation on host objects (#15151)
		var ret;
	
		if ( typeof context.getElementsByTagName !== "undefined" ) {
			ret = context.getElementsByTagName( tag || "*" );
	
		} else if ( typeof context.querySelectorAll !== "undefined" ) {
			ret = context.querySelectorAll( tag || "*" );
	
		} else {
			ret = [];
		}
	
		if ( tag === undefined || tag && nodeName( context, tag ) ) {
			return jQuery.merge( [ context ], ret );
		}
	
		return ret;
	}
	
	
	// Mark scripts as having already been evaluated
	function setGlobalEval( elems, refElements ) {
		var i = 0,
			l = elems.length;
	
		for ( ; i < l; i++ ) {
			dataPriv.set(
				elems[ i ],
				"globalEval",
				!refElements || dataPriv.get( refElements[ i ], "globalEval" )
			);
		}
	}
	
	
	var rhtml = /<|&#?\w+;/;
	
	function buildFragment( elems, context, scripts, selection, ignored ) {
		var elem, tmp, tag, wrap, attached, j,
			fragment = context.createDocumentFragment(),
			nodes = [],
			i = 0,
			l = elems.length;
	
		for ( ; i < l; i++ ) {
			elem = elems[ i ];
	
			if ( elem || elem === 0 ) {
	
				// Add nodes directly
				if ( toType( elem ) === "object" ) {
	
					// Support: Android <=4.0 only, PhantomJS 1 only
					// push.apply(_, arraylike) throws on ancient WebKit
					jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );
	
				// Convert non-html into a text node
				} else if ( !rhtml.test( elem ) ) {
					nodes.push( context.createTextNode( elem ) );
	
				// Convert html into DOM nodes
				} else {
					tmp = tmp || fragment.appendChild( context.createElement( "div" ) );
	
					// Deserialize a standard representation
					tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
					wrap = wrapMap[ tag ] || wrapMap._default;
					tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];
	
					// Descend through wrappers to the right content
					j = wrap[ 0 ];
					while ( j-- ) {
						tmp = tmp.lastChild;
					}
	
					// Support: Android <=4.0 only, PhantomJS 1 only
					// push.apply(_, arraylike) throws on ancient WebKit
					jQuery.merge( nodes, tmp.childNodes );
	
					// Remember the top-level container
					tmp = fragment.firstChild;
	
					// Ensure the created nodes are orphaned (#12392)
					tmp.textContent = "";
				}
			}
		}
	
		// Remove wrapper from fragment
		fragment.textContent = "";
	
		i = 0;
		while ( ( elem = nodes[ i++ ] ) ) {
	
			// Skip elements already in the context collection (trac-4087)
			if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
				if ( ignored ) {
					ignored.push( elem );
				}
				continue;
			}
	
			attached = isAttached( elem );
	
			// Append to fragment
			tmp = getAll( fragment.appendChild( elem ), "script" );
	
			// Preserve script evaluation history
			if ( attached ) {
				setGlobalEval( tmp );
			}
	
			// Capture executables
			if ( scripts ) {
				j = 0;
				while ( ( elem = tmp[ j++ ] ) ) {
					if ( rscriptType.test( elem.type || "" ) ) {
						scripts.push( elem );
					}
				}
			}
		}
	
		return fragment;
	}
	
	
	var rtypenamespace = /^([^.]*)(?:\.(.+)|)/;
	
	function returnTrue() {
		return true;
	}
	
	function returnFalse() {
		return false;
	}
	
	// Support: IE <=9 - 11+
	// focus() and blur() are asynchronous, except when they are no-op.
	// So expect focus to be synchronous when the element is already active,
	// and blur to be synchronous when the element is not already active.
	// (focus and blur are always synchronous in other supported browsers,
	// this just defines when we can count on it).
	function expectSync( elem, type ) {
		return ( elem === safeActiveElement() ) === ( type === "focus" );
	}
	
	// Support: IE <=9 only
	// Accessing document.activeElement can throw unexpectedly
	// https://bugs.jquery.com/ticket/13393
	function safeActiveElement() {
		try {
			return document.activeElement;
		} catch ( err ) { }
	}
	
	function on( elem, types, selector, data, fn, one ) {
		var origFn, type;
	
		// Types can be a map of types/handlers
		if ( typeof types === "object" ) {
	
			// ( types-Object, selector, data )
			if ( typeof selector !== "string" ) {
	
				// ( types-Object, data )
				data = data || selector;
				selector = undefined;
			}
			for ( type in types ) {
				on( elem, type, selector, data, types[ type ], one );
			}
			return elem;
		}
	
		if ( data == null && fn == null ) {
	
			// ( types, fn )
			fn = selector;
			data = selector = undefined;
		} else if ( fn == null ) {
			if ( typeof selector === "string" ) {
	
				// ( types, selector, fn )
				fn = data;
				data = undefined;
			} else {
	
				// ( types, data, fn )
				fn = data;
				data = selector;
				selector = undefined;
			}
		}
		if ( fn === false ) {
			fn = returnFalse;
		} else if ( !fn ) {
			return elem;
		}
	
		if ( one === 1 ) {
			origFn = fn;
			fn = function( event ) {
	
				// Can use an empty set, since event contains the info
				jQuery().off( event );
				return origFn.apply( this, arguments );
			};
	
			// Use same guid so caller can remove using origFn
			fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
		}
		return elem.each( function() {
			jQuery.event.add( this, types, fn, data, selector );
		} );
	}
	
	/*
	 * Helper functions for managing events -- not part of the public interface.
	 * Props to Dean Edwards' addEvent library for many of the ideas.
	 */
	jQuery.event = {
	
		global: {},
	
		add: function( elem, types, handler, data, selector ) {
	
			var handleObjIn, eventHandle, tmp,
				events, t, handleObj,
				special, handlers, type, namespaces, origType,
				elemData = dataPriv.get( elem );
	
			// Only attach events to objects that accept data
			if ( !acceptData( elem ) ) {
				return;
			}
	
			// Caller can pass in an object of custom data in lieu of the handler
			if ( handler.handler ) {
				handleObjIn = handler;
				handler = handleObjIn.handler;
				selector = handleObjIn.selector;
			}
	
			// Ensure that invalid selectors throw exceptions at attach time
			// Evaluate against documentElement in case elem is a non-element node (e.g., document)
			if ( selector ) {
				jQuery.find.matchesSelector( documentElement, selector );
			}
	
			// Make sure that the handler has a unique ID, used to find/remove it later
			if ( !handler.guid ) {
				handler.guid = jQuery.guid++;
			}
	
			// Init the element's event structure and main handler, if this is the first
			if ( !( events = elemData.events ) ) {
				events = elemData.events = Object.create( null );
			}
			if ( !( eventHandle = elemData.handle ) ) {
				eventHandle = elemData.handle = function( e ) {
	
					// Discard the second event of a jQuery.event.trigger() and
					// when an event is called after a page has unloaded
					return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
						jQuery.event.dispatch.apply( elem, arguments ) : undefined;
				};
			}
	
			// Handle multiple events separated by a space
			types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
			t = types.length;
			while ( t-- ) {
				tmp = rtypenamespace.exec( types[ t ] ) || [];
				type = origType = tmp[ 1 ];
				namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();
	
				// There *must* be a type, no attaching namespace-only handlers
				if ( !type ) {
					continue;
				}
	
				// If event changes its type, use the special event handlers for the changed type
				special = jQuery.event.special[ type ] || {};
	
				// If selector defined, determine special event api type, otherwise given type
				type = ( selector ? special.delegateType : special.bindType ) || type;
	
				// Update special based on newly reset type
				special = jQuery.event.special[ type ] || {};
	
				// handleObj is passed to all event handlers
				handleObj = jQuery.extend( {
					type: type,
					origType: origType,
					data: data,
					handler: handler,
					guid: handler.guid,
					selector: selector,
					needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
					namespace: namespaces.join( "." )
				}, handleObjIn );
	
				// Init the event handler queue if we're the first
				if ( !( handlers = events[ type ] ) ) {
					handlers = events[ type ] = [];
					handlers.delegateCount = 0;
	
					// Only use addEventListener if the special events handler returns false
					if ( !special.setup ||
						special.setup.call( elem, data, namespaces, eventHandle ) === false ) {
	
						if ( elem.addEventListener ) {
							elem.addEventListener( type, eventHandle );
						}
					}
				}
	
				if ( special.add ) {
					special.add.call( elem, handleObj );
	
					if ( !handleObj.handler.guid ) {
						handleObj.handler.guid = handler.guid;
					}
				}
	
				// Add to the element's handler list, delegates in front
				if ( selector ) {
					handlers.splice( handlers.delegateCount++, 0, handleObj );
				} else {
					handlers.push( handleObj );
				}
	
				// Keep track of which events have ever been used, for event optimization
				jQuery.event.global[ type ] = true;
			}
	
		},
	
		// Detach an event or set of events from an element
		remove: function( elem, types, handler, selector, mappedTypes ) {
	
			var j, origCount, tmp,
				events, t, handleObj,
				special, handlers, type, namespaces, origType,
				elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );
	
			if ( !elemData || !( events = elemData.events ) ) {
				return;
			}
	
			// Once for each type.namespace in types; type may be omitted
			types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
			t = types.length;
			while ( t-- ) {
				tmp = rtypenamespace.exec( types[ t ] ) || [];
				type = origType = tmp[ 1 ];
				namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();
	
				// Unbind all events (on this namespace, if provided) for the element
				if ( !type ) {
					for ( type in events ) {
						jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
					}
					continue;
				}
	
				special = jQuery.event.special[ type ] || {};
				type = ( selector ? special.delegateType : special.bindType ) || type;
				handlers = events[ type ] || [];
				tmp = tmp[ 2 ] &&
					new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );
	
				// Remove matching events
				origCount = j = handlers.length;
				while ( j-- ) {
					handleObj = handlers[ j ];
	
					if ( ( mappedTypes || origType === handleObj.origType ) &&
						( !handler || handler.guid === handleObj.guid ) &&
						( !tmp || tmp.test( handleObj.namespace ) ) &&
						( !selector || selector === handleObj.selector ||
							selector === "**" && handleObj.selector ) ) {
						handlers.splice( j, 1 );
	
						if ( handleObj.selector ) {
							handlers.delegateCount--;
						}
						if ( special.remove ) {
							special.remove.call( elem, handleObj );
						}
					}
				}
	
				// Remove generic event handler if we removed something and no more handlers exist
				// (avoids potential for endless recursion during removal of special event handlers)
				if ( origCount && !handlers.length ) {
					if ( !special.teardown ||
						special.teardown.call( elem, namespaces, elemData.handle ) === false ) {
	
						jQuery.removeEvent( elem, type, elemData.handle );
					}
	
					delete events[ type ];
				}
			}
	
			// Remove data and the expando if it's no longer used
			if ( jQuery.isEmptyObject( events ) ) {
				dataPriv.remove( elem, "handle events" );
			}
		},
	
		dispatch: function( nativeEvent ) {
	
			var i, j, ret, matched, handleObj, handlerQueue,
				args = new Array( arguments.length ),
	
				// Make a writable jQuery.Event from the native event object
				event = jQuery.event.fix( nativeEvent ),
	
				handlers = (
					dataPriv.get( this, "events" ) || Object.create( null )
				)[ event.type ] || [],
				special = jQuery.event.special[ event.type ] || {};
	
			// Use the fix-ed jQuery.Event rather than the (read-only) native event
			args[ 0 ] = event;
	
			for ( i = 1; i < arguments.length; i++ ) {
				args[ i ] = arguments[ i ];
			}
	
			event.delegateTarget = this;
	
			// Call the preDispatch hook for the mapped type, and let it bail if desired
			if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
				return;
			}
	
			// Determine handlers
			handlerQueue = jQuery.event.handlers.call( this, event, handlers );
	
			// Run delegates first; they may want to stop propagation beneath us
			i = 0;
			while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
				event.currentTarget = matched.elem;
	
				j = 0;
				while ( ( handleObj = matched.handlers[ j++ ] ) &&
					!event.isImmediatePropagationStopped() ) {
	
					// If the event is namespaced, then each handler is only invoked if it is
					// specially universal or its namespaces are a superset of the event's.
					if ( !event.rnamespace || handleObj.namespace === false ||
						event.rnamespace.test( handleObj.namespace ) ) {
	
						event.handleObj = handleObj;
						event.data = handleObj.data;
	
						ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
							handleObj.handler ).apply( matched.elem, args );
	
						if ( ret !== undefined ) {
							if ( ( event.result = ret ) === false ) {
								event.preventDefault();
								event.stopPropagation();
							}
						}
					}
				}
			}
	
			// Call the postDispatch hook for the mapped type
			if ( special.postDispatch ) {
				special.postDispatch.call( this, event );
			}
	
			return event.result;
		},
	
		handlers: function( event, handlers ) {
			var i, handleObj, sel, matchedHandlers, matchedSelectors,
				handlerQueue = [],
				delegateCount = handlers.delegateCount,
				cur = event.target;
	
			// Find delegate handlers
			if ( delegateCount &&
	
				// Support: IE <=9
				// Black-hole SVG <use> instance trees (trac-13180)
				cur.nodeType &&
	
				// Support: Firefox <=42
				// Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
				// https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
				// Support: IE 11 only
				// ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
				!( event.type === "click" && event.button >= 1 ) ) {
	
				for ( ; cur !== this; cur = cur.parentNode || this ) {
	
					// Don't check non-elements (#13208)
					// Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
					if ( cur.nodeType === 1 && !( event.type === "click" && cur.disabled === true ) ) {
						matchedHandlers = [];
						matchedSelectors = {};
						for ( i = 0; i < delegateCount; i++ ) {
							handleObj = handlers[ i ];
	
							// Don't conflict with Object.prototype properties (#13203)
							sel = handleObj.selector + " ";
	
							if ( matchedSelectors[ sel ] === undefined ) {
								matchedSelectors[ sel ] = handleObj.needsContext ?
									jQuery( sel, this ).index( cur ) > -1 :
									jQuery.find( sel, this, null, [ cur ] ).length;
							}
							if ( matchedSelectors[ sel ] ) {
								matchedHandlers.push( handleObj );
							}
						}
						if ( matchedHandlers.length ) {
							handlerQueue.push( { elem: cur, handlers: matchedHandlers } );
						}
					}
				}
			}
	
			// Add the remaining (directly-bound) handlers
			cur = this;
			if ( delegateCount < handlers.length ) {
				handlerQueue.push( { elem: cur, handlers: handlers.slice( delegateCount ) } );
			}
	
			return handlerQueue;
		},
	
		addProp: function( name, hook ) {
			Object.defineProperty( jQuery.Event.prototype, name, {
				enumerable: true,
				configurable: true,
	
				get: isFunction( hook ) ?
					function() {
						if ( this.originalEvent ) {
							return hook( this.originalEvent );
						}
					} :
					function() {
						if ( this.originalEvent ) {
							return this.originalEvent[ name ];
						}
					},
	
				set: function( value ) {
					Object.defineProperty( this, name, {
						enumerable: true,
						configurable: true,
						writable: true,
						value: value
					} );
				}
			} );
		},
	
		fix: function( originalEvent ) {
			return originalEvent[ jQuery.expando ] ?
				originalEvent :
				new jQuery.Event( originalEvent );
		},
	
		special: {
			load: {
	
				// Prevent triggered image.load events from bubbling to window.load
				noBubble: true
			},
			click: {
	
				// Utilize native event to ensure correct state for checkable inputs
				setup: function( data ) {
	
					// For mutual compressibility with _default, replace `this` access with a local var.
					// `|| data` is dead code meant only to preserve the variable through minification.
					var el = this || data;
	
					// Claim the first handler
					if ( rcheckableType.test( el.type ) &&
						el.click && nodeName( el, "input" ) ) {
	
						// dataPriv.set( el, "click", ... )
						leverageNative( el, "click", returnTrue );
					}
	
					// Return false to allow normal processing in the caller
					return false;
				},
				trigger: function( data ) {
	
					// For mutual compressibility with _default, replace `this` access with a local var.
					// `|| data` is dead code meant only to preserve the variable through minification.
					var el = this || data;
	
					// Force setup before triggering a click
					if ( rcheckableType.test( el.type ) &&
						el.click && nodeName( el, "input" ) ) {
	
						leverageNative( el, "click" );
					}
	
					// Return non-false to allow normal event-path propagation
					return true;
				},
	
				// For cross-browser consistency, suppress native .click() on links
				// Also prevent it if we're currently inside a leveraged native-event stack
				_default: function( event ) {
					var target = event.target;
					return rcheckableType.test( target.type ) &&
						target.click && nodeName( target, "input" ) &&
						dataPriv.get( target, "click" ) ||
						nodeName( target, "a" );
				}
			},
	
			beforeunload: {
				postDispatch: function( event ) {
	
					// Support: Firefox 20+
					// Firefox doesn't alert if the returnValue field is not set.
					if ( event.result !== undefined && event.originalEvent ) {
						event.originalEvent.returnValue = event.result;
					}
				}
			}
		}
	};
	
	// Ensure the presence of an event listener that handles manually-triggered
	// synthetic events by interrupting progress until reinvoked in response to
	// *native* events that it fires directly, ensuring that state changes have
	// already occurred before other listeners are invoked.
	function leverageNative( el, type, expectSync ) {
	
		// Missing expectSync indicates a trigger call, which must force setup through jQuery.event.add
		if ( !expectSync ) {
			if ( dataPriv.get( el, type ) === undefined ) {
				jQuery.event.add( el, type, returnTrue );
			}
			return;
		}
	
		// Register the controller as a special universal handler for all event namespaces
		dataPriv.set( el, type, false );
		jQuery.event.add( el, type, {
			namespace: false,
			handler: function( event ) {
				var notAsync, result,
					saved = dataPriv.get( this, type );
	
				if ( ( event.isTrigger & 1 ) && this[ type ] ) {
	
					// Interrupt processing of the outer synthetic .trigger()ed event
					// Saved data should be false in such cases, but might be a leftover capture object
					// from an async native handler (gh-4350)
					if ( !saved.length ) {
	
						// Store arguments for use when handling the inner native event
						// There will always be at least one argument (an event object), so this array
						// will not be confused with a leftover capture object.
						saved = slice.call( arguments );
						dataPriv.set( this, type, saved );
	
						// Trigger the native event and capture its result
						// Support: IE <=9 - 11+
						// focus() and blur() are asynchronous
						notAsync = expectSync( this, type );
						this[ type ]();
						result = dataPriv.get( this, type );
						if ( saved !== result || notAsync ) {
							dataPriv.set( this, type, false );
						} else {
							result = {};
						}
						if ( saved !== result ) {
	
							// Cancel the outer synthetic event
							event.stopImmediatePropagation();
							event.preventDefault();
	
							// Support: Chrome 86+
							// In Chrome, if an element having a focusout handler is blurred by
							// clicking outside of it, it invokes the handler synchronously. If
							// that handler calls `.remove()` on the element, the data is cleared,
							// leaving `result` undefined. We need to guard against this.
							return result && result.value;
						}
	
					// If this is an inner synthetic event for an event with a bubbling surrogate
					// (focus or blur), assume that the surrogate already propagated from triggering the
					// native event and prevent that from happening again here.
					// This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
					// bubbling surrogate propagates *after* the non-bubbling base), but that seems
					// less bad than duplication.
					} else if ( ( jQuery.event.special[ type ] || {} ).delegateType ) {
						event.stopPropagation();
					}
	
				// If this is a native event triggered above, everything is now in order
				// Fire an inner synthetic event with the original arguments
				} else if ( saved.length ) {
	
					// ...and capture the result
					dataPriv.set( this, type, {
						value: jQuery.event.trigger(
	
							// Support: IE <=9 - 11+
							// Extend with the prototype to reset the above stopImmediatePropagation()
							jQuery.extend( saved[ 0 ], jQuery.Event.prototype ),
							saved.slice( 1 ),
							this
						)
					} );
	
					// Abort handling of the native event
					event.stopImmediatePropagation();
				}
			}
		} );
	}
	
	jQuery.removeEvent = function( elem, type, handle ) {
	
		// This "if" is needed for plain objects
		if ( elem.removeEventListener ) {
			elem.removeEventListener( type, handle );
		}
	};
	
	jQuery.Event = function( src, props ) {
	
		// Allow instantiation without the 'new' keyword
		if ( !( this instanceof jQuery.Event ) ) {
			return new jQuery.Event( src, props );
		}
	
		// Event object
		if ( src && src.type ) {
			this.originalEvent = src;
			this.type = src.type;
	
			// Events bubbling up the document may have been marked as prevented
			// by a handler lower down the tree; reflect the correct value.
			this.isDefaultPrevented = src.defaultPrevented ||
					src.defaultPrevented === undefined &&
	
					// Support: Android <=2.3 only
					src.returnValue === false ?
				returnTrue :
				returnFalse;
	
			// Create target properties
			// Support: Safari <=6 - 7 only
			// Target should not be a text node (#504, #13143)
			this.target = ( src.target && src.target.nodeType === 3 ) ?
				src.target.parentNode :
				src.target;
	
			this.currentTarget = src.currentTarget;
			this.relatedTarget = src.relatedTarget;
	
		// Event type
		} else {
			this.type = src;
		}
	
		// Put explicitly provided properties onto the event object
		if ( props ) {
			jQuery.extend( this, props );
		}
	
		// Create a timestamp if incoming event doesn't have one
		this.timeStamp = src && src.timeStamp || Date.now();
	
		// Mark it as fixed
		this[ jQuery.expando ] = true;
	};
	
	// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
	// https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
	jQuery.Event.prototype = {
		constructor: jQuery.Event,
		isDefaultPrevented: returnFalse,
		isPropagationStopped: returnFalse,
		isImmediatePropagationStopped: returnFalse,
		isSimulated: false,
	
		preventDefault: function() {
			var e = this.originalEvent;
	
			this.isDefaultPrevented = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.preventDefault();
			}
		},
		stopPropagation: function() {
			var e = this.originalEvent;
	
			this.isPropagationStopped = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.stopPropagation();
			}
		},
		stopImmediatePropagation: function() {
			var e = this.originalEvent;
	
			this.isImmediatePropagationStopped = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.stopImmediatePropagation();
			}
	
			this.stopPropagation();
		}
	};
	
	// Includes all common event props including KeyEvent and MouseEvent specific props
	jQuery.each( {
		altKey: true,
		bubbles: true,
		cancelable: true,
		changedTouches: true,
		ctrlKey: true,
		detail: true,
		eventPhase: true,
		metaKey: true,
		pageX: true,
		pageY: true,
		shiftKey: true,
		view: true,
		"char": true,
		code: true,
		charCode: true,
		key: true,
		keyCode: true,
		button: true,
		buttons: true,
		clientX: true,
		clientY: true,
		offsetX: true,
		offsetY: true,
		pointerId: true,
		pointerType: true,
		screenX: true,
		screenY: true,
		targetTouches: true,
		toElement: true,
		touches: true,
		which: true
	}, jQuery.event.addProp );
	
	jQuery.each( { focus: "focusin", blur: "focusout" }, function( type, delegateType ) {
		jQuery.event.special[ type ] = {
	
			// Utilize native event if possible so blur/focus sequence is correct
			setup: function() {
	
				// Claim the first handler
				// dataPriv.set( this, "focus", ... )
				// dataPriv.set( this, "blur", ... )
				leverageNative( this, type, expectSync );
	
				// Return false to allow normal processing in the caller
				return false;
			},
			trigger: function() {
	
				// Force setup before trigger
				leverageNative( this, type );
	
				// Return non-false to allow normal event-path propagation
				return true;
			},
	
			// Suppress native focus or blur as it's already being fired
			// in leverageNative.
			_default: function() {
				return true;
			},
	
			delegateType: delegateType
		};
	} );
	
	// Create mouseenter/leave events using mouseover/out and event-time checks
	// so that event delegation works in jQuery.
	// Do the same for pointerenter/pointerleave and pointerover/pointerout
	//
	// Support: Safari 7 only
	// Safari sends mouseenter too often; see:
	// https://bugs.chromium.org/p/chromium/issues/detail?id=470258
	// for the description of the bug (it existed in older Chrome versions as well).
	jQuery.each( {
		mouseenter: "mouseover",
		mouseleave: "mouseout",
		pointerenter: "pointerover",
		pointerleave: "pointerout"
	}, function( orig, fix ) {
		jQuery.event.special[ orig ] = {
			delegateType: fix,
			bindType: fix,
	
			handle: function( event ) {
				var ret,
					target = this,
					related = event.relatedTarget,
					handleObj = event.handleObj;
	
				// For mouseenter/leave call the handler if related is outside the target.
				// NB: No relatedTarget if the mouse left/entered the browser window
				if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
					event.type = handleObj.origType;
					ret = handleObj.handler.apply( this, arguments );
					event.type = fix;
				}
				return ret;
			}
		};
	} );
	
	jQuery.fn.extend( {
	
		on: function( types, selector, data, fn ) {
			return on( this, types, selector, data, fn );
		},
		one: function( types, selector, data, fn ) {
			return on( this, types, selector, data, fn, 1 );
		},
		off: function( types, selector, fn ) {
			var handleObj, type;
			if ( types && types.preventDefault && types.handleObj ) {
	
				// ( event )  dispatched jQuery.Event
				handleObj = types.handleObj;
				jQuery( types.delegateTarget ).off(
					handleObj.namespace ?
						handleObj.origType + "." + handleObj.namespace :
						handleObj.origType,
					handleObj.selector,
					handleObj.handler
				);
				return this;
			}
			if ( typeof types === "object" ) {
	
				// ( types-object [, selector] )
				for ( type in types ) {
					this.off( type, selector, types[ type ] );
				}
				return this;
			}
			if ( selector === false || typeof selector === "function" ) {
	
				// ( types [, fn] )
				fn = selector;
				selector = undefined;
			}
			if ( fn === false ) {
				fn = returnFalse;
			}
			return this.each( function() {
				jQuery.event.remove( this, types, fn, selector );
			} );
		}
	} );
	
	
	var
	
		// Support: IE <=10 - 11, Edge 12 - 13 only
		// In IE/Edge using regex groups here causes severe slowdowns.
		// See https://connect.microsoft.com/IE/feedback/details/1736512/
		rnoInnerhtml = /<script|<style|<link/i,
	
		// checked="checked" or checked
		rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
		rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;
	
	// Prefer a tbody over its parent table for containing new rows
	function manipulationTarget( elem, content ) {
		if ( nodeName( elem, "table" ) &&
			nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ) {
	
			return jQuery( elem ).children( "tbody" )[ 0 ] || elem;
		}
	
		return elem;
	}
	
	// Replace/restore the type attribute of script elements for safe DOM manipulation
	function disableScript( elem ) {
		elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
		return elem;
	}
	function restoreScript( elem ) {
		if ( ( elem.type || "" ).slice( 0, 5 ) === "true/" ) {
			elem.type = elem.type.slice( 5 );
		} else {
			elem.removeAttribute( "type" );
		}
	
		return elem;
	}
	
	function cloneCopyEvent( src, dest ) {
		var i, l, type, pdataOld, udataOld, udataCur, events;
	
		if ( dest.nodeType !== 1 ) {
			return;
		}
	
		// 1. Copy private data: events, handlers, etc.
		if ( dataPriv.hasData( src ) ) {
			pdataOld = dataPriv.get( src );
			events = pdataOld.events;
	
			if ( events ) {
				dataPriv.remove( dest, "handle events" );
	
				for ( type in events ) {
					for ( i = 0, l = events[ type ].length; i < l; i++ ) {
						jQuery.event.add( dest, type, events[ type ][ i ] );
					}
				}
			}
		}
	
		// 2. Copy user data
		if ( dataUser.hasData( src ) ) {
			udataOld = dataUser.access( src );
			udataCur = jQuery.extend( {}, udataOld );
	
			dataUser.set( dest, udataCur );
		}
	}
	
	// Fix IE bugs, see support tests
	function fixInput( src, dest ) {
		var nodeName = dest.nodeName.toLowerCase();
	
		// Fails to persist the checked state of a cloned checkbox or radio button.
		if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
			dest.checked = src.checked;
	
		// Fails to return the selected option to the default selected state when cloning options
		} else if ( nodeName === "input" || nodeName === "textarea" ) {
			dest.defaultValue = src.defaultValue;
		}
	}
	
	function domManip( collection, args, callback, ignored ) {
	
		// Flatten any nested arrays
		args = flat( args );
	
		var fragment, first, scripts, hasScripts, node, doc,
			i = 0,
			l = collection.length,
			iNoClone = l - 1,
			value = args[ 0 ],
			valueIsFunction = isFunction( value );
	
		// We can't cloneNode fragments that contain checked, in WebKit
		if ( valueIsFunction ||
				( l > 1 && typeof value === "string" &&
					!support.checkClone && rchecked.test( value ) ) ) {
			return collection.each( function( index ) {
				var self = collection.eq( index );
				if ( valueIsFunction ) {
					args[ 0 ] = value.call( this, index, self.html() );
				}
				domManip( self, args, callback, ignored );
			} );
		}
	
		if ( l ) {
			fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
			first = fragment.firstChild;
	
			if ( fragment.childNodes.length === 1 ) {
				fragment = first;
			}
	
			// Require either new content or an interest in ignored elements to invoke the callback
			if ( first || ignored ) {
				scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
				hasScripts = scripts.length;
	
				// Use the original fragment for the last item
				// instead of the first because it can end up
				// being emptied incorrectly in certain situations (#8070).
				for ( ; i < l; i++ ) {
					node = fragment;
	
					if ( i !== iNoClone ) {
						node = jQuery.clone( node, true, true );
	
						// Keep references to cloned scripts for later restoration
						if ( hasScripts ) {
	
							// Support: Android <=4.0 only, PhantomJS 1 only
							// push.apply(_, arraylike) throws on ancient WebKit
							jQuery.merge( scripts, getAll( node, "script" ) );
						}
					}
	
					callback.call( collection[ i ], node, i );
				}
	
				if ( hasScripts ) {
					doc = scripts[ scripts.length - 1 ].ownerDocument;
	
					// Reenable scripts
					jQuery.map( scripts, restoreScript );
	
					// Evaluate executable scripts on first document insertion
					for ( i = 0; i < hasScripts; i++ ) {
						node = scripts[ i ];
						if ( rscriptType.test( node.type || "" ) &&
							!dataPriv.access( node, "globalEval" ) &&
							jQuery.contains( doc, node ) ) {
	
							if ( node.src && ( node.type || "" ).toLowerCase()  !== "module" ) {
	
								// Optional AJAX dependency, but won't run scripts if not present
								if ( jQuery._evalUrl && !node.noModule ) {
									jQuery._evalUrl( node.src, {
										nonce: node.nonce || node.getAttribute( "nonce" )
									}, doc );
								}
							} else {
								DOMEval( node.textContent.replace( rcleanScript, "" ), node, doc );
							}
						}
					}
				}
			}
		}
	
		return collection;
	}
	
	function remove( elem, selector, keepData ) {
		var node,
			nodes = selector ? jQuery.filter( selector, elem ) : elem,
			i = 0;
	
		for ( ; ( node = nodes[ i ] ) != null; i++ ) {
			if ( !keepData && node.nodeType === 1 ) {
				jQuery.cleanData( getAll( node ) );
			}
	
			if ( node.parentNode ) {
				if ( keepData && isAttached( node ) ) {
					setGlobalEval( getAll( node, "script" ) );
				}
				node.parentNode.removeChild( node );
			}
		}
	
		return elem;
	}
	
	jQuery.extend( {
		htmlPrefilter: function( html ) {
			return html;
		},
	
		clone: function( elem, dataAndEvents, deepDataAndEvents ) {
			var i, l, srcElements, destElements,
				clone = elem.cloneNode( true ),
				inPage = isAttached( elem );
	
			// Fix IE cloning issues
			if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
					!jQuery.isXMLDoc( elem ) ) {
	
				// We eschew Sizzle here for performance reasons: https://jsperf.com/getall-vs-sizzle/2
				destElements = getAll( clone );
				srcElements = getAll( elem );
	
				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					fixInput( srcElements[ i ], destElements[ i ] );
				}
			}
	
			// Copy the events from the original to the clone
			if ( dataAndEvents ) {
				if ( deepDataAndEvents ) {
					srcElements = srcElements || getAll( elem );
					destElements = destElements || getAll( clone );
	
					for ( i = 0, l = srcElements.length; i < l; i++ ) {
						cloneCopyEvent( srcElements[ i ], destElements[ i ] );
					}
				} else {
					cloneCopyEvent( elem, clone );
				}
			}
	
			// Preserve script evaluation history
			destElements = getAll( clone, "script" );
			if ( destElements.length > 0 ) {
				setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
			}
	
			// Return the cloned set
			return clone;
		},
	
		cleanData: function( elems ) {
			var data, elem, type,
				special = jQuery.event.special,
				i = 0;
	
			for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
				if ( acceptData( elem ) ) {
					if ( ( data = elem[ dataPriv.expando ] ) ) {
						if ( data.events ) {
							for ( type in data.events ) {
								if ( special[ type ] ) {
									jQuery.event.remove( elem, type );
	
								// This is a shortcut to avoid jQuery.event.remove's overhead
								} else {
									jQuery.removeEvent( elem, type, data.handle );
								}
							}
						}
	
						// Support: Chrome <=35 - 45+
						// Assign undefined instead of using delete, see Data#remove
						elem[ dataPriv.expando ] = undefined;
					}
					if ( elem[ dataUser.expando ] ) {
	
						// Support: Chrome <=35 - 45+
						// Assign undefined instead of using delete, see Data#remove
						elem[ dataUser.expando ] = undefined;
					}
				}
			}
		}
	} );
	
	jQuery.fn.extend( {
		detach: function( selector ) {
			return remove( this, selector, true );
		},
	
		remove: function( selector ) {
			return remove( this, selector );
		},
	
		text: function( value ) {
			return access( this, function( value ) {
				return value === undefined ?
					jQuery.text( this ) :
					this.empty().each( function() {
						if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
							this.textContent = value;
						}
					} );
			}, null, value, arguments.length );
		},
	
		append: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
					var target = manipulationTarget( this, elem );
					target.appendChild( elem );
				}
			} );
		},
	
		prepend: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
					var target = manipulationTarget( this, elem );
					target.insertBefore( elem, target.firstChild );
				}
			} );
		},
	
		before: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.parentNode ) {
					this.parentNode.insertBefore( elem, this );
				}
			} );
		},
	
		after: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.parentNode ) {
					this.parentNode.insertBefore( elem, this.nextSibling );
				}
			} );
		},
	
		empty: function() {
			var elem,
				i = 0;
	
			for ( ; ( elem = this[ i ] ) != null; i++ ) {
				if ( elem.nodeType === 1 ) {
	
					// Prevent memory leaks
					jQuery.cleanData( getAll( elem, false ) );
	
					// Remove any remaining nodes
					elem.textContent = "";
				}
			}
	
			return this;
		},
	
		clone: function( dataAndEvents, deepDataAndEvents ) {
			dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
			deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;
	
			return this.map( function() {
				return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
			} );
		},
	
		html: function( value ) {
			return access( this, function( value ) {
				var elem = this[ 0 ] || {},
					i = 0,
					l = this.length;
	
				if ( value === undefined && elem.nodeType === 1 ) {
					return elem.innerHTML;
				}
	
				// See if we can take a shortcut and just use innerHTML
				if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
					!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {
	
					value = jQuery.htmlPrefilter( value );
	
					try {
						for ( ; i < l; i++ ) {
							elem = this[ i ] || {};
	
							// Remove element nodes and prevent memory leaks
							if ( elem.nodeType === 1 ) {
								jQuery.cleanData( getAll( elem, false ) );
								elem.innerHTML = value;
							}
						}
	
						elem = 0;
	
					// If using innerHTML throws an exception, use the fallback method
					} catch ( e ) {}
				}
	
				if ( elem ) {
					this.empty().append( value );
				}
			}, null, value, arguments.length );
		},
	
		replaceWith: function() {
			var ignored = [];
	
			// Make the changes, replacing each non-ignored context element with the new content
			return domManip( this, arguments, function( elem ) {
				var parent = this.parentNode;
	
				if ( jQuery.inArray( this, ignored ) < 0 ) {
					jQuery.cleanData( getAll( this ) );
					if ( parent ) {
						parent.replaceChild( elem, this );
					}
				}
	
			// Force callback invocation
			}, ignored );
		}
	} );
	
	jQuery.each( {
		appendTo: "append",
		prependTo: "prepend",
		insertBefore: "before",
		insertAfter: "after",
		replaceAll: "replaceWith"
	}, function( name, original ) {
		jQuery.fn[ name ] = function( selector ) {
			var elems,
				ret = [],
				insert = jQuery( selector ),
				last = insert.length - 1,
				i = 0;
	
			for ( ; i <= last; i++ ) {
				elems = i === last ? this : this.clone( true );
				jQuery( insert[ i ] )[ original ]( elems );
	
				// Support: Android <=4.0 only, PhantomJS 1 only
				// .get() because push.apply(_, arraylike) throws on ancient WebKit
				push.apply( ret, elems.get() );
			}
	
			return this.pushStack( ret );
		};
	} );
	var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );
	
	var getStyles = function( elem ) {
	
			// Support: IE <=11 only, Firefox <=30 (#15098, #14150)
			// IE throws on elements created in popups
			// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
			var view = elem.ownerDocument.defaultView;
	
			if ( !view || !view.opener ) {
				view = window;
			}
	
			return view.getComputedStyle( elem );
		};
	
	var swap = function( elem, options, callback ) {
		var ret, name,
			old = {};
	
		// Remember the old values, and insert the new ones
		for ( name in options ) {
			old[ name ] = elem.style[ name ];
			elem.style[ name ] = options[ name ];
		}
	
		ret = callback.call( elem );
	
		// Revert the old values
		for ( name in options ) {
			elem.style[ name ] = old[ name ];
		}
	
		return ret;
	};
	
	
	var rboxStyle = new RegExp( cssExpand.join( "|" ), "i" );
	
	
	
	( function() {
	
		// Executing both pixelPosition & boxSizingReliable tests require only one layout
		// so they're executed at the same time to save the second computation.
		function computeStyleTests() {
	
			// This is a singleton, we need to execute it only once
			if ( !div ) {
				return;
			}
	
			container.style.cssText = "position:absolute;left:-11111px;width:60px;" +
				"margin-top:1px;padding:0;border:0";
			div.style.cssText =
				"position:relative;display:block;box-sizing:border-box;overflow:scroll;" +
				"margin:auto;border:1px;padding:1px;" +
				"width:60%;top:1%";
			documentElement.appendChild( container ).appendChild( div );
	
			var divStyle = window.getComputedStyle( div );
			pixelPositionVal = divStyle.top !== "1%";
	
			// Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
			reliableMarginLeftVal = roundPixelMeasures( divStyle.marginLeft ) === 12;
	
			// Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
			// Some styles come back with percentage values, even though they shouldn't
			div.style.right = "60%";
			pixelBoxStylesVal = roundPixelMeasures( divStyle.right ) === 36;
	
			// Support: IE 9 - 11 only
			// Detect misreporting of content dimensions for box-sizing:border-box elements
			boxSizingReliableVal = roundPixelMeasures( divStyle.width ) === 36;
	
			// Support: IE 9 only
			// Detect overflow:scroll screwiness (gh-3699)
			// Support: Chrome <=64
			// Don't get tricked when zoom affects offsetWidth (gh-4029)
			div.style.position = "absolute";
			scrollboxSizeVal = roundPixelMeasures( div.offsetWidth / 3 ) === 12;
	
			documentElement.removeChild( container );
	
			// Nullify the div so it wouldn't be stored in the memory and
			// it will also be a sign that checks already performed
			div = null;
		}
	
		function roundPixelMeasures( measure ) {
			return Math.round( parseFloat( measure ) );
		}
	
		var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal,
			reliableTrDimensionsVal, reliableMarginLeftVal,
			container = document.createElement( "div" ),
			div = document.createElement( "div" );
	
		// Finish early in limited (non-browser) environments
		if ( !div.style ) {
			return;
		}
	
		// Support: IE <=9 - 11 only
		// Style of cloned element affects source element cloned (#8908)
		div.style.backgroundClip = "content-box";
		div.cloneNode( true ).style.backgroundClip = "";
		support.clearCloneStyle = div.style.backgroundClip === "content-box";
	
		jQuery.extend( support, {
			boxSizingReliable: function() {
				computeStyleTests();
				return boxSizingReliableVal;
			},
			pixelBoxStyles: function() {
				computeStyleTests();
				return pixelBoxStylesVal;
			},
			pixelPosition: function() {
				computeStyleTests();
				return pixelPositionVal;
			},
			reliableMarginLeft: function() {
				computeStyleTests();
				return reliableMarginLeftVal;
			},
			scrollboxSize: function() {
				computeStyleTests();
				return scrollboxSizeVal;
			},
	
			// Support: IE 9 - 11+, Edge 15 - 18+
			// IE/Edge misreport `getComputedStyle` of table rows with width/height
			// set in CSS while `offset*` properties report correct values.
			// Behavior in IE 9 is more subtle than in newer versions & it passes
			// some versions of this test; make sure not to make it pass there!
			//
			// Support: Firefox 70+
			// Only Firefox includes border widths
			// in computed dimensions. (gh-4529)
			reliableTrDimensions: function() {
				var table, tr, trChild, trStyle;
				if ( reliableTrDimensionsVal == null ) {
					table = document.createElement( "table" );
					tr = document.createElement( "tr" );
					trChild = document.createElement( "div" );
	
					table.style.cssText = "position:absolute;left:-11111px;border-collapse:separate";
					tr.style.cssText = "border:1px solid";
	
					// Support: Chrome 86+
					// Height set through cssText does not get applied.
					// Computed height then comes back as 0.
					tr.style.height = "1px";
					trChild.style.height = "9px";
	
					// Support: Android 8 Chrome 86+
					// In our bodyBackground.html iframe,
					// display for all div elements is set to "inline",
					// which causes a problem only in Android 8 Chrome 86.
					// Ensuring the div is display: block
					// gets around this issue.
					trChild.style.display = "block";
	
					documentElement
						.appendChild( table )
						.appendChild( tr )
						.appendChild( trChild );
	
					trStyle = window.getComputedStyle( tr );
					reliableTrDimensionsVal = ( parseInt( trStyle.height, 10 ) +
						parseInt( trStyle.borderTopWidth, 10 ) +
						parseInt( trStyle.borderBottomWidth, 10 ) ) === tr.offsetHeight;
	
					documentElement.removeChild( table );
				}
				return reliableTrDimensionsVal;
			}
		} );
	} )();
	
	
	function curCSS( elem, name, computed ) {
		var width, minWidth, maxWidth, ret,
	
			// Support: Firefox 51+
			// Retrieving style before computed somehow
			// fixes an issue with getting wrong values
			// on detached elements
			style = elem.style;
	
		computed = computed || getStyles( elem );
	
		// getPropertyValue is needed for:
		//   .css('filter') (IE 9 only, #12537)
		//   .css('--customProperty) (#3144)
		if ( computed ) {
			ret = computed.getPropertyValue( name ) || computed[ name ];
	
			if ( ret === "" && !isAttached( elem ) ) {
				ret = jQuery.style( elem, name );
			}
	
			// A tribute to the "awesome hack by Dean Edwards"
			// Android Browser returns percentage for some values,
			// but width seems to be reliably pixels.
			// This is against the CSSOM draft spec:
			// https://drafts.csswg.org/cssom/#resolved-values
			if ( !support.pixelBoxStyles() && rnumnonpx.test( ret ) && rboxStyle.test( name ) ) {
	
				// Remember the original values
				width = style.width;
				minWidth = style.minWidth;
				maxWidth = style.maxWidth;
	
				// Put in the new values to get a computed value out
				style.minWidth = style.maxWidth = style.width = ret;
				ret = computed.width;
	
				// Revert the changed values
				style.width = width;
				style.minWidth = minWidth;
				style.maxWidth = maxWidth;
			}
		}
	
		return ret !== undefined ?
	
			// Support: IE <=9 - 11 only
			// IE returns zIndex value as an integer.
			ret + "" :
			ret;
	}
	
	
	function addGetHookIf( conditionFn, hookFn ) {
	
		// Define the hook, we'll check on the first run if it's really needed.
		return {
			get: function() {
				if ( conditionFn() ) {
	
					// Hook not needed (or it's not possible to use it due
					// to missing dependency), remove it.
					delete this.get;
					return;
				}
	
				// Hook needed; redefine it so that the support test is not executed again.
				return ( this.get = hookFn ).apply( this, arguments );
			}
		};
	}
	
	
	var cssPrefixes = [ "Webkit", "Moz", "ms" ],
		emptyStyle = document.createElement( "div" ).style,
		vendorProps = {};
	
	// Return a vendor-prefixed property or undefined
	function vendorPropName( name ) {
	
		// Check for vendor prefixed names
		var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
			i = cssPrefixes.length;
	
		while ( i-- ) {
			name = cssPrefixes[ i ] + capName;
			if ( name in emptyStyle ) {
				return name;
			}
		}
	}
	
	// Return a potentially-mapped jQuery.cssProps or vendor prefixed property
	function finalPropName( name ) {
		var final = jQuery.cssProps[ name ] || vendorProps[ name ];
	
		if ( final ) {
			return final;
		}
		if ( name in emptyStyle ) {
			return name;
		}
		return vendorProps[ name ] = vendorPropName( name ) || name;
	}
	
	
	var
	
		// Swappable if display is none or starts with table
		// except "table", "table-cell", or "table-caption"
		// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
		rdisplayswap = /^(none|table(?!-c[ea]).+)/,
		rcustomProp = /^--/,
		cssShow = { position: "absolute", visibility: "hidden", display: "block" },
		cssNormalTransform = {
			letterSpacing: "0",
			fontWeight: "400"
		};
	
	function setPositiveNumber( _elem, value, subtract ) {
	
		// Any relative (+/-) values have already been
		// normalized at this point
		var matches = rcssNum.exec( value );
		return matches ?
	
			// Guard against undefined "subtract", e.g., when used as in cssHooks
			Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
			value;
	}
	
	function boxModelAdjustment( elem, dimension, box, isBorderBox, styles, computedVal ) {
		var i = dimension === "width" ? 1 : 0,
			extra = 0,
			delta = 0;
	
		// Adjustment may not be necessary
		if ( box === ( isBorderBox ? "border" : "content" ) ) {
			return 0;
		}
	
		for ( ; i < 4; i += 2 ) {
	
			// Both box models exclude margin
			if ( box === "margin" ) {
				delta += jQuery.css( elem, box + cssExpand[ i ], true, styles );
			}
	
			// If we get here with a content-box, we're seeking "padding" or "border" or "margin"
			if ( !isBorderBox ) {
	
				// Add padding
				delta += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
	
				// For "border" or "margin", add border
				if ( box !== "padding" ) {
					delta += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
	
				// But still keep track of it otherwise
				} else {
					extra += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
				}
	
			// If we get here with a border-box (content + padding + border), we're seeking "content" or
			// "padding" or "margin"
			} else {
	
				// For "content", subtract padding
				if ( box === "content" ) {
					delta -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
				}
	
				// For "content" or "padding", subtract border
				if ( box !== "margin" ) {
					delta -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
				}
			}
		}
	
		// Account for positive content-box scroll gutter when requested by providing computedVal
		if ( !isBorderBox && computedVal >= 0 ) {
	
			// offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
			// Assuming integer scroll gutter, subtract the rest and round down
			delta += Math.max( 0, Math.ceil(
				elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
				computedVal -
				delta -
				extra -
				0.5
	
			// If offsetWidth/offsetHeight is unknown, then we can't determine content-box scroll gutter
			// Use an explicit zero to avoid NaN (gh-3964)
			) ) || 0;
		}
	
		return delta;
	}
	
	function getWidthOrHeight( elem, dimension, extra ) {
	
		// Start with computed style
		var styles = getStyles( elem ),
	
			// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
			// Fake content-box until we know it's needed to know the true value.
			boxSizingNeeded = !support.boxSizingReliable() || extra,
			isBorderBox = boxSizingNeeded &&
				jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
			valueIsBorderBox = isBorderBox,
	
			val = curCSS( elem, dimension, styles ),
			offsetProp = "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 );
	
		// Support: Firefox <=54
		// Return a confounding non-pixel value or feign ignorance, as appropriate.
		if ( rnumnonpx.test( val ) ) {
			if ( !extra ) {
				return val;
			}
			val = "auto";
		}
	
	
		// Support: IE 9 - 11 only
		// Use offsetWidth/offsetHeight for when box sizing is unreliable.
		// In those cases, the computed value can be trusted to be border-box.
		if ( ( !support.boxSizingReliable() && isBorderBox ||
	
			// Support: IE 10 - 11+, Edge 15 - 18+
			// IE/Edge misreport `getComputedStyle` of table rows with width/height
			// set in CSS while `offset*` properties report correct values.
			// Interestingly, in some cases IE 9 doesn't suffer from this issue.
			!support.reliableTrDimensions() && nodeName( elem, "tr" ) ||
	
			// Fall back to offsetWidth/offsetHeight when value is "auto"
			// This happens for inline elements with no explicit setting (gh-3571)
			val === "auto" ||
	
			// Support: Android <=4.1 - 4.3 only
			// Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
			!parseFloat( val ) && jQuery.css( elem, "display", false, styles ) === "inline" ) &&
	
			// Make sure the element is visible & connected
			elem.getClientRects().length ) {
	
			isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box";
	
			// Where available, offsetWidth/offsetHeight approximate border box dimensions.
			// Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
			// retrieved value as a content box dimension.
			valueIsBorderBox = offsetProp in elem;
			if ( valueIsBorderBox ) {
				val = elem[ offsetProp ];
			}
		}
	
		// Normalize "" and auto
		val = parseFloat( val ) || 0;
	
		// Adjust for the element's box model
		return ( val +
			boxModelAdjustment(
				elem,
				dimension,
				extra || ( isBorderBox ? "border" : "content" ),
				valueIsBorderBox,
				styles,
	
				// Provide the current computed size to request scroll gutter calculation (gh-3589)
				val
			)
		) + "px";
	}
	
	jQuery.extend( {
	
		// Add in style property hooks for overriding the default
		// behavior of getting and setting a style property
		cssHooks: {
			opacity: {
				get: function( elem, computed ) {
					if ( computed ) {
	
						// We should always get a number back from opacity
						var ret = curCSS( elem, "opacity" );
						return ret === "" ? "1" : ret;
					}
				}
			}
		},
	
		// Don't automatically add "px" to these possibly-unitless properties
		cssNumber: {
			"animationIterationCount": true,
			"columnCount": true,
			"fillOpacity": true,
			"flexGrow": true,
			"flexShrink": true,
			"fontWeight": true,
			"gridArea": true,
			"gridColumn": true,
			"gridColumnEnd": true,
			"gridColumnStart": true,
			"gridRow": true,
			"gridRowEnd": true,
			"gridRowStart": true,
			"lineHeight": true,
			"opacity": true,
			"order": true,
			"orphans": true,
			"widows": true,
			"zIndex": true,
			"zoom": true
		},
	
		// Add in properties whose names you wish to fix before
		// setting or getting the value
		cssProps: {},
	
		// Get and set the style property on a DOM Node
		style: function( elem, name, value, extra ) {
	
			// Don't set styles on text and comment nodes
			if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
				return;
			}
	
			// Make sure that we're working with the right name
			var ret, type, hooks,
				origName = camelCase( name ),
				isCustomProp = rcustomProp.test( name ),
				style = elem.style;
	
			// Make sure that we're working with the right name. We don't
			// want to query the value if it is a CSS custom property
			// since they are user-defined.
			if ( !isCustomProp ) {
				name = finalPropName( origName );
			}
	
			// Gets hook for the prefixed version, then unprefixed version
			hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];
	
			// Check if we're setting a value
			if ( value !== undefined ) {
				type = typeof value;
	
				// Convert "+=" or "-=" to relative numbers (#7345)
				if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
					value = adjustCSS( elem, name, ret );
	
					// Fixes bug #9237
					type = "number";
				}
	
				// Make sure that null and NaN values aren't set (#7116)
				if ( value == null || value !== value ) {
					return;
				}
	
				// If a number was passed in, add the unit (except for certain CSS properties)
				// The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
				// "px" to a few hardcoded values.
				if ( type === "number" && !isCustomProp ) {
					value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
				}
	
				// background-* props affect original clone's values
				if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
					style[ name ] = "inherit";
				}
	
				// If a hook was provided, use that value, otherwise just set the specified value
				if ( !hooks || !( "set" in hooks ) ||
					( value = hooks.set( elem, value, extra ) ) !== undefined ) {
	
					if ( isCustomProp ) {
						style.setProperty( name, value );
					} else {
						style[ name ] = value;
					}
				}
	
			} else {
	
				// If a hook was provided get the non-computed value from there
				if ( hooks && "get" in hooks &&
					( ret = hooks.get( elem, false, extra ) ) !== undefined ) {
	
					return ret;
				}
	
				// Otherwise just get the value from the style object
				return style[ name ];
			}
		},
	
		css: function( elem, name, extra, styles ) {
			var val, num, hooks,
				origName = camelCase( name ),
				isCustomProp = rcustomProp.test( name );
	
			// Make sure that we're working with the right name. We don't
			// want to modify the value if it is a CSS custom property
			// since they are user-defined.
			if ( !isCustomProp ) {
				name = finalPropName( origName );
			}
	
			// Try prefixed name followed by the unprefixed name
			hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];
	
			// If a hook was provided get the computed value from there
			if ( hooks && "get" in hooks ) {
				val = hooks.get( elem, true, extra );
			}
	
			// Otherwise, if a way to get the computed value exists, use that
			if ( val === undefined ) {
				val = curCSS( elem, name, styles );
			}
	
			// Convert "normal" to computed value
			if ( val === "normal" && name in cssNormalTransform ) {
				val = cssNormalTransform[ name ];
			}
	
			// Make numeric if forced or a qualifier was provided and val looks numeric
			if ( extra === "" || extra ) {
				num = parseFloat( val );
				return extra === true || isFinite( num ) ? num || 0 : val;
			}
	
			return val;
		}
	} );
	
	jQuery.each( [ "height", "width" ], function( _i, dimension ) {
		jQuery.cssHooks[ dimension ] = {
			get: function( elem, computed, extra ) {
				if ( computed ) {
	
					// Certain elements can have dimension info if we invisibly show them
					// but it must have a current display style that would benefit
					return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&
	
						// Support: Safari 8+
						// Table columns in Safari have non-zero offsetWidth & zero
						// getBoundingClientRect().width unless display is changed.
						// Support: IE <=11 only
						// Running getBoundingClientRect on a disconnected node
						// in IE throws an error.
						( !elem.getClientRects().length || !elem.getBoundingClientRect().width ) ?
						swap( elem, cssShow, function() {
							return getWidthOrHeight( elem, dimension, extra );
						} ) :
						getWidthOrHeight( elem, dimension, extra );
				}
			},
	
			set: function( elem, value, extra ) {
				var matches,
					styles = getStyles( elem ),
	
					// Only read styles.position if the test has a chance to fail
					// to avoid forcing a reflow.
					scrollboxSizeBuggy = !support.scrollboxSize() &&
						styles.position === "absolute",
	
					// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
					boxSizingNeeded = scrollboxSizeBuggy || extra,
					isBorderBox = boxSizingNeeded &&
						jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
					subtract = extra ?
						boxModelAdjustment(
							elem,
							dimension,
							extra,
							isBorderBox,
							styles
						) :
						0;
	
				// Account for unreliable border-box dimensions by comparing offset* to computed and
				// faking a content-box to get border and padding (gh-3699)
				if ( isBorderBox && scrollboxSizeBuggy ) {
					subtract -= Math.ceil(
						elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
						parseFloat( styles[ dimension ] ) -
						boxModelAdjustment( elem, dimension, "border", false, styles ) -
						0.5
					);
				}
	
				// Convert to pixels if value adjustment is needed
				if ( subtract && ( matches = rcssNum.exec( value ) ) &&
					( matches[ 3 ] || "px" ) !== "px" ) {
	
					elem.style[ dimension ] = value;
					value = jQuery.css( elem, dimension );
				}
	
				return setPositiveNumber( elem, value, subtract );
			}
		};
	} );
	
	jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
		function( elem, computed ) {
			if ( computed ) {
				return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
					elem.getBoundingClientRect().left -
						swap( elem, { marginLeft: 0 }, function() {
							return elem.getBoundingClientRect().left;
						} )
				) + "px";
			}
		}
	);
	
	// These hooks are used by animate to expand properties
	jQuery.each( {
		margin: "",
		padding: "",
		border: "Width"
	}, function( prefix, suffix ) {
		jQuery.cssHooks[ prefix + suffix ] = {
			expand: function( value ) {
				var i = 0,
					expanded = {},
	
					// Assumes a single number if not a string
					parts = typeof value === "string" ? value.split( " " ) : [ value ];
	
				for ( ; i < 4; i++ ) {
					expanded[ prefix + cssExpand[ i ] + suffix ] =
						parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
				}
	
				return expanded;
			}
		};
	
		if ( prefix !== "margin" ) {
			jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
		}
	} );
	
	jQuery.fn.extend( {
		css: function( name, value ) {
			return access( this, function( elem, name, value ) {
				var styles, len,
					map = {},
					i = 0;
	
				if ( Array.isArray( name ) ) {
					styles = getStyles( elem );
					len = name.length;
	
					for ( ; i < len; i++ ) {
						map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
					}
	
					return map;
				}
	
				return value !== undefined ?
					jQuery.style( elem, name, value ) :
					jQuery.css( elem, name );
			}, name, value, arguments.length > 1 );
		}
	} );
	
	
	function Tween( elem, options, prop, end, easing ) {
		return new Tween.prototype.init( elem, options, prop, end, easing );
	}
	jQuery.Tween = Tween;
	
	Tween.prototype = {
		constructor: Tween,
		init: function( elem, options, prop, end, easing, unit ) {
			this.elem = elem;
			this.prop = prop;
			this.easing = easing || jQuery.easing._default;
			this.options = options;
			this.start = this.now = this.cur();
			this.end = end;
			this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
		},
		cur: function() {
			var hooks = Tween.propHooks[ this.prop ];
	
			return hooks && hooks.get ?
				hooks.get( this ) :
				Tween.propHooks._default.get( this );
		},
		run: function( percent ) {
			var eased,
				hooks = Tween.propHooks[ this.prop ];
	
			if ( this.options.duration ) {
				this.pos = eased = jQuery.easing[ this.easing ](
					percent, this.options.duration * percent, 0, 1, this.options.duration
				);
			} else {
				this.pos = eased = percent;
			}
			this.now = ( this.end - this.start ) * eased + this.start;
	
			if ( this.options.step ) {
				this.options.step.call( this.elem, this.now, this );
			}
	
			if ( hooks && hooks.set ) {
				hooks.set( this );
			} else {
				Tween.propHooks._default.set( this );
			}
			return this;
		}
	};
	
	Tween.prototype.init.prototype = Tween.prototype;
	
	Tween.propHooks = {
		_default: {
			get: function( tween ) {
				var result;
	
				// Use a property on the element directly when it is not a DOM element,
				// or when there is no matching style property that exists.
				if ( tween.elem.nodeType !== 1 ||
					tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
					return tween.elem[ tween.prop ];
				}
	
				// Passing an empty string as a 3rd parameter to .css will automatically
				// attempt a parseFloat and fallback to a string if the parse fails.
				// Simple values such as "10px" are parsed to Float;
				// complex values such as "rotate(1rad)" are returned as-is.
				result = jQuery.css( tween.elem, tween.prop, "" );
	
				// Empty strings, null, undefined and "auto" are converted to 0.
				return !result || result === "auto" ? 0 : result;
			},
			set: function( tween ) {
	
				// Use step hook for back compat.
				// Use cssHook if its there.
				// Use .style if available and use plain properties where available.
				if ( jQuery.fx.step[ tween.prop ] ) {
					jQuery.fx.step[ tween.prop ]( tween );
				} else if ( tween.elem.nodeType === 1 && (
					jQuery.cssHooks[ tween.prop ] ||
						tween.elem.style[ finalPropName( tween.prop ) ] != null ) ) {
					jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
				} else {
					tween.elem[ tween.prop ] = tween.now;
				}
			}
		}
	};
	
	// Support: IE <=9 only
	// Panic based approach to setting things on disconnected nodes
	Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
		set: function( tween ) {
			if ( tween.elem.nodeType && tween.elem.parentNode ) {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	};
	
	jQuery.easing = {
		linear: function( p ) {
			return p;
		},
		swing: function( p ) {
			return 0.5 - Math.cos( p * Math.PI ) / 2;
		},
		_default: "swing"
	};
	
	jQuery.fx = Tween.prototype.init;
	
	// Back compat <1.8 extension point
	jQuery.fx.step = {};
	
	
	
	
	var
		fxNow, inProgress,
		rfxtypes = /^(?:toggle|show|hide)$/,
		rrun = /queueHooks$/;
	
	function schedule() {
		if ( inProgress ) {
			if ( document.hidden === false && window.requestAnimationFrame ) {
				window.requestAnimationFrame( schedule );
			} else {
				window.setTimeout( schedule, jQuery.fx.interval );
			}
	
			jQuery.fx.tick();
		}
	}
	
	// Animations created synchronously will run synchronously
	function createFxNow() {
		window.setTimeout( function() {
			fxNow = undefined;
		} );
		return ( fxNow = Date.now() );
	}
	
	// Generate parameters to create a standard animation
	function genFx( type, includeWidth ) {
		var which,
			i = 0,
			attrs = { height: type };
	
		// If we include width, step value is 1 to do all cssExpand values,
		// otherwise step value is 2 to skip over Left and Right
		includeWidth = includeWidth ? 1 : 0;
		for ( ; i < 4; i += 2 - includeWidth ) {
			which = cssExpand[ i ];
			attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
		}
	
		if ( includeWidth ) {
			attrs.opacity = attrs.width = type;
		}
	
		return attrs;
	}
	
	function createTween( value, prop, animation ) {
		var tween,
			collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
			index = 0,
			length = collection.length;
		for ( ; index < length; index++ ) {
			if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {
	
				// We're done with this property
				return tween;
			}
		}
	}
	
	function defaultPrefilter( elem, props, opts ) {
		var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display,
			isBox = "width" in props || "height" in props,
			anim = this,
			orig = {},
			style = elem.style,
			hidden = elem.nodeType && isHiddenWithinTree( elem ),
			dataShow = dataPriv.get( elem, "fxshow" );
	
		// Queue-skipping animations hijack the fx hooks
		if ( !opts.queue ) {
			hooks = jQuery._queueHooks( elem, "fx" );
			if ( hooks.unqueued == null ) {
				hooks.unqueued = 0;
				oldfire = hooks.empty.fire;
				hooks.empty.fire = function() {
					if ( !hooks.unqueued ) {
						oldfire();
					}
				};
			}
			hooks.unqueued++;
	
			anim.always( function() {
	
				// Ensure the complete handler is called before this completes
				anim.always( function() {
					hooks.unqueued--;
					if ( !jQuery.queue( elem, "fx" ).length ) {
						hooks.empty.fire();
					}
				} );
			} );
		}
	
		// Detect show/hide animations
		for ( prop in props ) {
			value = props[ prop ];
			if ( rfxtypes.test( value ) ) {
				delete props[ prop ];
				toggle = toggle || value === "toggle";
				if ( value === ( hidden ? "hide" : "show" ) ) {
	
					// Pretend to be hidden if this is a "show" and
					// there is still data from a stopped show/hide
					if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
						hidden = true;
	
					// Ignore all other no-op show/hide data
					} else {
						continue;
					}
				}
				orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
			}
		}
	
		// Bail out if this is a no-op like .hide().hide()
		propTween = !jQuery.isEmptyObject( props );
		if ( !propTween && jQuery.isEmptyObject( orig ) ) {
			return;
		}
	
		// Restrict "overflow" and "display" styles during box animations
		if ( isBox && elem.nodeType === 1 ) {
	
			// Support: IE <=9 - 11, Edge 12 - 15
			// Record all 3 overflow attributes because IE does not infer the shorthand
			// from identically-valued overflowX and overflowY and Edge just mirrors
			// the overflowX value there.
			opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];
	
			// Identify a display type, preferring old show/hide data over the CSS cascade
			restoreDisplay = dataShow && dataShow.display;
			if ( restoreDisplay == null ) {
				restoreDisplay = dataPriv.get( elem, "display" );
			}
			display = jQuery.css( elem, "display" );
			if ( display === "none" ) {
				if ( restoreDisplay ) {
					display = restoreDisplay;
				} else {
	
					// Get nonempty value(s) by temporarily forcing visibility
					showHide( [ elem ], true );
					restoreDisplay = elem.style.display || restoreDisplay;
					display = jQuery.css( elem, "display" );
					showHide( [ elem ] );
				}
			}
	
			// Animate inline elements as inline-block
			if ( display === "inline" || display === "inline-block" && restoreDisplay != null ) {
				if ( jQuery.css( elem, "float" ) === "none" ) {
	
					// Restore the original display value at the end of pure show/hide animations
					if ( !propTween ) {
						anim.done( function() {
							style.display = restoreDisplay;
						} );
						if ( restoreDisplay == null ) {
							display = style.display;
							restoreDisplay = display === "none" ? "" : display;
						}
					}
					style.display = "inline-block";
				}
			}
		}
	
		if ( opts.overflow ) {
			style.overflow = "hidden";
			anim.always( function() {
				style.overflow = opts.overflow[ 0 ];
				style.overflowX = opts.overflow[ 1 ];
				style.overflowY = opts.overflow[ 2 ];
			} );
		}
	
		// Implement show/hide animations
		propTween = false;
		for ( prop in orig ) {
	
			// General show/hide setup for this element animation
			if ( !propTween ) {
				if ( dataShow ) {
					if ( "hidden" in dataShow ) {
						hidden = dataShow.hidden;
					}
				} else {
					dataShow = dataPriv.access( elem, "fxshow", { display: restoreDisplay } );
				}
	
				// Store hidden/visible for toggle so `.stop().toggle()` "reverses"
				if ( toggle ) {
					dataShow.hidden = !hidden;
				}
	
				// Show elements before animating them
				if ( hidden ) {
					showHide( [ elem ], true );
				}
	
				/* eslint-disable no-loop-func */
	
				anim.done( function() {
	
					/* eslint-enable no-loop-func */
	
					// The final step of a "hide" animation is actually hiding the element
					if ( !hidden ) {
						showHide( [ elem ] );
					}
					dataPriv.remove( elem, "fxshow" );
					for ( prop in orig ) {
						jQuery.style( elem, prop, orig[ prop ] );
					}
				} );
			}
	
			// Per-property setup
			propTween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
			if ( !( prop in dataShow ) ) {
				dataShow[ prop ] = propTween.start;
				if ( hidden ) {
					propTween.end = propTween.start;
					propTween.start = 0;
				}
			}
		}
	}
	
	function propFilter( props, specialEasing ) {
		var index, name, easing, value, hooks;
	
		// camelCase, specialEasing and expand cssHook pass
		for ( index in props ) {
			name = camelCase( index );
			easing = specialEasing[ name ];
			value = props[ index ];
			if ( Array.isArray( value ) ) {
				easing = value[ 1 ];
				value = props[ index ] = value[ 0 ];
			}
	
			if ( index !== name ) {
				props[ name ] = value;
				delete props[ index ];
			}
	
			hooks = jQuery.cssHooks[ name ];
			if ( hooks && "expand" in hooks ) {
				value = hooks.expand( value );
				delete props[ name ];
	
				// Not quite $.extend, this won't overwrite existing keys.
				// Reusing 'index' because we have the correct "name"
				for ( index in value ) {
					if ( !( index in props ) ) {
						props[ index ] = value[ index ];
						specialEasing[ index ] = easing;
					}
				}
			} else {
				specialEasing[ name ] = easing;
			}
		}
	}
	
	function Animation( elem, properties, options ) {
		var result,
			stopped,
			index = 0,
			length = Animation.prefilters.length,
			deferred = jQuery.Deferred().always( function() {
	
				// Don't match elem in the :animated selector
				delete tick.elem;
			} ),
			tick = function() {
				if ( stopped ) {
					return false;
				}
				var currentTime = fxNow || createFxNow(),
					remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),
	
					// Support: Android 2.3 only
					// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
					temp = remaining / animation.duration || 0,
					percent = 1 - temp,
					index = 0,
					length = animation.tweens.length;
	
				for ( ; index < length; index++ ) {
					animation.tweens[ index ].run( percent );
				}
	
				deferred.notifyWith( elem, [ animation, percent, remaining ] );
	
				// If there's more to do, yield
				if ( percent < 1 && length ) {
					return remaining;
				}
	
				// If this was an empty animation, synthesize a final progress notification
				if ( !length ) {
					deferred.notifyWith( elem, [ animation, 1, 0 ] );
				}
	
				// Resolve the animation and report its conclusion
				deferred.resolveWith( elem, [ animation ] );
				return false;
			},
			animation = deferred.promise( {
				elem: elem,
				props: jQuery.extend( {}, properties ),
				opts: jQuery.extend( true, {
					specialEasing: {},
					easing: jQuery.easing._default
				}, options ),
				originalProperties: properties,
				originalOptions: options,
				startTime: fxNow || createFxNow(),
				duration: options.duration,
				tweens: [],
				createTween: function( prop, end ) {
					var tween = jQuery.Tween( elem, animation.opts, prop, end,
						animation.opts.specialEasing[ prop ] || animation.opts.easing );
					animation.tweens.push( tween );
					return tween;
				},
				stop: function( gotoEnd ) {
					var index = 0,
	
						// If we are going to the end, we want to run all the tweens
						// otherwise we skip this part
						length = gotoEnd ? animation.tweens.length : 0;
					if ( stopped ) {
						return this;
					}
					stopped = true;
					for ( ; index < length; index++ ) {
						animation.tweens[ index ].run( 1 );
					}
	
					// Resolve when we played the last frame; otherwise, reject
					if ( gotoEnd ) {
						deferred.notifyWith( elem, [ animation, 1, 0 ] );
						deferred.resolveWith( elem, [ animation, gotoEnd ] );
					} else {
						deferred.rejectWith( elem, [ animation, gotoEnd ] );
					}
					return this;
				}
			} ),
			props = animation.props;
	
		propFilter( props, animation.opts.specialEasing );
	
		for ( ; index < length; index++ ) {
			result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
			if ( result ) {
				if ( isFunction( result.stop ) ) {
					jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
						result.stop.bind( result );
				}
				return result;
			}
		}
	
		jQuery.map( props, createTween, animation );
	
		if ( isFunction( animation.opts.start ) ) {
			animation.opts.start.call( elem, animation );
		}
	
		// Attach callbacks from options
		animation
			.progress( animation.opts.progress )
			.done( animation.opts.done, animation.opts.complete )
			.fail( animation.opts.fail )
			.always( animation.opts.always );
	
		jQuery.fx.timer(
			jQuery.extend( tick, {
				elem: elem,
				anim: animation,
				queue: animation.opts.queue
			} )
		);
	
		return animation;
	}
	
	jQuery.Animation = jQuery.extend( Animation, {
	
		tweeners: {
			"*": [ function( prop, value ) {
				var tween = this.createTween( prop, value );
				adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
				return tween;
			} ]
		},
	
		tweener: function( props, callback ) {
			if ( isFunction( props ) ) {
				callback = props;
				props = [ "*" ];
			} else {
				props = props.match( rnothtmlwhite );
			}
	
			var prop,
				index = 0,
				length = props.length;
	
			for ( ; index < length; index++ ) {
				prop = props[ index ];
				Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
				Animation.tweeners[ prop ].unshift( callback );
			}
		},
	
		prefilters: [ defaultPrefilter ],
	
		prefilter: function( callback, prepend ) {
			if ( prepend ) {
				Animation.prefilters.unshift( callback );
			} else {
				Animation.prefilters.push( callback );
			}
		}
	} );
	
	jQuery.speed = function( speed, easing, fn ) {
		var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
			complete: fn || !fn && easing ||
				isFunction( speed ) && speed,
			duration: speed,
			easing: fn && easing || easing && !isFunction( easing ) && easing
		};
	
		// Go to the end state if fx are off
		if ( jQuery.fx.off ) {
			opt.duration = 0;
	
		} else {
			if ( typeof opt.duration !== "number" ) {
				if ( opt.duration in jQuery.fx.speeds ) {
					opt.duration = jQuery.fx.speeds[ opt.duration ];
	
				} else {
					opt.duration = jQuery.fx.speeds._default;
				}
			}
		}
	
		// Normalize opt.queue - true/undefined/null -> "fx"
		if ( opt.queue == null || opt.queue === true ) {
			opt.queue = "fx";
		}
	
		// Queueing
		opt.old = opt.complete;
	
		opt.complete = function() {
			if ( isFunction( opt.old ) ) {
				opt.old.call( this );
			}
	
			if ( opt.queue ) {
				jQuery.dequeue( this, opt.queue );
			}
		};
	
		return opt;
	};
	
	jQuery.fn.extend( {
		fadeTo: function( speed, to, easing, callback ) {
	
			// Show any hidden elements after setting opacity to 0
			return this.filter( isHiddenWithinTree ).css( "opacity", 0 ).show()
	
				// Animate to the value specified
				.end().animate( { opacity: to }, speed, easing, callback );
		},
		animate: function( prop, speed, easing, callback ) {
			var empty = jQuery.isEmptyObject( prop ),
				optall = jQuery.speed( speed, easing, callback ),
				doAnimation = function() {
	
					// Operate on a copy of prop so per-property easing won't be lost
					var anim = Animation( this, jQuery.extend( {}, prop ), optall );
	
					// Empty animations, or finishing resolves immediately
					if ( empty || dataPriv.get( this, "finish" ) ) {
						anim.stop( true );
					}
				};
	
			doAnimation.finish = doAnimation;
	
			return empty || optall.queue === false ?
				this.each( doAnimation ) :
				this.queue( optall.queue, doAnimation );
		},
		stop: function( type, clearQueue, gotoEnd ) {
			var stopQueue = function( hooks ) {
				var stop = hooks.stop;
				delete hooks.stop;
				stop( gotoEnd );
			};
	
			if ( typeof type !== "string" ) {
				gotoEnd = clearQueue;
				clearQueue = type;
				type = undefined;
			}
			if ( clearQueue ) {
				this.queue( type || "fx", [] );
			}
	
			return this.each( function() {
				var dequeue = true,
					index = type != null && type + "queueHooks",
					timers = jQuery.timers,
					data = dataPriv.get( this );
	
				if ( index ) {
					if ( data[ index ] && data[ index ].stop ) {
						stopQueue( data[ index ] );
					}
				} else {
					for ( index in data ) {
						if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
							stopQueue( data[ index ] );
						}
					}
				}
	
				for ( index = timers.length; index--; ) {
					if ( timers[ index ].elem === this &&
						( type == null || timers[ index ].queue === type ) ) {
	
						timers[ index ].anim.stop( gotoEnd );
						dequeue = false;
						timers.splice( index, 1 );
					}
				}
	
				// Start the next in the queue if the last step wasn't forced.
				// Timers currently will call their complete callbacks, which
				// will dequeue but only if they were gotoEnd.
				if ( dequeue || !gotoEnd ) {
					jQuery.dequeue( this, type );
				}
			} );
		},
		finish: function( type ) {
			if ( type !== false ) {
				type = type || "fx";
			}
			return this.each( function() {
				var index,
					data = dataPriv.get( this ),
					queue = data[ type + "queue" ],
					hooks = data[ type + "queueHooks" ],
					timers = jQuery.timers,
					length = queue ? queue.length : 0;
	
				// Enable finishing flag on private data
				data.finish = true;
	
				// Empty the queue first
				jQuery.queue( this, type, [] );
	
				if ( hooks && hooks.stop ) {
					hooks.stop.call( this, true );
				}
	
				// Look for any active animations, and finish them
				for ( index = timers.length; index--; ) {
					if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
						timers[ index ].anim.stop( true );
						timers.splice( index, 1 );
					}
				}
	
				// Look for any animations in the old queue and finish them
				for ( index = 0; index < length; index++ ) {
					if ( queue[ index ] && queue[ index ].finish ) {
						queue[ index ].finish.call( this );
					}
				}
	
				// Turn off finishing flag
				delete data.finish;
			} );
		}
	} );
	
	jQuery.each( [ "toggle", "show", "hide" ], function( _i, name ) {
		var cssFn = jQuery.fn[ name ];
		jQuery.fn[ name ] = function( speed, easing, callback ) {
			return speed == null || typeof speed === "boolean" ?
				cssFn.apply( this, arguments ) :
				this.animate( genFx( name, true ), speed, easing, callback );
		};
	} );
	
	// Generate shortcuts for custom animations
	jQuery.each( {
		slideDown: genFx( "show" ),
		slideUp: genFx( "hide" ),
		slideToggle: genFx( "toggle" ),
		fadeIn: { opacity: "show" },
		fadeOut: { opacity: "hide" },
		fadeToggle: { opacity: "toggle" }
	}, function( name, props ) {
		jQuery.fn[ name ] = function( speed, easing, callback ) {
			return this.animate( props, speed, easing, callback );
		};
	} );
	
	jQuery.timers = [];
	jQuery.fx.tick = function() {
		var timer,
			i = 0,
			timers = jQuery.timers;
	
		fxNow = Date.now();
	
		for ( ; i < timers.length; i++ ) {
			timer = timers[ i ];
	
			// Run the timer and safely remove it when done (allowing for external removal)
			if ( !timer() && timers[ i ] === timer ) {
				timers.splice( i--, 1 );
			}
		}
	
		if ( !timers.length ) {
			jQuery.fx.stop();
		}
		fxNow = undefined;
	};
	
	jQuery.fx.timer = function( timer ) {
		jQuery.timers.push( timer );
		jQuery.fx.start();
	};
	
	jQuery.fx.interval = 13;
	jQuery.fx.start = function() {
		if ( inProgress ) {
			return;
		}
	
		inProgress = true;
		schedule();
	};
	
	jQuery.fx.stop = function() {
		inProgress = null;
	};
	
	jQuery.fx.speeds = {
		slow: 600,
		fast: 200,
	
		// Default speed
		_default: 400
	};
	
	
	// Based off of the plugin by Clint Helfers, with permission.
	// https://web.archive.org/web/20100324014747/http://blindsignals.com/index.php/2009/07/jquery-delay/
	jQuery.fn.delay = function( time, type ) {
		time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
		type = type || "fx";
	
		return this.queue( type, function( next, hooks ) {
			var timeout = window.setTimeout( next, time );
			hooks.stop = function() {
				window.clearTimeout( timeout );
			};
		} );
	};
	
	
	( function() {
		var input = document.createElement( "input" ),
			select = document.createElement( "select" ),
			opt = select.appendChild( document.createElement( "option" ) );
	
		input.type = "checkbox";
	
		// Support: Android <=4.3 only
		// Default value for a checkbox should be "on"
		support.checkOn = input.value !== "";
	
		// Support: IE <=11 only
		// Must access selectedIndex to make default options select
		support.optSelected = opt.selected;
	
		// Support: IE <=11 only
		// An input loses its value after becoming a radio
		input = document.createElement( "input" );
		input.value = "t";
		input.type = "radio";
		support.radioValue = input.value === "t";
	} )();
	
	
	var boolHook,
		attrHandle = jQuery.expr.attrHandle;
	
	jQuery.fn.extend( {
		attr: function( name, value ) {
			return access( this, jQuery.attr, name, value, arguments.length > 1 );
		},
	
		removeAttr: function( name ) {
			return this.each( function() {
				jQuery.removeAttr( this, name );
			} );
		}
	} );
	
	jQuery.extend( {
		attr: function( elem, name, value ) {
			var ret, hooks,
				nType = elem.nodeType;
	
			// Don't get/set attributes on text, comment and attribute nodes
			if ( nType === 3 || nType === 8 || nType === 2 ) {
				return;
			}
	
			// Fallback to prop when attributes are not supported
			if ( typeof elem.getAttribute === "undefined" ) {
				return jQuery.prop( elem, name, value );
			}
	
			// Attribute hooks are determined by the lowercase version
			// Grab necessary hook if one is defined
			if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
				hooks = jQuery.attrHooks[ name.toLowerCase() ] ||
					( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
			}
	
			if ( value !== undefined ) {
				if ( value === null ) {
					jQuery.removeAttr( elem, name );
					return;
				}
	
				if ( hooks && "set" in hooks &&
					( ret = hooks.set( elem, value, name ) ) !== undefined ) {
					return ret;
				}
	
				elem.setAttribute( name, value + "" );
				return value;
			}
	
			if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
				return ret;
			}
	
			ret = jQuery.find.attr( elem, name );
	
			// Non-existent attributes return null, we normalize to undefined
			return ret == null ? undefined : ret;
		},
	
		attrHooks: {
			type: {
				set: function( elem, value ) {
					if ( !support.radioValue && value === "radio" &&
						nodeName( elem, "input" ) ) {
						var val = elem.value;
						elem.setAttribute( "type", value );
						if ( val ) {
							elem.value = val;
						}
						return value;
					}
				}
			}
		},
	
		removeAttr: function( elem, value ) {
			var name,
				i = 0,
	
				// Attribute names can contain non-HTML whitespace characters
				// https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
				attrNames = value && value.match( rnothtmlwhite );
	
			if ( attrNames && elem.nodeType === 1 ) {
				while ( ( name = attrNames[ i++ ] ) ) {
					elem.removeAttribute( name );
				}
			}
		}
	} );
	
	// Hooks for boolean attributes
	boolHook = {
		set: function( elem, value, name ) {
			if ( value === false ) {
	
				// Remove boolean attributes when set to false
				jQuery.removeAttr( elem, name );
			} else {
				elem.setAttribute( name, name );
			}
			return name;
		}
	};
	
	jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( _i, name ) {
		var getter = attrHandle[ name ] || jQuery.find.attr;
	
		attrHandle[ name ] = function( elem, name, isXML ) {
			var ret, handle,
				lowercaseName = name.toLowerCase();
	
			if ( !isXML ) {
	
				// Avoid an infinite loop by temporarily removing this function from the getter
				handle = attrHandle[ lowercaseName ];
				attrHandle[ lowercaseName ] = ret;
				ret = getter( elem, name, isXML ) != null ?
					lowercaseName :
					null;
				attrHandle[ lowercaseName ] = handle;
			}
			return ret;
		};
	} );
	
	
	
	
	var rfocusable = /^(?:input|select|textarea|button)$/i,
		rclickable = /^(?:a|area)$/i;
	
	jQuery.fn.extend( {
		prop: function( name, value ) {
			return access( this, jQuery.prop, name, value, arguments.length > 1 );
		},
	
		removeProp: function( name ) {
			return this.each( function() {
				delete this[ jQuery.propFix[ name ] || name ];
			} );
		}
	} );
	
	jQuery.extend( {
		prop: function( elem, name, value ) {
			var ret, hooks,
				nType = elem.nodeType;
	
			// Don't get/set properties on text, comment and attribute nodes
			if ( nType === 3 || nType === 8 || nType === 2 ) {
				return;
			}
	
			if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
	
				// Fix name and attach hooks
				name = jQuery.propFix[ name ] || name;
				hooks = jQuery.propHooks[ name ];
			}
	
			if ( value !== undefined ) {
				if ( hooks && "set" in hooks &&
					( ret = hooks.set( elem, value, name ) ) !== undefined ) {
					return ret;
				}
	
				return ( elem[ name ] = value );
			}
	
			if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
				return ret;
			}
	
			return elem[ name ];
		},
	
		propHooks: {
			tabIndex: {
				get: function( elem ) {
	
					// Support: IE <=9 - 11 only
					// elem.tabIndex doesn't always return the
					// correct value when it hasn't been explicitly set
					// https://web.archive.org/web/20141116233347/http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
					// Use proper attribute retrieval(#12072)
					var tabindex = jQuery.find.attr( elem, "tabindex" );
	
					if ( tabindex ) {
						return parseInt( tabindex, 10 );
					}
	
					if (
						rfocusable.test( elem.nodeName ) ||
						rclickable.test( elem.nodeName ) &&
						elem.href
					) {
						return 0;
					}
	
					return -1;
				}
			}
		},
	
		propFix: {
			"for": "htmlFor",
			"class": "className"
		}
	} );
	
	// Support: IE <=11 only
	// Accessing the selectedIndex property
	// forces the browser to respect setting selected
	// on the option
	// The getter ensures a default option is selected
	// when in an optgroup
	// eslint rule "no-unused-expressions" is disabled for this code
	// since it considers such accessions noop
	if ( !support.optSelected ) {
		jQuery.propHooks.selected = {
			get: function( elem ) {
	
				/* eslint no-unused-expressions: "off" */
	
				var parent = elem.parentNode;
				if ( parent && parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
				return null;
			},
			set: function( elem ) {
	
				/* eslint no-unused-expressions: "off" */
	
				var parent = elem.parentNode;
				if ( parent ) {
					parent.selectedIndex;
	
					if ( parent.parentNode ) {
						parent.parentNode.selectedIndex;
					}
				}
			}
		};
	}
	
	jQuery.each( [
		"tabIndex",
		"readOnly",
		"maxLength",
		"cellSpacing",
		"cellPadding",
		"rowSpan",
		"colSpan",
		"useMap",
		"frameBorder",
		"contentEditable"
	], function() {
		jQuery.propFix[ this.toLowerCase() ] = this;
	} );
	
	
	
	
		// Strip and collapse whitespace according to HTML spec
		// https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
		function stripAndCollapse( value ) {
			var tokens = value.match( rnothtmlwhite ) || [];
			return tokens.join( " " );
		}
	
	
	function getClass( elem ) {
		return elem.getAttribute && elem.getAttribute( "class" ) || "";
	}
	
	function classesToArray( value ) {
		if ( Array.isArray( value ) ) {
			return value;
		}
		if ( typeof value === "string" ) {
			return value.match( rnothtmlwhite ) || [];
		}
		return [];
	}
	
	jQuery.fn.extend( {
		addClass: function( value ) {
			var classes, elem, cur, curValue, clazz, j, finalValue,
				i = 0;
	
			if ( isFunction( value ) ) {
				return this.each( function( j ) {
					jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
				} );
			}
	
			classes = classesToArray( value );
	
			if ( classes.length ) {
				while ( ( elem = this[ i++ ] ) ) {
					curValue = getClass( elem );
					cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );
	
					if ( cur ) {
						j = 0;
						while ( ( clazz = classes[ j++ ] ) ) {
							if ( cur.indexOf( " " + clazz + " " ) < 0 ) {
								cur += clazz + " ";
							}
						}
	
						// Only assign if different to avoid unneeded rendering.
						finalValue = stripAndCollapse( cur );
						if ( curValue !== finalValue ) {
							elem.setAttribute( "class", finalValue );
						}
					}
				}
			}
	
			return this;
		},
	
		removeClass: function( value ) {
			var classes, elem, cur, curValue, clazz, j, finalValue,
				i = 0;
	
			if ( isFunction( value ) ) {
				return this.each( function( j ) {
					jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
				} );
			}
	
			if ( !arguments.length ) {
				return this.attr( "class", "" );
			}
	
			classes = classesToArray( value );
	
			if ( classes.length ) {
				while ( ( elem = this[ i++ ] ) ) {
					curValue = getClass( elem );
	
					// This expression is here for better compressibility (see addClass)
					cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );
	
					if ( cur ) {
						j = 0;
						while ( ( clazz = classes[ j++ ] ) ) {
	
							// Remove *all* instances
							while ( cur.indexOf( " " + clazz + " " ) > -1 ) {
								cur = cur.replace( " " + clazz + " ", " " );
							}
						}
	
						// Only assign if different to avoid unneeded rendering.
						finalValue = stripAndCollapse( cur );
						if ( curValue !== finalValue ) {
							elem.setAttribute( "class", finalValue );
						}
					}
				}
			}
	
			return this;
		},
	
		toggleClass: function( value, stateVal ) {
			var type = typeof value,
				isValidValue = type === "string" || Array.isArray( value );
	
			if ( typeof stateVal === "boolean" && isValidValue ) {
				return stateVal ? this.addClass( value ) : this.removeClass( value );
			}
	
			if ( isFunction( value ) ) {
				return this.each( function( i ) {
					jQuery( this ).toggleClass(
						value.call( this, i, getClass( this ), stateVal ),
						stateVal
					);
				} );
			}
	
			return this.each( function() {
				var className, i, self, classNames;
	
				if ( isValidValue ) {
	
					// Toggle individual class names
					i = 0;
					self = jQuery( this );
					classNames = classesToArray( value );
	
					while ( ( className = classNames[ i++ ] ) ) {
	
						// Check each className given, space separated list
						if ( self.hasClass( className ) ) {
							self.removeClass( className );
						} else {
							self.addClass( className );
						}
					}
	
				// Toggle whole class name
				} else if ( value === undefined || type === "boolean" ) {
					className = getClass( this );
					if ( className ) {
	
						// Store className if set
						dataPriv.set( this, "__className__", className );
					}
	
					// If the element has a class name or if we're passed `false`,
					// then remove the whole classname (if there was one, the above saved it).
					// Otherwise bring back whatever was previously saved (if anything),
					// falling back to the empty string if nothing was stored.
					if ( this.setAttribute ) {
						this.setAttribute( "class",
							className || value === false ?
								"" :
								dataPriv.get( this, "__className__" ) || ""
						);
					}
				}
			} );
		},
	
		hasClass: function( selector ) {
			var className, elem,
				i = 0;
	
			className = " " + selector + " ";
			while ( ( elem = this[ i++ ] ) ) {
				if ( elem.nodeType === 1 &&
					( " " + stripAndCollapse( getClass( elem ) ) + " " ).indexOf( className ) > -1 ) {
					return true;
				}
			}
	
			return false;
		}
	} );
	
	
	
	
	var rreturn = /\r/g;
	
	jQuery.fn.extend( {
		val: function( value ) {
			var hooks, ret, valueIsFunction,
				elem = this[ 0 ];
	
			if ( !arguments.length ) {
				if ( elem ) {
					hooks = jQuery.valHooks[ elem.type ] ||
						jQuery.valHooks[ elem.nodeName.toLowerCase() ];
	
					if ( hooks &&
						"get" in hooks &&
						( ret = hooks.get( elem, "value" ) ) !== undefined
					) {
						return ret;
					}
	
					ret = elem.value;
	
					// Handle most common string cases
					if ( typeof ret === "string" ) {
						return ret.replace( rreturn, "" );
					}
	
					// Handle cases where value is null/undef or number
					return ret == null ? "" : ret;
				}
	
				return;
			}
	
			valueIsFunction = isFunction( value );
	
			return this.each( function( i ) {
				var val;
	
				if ( this.nodeType !== 1 ) {
					return;
				}
	
				if ( valueIsFunction ) {
					val = value.call( this, i, jQuery( this ).val() );
				} else {
					val = value;
				}
	
				// Treat null/undefined as ""; convert numbers to string
				if ( val == null ) {
					val = "";
	
				} else if ( typeof val === "number" ) {
					val += "";
	
				} else if ( Array.isArray( val ) ) {
					val = jQuery.map( val, function( value ) {
						return value == null ? "" : value + "";
					} );
				}
	
				hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];
	
				// If set returns undefined, fall back to normal setting
				if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
					this.value = val;
				}
			} );
		}
	} );
	
	jQuery.extend( {
		valHooks: {
			option: {
				get: function( elem ) {
	
					var val = jQuery.find.attr( elem, "value" );
					return val != null ?
						val :
	
						// Support: IE <=10 - 11 only
						// option.text throws exceptions (#14686, #14858)
						// Strip and collapse whitespace
						// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
						stripAndCollapse( jQuery.text( elem ) );
				}
			},
			select: {
				get: function( elem ) {
					var value, option, i,
						options = elem.options,
						index = elem.selectedIndex,
						one = elem.type === "select-one",
						values = one ? null : [],
						max = one ? index + 1 : options.length;
	
					if ( index < 0 ) {
						i = max;
	
					} else {
						i = one ? index : 0;
					}
	
					// Loop through all the selected options
					for ( ; i < max; i++ ) {
						option = options[ i ];
	
						// Support: IE <=9 only
						// IE8-9 doesn't update selected after form reset (#2551)
						if ( ( option.selected || i === index ) &&
	
								// Don't return options that are disabled or in a disabled optgroup
								!option.disabled &&
								( !option.parentNode.disabled ||
									!nodeName( option.parentNode, "optgroup" ) ) ) {
	
							// Get the specific value for the option
							value = jQuery( option ).val();
	
							// We don't need an array for one selects
							if ( one ) {
								return value;
							}
	
							// Multi-Selects return an array
							values.push( value );
						}
					}
	
					return values;
				},
	
				set: function( elem, value ) {
					var optionSet, option,
						options = elem.options,
						values = jQuery.makeArray( value ),
						i = options.length;
	
					while ( i-- ) {
						option = options[ i ];
	
						/* eslint-disable no-cond-assign */
	
						if ( option.selected =
							jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
						) {
							optionSet = true;
						}
	
						/* eslint-enable no-cond-assign */
					}
	
					// Force browsers to behave consistently when non-matching value is set
					if ( !optionSet ) {
						elem.selectedIndex = -1;
					}
					return values;
				}
			}
		}
	} );
	
	// Radios and checkboxes getter/setter
	jQuery.each( [ "radio", "checkbox" ], function() {
		jQuery.valHooks[ this ] = {
			set: function( elem, value ) {
				if ( Array.isArray( value ) ) {
					return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
				}
			}
		};
		if ( !support.checkOn ) {
			jQuery.valHooks[ this ].get = function( elem ) {
				return elem.getAttribute( "value" ) === null ? "on" : elem.value;
			};
		}
	} );
	
	
	
	
	// Return jQuery for attributes-only inclusion
	
	
	support.focusin = "onfocusin" in window;
	
	
	var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
		stopPropagationCallback = function( e ) {
			e.stopPropagation();
		};
	
	jQuery.extend( jQuery.event, {
	
		trigger: function( event, data, elem, onlyHandlers ) {
	
			var i, cur, tmp, bubbleType, ontype, handle, special, lastElement,
				eventPath = [ elem || document ],
				type = hasOwn.call( event, "type" ) ? event.type : event,
				namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];
	
			cur = lastElement = tmp = elem = elem || document;
	
			// Don't do events on text and comment nodes
			if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
				return;
			}
	
			// focus/blur morphs to focusin/out; ensure we're not firing them right now
			if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
				return;
			}
	
			if ( type.indexOf( "." ) > -1 ) {
	
				// Namespaced trigger; create a regexp to match event type in handle()
				namespaces = type.split( "." );
				type = namespaces.shift();
				namespaces.sort();
			}
			ontype = type.indexOf( ":" ) < 0 && "on" + type;
	
			// Caller can pass in a jQuery.Event object, Object, or just an event type string
			event = event[ jQuery.expando ] ?
				event :
				new jQuery.Event( type, typeof event === "object" && event );
	
			// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
			event.isTrigger = onlyHandlers ? 2 : 3;
			event.namespace = namespaces.join( "." );
			event.rnamespace = event.namespace ?
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
				null;
	
			// Clean up the event in case it is being reused
			event.result = undefined;
			if ( !event.target ) {
				event.target = elem;
			}
	
			// Clone any incoming data and prepend the event, creating the handler arg list
			data = data == null ?
				[ event ] :
				jQuery.makeArray( data, [ event ] );
	
			// Allow special events to draw outside the lines
			special = jQuery.event.special[ type ] || {};
			if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
				return;
			}
	
			// Determine event propagation path in advance, per W3C events spec (#9951)
			// Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
			if ( !onlyHandlers && !special.noBubble && !isWindow( elem ) ) {
	
				bubbleType = special.delegateType || type;
				if ( !rfocusMorph.test( bubbleType + type ) ) {
					cur = cur.parentNode;
				}
				for ( ; cur; cur = cur.parentNode ) {
					eventPath.push( cur );
					tmp = cur;
				}
	
				// Only add window if we got to document (e.g., not plain obj or detached DOM)
				if ( tmp === ( elem.ownerDocument || document ) ) {
					eventPath.push( tmp.defaultView || tmp.parentWindow || window );
				}
			}
	
			// Fire handlers on the event path
			i = 0;
			while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {
				lastElement = cur;
				event.type = i > 1 ?
					bubbleType :
					special.bindType || type;
	
				// jQuery handler
				handle = ( dataPriv.get( cur, "events" ) || Object.create( null ) )[ event.type ] &&
					dataPriv.get( cur, "handle" );
				if ( handle ) {
					handle.apply( cur, data );
				}
	
				// Native handler
				handle = ontype && cur[ ontype ];
				if ( handle && handle.apply && acceptData( cur ) ) {
					event.result = handle.apply( cur, data );
					if ( event.result === false ) {
						event.preventDefault();
					}
				}
			}
			event.type = type;
	
			// If nobody prevented the default action, do it now
			if ( !onlyHandlers && !event.isDefaultPrevented() ) {
	
				if ( ( !special._default ||
					special._default.apply( eventPath.pop(), data ) === false ) &&
					acceptData( elem ) ) {
	
					// Call a native DOM method on the target with the same name as the event.
					// Don't do default actions on window, that's where global variables be (#6170)
					if ( ontype && isFunction( elem[ type ] ) && !isWindow( elem ) ) {
	
						// Don't re-trigger an onFOO event when we call its FOO() method
						tmp = elem[ ontype ];
	
						if ( tmp ) {
							elem[ ontype ] = null;
						}
	
						// Prevent re-triggering of the same event, since we already bubbled it above
						jQuery.event.triggered = type;
	
						if ( event.isPropagationStopped() ) {
							lastElement.addEventListener( type, stopPropagationCallback );
						}
	
						elem[ type ]();
	
						if ( event.isPropagationStopped() ) {
							lastElement.removeEventListener( type, stopPropagationCallback );
						}
	
						jQuery.event.triggered = undefined;
	
						if ( tmp ) {
							elem[ ontype ] = tmp;
						}
					}
				}
			}
	
			return event.result;
		},
	
		// Piggyback on a donor event to simulate a different one
		// Used only for `focus(in | out)` events
		simulate: function( type, elem, event ) {
			var e = jQuery.extend(
				new jQuery.Event(),
				event,
				{
					type: type,
					isSimulated: true
				}
			);
	
			jQuery.event.trigger( e, null, elem );
		}
	
	} );
	
	jQuery.fn.extend( {
	
		trigger: function( type, data ) {
			return this.each( function() {
				jQuery.event.trigger( type, data, this );
			} );
		},
		triggerHandler: function( type, data ) {
			var elem = this[ 0 ];
			if ( elem ) {
				return jQuery.event.trigger( type, data, elem, true );
			}
		}
	} );
	
	
	// Support: Firefox <=44
	// Firefox doesn't have focus(in | out) events
	// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
	//
	// Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
	// focus(in | out) events fire after focus & blur events,
	// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
	// Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
	if ( !support.focusin ) {
		jQuery.each( { focus: "focusin", blur: "focusout" }, function( orig, fix ) {
	
			// Attach a single capturing handler on the document while someone wants focusin/focusout
			var handler = function( event ) {
				jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ) );
			};
	
			jQuery.event.special[ fix ] = {
				setup: function() {
	
					// Handle: regular nodes (via `this.ownerDocument`), window
					// (via `this.document`) & document (via `this`).
					var doc = this.ownerDocument || this.document || this,
						attaches = dataPriv.access( doc, fix );
	
					if ( !attaches ) {
						doc.addEventListener( orig, handler, true );
					}
					dataPriv.access( doc, fix, ( attaches || 0 ) + 1 );
				},
				teardown: function() {
					var doc = this.ownerDocument || this.document || this,
						attaches = dataPriv.access( doc, fix ) - 1;
	
					if ( !attaches ) {
						doc.removeEventListener( orig, handler, true );
						dataPriv.remove( doc, fix );
	
					} else {
						dataPriv.access( doc, fix, attaches );
					}
				}
			};
		} );
	}
	var location = window.location;
	
	var nonce = { guid: Date.now() };
	
	var rquery = ( /\?/ );
	
	
	
	// Cross-browser xml parsing
	jQuery.parseXML = function( data ) {
		var xml, parserErrorElem;
		if ( !data || typeof data !== "string" ) {
			return null;
		}
	
		// Support: IE 9 - 11 only
		// IE throws on parseFromString with invalid input.
		try {
			xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
		} catch ( e ) {}
	
		parserErrorElem = xml && xml.getElementsByTagName( "parsererror" )[ 0 ];
		if ( !xml || parserErrorElem ) {
			jQuery.error( "Invalid XML: " + (
				parserErrorElem ?
					jQuery.map( parserErrorElem.childNodes, function( el ) {
						return el.textContent;
					} ).join( "\n" ) :
					data
			) );
		}
		return xml;
	};
	
	
	var
		rbracket = /\[\]$/,
		rCRLF = /\r?\n/g,
		rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
		rsubmittable = /^(?:input|select|textarea|keygen)/i;
	
	function buildParams( prefix, obj, traditional, add ) {
		var name;
	
		if ( Array.isArray( obj ) ) {
	
			// Serialize array item.
			jQuery.each( obj, function( i, v ) {
				if ( traditional || rbracket.test( prefix ) ) {
	
					// Treat each array item as a scalar.
					add( prefix, v );
	
				} else {
	
					// Item is non-scalar (array or object), encode its numeric index.
					buildParams(
						prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
						v,
						traditional,
						add
					);
				}
			} );
	
		} else if ( !traditional && toType( obj ) === "object" ) {
	
			// Serialize object item.
			for ( name in obj ) {
				buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
			}
	
		} else {
	
			// Serialize scalar item.
			add( prefix, obj );
		}
	}
	
	// Serialize an array of form elements or a set of
	// key/values into a query string
	jQuery.param = function( a, traditional ) {
		var prefix,
			s = [],
			add = function( key, valueOrFunction ) {
	
				// If value is a function, invoke it and use its return value
				var value = isFunction( valueOrFunction ) ?
					valueOrFunction() :
					valueOrFunction;
	
				s[ s.length ] = encodeURIComponent( key ) + "=" +
					encodeURIComponent( value == null ? "" : value );
			};
	
		if ( a == null ) {
			return "";
		}
	
		// If an array was passed in, assume that it is an array of form elements.
		if ( Array.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {
	
			// Serialize the form elements
			jQuery.each( a, function() {
				add( this.name, this.value );
			} );
	
		} else {
	
			// If traditional, encode the "old" way (the way 1.3.2 or older
			// did it), otherwise encode params recursively.
			for ( prefix in a ) {
				buildParams( prefix, a[ prefix ], traditional, add );
			}
		}
	
		// Return the resulting serialization
		return s.join( "&" );
	};
	
	jQuery.fn.extend( {
		serialize: function() {
			return jQuery.param( this.serializeArray() );
		},
		serializeArray: function() {
			return this.map( function() {
	
				// Can add propHook for "elements" to filter or add form elements
				var elements = jQuery.prop( this, "elements" );
				return elements ? jQuery.makeArray( elements ) : this;
			} ).filter( function() {
				var type = this.type;
	
				// Use .is( ":disabled" ) so that fieldset[disabled] works
				return this.name && !jQuery( this ).is( ":disabled" ) &&
					rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
					( this.checked || !rcheckableType.test( type ) );
			} ).map( function( _i, elem ) {
				var val = jQuery( this ).val();
	
				if ( val == null ) {
					return null;
				}
	
				if ( Array.isArray( val ) ) {
					return jQuery.map( val, function( val ) {
						return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
					} );
				}
	
				return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
			} ).get();
		}
	} );
	
	
	var
		r20 = /%20/g,
		rhash = /#.*$/,
		rantiCache = /([?&])_=[^&]*/,
		rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,
	
		// #7653, #8125, #8152: local protocol detection
		rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
		rnoContent = /^(?:GET|HEAD)$/,
		rprotocol = /^\/\//,
	
		/* Prefilters
		 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
		 * 2) These are called:
		 *    - BEFORE asking for a transport
		 *    - AFTER param serialization (s.data is a string if s.processData is true)
		 * 3) key is the dataType
		 * 4) the catchall symbol "*" can be used
		 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
		 */
		prefilters = {},
	
		/* Transports bindings
		 * 1) key is the dataType
		 * 2) the catchall symbol "*" can be used
		 * 3) selection will start with transport dataType and THEN go to "*" if needed
		 */
		transports = {},
	
		// Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
		allTypes = "*/".concat( "*" ),
	
		// Anchor tag for parsing the document origin
		originAnchor = document.createElement( "a" );
	
	originAnchor.href = location.href;
	
	// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
	function addToPrefiltersOrTransports( structure ) {
	
		// dataTypeExpression is optional and defaults to "*"
		return function( dataTypeExpression, func ) {
	
			if ( typeof dataTypeExpression !== "string" ) {
				func = dataTypeExpression;
				dataTypeExpression = "*";
			}
	
			var dataType,
				i = 0,
				dataTypes = dataTypeExpression.toLowerCase().match( rnothtmlwhite ) || [];
	
			if ( isFunction( func ) ) {
	
				// For each dataType in the dataTypeExpression
				while ( ( dataType = dataTypes[ i++ ] ) ) {
	
					// Prepend if requested
					if ( dataType[ 0 ] === "+" ) {
						dataType = dataType.slice( 1 ) || "*";
						( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );
	
					// Otherwise append
					} else {
						( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
					}
				}
			}
		};
	}
	
	// Base inspection function for prefilters and transports
	function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {
	
		var inspected = {},
			seekingTransport = ( structure === transports );
	
		function inspect( dataType ) {
			var selected;
			inspected[ dataType ] = true;
			jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
				var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
				if ( typeof dataTypeOrTransport === "string" &&
					!seekingTransport && !inspected[ dataTypeOrTransport ] ) {
	
					options.dataTypes.unshift( dataTypeOrTransport );
					inspect( dataTypeOrTransport );
					return false;
				} else if ( seekingTransport ) {
					return !( selected = dataTypeOrTransport );
				}
			} );
			return selected;
		}
	
		return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
	}
	
	// A special extend for ajax options
	// that takes "flat" options (not to be deep extended)
	// Fixes #9887
	function ajaxExtend( target, src ) {
		var key, deep,
			flatOptions = jQuery.ajaxSettings.flatOptions || {};
	
		for ( key in src ) {
			if ( src[ key ] !== undefined ) {
				( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
			}
		}
		if ( deep ) {
			jQuery.extend( true, target, deep );
		}
	
		return target;
	}
	
	/* Handles responses to an ajax request:
	 * - finds the right dataType (mediates between content-type and expected dataType)
	 * - returns the corresponding response
	 */
	function ajaxHandleResponses( s, jqXHR, responses ) {
	
		var ct, type, finalDataType, firstDataType,
			contents = s.contents,
			dataTypes = s.dataTypes;
	
		// Remove auto dataType and get content-type in the process
		while ( dataTypes[ 0 ] === "*" ) {
			dataTypes.shift();
			if ( ct === undefined ) {
				ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
			}
		}
	
		// Check if we're dealing with a known content-type
		if ( ct ) {
			for ( type in contents ) {
				if ( contents[ type ] && contents[ type ].test( ct ) ) {
					dataTypes.unshift( type );
					break;
				}
			}
		}
	
		// Check to see if we have a response for the expected dataType
		if ( dataTypes[ 0 ] in responses ) {
			finalDataType = dataTypes[ 0 ];
		} else {
	
			// Try convertible dataTypes
			for ( type in responses ) {
				if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
					finalDataType = type;
					break;
				}
				if ( !firstDataType ) {
					firstDataType = type;
				}
			}
	
			// Or just use first one
			finalDataType = finalDataType || firstDataType;
		}
	
		// If we found a dataType
		// We add the dataType to the list if needed
		// and return the corresponding response
		if ( finalDataType ) {
			if ( finalDataType !== dataTypes[ 0 ] ) {
				dataTypes.unshift( finalDataType );
			}
			return responses[ finalDataType ];
		}
	}
	
	/* Chain conversions given the request and the original response
	 * Also sets the responseXXX fields on the jqXHR instance
	 */
	function ajaxConvert( s, response, jqXHR, isSuccess ) {
		var conv2, current, conv, tmp, prev,
			converters = {},
	
			// Work with a copy of dataTypes in case we need to modify it for conversion
			dataTypes = s.dataTypes.slice();
	
		// Create converters map with lowercased keys
		if ( dataTypes[ 1 ] ) {
			for ( conv in s.converters ) {
				converters[ conv.toLowerCase() ] = s.converters[ conv ];
			}
		}
	
		current = dataTypes.shift();
	
		// Convert to each sequential dataType
		while ( current ) {
	
			if ( s.responseFields[ current ] ) {
				jqXHR[ s.responseFields[ current ] ] = response;
			}
	
			// Apply the dataFilter if provided
			if ( !prev && isSuccess && s.dataFilter ) {
				response = s.dataFilter( response, s.dataType );
			}
	
			prev = current;
			current = dataTypes.shift();
	
			if ( current ) {
	
				// There's only work to do if current dataType is non-auto
				if ( current === "*" ) {
	
					current = prev;
	
				// Convert response if prev dataType is non-auto and differs from current
				} else if ( prev !== "*" && prev !== current ) {
	
					// Seek a direct converter
					conv = converters[ prev + " " + current ] || converters[ "* " + current ];
	
					// If none found, seek a pair
					if ( !conv ) {
						for ( conv2 in converters ) {
	
							// If conv2 outputs current
							tmp = conv2.split( " " );
							if ( tmp[ 1 ] === current ) {
	
								// If prev can be converted to accepted input
								conv = converters[ prev + " " + tmp[ 0 ] ] ||
									converters[ "* " + tmp[ 0 ] ];
								if ( conv ) {
	
									// Condense equivalence converters
									if ( conv === true ) {
										conv = converters[ conv2 ];
	
									// Otherwise, insert the intermediate dataType
									} else if ( converters[ conv2 ] !== true ) {
										current = tmp[ 0 ];
										dataTypes.unshift( tmp[ 1 ] );
									}
									break;
								}
							}
						}
					}
	
					// Apply converter (if not an equivalence)
					if ( conv !== true ) {
	
						// Unless errors are allowed to bubble, catch and return them
						if ( conv && s.throws ) {
							response = conv( response );
						} else {
							try {
								response = conv( response );
							} catch ( e ) {
								return {
									state: "parsererror",
									error: conv ? e : "No conversion from " + prev + " to " + current
								};
							}
						}
					}
				}
			}
		}
	
		return { state: "success", data: response };
	}
	
	jQuery.extend( {
	
		// Counter for holding the number of active queries
		active: 0,
	
		// Last-Modified header cache for next request
		lastModified: {},
		etag: {},
	
		ajaxSettings: {
			url: location.href,
			type: "GET",
			isLocal: rlocalProtocol.test( location.protocol ),
			global: true,
			processData: true,
			async: true,
			contentType: "application/x-www-form-urlencoded; charset=UTF-8",
	
			/*
			timeout: 0,
			data: null,
			dataType: null,
			username: null,
			password: null,
			cache: null,
			throws: false,
			traditional: false,
			headers: {},
			*/
	
			accepts: {
				"*": allTypes,
				text: "text/plain",
				html: "text/html",
				xml: "application/xml, text/xml",
				json: "application/json, text/javascript"
			},
	
			contents: {
				xml: /\bxml\b/,
				html: /\bhtml/,
				json: /\bjson\b/
			},
	
			responseFields: {
				xml: "responseXML",
				text: "responseText",
				json: "responseJSON"
			},
	
			// Data converters
			// Keys separate source (or catchall "*") and destination types with a single space
			converters: {
	
				// Convert anything to text
				"* text": String,
	
				// Text to html (true = no transformation)
				"text html": true,
	
				// Evaluate text as a json expression
				"text json": JSON.parse,
	
				// Parse text as xml
				"text xml": jQuery.parseXML
			},
	
			// For options that shouldn't be deep extended:
			// you can add your own custom options here if
			// and when you create one that shouldn't be
			// deep extended (see ajaxExtend)
			flatOptions: {
				url: true,
				context: true
			}
		},
	
		// Creates a full fledged settings object into target
		// with both ajaxSettings and settings fields.
		// If target is omitted, writes into ajaxSettings.
		ajaxSetup: function( target, settings ) {
			return settings ?
	
				// Building a settings object
				ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :
	
				// Extending ajaxSettings
				ajaxExtend( jQuery.ajaxSettings, target );
		},
	
		ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
		ajaxTransport: addToPrefiltersOrTransports( transports ),
	
		// Main method
		ajax: function( url, options ) {
	
			// If url is an object, simulate pre-1.5 signature
			if ( typeof url === "object" ) {
				options = url;
				url = undefined;
			}
	
			// Force options to be an object
			options = options || {};
	
			var transport,
	
				// URL without anti-cache param
				cacheURL,
	
				// Response headers
				responseHeadersString,
				responseHeaders,
	
				// timeout handle
				timeoutTimer,
	
				// Url cleanup var
				urlAnchor,
	
				// Request state (becomes false upon send and true upon completion)
				completed,
	
				// To know if global events are to be dispatched
				fireGlobals,
	
				// Loop variable
				i,
	
				// uncached part of the url
				uncached,
	
				// Create the final options object
				s = jQuery.ajaxSetup( {}, options ),
	
				// Callbacks context
				callbackContext = s.context || s,
	
				// Context for global events is callbackContext if it is a DOM node or jQuery collection
				globalEventContext = s.context &&
					( callbackContext.nodeType || callbackContext.jquery ) ?
					jQuery( callbackContext ) :
					jQuery.event,
	
				// Deferreds
				deferred = jQuery.Deferred(),
				completeDeferred = jQuery.Callbacks( "once memory" ),
	
				// Status-dependent callbacks
				statusCode = s.statusCode || {},
	
				// Headers (they are sent all at once)
				requestHeaders = {},
				requestHeadersNames = {},
	
				// Default abort message
				strAbort = "canceled",
	
				// Fake xhr
				jqXHR = {
					readyState: 0,
	
					// Builds headers hashtable if needed
					getResponseHeader: function( key ) {
						var match;
						if ( completed ) {
							if ( !responseHeaders ) {
								responseHeaders = {};
								while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
									responseHeaders[ match[ 1 ].toLowerCase() + " " ] =
										( responseHeaders[ match[ 1 ].toLowerCase() + " " ] || [] )
											.concat( match[ 2 ] );
								}
							}
							match = responseHeaders[ key.toLowerCase() + " " ];
						}
						return match == null ? null : match.join( ", " );
					},
	
					// Raw string
					getAllResponseHeaders: function() {
						return completed ? responseHeadersString : null;
					},
	
					// Caches the header
					setRequestHeader: function( name, value ) {
						if ( completed == null ) {
							name = requestHeadersNames[ name.toLowerCase() ] =
								requestHeadersNames[ name.toLowerCase() ] || name;
							requestHeaders[ name ] = value;
						}
						return this;
					},
	
					// Overrides response content-type header
					overrideMimeType: function( type ) {
						if ( completed == null ) {
							s.mimeType = type;
						}
						return this;
					},
	
					// Status-dependent callbacks
					statusCode: function( map ) {
						var code;
						if ( map ) {
							if ( completed ) {
	
								// Execute the appropriate callbacks
								jqXHR.always( map[ jqXHR.status ] );
							} else {
	
								// Lazy-add the new callbacks in a way that preserves old ones
								for ( code in map ) {
									statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
								}
							}
						}
						return this;
					},
	
					// Cancel the request
					abort: function( statusText ) {
						var finalText = statusText || strAbort;
						if ( transport ) {
							transport.abort( finalText );
						}
						done( 0, finalText );
						return this;
					}
				};
	
			// Attach deferreds
			deferred.promise( jqXHR );
	
			// Add protocol if not provided (prefilters might expect it)
			// Handle falsy url in the settings object (#10093: consistency with old signature)
			// We also use the url parameter if available
			s.url = ( ( url || s.url || location.href ) + "" )
				.replace( rprotocol, location.protocol + "//" );
	
			// Alias method option to type as per ticket #12004
			s.type = options.method || options.type || s.method || s.type;
	
			// Extract dataTypes list
			s.dataTypes = ( s.dataType || "*" ).toLowerCase().match( rnothtmlwhite ) || [ "" ];
	
			// A cross-domain request is in order when the origin doesn't match the current origin.
			if ( s.crossDomain == null ) {
				urlAnchor = document.createElement( "a" );
	
				// Support: IE <=8 - 11, Edge 12 - 15
				// IE throws exception on accessing the href property if url is malformed,
				// e.g. http://example.com:80x/
				try {
					urlAnchor.href = s.url;
	
					// Support: IE <=8 - 11 only
					// Anchor's host property isn't correctly set when s.url is relative
					urlAnchor.href = urlAnchor.href;
					s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
						urlAnchor.protocol + "//" + urlAnchor.host;
				} catch ( e ) {
	
					// If there is an error parsing the URL, assume it is crossDomain,
					// it can be rejected by the transport if it is invalid
					s.crossDomain = true;
				}
			}
	
			// Convert data if not already a string
			if ( s.data && s.processData && typeof s.data !== "string" ) {
				s.data = jQuery.param( s.data, s.traditional );
			}
	
			// Apply prefilters
			inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );
	
			// If request was aborted inside a prefilter, stop there
			if ( completed ) {
				return jqXHR;
			}
	
			// We can fire global events as of now if asked to
			// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
			fireGlobals = jQuery.event && s.global;
	
			// Watch for a new set of requests
			if ( fireGlobals && jQuery.active++ === 0 ) {
				jQuery.event.trigger( "ajaxStart" );
			}
	
			// Uppercase the type
			s.type = s.type.toUpperCase();
	
			// Determine if request has content
			s.hasContent = !rnoContent.test( s.type );
	
			// Save the URL in case we're toying with the If-Modified-Since
			// and/or If-None-Match header later on
			// Remove hash to simplify url manipulation
			cacheURL = s.url.replace( rhash, "" );
	
			// More options handling for requests with no content
			if ( !s.hasContent ) {
	
				// Remember the hash so we can put it back
				uncached = s.url.slice( cacheURL.length );
	
				// If data is available and should be processed, append data to url
				if ( s.data && ( s.processData || typeof s.data === "string" ) ) {
					cacheURL += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data;
	
					// #9682: remove data so that it's not used in an eventual retry
					delete s.data;
				}
	
				// Add or update anti-cache param if needed
				if ( s.cache === false ) {
					cacheURL = cacheURL.replace( rantiCache, "$1" );
					uncached = ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + ( nonce.guid++ ) +
						uncached;
				}
	
				// Put hash and anti-cache on the URL that will be requested (gh-1732)
				s.url = cacheURL + uncached;
	
			// Change '%20' to '+' if this is encoded form body content (gh-2658)
			} else if ( s.data && s.processData &&
				( s.contentType || "" ).indexOf( "application/x-www-form-urlencoded" ) === 0 ) {
				s.data = s.data.replace( r20, "+" );
			}
	
			// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
			if ( s.ifModified ) {
				if ( jQuery.lastModified[ cacheURL ] ) {
					jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
				}
				if ( jQuery.etag[ cacheURL ] ) {
					jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
				}
			}
	
			// Set the correct header, if data is being sent
			if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
				jqXHR.setRequestHeader( "Content-Type", s.contentType );
			}
	
			// Set the Accepts header for the server, depending on the dataType
			jqXHR.setRequestHeader(
				"Accept",
				s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
					s.accepts[ s.dataTypes[ 0 ] ] +
						( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
					s.accepts[ "*" ]
			);
	
			// Check for headers option
			for ( i in s.headers ) {
				jqXHR.setRequestHeader( i, s.headers[ i ] );
			}
	
			// Allow custom headers/mimetypes and early abort
			if ( s.beforeSend &&
				( s.beforeSend.call( callbackContext, jqXHR, s ) === false || completed ) ) {
	
				// Abort if not done already and return
				return jqXHR.abort();
			}
	
			// Aborting is no longer a cancellation
			strAbort = "abort";
	
			// Install callbacks on deferreds
			completeDeferred.add( s.complete );
			jqXHR.done( s.success );
			jqXHR.fail( s.error );
	
			// Get transport
			transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );
	
			// If no transport, we auto-abort
			if ( !transport ) {
				done( -1, "No Transport" );
			} else {
				jqXHR.readyState = 1;
	
				// Send global event
				if ( fireGlobals ) {
					globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
				}
	
				// If request was aborted inside ajaxSend, stop there
				if ( completed ) {
					return jqXHR;
				}
	
				// Timeout
				if ( s.async && s.timeout > 0 ) {
					timeoutTimer = window.setTimeout( function() {
						jqXHR.abort( "timeout" );
					}, s.timeout );
				}
	
				try {
					completed = false;
					transport.send( requestHeaders, done );
				} catch ( e ) {
	
					// Rethrow post-completion exceptions
					if ( completed ) {
						throw e;
					}
	
					// Propagate others as results
					done( -1, e );
				}
			}
	
			// Callback for when everything is done
			function done( status, nativeStatusText, responses, headers ) {
				var isSuccess, success, error, response, modified,
					statusText = nativeStatusText;
	
				// Ignore repeat invocations
				if ( completed ) {
					return;
				}
	
				completed = true;
	
				// Clear timeout if it exists
				if ( timeoutTimer ) {
					window.clearTimeout( timeoutTimer );
				}
	
				// Dereference transport for early garbage collection
				// (no matter how long the jqXHR object will be used)
				transport = undefined;
	
				// Cache response headers
				responseHeadersString = headers || "";
	
				// Set readyState
				jqXHR.readyState = status > 0 ? 4 : 0;
	
				// Determine if successful
				isSuccess = status >= 200 && status < 300 || status === 304;
	
				// Get response data
				if ( responses ) {
					response = ajaxHandleResponses( s, jqXHR, responses );
				}
	
				// Use a noop converter for missing script but not if jsonp
				if ( !isSuccess &&
					jQuery.inArray( "script", s.dataTypes ) > -1 &&
					jQuery.inArray( "json", s.dataTypes ) < 0 ) {
					s.converters[ "text script" ] = function() {};
				}
	
				// Convert no matter what (that way responseXXX fields are always set)
				response = ajaxConvert( s, response, jqXHR, isSuccess );
	
				// If successful, handle type chaining
				if ( isSuccess ) {
	
					// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
					if ( s.ifModified ) {
						modified = jqXHR.getResponseHeader( "Last-Modified" );
						if ( modified ) {
							jQuery.lastModified[ cacheURL ] = modified;
						}
						modified = jqXHR.getResponseHeader( "etag" );
						if ( modified ) {
							jQuery.etag[ cacheURL ] = modified;
						}
					}
	
					// if no content
					if ( status === 204 || s.type === "HEAD" ) {
						statusText = "nocontent";
	
					// if not modified
					} else if ( status === 304 ) {
						statusText = "notmodified";
	
					// If we have data, let's convert it
					} else {
						statusText = response.state;
						success = response.data;
						error = response.error;
						isSuccess = !error;
					}
				} else {
	
					// Extract error from statusText and normalize for non-aborts
					error = statusText;
					if ( status || !statusText ) {
						statusText = "error";
						if ( status < 0 ) {
							status = 0;
						}
					}
				}
	
				// Set data for the fake xhr object
				jqXHR.status = status;
				jqXHR.statusText = ( nativeStatusText || statusText ) + "";
	
				// Success/Error
				if ( isSuccess ) {
					deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
				} else {
					deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
				}
	
				// Status-dependent callbacks
				jqXHR.statusCode( statusCode );
				statusCode = undefined;
	
				if ( fireGlobals ) {
					globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
						[ jqXHR, s, isSuccess ? success : error ] );
				}
	
				// Complete
				completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );
	
				if ( fireGlobals ) {
					globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );
	
					// Handle the global AJAX counter
					if ( !( --jQuery.active ) ) {
						jQuery.event.trigger( "ajaxStop" );
					}
				}
			}
	
			return jqXHR;
		},
	
		getJSON: function( url, data, callback ) {
			return jQuery.get( url, data, callback, "json" );
		},
	
		getScript: function( url, callback ) {
			return jQuery.get( url, undefined, callback, "script" );
		}
	} );
	
	jQuery.each( [ "get", "post" ], function( _i, method ) {
		jQuery[ method ] = function( url, data, callback, type ) {
	
			// Shift arguments if data argument was omitted
			if ( isFunction( data ) ) {
				type = type || callback;
				callback = data;
				data = undefined;
			}
	
			// The url can be an options object (which then must have .url)
			return jQuery.ajax( jQuery.extend( {
				url: url,
				type: method,
				dataType: type,
				data: data,
				success: callback
			}, jQuery.isPlainObject( url ) && url ) );
		};
	} );
	
	jQuery.ajaxPrefilter( function( s ) {
		var i;
		for ( i in s.headers ) {
			if ( i.toLowerCase() === "content-type" ) {
				s.contentType = s.headers[ i ] || "";
			}
		}
	} );
	
	
	jQuery._evalUrl = function( url, options, doc ) {
		return jQuery.ajax( {
			url: url,
	
			// Make this explicit, since user can override this through ajaxSetup (#11264)
			type: "GET",
			dataType: "script",
			cache: true,
			async: false,
			global: false,
	
			// Only evaluate the response if it is successful (gh-4126)
			// dataFilter is not invoked for failure responses, so using it instead
			// of the default converter is kludgy but it works.
			converters: {
				"text script": function() {}
			},
			dataFilter: function( response ) {
				jQuery.globalEval( response, options, doc );
			}
		} );
	};
	
	
	jQuery.fn.extend( {
		wrapAll: function( html ) {
			var wrap;
	
			if ( this[ 0 ] ) {
				if ( isFunction( html ) ) {
					html = html.call( this[ 0 ] );
				}
	
				// The elements to wrap the target around
				wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );
	
				if ( this[ 0 ].parentNode ) {
					wrap.insertBefore( this[ 0 ] );
				}
	
				wrap.map( function() {
					var elem = this;
	
					while ( elem.firstElementChild ) {
						elem = elem.firstElementChild;
					}
	
					return elem;
				} ).append( this );
			}
	
			return this;
		},
	
		wrapInner: function( html ) {
			if ( isFunction( html ) ) {
				return this.each( function( i ) {
					jQuery( this ).wrapInner( html.call( this, i ) );
				} );
			}
	
			return this.each( function() {
				var self = jQuery( this ),
					contents = self.contents();
	
				if ( contents.length ) {
					contents.wrapAll( html );
	
				} else {
					self.append( html );
				}
			} );
		},
	
		wrap: function( html ) {
			var htmlIsFunction = isFunction( html );
	
			return this.each( function( i ) {
				jQuery( this ).wrapAll( htmlIsFunction ? html.call( this, i ) : html );
			} );
		},
	
		unwrap: function( selector ) {
			this.parent( selector ).not( "body" ).each( function() {
				jQuery( this ).replaceWith( this.childNodes );
			} );
			return this;
		}
	} );
	
	
	jQuery.expr.pseudos.hidden = function( elem ) {
		return !jQuery.expr.pseudos.visible( elem );
	};
	jQuery.expr.pseudos.visible = function( elem ) {
		return !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length );
	};
	
	
	
	
	jQuery.ajaxSettings.xhr = function() {
		try {
			return new window.XMLHttpRequest();
		} catch ( e ) {}
	};
	
	var xhrSuccessStatus = {
	
			// File protocol always yields status code 0, assume 200
			0: 200,
	
			// Support: IE <=9 only
			// #1450: sometimes IE returns 1223 when it should be 204
			1223: 204
		},
		xhrSupported = jQuery.ajaxSettings.xhr();
	
	support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
	support.ajax = xhrSupported = !!xhrSupported;
	
	jQuery.ajaxTransport( function( options ) {
		var callback, errorCallback;
	
		// Cross domain only allowed if supported through XMLHttpRequest
		if ( support.cors || xhrSupported && !options.crossDomain ) {
			return {
				send: function( headers, complete ) {
					var i,
						xhr = options.xhr();
	
					xhr.open(
						options.type,
						options.url,
						options.async,
						options.username,
						options.password
					);
	
					// Apply custom fields if provided
					if ( options.xhrFields ) {
						for ( i in options.xhrFields ) {
							xhr[ i ] = options.xhrFields[ i ];
						}
					}
	
					// Override mime type if needed
					if ( options.mimeType && xhr.overrideMimeType ) {
						xhr.overrideMimeType( options.mimeType );
					}
	
					// X-Requested-With header
					// For cross-domain requests, seeing as conditions for a preflight are
					// akin to a jigsaw puzzle, we simply never set it to be sure.
					// (it can always be set on a per-request basis or even using ajaxSetup)
					// For same-domain requests, won't change header if already provided.
					if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
						headers[ "X-Requested-With" ] = "XMLHttpRequest";
					}
	
					// Set headers
					for ( i in headers ) {
						xhr.setRequestHeader( i, headers[ i ] );
					}
	
					// Callback
					callback = function( type ) {
						return function() {
							if ( callback ) {
								callback = errorCallback = xhr.onload =
									xhr.onerror = xhr.onabort = xhr.ontimeout =
										xhr.onreadystatechange = null;
	
								if ( type === "abort" ) {
									xhr.abort();
								} else if ( type === "error" ) {
	
									// Support: IE <=9 only
									// On a manual native abort, IE9 throws
									// errors on any property access that is not readyState
									if ( typeof xhr.status !== "number" ) {
										complete( 0, "error" );
									} else {
										complete(
	
											// File: protocol always yields status 0; see #8605, #14207
											xhr.status,
											xhr.statusText
										);
									}
								} else {
									complete(
										xhrSuccessStatus[ xhr.status ] || xhr.status,
										xhr.statusText,
	
										// Support: IE <=9 only
										// IE9 has no XHR2 but throws on binary (trac-11426)
										// For XHR2 non-text, let the caller handle it (gh-2498)
										( xhr.responseType || "text" ) !== "text"  ||
										typeof xhr.responseText !== "string" ?
											{ binary: xhr.response } :
											{ text: xhr.responseText },
										xhr.getAllResponseHeaders()
									);
								}
							}
						};
					};
	
					// Listen to events
					xhr.onload = callback();
					errorCallback = xhr.onerror = xhr.ontimeout = callback( "error" );
	
					// Support: IE 9 only
					// Use onreadystatechange to replace onabort
					// to handle uncaught aborts
					if ( xhr.onabort !== undefined ) {
						xhr.onabort = errorCallback;
					} else {
						xhr.onreadystatechange = function() {
	
							// Check readyState before timeout as it changes
							if ( xhr.readyState === 4 ) {
	
								// Allow onerror to be called first,
								// but that will not handle a native abort
								// Also, save errorCallback to a variable
								// as xhr.onerror cannot be accessed
								window.setTimeout( function() {
									if ( callback ) {
										errorCallback();
									}
								} );
							}
						};
					}
	
					// Create the abort callback
					callback = callback( "abort" );
	
					try {
	
						// Do send the request (this may raise an exception)
						xhr.send( options.hasContent && options.data || null );
					} catch ( e ) {
	
						// #14683: Only rethrow if this hasn't been notified as an error yet
						if ( callback ) {
							throw e;
						}
					}
				},
	
				abort: function() {
					if ( callback ) {
						callback();
					}
				}
			};
		}
	} );
	
	
	
	
	// Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
	jQuery.ajaxPrefilter( function( s ) {
		if ( s.crossDomain ) {
			s.contents.script = false;
		}
	} );
	
	// Install script dataType
	jQuery.ajaxSetup( {
		accepts: {
			script: "text/javascript, application/javascript, " +
				"application/ecmascript, application/x-ecmascript"
		},
		contents: {
			script: /\b(?:java|ecma)script\b/
		},
		converters: {
			"text script": function( text ) {
				jQuery.globalEval( text );
				return text;
			}
		}
	} );
	
	// Handle cache's special case and crossDomain
	jQuery.ajaxPrefilter( "script", function( s ) {
		if ( s.cache === undefined ) {
			s.cache = false;
		}
		if ( s.crossDomain ) {
			s.type = "GET";
		}
	} );
	
	// Bind script tag hack transport
	jQuery.ajaxTransport( "script", function( s ) {
	
		// This transport only deals with cross domain or forced-by-attrs requests
		if ( s.crossDomain || s.scriptAttrs ) {
			var script, callback;
			return {
				send: function( _, complete ) {
					script = jQuery( "<script>" )
						.attr( s.scriptAttrs || {} )
						.prop( { charset: s.scriptCharset, src: s.url } )
						.on( "load error", callback = function( evt ) {
							script.remove();
							callback = null;
							if ( evt ) {
								complete( evt.type === "error" ? 404 : 200, evt.type );
							}
						} );
	
					// Use native DOM manipulation to avoid our domManip AJAX trickery
					document.head.appendChild( script[ 0 ] );
				},
				abort: function() {
					if ( callback ) {
						callback();
					}
				}
			};
		}
	} );
	
	
	
	
	var oldCallbacks = [],
		rjsonp = /(=)\?(?=&|$)|\?\?/;
	
	// Default jsonp settings
	jQuery.ajaxSetup( {
		jsonp: "callback",
		jsonpCallback: function() {
			var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce.guid++ ) );
			this[ callback ] = true;
			return callback;
		}
	} );
	
	// Detect, normalize options and install callbacks for jsonp requests
	jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {
	
		var callbackName, overwritten, responseContainer,
			jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
				"url" :
				typeof s.data === "string" &&
					( s.contentType || "" )
						.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
					rjsonp.test( s.data ) && "data"
			);
	
		// Handle iff the expected data type is "jsonp" or we have a parameter to set
		if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {
	
			// Get callback name, remembering preexisting value associated with it
			callbackName = s.jsonpCallback = isFunction( s.jsonpCallback ) ?
				s.jsonpCallback() :
				s.jsonpCallback;
	
			// Insert callback into url or form data
			if ( jsonProp ) {
				s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
			} else if ( s.jsonp !== false ) {
				s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
			}
	
			// Use data converter to retrieve json after script execution
			s.converters[ "script json" ] = function() {
				if ( !responseContainer ) {
					jQuery.error( callbackName + " was not called" );
				}
				return responseContainer[ 0 ];
			};
	
			// Force json dataType
			s.dataTypes[ 0 ] = "json";
	
			// Install callback
			overwritten = window[ callbackName ];
			window[ callbackName ] = function() {
				responseContainer = arguments;
			};
	
			// Clean-up function (fires after converters)
			jqXHR.always( function() {
	
				// If previous value didn't exist - remove it
				if ( overwritten === undefined ) {
					jQuery( window ).removeProp( callbackName );
	
				// Otherwise restore preexisting value
				} else {
					window[ callbackName ] = overwritten;
				}
	
				// Save back as free
				if ( s[ callbackName ] ) {
	
					// Make sure that re-using the options doesn't screw things around
					s.jsonpCallback = originalSettings.jsonpCallback;
	
					// Save the callback name for future use
					oldCallbacks.push( callbackName );
				}
	
				// Call if it was a function and we have a response
				if ( responseContainer && isFunction( overwritten ) ) {
					overwritten( responseContainer[ 0 ] );
				}
	
				responseContainer = overwritten = undefined;
			} );
	
			// Delegate to script
			return "script";
		}
	} );
	
	
	
	
	// Support: Safari 8 only
	// In Safari 8 documents created via document.implementation.createHTMLDocument
	// collapse sibling forms: the second one becomes a child of the first one.
	// Because of that, this security measure has to be disabled in Safari 8.
	// https://bugs.webkit.org/show_bug.cgi?id=137337
	support.createHTMLDocument = ( function() {
		var body = document.implementation.createHTMLDocument( "" ).body;
		body.innerHTML = "<form></form><form></form>";
		return body.childNodes.length === 2;
	} )();
	
	
	// Argument "data" should be string of html
	// context (optional): If specified, the fragment will be created in this context,
	// defaults to document
	// keepScripts (optional): If true, will include scripts passed in the html string
	jQuery.parseHTML = function( data, context, keepScripts ) {
		if ( typeof data !== "string" ) {
			return [];
		}
		if ( typeof context === "boolean" ) {
			keepScripts = context;
			context = false;
		}
	
		var base, parsed, scripts;
	
		if ( !context ) {
	
			// Stop scripts or inline event handlers from being executed immediately
			// by using document.implementation
			if ( support.createHTMLDocument ) {
				context = document.implementation.createHTMLDocument( "" );
	
				// Set the base href for the created document
				// so any parsed elements with URLs
				// are based on the document's URL (gh-2965)
				base = context.createElement( "base" );
				base.href = document.location.href;
				context.head.appendChild( base );
			} else {
				context = document;
			}
		}
	
		parsed = rsingleTag.exec( data );
		scripts = !keepScripts && [];
	
		// Single tag
		if ( parsed ) {
			return [ context.createElement( parsed[ 1 ] ) ];
		}
	
		parsed = buildFragment( [ data ], context, scripts );
	
		if ( scripts && scripts.length ) {
			jQuery( scripts ).remove();
		}
	
		return jQuery.merge( [], parsed.childNodes );
	};
	
	
	/**
	 * Load a url into a page
	 */
	jQuery.fn.load = function( url, params, callback ) {
		var selector, type, response,
			self = this,
			off = url.indexOf( " " );
	
		if ( off > -1 ) {
			selector = stripAndCollapse( url.slice( off ) );
			url = url.slice( 0, off );
		}
	
		// If it's a function
		if ( isFunction( params ) ) {
	
			// We assume that it's the callback
			callback = params;
			params = undefined;
	
		// Otherwise, build a param string
		} else if ( params && typeof params === "object" ) {
			type = "POST";
		}
	
		// If we have elements to modify, make the request
		if ( self.length > 0 ) {
			jQuery.ajax( {
				url: url,
	
				// If "type" variable is undefined, then "GET" method will be used.
				// Make value of this field explicit since
				// user can override it through ajaxSetup method
				type: type || "GET",
				dataType: "html",
				data: params
			} ).done( function( responseText ) {
	
				// Save response for use in complete callback
				response = arguments;
	
				self.html( selector ?
	
					// If a selector was specified, locate the right elements in a dummy div
					// Exclude scripts to avoid IE 'Permission Denied' errors
					jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :
	
					// Otherwise use the full result
					responseText );
	
			// If the request succeeds, this function gets "data", "status", "jqXHR"
			// but they are ignored because response was set above.
			// If it fails, this function gets "jqXHR", "status", "error"
			} ).always( callback && function( jqXHR, status ) {
				self.each( function() {
					callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
				} );
			} );
		}
	
		return this;
	};
	
	
	
	
	jQuery.expr.pseudos.animated = function( elem ) {
		return jQuery.grep( jQuery.timers, function( fn ) {
			return elem === fn.elem;
		} ).length;
	};
	
	
	
	
	jQuery.offset = {
		setOffset: function( elem, options, i ) {
			var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
				position = jQuery.css( elem, "position" ),
				curElem = jQuery( elem ),
				props = {};
	
			// Set position first, in-case top/left are set even on static elem
			if ( position === "static" ) {
				elem.style.position = "relative";
			}
	
			curOffset = curElem.offset();
			curCSSTop = jQuery.css( elem, "top" );
			curCSSLeft = jQuery.css( elem, "left" );
			calculatePosition = ( position === "absolute" || position === "fixed" ) &&
				( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;
	
			// Need to be able to calculate position if either
			// top or left is auto and position is either absolute or fixed
			if ( calculatePosition ) {
				curPosition = curElem.position();
				curTop = curPosition.top;
				curLeft = curPosition.left;
	
			} else {
				curTop = parseFloat( curCSSTop ) || 0;
				curLeft = parseFloat( curCSSLeft ) || 0;
			}
	
			if ( isFunction( options ) ) {
	
				// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
				options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
			}
	
			if ( options.top != null ) {
				props.top = ( options.top - curOffset.top ) + curTop;
			}
			if ( options.left != null ) {
				props.left = ( options.left - curOffset.left ) + curLeft;
			}
	
			if ( "using" in options ) {
				options.using.call( elem, props );
	
			} else {
				curElem.css( props );
			}
		}
	};
	
	jQuery.fn.extend( {
	
		// offset() relates an element's border box to the document origin
		offset: function( options ) {
	
			// Preserve chaining for setter
			if ( arguments.length ) {
				return options === undefined ?
					this :
					this.each( function( i ) {
						jQuery.offset.setOffset( this, options, i );
					} );
			}
	
			var rect, win,
				elem = this[ 0 ];
	
			if ( !elem ) {
				return;
			}
	
			// Return zeros for disconnected and hidden (display: none) elements (gh-2310)
			// Support: IE <=11 only
			// Running getBoundingClientRect on a
			// disconnected node in IE throws an error
			if ( !elem.getClientRects().length ) {
				return { top: 0, left: 0 };
			}
	
			// Get document-relative position by adding viewport scroll to viewport-relative gBCR
			rect = elem.getBoundingClientRect();
			win = elem.ownerDocument.defaultView;
			return {
				top: rect.top + win.pageYOffset,
				left: rect.left + win.pageXOffset
			};
		},
	
		// position() relates an element's margin box to its offset parent's padding box
		// This corresponds to the behavior of CSS absolute positioning
		position: function() {
			if ( !this[ 0 ] ) {
				return;
			}
	
			var offsetParent, offset, doc,
				elem = this[ 0 ],
				parentOffset = { top: 0, left: 0 };
	
			// position:fixed elements are offset from the viewport, which itself always has zero offset
			if ( jQuery.css( elem, "position" ) === "fixed" ) {
	
				// Assume position:fixed implies availability of getBoundingClientRect
				offset = elem.getBoundingClientRect();
	
			} else {
				offset = this.offset();
	
				// Account for the *real* offset parent, which can be the document or its root element
				// when a statically positioned element is identified
				doc = elem.ownerDocument;
				offsetParent = elem.offsetParent || doc.documentElement;
				while ( offsetParent &&
					( offsetParent === doc.body || offsetParent === doc.documentElement ) &&
					jQuery.css( offsetParent, "position" ) === "static" ) {
	
					offsetParent = offsetParent.parentNode;
				}
				if ( offsetParent && offsetParent !== elem && offsetParent.nodeType === 1 ) {
	
					// Incorporate borders into its offset, since they are outside its content origin
					parentOffset = jQuery( offsetParent ).offset();
					parentOffset.top += jQuery.css( offsetParent, "borderTopWidth", true );
					parentOffset.left += jQuery.css( offsetParent, "borderLeftWidth", true );
				}
			}
	
			// Subtract parent offsets and element margins
			return {
				top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
				left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
			};
		},
	
		// This method will return documentElement in the following cases:
		// 1) For the element inside the iframe without offsetParent, this method will return
		//    documentElement of the parent window
		// 2) For the hidden or detached element
		// 3) For body or html element, i.e. in case of the html node - it will return itself
		//
		// but those exceptions were never presented as a real life use-cases
		// and might be considered as more preferable results.
		//
		// This logic, however, is not guaranteed and can change at any point in the future
		offsetParent: function() {
			return this.map( function() {
				var offsetParent = this.offsetParent;
	
				while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
					offsetParent = offsetParent.offsetParent;
				}
	
				return offsetParent || documentElement;
			} );
		}
	} );
	
	// Create scrollLeft and scrollTop methods
	jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
		var top = "pageYOffset" === prop;
	
		jQuery.fn[ method ] = function( val ) {
			return access( this, function( elem, method, val ) {
	
				// Coalesce documents and windows
				var win;
				if ( isWindow( elem ) ) {
					win = elem;
				} else if ( elem.nodeType === 9 ) {
					win = elem.defaultView;
				}
	
				if ( val === undefined ) {
					return win ? win[ prop ] : elem[ method ];
				}
	
				if ( win ) {
					win.scrollTo(
						!top ? val : win.pageXOffset,
						top ? val : win.pageYOffset
					);
	
				} else {
					elem[ method ] = val;
				}
			}, method, val, arguments.length );
		};
	} );
	
	// Support: Safari <=7 - 9.1, Chrome <=37 - 49
	// Add the top/left cssHooks using jQuery.fn.position
	// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
	// Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
	// getComputedStyle returns percent when specified for top/left/bottom/right;
	// rather than make the css module depend on the offset module, just check for it here
	jQuery.each( [ "top", "left" ], function( _i, prop ) {
		jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
			function( elem, computed ) {
				if ( computed ) {
					computed = curCSS( elem, prop );
	
					// If curCSS returns percentage, fallback to offset
					return rnumnonpx.test( computed ) ?
						jQuery( elem ).position()[ prop ] + "px" :
						computed;
				}
			}
		);
	} );
	
	
	// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
	jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
		jQuery.each( {
			padding: "inner" + name,
			content: type,
			"": "outer" + name
		}, function( defaultExtra, funcName ) {
	
			// Margin is only for outerHeight, outerWidth
			jQuery.fn[ funcName ] = function( margin, value ) {
				var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
					extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );
	
				return access( this, function( elem, type, value ) {
					var doc;
	
					if ( isWindow( elem ) ) {
	
						// $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
						return funcName.indexOf( "outer" ) === 0 ?
							elem[ "inner" + name ] :
							elem.document.documentElement[ "client" + name ];
					}
	
					// Get document width or height
					if ( elem.nodeType === 9 ) {
						doc = elem.documentElement;
	
						// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
						// whichever is greatest
						return Math.max(
							elem.body[ "scroll" + name ], doc[ "scroll" + name ],
							elem.body[ "offset" + name ], doc[ "offset" + name ],
							doc[ "client" + name ]
						);
					}
	
					return value === undefined ?
	
						// Get width or height on the element, requesting but not forcing parseFloat
						jQuery.css( elem, type, extra ) :
	
						// Set width or height on the element
						jQuery.style( elem, type, value, extra );
				}, type, chainable ? margin : undefined, chainable );
			};
		} );
	} );
	
	
	jQuery.each( [
		"ajaxStart",
		"ajaxStop",
		"ajaxComplete",
		"ajaxError",
		"ajaxSuccess",
		"ajaxSend"
	], function( _i, type ) {
		jQuery.fn[ type ] = function( fn ) {
			return this.on( type, fn );
		};
	} );
	
	
	
	
	jQuery.fn.extend( {
	
		bind: function( types, data, fn ) {
			return this.on( types, null, data, fn );
		},
		unbind: function( types, fn ) {
			return this.off( types, null, fn );
		},
	
		delegate: function( selector, types, data, fn ) {
			return this.on( types, selector, data, fn );
		},
		undelegate: function( selector, types, fn ) {
	
			// ( namespace ) or ( selector, types [, fn] )
			return arguments.length === 1 ?
				this.off( selector, "**" ) :
				this.off( types, selector || "**", fn );
		},
	
		hover: function( fnOver, fnOut ) {
			return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
		}
	} );
	
	jQuery.each(
		( "blur focus focusin focusout resize scroll click dblclick " +
		"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
		"change select submit keydown keypress keyup contextmenu" ).split( " " ),
		function( _i, name ) {
	
			// Handle event binding
			jQuery.fn[ name ] = function( data, fn ) {
				return arguments.length > 0 ?
					this.on( name, null, data, fn ) :
					this.trigger( name );
			};
		}
	);
	
	
	
	
	// Support: Android <=4.0 only
	// Make sure we trim BOM and NBSP
	var rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
	
	// Bind a function to a context, optionally partially applying any
	// arguments.
	// jQuery.proxy is deprecated to promote standards (specifically Function#bind)
	// However, it is not slated for removal any time soon
	jQuery.proxy = function( fn, context ) {
		var tmp, args, proxy;
	
		if ( typeof context === "string" ) {
			tmp = fn[ context ];
			context = fn;
			fn = tmp;
		}
	
		// Quick check to determine if target is callable, in the spec
		// this throws a TypeError, but we will just return undefined.
		if ( !isFunction( fn ) ) {
			return undefined;
		}
	
		// Simulated bind
		args = slice.call( arguments, 2 );
		proxy = function() {
			return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
		};
	
		// Set the guid of unique handler to the same of original handler, so it can be removed
		proxy.guid = fn.guid = fn.guid || jQuery.guid++;
	
		return proxy;
	};
	
	jQuery.holdReady = function( hold ) {
		if ( hold ) {
			jQuery.readyWait++;
		} else {
			jQuery.ready( true );
		}
	};
	jQuery.isArray = Array.isArray;
	jQuery.parseJSON = JSON.parse;
	jQuery.nodeName = nodeName;
	jQuery.isFunction = isFunction;
	jQuery.isWindow = isWindow;
	jQuery.camelCase = camelCase;
	jQuery.type = toType;
	
	jQuery.now = Date.now;
	
	jQuery.isNumeric = function( obj ) {
	
		// As of jQuery 3.0, isNumeric is limited to
		// strings and numbers (primitives or objects)
		// that can be coerced to finite numbers (gh-2662)
		var type = jQuery.type( obj );
		return ( type === "number" || type === "string" ) &&
	
			// parseFloat NaNs numeric-cast false positives ("")
			// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
			// subtraction forces infinities to NaN
			!isNaN( obj - parseFloat( obj ) );
	};
	
	jQuery.trim = function( text ) {
		return text == null ?
			"" :
			( text + "" ).replace( rtrim, "" );
	};
	
	
	
	// Register as a named AMD module, since jQuery can be concatenated with other
	// files that may use define, but not via a proper concatenation script that
	// understands anonymous AMD modules. A named AMD is safest and most robust
	// way to register. Lowercase jquery is used because AMD module names are
	// derived from file names, and jQuery is normally delivered in a lowercase
	// file name. Do this after creating the global so that if an AMD module wants
	// to call noConflict to hide this version of jQuery, it will work.
	
	// Note that for maximum portability, libraries that are not jQuery should
	// declare themselves as anonymous modules, and avoid setting a global if an
	// AMD loader is present. jQuery is a special case. For more information, see
	// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon
	
	if ( true ) {
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
			return jQuery;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}
	
	
	
	
	var
	
		// Map over jQuery in case of overwrite
		_jQuery = window.jQuery,
	
		// Map over the $ in case of overwrite
		_$ = window.$;
	
	jQuery.noConflict = function( deep ) {
		if ( window.$ === jQuery ) {
			window.$ = _$;
		}
	
		if ( deep && window.jQuery === jQuery ) {
			window.jQuery = _jQuery;
		}
	
		return jQuery;
	};
	
	// Expose jQuery and $ identifiers, even in AMD
	// (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
	// and CommonJS for browser emulators (#13566)
	if ( typeof noGlobal === "undefined" ) {
		window.jQuery = window.$ = jQuery;
	}
	
	
	
	
	return jQuery;
	} );


/***/ }),
/* 3 */
/***/ (function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self
	  // eslint-disable-next-line no-new-func
	  : Function('return this')();
	if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	var store = __webpack_require__(33)('wks');
	var uid = __webpack_require__(25);
	var Symbol = __webpack_require__(3).Symbol;
	var USE_SYMBOL = typeof Symbol == 'function';
	
	var $exports = module.exports = function (name) {
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};
	
	$exports.store = store;


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  API_HOST: ("https://wxpos.xianguoyihao.com"),
	  LOGIN_URL: '/api/login.htm',
	  AUTO_LOGIN_URL: '/api/auto_login.htm',
	  LOGOUT_URL: '/api/logout.htm',
	  AUTH_TOKEN_KEY: 'af885c03a23d4c08827b0c32151a0347',
	  AUTH_USER_KEY: 'session_user',
	
	  API_LOGIN: '/static/weixin/login.html',
	
	  API_CARD_DETAIL_LIST: '/mapi/card_member/card_detail_list.htm',
	
	  API_VIEW_QRCODE_CARD: '/uapi/card/view_qrcode_card.htm',
	
	  API_BIND_CARD_PRO: '/mapi/card_member/bind_card_pro.htm',
	
	  API_BIND_CARD_FIN: '/mapi/card_member/bind_card_fin.htm',
	
	  API_VIEW_CARD: '/mapi/card_member/view_card.htm',
	
	  API_UNBIND_CARD: '/mapi/card_member/unbind_card.htm',
	
	  API_FIND_BACK_PRO: '/mapi/card_member/find_back_pro.htm',
	
	  API_FIND_BACK_FIN: '/mapi/card_member/find_back_fin.htm',
	
	  API_DOWNLOAD_CERT: '/uapi/card_cert/download_cert.htm',
	
	  API_QUICK_PASS: '/api/card/quick_pass.htm',
	
	  api_CARD_INFO: '/api/card/card_info.htm',
	
	  API_CARD_DETAIL: '/api/card/card_detail.htm',
	
	  API_CARD_APPLY: '/mapi/card_member/card_apply.htm',
	
	  API_CARD_APPLY_SMS: '/mapi/card_member/card_apply_sms.htm',
	
	  API_CARD_OPTION_LIST: '/mapi/member/echarge/option_list.htm',
	
	  API_CARD_ECHARGE_ORDER: '/mapi/member/echarge/echarge_order.htm',
	
	  API_ECHARGE_VIEW: '/mapi/member/echarge/echarge_view.htm',
	
	  API_CARD_MODIFY: '/mapi/card_member/card_modify.htm',
	
	  getMid: function getMid() {
	    var local_admin = JSON.parse(localStorage.getItem(this.AUTH_USER_KEY));
	    if (local_admin) {
	      return local_admin.ts;
	    }
	    return "";
	  }
	};

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(38);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _promise = __webpack_require__(96);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _constants = __webpack_require__(5);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	
	  user: null,
	
	  authenticated: false,
	
	  autoLogin: function autoLogin(context, creds) {
	    return new _promise2.default(function (resolve, reject) {
	      var _this = this;
	
	      var error_result = { code: "500", data: "自动登陆失败" };
	      var accessToken = localStorage.getItem(_constants2.default.AUTH_TOKEN_KEY);
	      if (accessToken) {
	        context.$http.post(_constants2.default.API_HOST + _constants2.default.AUTO_LOGIN_URL, { token: accessToken }).then(function (result) {
	          var data = result.data;
	          if (data.code === "200") {
	            localStorage.setItem(_constants2.default.AUTH_TOKEN_KEY, data.data.access_token);
	            localStorage.setItem(_constants2.default.AUTH_USER_KEY, (0, _stringify2.default)(data.data.user));
	            _this.authenticated = true;
	            _this.user = data.data.user;
	            resolve(data);
	          } else {
	            reject(data);
	          }
	        }, function (error) {
	          reject(error_result);
	        });
	      } else {
	        reject(error_result);
	      }
	    }.bind(this));
	  },
	  login: function login(context, creds) {
	
	    return new _promise2.default(function (resolve, reject) {
	      var _this2 = this;
	
	      var error_result = { code: "500", data: "登陆失败" };
	      context.$http.post(_constants2.default.API_HOST + _constants2.default.LOGIN_URL, creds).then(function (result) {
	        var data = result.data;
	        if (data.code === "200") {
	          localStorage.setItem(_constants2.default.AUTH_TOKEN_KEY, data.data.access_token);
	          localStorage.setItem(_constants2.default.AUTH_USER_KEY, (0, _stringify2.default)(data.data.user));
	          _this2.authenticated = true;
	          _this2.user = data.data.user;
	          resolve(data);
	        } else {
	          reject(data);
	        }
	      }, function (error) {
	        reject(error_result);
	      });
	    }.bind(this));
	  },
	  logouted: function logouted(context) {
	
	    return new _promise2.default(function (resolve, reject) {
	      var _this3 = this;
	
	      context.$http.post(_constants2.default.API_HOST + _constants2.default.LOGOUT_URL).then(function (result) {
	        var data = result.data;
	        if (data.code === "200") {
	          localStorage.removeItem(_constants2.default.AUTH_TOKEN_KEY);
	          localStorage.removeItem(_constants2.default.AUTH_USER_KEY);
	          _this3.authenticated = false;
	          _this3.user = null;
	          resolve();
	        } else {
	          reject();
	        }
	      }, function (error) {
	        reject(error);
	      });
	    }.bind(this));
	  },
	  logout: function logout(context) {
	
	    return new _promise2.default(function (resolve, reject) {
	      var _this4 = this;
	
	      context.$http.post(_constants2.default.API_HOST + _constants2.default.LOGOUT_URL).then(function (result) {
	        var data = result.data;
	        if (data.code === "200") {
	          localStorage.removeItem(_constants2.default.AUTH_TOKEN_KEY);
	          localStorage.removeItem(_constants2.default.AUTH_USER_KEY);
	          _this4.authenticated = false;
	          _this4.user = null;
	          resolve();
	        } else {
	          reject();
	        }
	      }, function (error) {
	        reject(error);
	      });
	    }.bind(this));
	  },
	  checkAuth: function checkAuth() {
	    var token = localStorage.getItem(_constants2.default.AUTH_TOKEN_KEY);
	    if (token) {
	      this.authenticated = true;
	    } else {
	      this.authenticated = false;
	    }
	  },
	  getToken: function getToken() {
	    return localStorage.getItem(_constants2.default.AUTH_TOKEN_KEY);
	  }
	};

/***/ }),
/* 7 */
/***/ (function(module, exports) {

	var core = module.exports = { version: '2.6.12' };
	if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(13);
	module.exports = function (it) {
	  if (!isObject(it)) throw TypeError(it + ' is not an object!');
	  return it;
	};


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _iterator = __webpack_require__(98);
	
	var _iterator2 = _interopRequireDefault(_iterator);
	
	var _symbol = __webpack_require__(97);
	
	var _symbol2 = _interopRequireDefault(_symbol);
	
	var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
	  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
	} : function (obj) {
	  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
	};

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(22)(function () {
	  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 11 */
/***/ (function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function (it, key) {
	  return hasOwnProperty.call(it, key);
	};


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(14);
	var createDesc = __webpack_require__(23);
	module.exports = __webpack_require__(10) ? function (object, key, value) {
	  return dP.f(object, key, createDesc(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};


/***/ }),
/* 13 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(8);
	var IE8_DOM_DEFINE = __webpack_require__(41);
	var toPrimitive = __webpack_require__(35);
	var dP = Object.defineProperty;
	
	exports.f = __webpack_require__(10) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return dP(O, P, Attributes);
	  } catch (e) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(109);
	var defined = __webpack_require__(26);
	module.exports = function (it) {
	  return IObject(defined(it));
	};


/***/ }),
/* 16 */
/***/ (function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function (it) {
	  return toString.call(it).slice(8, -1);
	};


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(3);
	var core = __webpack_require__(7);
	var ctx = __webpack_require__(21);
	var hide = __webpack_require__(12);
	var has = __webpack_require__(11);
	var PROTOTYPE = 'prototype';
	
	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var IS_WRAP = type & $export.W;
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE];
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
	  var key, own, out;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    if (own && has(exports, key)) continue;
	    // export native or passed
	    out = own ? target[key] : source[key];
	    // prevent global pollution for namespaces
	    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
	    // bind timers to global for call from export context
	    : IS_BIND && own ? ctx(out, global)
	    // wrap global constructors for prevent change them in library
	    : IS_WRAP && target[key] == out ? (function (C) {
	      var F = function (a, b, c) {
	        if (this instanceof C) {
	          switch (arguments.length) {
	            case 0: return new C();
	            case 1: return new C(a);
	            case 2: return new C(a, b);
	          } return new C(a, b, c);
	        } return C.apply(this, arguments);
	      };
	      F[PROTOTYPE] = C[PROTOTYPE];
	      return F;
	    // make static versions for prototype methods
	    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
	    if (IS_PROTO) {
	      (exports.virtual || (exports.virtual = {}))[key] = out;
	      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
	      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
	    }
	  }
	};
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;


/***/ }),
/* 18 */
/***/ (function(module, exports) {

	module.exports = {};


/***/ }),
/* 19 */
/***/ (function(module, exports) {

	module.exports = true;


/***/ }),
/* 20 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
	  return it;
	};


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(20);
	module.exports = function (fn, that, length) {
	  aFunction(fn);
	  if (that === undefined) return fn;
	  switch (length) {
	    case 1: return function (a) {
	      return fn.call(that, a);
	    };
	    case 2: return function (a, b) {
	      return fn.call(that, a, b);
	    };
	    case 3: return function (a, b, c) {
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};


/***/ }),
/* 22 */
/***/ (function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return !!exec();
	  } catch (e) {
	    return true;
	  }
	};


/***/ }),
/* 23 */
/***/ (function(module, exports) {

	module.exports = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

	var def = __webpack_require__(14).f;
	var has = __webpack_require__(11);
	var TAG = __webpack_require__(4)('toStringTag');
	
	module.exports = function (it, tag, stat) {
	  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
	};


/***/ }),
/* 25 */
/***/ (function(module, exports) {

	var id = 0;
	var px = Math.random();
	module.exports = function (key) {
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};


/***/ }),
/* 26 */
/***/ (function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function (it) {
	  if (it == undefined) throw TypeError("Can't call method on  " + it);
	  return it;
	};


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(13);
	var document = __webpack_require__(3).document;
	// typeof document.createElement is 'object' in old IE
	var is = isObject(document) && isObject(document.createElement);
	module.exports = function (it) {
	  return is ? document.createElement(it) : {};
	};


/***/ }),
/* 28 */
/***/ (function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 25.4.1.5 NewPromiseCapability(C)
	var aFunction = __webpack_require__(20);
	
	function PromiseCapability(C) {
	  var resolve, reject;
	  this.promise = new C(function ($$resolve, $$reject) {
	    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
	    resolve = $$resolve;
	    reject = $$reject;
	  });
	  this.resolve = aFunction(resolve);
	  this.reject = aFunction(reject);
	}
	
	module.exports.f = function (C) {
	  return new PromiseCapability(C);
	};


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys = __webpack_require__(46);
	var enumBugKeys = __webpack_require__(28);
	
	module.exports = Object.keys || function keys(O) {
	  return $keys(O, enumBugKeys);
	};


/***/ }),
/* 31 */
/***/ (function(module, exports) {

	exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

	var shared = __webpack_require__(33)('keys');
	var uid = __webpack_require__(25);
	module.exports = function (key) {
	  return shared[key] || (shared[key] = uid(key));
	};


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

	var core = __webpack_require__(7);
	var global = __webpack_require__(3);
	var SHARED = '__core-js_shared__';
	var store = global[SHARED] || (global[SHARED] = {});
	
	(module.exports = function (key, value) {
	  return store[key] || (store[key] = value !== undefined ? value : {});
	})('versions', []).push({
	  version: core.version,
	  mode: __webpack_require__(19) ? 'pure' : 'global',
	  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
	});


/***/ }),
/* 34 */
/***/ (function(module, exports) {

	// 7.1.4 ToInteger
	var ceil = Math.ceil;
	var floor = Math.floor;
	module.exports = function (it) {
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(13);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function (it, S) {
	  if (!isObject(it)) return it;
	  var fn, val;
	  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  throw TypeError("Can't convert object to primitive value");
	};


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(3);
	var core = __webpack_require__(7);
	var LIBRARY = __webpack_require__(19);
	var wksExt = __webpack_require__(37);
	var defineProperty = __webpack_require__(14).f;
	module.exports = function (name) {
	  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
	  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
	};


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

	exports.f = __webpack_require__(4);


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(99), __esModule: true };

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(16);
	var TAG = __webpack_require__(4)('toStringTag');
	// ES3 wrong here
	var ARG = cof(function () { return arguments; }()) == 'Arguments';
	
	// fallback for IE11 Script Access Denied error
	var tryGet = function (it, key) {
	  try {
	    return it[key];
	  } catch (e) { /* empty */ }
	};
	
	module.exports = function (it) {
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

	var document = __webpack_require__(3).document;
	module.exports = document && document.documentElement;


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(10) && !__webpack_require__(22)(function () {
	  return Object.defineProperty(__webpack_require__(27)('div'), 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(19);
	var $export = __webpack_require__(17);
	var redefine = __webpack_require__(49);
	var hide = __webpack_require__(12);
	var Iterators = __webpack_require__(18);
	var $iterCreate = __webpack_require__(113);
	var setToStringTag = __webpack_require__(24);
	var getPrototypeOf = __webpack_require__(121);
	var ITERATOR = __webpack_require__(4)('iterator');
	var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
	var FF_ITERATOR = '@@iterator';
	var KEYS = 'keys';
	var VALUES = 'values';
	
	var returnThis = function () { return this; };
	
	module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function (kind) {
	    if (!BUGGY && kind in proto) return proto[kind];
	    switch (kind) {
	      case KEYS: return function keys() { return new Constructor(this, kind); };
	      case VALUES: return function values() { return new Constructor(this, kind); };
	    } return function entries() { return new Constructor(this, kind); };
	  };
	  var TAG = NAME + ' Iterator';
	  var DEF_VALUES = DEFAULT == VALUES;
	  var VALUES_BUG = false;
	  var proto = Base.prototype;
	  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
	  var $default = $native || getMethod(DEFAULT);
	  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
	  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
	  var methods, key, IteratorPrototype;
	  // Fix native
	  if ($anyNative) {
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
	    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if (DEF_VALUES && $native && $native.name !== VALUES) {
	    VALUES_BUG = true;
	    $default = function values() { return $native.call(this); };
	  }
	  // Define iterator
	  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG] = returnThis;
	  if (DEFAULT) {
	    methods = {
	      values: DEF_VALUES ? $default : getMethod(VALUES),
	      keys: IS_SET ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if (FORCED) for (key in methods) {
	      if (!(key in proto)) redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject = __webpack_require__(8);
	var dPs = __webpack_require__(118);
	var enumBugKeys = __webpack_require__(28);
	var IE_PROTO = __webpack_require__(32)('IE_PROTO');
	var Empty = function () { /* empty */ };
	var PROTOTYPE = 'prototype';
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function () {
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__(27)('iframe');
	  var i = enumBugKeys.length;
	  var lt = '<';
	  var gt = '>';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__(40).appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};
	
	module.exports = Object.create || function create(O, Properties) {
	  var result;
	  if (O !== null) {
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty();
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
	var $keys = __webpack_require__(46);
	var hiddenKeys = __webpack_require__(28).concat('length', 'prototype');
	
	exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
	  return $keys(O, hiddenKeys);
	};


/***/ }),
/* 45 */
/***/ (function(module, exports) {

	exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

	var has = __webpack_require__(11);
	var toIObject = __webpack_require__(15);
	var arrayIndexOf = __webpack_require__(105)(false);
	var IE_PROTO = __webpack_require__(32)('IE_PROTO');
	
	module.exports = function (object, names) {
	  var O = toIObject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while (names.length > i) if (has(O, key = names[i++])) {
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};


/***/ }),
/* 47 */
/***/ (function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return { e: false, v: exec() };
	  } catch (e) {
	    return { e: true, v: e };
	  }
	};


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(8);
	var isObject = __webpack_require__(13);
	var newPromiseCapability = __webpack_require__(29);
	
	module.exports = function (C, x) {
	  anObject(C);
	  if (isObject(x) && x.constructor === C) return x;
	  var promiseCapability = newPromiseCapability.f(C);
	  var resolve = promiseCapability.resolve;
	  resolve(x);
	  return promiseCapability.promise;
	};


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(12);


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.3.20 SpeciesConstructor(O, defaultConstructor)
	var anObject = __webpack_require__(8);
	var aFunction = __webpack_require__(20);
	var SPECIES = __webpack_require__(4)('species');
	module.exports = function (O, D) {
	  var C = anObject(O).constructor;
	  var S;
	  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
	};


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

	var ctx = __webpack_require__(21);
	var invoke = __webpack_require__(108);
	var html = __webpack_require__(40);
	var cel = __webpack_require__(27);
	var global = __webpack_require__(3);
	var process = global.process;
	var setTask = global.setImmediate;
	var clearTask = global.clearImmediate;
	var MessageChannel = global.MessageChannel;
	var Dispatch = global.Dispatch;
	var counter = 0;
	var queue = {};
	var ONREADYSTATECHANGE = 'onreadystatechange';
	var defer, channel, port;
	var run = function () {
	  var id = +this;
	  // eslint-disable-next-line no-prototype-builtins
	  if (queue.hasOwnProperty(id)) {
	    var fn = queue[id];
	    delete queue[id];
	    fn();
	  }
	};
	var listener = function (event) {
	  run.call(event.data);
	};
	// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
	if (!setTask || !clearTask) {
	  setTask = function setImmediate(fn) {
	    var args = [];
	    var i = 1;
	    while (arguments.length > i) args.push(arguments[i++]);
	    queue[++counter] = function () {
	      // eslint-disable-next-line no-new-func
	      invoke(typeof fn == 'function' ? fn : Function(fn), args);
	    };
	    defer(counter);
	    return counter;
	  };
	  clearTask = function clearImmediate(id) {
	    delete queue[id];
	  };
	  // Node.js 0.8-
	  if (__webpack_require__(16)(process) == 'process') {
	    defer = function (id) {
	      process.nextTick(ctx(run, id, 1));
	    };
	  // Sphere (JS game engine) Dispatch API
	  } else if (Dispatch && Dispatch.now) {
	    defer = function (id) {
	      Dispatch.now(ctx(run, id, 1));
	    };
	  // Browsers with MessageChannel, includes WebWorkers
	  } else if (MessageChannel) {
	    channel = new MessageChannel();
	    port = channel.port2;
	    channel.port1.onmessage = listener;
	    defer = ctx(port.postMessage, port, 1);
	  // Browsers with postMessage, skip WebWorkers
	  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
	  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
	    defer = function (id) {
	      global.postMessage(id + '', '*');
	    };
	    global.addEventListener('message', listener, false);
	  // IE8-
	  } else if (ONREADYSTATECHANGE in cel('script')) {
	    defer = function (id) {
	      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
	        html.removeChild(this);
	        run.call(id);
	      };
	    };
	  // Rest old browsers
	  } else {
	    defer = function (id) {
	      setTimeout(ctx(run, id, 1), 0);
	    };
	  }
	}
	module.exports = {
	  set: setTask,
	  clear: clearTask
	};


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(34);
	var min = Math.min;
	module.exports = function (it) {
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(26);
	module.exports = function (it) {
	  return Object(defined(it));
	};


/***/ }),
/* 54 */
/***/ (function(module, exports) {



/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $at = __webpack_require__(124)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(42)(String, 'String', function (iterated) {
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var index = this._i;
	  var point;
	  if (index >= O.length) return { value: undefined, done: true };
	  point = $at(O, index);
	  this._i += point.length;
	  return { value: point, done: false };
	});


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(128);
	var global = __webpack_require__(3);
	var hide = __webpack_require__(12);
	var Iterators = __webpack_require__(18);
	var TO_STRING_TAG = __webpack_require__(4)('toStringTag');
	
	var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
	  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
	  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
	  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
	  'TextTrackList,TouchList').split(',');
	
	for (var i = 0; i < DOMIterables.length; i++) {
	  var NAME = DOMIterables[i];
	  var Collection = global[NAME];
	  var proto = Collection && Collection.prototype;
	  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
	  Iterators[NAME] = Iterators.Array;
	}


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

	if (true) {
	  module.exports = __webpack_require__(227)
	} else {
	  module.exports = require('./vue.common.dev.js')
	}


/***/ }),
/* 58 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {module.exports = __webpack_amd_options__;
	
	/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ }),
/* 59 */
/***/ (function(module, exports) {

	'use strict';
	module.exports = function (arr, predicate, ctx) {
		if (typeof Array.prototype.findIndex === 'function') {
			return arr.findIndex(predicate, ctx);
		}
	
		if (typeof predicate !== 'function') {
			throw new TypeError('predicate must be a function');
		}
	
		var list = Object(arr);
		var len = list.length;
	
		if (len === 0) {
			return -1;
		}
	
		for (var i = 0; i < len; i++) {
			if (predicate.call(ctx, list[i], i, list)) {
				return i;
			}
		}
	
		return -1;
	};


/***/ }),
/* 60 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    props: {
	        title: {
	            type: String,
	            default: ''
	        },
	        paths: {
	            type: Array
	        }
	    },
	    computed: {
	        count: function count() {
	            return this.paths.length;
	        }
	    }
	};

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	Object.defineProperty(exports, "__esModule", {
					value: true
	});
	exports.default = {
					props: {
									show: {
													default: false
									}
					},
					mounted: function mounted() {
									$("#icons li").click(function () {
													$("#icons li").removeClass("active");
													$("#icons li i").removeClass("icon-white");
													$(this).addClass("active");
													$(this).children("i").addClass("icon-white");
													$("#icon").val($(this).find('i').attr('class').split(" ")[1]);
									});
									$("#icons li").each(function () {
													if ($(this).text() == "${value}") {
																	$(this).click();
													}
									});
									$("#icons li").dblclick(function () {});
					}
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 62 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    props: {
	        show: {
	            default: false
	        }
	    }
	};

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    data: function data() {
	        return {
	            opened: false
	        };
	    },
	
	    props: {
	        large: Boolean,
	        closed: Function,
	        classes: {
	            type: String,
	            default: ''
	        },
	        title: {
	            type: String,
	            default: ''
	        },
	        options: {
	            type: Object,
	            default: function _default() {
	                return {};
	            }
	        }
	    },
	    mounted: function mounted() {
	        var _this = this;
	
	        document.body.appendChild(this.$el);
	        this.$element = $(this.$el);
	        this.$element.modal($.extend({ show: false }, this.options));
	        this.$element.on('hide.bs.modal', function () {
	            _this.opened = false;
	            if (_this.closed) {
	                _this.closed();
	            }
	        });
	    },
	
	    methods: {
	        open: function open() {
	            this.opened = true;
	            this.$element.modal('show');
	        },
	        close: function close() {
	            this.$element.modal('hide');
	        }
	    }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    data: function data() {
	        return {
	            opened: false
	        };
	    },
	
	    props: {
	        large: Boolean,
	        closed: Function,
	        classes: {
	            type: String,
	            default: ''
	        },
	        title: {
	            type: String,
	            default: ''
	        },
	        options: {
	            type: Object,
	            default: function _default() {
	                return {};
	            }
	        }
	    },
	    mounted: function mounted() {
	        var _this = this;
	
	        document.body.appendChild(this.$el);
	        this.$element = $(this.$el);
	        this.$element.modal($.extend({ show: false }, this.options));
	        this.$element.on('hide.bs.modal', function () {
	            _this.opened = false;
	            if (_this.closed) {
	                _this.closed();
	            }
	        });
	    },
	
	    methods: {
	        open: function open() {
	            this.opened = true;
	            this.$element.modal('show');
	        },
	        close: function close() {
	            this.$element.modal('hide');
	        }
	    }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 65 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    props: {
	        action: {
	            type: Function,
	            default: function _default(page) {}
	        },
	        page: {
	            required: true,
	            type: Number,
	            default: 1
	        },
	        totalPage: {
	            type: Number,
	            default: 1
	        },
	        showSize: {
	            type: Number,
	            default: 10
	        },
	        count: {
	            type: Number,
	            default: 1
	        },
	        pageSize: {
	            type: Number,
	            default: 10
	        }
	    },
	    computed: {
	        isShow: function isShow() {
	            return this.totalPage > 1 || Math.ceil(this.count / this.pageSize) > 1;
	        },
	        pages: function pages() {
	            var totalPage = this.totalPage;
	            if (this.count) {
	                totalPage = Math.ceil(this.count / this.pageSize);
	            }
	            var currentPage = this.page,
	                showSize = this.showSize,
	                left = 1,
	                right = totalPage,
	                pageArr = [];
	            if (totalPage > showSize) {
	                var halfLeft = Math.floor((showSize - 1) / 2);
	                var halfRight = Math.ceil((showSize - 1) / 2);
	                if (currentPage > halfRight && currentPage < totalPage - halfLeft) {
	                    left = currentPage - halfRight;
	                    right = currentPage + halfLeft;
	                } else {
	                    if (currentPage <= halfRight) {
	                        left = 1;
	                        right = showSize;
	                    } else {
	                        right = totalPage;
	                        left = totalPage - (showSize - 1);
	                    }
	                }
	            }
	            while (left <= right) {
	                pageArr.push(left);
	                left++;
	            }
	            return pageArr;
	        },
	        showPrev: function showPrev() {
	            return this.page > 1;
	        },
	        showNext: function showNext() {
	            return this.page < this.totalPage;
	        }
	    }
	};

/***/ }),
/* 66 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    data: function data() {
	        return {};
	    },
	
	    props: {},
	    mounted: function mounted() {},
	
	    methods: {
	        goBack: function goBack() {
	            router.push('card_qrcode');
	        }
	    }
	};

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'items',
	  props: ['model'],
	  components: {},
	  data: function data() {
	    return {
	      open: true,
	      isFolder: true
	    };
	  },
	
	  computed: {
	    isFolder: function isFolder() {
	      return this.model.childTreeNode && this.model.childTreeNode.length;
	    }
	  },
	  mounted: function mounted() {
	    $(".menuTree_1_check").click(function () {
	      if ($(this).hasClass("check")) {
	        $(this).removeClass("check");
	      } else {
	        $(this).addClass("check");
	      }
	      if (this.checked) {
	        $(this).parent().next("ul").find(".menuTree_1_check").prop("checked", true);
	        $(this).parent().next("ul").find(".menuTree_1_check").addClass("check");
	      } else {
	        $(this).parent().next("ul").find(".menuTree_1_check").prop("checked", false);
	        $(this).parent().next("ul").find(".menuTree_1_check").removeClass("check");
	      }
	    });
	  },
	
	  methods: {
	    toggle: function toggle() {
	      if (this.isFolder) {
	        this.open = !this.open;
	      }
	    }
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'items',
	  props: ['model'],
	  components: {},
	  data: function data() {
	    return {
	      open: false,
	      isFolder: true
	    };
	  },
	
	  computed: {
	    isFolder: function isFolder() {
	      return this.model.childTreeNode && this.model.childTreeNode.length;
	    }
	  },
	  mounted: function mounted() {
	    $(".menuname").click(function () {
	      $(".menuname").removeClass("active");
	      $(this).addClass("active");
	      $(".menuname").val($(this).find('i').attr('class'));
	    });
	  },
	
	  methods: {
	    toggle: function toggle() {
	      if (this.isFolder) {
	        this.open = !this.open;
	      }
	    }
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue2Dropzone = __webpack_require__(228);
	
	var _vue2Dropzone2 = _interopRequireDefault(_vue2Dropzone);
	
	var _constants = __webpack_require__(5);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'MainApp',
	  components: {
	    Dropzone: _vue2Dropzone2.default
	  },
	  data: function data() {
	    return {
	      url: _constants2.default.API_HOST + _constants2.default.API_UEDITOR_UPLOAD
	    };
	  },
	  mounted: function mounted() {},
	
	  methods: {
	    showSuccess: function showSuccess(file) {
	      console.log(eval('(' + file.xhr.response + ')').url);
	      console.log(file.name.split(".")[0], 120);
	      this.$emit("upup", eval('(' + file.xhr.response + ')').url);
	    }
	  }
	};

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _myScroll = __webpack_require__(92);
	
	var _myScroll2 = _interopRequireDefault(_myScroll);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PULL_DOWN_NORMAL = '下拉刷新';
	var PULL_DOWN_RELEASE = '释放加载';
	var PULL_DOWN_LOADING = '加载中，请稍后';
	
	var PULL_UP_NORMAL = '上拉刷新';
	var PULL_UP_RELEASE = '释放加载';
	var PULL_UP_LOADING = '加载中，请稍后';
	
	var STATE_DEFAULT = -1;
	var STATE_PULL_NORMAL = 0;
	var STATE_PULL_RELEASE = 1;
	var STATE_PULL_LOADING = 2;
	
	var STYLE_RELEASE = 'release';
	var STYLE_REFRESH = 'refresh';
	
	var timeoutHandler = 0,
	    timeout = 30000,
	    pullDownHeight = 50,
	    pullUpHeight = 50;
	
	exports.default = {
	  props: {
	    disablePulldown: {
	      type: Boolean,
	      default: false
	    },
	    disablePullup: {
	      type: Boolean,
	      default: false
	    }
	  },
	  data: function data() {
	    return {
	      displaypullDownDiv: false,
	      displaypullUpDiv: false,
	      pullUpTip: PULL_UP_NORMAL,
	      pullDownTip: PULL_DOWN_NORMAL,
	      refreshStep: STATE_DEFAULT,
	      eleId: 'bajianscroll',
	      pulldownChangeStyle: '',
	      pullupChangeStyle: '',
	      pullDownDiff: 0
	    };
	  },
	  mounted: function mounted() {
	    this.$nextTick(function () {
	      var _this = this;
	
	      this.eleId = 'bajian' + Math.round(Math.random() * 1000);
	      setTimeout(function () {
	        _this.registerDrag();
	      }, 50);
	    });
	  },
	
	  methods: {
	    registerDrag: function registerDrag() {
	      this.myscroll = new _myScroll2.default('#' + this.eleId);
	      this.myscroll.on('scroll', this._onTouchMove);
	      this.myscroll.on('scrollEnd', this._onTouchEnd);
	    },
	    _onTouchMove: function _onTouchMove() {
	      if (this.refreshStep == STATE_PULL_LOADING) return;
	
	      if (!this.disablePulldown && this.myscroll.y > 5 && this.myscroll.y < pullDownHeight / 2) {
	        this.pullDownDiff = pullDownHeight - this.myscroll.y;
	        if (this.refreshStep === STATE_PULL_NORMAL) return;
	        this.displaypullDownDiv = true;
	        this.displaypullUpDiv = false;
	        this.pulldownChangeStyle = '';
	        this.pullDownTip = PULL_DOWN_NORMAL;
	        this.refreshStep = STATE_PULL_NORMAL;
	      } else if (!this.disablePulldown && this.myscroll.y >= pullDownHeight) {
	        this.pulldownChangeStyle = STYLE_RELEASE;
	        this.pullDownTip = PULL_DOWN_RELEASE;
	        this.refreshStep = STATE_PULL_RELEASE;
	      } else if (!this.disablePullup && this.myscroll.y < -5 && -this.myscroll.y >= pullUpHeight - this.myscroll.maxScrollY) {
	        this.pullupChangeStyle = STYLE_RELEASE;
	        this.pullUpTip = PULL_UP_RELEASE;
	        this.refreshStep = STATE_PULL_RELEASE;
	      } else if (!this.disablePullup && this.myscroll.y < -5 && this.myscroll.y < this.myscroll.maxScrollY && this.myscroll.y > -pullUpHeight + this.myscroll.maxScrollY) {
	        if (this.refreshStep === STATE_PULL_NORMAL) return;
	        this.displaypullUpDiv = true;
	        this.displaypullDownDiv = false;
	        this.pullupChangeStyle = '';
	        this.pullUpTip = PULL_UP_NORMAL;
	        this.refreshStep = STATE_PULL_NORMAL;
	      }
	    },
	    reset: function reset() {
	      var _this2 = this;
	
	      if (this.refreshStep != STATE_DEFAULT) {
	        this.refreshStep = STATE_DEFAULT;
	        if (!this.disablePulldown) {
	          this.displaypullDownDiv = false;
	          this.pulldownChangeStyle = '';
	        }
	        if (!this.disablePullup) {
	          this.displaypullUpDiv = false;
	          this.pullupChangeStyle = '';
	        }
	        setTimeout(function () {
	          _this2.myscroll.refresh();
	        }, 0);
	        clearTimeout(timeoutHandler);
	      }
	    },
	    _onTouchEnd: function _onTouchEnd() {
	      var _this3 = this;
	
	      this.pullDownDiff = 0;
	      if (this.refreshStep == STATE_PULL_RELEASE) {
	        if (!this.disablePullup && this.pullupChangeStyle == STYLE_RELEASE) {
	          this.myscroll.maxScrollY < -10 && this.myscroll.scrollTo(0, this.myscroll.maxScrollY - pullUpHeight);
	          this.pullupChangeStyle = STYLE_REFRESH;
	          this.pullUpTip = PULL_UP_LOADING;
	          this.refreshStep = STATE_PULL_LOADING;
	          this.$emit('on-pullup', this.reset);
	        } else if (!this.disablePulldown && this.pulldownChangeStyle == STYLE_RELEASE) {
	          this.pulldownChangeStyle = STYLE_REFRESH;
	          this.pullDownTip = PULL_DOWN_LOADING;
	          this.refreshStep = STATE_PULL_LOADING;
	          this.$emit('on-pulldown', this.reset);
	        }
	
	        timeoutHandler = window.setTimeout(function () {
	          if (_this3.refreshStep == STATE_PULL_LOADING) _this3.reset();
	        }, timeout);
	      } else if (this.refreshStep != STATE_PULL_LOADING) {
	        this.reset();
	      }
	    }
	  }
	};

/***/ }),
/* 71 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	     value: true
	});
	exports.default = {
	     components: {}
	};

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _auth = __webpack_require__(6);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _constants = __webpack_require__(5);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      mid: "123",
	      store_id: "",
	      cb_url: encodeURIComponent(location.href),
	      card_num: "",
	      cust_mobile: "",
	      card_bind_vcode: "",
	      err_msg: "",
	      time: 60,
	      sendMsgDisabled: false
	    };
	  },
	  mounted: function mounted() {
	    this.mid = getQueryString("mid");
	    this.store_id = getQueryString("store_id") || "";
	    var r_code = getQueryString("r_code");
	    var r_data = getQueryString("r_data");
	    if (!r_code && !r_data) {
	      window.location.href = _constants2.default.API_HOST + '/api/weixin/login.htm?mid=' + this.mid + '&cb_url=' + this.cb_url + '&store_id=' + this.store_id;
	    } else {
	      if (r_code == 200) {
	        console.log(r_data, 233);
	
	        var tokens = r_data;
	        localStorage.setItem("tokens", tokens);
	        this.getVip();
	      } else {
	        location.href = '/main.html?mid= ' + this.mid + '&store_id=' + this.store_id + '#/gowhere';
	      }
	    }
	  },
	
	  methods: {
	    getVip: function getVip() {
	      var _this = this;
	
	      this.$http.post(_constants2.default.API_HOST + _constants2.default.API_VIEW_CARD, {}).then(function (result) {
	        var data = result.data;
	        if (data.code === "200") {
	          location.href = '/main.html?mid=' + _this.mid + '&store_id=' + _this.store_id + '#/card_qrcode';
	        } else {
	          location.href = '/main.html?mid=' + _this.mid + '&store_id=' + _this.store_id + '#/card_choose';
	        }
	      }, function (error) {
	        error.data && _this.$alert(error.data);
	      });
	    }
	  }
	
	};
	
	
	function getQueryString(key) {
	  var reg = new RegExp("(^|&)" + key + "=([^&]*)(&|#|$)");
	  var result = window.location.search.substr(1).match(reg);
	  return result ? decodeURIComponent(result[2]) : null;
	}

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _auth = __webpack_require__(6);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _constants = __webpack_require__(5);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	var _pullToRefresh = __webpack_require__(189);
	
	var _pullToRefresh2 = _interopRequireDefault(_pullToRefresh);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      entity: {},
	      recordList: [],
	      page: 1,
	      size: 6,
	      getType: {
	        "deposit": "充值",
	        "consume": "消费",
	        "refund": "退款"
	      },
	      getPayType: {
	        "other": "其他支付",
	        "card": "会员卡支付",
	        "weixin": "微信支付",
	        "cash": "现金支付",
	        "alipay": "支付宝支付"
	      },
	      getKinds: {
	        "PET": '门店消费',
	        "PEO": "门店消费",
	        "ECP": '卡充值订单',
	        "MEP": '线上充值',
	        "E": "商城消费",
	        "EC": "商城充值",
	        "F": "试吃消费",
	        "G": "团购消费",
	        "R": "退款",
	        "dno": '普通充值',
	        "esd": "商城充值"
	      }
	    };
	  },
	  mounted: function mounted() {
	    this.refresh(1);
	  },
	
	  components: {
	    PullToRefresh: _pullToRefresh2.default
	  },
	  methods: {
	    onPullup: function onPullup(finshCallback) {
	      var _this = this;
	
	      console.log('onPullup');
	      setTimeout(function () {
	        console.log('finshCallback');
	        _this.size = _this.size + 10;
	        _this.refresh();
	        finshCallback();
	      }, 500);
	    },
	    refresh: function refresh(page) {
	      var _this2 = this;
	
	      console.log(this.size);
	      this.$http.post(_constants2.default.API_HOST + _constants2.default.API_CARD_DETAIL_LIST, {
	        page: this.page,
	        size: this.size,
	        entity: this.entity
	      }).then(function (result) {
	        var data = result.data;
	        if (data.code === "200") {
	          _this2.recordList = data.data.dataList;
	          for (var i = 0; i < _this2.recordList.length; i++) {
	            var rl = _this2.recordList[i].co_nbr;
	            var trl = rl.substring(-1, 3);
	            var srl = rl.substring(-1, 2);
	            var frl = rl.substring(1, 0);
	            if (trl == "PET" || trl == "ECP" || trl == "MEP" || trl == 'dno' || trl == 'PEO') {
	              _this2.recordList[i].coCode = trl;
	            } else if (srl == "EC") {
	              _this2.recordList[i].coCode = srl;
	            } else {
	              _this2.recordList[i].coCode = frl;
	            }
	          }
	          console.log(_this2.recordList, 111);
	        } else {
	          _this2.$alert(data.data);
	        }
	      }, function (error) {
	        error.data && _this2.$alert(error.data);
	      });
	    }
	  }
	
	};

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _auth = __webpack_require__(6);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _constants = __webpack_require__(5);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      mid: "123",
	      store_id: "",
	      cb_url: encodeURIComponent(location.href),
	      card_num: "",
	      cust_mobile: "",
	      card_bind_vcode: "",
	      err_msg: "",
	      time: 60,
	      sendMsgDisabled: false
	    };
	  },
	  mounted: function mounted() {},
	
	  methods: {
	    goBack: function goBack() {
	      location.href = location.href;
	    },
	    goQrcode: function goQrcode() {
	      router.push("/card_qrcode");
	    },
	    closePhone: function closePhone() {
	      $(".again").hide();_;
	    },
	    closeAgain: function closeAgain() {
	      router.push("/card_qrcode");
	    },
	    getSession: function getSession() {
	      var _this = this;
	
	      var numREG = /^(((13[0-9]{1})|(14[0-9]{1})|(15[0-9]{1})|(17[0-9]{1})|(18[0-9]{1}))+\d{8})$/;
	      if (!this.card_num || !this.cust_mobile) {
	        alert("请输入会员卡号和手机号!");
	      } else if (!numREG.test(this.cust_mobile)) {
	        alert("请输入正确的手机号码!");
	      } else {
	        this.$http.post(_constants2.default.API_HOST + _constants2.default.API_BIND_CARD_PRO, {
	          "card_num": this.card_num,
	          "cust_mobile": this.cust_mobile,
	          "card_type": "fcard"
	        }).then(function (result) {
	          var data = result.data;
	          console.log(data, 8797);
	
	          if (data.code === "200") {
	            _this.send();
	          } else if (data.code === "641") {
	            _this.err_msg = data.data;
	            $(".fail").show();
	          } else {
	            _this.$alert(data.data);
	          }
	        }, function (error) {});
	      }
	    },
	    send: function send() {
	      var me = this;
	      me.sendMsgDisabled = true;
	      var interval = window.setInterval(function () {
	        if (me.time-- <= 0) {
	          me.time = 60;
	          me.sendMsgDisabled = false;
	          window.clearInterval(interval);
	        }
	      }, 1000);
	    },
	    bindup: function bindup() {
	      var _this2 = this;
	
	      if (!this.card_bind_vcode) {
	        alert("请输入短信验证码");
	      } else {
	        $('.bangding').attr('disabled', "true");
	        this.$http.post(_constants2.default.API_HOST + _constants2.default.API_BIND_CARD_FIN, {
	          "card_num": this.card_num,
	          "cust_mobile": this.cust_mobile,
	          "card_bind_vcode": this.card_bind_vcode
	        }).then(function (result) {
	          var data = result.data;
	          if (data.code === "200") {
	            $(".success").show();
	          } else {
	            _this2.$alert(data.data);
	            $('.bangding').removeAttr("disabled");
	          }
	        }, function (error) {
	          error.data && _this2.$alert(error.data);
	          $('.bangding').removeAttr("disabled");
	        });
	      }
	    }
	  }
	
	};
	
	
	function getQueryString(key) {
	  var reg = new RegExp("(^|&)" + key + "=([^&]*)(&|$)");
	  var result = window.location.search.substr(1).match(reg);
	  return result ? decodeURIComponent(result[2]) : null;
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _auth = __webpack_require__(6);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _constants = __webpack_require__(5);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {};
	  },
	  mounted: function mounted() {},
	
	  methods: {
	    goOnline: function goOnline() {
	      router.push('card_online');
	    },
	    goMain: function goMain() {
	      router.push('card_bind');
	    }
	  }
	
	};

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _auth = __webpack_require__(6);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _constants = __webpack_require__(5);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      phoneNumber: '',
	      msg: '',
	      cust_birthday: '',
	      time: 60,
	      sendMsgDisabled: false,
	      isGender: false,
	      isWhatGender: '',
	      getCG: {
	        "N": "保密",
	        "M": "男",
	        "G": "女"
	      },
	      pickerValue: '',
	      startDate: new Date("1970-01-01"),
	      endDate: new Date()
	    };
	  },
	  mounted: function mounted() {},
	
	  methods: {
	    openPicker: function openPicker() {
	      this.$refs.picker.open();
	    },
	    send: function send() {
	      var me = this;
	      me.sendMsgDisabled = true;
	      var interval = window.setInterval(function () {
	        if (me.time-- <= 0) {
	          me.time = 60;
	          me.sendMsgDisabled = false;
	          window.clearInterval(interval);
	        }
	      }, 1000);
	    },
	    goGender: function goGender() {
	      this.isGender = true;
	    },
	    ch_none: function ch_none() {
	      this.isWhatGender = 'N';
	      this.isGender = false;
	    },
	    ch_b: function ch_b() {
	      this.isWhatGender = 'M';
	      this.isGender = false;
	    },
	    ch_g: function ch_g() {
	      this.isWhatGender = 'G';
	      this.isGender = false;
	    },
	    getMessage: function getMessage() {
	      var _this = this;
	
	      console.log(this.phoneNumber, 111);
	      var numREG = /^(((13[0-9]{1})|(14[0-9]{1})|(15[0-9]{1})|(17[0-9]{1})|(18[0-9]{1}))+\d{8})$/;
	      if (!numREG.test(this.phoneNumber)) {
	        this.$alert("请输入正确的手机号!");
	      } else {
	        this.$http.post(_constants2.default.API_HOST + _constants2.default.API_CARD_APPLY_SMS, {
	          cust_mobile: this.phoneNumber,
	          card_type: 'fcard'
	        }).then(function (result) {
	          var data = result.data;
	          if (data.code === "200") {
	            console.log(data.data);
	            _this.send();
	          } else {
	            _this.$alert(data.data);
	          }
	        }, function (error) {
	          error.data && _this.$alert(error.data);
	        });
	      }
	    },
	    confirm: function confirm() {
	      var _this2 = this;
	
	      var dps = this.pickerValue;
	      this.cust_birthday = new Date(dps).getTime();
	      console.log(this.cust_birthday, 222);
	      if (!this.phoneNumber || !this.msg) {
	        this.$alert("请输入正确信息");
	      } else {
	        this.$http.post(_constants2.default.API_HOST + _constants2.default.API_CARD_APPLY, {
	          cust_mobile: this.phoneNumber,
	          card_type: 'fcard',
	          apply_vcode: this.msg,
	          cust_gender: this.isWhatGender,
	          cust_birthday: this.cust_birthday
	        }).then(function (result) {
	          var data = result.data;
	          if (data.code === "200") {
	            console.log(data.data);
	            router.push("main");
	          } else {
	            _this2.$alert(data.data);
	          }
	        }, function (error) {
	          error.data && _this2.$alert(error.data);
	        });
	      }
	    }
	  }
	
	};

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _auth = __webpack_require__(6);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _constants = __webpack_require__(5);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      ava_balance: "",
	      card_num: ""
	    };
	  },
	  mounted: function mounted() {
	    this.getVip();
	  },
	
	  methods: {
	    reloads: function reloads() {
	      window.location.reload();
	    },
	    reload: function reload() {
	      console.log(1);
	      setInterval(function () {
	        window.location.reload();
	      }, 150000);
	    },
	    goRecharge: function goRecharge() {
	      router.push("recharge");
	    },
	    goBill: function goBill() {
	      router.push("bill");
	    },
	    goSetup: function goSetup() {
	      router.push("setup");
	    },
	    getVip: function getVip() {
	      var _this = this;
	
	      this.$http.post(_constants2.default.API_HOST + _constants2.default.API_VIEW_CARD, {}).then(function (result) {
	        var data = result.data;
	        if (data.code === "200") {
	          console.log(data.data);
	          _this.ava_balance = data.data.card.ava_balance;
	          if (_this.ava_balance == 0) {
	            _this.ava_balance = "0.00";
	          }
	          _this.card_num = data.data.card.card_num;
	          var qrcode = data.data.payQrcode;
	          $("#qrCodeImg").qrcode({
	            text: qrcode,
	            width: 210,
	            height: 210
	          });
	        } else {
	          _this.$alert(data.data);
	        }
	      }, function (error) {
	        error.data && _this.$alert(error.data);
	      });
	    },
	    unBind: function unBind() {
	      $(".out-all").show();
	    },
	    closeQ: function closeQ() {
	      $(".out-all").hide();
	    },
	    unBindOk: function unBindOk() {
	      var _this2 = this;
	
	      this.$http.post(_constants2.default.API_HOST + _constants2.default.API_UNBIND_CARD, {}).then(function (result) {
	        var data = result.data;
	        if (data.code === "200") {
	          location.href = "main.html#/main";
	          console.log(123);
	        } else {
	          _this2.$alert(data.data);
	        }
	      }, function (error) {
	        error.data && _this2.$alert(error.data);
	      });
	    }
	  }
	
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _auth = __webpack_require__(6);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _constants = __webpack_require__(5);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      mid: "123",
	      cb_url: 'main.html#/main'
	    };
	  },
	  mounted: function mounted() {},
	
	  methods: {}
	};

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _auth = __webpack_require__(6);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      credentials: {
	        name: '',
	        password: ''
	      }
	
	    };
	  },
	
	  methods: {
	    login: function login() {
	      _auth2.default.login(this, this.credentials).then(function () {
	        router.push('registration');
	      }, function (error) {
	        alert("error");
	      });
	    }
	  }
	};

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _auth = __webpack_require__(6);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      credentials: {
	        name: '',
	        password: ''
	      }
	    };
	  },
	  mounted: function mounted() {
	    _auth2.default.autoLogin(this, this.credentials).then(function () {
	      router.push('main');
	    }, function (error) {});
	  },
	
	  methods: {
	    login: function login() {
	      var _this = this;
	
	      _auth2.default.login(this, this.credentials).then(function () {
	        router.push('main');
	      }, function (error) {
	        error.data && _this.$alert(error.data);
	      });
	    }
	  }
	};

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(38);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _auth = __webpack_require__(6);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _constants = __webpack_require__(5);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      codeList: [],
	      page: 1,
	      size: 20,
	      queryId: '',
	      choosedId: '',
	      nowIndex: ''
	    };
	  },
	  mounted: function mounted() {
	    this.getPayCode();
	  },
	
	  methods: {
	    choosePrice: function choosePrice(id, index) {
	      this.choosedId = id;
	      this.nowIndex = index;
	      this.recharge(id);
	    },
	    confirm_recharge: function confirm_recharge() {
	      this.recharge(this.choosedId);
	    },
	    getPayCode: function getPayCode() {
	      var _this = this;
	
	      this.$http.post(_constants2.default.API_HOST + _constants2.default.API_CARD_OPTION_LIST, {
	        page: this.page,
	        size: this.size
	      }).then(function (result) {
	        var data = result.data;
	        if (data.code === "200") {
	          _this.codeList = data.data.dataList;
	          console.log((0, _stringify2.default)(_this.codeList), 111);
	        } else {
	          _this.$alert(data.data);
	        }
	      }, function (error) {
	        error.data && _this.$alert(error.data);
	      });
	    },
	    recharge: function recharge(id) {
	      var _this2 = this;
	
	      console.log(id, 233);
	      this.queryId = id;
	      var ua = window.navigator.userAgent.toLowerCase();
	      if (ua.match(/MicroMessenger/i) == 'micromessenger') {
	        this.$http.post(_constants2.default.API_HOST + _constants2.default.API_CARD_ECHARGE_ORDER, {
	          pay_type: 'weixin',
	          echarge_option_id: this.queryId
	        }).then(function (result) {
	          var data = result.data;
	          if (data.code === "200") {
	            console.log(data.data);
	            var co_nbr = data.data.co_nbr;
	            var price = data.data.price;
	            _this2.weixinPay(co_nbr, price);
	          } else {
	            _this2.$alert(data.data);
	          }
	        }, function (error) {
	          error.data && _this2.$alert(error.data);
	        });
	      } else {
	        this.$alert("请在微信环境使用");
	      }
	    },
	    repeatSearch: function repeatSearch(co_nbr) {
	      var _this3 = this;
	
	      this.$http.post(_constants2.default.API_HOST + _constants2.default.API_ECHARGE_VIEW, {
	        co_nbr: co_nbr
	      }).then(function (result) {
	        var data = result.data;
	        if (data.code === "200") {
	          var status = data.data.status;
	          if (status == "W" || status == "P") {
	            _this3.repeatSearch(co_nbr);
	          } else if (status == "PE") {
	            _this3.$alert("支付异常", function () {
	              router.push('card_qrcode');
	            });
	          } else if (status == "ES") {
	            _this3.$alert("充值成功", function () {
	              router.push('card_qrcode');
	            });
	          } else if (status == "EF") {
	            _this3.$alert("充值失败", function () {
	              router.push('card_qrcode');
	            });
	          }
	        } else {
	          _this3.$alert(data.data);
	        }
	      }, function (error) {
	        error.data && _this3.$alert(error.data);
	      });
	    },
	    weixinPay: function weixinPay(co_nbr, price) {
	      var _this4 = this;
	
	      var that = this;
	      this.$http.post(_constants2.default.API_HOST + '/mapi/pay/pay_sign.htm', {
	        co_nbr: co_nbr,
	        pay_type: 'weixin',
	        pay_fee: price
	      }).then(function (result) {
	        var data = result.data;
	        if (data.code === "200") {
	          console.log(data, 23132);
	          var n = data.data;
	          if (typeof WeixinJSBridge != 'undefined') {
	            WeixinJSBridge.invoke("getBrandWCPayRequest", {
	              appId: n.app_id,
	              timeStamp: n.time_stamp_str,
	              nonceStr: n.nonce_str,
	              package: n.package_str,
	              signType: n.sign_type,
	              paySign: n.pay_sign
	            }, function (o) {
	              if (o.err_msg == "get_brand_wcpay_request:ok") {
	                that.repeatSearch(co_nbr);
	              } else if (o.err_msg == "get_brand_wcpay_request:cancel") {
	                router.push('main');
	              } else if (o.err_msg == "get_brand_wcpay_request:fail") {
	                router.push('main');
	              }
	            });
	          } else {
	            _this4.$alert("Error");
	          }
	          console.log(data.data);
	        } else {
	          _this4.$alert(data.data);
	        }
	      }, function (error) {
	        error.data && _this4.$alert(error.data);
	      });
	    }
	  }
	
	};

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _auth = __webpack_require__(6);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _constants = __webpack_require__(5);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      cardMember: {},
	      card: {},
	      getGender: {
	        "N": "保密",
	        "M": "男",
	        "G": "女"
	      },
	      mid: '',
	      card_num: '',
	      cust_name: '',
	      cust_mobile: '',
	      cust_gender: '',
	      cust_birthday: '',
	
	      newName: '',
	      newPhone: '',
	      newGender: '',
	      newBirthday: '',
	
	      isWhatGender: '',
	
	      pickerValue: '',
	      startDate: new Date("1970-01-01"),
	      endDate: new Date()
	    };
	  },
	  mounted: function mounted() {
	    this.refresh();
	  },
	
	  methods: {
	    openPicker: function openPicker() {
	      this.$refs.picker.open();
	    },
	    ch_none: function ch_none() {
	      this.isWhatGender = 'N';
	      this.dealentity();
	    },
	    ch_b: function ch_b() {
	      this.isWhatGender = 'M';
	      this.dealentity();
	    },
	    ch_g: function ch_g() {
	      this.isWhatGender = 'G';
	      this.dealentity();
	    },
	    editN: function editN() {
	      $(".out-alln").show();
	      this.newName = this.card.cust_name;
	    },
	    editG: function editG() {
	      $(".out-allg").show();
	      this.newGender = this.card.cust_gender;
	    },
	    editB: function editB(cbs) {
	      var cbs = new Date(this.card.cust_birthday);
	      var year = cbs.getFullYear();
	      var month = cbs.getMonth() + 1;
	      if (month <= 9 & month > 0) {
	        month = '0' + month;
	      }
	      var day = cbs.getDate();
	      if (day <= 9 & day > 0) {
	        day = '0' + day;
	      }
	      var nowDate = year + '-' + month + '-' + day;
	      console.log(nowDate, 233);
	      this.newBirthday = nowDate;
	    },
	    dealentity: function dealentity() {
	      this.cust_name = this.newName;
	      this.cust_gender = this.isWhatGender;
	      var cb = this.pickerValue;
	      console.log(cb, 11);
	      this.cust_birthday = new Date(cb).getTime();
	      console.log(this.cust_birthday, 22);
	      this.editMessage();
	    },
	    refresh: function refresh() {
	      var _this = this;
	
	      this.$http.post(_constants2.default.API_HOST + _constants2.default.API_VIEW_CARD, {}).then(function (result) {
	        var data = result.data;
	        if (data.code === "200") {
	          console.log(data.data);
	          _this.cardMember = data.data.cardMember;
	          _this.mid = data.data.cardMember.mid;
	          _this.card = data.data.card;
	          _this.editB(_this.card.cust_birthday);
	        } else {
	          _this.$alert(data.data);
	        }
	      }, function (error) {
	        error.data && _this.$alert(error.data);
	      });
	    },
	    editMessage: function editMessage() {
	      var _this2 = this;
	
	      var numREG = /^(((13[0-9]{1})|(14[0-9]{1})|(15[0-9]{1})|(17[0-9]{1})|(18[0-9]{1}))+\d{8})$/;
	
	
	      this.$http.post(_constants2.default.API_HOST + _constants2.default.API_CARD_MODIFY, {
	        mid: this.mid,
	        cust_name: this.cust_name,
	        cust_mobile: this.cust_mobile,
	        cust_gender: this.cust_gender,
	        cust_birthday: this.cust_birthday
	      }).then(function (result) {
	        var data = result.data;
	        if (data.code === "200") {
	          location.reload();
	        } else {
	          _this2.$alert(data.data);
	        }
	      }, function (error) {
	        error.data && _this2.$alert(error.data);
	      });
	    },
	    unBind: function unBind() {
	      $(".out-all").show();
	    },
	    gobackCardQrcode: function gobackCardQrcode() {
	      router.push('card_qrcode');
	    },
	    closeQ: function closeQ() {
	      $(".out-all").hide();
	      $(".out-alln").hide();
	      $(".out-allg").hide();
	      $(".out-allb").hide();
	    },
	    unBindOk: function unBindOk() {
	      var _this3 = this;
	
	      this.$http.post(_constants2.default.API_HOST + _constants2.default.API_UNBIND_CARD, {}).then(function (result) {
	        var data = result.data;
	        if (data.code === "200") {
	          router.push('card_choose');
	        } else {
	          _this3.$alert(data.data);
	        }
	      }, function (error) {
	        error.data && _this3.$alert(error.data);
	      });
	    }
	  }
	
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {'use strict';
	
	var _typeof2 = __webpack_require__(9);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	if (typeof jQuery === 'undefined') {
	  throw new Error('Bootstrap\'s JavaScript requires jQuery');
	}
	
	+function ($) {
	  'use strict';
	
	  var version = $.fn.jquery.split(' ')[0].split('.');
	  if (version[0] < 2 && version[1] < 9 || version[0] == 1 && version[1] == 9 && version[2] < 1) {
	    throw new Error('Bootstrap\'s JavaScript requires jQuery version 1.9.1 or higher');
	  }
	}(jQuery);
	
	+function ($) {
	  'use strict';
	
	  function transitionEnd() {
	    var el = document.createElement('bootstrap');
	
	    var transEndEventNames = {
	      WebkitTransition: 'webkitTransitionEnd',
	      MozTransition: 'transitionend',
	      OTransition: 'oTransitionEnd otransitionend',
	      transition: 'transitionend'
	    };
	
	    for (var name in transEndEventNames) {
	      if (el.style[name] !== undefined) {
	        return { end: transEndEventNames[name] };
	      }
	    }
	
	    return false;
	  }
	
	  $.fn.emulateTransitionEnd = function (duration) {
	    var called = false;
	    var $el = this;
	    $(this).one('bsTransitionEnd', function () {
	      called = true;
	    });
	    var callback = function callback() {
	      if (!called) $($el).trigger($.support.transition.end);
	    };
	    setTimeout(callback, duration);
	    return this;
	  };
	
	  $(function () {
	    $.support.transition = transitionEnd();
	
	    if (!$.support.transition) return;
	
	    $.event.special.bsTransitionEnd = {
	      bindType: $.support.transition.end,
	      delegateType: $.support.transition.end,
	      handle: function handle(e) {
	        if ($(e.target).is(this)) return e.handleObj.handler.apply(this, arguments);
	      }
	    };
	  });
	}(jQuery);
	
	+function ($) {
	  'use strict';
	
	  var dismiss = '[data-dismiss="alert"]';
	  var Alert = function Alert(el) {
	    $(el).on('click', dismiss, this.close);
	  };
	
	  Alert.VERSION = '3.3.4';
	
	  Alert.TRANSITION_DURATION = 150;
	
	  Alert.prototype.close = function (e) {
	    var $this = $(this);
	    var selector = $this.attr('data-target');
	
	    if (!selector) {
	      selector = $this.attr('href');
	      selector = selector && selector.replace(/.*(?=#[^\s]*$)/, '');
	    }
	
	    var $parent = $(selector);
	
	    if (e) e.preventDefault();
	
	    if (!$parent.length) {
	      $parent = $this.closest('.alert');
	    }
	
	    $parent.trigger(e = $.Event('close.bs.alert'));
	
	    if (e.isDefaultPrevented()) return;
	
	    $parent.removeClass('in');
	
	    function removeElement() {
	      $parent.detach().trigger('closed.bs.alert').remove();
	    }
	
	    $.support.transition && $parent.hasClass('fade') ? $parent.one('bsTransitionEnd', removeElement).emulateTransitionEnd(Alert.TRANSITION_DURATION) : removeElement();
	  };
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this = $(this);
	      var data = $this.data('bs.alert');
	
	      if (!data) $this.data('bs.alert', data = new Alert(this));
	      if (typeof option == 'string') data[option].call($this);
	    });
	  }
	
	  var old = $.fn.alert;
	
	  $.fn.alert = Plugin;
	  $.fn.alert.Constructor = Alert;
	
	  $.fn.alert.noConflict = function () {
	    $.fn.alert = old;
	    return this;
	  };
	
	  $(document).on('click.bs.alert.data-api', dismiss, Alert.prototype.close);
	}(jQuery);
	
	+function ($) {
	  'use strict';
	
	  var Button = function Button(element, options) {
	    this.$element = $(element);
	    this.options = $.extend({}, Button.DEFAULTS, options);
	    this.isLoading = false;
	  };
	
	  Button.VERSION = '3.3.4';
	
	  Button.DEFAULTS = {
	    loadingText: 'loading...'
	  };
	
	  Button.prototype.setState = function (state) {
	    var d = 'disabled';
	    var $el = this.$element;
	    var val = $el.is('input') ? 'val' : 'html';
	    var data = $el.data();
	
	    state = state + 'Text';
	
	    if (data.resetText == null) $el.data('resetText', $el[val]());
	
	    setTimeout($.proxy(function () {
	      $el[val](data[state] == null ? this.options[state] : data[state]);
	
	      if (state == 'loadingText') {
	        this.isLoading = true;
	        $el.addClass(d).attr(d, d);
	      } else if (this.isLoading) {
	        this.isLoading = false;
	        $el.removeClass(d).removeAttr(d);
	      }
	    }, this), 0);
	  };
	
	  Button.prototype.toggle = function () {
	    var changed = true;
	    var $parent = this.$element.closest('[data-toggle="buttons"]');
	
	    if ($parent.length) {
	      var $input = this.$element.find('input');
	      if ($input.prop('type') == 'radio') {
	        if ($input.prop('checked') && this.$element.hasClass('active')) changed = false;else $parent.find('.active').removeClass('active');
	      }
	      if (changed) $input.prop('checked', !this.$element.hasClass('active')).trigger('change');
	    } else {
	      this.$element.attr('aria-pressed', !this.$element.hasClass('active'));
	    }
	
	    if (changed) this.$element.toggleClass('active');
	  };
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this = $(this);
	      var data = $this.data('bs.button');
	      var options = (typeof option === 'undefined' ? 'undefined' : (0, _typeof3.default)(option)) == 'object' && option;
	
	      if (!data) $this.data('bs.button', data = new Button(this, options));
	
	      if (option == 'toggle') data.toggle();else if (option) data.setState(option);
	    });
	  }
	
	  var old = $.fn.button;
	
	  $.fn.button = Plugin;
	  $.fn.button.Constructor = Button;
	
	  $.fn.button.noConflict = function () {
	    $.fn.button = old;
	    return this;
	  };
	
	  $(document).on('click.bs.button.data-api', '[data-toggle^="button"]', function (e) {
	    var $btn = $(e.target);
	    if (!$btn.hasClass('btn')) $btn = $btn.closest('.btn');
	    Plugin.call($btn, 'toggle');
	    e.preventDefault();
	  }).on('focus.bs.button.data-api blur.bs.button.data-api', '[data-toggle^="button"]', function (e) {
	    $(e.target).closest('.btn').toggleClass('focus', /^focus(in)?$/.test(e.type));
	  });
	}(jQuery);
	
	+function ($) {
	  'use strict';
	
	  var Carousel = function Carousel(element, options) {
	    this.$element = $(element);
	    this.$indicators = this.$element.find('.carousel-indicators');
	    this.options = options;
	    this.paused = null;
	    this.sliding = null;
	    this.interval = null;
	    this.$active = null;
	    this.$items = null;
	
	    this.options.keyboard && this.$element.on('keydown.bs.carousel', $.proxy(this.keydown, this));
	
	    this.options.pause == 'hover' && !('ontouchstart' in document.documentElement) && this.$element.on('mouseenter.bs.carousel', $.proxy(this.pause, this)).on('mouseleave.bs.carousel', $.proxy(this.cycle, this));
	  };
	
	  Carousel.VERSION = '3.3.4';
	
	  Carousel.TRANSITION_DURATION = 600;
	
	  Carousel.DEFAULTS = {
	    interval: 5000,
	    pause: 'hover',
	    wrap: true,
	    keyboard: true
	  };
	
	  Carousel.prototype.keydown = function (e) {
	    if (/input|textarea/i.test(e.target.tagName)) return;
	    switch (e.which) {
	      case 37:
	        this.prev();break;
	      case 39:
	        this.next();break;
	      default:
	        return;
	    }
	
	    e.preventDefault();
	  };
	
	  Carousel.prototype.cycle = function (e) {
	    e || (this.paused = false);
	
	    this.interval && clearInterval(this.interval);
	
	    this.options.interval && !this.paused && (this.interval = setInterval($.proxy(this.next, this), this.options.interval));
	
	    return this;
	  };
	
	  Carousel.prototype.getItemIndex = function (item) {
	    this.$items = item.parent().children('.item');
	    return this.$items.index(item || this.$active);
	  };
	
	  Carousel.prototype.getItemForDirection = function (direction, active) {
	    var activeIndex = this.getItemIndex(active);
	    var willWrap = direction == 'prev' && activeIndex === 0 || direction == 'next' && activeIndex == this.$items.length - 1;
	    if (willWrap && !this.options.wrap) return active;
	    var delta = direction == 'prev' ? -1 : 1;
	    var itemIndex = (activeIndex + delta) % this.$items.length;
	    return this.$items.eq(itemIndex);
	  };
	
	  Carousel.prototype.to = function (pos) {
	    var that = this;
	    var activeIndex = this.getItemIndex(this.$active = this.$element.find('.item.active'));
	
	    if (pos > this.$items.length - 1 || pos < 0) return;
	
	    if (this.sliding) return this.$element.one('slid.bs.carousel', function () {
	      that.to(pos);
	    });
	    if (activeIndex == pos) return this.pause().cycle();
	
	    return this.slide(pos > activeIndex ? 'next' : 'prev', this.$items.eq(pos));
	  };
	
	  Carousel.prototype.pause = function (e) {
	    e || (this.paused = true);
	
	    if (this.$element.find('.next, .prev').length && $.support.transition) {
	      this.$element.trigger($.support.transition.end);
	      this.cycle(true);
	    }
	
	    this.interval = clearInterval(this.interval);
	
	    return this;
	  };
	
	  Carousel.prototype.next = function () {
	    if (this.sliding) return;
	    return this.slide('next');
	  };
	
	  Carousel.prototype.prev = function () {
	    if (this.sliding) return;
	    return this.slide('prev');
	  };
	
	  Carousel.prototype.slide = function (type, next) {
	    var $active = this.$element.find('.item.active');
	    var $next = next || this.getItemForDirection(type, $active);
	    var isCycling = this.interval;
	    var direction = type == 'next' ? 'left' : 'right';
	    var that = this;
	
	    if ($next.hasClass('active')) return this.sliding = false;
	
	    var relatedTarget = $next[0];
	    var slideEvent = $.Event('slide.bs.carousel', {
	      relatedTarget: relatedTarget,
	      direction: direction
	    });
	    this.$element.trigger(slideEvent);
	    if (slideEvent.isDefaultPrevented()) return;
	
	    this.sliding = true;
	
	    isCycling && this.pause();
	
	    if (this.$indicators.length) {
	      this.$indicators.find('.active').removeClass('active');
	      var $nextIndicator = $(this.$indicators.children()[this.getItemIndex($next)]);
	      $nextIndicator && $nextIndicator.addClass('active');
	    }
	
	    var slidEvent = $.Event('slid.bs.carousel', { relatedTarget: relatedTarget, direction: direction });
	    if ($.support.transition && this.$element.hasClass('slide')) {
	      $next.addClass(type);
	      $next[0].offsetWidth;
	      $active.addClass(direction);
	      $next.addClass(direction);
	      $active.one('bsTransitionEnd', function () {
	        $next.removeClass([type, direction].join(' ')).addClass('active');
	        $active.removeClass(['active', direction].join(' '));
	        that.sliding = false;
	        setTimeout(function () {
	          that.$element.trigger(slidEvent);
	        }, 0);
	      }).emulateTransitionEnd(Carousel.TRANSITION_DURATION);
	    } else {
	      $active.removeClass('active');
	      $next.addClass('active');
	      this.sliding = false;
	      this.$element.trigger(slidEvent);
	    }
	
	    isCycling && this.cycle();
	
	    return this;
	  };
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this = $(this);
	      var data = $this.data('bs.carousel');
	      var options = $.extend({}, Carousel.DEFAULTS, $this.data(), (typeof option === 'undefined' ? 'undefined' : (0, _typeof3.default)(option)) == 'object' && option);
	      var action = typeof option == 'string' ? option : options.slide;
	
	      if (!data) $this.data('bs.carousel', data = new Carousel(this, options));
	      if (typeof option == 'number') data.to(option);else if (action) data[action]();else if (options.interval) data.pause().cycle();
	    });
	  }
	
	  var old = $.fn.carousel;
	
	  $.fn.carousel = Plugin;
	  $.fn.carousel.Constructor = Carousel;
	
	  $.fn.carousel.noConflict = function () {
	    $.fn.carousel = old;
	    return this;
	  };
	
	  var clickHandler = function clickHandler(e) {
	    var href;
	    var $this = $(this);
	    var $target = $($this.attr('data-target') || (href = $this.attr('href')) && href.replace(/.*(?=#[^\s]+$)/, ''));
	    if (!$target.hasClass('carousel')) return;
	    var options = $.extend({}, $target.data(), $this.data());
	    var slideIndex = $this.attr('data-slide-to');
	    if (slideIndex) options.interval = false;
	
	    Plugin.call($target, options);
	
	    if (slideIndex) {
	      $target.data('bs.carousel').to(slideIndex);
	    }
	
	    e.preventDefault();
	  };
	
	  $(document).on('click.bs.carousel.data-api', '[data-slide]', clickHandler).on('click.bs.carousel.data-api', '[data-slide-to]', clickHandler);
	
	  $(window).on('load', function () {
	    $('[data-ride="carousel"]').each(function () {
	      var $carousel = $(this);
	      Plugin.call($carousel, $carousel.data());
	    });
	  });
	}(jQuery);
	
	+function ($) {
	  'use strict';
	
	  var Collapse = function Collapse(element, options) {
	    this.$element = $(element);
	    this.options = $.extend({}, Collapse.DEFAULTS, options);
	    this.$trigger = $('[data-toggle="collapse"][href="#' + element.id + '"],' + '[data-toggle="collapse"][data-target="#' + element.id + '"]');
	    this.transitioning = null;
	
	    if (this.options.parent) {
	      this.$parent = this.getParent();
	    } else {
	      this.addAriaAndCollapsedClass(this.$element, this.$trigger);
	    }
	
	    if (this.options.toggle) this.toggle();
	  };
	
	  Collapse.VERSION = '3.3.4';
	
	  Collapse.TRANSITION_DURATION = 350;
	
	  Collapse.DEFAULTS = {
	    toggle: true
	  };
	
	  Collapse.prototype.dimension = function () {
	    var hasWidth = this.$element.hasClass('width');
	    return hasWidth ? 'width' : 'height';
	  };
	
	  Collapse.prototype.show = function () {
	    if (this.transitioning || this.$element.hasClass('in')) return;
	
	    var activesData;
	    var actives = this.$parent && this.$parent.children('.panel').children('.in, .collapsing');
	
	    if (actives && actives.length) {
	      activesData = actives.data('bs.collapse');
	      if (activesData && activesData.transitioning) return;
	    }
	
	    var startEvent = $.Event('show.bs.collapse');
	    this.$element.trigger(startEvent);
	    if (startEvent.isDefaultPrevented()) return;
	
	    if (actives && actives.length) {
	      Plugin.call(actives, 'hide');
	      activesData || actives.data('bs.collapse', null);
	    }
	
	    var dimension = this.dimension();
	
	    this.$element.removeClass('collapse').addClass('collapsing')[dimension](0).attr('aria-expanded', true);
	
	    this.$trigger.removeClass('collapsed').attr('aria-expanded', true);
	
	    this.transitioning = 1;
	
	    var complete = function complete() {
	      this.$element.removeClass('collapsing').addClass('collapse in')[dimension]('');
	      this.transitioning = 0;
	      this.$element.trigger('shown.bs.collapse');
	    };
	
	    if (!$.support.transition) return complete.call(this);
	
	    var scrollSize = $.camelCase(['scroll', dimension].join('-'));
	
	    this.$element.one('bsTransitionEnd', $.proxy(complete, this)).emulateTransitionEnd(Collapse.TRANSITION_DURATION)[dimension](this.$element[0][scrollSize]);
	  };
	
	  Collapse.prototype.hide = function () {
	    if (this.transitioning || !this.$element.hasClass('in')) return;
	
	    var startEvent = $.Event('hide.bs.collapse');
	    this.$element.trigger(startEvent);
	    if (startEvent.isDefaultPrevented()) return;
	
	    var dimension = this.dimension();
	
	    this.$element[dimension](this.$element[dimension]())[0].offsetHeight;
	
	    this.$element.addClass('collapsing').removeClass('collapse in').attr('aria-expanded', false);
	
	    this.$trigger.addClass('collapsed').attr('aria-expanded', false);
	
	    this.transitioning = 1;
	
	    var complete = function complete() {
	      this.transitioning = 0;
	      this.$element.removeClass('collapsing').addClass('collapse').trigger('hidden.bs.collapse');
	    };
	
	    if (!$.support.transition) return complete.call(this);
	
	    this.$element[dimension](0).one('bsTransitionEnd', $.proxy(complete, this)).emulateTransitionEnd(Collapse.TRANSITION_DURATION);
	  };
	
	  Collapse.prototype.toggle = function () {
	    this[this.$element.hasClass('in') ? 'hide' : 'show']();
	  };
	
	  Collapse.prototype.getParent = function () {
	    return $(this.options.parent).find('[data-toggle="collapse"][data-parent="' + this.options.parent + '"]').each($.proxy(function (i, element) {
	      var $element = $(element);
	      this.addAriaAndCollapsedClass(getTargetFromTrigger($element), $element);
	    }, this)).end();
	  };
	
	  Collapse.prototype.addAriaAndCollapsedClass = function ($element, $trigger) {
	    var isOpen = $element.hasClass('in');
	
	    $element.attr('aria-expanded', isOpen);
	    $trigger.toggleClass('collapsed', !isOpen).attr('aria-expanded', isOpen);
	  };
	
	  function getTargetFromTrigger($trigger) {
	    var href;
	    var target = $trigger.attr('data-target') || (href = $trigger.attr('href')) && href.replace(/.*(?=#[^\s]+$)/, '');
	
	    return $(target);
	  }
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this = $(this);
	      var data = $this.data('bs.collapse');
	      var options = $.extend({}, Collapse.DEFAULTS, $this.data(), (typeof option === 'undefined' ? 'undefined' : (0, _typeof3.default)(option)) == 'object' && option);
	
	      if (!data && options.toggle && /show|hide/.test(option)) options.toggle = false;
	      if (!data) $this.data('bs.collapse', data = new Collapse(this, options));
	      if (typeof option == 'string') data[option]();
	    });
	  }
	
	  var old = $.fn.collapse;
	
	  $.fn.collapse = Plugin;
	  $.fn.collapse.Constructor = Collapse;
	
	  $.fn.collapse.noConflict = function () {
	    $.fn.collapse = old;
	    return this;
	  };
	
	  $(document).on('click.bs.collapse.data-api', '[data-toggle="collapse"]', function (e) {
	    var $this = $(this);
	
	    if (!$this.attr('data-target')) e.preventDefault();
	
	    var $target = getTargetFromTrigger($this);
	    var data = $target.data('bs.collapse');
	    var option = data ? 'toggle' : $this.data();
	
	    Plugin.call($target, option);
	  });
	}(jQuery);
	
	+function ($) {
	  'use strict';
	
	  var backdrop = '.dropdown-backdrop';
	  var toggle = '[data-toggle="dropdown"]';
	  var Dropdown = function Dropdown(element) {
	    $(element).on('click.bs.dropdown', this.toggle);
	  };
	
	  Dropdown.VERSION = '3.3.4';
	
	  Dropdown.prototype.toggle = function (e) {
	    var $this = $(this);
	
	    if ($this.is('.disabled, :disabled')) return;
	
	    var $parent = getParent($this);
	    var isActive = $parent.hasClass('open');
	
	    clearMenus();
	
	    if (!isActive) {
	      if ('ontouchstart' in document.documentElement && !$parent.closest('.navbar-nav').length) {
	        $('<div class="dropdown-backdrop"/>').insertAfter($(this)).on('click', clearMenus);
	      }
	
	      var relatedTarget = { relatedTarget: this };
	      $parent.trigger(e = $.Event('show.bs.dropdown', relatedTarget));
	
	      if (e.isDefaultPrevented()) return;
	
	      $this.trigger('focus').attr('aria-expanded', 'true');
	
	      $parent.toggleClass('open').trigger('shown.bs.dropdown', relatedTarget);
	    }
	
	    return false;
	  };
	
	  Dropdown.prototype.keydown = function (e) {
	    if (!/(38|40|27|32)/.test(e.which) || /input|textarea/i.test(e.target.tagName)) return;
	
	    var $this = $(this);
	
	    e.preventDefault();
	    e.stopPropagation();
	
	    if ($this.is('.disabled, :disabled')) return;
	
	    var $parent = getParent($this);
	    var isActive = $parent.hasClass('open');
	
	    if (!isActive && e.which != 27 || isActive && e.which == 27) {
	      if (e.which == 27) $parent.find(toggle).trigger('focus');
	      return $this.trigger('click');
	    }
	
	    var desc = ' li:not(.disabled):visible a';
	    var $items = $parent.find('[role="menu"]' + desc + ', [role="listbox"]' + desc);
	
	    if (!$items.length) return;
	
	    var index = $items.index(e.target);
	
	    if (e.which == 38 && index > 0) index--;
	    if (e.which == 40 && index < $items.length - 1) index++;
	    if (!~index) index = 0;
	
	    $items.eq(index).trigger('focus');
	  };
	
	  function clearMenus(e) {
	    if (e && e.which === 3) return;
	    $(backdrop).remove();
	    $(toggle).each(function () {
	      var $this = $(this);
	      var $parent = getParent($this);
	      var relatedTarget = { relatedTarget: this };
	
	      if (!$parent.hasClass('open')) return;
	
	      $parent.trigger(e = $.Event('hide.bs.dropdown', relatedTarget));
	
	      if (e.isDefaultPrevented()) return;
	
	      $this.attr('aria-expanded', 'false');
	      $parent.removeClass('open').trigger('hidden.bs.dropdown', relatedTarget);
	    });
	  }
	
	  function getParent($this) {
	    var selector = $this.attr('data-target');
	
	    if (!selector) {
	      selector = $this.attr('href');
	      selector = selector && /#[A-Za-z]/.test(selector) && selector.replace(/.*(?=#[^\s]*$)/, '');
	    }
	
	    var $parent = selector && $(selector);
	
	    return $parent && $parent.length ? $parent : $this.parent();
	  }
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this = $(this);
	      var data = $this.data('bs.dropdown');
	
	      if (!data) $this.data('bs.dropdown', data = new Dropdown(this));
	      if (typeof option == 'string') data[option].call($this);
	    });
	  }
	
	  var old = $.fn.dropdown;
	
	  $.fn.dropdown = Plugin;
	  $.fn.dropdown.Constructor = Dropdown;
	
	  $.fn.dropdown.noConflict = function () {
	    $.fn.dropdown = old;
	    return this;
	  };
	
	  $(document).on('click.bs.dropdown.data-api', clearMenus).on('click.bs.dropdown.data-api', '.dropdown form', function (e) {
	    e.stopPropagation();
	  }).on('click.bs.dropdown.data-api', toggle, Dropdown.prototype.toggle).on('keydown.bs.dropdown.data-api', toggle, Dropdown.prototype.keydown).on('keydown.bs.dropdown.data-api', '[role="menu"]', Dropdown.prototype.keydown).on('keydown.bs.dropdown.data-api', '[role="listbox"]', Dropdown.prototype.keydown);
	}(jQuery);
	
	+function ($) {
	  'use strict';
	
	  var Modal = function Modal(element, options) {
	    this.options = options;
	    this.$body = $(document.body);
	    this.$element = $(element);
	    this.$dialog = this.$element.find('.modal-dialog');
	    this.$backdrop = null;
	    this.isShown = null;
	    this.originalBodyPad = null;
	    this.scrollbarWidth = 0;
	    this.ignoreBackdropClick = false;
	
	    if (this.options.remote) {
	      this.$element.find('.modal-content').load(this.options.remote, $.proxy(function () {
	        this.$element.trigger('loaded.bs.modal');
	      }, this));
	    }
	  };
	
	  Modal.VERSION = '3.3.4';
	
	  Modal.TRANSITION_DURATION = 300;
	  Modal.BACKDROP_TRANSITION_DURATION = 150;
	
	  Modal.DEFAULTS = {
	    backdrop: true,
	    keyboard: true,
	    show: true
	  };
	
	  Modal.prototype.toggle = function (_relatedTarget) {
	    return this.isShown ? this.hide() : this.show(_relatedTarget);
	  };
	
	  Modal.prototype.show = function (_relatedTarget) {
	    var that = this;
	    var e = $.Event('show.bs.modal', { relatedTarget: _relatedTarget });
	
	    this.$element.trigger(e);
	
	    if (this.isShown || e.isDefaultPrevented()) return;
	
	    this.isShown = true;
	
	    this.checkScrollbar();
	    this.setScrollbar();
	    this.$body.addClass('modal-open');
	
	    this.escape();
	    this.resize();
	
	    this.$element.on('click.dismiss.bs.modal', '[data-dismiss="modal"]', $.proxy(this.hide, this));
	
	    this.$dialog.on('mousedown.dismiss.bs.modal', function () {
	      that.$element.one('mouseup.dismiss.bs.modal', function (e) {
	        if ($(e.target).is(that.$element)) that.ignoreBackdropClick = true;
	      });
	    });
	
	    this.backdrop(function () {
	      var transition = $.support.transition && that.$element.hasClass('fade');
	
	      if (!that.$element.parent().length) {
	        that.$element.appendTo(that.$body);
	      }
	
	      that.$element.show().scrollTop(0);
	
	      that.adjustDialog();
	
	      if (transition) {
	        that.$element[0].offsetWidth;
	      }
	
	      that.$element.addClass('in').attr('aria-hidden', false);
	
	      that.enforceFocus();
	
	      var e = $.Event('shown.bs.modal', { relatedTarget: _relatedTarget });
	
	      transition ? that.$dialog.one('bsTransitionEnd', function () {
	        that.$element.trigger('focus').trigger(e);
	      }).emulateTransitionEnd(Modal.TRANSITION_DURATION) : that.$element.trigger('focus').trigger(e);
	    });
	  };
	
	  Modal.prototype.hide = function (e) {
	    if (e) e.preventDefault();
	
	    e = $.Event('hide.bs.modal');
	
	    this.$element.trigger(e);
	
	    if (!this.isShown || e.isDefaultPrevented()) return;
	
	    this.isShown = false;
	
	    this.escape();
	    this.resize();
	
	    $(document).off('focusin.bs.modal');
	
	    this.$element.removeClass('in').attr('aria-hidden', true).off('click.dismiss.bs.modal').off('mouseup.dismiss.bs.modal');
	
	    this.$dialog.off('mousedown.dismiss.bs.modal');
	
	    $.support.transition && this.$element.hasClass('fade') ? this.$element.one('bsTransitionEnd', $.proxy(this.hideModal, this)).emulateTransitionEnd(Modal.TRANSITION_DURATION) : this.hideModal();
	  };
	
	  Modal.prototype.enforceFocus = function () {
	    $(document).off('focusin.bs.modal').on('focusin.bs.modal', $.proxy(function (e) {
	      if (this.$element[0] !== e.target && !this.$element.has(e.target).length) {
	        this.$element.trigger('focus');
	      }
	    }, this));
	  };
	
	  Modal.prototype.escape = function () {
	    if (this.isShown && this.options.keyboard) {
	      this.$element.on('keydown.dismiss.bs.modal', $.proxy(function (e) {
	        e.which == 27 && this.hide();
	      }, this));
	    } else if (!this.isShown) {
	      this.$element.off('keydown.dismiss.bs.modal');
	    }
	  };
	
	  Modal.prototype.resize = function () {
	    if (this.isShown) {
	      $(window).on('resize.bs.modal', $.proxy(this.handleUpdate, this));
	    } else {
	      $(window).off('resize.bs.modal');
	    }
	  };
	
	  Modal.prototype.hideModal = function () {
	    var that = this;
	    this.$element.hide();
	    this.backdrop(function () {
	      that.$body.removeClass('modal-open');
	      that.resetAdjustments();
	      that.resetScrollbar();
	      that.$element.trigger('hidden.bs.modal');
	    });
	  };
	
	  Modal.prototype.removeBackdrop = function () {
	    this.$backdrop && this.$backdrop.remove();
	    this.$backdrop = null;
	  };
	
	  Modal.prototype.backdrop = function (callback) {
	    var that = this;
	    var animate = this.$element.hasClass('fade') ? 'fade' : '';
	
	    if (this.isShown && this.options.backdrop) {
	      var doAnimate = $.support.transition && animate;
	
	      this.$backdrop = $('<div class="modal-backdrop ' + animate + '" />').appendTo(this.$body);
	
	      this.$element.on('click.dismiss.bs.modal', $.proxy(function (e) {
	        if (this.ignoreBackdropClick) {
	          this.ignoreBackdropClick = false;
	          return;
	        }
	        if (e.target !== e.currentTarget) return;
	        this.options.backdrop == 'static' ? this.$element[0].focus() : this.hide();
	      }, this));
	
	      if (doAnimate) this.$backdrop[0].offsetWidth;
	
	      this.$backdrop.addClass('in');
	
	      if (!callback) return;
	
	      doAnimate ? this.$backdrop.one('bsTransitionEnd', callback).emulateTransitionEnd(Modal.BACKDROP_TRANSITION_DURATION) : callback();
	    } else if (!this.isShown && this.$backdrop) {
	      this.$backdrop.removeClass('in');
	
	      var callbackRemove = function callbackRemove() {
	        that.removeBackdrop();
	        callback && callback();
	      };
	      $.support.transition && this.$element.hasClass('fade') ? this.$backdrop.one('bsTransitionEnd', callbackRemove).emulateTransitionEnd(Modal.BACKDROP_TRANSITION_DURATION) : callbackRemove();
	    } else if (callback) {
	      callback();
	    }
	  };
	
	  Modal.prototype.handleUpdate = function () {
	    this.adjustDialog();
	  };
	
	  Modal.prototype.adjustDialog = function () {
	    var modalIsOverflowing = this.$element[0].scrollHeight > document.documentElement.clientHeight;
	
	    this.$element.css({
	      paddingLeft: !this.bodyIsOverflowing && modalIsOverflowing ? this.scrollbarWidth : '',
	      paddingRight: this.bodyIsOverflowing && !modalIsOverflowing ? this.scrollbarWidth : ''
	    });
	  };
	
	  Modal.prototype.resetAdjustments = function () {
	    this.$element.css({
	      paddingLeft: '',
	      paddingRight: ''
	    });
	  };
	
	  Modal.prototype.checkScrollbar = function () {
	    var fullWindowWidth = window.innerWidth;
	    if (!fullWindowWidth) {
	      var documentElementRect = document.documentElement.getBoundingClientRect();
	      fullWindowWidth = documentElementRect.right - Math.abs(documentElementRect.left);
	    }
	    this.bodyIsOverflowing = document.body.clientWidth < fullWindowWidth;
	    this.scrollbarWidth = this.measureScrollbar();
	  };
	
	  Modal.prototype.setScrollbar = function () {
	    var bodyPad = parseInt(this.$body.css('padding-right') || 0, 10);
	    this.originalBodyPad = document.body.style.paddingRight || '';
	    if (this.bodyIsOverflowing) this.$body.css('padding-right', bodyPad + this.scrollbarWidth);
	  };
	
	  Modal.prototype.resetScrollbar = function () {
	    this.$body.css('padding-right', this.originalBodyPad);
	  };
	
	  Modal.prototype.measureScrollbar = function () {
	    var scrollDiv = document.createElement('div');
	    scrollDiv.className = 'modal-scrollbar-measure';
	    this.$body.append(scrollDiv);
	    var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
	    this.$body[0].removeChild(scrollDiv);
	    return scrollbarWidth;
	  };
	
	  function Plugin(option, _relatedTarget) {
	    return this.each(function () {
	      var $this = $(this);
	      var data = $this.data('bs.modal');
	      var options = $.extend({}, Modal.DEFAULTS, $this.data(), (typeof option === 'undefined' ? 'undefined' : (0, _typeof3.default)(option)) == 'object' && option);
	
	      if (!data) $this.data('bs.modal', data = new Modal(this, options));
	      if (typeof option == 'string') data[option](_relatedTarget);else if (options.show) data.show(_relatedTarget);
	    });
	  }
	
	  var old = $.fn.modal;
	
	  $.fn.modal = Plugin;
	  $.fn.modal.Constructor = Modal;
	
	  $.fn.modal.noConflict = function () {
	    $.fn.modal = old;
	    return this;
	  };
	
	  $(document).on('click.bs.modal.data-api', '[data-toggle="modal"]', function (e) {
	    var $this = $(this);
	    var href = $this.attr('href');
	    var $target = $($this.attr('data-target') || href && href.replace(/.*(?=#[^\s]+$)/, ''));
	    var option = $target.data('bs.modal') ? 'toggle' : $.extend({ remote: !/#/.test(href) && href }, $target.data(), $this.data());
	
	    if ($this.is('a')) e.preventDefault();
	
	    $target.one('show.bs.modal', function (showEvent) {
	      if (showEvent.isDefaultPrevented()) return;
	      $target.one('hidden.bs.modal', function () {
	        $this.is(':visible') && $this.trigger('focus');
	      });
	    });
	    Plugin.call($target, option, this);
	  });
	}(jQuery);
	
	+function ($) {
	  'use strict';
	
	  var Tooltip = function Tooltip(element, options) {
	    this.type = null;
	    this.options = null;
	    this.enabled = null;
	    this.timeout = null;
	    this.hoverState = null;
	    this.$element = null;
	
	    this.init('tooltip', element, options);
	  };
	
	  Tooltip.VERSION = '3.3.4';
	
	  Tooltip.TRANSITION_DURATION = 150;
	
	  Tooltip.DEFAULTS = {
	    animation: true,
	    placement: 'top',
	    selector: false,
	    template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
	    trigger: 'hover focus',
	    title: '',
	    delay: 0,
	    html: false,
	    container: false,
	    viewport: {
	      selector: 'body',
	      padding: 0
	    }
	  };
	
	  Tooltip.prototype.init = function (type, element, options) {
	    this.enabled = true;
	    this.type = type;
	    this.$element = $(element);
	    this.options = this.getOptions(options);
	    this.$viewport = this.options.viewport && $(this.options.viewport.selector || this.options.viewport);
	
	    if (this.$element[0] instanceof document.constructor && !this.options.selector) {
	      throw new Error('`selector` option must be specified when initializing ' + this.type + ' on the window.document object!');
	    }
	
	    var triggers = this.options.trigger.split(' ');
	
	    for (var i = triggers.length; i--;) {
	      var trigger = triggers[i];
	
	      if (trigger == 'click') {
	        this.$element.on('click.' + this.type, this.options.selector, $.proxy(this.toggle, this));
	      } else if (trigger != 'manual') {
	        var eventIn = trigger == 'hover' ? 'mouseenter' : 'focusin';
	        var eventOut = trigger == 'hover' ? 'mouseleave' : 'focusout';
	
	        this.$element.on(eventIn + '.' + this.type, this.options.selector, $.proxy(this.enter, this));
	        this.$element.on(eventOut + '.' + this.type, this.options.selector, $.proxy(this.leave, this));
	      }
	    }
	
	    this.options.selector ? this._options = $.extend({}, this.options, { trigger: 'manual', selector: '' }) : this.fixTitle();
	  };
	
	  Tooltip.prototype.getDefaults = function () {
	    return Tooltip.DEFAULTS;
	  };
	
	  Tooltip.prototype.getOptions = function (options) {
	    options = $.extend({}, this.getDefaults(), this.$element.data(), options);
	
	    if (options.delay && typeof options.delay == 'number') {
	      options.delay = {
	        show: options.delay,
	        hide: options.delay
	      };
	    }
	
	    return options;
	  };
	
	  Tooltip.prototype.getDelegateOptions = function () {
	    var options = {};
	    var defaults = this.getDefaults();
	
	    this._options && $.each(this._options, function (key, value) {
	      if (defaults[key] != value) options[key] = value;
	    });
	
	    return options;
	  };
	
	  Tooltip.prototype.enter = function (obj) {
	    var self = obj instanceof this.constructor ? obj : $(obj.currentTarget).data('bs.' + this.type);
	
	    if (self && self.$tip && self.$tip.is(':visible')) {
	      self.hoverState = 'in';
	      return;
	    }
	
	    if (!self) {
	      self = new this.constructor(obj.currentTarget, this.getDelegateOptions());
	      $(obj.currentTarget).data('bs.' + this.type, self);
	    }
	
	    clearTimeout(self.timeout);
	
	    self.hoverState = 'in';
	
	    if (!self.options.delay || !self.options.delay.show) return self.show();
	
	    self.timeout = setTimeout(function () {
	      if (self.hoverState == 'in') self.show();
	    }, self.options.delay.show);
	  };
	
	  Tooltip.prototype.leave = function (obj) {
	    var self = obj instanceof this.constructor ? obj : $(obj.currentTarget).data('bs.' + this.type);
	
	    if (!self) {
	      self = new this.constructor(obj.currentTarget, this.getDelegateOptions());
	      $(obj.currentTarget).data('bs.' + this.type, self);
	    }
	
	    clearTimeout(self.timeout);
	
	    self.hoverState = 'out';
	
	    if (!self.options.delay || !self.options.delay.hide) return self.hide();
	
	    self.timeout = setTimeout(function () {
	      if (self.hoverState == 'out') self.hide();
	    }, self.options.delay.hide);
	  };
	
	  Tooltip.prototype.show = function () {
	    var e = $.Event('show.bs.' + this.type);
	
	    if (this.hasContent() && this.enabled) {
	      this.$element.trigger(e);
	
	      var inDom = $.contains(this.$element[0].ownerDocument.documentElement, this.$element[0]);
	      if (e.isDefaultPrevented() || !inDom) return;
	      var that = this;
	
	      var $tip = this.tip();
	
	      var tipId = this.getUID(this.type);
	
	      this.setContent();
	      $tip.attr('id', tipId);
	      this.$element.attr('aria-describedby', tipId);
	
	      if (this.options.animation) $tip.addClass('fade');
	
	      var placement = typeof this.options.placement == 'function' ? this.options.placement.call(this, $tip[0], this.$element[0]) : this.options.placement;
	
	      var autoToken = /\s?auto?\s?/i;
	      var autoPlace = autoToken.test(placement);
	      if (autoPlace) placement = placement.replace(autoToken, '') || 'top';
	
	      $tip.detach().css({ top: 0, left: 0, display: 'block' }).addClass(placement).data('bs.' + this.type, this);
	
	      this.options.container ? $tip.appendTo(this.options.container) : $tip.insertAfter(this.$element);
	
	      var pos = this.getPosition();
	      var actualWidth = $tip[0].offsetWidth;
	      var actualHeight = $tip[0].offsetHeight;
	
	      if (autoPlace) {
	        var orgPlacement = placement;
	        var $container = this.options.container ? $(this.options.container) : this.$element.parent();
	        var containerDim = this.getPosition($container);
	
	        placement = placement == 'bottom' && pos.bottom + actualHeight > containerDim.bottom ? 'top' : placement == 'top' && pos.top - actualHeight < containerDim.top ? 'bottom' : placement == 'right' && pos.right + actualWidth > containerDim.width ? 'left' : placement == 'left' && pos.left - actualWidth < containerDim.left ? 'right' : placement;
	
	        $tip.removeClass(orgPlacement).addClass(placement);
	      }
	
	      var calculatedOffset = this.getCalculatedOffset(placement, pos, actualWidth, actualHeight);
	
	      this.applyPlacement(calculatedOffset, placement);
	
	      var complete = function complete() {
	        var prevHoverState = that.hoverState;
	        that.$element.trigger('shown.bs.' + that.type);
	        that.hoverState = null;
	
	        if (prevHoverState == 'out') that.leave(that);
	      };
	
	      $.support.transition && this.$tip.hasClass('fade') ? $tip.one('bsTransitionEnd', complete).emulateTransitionEnd(Tooltip.TRANSITION_DURATION) : complete();
	    }
	  };
	
	  Tooltip.prototype.applyPlacement = function (offset, placement) {
	    var $tip = this.tip();
	    var width = $tip[0].offsetWidth;
	    var height = $tip[0].offsetHeight;
	
	    var marginTop = parseInt($tip.css('margin-top'), 10);
	    var marginLeft = parseInt($tip.css('margin-left'), 10);
	
	    if (isNaN(marginTop)) marginTop = 0;
	    if (isNaN(marginLeft)) marginLeft = 0;
	
	    offset.top = offset.top + marginTop;
	    offset.left = offset.left + marginLeft;
	
	    $.offset.setOffset($tip[0], $.extend({
	      using: function using(props) {
	        $tip.css({
	          top: Math.round(props.top),
	          left: Math.round(props.left)
	        });
	      }
	    }, offset), 0);
	
	    $tip.addClass('in');
	
	    var actualWidth = $tip[0].offsetWidth;
	    var actualHeight = $tip[0].offsetHeight;
	
	    if (placement == 'top' && actualHeight != height) {
	      offset.top = offset.top + height - actualHeight;
	    }
	
	    var delta = this.getViewportAdjustedDelta(placement, offset, actualWidth, actualHeight);
	
	    if (delta.left) offset.left += delta.left;else offset.top += delta.top;
	
	    var isVertical = /top|bottom/.test(placement);
	    var arrowDelta = isVertical ? delta.left * 2 - width + actualWidth : delta.top * 2 - height + actualHeight;
	    var arrowOffsetPosition = isVertical ? 'offsetWidth' : 'offsetHeight';
	
	    $tip.offset(offset);
	    this.replaceArrow(arrowDelta, $tip[0][arrowOffsetPosition], isVertical);
	  };
	
	  Tooltip.prototype.replaceArrow = function (delta, dimension, isVertical) {
	    this.arrow().css(isVertical ? 'left' : 'top', 50 * (1 - delta / dimension) + '%').css(isVertical ? 'top' : 'left', '');
	  };
	
	  Tooltip.prototype.setContent = function () {
	    var $tip = this.tip();
	    var title = this.getTitle();
	
	    $tip.find('.tooltip-inner')[this.options.html ? 'html' : 'text'](title);
	    $tip.removeClass('fade in top bottom left right');
	  };
	
	  Tooltip.prototype.hide = function (callback) {
	    var that = this;
	    var $tip = $(this.$tip);
	    var e = $.Event('hide.bs.' + this.type);
	
	    function complete() {
	      if (that.hoverState != 'in') $tip.detach();
	      that.$element.removeAttr('aria-describedby').trigger('hidden.bs.' + that.type);
	      callback && callback();
	    }
	
	    this.$element.trigger(e);
	
	    if (e.isDefaultPrevented()) return;
	
	    $tip.removeClass('in');
	
	    $.support.transition && $tip.hasClass('fade') ? $tip.one('bsTransitionEnd', complete).emulateTransitionEnd(Tooltip.TRANSITION_DURATION) : complete();
	
	    this.hoverState = null;
	
	    return this;
	  };
	
	  Tooltip.prototype.fixTitle = function () {
	    var $e = this.$element;
	    if ($e.attr('title') || typeof $e.attr('data-original-title') != 'string') {
	      $e.attr('data-original-title', $e.attr('title') || '').attr('title', '');
	    }
	  };
	
	  Tooltip.prototype.hasContent = function () {
	    return this.getTitle();
	  };
	
	  Tooltip.prototype.getPosition = function ($element) {
	    $element = $element || this.$element;
	
	    var el = $element[0];
	    var isBody = el.tagName == 'BODY';
	
	    var elRect = el.getBoundingClientRect();
	    if (elRect.width == null) {
	      elRect = $.extend({}, elRect, { width: elRect.right - elRect.left, height: elRect.bottom - elRect.top });
	    }
	    var elOffset = isBody ? { top: 0, left: 0 } : $element.offset();
	    var scroll = { scroll: isBody ? document.documentElement.scrollTop || document.body.scrollTop : $element.scrollTop() };
	    var outerDims = isBody ? { width: $(window).width(), height: $(window).height() } : null;
	
	    return $.extend({}, elRect, scroll, outerDims, elOffset);
	  };
	
	  Tooltip.prototype.getCalculatedOffset = function (placement, pos, actualWidth, actualHeight) {
	    return placement == 'bottom' ? { top: pos.top + pos.height, left: pos.left + pos.width / 2 - actualWidth / 2 } : placement == 'top' ? { top: pos.top - actualHeight, left: pos.left + pos.width / 2 - actualWidth / 2 } : placement == 'left' ? { top: pos.top + pos.height / 2 - actualHeight / 2, left: pos.left - actualWidth } : { top: pos.top + pos.height / 2 - actualHeight / 2, left: pos.left + pos.width };
	  };
	
	  Tooltip.prototype.getViewportAdjustedDelta = function (placement, pos, actualWidth, actualHeight) {
	    var delta = { top: 0, left: 0 };
	    if (!this.$viewport) return delta;
	
	    var viewportPadding = this.options.viewport && this.options.viewport.padding || 0;
	    var viewportDimensions = this.getPosition(this.$viewport);
	
	    if (/right|left/.test(placement)) {
	      var topEdgeOffset = pos.top - viewportPadding - viewportDimensions.scroll;
	      var bottomEdgeOffset = pos.top + viewportPadding - viewportDimensions.scroll + actualHeight;
	      if (topEdgeOffset < viewportDimensions.top) {
	        delta.top = viewportDimensions.top - topEdgeOffset;
	      } else if (bottomEdgeOffset > viewportDimensions.top + viewportDimensions.height) {
	        delta.top = viewportDimensions.top + viewportDimensions.height - bottomEdgeOffset;
	      }
	    } else {
	      var leftEdgeOffset = pos.left - viewportPadding;
	      var rightEdgeOffset = pos.left + viewportPadding + actualWidth;
	      if (leftEdgeOffset < viewportDimensions.left) {
	        delta.left = viewportDimensions.left - leftEdgeOffset;
	      } else if (rightEdgeOffset > viewportDimensions.width) {
	        delta.left = viewportDimensions.left + viewportDimensions.width - rightEdgeOffset;
	      }
	    }
	
	    return delta;
	  };
	
	  Tooltip.prototype.getTitle = function () {
	    var title;
	    var $e = this.$element;
	    var o = this.options;
	
	    title = $e.attr('data-original-title') || (typeof o.title == 'function' ? o.title.call($e[0]) : o.title);
	
	    return title;
	  };
	
	  Tooltip.prototype.getUID = function (prefix) {
	    do {
	      prefix += ~~(Math.random() * 1000000);
	    } while (document.getElementById(prefix));
	    return prefix;
	  };
	
	  Tooltip.prototype.tip = function () {
	    return this.$tip = this.$tip || $(this.options.template);
	  };
	
	  Tooltip.prototype.arrow = function () {
	    return this.$arrow = this.$arrow || this.tip().find('.tooltip-arrow');
	  };
	
	  Tooltip.prototype.enable = function () {
	    this.enabled = true;
	  };
	
	  Tooltip.prototype.disable = function () {
	    this.enabled = false;
	  };
	
	  Tooltip.prototype.toggleEnabled = function () {
	    this.enabled = !this.enabled;
	  };
	
	  Tooltip.prototype.toggle = function (e) {
	    var self = this;
	    if (e) {
	      self = $(e.currentTarget).data('bs.' + this.type);
	      if (!self) {
	        self = new this.constructor(e.currentTarget, this.getDelegateOptions());
	        $(e.currentTarget).data('bs.' + this.type, self);
	      }
	    }
	
	    self.tip().hasClass('in') ? self.leave(self) : self.enter(self);
	  };
	
	  Tooltip.prototype.destroy = function () {
	    var that = this;
	    clearTimeout(this.timeout);
	    this.hide(function () {
	      that.$element.off('.' + that.type).removeData('bs.' + that.type);
	    });
	  };
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this = $(this);
	      var data = $this.data('bs.tooltip');
	      var options = (typeof option === 'undefined' ? 'undefined' : (0, _typeof3.default)(option)) == 'object' && option;
	
	      if (!data && /destroy|hide/.test(option)) return;
	      if (!data) $this.data('bs.tooltip', data = new Tooltip(this, options));
	      if (typeof option == 'string') data[option]();
	    });
	  }
	
	  var old = $.fn.tooltip;
	
	  $.fn.tooltip = Plugin;
	  $.fn.tooltip.Constructor = Tooltip;
	
	  $.fn.tooltip.noConflict = function () {
	    $.fn.tooltip = old;
	    return this;
	  };
	}(jQuery);
	
	+function ($) {
	  'use strict';
	
	  var Popover = function Popover(element, options) {
	    this.init('popover', element, options);
	  };
	
	  if (!$.fn.tooltip) throw new Error('Popover requires tooltip.js');
	
	  Popover.VERSION = '3.3.4';
	
	  Popover.DEFAULTS = $.extend({}, $.fn.tooltip.Constructor.DEFAULTS, {
	    placement: 'right',
	    trigger: 'click',
	    content: '',
	    template: '<div class="popover" role="tooltip"><div class="arrow"></div><h3 class="popover-title"></h3><div class="popover-content"></div></div>'
	  });
	
	  Popover.prototype = $.extend({}, $.fn.tooltip.Constructor.prototype);
	
	  Popover.prototype.constructor = Popover;
	
	  Popover.prototype.getDefaults = function () {
	    return Popover.DEFAULTS;
	  };
	
	  Popover.prototype.setContent = function () {
	    var $tip = this.tip();
	    var title = this.getTitle();
	    var content = this.getContent();
	
	    $tip.find('.popover-title')[this.options.html ? 'html' : 'text'](title);
	    $tip.find('.popover-content').children().detach().end()[this.options.html ? typeof content == 'string' ? 'html' : 'append' : 'text'](content);
	
	    $tip.removeClass('fade top bottom left right in');
	
	    if (!$tip.find('.popover-title').html()) $tip.find('.popover-title').hide();
	  };
	
	  Popover.prototype.hasContent = function () {
	    return this.getTitle() || this.getContent();
	  };
	
	  Popover.prototype.getContent = function () {
	    var $e = this.$element;
	    var o = this.options;
	
	    return $e.attr('data-content') || (typeof o.content == 'function' ? o.content.call($e[0]) : o.content);
	  };
	
	  Popover.prototype.arrow = function () {
	    return this.$arrow = this.$arrow || this.tip().find('.arrow');
	  };
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this = $(this);
	      var data = $this.data('bs.popover');
	      var options = (typeof option === 'undefined' ? 'undefined' : (0, _typeof3.default)(option)) == 'object' && option;
	
	      if (!data && /destroy|hide/.test(option)) return;
	      if (!data) $this.data('bs.popover', data = new Popover(this, options));
	      if (typeof option == 'string') data[option]();
	    });
	  }
	
	  var old = $.fn.popover;
	
	  $.fn.popover = Plugin;
	  $.fn.popover.Constructor = Popover;
	
	  $.fn.popover.noConflict = function () {
	    $.fn.popover = old;
	    return this;
	  };
	}(jQuery);
	
	+function ($) {
	  'use strict';
	
	  function ScrollSpy(element, options) {
	    this.$body = $(document.body);
	    this.$scrollElement = $(element).is(document.body) ? $(window) : $(element);
	    this.options = $.extend({}, ScrollSpy.DEFAULTS, options);
	    this.selector = (this.options.target || '') + ' .nav li > a';
	    this.offsets = [];
	    this.targets = [];
	    this.activeTarget = null;
	    this.scrollHeight = 0;
	
	    this.$scrollElement.on('scroll.bs.scrollspy', $.proxy(this.process, this));
	    this.refresh();
	    this.process();
	  }
	
	  ScrollSpy.VERSION = '3.3.4';
	
	  ScrollSpy.DEFAULTS = {
	    offset: 10
	  };
	
	  ScrollSpy.prototype.getScrollHeight = function () {
	    return this.$scrollElement[0].scrollHeight || Math.max(this.$body[0].scrollHeight, document.documentElement.scrollHeight);
	  };
	
	  ScrollSpy.prototype.refresh = function () {
	    var that = this;
	    var offsetMethod = 'offset';
	    var offsetBase = 0;
	
	    this.offsets = [];
	    this.targets = [];
	    this.scrollHeight = this.getScrollHeight();
	
	    if (!$.isWindow(this.$scrollElement[0])) {
	      offsetMethod = 'position';
	      offsetBase = this.$scrollElement.scrollTop();
	    }
	
	    this.$body.find(this.selector).map(function () {
	      var $el = $(this);
	      var href = $el.data('target') || $el.attr('href');
	      var $href = /^#./.test(href) && $(href);
	
	      return $href && $href.length && $href.is(':visible') && [[$href[offsetMethod]().top + offsetBase, href]] || null;
	    }).sort(function (a, b) {
	      return a[0] - b[0];
	    }).each(function () {
	      that.offsets.push(this[0]);
	      that.targets.push(this[1]);
	    });
	  };
	
	  ScrollSpy.prototype.process = function () {
	    var scrollTop = this.$scrollElement.scrollTop() + this.options.offset;
	    var scrollHeight = this.getScrollHeight();
	    var maxScroll = this.options.offset + scrollHeight - this.$scrollElement.height();
	    var offsets = this.offsets;
	    var targets = this.targets;
	    var activeTarget = this.activeTarget;
	    var i;
	
	    if (this.scrollHeight != scrollHeight) {
	      this.refresh();
	    }
	
	    if (scrollTop >= maxScroll) {
	      return activeTarget != (i = targets[targets.length - 1]) && this.activate(i);
	    }
	
	    if (activeTarget && scrollTop < offsets[0]) {
	      this.activeTarget = null;
	      return this.clear();
	    }
	
	    for (i = offsets.length; i--;) {
	      activeTarget != targets[i] && scrollTop >= offsets[i] && (offsets[i + 1] === undefined || scrollTop < offsets[i + 1]) && this.activate(targets[i]);
	    }
	  };
	
	  ScrollSpy.prototype.activate = function (target) {
	    this.activeTarget = target;
	
	    this.clear();
	
	    var selector = this.selector + '[data-target="' + target + '"],' + this.selector + '[href="' + target + '"]';
	
	    var active = $(selector).parents('li').addClass('active');
	
	    if (active.parent('.dropdown-menu').length) {
	      active = active.closest('li.dropdown').addClass('active');
	    }
	
	    active.trigger('activate.bs.scrollspy');
	  };
	
	  ScrollSpy.prototype.clear = function () {
	    $(this.selector).parentsUntil(this.options.target, '.active').removeClass('active');
	  };
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this = $(this);
	      var data = $this.data('bs.scrollspy');
	      var options = (typeof option === 'undefined' ? 'undefined' : (0, _typeof3.default)(option)) == 'object' && option;
	
	      if (!data) $this.data('bs.scrollspy', data = new ScrollSpy(this, options));
	      if (typeof option == 'string') data[option]();
	    });
	  }
	
	  var old = $.fn.scrollspy;
	
	  $.fn.scrollspy = Plugin;
	  $.fn.scrollspy.Constructor = ScrollSpy;
	
	  $.fn.scrollspy.noConflict = function () {
	    $.fn.scrollspy = old;
	    return this;
	  };
	
	  $(window).on('load.bs.scrollspy.data-api', function () {
	    $('[data-spy="scroll"]').each(function () {
	      var $spy = $(this);
	      Plugin.call($spy, $spy.data());
	    });
	  });
	}(jQuery);
	
	+function ($) {
	  'use strict';
	
	  var Tab = function Tab(element) {
	    this.element = $(element);
	  };
	
	  Tab.VERSION = '3.3.4';
	
	  Tab.TRANSITION_DURATION = 150;
	
	  Tab.prototype.show = function () {
	    var $this = this.element;
	    var $ul = $this.closest('ul:not(.dropdown-menu)');
	    var selector = $this.data('target');
	
	    if (!selector) {
	      selector = $this.attr('href');
	      selector = selector && selector.replace(/.*(?=#[^\s]*$)/, '');
	    }
	
	    if ($this.parent('li').hasClass('active')) return;
	
	    var $previous = $ul.find('.active:last a');
	    var hideEvent = $.Event('hide.bs.tab', {
	      relatedTarget: $this[0]
	    });
	    var showEvent = $.Event('show.bs.tab', {
	      relatedTarget: $previous[0]
	    });
	
	    $previous.trigger(hideEvent);
	    $this.trigger(showEvent);
	
	    if (showEvent.isDefaultPrevented() || hideEvent.isDefaultPrevented()) return;
	
	    var $target = $(selector);
	
	    this.activate($this.closest('li'), $ul);
	    this.activate($target, $target.parent(), function () {
	      $previous.trigger({
	        type: 'hidden.bs.tab',
	        relatedTarget: $this[0]
	      });
	      $this.trigger({
	        type: 'shown.bs.tab',
	        relatedTarget: $previous[0]
	      });
	    });
	  };
	
	  Tab.prototype.activate = function (element, container, callback) {
	    var $active = container.find('> .active');
	    var transition = callback && $.support.transition && ($active.length && $active.hasClass('fade') || !!container.find('> .fade').length);
	
	    function next() {
	      $active.removeClass('active').find('> .dropdown-menu > .active').removeClass('active').end().find('[data-toggle="tab"]').attr('aria-expanded', false);
	
	      element.addClass('active').find('[data-toggle="tab"]').attr('aria-expanded', true);
	
	      if (transition) {
	        element[0].offsetWidth;
	        element.addClass('in');
	      } else {
	        element.removeClass('fade');
	      }
	
	      if (element.parent('.dropdown-menu').length) {
	        element.closest('li.dropdown').addClass('active').end().find('[data-toggle="tab"]').attr('aria-expanded', true);
	      }
	
	      callback && callback();
	    }
	
	    $active.length && transition ? $active.one('bsTransitionEnd', next).emulateTransitionEnd(Tab.TRANSITION_DURATION) : next();
	
	    $active.removeClass('in');
	  };
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this = $(this);
	      var data = $this.data('bs.tab');
	
	      if (!data) $this.data('bs.tab', data = new Tab(this));
	      if (typeof option == 'string') data[option]();
	    });
	  }
	
	  var old = $.fn.tab;
	
	  $.fn.tab = Plugin;
	  $.fn.tab.Constructor = Tab;
	
	  $.fn.tab.noConflict = function () {
	    $.fn.tab = old;
	    return this;
	  };
	
	  var clickHandler = function clickHandler(e) {
	    e.preventDefault();
	    Plugin.call($(this), 'show');
	  };
	
	  $(document).on('click.bs.tab.data-api', '[data-toggle="tab"]', clickHandler).on('click.bs.tab.data-api', '[data-toggle="pill"]', clickHandler);
	}(jQuery);
	
	+function ($) {
	  'use strict';
	
	  var Affix = function Affix(element, options) {
	    this.options = $.extend({}, Affix.DEFAULTS, options);
	
	    this.$target = $(this.options.target).on('scroll.bs.affix.data-api', $.proxy(this.checkPosition, this)).on('click.bs.affix.data-api', $.proxy(this.checkPositionWithEventLoop, this));
	
	    this.$element = $(element);
	    this.affixed = null;
	    this.unpin = null;
	    this.pinnedOffset = null;
	
	    this.checkPosition();
	  };
	
	  Affix.VERSION = '3.3.4';
	
	  Affix.RESET = 'affix affix-top affix-bottom';
	
	  Affix.DEFAULTS = {
	    offset: 0,
	    target: window
	  };
	
	  Affix.prototype.getState = function (scrollHeight, height, offsetTop, offsetBottom) {
	    var scrollTop = this.$target.scrollTop();
	    var position = this.$element.offset();
	    var targetHeight = this.$target.height();
	
	    if (offsetTop != null && this.affixed == 'top') return scrollTop < offsetTop ? 'top' : false;
	
	    if (this.affixed == 'bottom') {
	      if (offsetTop != null) return scrollTop + this.unpin <= position.top ? false : 'bottom';
	      return scrollTop + targetHeight <= scrollHeight - offsetBottom ? false : 'bottom';
	    }
	
	    var initializing = this.affixed == null;
	    var colliderTop = initializing ? scrollTop : position.top;
	    var colliderHeight = initializing ? targetHeight : height;
	
	    if (offsetTop != null && scrollTop <= offsetTop) return 'top';
	    if (offsetBottom != null && colliderTop + colliderHeight >= scrollHeight - offsetBottom) return 'bottom';
	
	    return false;
	  };
	
	  Affix.prototype.getPinnedOffset = function () {
	    if (this.pinnedOffset) return this.pinnedOffset;
	    this.$element.removeClass(Affix.RESET).addClass('affix');
	    var scrollTop = this.$target.scrollTop();
	    var position = this.$element.offset();
	    return this.pinnedOffset = position.top - scrollTop;
	  };
	
	  Affix.prototype.checkPositionWithEventLoop = function () {
	    setTimeout($.proxy(this.checkPosition, this), 1);
	  };
	
	  Affix.prototype.checkPosition = function () {
	    if (!this.$element.is(':visible')) return;
	
	    var height = this.$element.height();
	    var offset = this.options.offset;
	    var offsetTop = offset.top;
	    var offsetBottom = offset.bottom;
	    var scrollHeight = $(document.body).height();
	
	    if ((typeof offset === 'undefined' ? 'undefined' : (0, _typeof3.default)(offset)) != 'object') offsetBottom = offsetTop = offset;
	    if (typeof offsetTop == 'function') offsetTop = offset.top(this.$element);
	    if (typeof offsetBottom == 'function') offsetBottom = offset.bottom(this.$element);
	
	    var affix = this.getState(scrollHeight, height, offsetTop, offsetBottom);
	
	    if (this.affixed != affix) {
	      if (this.unpin != null) this.$element.css('top', '');
	
	      var affixType = 'affix' + (affix ? '-' + affix : '');
	      var e = $.Event(affixType + '.bs.affix');
	
	      this.$element.trigger(e);
	
	      if (e.isDefaultPrevented()) return;
	
	      this.affixed = affix;
	      this.unpin = affix == 'bottom' ? this.getPinnedOffset() : null;
	
	      this.$element.removeClass(Affix.RESET).addClass(affixType).trigger(affixType.replace('affix', 'affixed') + '.bs.affix');
	    }
	
	    if (affix == 'bottom') {
	      this.$element.offset({
	        top: scrollHeight - height - offsetBottom
	      });
	    }
	  };
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this = $(this);
	      var data = $this.data('bs.affix');
	      var options = (typeof option === 'undefined' ? 'undefined' : (0, _typeof3.default)(option)) == 'object' && option;
	
	      if (!data) $this.data('bs.affix', data = new Affix(this, options));
	      if (typeof option == 'string') data[option]();
	    });
	  }
	
	  var old = $.fn.affix;
	
	  $.fn.affix = Plugin;
	  $.fn.affix.Constructor = Affix;
	
	  $.fn.affix.noConflict = function () {
	    $.fn.affix = old;
	    return this;
	  };
	
	  $(window).on('load', function () {
	    $('[data-spy="affix"]').each(function () {
	      var $spy = $(this);
	      var data = $spy.data();
	
	      data.offset = data.offset || {};
	
	      if (data.offsetBottom != null) data.offset.bottom = data.offsetBottom;
	      if (data.offsetTop != null) data.offset.top = data.offsetTop;
	
	      Plugin.call($spy, data);
	    });
	  });
	}(jQuery);
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	var _typeof2 = __webpack_require__(9);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	!function () {
	  "use strict";
	  function t(e, o) {
	    function i(t, e) {
	      return function () {
	        return t.apply(e, arguments);
	      };
	    }var r;if (o = o || {}, this.trackingClick = !1, this.trackingClickStart = 0, this.targetElement = null, this.touchStartX = 0, this.touchStartY = 0, this.lastTouchIdentifier = 0, this.touchBoundary = o.touchBoundary || 10, this.layer = e, this.tapDelay = o.tapDelay || 200, this.tapTimeout = o.tapTimeout || 700, !t.notNeeded(e)) {
	      for (var a = ["onMouse", "onClick", "onTouchStart", "onTouchMove", "onTouchEnd", "onTouchCancel"], c = this, s = 0, u = a.length; u > s; s++) {
	        c[a[s]] = i(c[a[s]], c);
	      }n && (e.addEventListener("mouseover", this.onMouse, !0), e.addEventListener("mousedown", this.onMouse, !0), e.addEventListener("mouseup", this.onMouse, !0)), e.addEventListener("click", this.onClick, !0), e.addEventListener("touchstart", this.onTouchStart, !1), e.addEventListener("touchmove", this.onTouchMove, !1), e.addEventListener("touchend", this.onTouchEnd, !1), e.addEventListener("touchcancel", this.onTouchCancel, !1), Event.prototype.stopImmediatePropagation || (e.removeEventListener = function (t, n, o) {
	        var i = Node.prototype.removeEventListener;"click" === t ? i.call(e, t, n.hijacked || n, o) : i.call(e, t, n, o);
	      }, e.addEventListener = function (t, n, o) {
	        var i = Node.prototype.addEventListener;"click" === t ? i.call(e, t, n.hijacked || (n.hijacked = function (t) {
	          t.propagationStopped || n(t);
	        }), o) : i.call(e, t, n, o);
	      }), "function" == typeof e.onclick && (r = e.onclick, e.addEventListener("click", function (t) {
	        r(t);
	      }, !1), e.onclick = null);
	    }
	  }var e = navigator.userAgent.indexOf("Windows Phone") >= 0,
	      n = navigator.userAgent.indexOf("Android") > 0 && !e,
	      o = /iP(ad|hone|od)/.test(navigator.userAgent) && !e,
	      i = o && /OS 4_\d(_\d)?/.test(navigator.userAgent),
	      r = o && /OS [6-7]_\d/.test(navigator.userAgent),
	      a = navigator.userAgent.indexOf("BB10") > 0;t.prototype.needsClick = function (t) {
	    switch (t.nodeName.toLowerCase()) {case "button":case "select":case "textarea":
	        if (t.disabled) return !0;break;case "input":
	        if (o && "file" === t.type || t.disabled) return !0;break;case "label":case "iframe":case "video":
	        return !0;}return (/\bneedsclick\b/.test(t.className)
	    );
	  }, t.prototype.needsFocus = function (t) {
	    switch (t.nodeName.toLowerCase()) {case "textarea":
	        return !0;case "select":
	        return !n;case "input":
	        switch (t.type) {case "button":case "checkbox":case "file":case "image":case "radio":case "submit":
	            return !1;}return !t.disabled && !t.readOnly;default:
	        return (/\bneedsfocus\b/.test(t.className)
	        );}
	  }, t.prototype.sendClick = function (t, e) {
	    var n, o;document.activeElement && document.activeElement !== t && document.activeElement.blur(), o = e.changedTouches[0], n = document.createEvent("MouseEvents"), n.initMouseEvent(this.determineEventType(t), !0, !0, window, 1, o.screenX, o.screenY, o.clientX, o.clientY, !1, !1, !1, !1, 0, null), n.forwardedTouchEvent = !0, t.dispatchEvent(n);
	  }, t.prototype.determineEventType = function (t) {
	    return n && "select" === t.tagName.toLowerCase() ? "mousedown" : "click";
	  }, t.prototype.focus = function (t) {
	    var e;o && t.setSelectionRange && 0 !== t.type.indexOf("date") && "time" !== t.type && "month" !== t.type ? (e = t.value.length, t.setSelectionRange(e, e)) : t.focus();
	  }, t.prototype.updateScrollParent = function (t) {
	    var e, n;if (e = t.fastClickScrollParent, !e || !e.contains(t)) {
	      n = t;do {
	        if (n.scrollHeight > n.offsetHeight) {
	          e = n, t.fastClickScrollParent = n;break;
	        }n = n.parentElement;
	      } while (n);
	    }e && (e.fastClickLastScrollTop = e.scrollTop);
	  }, t.prototype.getTargetElementFromEventTarget = function (t) {
	    return t.nodeType === Node.TEXT_NODE ? t.parentNode : t;
	  }, t.prototype.onTouchStart = function (t) {
	    var e, n, r;if (t.targetTouches.length > 1) return !0;if (e = this.getTargetElementFromEventTarget(t.target), n = t.targetTouches[0], o) {
	      if (r = window.getSelection(), r.rangeCount && !r.isCollapsed) return !0;if (!i) {
	        if (n.identifier && n.identifier === this.lastTouchIdentifier) return t.preventDefault(), !1;this.lastTouchIdentifier = n.identifier, this.updateScrollParent(e);
	      }
	    }return this.trackingClick = !0, this.trackingClickStart = t.timeStamp, this.targetElement = e, this.touchStartX = n.pageX, this.touchStartY = n.pageY, t.timeStamp - this.lastClickTime < this.tapDelay && t.preventDefault(), !0;
	  }, t.prototype.touchHasMoved = function (t) {
	    var e = t.changedTouches[0],
	        n = this.touchBoundary;return Math.abs(e.pageX - this.touchStartX) > n || Math.abs(e.pageY - this.touchStartY) > n ? !0 : !1;
	  }, t.prototype.onTouchMove = function (t) {
	    return this.trackingClick ? ((this.targetElement !== this.getTargetElementFromEventTarget(t.target) || this.touchHasMoved(t)) && (this.trackingClick = !1, this.targetElement = null), !0) : !0;
	  }, t.prototype.findControl = function (t) {
	    return void 0 !== t.control ? t.control : t.htmlFor ? document.getElementById(t.htmlFor) : t.querySelector("button, input:not([type=hidden]), keygen, meter, output, progress, select, textarea");
	  }, t.prototype.onTouchEnd = function (t) {
	    var e,
	        a,
	        c,
	        s,
	        u,
	        l = this.targetElement;if (!this.trackingClick) return !0;if (t.timeStamp - this.lastClickTime < this.tapDelay) return this.cancelNextClick = !0, !0;if (t.timeStamp - this.trackingClickStart > this.tapTimeout) return !0;if (this.cancelNextClick = !1, this.lastClickTime = t.timeStamp, a = this.trackingClickStart, this.trackingClick = !1, this.trackingClickStart = 0, r && (u = t.changedTouches[0], l = document.elementFromPoint(u.pageX - window.pageXOffset, u.pageY - window.pageYOffset) || l, l.fastClickScrollParent = this.targetElement.fastClickScrollParent), c = l.tagName.toLowerCase(), "label" === c) {
	      if (e = this.findControl(l)) {
	        if (this.focus(l), n) return !1;l = e;
	      }
	    } else if (this.needsFocus(l)) return t.timeStamp - a > 100 || o && window.top !== window && "input" === c ? (this.targetElement = null, !1) : (this.focus(l), this.sendClick(l, t), o && "select" === c || (this.targetElement = null, t.preventDefault()), !1);return o && !i && (s = l.fastClickScrollParent, s && s.fastClickLastScrollTop !== s.scrollTop) ? !0 : (this.needsClick(l) || (t.preventDefault(), this.sendClick(l, t)), !1);
	  }, t.prototype.onTouchCancel = function () {
	    this.trackingClick = !1, this.targetElement = null;
	  }, t.prototype.onMouse = function (t) {
	    return this.targetElement ? t.forwardedTouchEvent ? !0 : t.cancelable && (!this.needsClick(this.targetElement) || this.cancelNextClick) ? (t.stopImmediatePropagation ? t.stopImmediatePropagation() : t.propagationStopped = !0, t.stopPropagation(), t.preventDefault(), !1) : !0 : !0;
	  }, t.prototype.onClick = function (t) {
	    var e;return this.trackingClick ? (this.targetElement = null, this.trackingClick = !1, !0) : "submit" === t.target.type && 0 === t.detail ? !0 : (e = this.onMouse(t), e || (this.targetElement = null), e);
	  }, t.prototype.destroy = function () {
	    var t = this.layer;n && (t.removeEventListener("mouseover", this.onMouse, !0), t.removeEventListener("mousedown", this.onMouse, !0), t.removeEventListener("mouseup", this.onMouse, !0)), t.removeEventListener("click", this.onClick, !0), t.removeEventListener("touchstart", this.onTouchStart, !1), t.removeEventListener("touchmove", this.onTouchMove, !1), t.removeEventListener("touchend", this.onTouchEnd, !1), t.removeEventListener("touchcancel", this.onTouchCancel, !1);
	  }, t.notNeeded = function (t) {
	    var e, o, i, r;if ("undefined" == typeof window.ontouchstart) return !0;if (o = +(/Chrome\/([0-9]+)/.exec(navigator.userAgent) || [, 0])[1]) {
	      if (!n) return !0;if (e = document.querySelector("meta[name=viewport]")) {
	        if (-1 !== e.content.indexOf("user-scalable=no")) return !0;if (o > 31 && document.documentElement.scrollWidth <= window.outerWidth) return !0;
	      }
	    }if (a && (i = navigator.userAgent.match(/Version\/([0-9]*)\.([0-9]*)/), i[1] >= 10 && i[2] >= 3 && (e = document.querySelector("meta[name=viewport]")))) {
	      if (-1 !== e.content.indexOf("user-scalable=no")) return !0;if (document.documentElement.scrollWidth <= window.outerWidth) return !0;
	    }return "none" === t.style.msTouchAction || "manipulation" === t.style.touchAction ? !0 : (r = +(/Firefox\/([0-9]+)/.exec(navigator.userAgent) || [, 0])[1], r >= 27 && (e = document.querySelector("meta[name=viewport]"), e && (-1 !== e.content.indexOf("user-scalable=no") || document.documentElement.scrollWidth <= window.outerWidth)) ? !0 : "none" === t.style.touchAction || "manipulation" === t.style.touchAction ? !0 : !1);
	  }, t.attach = function (e, n) {
	    return new t(e, n);
	  }, "function" == "function" && "object" == (0, _typeof3.default)(__webpack_require__(58)) && __webpack_require__(58) ? !(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
	    return t;
	  }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : "undefined" != typeof module && module.exports ? (module.exports = t.attach, module.exports.FastClick = t) : window.FastClick = t;
	}();

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {"use strict";
	
	(function (r) {
	  r.fn.qrcode = function (h) {
	    var s;function u(a) {
	      this.mode = s;this.data = a;
	    }function o(a, c) {
	      this.typeNumber = a;this.errorCorrectLevel = c;this.modules = null;this.moduleCount = 0;this.dataCache = null;this.dataList = [];
	    }function q(a, c) {
	      if (void 0 == a.length) throw Error(a.length + "/" + c);for (var d = 0; d < a.length && 0 == a[d];) {
	        d++;
	      }this.num = Array(a.length - d + c);for (var b = 0; b < a.length - d; b++) {
	        this.num[b] = a[b + d];
	      }
	    }function p(a, c) {
	      this.totalCount = a;this.dataCount = c;
	    }function t() {
	      this.buffer = [];this.length = 0;
	    }u.prototype = { getLength: function getLength() {
	        return this.data.length;
	      },
	      write: function write(a) {
	        for (var c = 0; c < this.data.length; c++) {
	          a.put(this.data.charCodeAt(c), 8);
	        }
	      } };o.prototype = { addData: function addData(a) {
	        this.dataList.push(new u(a));this.dataCache = null;
	      }, isDark: function isDark(a, c) {
	        if (0 > a || this.moduleCount <= a || 0 > c || this.moduleCount <= c) throw Error(a + "," + c);return this.modules[a][c];
	      }, getModuleCount: function getModuleCount() {
	        return this.moduleCount;
	      }, make: function make() {
	        if (1 > this.typeNumber) {
	          for (var a = 1, a = 1; 40 > a; a++) {
	            for (var c = p.getRSBlocks(a, this.errorCorrectLevel), d = new t(), b = 0, e = 0; e < c.length; e++) {
	              b += c[e].dataCount;
	            }for (e = 0; e < this.dataList.length; e++) {
	              c = this.dataList[e], d.put(c.mode, 4), d.put(c.getLength(), j.getLengthInBits(c.mode, a)), c.write(d);
	            }if (d.getLengthInBits() <= 8 * b) break;
	          }this.typeNumber = a;
	        }this.makeImpl(!1, this.getBestMaskPattern());
	      }, makeImpl: function makeImpl(a, c) {
	        this.moduleCount = 4 * this.typeNumber + 17;this.modules = Array(this.moduleCount);for (var d = 0; d < this.moduleCount; d++) {
	          this.modules[d] = Array(this.moduleCount);for (var b = 0; b < this.moduleCount; b++) {
	            this.modules[d][b] = null;
	          }
	        }this.setupPositionProbePattern(0, 0);this.setupPositionProbePattern(this.moduleCount - 7, 0);this.setupPositionProbePattern(0, this.moduleCount - 7);this.setupPositionAdjustPattern();this.setupTimingPattern();this.setupTypeInfo(a, c);7 <= this.typeNumber && this.setupTypeNumber(a);null == this.dataCache && (this.dataCache = o.createData(this.typeNumber, this.errorCorrectLevel, this.dataList));this.mapData(this.dataCache, c);
	      }, setupPositionProbePattern: function setupPositionProbePattern(a, c) {
	        for (var d = -1; 7 >= d; d++) {
	          if (!(-1 >= a + d || this.moduleCount <= a + d)) for (var b = -1; 7 >= b; b++) {
	            -1 >= c + b || this.moduleCount <= c + b || (this.modules[a + d][c + b] = 0 <= d && 6 >= d && (0 == b || 6 == b) || 0 <= b && 6 >= b && (0 == d || 6 == d) || 2 <= d && 4 >= d && 2 <= b && 4 >= b ? !0 : !1);
	          }
	        }
	      }, getBestMaskPattern: function getBestMaskPattern() {
	        for (var a = 0, c = 0, d = 0; 8 > d; d++) {
	          this.makeImpl(!0, d);var b = j.getLostPoint(this);if (0 == d || a > b) a = b, c = d;
	        }return c;
	      }, createMovieClip: function createMovieClip(a, c, d) {
	        a = a.createEmptyMovieClip(c, d);this.make();for (c = 0; c < this.modules.length; c++) {
	          for (var d = 1 * c, b = 0; b < this.modules[c].length; b++) {
	            var e = 1 * b;this.modules[c][b] && (a.beginFill(0, 100), a.moveTo(e, d), a.lineTo(e + 1, d), a.lineTo(e + 1, d + 1), a.lineTo(e, d + 1), a.endFill());
	          }
	        }return a;
	      },
	      setupTimingPattern: function setupTimingPattern() {
	        for (var a = 8; a < this.moduleCount - 8; a++) {
	          null == this.modules[a][6] && (this.modules[a][6] = 0 == a % 2);
	        }for (a = 8; a < this.moduleCount - 8; a++) {
	          null == this.modules[6][a] && (this.modules[6][a] = 0 == a % 2);
	        }
	      }, setupPositionAdjustPattern: function setupPositionAdjustPattern() {
	        for (var a = j.getPatternPosition(this.typeNumber), c = 0; c < a.length; c++) {
	          for (var d = 0; d < a.length; d++) {
	            var b = a[c],
	                e = a[d];if (null == this.modules[b][e]) for (var f = -2; 2 >= f; f++) {
	              for (var i = -2; 2 >= i; i++) {
	                this.modules[b + f][e + i] = -2 == f || 2 == f || -2 == i || 2 == i || 0 == f && 0 == i ? !0 : !1;
	              }
	            }
	          }
	        }
	      }, setupTypeNumber: function setupTypeNumber(a) {
	        for (var c = j.getBCHTypeNumber(this.typeNumber), d = 0; 18 > d; d++) {
	          var b = !a && 1 == (c >> d & 1);this.modules[Math.floor(d / 3)][d % 3 + this.moduleCount - 8 - 3] = b;
	        }for (d = 0; 18 > d; d++) {
	          b = !a && 1 == (c >> d & 1), this.modules[d % 3 + this.moduleCount - 8 - 3][Math.floor(d / 3)] = b;
	        }
	      }, setupTypeInfo: function setupTypeInfo(a, c) {
	        for (var d = j.getBCHTypeInfo(this.errorCorrectLevel << 3 | c), b = 0; 15 > b; b++) {
	          var e = !a && 1 == (d >> b & 1);6 > b ? this.modules[b][8] = e : 8 > b ? this.modules[b + 1][8] = e : this.modules[this.moduleCount - 15 + b][8] = e;
	        }for (b = 0; 15 > b; b++) {
	          e = !a && 1 == (d >> b & 1), 8 > b ? this.modules[8][this.moduleCount - b - 1] = e : 9 > b ? this.modules[8][15 - b - 1 + 1] = e : this.modules[8][15 - b - 1] = e;
	        }this.modules[this.moduleCount - 8][8] = !a;
	      }, mapData: function mapData(a, c) {
	        for (var d = -1, b = this.moduleCount - 1, e = 7, f = 0, i = this.moduleCount - 1; 0 < i; i -= 2) {
	          for (6 == i && i--;;) {
	            for (var g = 0; 2 > g; g++) {
	              if (null == this.modules[b][i - g]) {
	                var n = !1;f < a.length && (n = 1 == (a[f] >>> e & 1));j.getMask(c, b, i - g) && (n = !n);this.modules[b][i - g] = n;e--;-1 == e && (f++, e = 7);
	              }
	            }b += d;if (0 > b || this.moduleCount <= b) {
	              b -= d;d = -d;break;
	            }
	          }
	        }
	      } };o.PAD0 = 236;o.PAD1 = 17;o.createData = function (a, c, d) {
	      for (var c = p.getRSBlocks(a, c), b = new t(), e = 0; e < d.length; e++) {
	        var f = d[e];b.put(f.mode, 4);b.put(f.getLength(), j.getLengthInBits(f.mode, a));f.write(b);
	      }for (e = a = 0; e < c.length; e++) {
	        a += c[e].dataCount;
	      }if (b.getLengthInBits() > 8 * a) throw Error("code length overflow. (" + b.getLengthInBits() + ">" + 8 * a + ")");for (b.getLengthInBits() + 4 <= 8 * a && b.put(0, 4); 0 != b.getLengthInBits() % 8;) {
	        b.putBit(!1);
	      }for (; !(b.getLengthInBits() >= 8 * a);) {
	        b.put(o.PAD0, 8);if (b.getLengthInBits() >= 8 * a) break;b.put(o.PAD1, 8);
	      }return o.createBytes(b, c);
	    };o.createBytes = function (a, c) {
	      for (var d = 0, b = 0, e = 0, f = Array(c.length), i = Array(c.length), g = 0; g < c.length; g++) {
	        var n = c[g].dataCount,
	            h = c[g].totalCount - n,
	            b = Math.max(b, n),
	            e = Math.max(e, h);f[g] = Array(n);for (var k = 0; k < f[g].length; k++) {
	          f[g][k] = 255 & a.buffer[k + d];
	        }d += n;k = j.getErrorCorrectPolynomial(h);n = new q(f[g], k.getLength() - 1).mod(k);i[g] = Array(k.getLength() - 1);for (k = 0; k < i[g].length; k++) {
	          h = k + n.getLength() - i[g].length, i[g][k] = 0 <= h ? n.get(h) : 0;
	        }
	      }for (k = g = 0; k < c.length; k++) {
	        g += c[k].totalCount;
	      }d = Array(g);for (k = n = 0; k < b; k++) {
	        for (g = 0; g < c.length; g++) {
	          k < f[g].length && (d[n++] = f[g][k]);
	        }
	      }for (k = 0; k < e; k++) {
	        for (g = 0; g < c.length; g++) {
	          k < i[g].length && (d[n++] = i[g][k]);
	        }
	      }return d;
	    };s = 4;for (var j = { PATTERN_POSITION_TABLE: [[], [6, 18], [6, 22], [6, 26], [6, 30], [6, 34], [6, 22, 38], [6, 24, 42], [6, 26, 46], [6, 28, 50], [6, 30, 54], [6, 32, 58], [6, 34, 62], [6, 26, 46, 66], [6, 26, 48, 70], [6, 26, 50, 74], [6, 30, 54, 78], [6, 30, 56, 82], [6, 30, 58, 86], [6, 34, 62, 90], [6, 28, 50, 72, 94], [6, 26, 50, 74, 98], [6, 30, 54, 78, 102], [6, 28, 54, 80, 106], [6, 32, 58, 84, 110], [6, 30, 58, 86, 114], [6, 34, 62, 90, 118], [6, 26, 50, 74, 98, 122], [6, 30, 54, 78, 102, 126], [6, 26, 52, 78, 104, 130], [6, 30, 56, 82, 108, 134], [6, 34, 60, 86, 112, 138], [6, 30, 58, 86, 114, 142], [6, 34, 62, 90, 118, 146], [6, 30, 54, 78, 102, 126, 150], [6, 24, 50, 76, 102, 128, 154], [6, 28, 54, 80, 106, 132, 158], [6, 32, 58, 84, 110, 136, 162], [6, 26, 54, 82, 110, 138, 166], [6, 30, 58, 86, 114, 142, 170]], G15: 1335, G18: 7973, G15_MASK: 21522, getBCHTypeInfo: function getBCHTypeInfo(a) {
	        for (var c = a << 10; 0 <= j.getBCHDigit(c) - j.getBCHDigit(j.G15);) {
	          c ^= j.G15 << j.getBCHDigit(c) - j.getBCHDigit(j.G15);
	        }return (a << 10 | c) ^ j.G15_MASK;
	      }, getBCHTypeNumber: function getBCHTypeNumber(a) {
	        for (var c = a << 12; 0 <= j.getBCHDigit(c) - j.getBCHDigit(j.G18);) {
	          c ^= j.G18 << j.getBCHDigit(c) - j.getBCHDigit(j.G18);
	        }return a << 12 | c;
	      }, getBCHDigit: function getBCHDigit(a) {
	        for (var c = 0; 0 != a;) {
	          c++, a >>>= 1;
	        }return c;
	      }, getPatternPosition: function getPatternPosition(a) {
	        return j.PATTERN_POSITION_TABLE[a - 1];
	      }, getMask: function getMask(a, c, d) {
	        switch (a) {case 0:
	            return 0 == (c + d) % 2;case 1:
	            return 0 == c % 2;case 2:
	            return 0 == d % 3;case 3:
	            return 0 == (c + d) % 3;case 4:
	            return 0 == (Math.floor(c / 2) + Math.floor(d / 3)) % 2;case 5:
	            return 0 == c * d % 2 + c * d % 3;case 6:
	            return 0 == (c * d % 2 + c * d % 3) % 2;case 7:
	            return 0 == (c * d % 3 + (c + d) % 2) % 2;default:
	            throw Error("bad maskPattern:" + a);}
	      }, getErrorCorrectPolynomial: function getErrorCorrectPolynomial(a) {
	        for (var c = new q([1], 0), d = 0; d < a; d++) {
	          c = c.multiply(new q([1, l.gexp(d)], 0));
	        }return c;
	      }, getLengthInBits: function getLengthInBits(a, c) {
	        if (1 <= c && 10 > c) switch (a) {case 1:
	            return 10;case 2:
	            return 9;case s:
	            return 8;case 8:
	            return 8;default:
	            throw Error("mode:" + a);} else if (27 > c) switch (a) {case 1:
	            return 12;case 2:
	            return 11;case s:
	            return 16;case 8:
	            return 10;default:
	            throw Error("mode:" + a);} else if (41 > c) switch (a) {case 1:
	            return 14;case 2:
	            return 13;case s:
	            return 16;case 8:
	            return 12;default:
	            throw Error("mode:" + a);} else throw Error("type:" + c);
	      }, getLostPoint: function getLostPoint(a) {
	        for (var c = a.getModuleCount(), d = 0, b = 0; b < c; b++) {
	          for (var e = 0; e < c; e++) {
	            for (var f = 0, i = a.isDark(b, e), g = -1; 1 >= g; g++) {
	              if (!(0 > b + g || c <= b + g)) for (var h = -1; 1 >= h; h++) {
	                0 > e + h || c <= e + h || 0 == g && 0 == h || i == a.isDark(b + g, e + h) && f++;
	              }
	            }5 < f && (d += 3 + f - 5);
	          }
	        }for (b = 0; b < c - 1; b++) {
	          for (e = 0; e < c - 1; e++) {
	            if (f = 0, a.isDark(b, e) && f++, a.isDark(b + 1, e) && f++, a.isDark(b, e + 1) && f++, a.isDark(b + 1, e + 1) && f++, 0 == f || 4 == f) d += 3;
	          }
	        }for (b = 0; b < c; b++) {
	          for (e = 0; e < c - 6; e++) {
	            a.isDark(b, e) && !a.isDark(b, e + 1) && a.isDark(b, e + 2) && a.isDark(b, e + 3) && a.isDark(b, e + 4) && !a.isDark(b, e + 5) && a.isDark(b, e + 6) && (d += 40);
	          }
	        }for (e = 0; e < c; e++) {
	          for (b = 0; b < c - 6; b++) {
	            a.isDark(b, e) && !a.isDark(b + 1, e) && a.isDark(b + 2, e) && a.isDark(b + 3, e) && a.isDark(b + 4, e) && !a.isDark(b + 5, e) && a.isDark(b + 6, e) && (d += 40);
	          }
	        }for (e = f = 0; e < c; e++) {
	          for (b = 0; b < c; b++) {
	            a.isDark(b, e) && f++;
	          }
	        }a = Math.abs(100 * f / c / c - 50) / 5;return d + 10 * a;
	      } }, l = { glog: function glog(a) {
	        if (1 > a) throw Error("glog(" + a + ")");return l.LOG_TABLE[a];
	      }, gexp: function gexp(a) {
	        for (; 0 > a;) {
	          a += 255;
	        }for (; 256 <= a;) {
	          a -= 255;
	        }return l.EXP_TABLE[a];
	      }, EXP_TABLE: Array(256),
	      LOG_TABLE: Array(256) }, m = 0; 8 > m; m++) {
	      l.EXP_TABLE[m] = 1 << m;
	    }for (m = 8; 256 > m; m++) {
	      l.EXP_TABLE[m] = l.EXP_TABLE[m - 4] ^ l.EXP_TABLE[m - 5] ^ l.EXP_TABLE[m - 6] ^ l.EXP_TABLE[m - 8];
	    }for (m = 0; 255 > m; m++) {
	      l.LOG_TABLE[l.EXP_TABLE[m]] = m;
	    }q.prototype = { get: function get(a) {
	        return this.num[a];
	      }, getLength: function getLength() {
	        return this.num.length;
	      }, multiply: function multiply(a) {
	        for (var c = Array(this.getLength() + a.getLength() - 1), d = 0; d < this.getLength(); d++) {
	          for (var b = 0; b < a.getLength(); b++) {
	            c[d + b] ^= l.gexp(l.glog(this.get(d)) + l.glog(a.get(b)));
	          }
	        }return new q(c, 0);
	      }, mod: function mod(a) {
	        if (0 > this.getLength() - a.getLength()) return this;for (var c = l.glog(this.get(0)) - l.glog(a.get(0)), d = Array(this.getLength()), b = 0; b < this.getLength(); b++) {
	          d[b] = this.get(b);
	        }for (b = 0; b < a.getLength(); b++) {
	          d[b] ^= l.gexp(l.glog(a.get(b)) + c);
	        }return new q(d, 0).mod(a);
	      } };p.RS_BLOCK_TABLE = [[1, 26, 19], [1, 26, 16], [1, 26, 13], [1, 26, 9], [1, 44, 34], [1, 44, 28], [1, 44, 22], [1, 44, 16], [1, 70, 55], [1, 70, 44], [2, 35, 17], [2, 35, 13], [1, 100, 80], [2, 50, 32], [2, 50, 24], [4, 25, 9], [1, 134, 108], [2, 67, 43], [2, 33, 15, 2, 34, 16], [2, 33, 11, 2, 34, 12], [2, 86, 68], [4, 43, 27], [4, 43, 19], [4, 43, 15], [2, 98, 78], [4, 49, 31], [2, 32, 14, 4, 33, 15], [4, 39, 13, 1, 40, 14], [2, 121, 97], [2, 60, 38, 2, 61, 39], [4, 40, 18, 2, 41, 19], [4, 40, 14, 2, 41, 15], [2, 146, 116], [3, 58, 36, 2, 59, 37], [4, 36, 16, 4, 37, 17], [4, 36, 12, 4, 37, 13], [2, 86, 68, 2, 87, 69], [4, 69, 43, 1, 70, 44], [6, 43, 19, 2, 44, 20], [6, 43, 15, 2, 44, 16], [4, 101, 81], [1, 80, 50, 4, 81, 51], [4, 50, 22, 4, 51, 23], [3, 36, 12, 8, 37, 13], [2, 116, 92, 2, 117, 93], [6, 58, 36, 2, 59, 37], [4, 46, 20, 6, 47, 21], [7, 42, 14, 4, 43, 15], [4, 133, 107], [8, 59, 37, 1, 60, 38], [8, 44, 20, 4, 45, 21], [12, 33, 11, 4, 34, 12], [3, 145, 115, 1, 146, 116], [4, 64, 40, 5, 65, 41], [11, 36, 16, 5, 37, 17], [11, 36, 12, 5, 37, 13], [5, 109, 87, 1, 110, 88], [5, 65, 41, 5, 66, 42], [5, 54, 24, 7, 55, 25], [11, 36, 12], [5, 122, 98, 1, 123, 99], [7, 73, 45, 3, 74, 46], [15, 43, 19, 2, 44, 20], [3, 45, 15, 13, 46, 16], [1, 135, 107, 5, 136, 108], [10, 74, 46, 1, 75, 47], [1, 50, 22, 15, 51, 23], [2, 42, 14, 17, 43, 15], [5, 150, 120, 1, 151, 121], [9, 69, 43, 4, 70, 44], [17, 50, 22, 1, 51, 23], [2, 42, 14, 19, 43, 15], [3, 141, 113, 4, 142, 114], [3, 70, 44, 11, 71, 45], [17, 47, 21, 4, 48, 22], [9, 39, 13, 16, 40, 14], [3, 135, 107, 5, 136, 108], [3, 67, 41, 13, 68, 42], [15, 54, 24, 5, 55, 25], [15, 43, 15, 10, 44, 16], [4, 144, 116, 4, 145, 117], [17, 68, 42], [17, 50, 22, 6, 51, 23], [19, 46, 16, 6, 47, 17], [2, 139, 111, 7, 140, 112], [17, 74, 46], [7, 54, 24, 16, 55, 25], [34, 37, 13], [4, 151, 121, 5, 152, 122], [4, 75, 47, 14, 76, 48], [11, 54, 24, 14, 55, 25], [16, 45, 15, 14, 46, 16], [6, 147, 117, 4, 148, 118], [6, 73, 45, 14, 74, 46], [11, 54, 24, 16, 55, 25], [30, 46, 16, 2, 47, 17], [8, 132, 106, 4, 133, 107], [8, 75, 47, 13, 76, 48], [7, 54, 24, 22, 55, 25], [22, 45, 15, 13, 46, 16], [10, 142, 114, 2, 143, 115], [19, 74, 46, 4, 75, 47], [28, 50, 22, 6, 51, 23], [33, 46, 16, 4, 47, 17], [8, 152, 122, 4, 153, 123], [22, 73, 45, 3, 74, 46], [8, 53, 23, 26, 54, 24], [12, 45, 15, 28, 46, 16], [3, 147, 117, 10, 148, 118], [3, 73, 45, 23, 74, 46], [4, 54, 24, 31, 55, 25], [11, 45, 15, 31, 46, 16], [7, 146, 116, 7, 147, 117], [21, 73, 45, 7, 74, 46], [1, 53, 23, 37, 54, 24], [19, 45, 15, 26, 46, 16], [5, 145, 115, 10, 146, 116], [19, 75, 47, 10, 76, 48], [15, 54, 24, 25, 55, 25], [23, 45, 15, 25, 46, 16], [13, 145, 115, 3, 146, 116], [2, 74, 46, 29, 75, 47], [42, 54, 24, 1, 55, 25], [23, 45, 15, 28, 46, 16], [17, 145, 115], [10, 74, 46, 23, 75, 47], [10, 54, 24, 35, 55, 25], [19, 45, 15, 35, 46, 16], [17, 145, 115, 1, 146, 116], [14, 74, 46, 21, 75, 47], [29, 54, 24, 19, 55, 25], [11, 45, 15, 46, 46, 16], [13, 145, 115, 6, 146, 116], [14, 74, 46, 23, 75, 47], [44, 54, 24, 7, 55, 25], [59, 46, 16, 1, 47, 17], [12, 151, 121, 7, 152, 122], [12, 75, 47, 26, 76, 48], [39, 54, 24, 14, 55, 25], [22, 45, 15, 41, 46, 16], [6, 151, 121, 14, 152, 122], [6, 75, 47, 34, 76, 48], [46, 54, 24, 10, 55, 25], [2, 45, 15, 64, 46, 16], [17, 152, 122, 4, 153, 123], [29, 74, 46, 14, 75, 47], [49, 54, 24, 10, 55, 25], [24, 45, 15, 46, 46, 16], [4, 152, 122, 18, 153, 123], [13, 74, 46, 32, 75, 47], [48, 54, 24, 14, 55, 25], [42, 45, 15, 32, 46, 16], [20, 147, 117, 4, 148, 118], [40, 75, 47, 7, 76, 48], [43, 54, 24, 22, 55, 25], [10, 45, 15, 67, 46, 16], [19, 148, 118, 6, 149, 119], [18, 75, 47, 31, 76, 48], [34, 54, 24, 34, 55, 25], [20, 45, 15, 61, 46, 16]];p.getRSBlocks = function (a, c) {
	      var d = p.getRsBlockTable(a, c);if (void 0 == d) throw Error("bad rs block @ typeNumber:" + a + "/errorCorrectLevel:" + c);for (var b = d.length / 3, e = [], f = 0; f < b; f++) {
	        for (var h = d[3 * f + 0], g = d[3 * f + 1], j = d[3 * f + 2], l = 0; l < h; l++) {
	          e.push(new p(g, j));
	        }
	      }return e;
	    };p.getRsBlockTable = function (a, c) {
	      switch (c) {case 1:
	          return p.RS_BLOCK_TABLE[4 * (a - 1) + 0];case 0:
	          return p.RS_BLOCK_TABLE[4 * (a - 1) + 1];case 3:
	          return p.RS_BLOCK_TABLE[4 * (a - 1) + 2];case 2:
	          return p.RS_BLOCK_TABLE[4 * (a - 1) + 3];}
	    };t.prototype = { get: function get(a) {
	        return 1 == (this.buffer[Math.floor(a / 8)] >>> 7 - a % 8 & 1);
	      }, put: function put(a, c) {
	        for (var d = 0; d < c; d++) {
	          this.putBit(1 == (a >>> c - d - 1 & 1));
	        }
	      }, getLengthInBits: function getLengthInBits() {
	        return this.length;
	      }, putBit: function putBit(a) {
	        var c = Math.floor(this.length / 8);this.buffer.length <= c && this.buffer.push(0);a && (this.buffer[c] |= 128 >>> this.length % 8);this.length++;
	      } };"string" === typeof h && (h = { text: h });h = r.extend({}, { render: "canvas", width: 256, height: 256, typeNumber: -1,
	      correctLevel: 2, background: "#ffffff", foreground: "#000000" }, h);return this.each(function () {
	      var a;if ("canvas" == h.render) {
	        a = new o(h.typeNumber, h.correctLevel);a.addData(h.text);a.make();var c = document.createElement("canvas");c.width = h.width;c.height = h.height;for (var d = c.getContext("2d"), b = h.width / a.getModuleCount(), e = h.height / a.getModuleCount(), f = 0; f < a.getModuleCount(); f++) {
	          for (var i = 0; i < a.getModuleCount(); i++) {
	            d.fillStyle = a.isDark(f, i) ? h.foreground : h.background;var g = Math.ceil((i + 1) * b) - Math.floor(i * b),
	                j = Math.ceil((f + 1) * b) - Math.floor(f * b);d.fillRect(Math.round(i * b), Math.round(f * e), g, j);
	          }
	        }
	      } else {
	        a = new o(h.typeNumber, h.correctLevel);a.addData(h.text);a.make();c = r("<table></table>").css("width", h.width + "px").css("height", h.height + "px").css("border", "0px").css("border-collapse", "collapse").css("background-color", h.background);d = h.width / a.getModuleCount();b = h.height / a.getModuleCount();for (e = 0; e < a.getModuleCount(); e++) {
	          f = r("<tr></tr>").css("height", b + "px").appendTo(c);for (i = 0; i < a.getModuleCount(); i++) {
	            r("<td></td>").css("width", d + "px").css("background-color", a.isDark(e, i) ? h.foreground : h.background).appendTo(f);
	          }
	        }
	      }a = c;jQuery(a).appendTo(this);
	    });
	  };
	})(jQuery);
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($, jQuery) {"use strict";
	
	var _typeof2 = __webpack_require__(9);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	if (!/Android|webOS|iPhone|iPod|iPad|BlackBerry/i.test(navigator.userAgent)) {
	  $(function () {
	    $(".numkeyboard").ioskeyboard({
	      keyboardRadix: 80,
	      keyboardRadixMin: 40,
	      keyboardRadixChange: true,
	      clickeve: true,
	      colorchange: true,
	      colorchangeStep: 1,
	      colorchangeMin: 154 });
	  });
	}
	(function ($) {
	  $.fn.ioskeyboard = function (options) {
	    var defaults = {
	      keyboardRadix: 100,
	      keyboardRadixMin: 60,
	      keyboardRadixChange: true,
	      clickeve: true,
	      colorchange: true,
	      colorchangeStep: 1,
	      colorchangeMin: 154 };
	    var options = $.extend(defaults, options);
	    var numkeyboardcount = 0;
	    var activeinputele;
	    var keyboardRadix = options.keyboardRadix;
	    var keyboardRadixMin = options.keyboardRadixMin;
	    var colorchange = options.colorchange;
	    var colorchangeStep = options.colorchangeStep;
	    var colorchangeMin = options.colorchangeMin;
	
	    var keyfixed = false;
	    if (keyboardRadix < keyboardRadixMin) {
	      keyboardRadix = keyboardRadixMin;
	    }
	    this.each(function () {
	      numkeyboardcount++;
	
	      if (numkeyboardcount < 2) {
	        $("body").append("<ul id='keyboard_5xbogf8c'>" + "<li><span>!</span><span>1</span></li>" + "<li>2</li>" + "<li>3</li>" + "<li>4</li>" + "<li>5</li>" + "<li>6</li>" + "<li>7</li>" + "<li>8</li>" + "<li>9</li>" + "<li>0</li>" + "<li>←</li>" + "<li class='zimu'>q</li>" + "<li class='zimu'>w</li>" + "<li class='zimu'>e</li>" + "<li class='zimu'>r</li>" + "<li class='zimu'>t</li>" + "<li class='zimu'>y</li>" + "<li class='zimu'>u</li>" + "<li class='zimu'>i</li>" + "<li class='zimu'>o</li>" + "<li class='zimu'>p</li>" + "<li></li>" + "<li class='zimu'>a</li>" + "<li class='zimu'>s</li>" + "<li class='zimu'>d</li>" + "<li class='zimu'>f</li>" + "<li class='zimu'>g</li>" + "<li class='zimu'>h</li>" + "<li class='zimu'>j</li>" + "<li class='zimu'>k</li>" + "<li class='zimu'>l</li>" + "<li>Exit</li>" + "<li>CapsLock</li>" + "<li class='zimu'>z</li>" + "<li class='zimu'>x</li>" + "<li class='zimu'>c</li>" + "<li class='zimu'>v</li>" + "<li class='zimu'>b</li>" + "<li class='zimu'>n</li>" + "<li class='zimu'>m</li>" + "<li><span>-</span><span>_</span></li>" + "<li><span>/</span><span>.</span></li>" + "<li>Clear</li>" + "<div id='keyboard_5xbogf8c_left'></div>" + "<div id='keyboard_5xbogf8c_right'></div>" + "</ul>");
	      }
	
	      var inputele = $(this);
	      console.log(inputele);
	      var keyboard = $("#keyboard_5xbogf8c");
	      var keys = keyboard.children("li");
	      var hiddenbutton = keyboard.children("div");
	      keyboard.css({ "font-size": keyboardRadix + "px" });
	
	      exit();
	      var shiftbool = false;
	      if (numkeyboardcount < 2) {
	        keyboard.dblclick(function () {
	          if (keyfixed) {
	            keyfixed = false;
	          } else {
	            keyboard.css({ "position": "fixed", "right": "0.05em", "bottom": "0.05em" });
	            keyfixed = true;
	          }
	        });
	        keys.click(function (event) {
	          var keyele = $(this);
	          var keytext = keyele.text();
	          var evebool = true;
	          if (keytext === "CapsLock") {
	            activeinputele[0].focus();
	            if (shiftbool) {
	              keyele.css({ background: "rgba(255,255,255,.9)" });
	              shiftbool = false;
	
	              var zimu = $(".zimu");
	              for (var i = 0; i < zimu.length; i++) {
	                zimu[i].innerHTML = zimu[i].innerHTML.toLowerCase();
	              };
	            } else {
	              keyele.css({ background: "rgba(188,188,188,.5)" });
	              shiftbool = true;
	
	              var zimu = $(".zimu");
	              for (var i = 0; i < zimu.length; i++) {
	                zimu[i].innerHTML = zimu[i].innerHTML.toUpperCase();
	              };
	            }
	
	            evebool = false;
	          }
	          if (keytext === "Exit" || keytext.length < 1) {
	            simulateKeyEvent(activeinputele[0], 13);
	            exit();
	            evebool = false;
	          }
	          if (keytext === "←") {
	            activeinputele[0].focus();
	            backspace();
	            evebool = false;
	          }
	          if (keytext === "Clear") {
	            activeinputele[0].focus();
	            keyclear();
	            evebool = false;
	          }
	          if (evebool) {
	            if (shiftbool) {
	              if (keytext.length === 2) {
	                keytext = keytext.substring(0, 1);
	              } else {
	                keytext = keytext.toUpperCase();
	              }
	            } else {
	              if (keytext.length === 2) {
	                keytext = keytext.substring(1, 2);
	              } else {
	                keytext = keytext.toLowerCase();
	              }
	            }
	            clickkey(keytext);
	            if (colorchange) {
	              var oldbabkground = $(this).css("background").split(',')[0].split('(')[1];
	              var newbabkground = oldbabkground - colorchangeStep;
	              if (newbabkground < colorchangeMin) {
	                newbabkground = colorchangeMin;
	                alert("min");
	              }
	              $(this).css("background", "rgba(" + newbabkground + "," + newbabkground + "," + newbabkground + ",.9)");
	            }
	          }
	        });
	        keyboard.children("li:eq(" + 21 + ")").mousedown(function (event) {
	          $(this).css({ top: "4.6em", "box-shadow": "inset 0 0.04em 0 rgba(0,0,0,.5)" });
	          keyboard.children("li:eq(" + 31 + ")").css({ top: "0.1em", "box-shadow": "inset 0 0em 0 rgba(0,0,0,.5)" });
	        }).mouseup(function (event) {
	          $(this).css({ top: "4.5em", "box-shadow": " inset 0 0em 0 rgba(0,0,0,.5)" });
	          keyboard.children("li:eq(" + 31 + ")").css({ top: "0px", "box-shadow": " inset 0 0em 0 rgba(0,0,0,.5)" });
	        });
	        keyboard.children("li:eq(" + 31 + ")").mousedown(function (event) {
	          $(this).css({ top: "0.1em", "box-shadow": "inset 0 0em 0 rgba(0,0,0,.5)" });
	          keyboard.children("li:eq(" + 21 + ")").css({ top: "4.6em", "box-shadow": "inset 0 0.04em 0 rgba(0,0,0,.5)" });
	        }).mouseup(function (event) {
	          $(this).css({ top: "0px", "box-shadow": " inset 0 0em 0 rgba(0,0,0,.5)" });
	          keyboard.children("li:eq(" + 21 + ")").css({ top: "4.5em", "box-shadow": " inset 0 0em 0 rgba(0,0,0,.5)" });
	        });
	      }
	
	      inputele.focus(function (event) {
	        activeinputele = inputele;
	        var p = GetScreenPosition(this);
	        if (keyboard.css("display") == "none") {
	          keyboard.css({ "display": "block" });
	        }
	      });
	
	      if (options.clickeve) {
	        inputele.click(function () {
	          activeinputele = inputele;
	          var p = GetScreenPosition(this);
	          if (keyboard.css("display") == "none") {
	            keyboard.css({ "display": "block" });
	          }
	        });
	      }
	
	      function GetScreenPosition(object) {
	        var position = {};
	        position.x = object.offsetLeft;
	        position.y = object.offsetTop;
	        while (object.offsetParent) {
	          position.x = position.x + object.offsetParent.offsetLeft;
	          position.y = position.y + object.offsetParent.offsetTop;
	          if (object == document.getElementsByTagName("body")[0]) {
	            break;
	          } else {
	            object = object.offsetParent;
	          }
	        }
	        return position;
	      }
	
	      function keyclear() {
	        activeinputele.val("");
	      }
	      function backspace() {
	        var inputtext = activeinputele.val();
	        if (inputtext.length > 0) {
	          inputtext = inputtext.substring(0, inputtext.length - 1);
	          activeinputele.val(inputtext);
	        }
	      }
	      function clickkey(key) {
	        var inputtext = activeinputele.val();
	        inputtext = inputtext + key;
	        activeinputele.val(inputtext);
	        activeinputele[0].focus();
	      }
	
	      function exit() {
	        keyboard.css({ "display": "none" });
	      }
	
	      var drag = new dragMing("#keyboard_5xbogf8c", "#keyboard_5xbogf8c");
	
	      function dragMing(idORclass1, idORclass2) {
	        var obj = this;
	        this.idORclass1 = idORclass1;
	        this.idORclass2 = idORclass2;
	        this.deltaX = 0;
	        this.deltaY = 0;
	
	        function dragStart(dragEvent) {
	          obj.deltaX = dragEvent.clientX - $(obj.idORclass2).offset().left;
	          obj.deltaY = dragEvent.clientY - $(obj.idORclass2).offset().top;
	          $(document).bind("mousemove", dragMove);
	          $(document).bind("mouseup", dragStop);
	          dragEvent.preventDefault();
	        }
	        function dragMove(dragEvent) {
	          $(obj.idORclass2).css({
	            "left": dragEvent.clientX - obj.deltaX + "px",
	            "top": dragEvent.clientY - obj.deltaY + "px"
	          });
	          dragEvent.preventDefault();
	        }
	        function dragStop() {
	          $(document).unbind("mousemove", dragMove);
	          $(document).unbind("mouseup", dragStop);
	        }
	
	        $(document).ready(function () {
	          $(obj.idORclass1).bind("mousedown", dragStart);
	        });
	      }
	
	      function simulateKeyEvent(target, keyCode) {
	        var customEvent = null;
	        var a = (0, _typeof3.default)(document.createEvent);
	
	        if (typeof document.createEvent == "function") {
	          try {
	            customEvent = document.createEvent("KeyEvents");
	            customEvent.initKeyEvent("keypress", true, true, window, false, false, false, false, keyCode, keyCode);
	            target.dispatchEvent(customEvent);
	          } catch (ex) {}
	        } else if (document.createEventObject) {
	          customEvent = document.createEventObject();
	          customEvent.bubbles = true;
	          customEvent.cancelable = true;
	          customEvent.view = window;
	          customEvent.ctrlKey = false;
	          customEvent.altKey = false;
	          customEvent.shiftKey = false;
	          customEvent.metaKey = false;
	          customEvent.keyCode = keyCode;
	          target.fireEvent("onkeypress", customEvent);
	        } else {}
	      }
	    });
	  };
	})(jQuery);
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2), __webpack_require__(2)))

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_jQuery) {'use strict';
	
	var _typeof2 = __webpack_require__(9);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(function ($, undefined) {
	
		var $window = $(window);
	
		function UTCDate() {
			return new Date(Date.UTC.apply(Date, arguments));
		}
		function UTCToday() {
			var today = new Date();
			return UTCDate(today.getFullYear(), today.getMonth(), today.getDate());
		}
		function alias(method) {
			return function () {
				return this[method].apply(this, arguments);
			};
		}
	
		var DateArray = function () {
			var extras = {
				get: function get(i) {
					return this.slice(i)[0];
				},
				contains: function contains(d) {
					var val = d && d.valueOf();
					for (var i = 0, l = this.length; i < l; i++) {
						if (this[i].valueOf() === val) return i;
					}return -1;
				},
				remove: function remove(i) {
					this.splice(i, 1);
				},
				replace: function replace(new_array) {
					if (!new_array) return;
					if (!$.isArray(new_array)) new_array = [new_array];
					this.clear();
					this.push.apply(this, new_array);
				},
				clear: function clear() {
					this.splice(0);
				},
				copy: function copy() {
					var a = new DateArray();
					a.replace(this);
					return a;
				}
			};
	
			return function () {
				var a = [];
				a.push.apply(a, arguments);
				$.extend(a, extras);
				return a;
			};
		}();
	
		var Datepicker = function Datepicker(element, options) {
			this.dates = new DateArray();
			this.viewDate = UTCToday();
			this.focusDate = null;
	
			this._process_options(options);
	
			this.element = $(element);
			this.isInline = false;
			this.isInput = this.element.is('input');
			this.component = this.element.is('.date') ? this.element.find('.add-on, .input-group-addon, .btn') : false;
			this.hasInput = this.component && this.element.find('input').length;
			if (this.component && this.component.length === 0) this.component = false;
	
			this.picker = $(DPGlobal.template);
			this._buildEvents();
			this._attachEvents();
	
			if (this.isInline) {
				this.picker.addClass('datepicker-inline').appendTo(this.element);
			} else {
				this.picker.addClass('datepicker-dropdown dropdown-menu');
			}
	
			if (this.o.rtl) {
				this.picker.addClass('datepicker-rtl');
			}
	
			this.viewMode = this.o.startView;
	
			if (this.o.calendarWeeks) this.picker.find('tfoot th.today').attr('colspan', function (i, val) {
				return parseInt(val) + 1;
			});
	
			this._allow_update = false;
	
			this.setStartDate(this._o.startDate);
			this.setEndDate(this._o.endDate);
			this.setDaysOfWeekDisabled(this.o.daysOfWeekDisabled);
	
			this.fillDow();
			this.fillMonths();
	
			this._allow_update = true;
	
			this.update();
			this.showMode();
	
			if (this.isInline) {
				this.show();
			}
		};
	
		Datepicker.prototype = {
			constructor: Datepicker,
	
			_process_options: function _process_options(opts) {
				this._o = $.extend({}, this._o, opts);
	
				var o = this.o = $.extend({}, this._o);
	
				var lang = o.language;
				if (!dates[lang]) {
					lang = lang.split('-')[0];
					if (!dates[lang]) lang = defaults.language;
				}
				o.language = lang;
	
				switch (o.startView) {
					case 2:
					case 'decade':
						o.startView = 2;
						break;
					case 1:
					case 'year':
						o.startView = 1;
						break;
					default:
						o.startView = 0;
				}
	
				switch (o.minViewMode) {
					case 1:
					case 'months':
						o.minViewMode = 1;
						break;
					case 2:
					case 'years':
						o.minViewMode = 2;
						break;
					default:
						o.minViewMode = 0;
				}
	
				o.startView = Math.max(o.startView, o.minViewMode);
	
				if (o.multidate !== true) {
					o.multidate = Number(o.multidate) || false;
					if (o.multidate !== false) o.multidate = Math.max(0, o.multidate);else o.multidate = 1;
				}
				o.multidateSeparator = String(o.multidateSeparator);
	
				o.weekStart %= 7;
				o.weekEnd = (o.weekStart + 6) % 7;
	
				var format = DPGlobal.parseFormat(o.format);
				if (o.startDate !== -Infinity) {
					if (!!o.startDate) {
						if (o.startDate instanceof Date) o.startDate = this._local_to_utc(this._zero_time(o.startDate));else o.startDate = DPGlobal.parseDate(o.startDate, format, o.language);
					} else {
						o.startDate = -Infinity;
					}
				}
				if (o.endDate !== Infinity) {
					if (!!o.endDate) {
						if (o.endDate instanceof Date) o.endDate = this._local_to_utc(this._zero_time(o.endDate));else o.endDate = DPGlobal.parseDate(o.endDate, format, o.language);
					} else {
						o.endDate = Infinity;
					}
				}
	
				o.daysOfWeekDisabled = o.daysOfWeekDisabled || [];
				if (!$.isArray(o.daysOfWeekDisabled)) o.daysOfWeekDisabled = o.daysOfWeekDisabled.split(/[,\s]*/);
				o.daysOfWeekDisabled = $.map(o.daysOfWeekDisabled, function (d) {
					return parseInt(d, 10);
				});
	
				var plc = String(o.orientation).toLowerCase().split(/\s+/g),
				    _plc = o.orientation.toLowerCase();
				plc = $.grep(plc, function (word) {
					return (/^auto|left|right|top|bottom$/.test(word)
					);
				});
				o.orientation = { x: 'auto', y: 'auto' };
				if (!_plc || _plc === 'auto') ;else if (plc.length === 1) {
						switch (plc[0]) {
							case 'top':
							case 'bottom':
								o.orientation.y = plc[0];
								break;
							case 'left':
							case 'right':
								o.orientation.x = plc[0];
								break;
						}
					} else {
						_plc = $.grep(plc, function (word) {
							return (/^left|right$/.test(word)
							);
						});
						o.orientation.x = _plc[0] || 'auto';
	
						_plc = $.grep(plc, function (word) {
							return (/^top|bottom$/.test(word)
							);
						});
						o.orientation.y = _plc[0] || 'auto';
					}
			},
			_events: [],
			_secondaryEvents: [],
			_applyEvents: function _applyEvents(evs) {
				for (var i = 0, el, ch, ev; i < evs.length; i++) {
					el = evs[i][0];
					if (evs[i].length === 2) {
						ch = undefined;
						ev = evs[i][1];
					} else if (evs[i].length === 3) {
						ch = evs[i][1];
						ev = evs[i][2];
					}
					el.on(ev, ch);
				}
			},
			_unapplyEvents: function _unapplyEvents(evs) {
				for (var i = 0, el, ev, ch; i < evs.length; i++) {
					el = evs[i][0];
					if (evs[i].length === 2) {
						ch = undefined;
						ev = evs[i][1];
					} else if (evs[i].length === 3) {
						ch = evs[i][1];
						ev = evs[i][2];
					}
					el.off(ev, ch);
				}
			},
			_buildEvents: function _buildEvents() {
				if (this.isInput) {
					this._events = [[this.element, {
						focus: $.proxy(this.show, this),
						keyup: $.proxy(function (e) {
							if ($.inArray(e.keyCode, [27, 37, 39, 38, 40, 32, 13, 9]) === -1) this.update();
						}, this),
						keydown: $.proxy(this.keydown, this)
					}]];
				} else if (this.component && this.hasInput) {
					this._events = [[this.element.find('input'), {
						focus: $.proxy(this.show, this),
						keyup: $.proxy(function (e) {
							if ($.inArray(e.keyCode, [27, 37, 39, 38, 40, 32, 13, 9]) === -1) this.update();
						}, this),
						keydown: $.proxy(this.keydown, this)
					}], [this.component, {
						click: $.proxy(this.show, this)
					}]];
				} else if (this.element.is('div')) {
					this.isInline = true;
				} else {
					this._events = [[this.element, {
						click: $.proxy(this.show, this)
					}]];
				}
				this._events.push([this.element, '*', {
					blur: $.proxy(function (e) {
						this._focused_from = e.target;
					}, this)
				}], [this.element, {
					blur: $.proxy(function (e) {
						this._focused_from = e.target;
					}, this)
				}]);
	
				this._secondaryEvents = [[this.picker, {
					click: $.proxy(this.click, this)
				}], [$(window), {
					resize: $.proxy(this.place, this)
				}], [$(document), {
					'mousedown touchstart': $.proxy(function (e) {
						if (!(this.element.is(e.target) || this.element.find(e.target).length || this.picker.is(e.target) || this.picker.find(e.target).length)) {
							this.hide();
						}
					}, this)
				}]];
			},
			_attachEvents: function _attachEvents() {
				this._detachEvents();
				this._applyEvents(this._events);
			},
			_detachEvents: function _detachEvents() {
				this._unapplyEvents(this._events);
			},
			_attachSecondaryEvents: function _attachSecondaryEvents() {
				this._detachSecondaryEvents();
				this._applyEvents(this._secondaryEvents);
			},
			_detachSecondaryEvents: function _detachSecondaryEvents() {
				this._unapplyEvents(this._secondaryEvents);
			},
			_trigger: function _trigger(event, altdate) {
				var date = altdate || this.dates.get(-1),
				    local_date = this._utc_to_local(date);
	
				this.element.trigger({
					type: event,
					date: local_date,
					dates: $.map(this.dates, this._utc_to_local),
					format: $.proxy(function (ix, format) {
						if (arguments.length === 0) {
							ix = this.dates.length - 1;
							format = this.o.format;
						} else if (typeof ix === 'string') {
							format = ix;
							ix = this.dates.length - 1;
						}
						format = format || this.o.format;
						var date = this.dates.get(ix);
						return DPGlobal.formatDate(date, format, this.o.language);
					}, this)
				});
			},
	
			show: function show() {
				if (!this.isInline) this.picker.appendTo('body');
				this.picker.show();
				this.place();
				this._attachSecondaryEvents();
				this._trigger('show');
			},
	
			hide: function hide() {
				if (this.isInline) return;
				if (!this.picker.is(':visible')) return;
				this.focusDate = null;
				this.picker.hide().detach();
				this._detachSecondaryEvents();
				this.viewMode = this.o.startView;
				this.showMode();
	
				if (this.o.forceParse && (this.isInput && this.element.val() || this.hasInput && this.element.find('input').val())) this.setValue();
				this._trigger('hide');
			},
	
			remove: function remove() {
				this.hide();
				this._detachEvents();
				this._detachSecondaryEvents();
				this.picker.remove();
				delete this.element.data().datepicker;
				if (!this.isInput) {
					delete this.element.data().date;
				}
			},
	
			_utc_to_local: function _utc_to_local(utc) {
				return utc && new Date(utc.getTime() + utc.getTimezoneOffset() * 60000);
			},
			_local_to_utc: function _local_to_utc(local) {
				return local && new Date(local.getTime() - local.getTimezoneOffset() * 60000);
			},
			_zero_time: function _zero_time(local) {
				return local && new Date(local.getFullYear(), local.getMonth(), local.getDate());
			},
			_zero_utc_time: function _zero_utc_time(utc) {
				return utc && new Date(Date.UTC(utc.getUTCFullYear(), utc.getUTCMonth(), utc.getUTCDate()));
			},
	
			getDates: function getDates() {
				return $.map(this.dates, this._utc_to_local);
			},
	
			getUTCDates: function getUTCDates() {
				return $.map(this.dates, function (d) {
					return new Date(d);
				});
			},
	
			getDate: function getDate() {
				return this._utc_to_local(this.getUTCDate());
			},
	
			getUTCDate: function getUTCDate() {
				return new Date(this.dates.get(-1));
			},
	
			setDates: function setDates() {
				var args = $.isArray(arguments[0]) ? arguments[0] : arguments;
				this.update.apply(this, args);
				this._trigger('changeDate');
				this.setValue();
			},
	
			setUTCDates: function setUTCDates() {
				var args = $.isArray(arguments[0]) ? arguments[0] : arguments;
				this.update.apply(this, $.map(args, this._utc_to_local));
				this._trigger('changeDate');
				this.setValue();
			},
	
			setDate: alias('setDates'),
			setUTCDate: alias('setUTCDates'),
	
			setValue: function setValue() {
				var formatted = this.getFormattedDate();
				if (!this.isInput) {
					if (this.component) {
						this.element.find('input').val(formatted).change();
					}
				} else {
					this.element.val(formatted).change();
				}
			},
	
			getFormattedDate: function getFormattedDate(format) {
				if (format === undefined) format = this.o.format;
	
				var lang = this.o.language;
				return $.map(this.dates, function (d) {
					return DPGlobal.formatDate(d, format, lang);
				}).join(this.o.multidateSeparator);
			},
	
			setStartDate: function setStartDate(startDate) {
				this._process_options({ startDate: startDate });
				this.update();
				this.updateNavArrows();
			},
	
			setEndDate: function setEndDate(endDate) {
				this._process_options({ endDate: endDate });
				this.update();
				this.updateNavArrows();
			},
	
			setDaysOfWeekDisabled: function setDaysOfWeekDisabled(daysOfWeekDisabled) {
				this._process_options({ daysOfWeekDisabled: daysOfWeekDisabled });
				this.update();
				this.updateNavArrows();
			},
	
			place: function place() {
				if (this.isInline) return;
				var calendarWidth = this.picker.outerWidth(),
				    calendarHeight = this.picker.outerHeight(),
				    visualPadding = 10,
				    windowWidth = $window.width(),
				    windowHeight = $window.height(),
				    scrollTop = $window.scrollTop();
	
				var zIndex = parseInt(this.element.parents().filter(function () {
					return $(this).css('z-index') !== 'auto';
				}).first().css('z-index')) + 2051;
				var offset = this.component ? this.component.parent().offset() : this.element.offset();
				var height = this.component ? this.component.outerHeight(true) : this.element.outerHeight(false);
				var width = this.component ? this.component.outerWidth(true) : this.element.outerWidth(false);
				var left = offset.left,
				    top = offset.top;
	
				this.picker.removeClass('datepicker-orient-top datepicker-orient-bottom ' + 'datepicker-orient-right datepicker-orient-left');
	
				if (this.o.orientation.x !== 'auto') {
					this.picker.addClass('datepicker-orient-' + this.o.orientation.x);
					if (this.o.orientation.x === 'right') left -= calendarWidth - width;
				} else {
						this.picker.addClass('datepicker-orient-left');
						if (offset.left < 0) left -= offset.left - visualPadding;else if (offset.left + calendarWidth > windowWidth) left = windowWidth - calendarWidth - visualPadding;
					}
	
				var yorient = this.o.orientation.y,
				    top_overflow,
				    bottom_overflow;
				if (yorient === 'auto') {
					top_overflow = -scrollTop + offset.top - calendarHeight;
					bottom_overflow = scrollTop + windowHeight - (offset.top + height + calendarHeight);
					if (Math.max(top_overflow, bottom_overflow) === bottom_overflow) yorient = 'top';else yorient = 'bottom';
				}
				this.picker.addClass('datepicker-orient-' + yorient);
				if (yorient === 'top') top += height;else top -= calendarHeight + parseInt(this.picker.css('padding-top'));
	
				this.picker.css({
					top: top,
					left: left,
					zIndex: zIndex
				});
			},
	
			_allow_update: true,
			update: function update() {
				if (!this._allow_update) return;
	
				var oldDates = this.dates.copy(),
				    dates = [],
				    fromArgs = false;
				if (arguments.length) {
					$.each(arguments, $.proxy(function (i, date) {
						if (date instanceof Date) date = this._local_to_utc(date);
						dates.push(date);
					}, this));
					fromArgs = true;
				} else {
					dates = this.isInput ? this.element.val() : this.element.data('date') || this.element.find('input').val();
					if (dates && this.o.multidate) dates = dates.split(this.o.multidateSeparator);else dates = [dates];
					delete this.element.data().date;
				}
	
				dates = $.map(dates, $.proxy(function (date) {
					return DPGlobal.parseDate(date, this.o.format, this.o.language);
				}, this));
				dates = $.grep(dates, $.proxy(function (date) {
					return date < this.o.startDate || date > this.o.endDate || !date;
				}, this), true);
				this.dates.replace(dates);
	
				if (this.dates.length) this.viewDate = new Date(this.dates.get(-1));else if (this.viewDate < this.o.startDate) this.viewDate = new Date(this.o.startDate);else if (this.viewDate > this.o.endDate) this.viewDate = new Date(this.o.endDate);
	
				if (fromArgs) {
					this.setValue();
				} else if (dates.length) {
					if (String(oldDates) !== String(this.dates)) this._trigger('changeDate');
				}
				if (!this.dates.length && oldDates.length) this._trigger('clearDate');
	
				this.fill();
			},
	
			fillDow: function fillDow() {
				var dowCnt = this.o.weekStart,
				    html = '<tr>';
				if (this.o.calendarWeeks) {
					var cell = '<th class="cw">&nbsp;</th>';
					html += cell;
					this.picker.find('.datepicker-days thead tr:first-child').prepend(cell);
				}
				while (dowCnt < this.o.weekStart + 7) {
					html += '<th class="dow">' + dates[this.o.language].daysMin[dowCnt++ % 7] + '</th>';
				}
				html += '</tr>';
				this.picker.find('.datepicker-days thead').append(html);
			},
	
			fillMonths: function fillMonths() {
				var html = '',
				    i = 0;
				while (i < 12) {
					html += '<span class="month">' + dates[this.o.language].monthsShort[i++] + '</span>';
				}
				this.picker.find('.datepicker-months td').html(html);
			},
	
			setRange: function setRange(range) {
				if (!range || !range.length) delete this.range;else this.range = $.map(range, function (d) {
					return d.valueOf();
				});
				this.fill();
			},
	
			getClassNames: function getClassNames(date) {
				var cls = [],
				    year = this.viewDate.getUTCFullYear(),
				    month = this.viewDate.getUTCMonth(),
				    today = new Date();
				if (date.getUTCFullYear() < year || date.getUTCFullYear() === year && date.getUTCMonth() < month) {
					cls.push('old');
				} else if (date.getUTCFullYear() > year || date.getUTCFullYear() === year && date.getUTCMonth() > month) {
					cls.push('new');
				}
				if (this.focusDate && date.valueOf() === this.focusDate.valueOf()) cls.push('focused');
	
				if (this.o.todayHighlight && date.getUTCFullYear() === today.getFullYear() && date.getUTCMonth() === today.getMonth() && date.getUTCDate() === today.getDate()) {
					cls.push('today');
				}
				if (this.dates.contains(date) !== -1) cls.push('active');
				if (date.valueOf() < this.o.startDate || date.valueOf() > this.o.endDate || $.inArray(date.getUTCDay(), this.o.daysOfWeekDisabled) !== -1) {
					cls.push('disabled');
				}
				if (this.range) {
					if (date > this.range[0] && date < this.range[this.range.length - 1]) {
						cls.push('range');
					}
					if ($.inArray(date.valueOf(), this.range) !== -1) {
						cls.push('selected');
					}
				}
				return cls;
			},
	
			fill: function fill() {
				var d = new Date(this.viewDate),
				    year = d.getUTCFullYear(),
				    month = d.getUTCMonth(),
				    startYear = this.o.startDate !== -Infinity ? this.o.startDate.getUTCFullYear() : -Infinity,
				    startMonth = this.o.startDate !== -Infinity ? this.o.startDate.getUTCMonth() : -Infinity,
				    endYear = this.o.endDate !== Infinity ? this.o.endDate.getUTCFullYear() : Infinity,
				    endMonth = this.o.endDate !== Infinity ? this.o.endDate.getUTCMonth() : Infinity,
				    todaytxt = dates[this.o.language].today || dates['en'].today || '',
				    cleartxt = dates[this.o.language].clear || dates['en'].clear || '',
				    tooltip;
				this.picker.find('.datepicker-days thead th.datepicker-switch').text(dates[this.o.language].months[month] + ' ' + year);
				this.picker.find('tfoot th.today').text(todaytxt).toggle(this.o.todayBtn !== false);
				this.picker.find('tfoot th.clear').text(cleartxt).toggle(this.o.clearBtn !== false);
				this.updateNavArrows();
				this.fillMonths();
				var prevMonth = UTCDate(year, month - 1, 28),
				    day = DPGlobal.getDaysInMonth(prevMonth.getUTCFullYear(), prevMonth.getUTCMonth());
				prevMonth.setUTCDate(day);
				prevMonth.setUTCDate(day - (prevMonth.getUTCDay() - this.o.weekStart + 7) % 7);
				var nextMonth = new Date(prevMonth);
				nextMonth.setUTCDate(nextMonth.getUTCDate() + 42);
				nextMonth = nextMonth.valueOf();
				var html = [];
				var clsName;
				while (prevMonth.valueOf() < nextMonth) {
					if (prevMonth.getUTCDay() === this.o.weekStart) {
						html.push('<tr>');
						if (this.o.calendarWeeks) {
							var ws = new Date(+prevMonth + (this.o.weekStart - prevMonth.getUTCDay() - 7) % 7 * 864e5),
							    th = new Date(Number(ws) + (7 + 4 - ws.getUTCDay()) % 7 * 864e5),
							    yth = new Date(Number(yth = UTCDate(th.getUTCFullYear(), 0, 1)) + (7 + 4 - yth.getUTCDay()) % 7 * 864e5),
							    calWeek = (th - yth) / 864e5 / 7 + 1;
							html.push('<td class="cw">' + calWeek + '</td>');
						}
					}
					clsName = this.getClassNames(prevMonth);
					clsName.push('day');
	
					if (this.o.beforeShowDay !== $.noop) {
						var before = this.o.beforeShowDay(this._utc_to_local(prevMonth));
						if (before === undefined) before = {};else if (typeof before === 'boolean') before = { enabled: before };else if (typeof before === 'string') before = { classes: before };
						if (before.enabled === false) clsName.push('disabled');
						if (before.classes) clsName = clsName.concat(before.classes.split(/\s+/));
						if (before.tooltip) tooltip = before.tooltip;
					}
	
					clsName = $.unique(clsName);
					html.push('<td class="' + clsName.join(' ') + '"' + (tooltip ? ' title="' + tooltip + '"' : '') + '>' + prevMonth.getUTCDate() + '</td>');
					if (prevMonth.getUTCDay() === this.o.weekEnd) {
						html.push('</tr>');
					}
					prevMonth.setUTCDate(prevMonth.getUTCDate() + 1);
				}
				this.picker.find('.datepicker-days tbody').empty().append(html.join(''));
	
				var months = this.picker.find('.datepicker-months').find('th:eq(1)').text(year).end().find('span').removeClass('active');
	
				$.each(this.dates, function (i, d) {
					if (d.getUTCFullYear() === year) months.eq(d.getUTCMonth()).addClass('active');
				});
	
				if (year < startYear || year > endYear) {
					months.addClass('disabled');
				}
				if (year === startYear) {
					months.slice(0, startMonth).addClass('disabled');
				}
				if (year === endYear) {
					months.slice(endMonth + 1).addClass('disabled');
				}
	
				html = '';
				year = parseInt(year / 10, 10) * 10;
				var yearCont = this.picker.find('.datepicker-years').find('th:eq(1)').text(year + '-' + (year + 9)).end().find('td');
				year -= 1;
				var years = $.map(this.dates, function (d) {
					return d.getUTCFullYear();
				}),
				    classes;
				for (var i = -1; i < 11; i++) {
					classes = ['year'];
					if (i === -1) classes.push('old');else if (i === 10) classes.push('new');
					if ($.inArray(year, years) !== -1) classes.push('active');
					if (year < startYear || year > endYear) classes.push('disabled');
					html += '<span class="' + classes.join(' ') + '">' + year + '</span>';
					year += 1;
				}
				yearCont.html(html);
			},
	
			updateNavArrows: function updateNavArrows() {
				if (!this._allow_update) return;
	
				var d = new Date(this.viewDate),
				    year = d.getUTCFullYear(),
				    month = d.getUTCMonth();
				switch (this.viewMode) {
					case 0:
						if (this.o.startDate !== -Infinity && year <= this.o.startDate.getUTCFullYear() && month <= this.o.startDate.getUTCMonth()) {
							this.picker.find('.prev').css({ visibility: 'hidden' });
						} else {
							this.picker.find('.prev').css({ visibility: 'visible' });
						}
						if (this.o.endDate !== Infinity && year >= this.o.endDate.getUTCFullYear() && month >= this.o.endDate.getUTCMonth()) {
							this.picker.find('.next').css({ visibility: 'hidden' });
						} else {
							this.picker.find('.next').css({ visibility: 'visible' });
						}
						break;
					case 1:
					case 2:
						if (this.o.startDate !== -Infinity && year <= this.o.startDate.getUTCFullYear()) {
							this.picker.find('.prev').css({ visibility: 'hidden' });
						} else {
							this.picker.find('.prev').css({ visibility: 'visible' });
						}
						if (this.o.endDate !== Infinity && year >= this.o.endDate.getUTCFullYear()) {
							this.picker.find('.next').css({ visibility: 'hidden' });
						} else {
							this.picker.find('.next').css({ visibility: 'visible' });
						}
						break;
				}
			},
	
			click: function click(e) {
				e.preventDefault();
				var target = $(e.target).closest('span, td, th'),
				    year,
				    month,
				    day;
				if (target.length === 1) {
					switch (target[0].nodeName.toLowerCase()) {
						case 'th':
							switch (target[0].className) {
								case 'datepicker-switch':
									this.showMode(1);
									break;
								case 'prev':
								case 'next':
									var dir = DPGlobal.modes[this.viewMode].navStep * (target[0].className === 'prev' ? -1 : 1);
									switch (this.viewMode) {
										case 0:
											this.viewDate = this.moveMonth(this.viewDate, dir);
											this._trigger('changeMonth', this.viewDate);
											break;
										case 1:
										case 2:
											this.viewDate = this.moveYear(this.viewDate, dir);
											if (this.viewMode === 1) this._trigger('changeYear', this.viewDate);
											break;
									}
									this.fill();
									break;
								case 'today':
									var date = new Date();
									date = UTCDate(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0);
	
									this.showMode(-2);
									var which = this.o.todayBtn === 'linked' ? null : 'view';
									this._setDate(date, which);
									break;
								case 'clear':
									var element;
									if (this.isInput) element = this.element;else if (this.component) element = this.element.find('input');
									if (element) element.val("").change();
									this.update();
									this._trigger('changeDate');
									if (this.o.autoclose) this.hide();
									break;
							}
							break;
						case 'span':
							if (!target.is('.disabled')) {
								this.viewDate.setUTCDate(1);
								if (target.is('.month')) {
									day = 1;
									month = target.parent().find('span').index(target);
									year = this.viewDate.getUTCFullYear();
									this.viewDate.setUTCMonth(month);
									this._trigger('changeMonth', this.viewDate);
									if (this.o.minViewMode === 1) {
										this._setDate(UTCDate(year, month, day));
									}
								} else {
									day = 1;
									month = 0;
									year = parseInt(target.text(), 10) || 0;
									this.viewDate.setUTCFullYear(year);
									this._trigger('changeYear', this.viewDate);
									if (this.o.minViewMode === 2) {
										this._setDate(UTCDate(year, month, day));
									}
								}
								this.showMode(-1);
								this.fill();
							}
							break;
						case 'td':
							if (target.is('.day') && !target.is('.disabled')) {
								day = parseInt(target.text(), 10) || 1;
								year = this.viewDate.getUTCFullYear();
								month = this.viewDate.getUTCMonth();
								if (target.is('.old')) {
									if (month === 0) {
										month = 11;
										year -= 1;
									} else {
										month -= 1;
									}
								} else if (target.is('.new')) {
									if (month === 11) {
										month = 0;
										year += 1;
									} else {
										month += 1;
									}
								}
								this._setDate(UTCDate(year, month, day));
							}
							break;
					}
				}
				if (this.picker.is(':visible') && this._focused_from) {
					$(this._focused_from).focus();
				}
				delete this._focused_from;
			},
	
			_toggle_multidate: function _toggle_multidate(date) {
				var ix = this.dates.contains(date);
				if (!date) {
					this.dates.clear();
				} else if (ix !== -1) {
					this.dates.remove(ix);
				} else {
					this.dates.push(date);
				}
				if (typeof this.o.multidate === 'number') while (this.dates.length > this.o.multidate) {
					this.dates.remove(0);
				}
			},
	
			_setDate: function _setDate(date, which) {
				if (!which || which === 'date') this._toggle_multidate(date && new Date(date));
				if (!which || which === 'view') this.viewDate = date && new Date(date);
	
				this.fill();
				this.setValue();
				this._trigger('changeDate');
				var element;
				if (this.isInput) {
					element = this.element;
				} else if (this.component) {
					element = this.element.find('input');
				}
				if (element) {
					element.change();
				}
				if (this.o.autoclose && (!which || which === 'date')) {
					this.hide();
				}
			},
	
			moveMonth: function moveMonth(date, dir) {
				if (!date) return undefined;
				if (!dir) return date;
				var new_date = new Date(date.valueOf()),
				    day = new_date.getUTCDate(),
				    month = new_date.getUTCMonth(),
				    mag = Math.abs(dir),
				    new_month,
				    test;
				dir = dir > 0 ? 1 : -1;
				if (mag === 1) {
					test = dir === -1 ? function () {
						return new_date.getUTCMonth() === month;
					} : function () {
						return new_date.getUTCMonth() !== new_month;
					};
					new_month = month + dir;
					new_date.setUTCMonth(new_month);
	
					if (new_month < 0 || new_month > 11) new_month = (new_month + 12) % 12;
				} else {
					for (var i = 0; i < mag; i++) {
						new_date = this.moveMonth(new_date, dir);
					}
					new_month = new_date.getUTCMonth();
					new_date.setUTCDate(day);
					test = function test() {
						return new_month !== new_date.getUTCMonth();
					};
				}
	
				while (test()) {
					new_date.setUTCDate(--day);
					new_date.setUTCMonth(new_month);
				}
				return new_date;
			},
	
			moveYear: function moveYear(date, dir) {
				return this.moveMonth(date, dir * 12);
			},
	
			dateWithinRange: function dateWithinRange(date) {
				return date >= this.o.startDate && date <= this.o.endDate;
			},
	
			keydown: function keydown(e) {
				if (this.picker.is(':not(:visible)')) {
					if (e.keyCode === 27) this.show();
					return;
				}
				var dateChanged = false,
				    dir,
				    newDate,
				    newViewDate,
				    focusDate = this.focusDate || this.viewDate;
				switch (e.keyCode) {
					case 27:
						if (this.focusDate) {
							this.focusDate = null;
							this.viewDate = this.dates.get(-1) || this.viewDate;
							this.fill();
						} else this.hide();
						e.preventDefault();
						break;
					case 37:
					case 39:
						if (!this.o.keyboardNavigation) break;
						dir = e.keyCode === 37 ? -1 : 1;
						if (e.ctrlKey) {
							newDate = this.moveYear(this.dates.get(-1) || UTCToday(), dir);
							newViewDate = this.moveYear(focusDate, dir);
							this._trigger('changeYear', this.viewDate);
						} else if (e.shiftKey) {
							newDate = this.moveMonth(this.dates.get(-1) || UTCToday(), dir);
							newViewDate = this.moveMonth(focusDate, dir);
							this._trigger('changeMonth', this.viewDate);
						} else {
							newDate = new Date(this.dates.get(-1) || UTCToday());
							newDate.setUTCDate(newDate.getUTCDate() + dir);
							newViewDate = new Date(focusDate);
							newViewDate.setUTCDate(focusDate.getUTCDate() + dir);
						}
						if (this.dateWithinRange(newDate)) {
							this.focusDate = this.viewDate = newViewDate;
							this.setValue();
							this.fill();
							e.preventDefault();
						}
						break;
					case 38:
					case 40:
						if (!this.o.keyboardNavigation) break;
						dir = e.keyCode === 38 ? -1 : 1;
						if (e.ctrlKey) {
							newDate = this.moveYear(this.dates.get(-1) || UTCToday(), dir);
							newViewDate = this.moveYear(focusDate, dir);
							this._trigger('changeYear', this.viewDate);
						} else if (e.shiftKey) {
							newDate = this.moveMonth(this.dates.get(-1) || UTCToday(), dir);
							newViewDate = this.moveMonth(focusDate, dir);
							this._trigger('changeMonth', this.viewDate);
						} else {
							newDate = new Date(this.dates.get(-1) || UTCToday());
							newDate.setUTCDate(newDate.getUTCDate() + dir * 7);
							newViewDate = new Date(focusDate);
							newViewDate.setUTCDate(focusDate.getUTCDate() + dir * 7);
						}
						if (this.dateWithinRange(newDate)) {
							this.focusDate = this.viewDate = newViewDate;
							this.setValue();
							this.fill();
							e.preventDefault();
						}
						break;
					case 32:
						break;
					case 13:
						focusDate = this.focusDate || this.dates.get(-1) || this.viewDate;
						this._toggle_multidate(focusDate);
						dateChanged = true;
						this.focusDate = null;
						this.viewDate = this.dates.get(-1) || this.viewDate;
						this.setValue();
						this.fill();
						if (this.picker.is(':visible')) {
							e.preventDefault();
							if (this.o.autoclose) this.hide();
						}
						break;
					case 9:
						this.focusDate = null;
						this.viewDate = this.dates.get(-1) || this.viewDate;
						this.fill();
						this.hide();
						break;
				}
				if (dateChanged) {
					if (this.dates.length) this._trigger('changeDate');else this._trigger('clearDate');
					var element;
					if (this.isInput) {
						element = this.element;
					} else if (this.component) {
						element = this.element.find('input');
					}
					if (element) {
						element.change();
					}
				}
			},
	
			showMode: function showMode(dir) {
				if (dir) {
					this.viewMode = Math.max(this.o.minViewMode, Math.min(2, this.viewMode + dir));
				}
				this.picker.find('>div').hide().filter('.datepicker-' + DPGlobal.modes[this.viewMode].clsName).css('display', 'block');
				this.updateNavArrows();
			}
		};
	
		var DateRangePicker = function DateRangePicker(element, options) {
			this.element = $(element);
			this.inputs = $.map(options.inputs, function (i) {
				return i.jquery ? i[0] : i;
			});
			delete options.inputs;
	
			$(this.inputs).datepicker(options).bind('changeDate', $.proxy(this.dateUpdated, this));
	
			this.pickers = $.map(this.inputs, function (i) {
				return $(i).data('datepicker');
			});
			this.updateDates();
		};
		DateRangePicker.prototype = {
			updateDates: function updateDates() {
				this.dates = $.map(this.pickers, function (i) {
					return i.getUTCDate();
				});
				this.updateRanges();
			},
			updateRanges: function updateRanges() {
				var range = $.map(this.dates, function (d) {
					return d.valueOf();
				});
				$.each(this.pickers, function (i, p) {
					p.setRange(range);
				});
			},
			dateUpdated: function dateUpdated(e) {
				if (this.updating) return;
				this.updating = true;
	
				var dp = $(e.target).data('datepicker'),
				    new_date = dp.getUTCDate(),
				    i = $.inArray(e.target, this.inputs),
				    l = this.inputs.length;
				if (i === -1) return;
	
				$.each(this.pickers, function (i, p) {
					if (!p.getUTCDate()) p.setUTCDate(new_date);
				});
	
				if (new_date < this.dates[i]) {
					while (i >= 0 && new_date < this.dates[i]) {
						this.pickers[i--].setUTCDate(new_date);
					}
				} else if (new_date > this.dates[i]) {
					while (i < l && new_date > this.dates[i]) {
						this.pickers[i++].setUTCDate(new_date);
					}
				}
				this.updateDates();
	
				delete this.updating;
			},
			remove: function remove() {
				$.map(this.pickers, function (p) {
					p.remove();
				});
				delete this.element.data().datepicker;
			}
		};
	
		function opts_from_el(el, prefix) {
			var data = $(el).data(),
			    out = {},
			    inkey,
			    replace = new RegExp('^' + prefix.toLowerCase() + '([A-Z])');
			prefix = new RegExp('^' + prefix.toLowerCase());
			function re_lower(_, a) {
				return a.toLowerCase();
			}
			for (var key in data) {
				if (prefix.test(key)) {
					inkey = key.replace(replace, re_lower);
					out[inkey] = data[key];
				}
			}return out;
		}
	
		function opts_from_locale(lang) {
			var out = {};
	
			if (!dates[lang]) {
				lang = lang.split('-')[0];
				if (!dates[lang]) return;
			}
			var d = dates[lang];
			$.each(locale_opts, function (i, k) {
				if (k in d) out[k] = d[k];
			});
			return out;
		}
	
		var old = $.fn.datepicker;
		$.fn.datepicker = function (option) {
			var args = Array.apply(null, arguments);
			args.shift();
			var internal_return;
			this.each(function () {
				var $this = $(this),
				    data = $this.data('datepicker'),
				    options = (typeof option === 'undefined' ? 'undefined' : (0, _typeof3.default)(option)) === 'object' && option;
				if (!data) {
					var elopts = opts_from_el(this, 'date'),
					    xopts = $.extend({}, defaults, elopts, options),
					    locopts = opts_from_locale(xopts.language),
					    opts = $.extend({}, defaults, locopts, elopts, options);
					if ($this.is('.input-daterange') || opts.inputs) {
						var ropts = {
							inputs: opts.inputs || $this.find('input').toArray()
						};
						$this.data('datepicker', data = new DateRangePicker(this, $.extend(opts, ropts)));
					} else {
						$this.data('datepicker', data = new Datepicker(this, opts));
					}
				}
				if (typeof option === 'string' && typeof data[option] === 'function') {
					internal_return = data[option].apply(data, args);
					if (internal_return !== undefined) return false;
				}
			});
			if (internal_return !== undefined) return internal_return;else return this;
		};
	
		var defaults = $.fn.datepicker.defaults = {
			autoclose: false,
			beforeShowDay: $.noop,
			calendarWeeks: false,
			clearBtn: false,
			daysOfWeekDisabled: [],
			endDate: Infinity,
			forceParse: true,
			format: 'yyyy-mm-dd',
			keyboardNavigation: true,
			language: 'cn',
			minViewMode: 0,
			multidate: false,
			multidateSeparator: ',',
			orientation: "auto",
			rtl: false,
			startDate: -Infinity,
			startView: 0,
			todayBtn: false,
			todayHighlight: false,
			weekStart: 0
		};
		var locale_opts = $.fn.datepicker.locale_opts = ['format', 'rtl', 'weekStart'];
		$.fn.datepicker.Constructor = Datepicker;
		var dates = $.fn.datepicker.dates = {
			en: {
				days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
				daysShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
				daysMin: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa", "Su"],
				months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
				monthsShort: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
				today: "Today",
				clear: "Clear"
			},
			cn: {
				days: ["周日", "周一", "周二", "周三", "周四", "周五", "周六", "周日"],
				daysShort: ["日", "一", "二", "三", "四", "五", "六", "七"],
				daysMin: ["日", "一", "二", "三", "四", "五", "六", "七"],
				months: ["一月", "二月", "三月", "四月", "五月", "六月", "七月", "八月", "九月", "十月", "十一月", "十二月"],
				monthsShort: ["一月", "二月", "三月", "四月", "五月", "六月", "七月", "八月", "九月", "十月", "十一月", "十二月"],
				today: "今天",
				clear: "清除"
			}
		};
	
		var DPGlobal = {
			modes: [{
				clsName: 'days',
				navFnc: 'Month',
				navStep: 1
			}, {
				clsName: 'months',
				navFnc: 'FullYear',
				navStep: 1
			}, {
				clsName: 'years',
				navFnc: 'FullYear',
				navStep: 10
			}],
			isLeapYear: function isLeapYear(year) {
				return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
			},
			getDaysInMonth: function getDaysInMonth(year, month) {
				return [31, DPGlobal.isLeapYear(year) ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][month];
			},
			validParts: /dd?|DD?|mm?|MM?|yy(?:yy)?/g,
			nonpunctuation: /[^ -\/:-@\[\u3400-\u9fff-`{-~\t\n\r]+/g,
			parseFormat: function parseFormat(format) {
				var separators = format.replace(this.validParts, '\0').split('\0'),
				    parts = format.match(this.validParts);
				if (!separators || !separators.length || !parts || parts.length === 0) {
					throw new Error("Invalid date format.");
				}
				return { separators: separators, parts: parts };
			},
			parseDate: function parseDate(date, format, language) {
				if (!date) return undefined;
				if (date instanceof Date) return date;
				if (typeof format === 'string') format = DPGlobal.parseFormat(format);
				var part_re = /([\-+]\d+)([dmwy])/,
				    parts = date.match(/([\-+]\d+)([dmwy])/g),
				    part,
				    dir,
				    i;
				if (/^[\-+]\d+[dmwy]([\s,]+[\-+]\d+[dmwy])*$/.test(date)) {
					date = new Date();
					for (i = 0; i < parts.length; i++) {
						part = part_re.exec(parts[i]);
						dir = parseInt(part[1]);
						switch (part[2]) {
							case 'd':
								date.setUTCDate(date.getUTCDate() + dir);
								break;
							case 'm':
								date = Datepicker.prototype.moveMonth.call(Datepicker.prototype, date, dir);
								break;
							case 'w':
								date.setUTCDate(date.getUTCDate() + dir * 7);
								break;
							case 'y':
								date = Datepicker.prototype.moveYear.call(Datepicker.prototype, date, dir);
								break;
						}
					}
					return UTCDate(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), 0, 0, 0);
				}
				parts = date && date.match(this.nonpunctuation) || [];
				date = new Date();
				var parsed = {},
				    setters_order = ['yyyy', 'yy', 'M', 'MM', 'm', 'mm', 'd', 'dd'],
				    setters_map = {
					yyyy: function yyyy(d, v) {
						return d.setUTCFullYear(v);
					},
					yy: function yy(d, v) {
						return d.setUTCFullYear(2000 + v);
					},
					m: function m(d, v) {
						if (isNaN(d)) return d;
						v -= 1;
						while (v < 0) {
							v += 12;
						}v %= 12;
						d.setUTCMonth(v);
						while (d.getUTCMonth() !== v) {
							d.setUTCDate(d.getUTCDate() - 1);
						}return d;
					},
					d: function d(_d, v) {
						return _d.setUTCDate(v);
					}
				},
				    val,
				    filtered;
				setters_map['M'] = setters_map['MM'] = setters_map['mm'] = setters_map['m'];
				setters_map['dd'] = setters_map['d'];
				date = UTCDate(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0);
				var fparts = format.parts.slice();
	
				if (parts.length !== fparts.length) {
					fparts = $(fparts).filter(function (i, p) {
						return $.inArray(p, setters_order) !== -1;
					}).toArray();
				}
	
				function match_part() {
					var m = this.slice(0, parts[i].length),
					    p = parts[i].slice(0, m.length);
					return m === p;
				}
				if (parts.length === fparts.length) {
					var cnt;
					for (i = 0, cnt = fparts.length; i < cnt; i++) {
						val = parseInt(parts[i], 10);
						part = fparts[i];
						if (isNaN(val)) {
							switch (part) {
								case 'MM':
									filtered = $(dates[language].months).filter(match_part);
									val = $.inArray(filtered[0], dates[language].months) + 1;
									break;
								case 'M':
									filtered = $(dates[language].monthsShort).filter(match_part);
									val = $.inArray(filtered[0], dates[language].monthsShort) + 1;
									break;
							}
						}
						parsed[part] = val;
					}
					var _date, s;
					for (i = 0; i < setters_order.length; i++) {
						s = setters_order[i];
						if (s in parsed && !isNaN(parsed[s])) {
							_date = new Date(date);
							setters_map[s](_date, parsed[s]);
							if (!isNaN(_date)) date = _date;
						}
					}
				}
				return date;
			},
			formatDate: function formatDate(date, format, language) {
				if (!date) return '';
				if (typeof format === 'string') format = DPGlobal.parseFormat(format);
				var val = {
					d: date.getUTCDate(),
					D: dates[language].daysShort[date.getUTCDay()],
					DD: dates[language].days[date.getUTCDay()],
					m: date.getUTCMonth() + 1,
					M: dates[language].monthsShort[date.getUTCMonth()],
					MM: dates[language].months[date.getUTCMonth()],
					yy: date.getUTCFullYear().toString().substring(2),
					yyyy: date.getUTCFullYear()
				};
				val.dd = (val.d < 10 ? '0' : '') + val.d;
				val.mm = (val.m < 10 ? '0' : '') + val.m;
				date = [];
				var seps = $.extend([], format.separators);
				for (var i = 0, cnt = format.parts.length; i <= cnt; i++) {
					if (seps.length) date.push(seps.shift());
					date.push(val[format.parts[i]]);
				}
				return date.join('');
			},
			headTemplate: '<thead>' + '<tr>' + '<th class="prev">&laquo;</th>' + '<th colspan="5" class="datepicker-switch"></th>' + '<th class="next">&raquo;</th>' + '</tr>' + '</thead>',
			contTemplate: '<tbody><tr><td colspan="7"></td></tr></tbody>',
			footTemplate: '<tfoot>' + '<tr>' + '<th colspan="7" class="today"></th>' + '</tr>' + '<tr>' + '<th colspan="7" class="clear"></th>' + '</tr>' + '</tfoot>'
		};
		DPGlobal.template = '<div class="datepicker">' + '<div class="datepicker-days">' + '<table class=" table-condensed">' + DPGlobal.headTemplate + '<tbody></tbody>' + DPGlobal.footTemplate + '</table>' + '</div>' + '<div class="datepicker-months">' + '<table class="table-condensed">' + DPGlobal.headTemplate + DPGlobal.contTemplate + DPGlobal.footTemplate + '</table>' + '</div>' + '<div class="datepicker-years">' + '<table class="table-condensed">' + DPGlobal.headTemplate + DPGlobal.contTemplate + DPGlobal.footTemplate + '</table>' + '</div>' + '</div>';
	
		$.fn.datepicker.DPGlobal = DPGlobal;
	
		$.fn.datepicker.noConflict = function () {
			$.fn.datepicker = old;
			return this;
		};
	
		$(document).on('focus.datepicker.data-api click.datepicker.data-api', '[data-provide="datepicker"]', function (e) {
			var $this = $(this);
			if ($this.data('datepicker')) return;
			e.preventDefault();
	
			$this.datepicker('show');
		});
		$(function () {
			$('[data-provide="datepicker-inline"]').datepicker();
		});
	})(__webpack_provided_window_dot_jQuery);
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof2 = __webpack_require__(9);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(function (factory) {
	  if (true) !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));else if ((typeof exports === 'undefined' ? 'undefined' : (0, _typeof3.default)(exports)) === 'object') factory(require('jquery'));else factory(jQuery);
	})(function ($, undefined) {
	  if (!('indexOf' in Array.prototype)) {
	    Array.prototype.indexOf = function (find, i) {
	      if (i === undefined) i = 0;
	      if (i < 0) i += this.length;
	      if (i < 0) i = 0;
	      for (var n = this.length; i < n; i++) {
	        if (i in this && this[i] === find) {
	          return i;
	        }
	      }
	      return -1;
	    };
	  }
	
	  function timeZoneAbbreviation() {
	    var abbreviation, date, formattedStr, i, len, matchedStrings, ref, str;
	    date = new Date().toString();
	    formattedStr = ((ref = date.split('(')[1]) != null ? ref.slice(0, -1) : 0) || date.split(' ');
	    if (formattedStr instanceof Array) {
	      matchedStrings = [];
	      for (var i = 0, len = formattedStr.length; i < len; i++) {
	        str = formattedStr[i];
	        if ((abbreviation = (ref = str.match(/\b[A-Z]+\b/)) !== null) ? ref[0] : 0) {
	          matchedStrings.push(abbreviation);
	        }
	      }
	      formattedStr = matchedStrings.pop();
	    }
	    return formattedStr;
	  }
	
	  function UTCDate() {
	    return new Date(Date.UTC.apply(Date, arguments));
	  }
	
	  var Datetimepicker = function Datetimepicker(element, options) {
	    var that = this;
	
	    this.element = $(element);
	
	    this.container = options.container || 'body';
	
	    this.language = options.language || this.element.data('date-language') || 'en';
	    this.language = this.language in dates ? this.language : this.language.split('-')[0];
	    this.language = this.language in dates ? this.language : 'en';
	    this.isRTL = dates[this.language].rtl || false;
	    this.formatType = options.formatType || this.element.data('format-type') || 'standard';
	    this.format = DPGlobal.parseFormat(options.format || this.element.data('date-format') || dates[this.language].format || DPGlobal.getDefaultFormat(this.formatType, 'input'), this.formatType);
	    this.isInline = false;
	    this.isVisible = false;
	    this.isInput = this.element.is('input');
	    this.fontAwesome = options.fontAwesome || this.element.data('font-awesome') || false;
	
	    this.bootcssVer = options.bootcssVer || (this.isInput ? this.element.is('.form-control') ? 3 : 2 : this.bootcssVer = this.element.is('.input-group') ? 3 : 2);
	
	    this.component = this.element.is('.date') ? this.bootcssVer === 3 ? this.element.find('.input-group-addon .glyphicon-th, .input-group-addon .glyphicon-time, .input-group-addon .glyphicon-remove, .input-group-addon .glyphicon-calendar, .input-group-addon .fa-calendar, .input-group-addon .fa-clock-o').parent() : this.element.find('.add-on .icon-th, .add-on .icon-time, .add-on .icon-calendar, .add-on .fa-calendar, .add-on .fa-clock-o').parent() : false;
	    this.componentReset = this.element.is('.date') ? this.bootcssVer === 3 ? this.element.find('.input-group-addon .glyphicon-remove, .input-group-addon .fa-times').parent() : this.element.find('.add-on .icon-remove, .add-on .fa-times').parent() : false;
	    this.hasInput = this.component && this.element.find('input').length;
	    if (this.component && this.component.length === 0) {
	      this.component = false;
	    }
	    this.linkField = options.linkField || this.element.data('link-field') || false;
	    this.linkFormat = DPGlobal.parseFormat(options.linkFormat || this.element.data('link-format') || DPGlobal.getDefaultFormat(this.formatType, 'link'), this.formatType);
	    this.minuteStep = options.minuteStep || this.element.data('minute-step') || 5;
	    this.pickerPosition = options.pickerPosition || this.element.data('picker-position') || 'bottom-right';
	    this.showMeridian = options.showMeridian || this.element.data('show-meridian') || false;
	    this.initialDate = options.initialDate || new Date();
	    this.zIndex = options.zIndex || this.element.data('z-index') || undefined;
	    this.title = typeof options.title === 'undefined' ? false : options.title;
	    this.timezone = options.timezone || timeZoneAbbreviation();
	
	    this.icons = {
	      leftArrow: this.fontAwesome ? 'fa-arrow-left' : this.bootcssVer === 3 ? 'glyphicon-arrow-left' : 'icon-arrow-left',
	      rightArrow: this.fontAwesome ? 'fa-arrow-right' : this.bootcssVer === 3 ? 'glyphicon-arrow-right' : 'icon-arrow-right'
	    };
	    this.icontype = this.fontAwesome ? 'fa' : 'glyphicon';
	
	    this._attachEvents();
	
	    this.clickedOutside = function (e) {
	      if ($(e.target).closest('.datetimepicker').length === 0) {
	        that.hide();
	      }
	    };
	
	    this.formatViewType = 'datetime';
	    if ('formatViewType' in options) {
	      this.formatViewType = options.formatViewType;
	    } else if ('formatViewType' in this.element.data()) {
	      this.formatViewType = this.element.data('formatViewType');
	    }
	
	    this.minView = 0;
	    if ('minView' in options) {
	      this.minView = options.minView;
	    } else if ('minView' in this.element.data()) {
	      this.minView = this.element.data('min-view');
	    }
	    this.minView = DPGlobal.convertViewMode(this.minView);
	
	    this.maxView = DPGlobal.modes.length - 1;
	    if ('maxView' in options) {
	      this.maxView = options.maxView;
	    } else if ('maxView' in this.element.data()) {
	      this.maxView = this.element.data('max-view');
	    }
	    this.maxView = DPGlobal.convertViewMode(this.maxView);
	
	    this.wheelViewModeNavigation = false;
	    if ('wheelViewModeNavigation' in options) {
	      this.wheelViewModeNavigation = options.wheelViewModeNavigation;
	    } else if ('wheelViewModeNavigation' in this.element.data()) {
	      this.wheelViewModeNavigation = this.element.data('view-mode-wheel-navigation');
	    }
	
	    this.wheelViewModeNavigationInverseDirection = false;
	
	    if ('wheelViewModeNavigationInverseDirection' in options) {
	      this.wheelViewModeNavigationInverseDirection = options.wheelViewModeNavigationInverseDirection;
	    } else if ('wheelViewModeNavigationInverseDirection' in this.element.data()) {
	      this.wheelViewModeNavigationInverseDirection = this.element.data('view-mode-wheel-navigation-inverse-dir');
	    }
	
	    this.wheelViewModeNavigationDelay = 100;
	    if ('wheelViewModeNavigationDelay' in options) {
	      this.wheelViewModeNavigationDelay = options.wheelViewModeNavigationDelay;
	    } else if ('wheelViewModeNavigationDelay' in this.element.data()) {
	      this.wheelViewModeNavigationDelay = this.element.data('view-mode-wheel-navigation-delay');
	    }
	
	    this.startViewMode = 2;
	    if ('startView' in options) {
	      this.startViewMode = options.startView;
	    } else if ('startView' in this.element.data()) {
	      this.startViewMode = this.element.data('start-view');
	    }
	    this.startViewMode = DPGlobal.convertViewMode(this.startViewMode);
	    this.viewMode = this.startViewMode;
	
	    this.viewSelect = this.minView;
	    if ('viewSelect' in options) {
	      this.viewSelect = options.viewSelect;
	    } else if ('viewSelect' in this.element.data()) {
	      this.viewSelect = this.element.data('view-select');
	    }
	    this.viewSelect = DPGlobal.convertViewMode(this.viewSelect);
	
	    this.forceParse = true;
	    if ('forceParse' in options) {
	      this.forceParse = options.forceParse;
	    } else if ('dateForceParse' in this.element.data()) {
	      this.forceParse = this.element.data('date-force-parse');
	    }
	    var template = this.bootcssVer === 3 ? DPGlobal.templateV3 : DPGlobal.template;
	    while (template.indexOf('{iconType}') !== -1) {
	      template = template.replace('{iconType}', this.icontype);
	    }
	    while (template.indexOf('{leftArrow}') !== -1) {
	      template = template.replace('{leftArrow}', this.icons.leftArrow);
	    }
	    while (template.indexOf('{rightArrow}') !== -1) {
	      template = template.replace('{rightArrow}', this.icons.rightArrow);
	    }
	    this.picker = $(template).appendTo(this.isInline ? this.element : this.container).on({
	      click: $.proxy(this.click, this),
	      mousedown: $.proxy(this.mousedown, this)
	    });
	
	    if (this.wheelViewModeNavigation) {
	      if ($.fn.mousewheel) {
	        this.picker.on({ mousewheel: $.proxy(this.mousewheel, this) });
	      } else {
	        console.log('Mouse Wheel event is not supported. Please include the jQuery Mouse Wheel plugin before enabling this option');
	      }
	    }
	
	    if (this.isInline) {
	      this.picker.addClass('datetimepicker-inline');
	    } else {
	      this.picker.addClass('datetimepicker-dropdown-' + this.pickerPosition + ' dropdown-menu');
	    }
	    if (this.isRTL) {
	      this.picker.addClass('datetimepicker-rtl');
	      var selector = this.bootcssVer === 3 ? '.prev span, .next span' : '.prev i, .next i';
	      this.picker.find(selector).toggleClass(this.icons.leftArrow + ' ' + this.icons.rightArrow);
	    }
	
	    $(document).on('mousedown touchend', this.clickedOutside);
	
	    this.autoclose = false;
	    if ('autoclose' in options) {
	      this.autoclose = options.autoclose;
	    } else if ('dateAutoclose' in this.element.data()) {
	      this.autoclose = this.element.data('date-autoclose');
	    }
	
	    this.keyboardNavigation = true;
	    if ('keyboardNavigation' in options) {
	      this.keyboardNavigation = options.keyboardNavigation;
	    } else if ('dateKeyboardNavigation' in this.element.data()) {
	      this.keyboardNavigation = this.element.data('date-keyboard-navigation');
	    }
	
	    this.todayBtn = options.todayBtn || this.element.data('date-today-btn') || false;
	    this.clearBtn = options.clearBtn || this.element.data('date-clear-btn') || false;
	    this.todayHighlight = options.todayHighlight || this.element.data('date-today-highlight') || false;
	
	    this.weekStart = 0;
	    if (typeof options.weekStart !== 'undefined') {
	      this.weekStart = options.weekStart;
	    } else if (typeof this.element.data('date-weekstart') !== 'undefined') {
	      this.weekStart = this.element.data('date-weekstart');
	    } else if (typeof dates[this.language].weekStart !== 'undefined') {
	      this.weekStart = dates[this.language].weekStart;
	    }
	    this.weekStart = this.weekStart % 7;
	    this.weekEnd = (this.weekStart + 6) % 7;
	    this.onRenderDay = function (date) {
	      var render = (options.onRenderDay || function () {
	        return [];
	      })(date);
	      if (typeof render === 'string') {
	        render = [render];
	      }
	      var res = ['day'];
	      return res.concat(render ? render : []);
	    };
	    this.onRenderHour = function (date) {
	      var render = (options.onRenderHour || function () {
	        return [];
	      })(date);
	      var res = ['hour'];
	      if (typeof render === 'string') {
	        render = [render];
	      }
	      return res.concat(render ? render : []);
	    };
	    this.onRenderMinute = function (date) {
	      var render = (options.onRenderMinute || function () {
	        return [];
	      })(date);
	      var res = ['minute'];
	      if (typeof render === 'string') {
	        render = [render];
	      }
	      if (date < this.startDate || date > this.endDate) {
	        res.push('disabled');
	      } else if (Math.floor(this.date.getUTCMinutes() / this.minuteStep) === Math.floor(date.getUTCMinutes() / this.minuteStep)) {
	        res.push('active');
	      }
	      return res.concat(render ? render : []);
	    };
	    this.onRenderYear = function (date) {
	      var render = (options.onRenderYear || function () {
	        return [];
	      })(date);
	      var res = ['year'];
	      if (typeof render === 'string') {
	        render = [render];
	      }
	      if (this.date.getUTCFullYear() === date.getUTCFullYear()) {
	        res.push('active');
	      }
	      var currentYear = date.getUTCFullYear();
	      var endYear = this.endDate.getUTCFullYear();
	      if (date < this.startDate || currentYear > endYear) {
	        res.push('disabled');
	      }
	      return res.concat(render ? render : []);
	    };
	    this.onRenderMonth = function (date) {
	      var render = (options.onRenderMonth || function () {
	        return [];
	      })(date);
	      var res = ['month'];
	      if (typeof render === 'string') {
	        render = [render];
	      }
	      return res.concat(render ? render : []);
	    };
	    this.startDate = new Date(-8639968443048000);
	    this.endDate = new Date(8639968443048000);
	    this.datesDisabled = [];
	    this.daysOfWeekDisabled = [];
	    this.setStartDate(options.startDate || this.element.data('date-startdate'));
	    this.setEndDate(options.endDate || this.element.data('date-enddate'));
	    this.setDatesDisabled(options.datesDisabled || this.element.data('date-dates-disabled'));
	    this.setDaysOfWeekDisabled(options.daysOfWeekDisabled || this.element.data('date-days-of-week-disabled'));
	    this.setMinutesDisabled(options.minutesDisabled || this.element.data('date-minute-disabled'));
	    this.setHoursDisabled(options.hoursDisabled || this.element.data('date-hour-disabled'));
	    this.fillDow();
	    this.fillMonths();
	    this.update();
	    this.showMode();
	
	    if (this.isInline) {
	      this.show();
	    }
	  };
	
	  Datetimepicker.prototype = {
	    constructor: Datetimepicker,
	
	    _events: [],
	    _attachEvents: function _attachEvents() {
	      this._detachEvents();
	      if (this.isInput) {
	        this._events = [[this.element, {
	          focus: $.proxy(this.show, this),
	          keyup: $.proxy(this.update, this),
	          keydown: $.proxy(this.keydown, this)
	        }]];
	      } else if (this.component && this.hasInput) {
	        this._events = [[this.element.find('input'), {
	          focus: $.proxy(this.show, this),
	          keyup: $.proxy(this.update, this),
	          keydown: $.proxy(this.keydown, this)
	        }], [this.component, {
	          click: $.proxy(this.show, this)
	        }]];
	        if (this.componentReset) {
	          this._events.push([this.componentReset, { click: $.proxy(this.reset, this) }]);
	        }
	      } else if (this.element.is('div')) {
	        this.isInline = true;
	      } else {
	        this._events = [[this.element, {
	          click: $.proxy(this.show, this)
	        }]];
	      }
	      for (var i = 0, el, ev; i < this._events.length; i++) {
	        el = this._events[i][0];
	        ev = this._events[i][1];
	        el.on(ev);
	      }
	    },
	
	    _detachEvents: function _detachEvents() {
	      for (var i = 0, el, ev; i < this._events.length; i++) {
	        el = this._events[i][0];
	        ev = this._events[i][1];
	        el.off(ev);
	      }
	      this._events = [];
	    },
	
	    show: function show(e) {
	      this.picker.show();
	      this.height = this.component ? this.component.outerHeight() : this.element.outerHeight();
	      if (this.forceParse) {
	        this.update();
	      }
	      this.place();
	      $(window).on('resize', $.proxy(this.place, this));
	      if (e) {
	        e.stopPropagation();
	        e.preventDefault();
	      }
	      this.isVisible = true;
	      this.element.trigger({
	        type: 'show',
	        date: this.date
	      });
	    },
	
	    hide: function hide() {
	      if (!this.isVisible) return;
	      if (this.isInline) return;
	      this.picker.hide();
	      $(window).off('resize', this.place);
	      this.viewMode = this.startViewMode;
	      this.showMode();
	      if (!this.isInput) {
	        $(document).off('mousedown', this.hide);
	      }
	
	      if (this.forceParse && (this.isInput && this.element.val() || this.hasInput && this.element.find('input').val())) this.setValue();
	      this.isVisible = false;
	      this.element.trigger({
	        type: 'hide',
	        date: this.date
	      });
	    },
	
	    remove: function remove() {
	      this._detachEvents();
	      $(document).off('mousedown', this.clickedOutside);
	      this.picker.remove();
	      delete this.picker;
	      delete this.element.data().datetimepicker;
	    },
	
	    getDate: function getDate() {
	      var d = this.getUTCDate();
	      if (d === null) {
	        return null;
	      }
	      return new Date(d.getTime() + d.getTimezoneOffset() * 60000);
	    },
	
	    getUTCDate: function getUTCDate() {
	      return this.date;
	    },
	
	    getInitialDate: function getInitialDate() {
	      return this.initialDate;
	    },
	
	    setInitialDate: function setInitialDate(initialDate) {
	      this.initialDate = initialDate;
	    },
	
	    setDate: function setDate(d) {
	      this.setUTCDate(new Date(d.getTime() - d.getTimezoneOffset() * 60000));
	    },
	
	    setUTCDate: function setUTCDate(d) {
	      if (d >= this.startDate && d <= this.endDate) {
	        this.date = d;
	        this.setValue();
	        this.viewDate = this.date;
	        this.fill();
	      } else {
	        this.element.trigger({
	          type: 'outOfRange',
	          date: d,
	          startDate: this.startDate,
	          endDate: this.endDate
	        });
	      }
	    },
	
	    setFormat: function setFormat(format) {
	      this.format = DPGlobal.parseFormat(format, this.formatType);
	      var element;
	      if (this.isInput) {
	        element = this.element;
	      } else if (this.component) {
	        element = this.element.find('input');
	      }
	      if (element && element.val()) {
	        this.setValue();
	      }
	    },
	
	    setValue: function setValue() {
	      var formatted = this.getFormattedDate();
	      if (!this.isInput) {
	        if (this.component) {
	          this.element.find('input').val(formatted);
	        }
	        this.element.data('date', formatted);
	      } else {
	        this.element.val(formatted);
	      }
	      if (this.linkField) {
	        $('#' + this.linkField).val(this.getFormattedDate(this.linkFormat));
	      }
	    },
	
	    getFormattedDate: function getFormattedDate(format) {
	      format = format || this.format;
	      return DPGlobal.formatDate(this.date, format, this.language, this.formatType, this.timezone);
	    },
	
	    setStartDate: function setStartDate(startDate) {
	      this.startDate = startDate || this.startDate;
	      if (this.startDate.valueOf() !== 8639968443048000) {
	        this.startDate = DPGlobal.parseDate(this.startDate, this.format, this.language, this.formatType, this.timezone);
	      }
	      this.update();
	      this.updateNavArrows();
	    },
	
	    setEndDate: function setEndDate(endDate) {
	      this.endDate = endDate || this.endDate;
	      if (this.endDate.valueOf() !== 8639968443048000) {
	        this.endDate = DPGlobal.parseDate(this.endDate, this.format, this.language, this.formatType, this.timezone);
	      }
	      this.update();
	      this.updateNavArrows();
	    },
	
	    setDatesDisabled: function setDatesDisabled(datesDisabled) {
	      this.datesDisabled = datesDisabled || [];
	      if (!$.isArray(this.datesDisabled)) {
	        this.datesDisabled = this.datesDisabled.split(/,\s*/);
	      }
	      var mThis = this;
	      this.datesDisabled = $.map(this.datesDisabled, function (d) {
	        return DPGlobal.parseDate(d, mThis.format, mThis.language, mThis.formatType, mThis.timezone).toDateString();
	      });
	      this.update();
	      this.updateNavArrows();
	    },
	
	    setTitle: function setTitle(selector, value) {
	      return this.picker.find(selector).find('th:eq(1)').text(this.title === false ? value : this.title);
	    },
	
	    setDaysOfWeekDisabled: function setDaysOfWeekDisabled(daysOfWeekDisabled) {
	      this.daysOfWeekDisabled = daysOfWeekDisabled || [];
	      if (!$.isArray(this.daysOfWeekDisabled)) {
	        this.daysOfWeekDisabled = this.daysOfWeekDisabled.split(/,\s*/);
	      }
	      this.daysOfWeekDisabled = $.map(this.daysOfWeekDisabled, function (d) {
	        return parseInt(d, 10);
	      });
	      this.update();
	      this.updateNavArrows();
	    },
	
	    setMinutesDisabled: function setMinutesDisabled(minutesDisabled) {
	      this.minutesDisabled = minutesDisabled || [];
	      if (!$.isArray(this.minutesDisabled)) {
	        this.minutesDisabled = this.minutesDisabled.split(/,\s*/);
	      }
	      this.minutesDisabled = $.map(this.minutesDisabled, function (d) {
	        return parseInt(d, 10);
	      });
	      this.update();
	      this.updateNavArrows();
	    },
	
	    setHoursDisabled: function setHoursDisabled(hoursDisabled) {
	      this.hoursDisabled = hoursDisabled || [];
	      if (!$.isArray(this.hoursDisabled)) {
	        this.hoursDisabled = this.hoursDisabled.split(/,\s*/);
	      }
	      this.hoursDisabled = $.map(this.hoursDisabled, function (d) {
	        return parseInt(d, 10);
	      });
	      this.update();
	      this.updateNavArrows();
	    },
	
	    place: function place() {
	      if (this.isInline) return;
	
	      if (!this.zIndex) {
	        var index_highest = 0;
	        $('div').each(function () {
	          var index_current = parseInt($(this).css('zIndex'), 10);
	          if (index_current > index_highest) {
	            index_highest = index_current;
	          }
	        });
	        this.zIndex = index_highest + 10;
	      }
	
	      var offset, top, left, containerOffset;
	      if (this.container instanceof $) {
	        containerOffset = this.container.offset();
	      } else {
	        containerOffset = $(this.container).offset();
	      }
	
	      if (this.component) {
	        offset = this.component.offset();
	        left = offset.left;
	        if (this.pickerPosition === 'bottom-left' || this.pickerPosition === 'top-left') {
	          left += this.component.outerWidth() - this.picker.outerWidth();
	        }
	      } else {
	        offset = this.element.offset();
	        left = offset.left;
	        if (this.pickerPosition === 'bottom-left' || this.pickerPosition === 'top-left') {
	          left += this.element.outerWidth() - this.picker.outerWidth();
	        }
	      }
	
	      var bodyWidth = document.body.clientWidth || window.innerWidth;
	      if (left + 220 > bodyWidth) {
	        left = bodyWidth - 220;
	      }
	
	      if (this.pickerPosition === 'top-left' || this.pickerPosition === 'top-right') {
	        top = offset.top - this.picker.outerHeight();
	      } else {
	        top = offset.top + this.height;
	      }
	
	      top = top - containerOffset.top;
	      left = left - containerOffset.left;
	
	      this.picker.css({
	        top: top,
	        left: left,
	        zIndex: this.zIndex
	      });
	    },
	
	    hour_minute: "^([0-9]|0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]",
	
	    update: function update() {
	      var date,
	          fromArgs = false;
	      if (arguments && arguments.length && (typeof arguments[0] === 'string' || arguments[0] instanceof Date)) {
	        date = arguments[0];
	        fromArgs = true;
	      } else {
	        date = (this.isInput ? this.element.val() : this.element.find('input').val()) || this.element.data('date') || this.initialDate;
	        if (typeof date === 'string') {
	          date = date.replace(/^\s+|\s+$/g, '');
	        }
	      }
	
	      if (!date) {
	        date = new Date();
	        fromArgs = false;
	      }
	
	      if (typeof date === "string") {
	        if (new RegExp(this.hour_minute).test(date) || new RegExp(this.hour_minute + ":[0-5][0-9]").test(date)) {
	          date = this.getDate();
	        }
	      }
	
	      this.date = DPGlobal.parseDate(date, this.format, this.language, this.formatType, this.timezone);
	
	      if (fromArgs) this.setValue();
	
	      if (this.date < this.startDate) {
	        this.viewDate = new Date(this.startDate);
	      } else if (this.date > this.endDate) {
	        this.viewDate = new Date(this.endDate);
	      } else {
	        this.viewDate = new Date(this.date);
	      }
	      this.fill();
	    },
	
	    fillDow: function fillDow() {
	      var dowCnt = this.weekStart,
	          html = '<tr>';
	      while (dowCnt < this.weekStart + 7) {
	        html += '<th class="dow">' + dates[this.language].daysMin[dowCnt++ % 7] + '</th>';
	      }
	      html += '</tr>';
	      this.picker.find('.datetimepicker-days thead').append(html);
	    },
	
	    fillMonths: function fillMonths() {
	      var html = '';
	      var d = new Date(this.viewDate);
	      for (var i = 0; i < 12; i++) {
	        d.setUTCMonth(i);
	        var classes = this.onRenderMonth(d);
	        html += '<span class="' + classes.join(' ') + '">' + dates[this.language].monthsShort[i] + '</span>';
	      }
	      this.picker.find('.datetimepicker-months td').html(html);
	    },
	
	    fill: function fill() {
	      if (!this.date || !this.viewDate) {
	        return;
	      }
	      var d = new Date(this.viewDate),
	          year = d.getUTCFullYear(),
	          month = d.getUTCMonth(),
	          dayMonth = d.getUTCDate(),
	          hours = d.getUTCHours(),
	          startYear = this.startDate.getUTCFullYear(),
	          startMonth = this.startDate.getUTCMonth(),
	          endYear = this.endDate.getUTCFullYear(),
	          endMonth = this.endDate.getUTCMonth() + 1,
	          currentDate = new UTCDate(this.date.getUTCFullYear(), this.date.getUTCMonth(), this.date.getUTCDate()).valueOf(),
	          today = new Date();
	      this.setTitle('.datetimepicker-days', dates[this.language].months[month] + ' ' + year);
	      if (this.formatViewType === 'time') {
	        var formatted = this.getFormattedDate();
	        this.setTitle('.datetimepicker-hours', formatted);
	        this.setTitle('.datetimepicker-minutes', formatted);
	      } else {
	        this.setTitle('.datetimepicker-hours', dayMonth + ' ' + dates[this.language].months[month] + ' ' + year);
	        this.setTitle('.datetimepicker-minutes', dayMonth + ' ' + dates[this.language].months[month] + ' ' + year);
	      }
	      this.picker.find('tfoot th.today').text(dates[this.language].today || dates['en'].today).toggle(this.todayBtn !== false);
	      this.picker.find('tfoot th.clear').text(dates[this.language].clear || dates['en'].clear).toggle(this.clearBtn !== false);
	      this.updateNavArrows();
	      this.fillMonths();
	      var prevMonth = UTCDate(year, month - 1, 28, 0, 0, 0, 0),
	          day = DPGlobal.getDaysInMonth(prevMonth.getUTCFullYear(), prevMonth.getUTCMonth());
	      prevMonth.setUTCDate(day);
	      prevMonth.setUTCDate(day - (prevMonth.getUTCDay() - this.weekStart + 7) % 7);
	      var nextMonth = new Date(prevMonth);
	      nextMonth.setUTCDate(nextMonth.getUTCDate() + 42);
	      nextMonth = nextMonth.valueOf();
	      var html = [];
	      var classes;
	      while (prevMonth.valueOf() < nextMonth) {
	        if (prevMonth.getUTCDay() === this.weekStart) {
	          html.push('<tr>');
	        }
	        classes = this.onRenderDay(prevMonth);
	        if (prevMonth.getUTCFullYear() < year || prevMonth.getUTCFullYear() === year && prevMonth.getUTCMonth() < month) {
	          classes.push('old');
	        } else if (prevMonth.getUTCFullYear() > year || prevMonth.getUTCFullYear() === year && prevMonth.getUTCMonth() > month) {
	          classes.push('new');
	        }
	
	        if (this.todayHighlight && prevMonth.getUTCFullYear() === today.getFullYear() && prevMonth.getUTCMonth() === today.getMonth() && prevMonth.getUTCDate() === today.getDate()) {
	          classes.push('today');
	        }
	        if (prevMonth.valueOf() === currentDate) {
	          classes.push('active');
	        }
	        if (prevMonth.valueOf() + 86400000 <= this.startDate || prevMonth.valueOf() > this.endDate || $.inArray(prevMonth.getUTCDay(), this.daysOfWeekDisabled) !== -1 || $.inArray(prevMonth.toDateString(), this.datesDisabled) !== -1) {
	          classes.push('disabled');
	        }
	        html.push('<td class="' + classes.join(' ') + '">' + prevMonth.getUTCDate() + '</td>');
	        if (prevMonth.getUTCDay() === this.weekEnd) {
	          html.push('</tr>');
	        }
	        prevMonth.setUTCDate(prevMonth.getUTCDate() + 1);
	      }
	      this.picker.find('.datetimepicker-days tbody').empty().append(html.join(''));
	
	      html = [];
	      var txt = '',
	          meridian = '',
	          meridianOld = '';
	      var hoursDisabled = this.hoursDisabled || [];
	      d = new Date(this.viewDate);
	      for (var i = 0; i < 24; i++) {
	        d.setUTCHours(i);
	        classes = this.onRenderHour(d);
	        if (hoursDisabled.indexOf(i) !== -1) {
	          classes.push('disabled');
	        }
	        var actual = UTCDate(year, month, dayMonth, i);
	
	        if (actual.valueOf() + 3600000 <= this.startDate || actual.valueOf() > this.endDate) {
	          classes.push('disabled');
	        } else if (hours === i) {
	          classes.push('active');
	        }
	        if (this.showMeridian && dates[this.language].meridiem.length === 2) {
	          meridian = i < 12 ? dates[this.language].meridiem[0] : dates[this.language].meridiem[1];
	          if (meridian !== meridianOld) {
	            if (meridianOld !== '') {
	              html.push('</fieldset>');
	            }
	            html.push('<fieldset class="hour"><legend>' + meridian.toUpperCase() + '</legend>');
	          }
	          meridianOld = meridian;
	          txt = i % 12 ? i % 12 : 12;
	          if (i < 12) {
	            classes.push('hour_am');
	          } else {
	            classes.push('hour_pm');
	          }
	          html.push('<span class="' + classes.join(' ') + '">' + txt + '</span>');
	          if (i === 23) {
	            html.push('</fieldset>');
	          }
	        } else {
	          txt = i + ':00';
	          html.push('<span class="' + classes.join(' ') + '">' + txt + '</span>');
	        }
	      }
	      this.picker.find('.datetimepicker-hours td').html(html.join(''));
	
	      html = [];
	      txt = '';
	      meridian = '';
	      meridianOld = '';
	      var minutesDisabled = this.minutesDisabled || [];
	      d = new Date(this.viewDate);
	      for (var i = 0; i < 60; i += this.minuteStep) {
	        if (minutesDisabled.indexOf(i) !== -1) continue;
	        d.setUTCMinutes(i);
	        d.setUTCSeconds(0);
	        classes = this.onRenderMinute(d);
	        if (this.showMeridian && dates[this.language].meridiem.length === 2) {
	          meridian = hours < 12 ? dates[this.language].meridiem[0] : dates[this.language].meridiem[1];
	          if (meridian !== meridianOld) {
	            if (meridianOld !== '') {
	              html.push('</fieldset>');
	            }
	            html.push('<fieldset class="minute"><legend>' + meridian.toUpperCase() + '</legend>');
	          }
	          meridianOld = meridian;
	          txt = hours % 12 ? hours % 12 : 12;
	          html.push('<span class="' + classes.join(' ') + '">' + txt + ':' + (i < 10 ? '0' + i : i) + '</span>');
	          if (i === 59) {
	            html.push('</fieldset>');
	          }
	        } else {
	          txt = i + ':00';
	          html.push('<span class="' + classes.join(' ') + '">' + hours + ':' + (i < 10 ? '0' + i : i) + '</span>');
	        }
	      }
	      this.picker.find('.datetimepicker-minutes td').html(html.join(''));
	
	      var currentYear = this.date.getUTCFullYear();
	      var months = this.setTitle('.datetimepicker-months', year).end().find('.month').removeClass('active');
	      if (currentYear === year) {
	        months.eq(this.date.getUTCMonth()).addClass('active');
	      }
	      if (year < startYear || year > endYear) {
	        months.addClass('disabled');
	      }
	      if (year === startYear) {
	        months.slice(0, startMonth).addClass('disabled');
	      }
	      if (year === endYear) {
	        months.slice(endMonth).addClass('disabled');
	      }
	
	      html = '';
	      year = parseInt(year / 10, 10) * 10;
	      var yearCont = this.setTitle('.datetimepicker-years', year + '-' + (year + 9)).end().find('td');
	      year -= 1;
	      d = new Date(this.viewDate);
	      for (var i = -1; i < 11; i++) {
	        d.setUTCFullYear(year);
	        classes = this.onRenderYear(d);
	        if (i === -1 || i === 10) {
	          classes.push(old);
	        }
	        html += '<span class="' + classes.join(' ') + '">' + year + '</span>';
	        year += 1;
	      }
	      yearCont.html(html);
	      this.place();
	    },
	
	    updateNavArrows: function updateNavArrows() {
	      var d = new Date(this.viewDate),
	          year = d.getUTCFullYear(),
	          month = d.getUTCMonth(),
	          day = d.getUTCDate(),
	          hour = d.getUTCHours();
	      switch (this.viewMode) {
	        case 0:
	          if (year <= this.startDate.getUTCFullYear() && month <= this.startDate.getUTCMonth() && day <= this.startDate.getUTCDate() && hour <= this.startDate.getUTCHours()) {
	            this.picker.find('.prev').css({ visibility: 'hidden' });
	          } else {
	            this.picker.find('.prev').css({ visibility: 'visible' });
	          }
	          if (year >= this.endDate.getUTCFullYear() && month >= this.endDate.getUTCMonth() && day >= this.endDate.getUTCDate() && hour >= this.endDate.getUTCHours()) {
	            this.picker.find('.next').css({ visibility: 'hidden' });
	          } else {
	            this.picker.find('.next').css({ visibility: 'visible' });
	          }
	          break;
	        case 1:
	          if (year <= this.startDate.getUTCFullYear() && month <= this.startDate.getUTCMonth() && day <= this.startDate.getUTCDate()) {
	            this.picker.find('.prev').css({ visibility: 'hidden' });
	          } else {
	            this.picker.find('.prev').css({ visibility: 'visible' });
	          }
	          if (year >= this.endDate.getUTCFullYear() && month >= this.endDate.getUTCMonth() && day >= this.endDate.getUTCDate()) {
	            this.picker.find('.next').css({ visibility: 'hidden' });
	          } else {
	            this.picker.find('.next').css({ visibility: 'visible' });
	          }
	          break;
	        case 2:
	          if (year <= this.startDate.getUTCFullYear() && month <= this.startDate.getUTCMonth()) {
	            this.picker.find('.prev').css({ visibility: 'hidden' });
	          } else {
	            this.picker.find('.prev').css({ visibility: 'visible' });
	          }
	          if (year >= this.endDate.getUTCFullYear() && month >= this.endDate.getUTCMonth()) {
	            this.picker.find('.next').css({ visibility: 'hidden' });
	          } else {
	            this.picker.find('.next').css({ visibility: 'visible' });
	          }
	          break;
	        case 3:
	        case 4:
	          if (year <= this.startDate.getUTCFullYear()) {
	            this.picker.find('.prev').css({ visibility: 'hidden' });
	          } else {
	            this.picker.find('.prev').css({ visibility: 'visible' });
	          }
	          if (year >= this.endDate.getUTCFullYear()) {
	            this.picker.find('.next').css({ visibility: 'hidden' });
	          } else {
	            this.picker.find('.next').css({ visibility: 'visible' });
	          }
	          break;
	      }
	    },
	
	    mousewheel: function mousewheel(e) {
	
	      e.preventDefault();
	      e.stopPropagation();
	
	      if (this.wheelPause) {
	        return;
	      }
	
	      this.wheelPause = true;
	
	      var originalEvent = e.originalEvent;
	
	      var delta = originalEvent.wheelDelta;
	
	      var mode = delta > 0 ? 1 : delta === 0 ? 0 : -1;
	
	      if (this.wheelViewModeNavigationInverseDirection) {
	        mode = -mode;
	      }
	
	      this.showMode(mode);
	
	      setTimeout($.proxy(function () {
	
	        this.wheelPause = false;
	      }, this), this.wheelViewModeNavigationDelay);
	    },
	
	    click: function click(e) {
	      e.stopPropagation();
	      e.preventDefault();
	      var target = $(e.target).closest('span, td, th, legend');
	      if (target.is('.' + this.icontype)) {
	        target = $(target).parent().closest('span, td, th, legend');
	      }
	      if (target.length === 1) {
	        if (target.is('.disabled')) {
	          this.element.trigger({
	            type: 'outOfRange',
	            date: this.viewDate,
	            startDate: this.startDate,
	            endDate: this.endDate
	          });
	          return;
	        }
	        switch (target[0].nodeName.toLowerCase()) {
	          case 'th':
	            switch (target[0].className) {
	              case 'switch':
	                this.showMode(1);
	                break;
	              case 'prev':
	              case 'next':
	                var dir = DPGlobal.modes[this.viewMode].navStep * (target[0].className === 'prev' ? -1 : 1);
	                switch (this.viewMode) {
	                  case 0:
	                    this.viewDate = this.moveHour(this.viewDate, dir);
	                    break;
	                  case 1:
	                    this.viewDate = this.moveDate(this.viewDate, dir);
	                    break;
	                  case 2:
	                    this.viewDate = this.moveMonth(this.viewDate, dir);
	                    break;
	                  case 3:
	                  case 4:
	                    this.viewDate = this.moveYear(this.viewDate, dir);
	                    break;
	                }
	                this.fill();
	                this.element.trigger({
	                  type: target[0].className + ':' + this.convertViewModeText(this.viewMode),
	                  date: this.viewDate,
	                  startDate: this.startDate,
	                  endDate: this.endDate
	                });
	                break;
	              case 'clear':
	                this.reset();
	                if (this.autoclose) {
	                  this.hide();
	                }
	                break;
	              case 'today':
	                var date = new Date();
	                date = UTCDate(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), 0);
	
	                if (date < this.startDate) date = this.startDate;else if (date > this.endDate) date = this.endDate;
	
	                this.viewMode = this.startViewMode;
	                this.showMode(0);
	                this._setDate(date);
	                this.fill();
	                if (this.autoclose) {
	                  this.hide();
	                }
	                break;
	            }
	            break;
	          case 'span':
	            if (!target.is('.disabled')) {
	              var year = this.viewDate.getUTCFullYear(),
	                  month = this.viewDate.getUTCMonth(),
	                  day = this.viewDate.getUTCDate(),
	                  hours = this.viewDate.getUTCHours(),
	                  minutes = this.viewDate.getUTCMinutes(),
	                  seconds = this.viewDate.getUTCSeconds();
	
	              if (target.is('.month')) {
	                this.viewDate.setUTCDate(1);
	                month = target.parent().find('span').index(target);
	                day = this.viewDate.getUTCDate();
	                this.viewDate.setUTCMonth(month);
	                this.element.trigger({
	                  type: 'changeMonth',
	                  date: this.viewDate
	                });
	                if (this.viewSelect >= 3) {
	                  this._setDate(UTCDate(year, month, day, hours, minutes, seconds, 0));
	                }
	              } else if (target.is('.year')) {
	                this.viewDate.setUTCDate(1);
	                year = parseInt(target.text(), 10) || 0;
	                this.viewDate.setUTCFullYear(year);
	                this.element.trigger({
	                  type: 'changeYear',
	                  date: this.viewDate
	                });
	                if (this.viewSelect >= 4) {
	                  this._setDate(UTCDate(year, month, day, hours, minutes, seconds, 0));
	                }
	              } else if (target.is('.hour')) {
	                hours = parseInt(target.text(), 10) || 0;
	                if (target.hasClass('hour_am') || target.hasClass('hour_pm')) {
	                  if (hours === 12 && target.hasClass('hour_am')) {
	                    hours = 0;
	                  } else if (hours !== 12 && target.hasClass('hour_pm')) {
	                    hours += 12;
	                  }
	                }
	                this.viewDate.setUTCHours(hours);
	                this.element.trigger({
	                  type: 'changeHour',
	                  date: this.viewDate
	                });
	                if (this.viewSelect >= 1) {
	                  this._setDate(UTCDate(year, month, day, hours, minutes, seconds, 0));
	                }
	              } else if (target.is('.minute')) {
	                minutes = parseInt(target.text().substr(target.text().indexOf(':') + 1), 10) || 0;
	                this.viewDate.setUTCMinutes(minutes);
	                this.element.trigger({
	                  type: 'changeMinute',
	                  date: this.viewDate
	                });
	                if (this.viewSelect >= 0) {
	                  this._setDate(UTCDate(year, month, day, hours, minutes, seconds, 0));
	                }
	              }
	              if (this.viewMode !== 0) {
	                var oldViewMode = this.viewMode;
	                this.showMode(-1);
	                this.fill();
	                if (oldViewMode === this.viewMode && this.autoclose) {
	                  this.hide();
	                }
	              } else {
	                this.fill();
	                if (this.autoclose) {
	                  this.hide();
	                }
	              }
	            }
	            break;
	          case 'td':
	            if (target.is('.day') && !target.is('.disabled')) {
	              var day = parseInt(target.text(), 10) || 1;
	              var year = this.viewDate.getUTCFullYear(),
	                  month = this.viewDate.getUTCMonth(),
	                  hours = this.viewDate.getUTCHours(),
	                  minutes = this.viewDate.getUTCMinutes(),
	                  seconds = this.viewDate.getUTCSeconds();
	              if (target.is('.old')) {
	                if (month === 0) {
	                  month = 11;
	                  year -= 1;
	                } else {
	                  month -= 1;
	                }
	              } else if (target.is('.new')) {
	                if (month === 11) {
	                  month = 0;
	                  year += 1;
	                } else {
	                  month += 1;
	                }
	              }
	              this.viewDate.setUTCFullYear(year);
	              this.viewDate.setUTCMonth(month, day);
	              this.element.trigger({
	                type: 'changeDay',
	                date: this.viewDate
	              });
	              if (this.viewSelect >= 2) {
	                this._setDate(UTCDate(year, month, day, hours, minutes, seconds, 0));
	              }
	            }
	            var oldViewMode = this.viewMode;
	            this.showMode(-1);
	            this.fill();
	            if (oldViewMode === this.viewMode && this.autoclose) {
	              this.hide();
	            }
	            break;
	        }
	      }
	    },
	
	    _setDate: function _setDate(date, which) {
	      if (!which || which === 'date') this.date = date;
	      if (!which || which === 'view') this.viewDate = date;
	      this.fill();
	      this.setValue();
	      var element;
	      if (this.isInput) {
	        element = this.element;
	      } else if (this.component) {
	        element = this.element.find('input');
	      }
	      if (element) {
	        element.change();
	      }
	      this.element.trigger({
	        type: 'changeDate',
	        date: this.getDate()
	      });
	      if (date === null) this.date = this.viewDate;
	    },
	
	    moveMinute: function moveMinute(date, dir) {
	      if (!dir) return date;
	      var new_date = new Date(date.valueOf());
	
	      new_date.setUTCMinutes(new_date.getUTCMinutes() + dir * this.minuteStep);
	      return new_date;
	    },
	
	    moveHour: function moveHour(date, dir) {
	      if (!dir) return date;
	      var new_date = new Date(date.valueOf());
	
	      new_date.setUTCHours(new_date.getUTCHours() + dir);
	      return new_date;
	    },
	
	    moveDate: function moveDate(date, dir) {
	      if (!dir) return date;
	      var new_date = new Date(date.valueOf());
	
	      new_date.setUTCDate(new_date.getUTCDate() + dir);
	      return new_date;
	    },
	
	    moveMonth: function moveMonth(date, dir) {
	      if (!dir) return date;
	      var new_date = new Date(date.valueOf()),
	          day = new_date.getUTCDate(),
	          month = new_date.getUTCMonth(),
	          mag = Math.abs(dir),
	          new_month,
	          test;
	      dir = dir > 0 ? 1 : -1;
	      if (mag === 1) {
	        test = dir === -1 ? function () {
	          return new_date.getUTCMonth() === month;
	        } : function () {
	          return new_date.getUTCMonth() !== new_month;
	        };
	        new_month = month + dir;
	        new_date.setUTCMonth(new_month);
	
	        if (new_month < 0 || new_month > 11) new_month = (new_month + 12) % 12;
	      } else {
	        for (var i = 0; i < mag; i++) {
	          new_date = this.moveMonth(new_date, dir);
	        }
	        new_month = new_date.getUTCMonth();
	        new_date.setUTCDate(day);
	        test = function test() {
	          return new_month !== new_date.getUTCMonth();
	        };
	      }
	
	      while (test()) {
	        new_date.setUTCDate(--day);
	        new_date.setUTCMonth(new_month);
	      }
	      return new_date;
	    },
	
	    moveYear: function moveYear(date, dir) {
	      return this.moveMonth(date, dir * 12);
	    },
	
	    dateWithinRange: function dateWithinRange(date) {
	      return date >= this.startDate && date <= this.endDate;
	    },
	
	    keydown: function keydown(e) {
	      if (this.picker.is(':not(:visible)')) {
	        if (e.keyCode === 27) this.show();
	        return;
	      }
	      var dateChanged = false,
	          dir,
	          newDate,
	          newViewDate;
	      switch (e.keyCode) {
	        case 27:
	          this.hide();
	          e.preventDefault();
	          break;
	        case 37:
	        case 39:
	          if (!this.keyboardNavigation) break;
	          dir = e.keyCode === 37 ? -1 : 1;
	          var viewMode = this.viewMode;
	          if (e.ctrlKey) {
	            viewMode += 2;
	          } else if (e.shiftKey) {
	            viewMode += 1;
	          }
	          if (viewMode === 4) {
	            newDate = this.moveYear(this.date, dir);
	            newViewDate = this.moveYear(this.viewDate, dir);
	          } else if (viewMode === 3) {
	            newDate = this.moveMonth(this.date, dir);
	            newViewDate = this.moveMonth(this.viewDate, dir);
	          } else if (viewMode === 2) {
	            newDate = this.moveDate(this.date, dir);
	            newViewDate = this.moveDate(this.viewDate, dir);
	          } else if (viewMode === 1) {
	            newDate = this.moveHour(this.date, dir);
	            newViewDate = this.moveHour(this.viewDate, dir);
	          } else if (viewMode === 0) {
	            newDate = this.moveMinute(this.date, dir);
	            newViewDate = this.moveMinute(this.viewDate, dir);
	          }
	          if (this.dateWithinRange(newDate)) {
	            this.date = newDate;
	            this.viewDate = newViewDate;
	            this.setValue();
	            this.update();
	            e.preventDefault();
	            dateChanged = true;
	          }
	          break;
	        case 38:
	        case 40:
	          if (!this.keyboardNavigation) break;
	          dir = e.keyCode === 38 ? -1 : 1;
	          viewMode = this.viewMode;
	          if (e.ctrlKey) {
	            viewMode += 2;
	          } else if (e.shiftKey) {
	            viewMode += 1;
	          }
	          if (viewMode === 4) {
	            newDate = this.moveYear(this.date, dir);
	            newViewDate = this.moveYear(this.viewDate, dir);
	          } else if (viewMode === 3) {
	            newDate = this.moveMonth(this.date, dir);
	            newViewDate = this.moveMonth(this.viewDate, dir);
	          } else if (viewMode === 2) {
	            newDate = this.moveDate(this.date, dir * 7);
	            newViewDate = this.moveDate(this.viewDate, dir * 7);
	          } else if (viewMode === 1) {
	            if (this.showMeridian) {
	              newDate = this.moveHour(this.date, dir * 6);
	              newViewDate = this.moveHour(this.viewDate, dir * 6);
	            } else {
	              newDate = this.moveHour(this.date, dir * 4);
	              newViewDate = this.moveHour(this.viewDate, dir * 4);
	            }
	          } else if (viewMode === 0) {
	            newDate = this.moveMinute(this.date, dir * 4);
	            newViewDate = this.moveMinute(this.viewDate, dir * 4);
	          }
	          if (this.dateWithinRange(newDate)) {
	            this.date = newDate;
	            this.viewDate = newViewDate;
	            this.setValue();
	            this.update();
	            e.preventDefault();
	            dateChanged = true;
	          }
	          break;
	        case 13:
	          if (this.viewMode !== 0) {
	            var oldViewMode = this.viewMode;
	            this.showMode(-1);
	            this.fill();
	            if (oldViewMode === this.viewMode && this.autoclose) {
	              this.hide();
	            }
	          } else {
	            this.fill();
	            if (this.autoclose) {
	              this.hide();
	            }
	          }
	          e.preventDefault();
	          break;
	        case 9:
	          this.hide();
	          break;
	      }
	      if (dateChanged) {
	        var element;
	        if (this.isInput) {
	          element = this.element;
	        } else if (this.component) {
	          element = this.element.find('input');
	        }
	        if (element) {
	          element.change();
	        }
	        this.element.trigger({
	          type: 'changeDate',
	          date: this.getDate()
	        });
	      }
	    },
	
	    showMode: function showMode(dir) {
	      if (dir) {
	        var newViewMode = Math.max(0, Math.min(DPGlobal.modes.length - 1, this.viewMode + dir));
	        if (newViewMode >= this.minView && newViewMode <= this.maxView) {
	          this.element.trigger({
	            type: 'changeMode',
	            date: this.viewDate,
	            oldViewMode: this.viewMode,
	            newViewMode: newViewMode
	          });
	
	          this.viewMode = newViewMode;
	        }
	      }
	
	      this.picker.find('>div').hide().filter('.datetimepicker-' + DPGlobal.modes[this.viewMode].clsName).css('display', 'block');
	      this.updateNavArrows();
	    },
	
	    reset: function reset() {
	      this._setDate(null, 'date');
	    },
	
	    convertViewModeText: function convertViewModeText(viewMode) {
	      switch (viewMode) {
	        case 4:
	          return 'decade';
	        case 3:
	          return 'year';
	        case 2:
	          return 'month';
	        case 1:
	          return 'day';
	        case 0:
	          return 'hour';
	      }
	    }
	  };
	
	  var old = $.fn.datetimepicker;
	  $.fn.datetimepicker = function (option) {
	    var args = Array.apply(null, arguments);
	    args.shift();
	    var internal_return;
	    this.each(function () {
	      var $this = $(this),
	          data = $this.data('datetimepicker'),
	          options = (typeof option === 'undefined' ? 'undefined' : (0, _typeof3.default)(option)) === 'object' && option;
	      if (!data) {
	        $this.data('datetimepicker', data = new Datetimepicker(this, $.extend({}, $.fn.datetimepicker.defaults, options)));
	      }
	      if (typeof option === 'string' && typeof data[option] === 'function') {
	        internal_return = data[option].apply(data, args);
	        if (internal_return !== undefined) {
	          return false;
	        }
	      }
	    });
	    if (internal_return !== undefined) return internal_return;else return this;
	  };
	
	  $.fn.datetimepicker.defaults = {};
	  $.fn.datetimepicker.Constructor = Datetimepicker;
	  var dates = $.fn.datetimepicker.dates = {
	    en: {
	      days: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
	      daysShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
	      daysMin: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
	      months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
	      monthsShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
	      meridiem: ['am', 'pm'],
	      suffix: ['st', 'nd', 'rd', 'th'],
	      today: 'Today',
	      clear: 'Clear'
	    }
	  };
	
	  var DPGlobal = {
	    modes: [{
	      clsName: 'minutes',
	      navFnc: 'Hours',
	      navStep: 1
	    }, {
	      clsName: 'hours',
	      navFnc: 'Date',
	      navStep: 1
	    }, {
	      clsName: 'days',
	      navFnc: 'Month',
	      navStep: 1
	    }, {
	      clsName: 'months',
	      navFnc: 'FullYear',
	      navStep: 1
	    }, {
	      clsName: 'years',
	      navFnc: 'FullYear',
	      navStep: 10
	    }],
	    isLeapYear: function isLeapYear(year) {
	      return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
	    },
	    getDaysInMonth: function getDaysInMonth(year, month) {
	      return [31, DPGlobal.isLeapYear(year) ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][month];
	    },
	    getDefaultFormat: function getDefaultFormat(type, field) {
	      if (type === 'standard') {
	        if (field === 'input') return 'yyyy-mm-dd hh:ii';else return 'yyyy-mm-dd hh:ii:ss';
	      } else if (type === 'php') {
	        if (field === 'input') return 'Y-m-d H:i';else return 'Y-m-d H:i:s';
	      } else {
	        throw new Error('Invalid format type.');
	      }
	    },
	    validParts: function validParts(type) {
	      if (type === 'standard') {
	        return (/t|hh?|HH?|p|P|z|Z|ii?|ss?|dd?|DD?|mm?|MM?|yy(?:yy)?/g
	        );
	      } else if (type === 'php') {
	        return (/[dDjlNwzFmMnStyYaABgGhHis]/g
	        );
	      } else {
	        throw new Error('Invalid format type.');
	      }
	    },
	    nonpunctuation: /[^ -\/:-@\[-`{-~\t\n\rTZ]+/g,
	    parseFormat: function parseFormat(format, type) {
	      var separators = format.replace(this.validParts(type), '\0').split('\0'),
	          parts = format.match(this.validParts(type));
	      if (!separators || !separators.length || !parts || parts.length === 0) {
	        throw new Error('Invalid date format.');
	      }
	      return { separators: separators, parts: parts };
	    },
	    parseDate: function parseDate(date, format, language, type, timezone) {
	      if (date instanceof Date) {
	        var dateUTC = new Date(date.valueOf() - date.getTimezoneOffset() * 60000);
	        dateUTC.setMilliseconds(0);
	        return dateUTC;
	      }
	      if (/^\d{4}\-\d{1,2}\-\d{1,2}$/.test(date)) {
	        format = this.parseFormat('yyyy-mm-dd', type);
	      }
	      if (/^\d{4}\-\d{1,2}\-\d{1,2}[T ]\d{1,2}\:\d{1,2}$/.test(date)) {
	        format = this.parseFormat('yyyy-mm-dd hh:ii', type);
	      }
	      if (/^\d{4}\-\d{1,2}\-\d{1,2}[T ]\d{1,2}\:\d{1,2}\:\d{1,2}[Z]{0,1}$/.test(date)) {
	        format = this.parseFormat('yyyy-mm-dd hh:ii:ss', type);
	      }
	      if (/^[-+]\d+[dmwy]([\s,]+[-+]\d+[dmwy])*$/.test(date)) {
	        var part_re = /([-+]\d+)([dmwy])/,
	            parts = date.match(/([-+]\d+)([dmwy])/g),
	            part,
	            dir;
	        date = new Date();
	        for (var i = 0; i < parts.length; i++) {
	          part = part_re.exec(parts[i]);
	          dir = parseInt(part[1]);
	          switch (part[2]) {
	            case 'd':
	              date.setUTCDate(date.getUTCDate() + dir);
	              break;
	            case 'm':
	              date = Datetimepicker.prototype.moveMonth.call(Datetimepicker.prototype, date, dir);
	              break;
	            case 'w':
	              date.setUTCDate(date.getUTCDate() + dir * 7);
	              break;
	            case 'y':
	              date = Datetimepicker.prototype.moveYear.call(Datetimepicker.prototype, date, dir);
	              break;
	          }
	        }
	        return UTCDate(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds(), 0);
	      }
	      var parts = date && date.toString().match(this.nonpunctuation) || [],
	          date = new Date(0, 0, 0, 0, 0, 0, 0),
	          parsed = {},
	          setters_order = ['hh', 'h', 'ii', 'i', 'ss', 's', 'yyyy', 'yy', 'M', 'MM', 'm', 'mm', 'D', 'DD', 'd', 'dd', 'H', 'HH', 'p', 'P', 'z', 'Z'],
	          setters_map = {
	        hh: function hh(d, v) {
	          return d.setUTCHours(v);
	        },
	        h: function h(d, v) {
	          return d.setUTCHours(v);
	        },
	        HH: function HH(d, v) {
	          return d.setUTCHours(v === 12 ? 0 : v);
	        },
	        H: function H(d, v) {
	          return d.setUTCHours(v === 12 ? 0 : v);
	        },
	        ii: function ii(d, v) {
	          return d.setUTCMinutes(v);
	        },
	        i: function i(d, v) {
	          return d.setUTCMinutes(v);
	        },
	        ss: function ss(d, v) {
	          return d.setUTCSeconds(v);
	        },
	        s: function s(d, v) {
	          return d.setUTCSeconds(v);
	        },
	        yyyy: function yyyy(d, v) {
	          return d.setUTCFullYear(v);
	        },
	        yy: function yy(d, v) {
	          return d.setUTCFullYear(2000 + v);
	        },
	        m: function m(d, v) {
	          v -= 1;
	          while (v < 0) {
	            v += 12;
	          }v %= 12;
	          d.setUTCMonth(v);
	          while (d.getUTCMonth() !== v) {
	            if (isNaN(d.getUTCMonth())) return d;else d.setUTCDate(d.getUTCDate() - 1);
	          }return d;
	        },
	        d: function d(_d, v) {
	          return _d.setUTCDate(v);
	        },
	        p: function p(d, v) {
	          return d.setUTCHours(v === 1 ? d.getUTCHours() + 12 : d.getUTCHours());
	        },
	        z: function z() {
	          return timezone;
	        }
	      },
	          val,
	          filtered,
	          part;
	      setters_map['M'] = setters_map['MM'] = setters_map['mm'] = setters_map['m'];
	      setters_map['dd'] = setters_map['d'];
	      setters_map['P'] = setters_map['p'];
	      setters_map['Z'] = setters_map['z'];
	      date = UTCDate(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds());
	      if (parts.length === format.parts.length) {
	        for (var i = 0, cnt = format.parts.length; i < cnt; i++) {
	          val = parseInt(parts[i], 10);
	          part = format.parts[i];
	          if (isNaN(val)) {
	            switch (part) {
	              case 'MM':
	                filtered = $(dates[language].months).filter(function () {
	                  var m = this.slice(0, parts[i].length),
	                      p = parts[i].slice(0, m.length);
	                  return m === p;
	                });
	                val = $.inArray(filtered[0], dates[language].months) + 1;
	                break;
	              case 'M':
	                filtered = $(dates[language].monthsShort).filter(function () {
	                  var m = this.slice(0, parts[i].length),
	                      p = parts[i].slice(0, m.length);
	                  return m.toLowerCase() === p.toLowerCase();
	                });
	                val = $.inArray(filtered[0], dates[language].monthsShort) + 1;
	                break;
	              case 'p':
	              case 'P':
	                val = $.inArray(parts[i].toLowerCase(), dates[language].meridiem);
	                break;
	              case 'z':
	              case 'Z':
	                timezone;
	                break;
	
	            }
	          }
	          parsed[part] = val;
	        }
	        for (var i = 0, s; i < setters_order.length; i++) {
	          s = setters_order[i];
	          if (s in parsed && !isNaN(parsed[s])) setters_map[s](date, parsed[s]);
	        }
	      }
	      return date;
	    },
	    formatDate: function formatDate(date, format, language, type, timezone) {
	      if (date === null) {
	        return '';
	      }
	      var val;
	      if (type === 'standard') {
	        val = {
	          t: date.getTime(),
	
	          yy: date.getUTCFullYear().toString().substring(2),
	          yyyy: date.getUTCFullYear(),
	
	          m: date.getUTCMonth() + 1,
	          M: dates[language].monthsShort[date.getUTCMonth()],
	          MM: dates[language].months[date.getUTCMonth()],
	
	          d: date.getUTCDate(),
	          D: dates[language].daysShort[date.getUTCDay()],
	          DD: dates[language].days[date.getUTCDay()],
	          p: dates[language].meridiem.length === 2 ? dates[language].meridiem[date.getUTCHours() < 12 ? 0 : 1] : '',
	
	          h: date.getUTCHours(),
	
	          i: date.getUTCMinutes(),
	
	          s: date.getUTCSeconds(),
	
	          z: timezone
	        };
	
	        if (dates[language].meridiem.length === 2) {
	          val.H = val.h % 12 === 0 ? 12 : val.h % 12;
	        } else {
	          val.H = val.h;
	        }
	        val.HH = (val.H < 10 ? '0' : '') + val.H;
	        val.P = val.p.toUpperCase();
	        val.Z = val.z;
	        val.hh = (val.h < 10 ? '0' : '') + val.h;
	        val.ii = (val.i < 10 ? '0' : '') + val.i;
	        val.ss = (val.s < 10 ? '0' : '') + val.s;
	        val.dd = (val.d < 10 ? '0' : '') + val.d;
	        val.mm = (val.m < 10 ? '0' : '') + val.m;
	      } else if (type === 'php') {
	        val = {
	          y: date.getUTCFullYear().toString().substring(2),
	          Y: date.getUTCFullYear(),
	
	          F: dates[language].months[date.getUTCMonth()],
	          M: dates[language].monthsShort[date.getUTCMonth()],
	          n: date.getUTCMonth() + 1,
	          t: DPGlobal.getDaysInMonth(date.getUTCFullYear(), date.getUTCMonth()),
	
	          j: date.getUTCDate(),
	          l: dates[language].days[date.getUTCDay()],
	          D: dates[language].daysShort[date.getUTCDay()],
	          w: date.getUTCDay(),
	          N: date.getUTCDay() === 0 ? 7 : date.getUTCDay(),
	          S: date.getUTCDate() % 10 <= dates[language].suffix.length ? dates[language].suffix[date.getUTCDate() % 10 - 1] : '',
	
	          a: dates[language].meridiem.length === 2 ? dates[language].meridiem[date.getUTCHours() < 12 ? 0 : 1] : '',
	          g: date.getUTCHours() % 12 === 0 ? 12 : date.getUTCHours() % 12,
	          G: date.getUTCHours(),
	
	          i: date.getUTCMinutes(),
	
	          s: date.getUTCSeconds()
	        };
	        val.m = (val.n < 10 ? '0' : '') + val.n;
	        val.d = (val.j < 10 ? '0' : '') + val.j;
	        val.A = val.a.toString().toUpperCase();
	        val.h = (val.g < 10 ? '0' : '') + val.g;
	        val.H = (val.G < 10 ? '0' : '') + val.G;
	        val.i = (val.i < 10 ? '0' : '') + val.i;
	        val.s = (val.s < 10 ? '0' : '') + val.s;
	      } else {
	        throw new Error('Invalid format type.');
	      }
	      var date = [],
	          seps = $.extend([], format.separators);
	      for (var i = 0, cnt = format.parts.length; i < cnt; i++) {
	        if (seps.length) {
	          date.push(seps.shift());
	        }
	        date.push(val[format.parts[i]]);
	      }
	      if (seps.length) {
	        date.push(seps.shift());
	      }
	      return date.join('');
	    },
	    convertViewMode: function convertViewMode(viewMode) {
	      switch (viewMode) {
	        case 4:
	        case 'decade':
	          viewMode = 4;
	          break;
	        case 3:
	        case 'year':
	          viewMode = 3;
	          break;
	        case 2:
	        case 'month':
	          viewMode = 2;
	          break;
	        case 1:
	        case 'day':
	          viewMode = 1;
	          break;
	        case 0:
	        case 'hour':
	          viewMode = 0;
	          break;
	      }
	
	      return viewMode;
	    },
	    headTemplate: '<thead>' + '<tr>' + '<th class="prev"><i class="{iconType} {leftArrow}"/></th>' + '<th colspan="5" class="switch"></th>' + '<th class="next"><i class="{iconType} {rightArrow}"/></th>' + '</tr>' + '</thead>',
	    headTemplateV3: '<thead>' + '<tr>' + '<th class="prev"><span class="{iconType} {leftArrow}"></span> </th>' + '<th colspan="5" class="switch"></th>' + '<th class="next"><span class="{iconType} {rightArrow}"></span> </th>' + '</tr>' + '</thead>',
	    contTemplate: '<tbody><tr><td colspan="7"></td></tr></tbody>',
	    footTemplate: '<tfoot>' + '<tr><th colspan="7" class="today"></th></tr>' + '<tr><th colspan="7" class="clear"></th></tr>' + '</tfoot>'
	  };
	  DPGlobal.template = '<div class="datetimepicker">' + '<div class="datetimepicker-minutes">' + '<table class=" table-condensed">' + DPGlobal.headTemplate + DPGlobal.contTemplate + DPGlobal.footTemplate + '</table>' + '</div>' + '<div class="datetimepicker-hours">' + '<table class=" table-condensed">' + DPGlobal.headTemplate + DPGlobal.contTemplate + DPGlobal.footTemplate + '</table>' + '</div>' + '<div class="datetimepicker-days">' + '<table class=" table-condensed">' + DPGlobal.headTemplate + '<tbody></tbody>' + DPGlobal.footTemplate + '</table>' + '</div>' + '<div class="datetimepicker-months">' + '<table class="table-condensed">' + DPGlobal.headTemplate + DPGlobal.contTemplate + DPGlobal.footTemplate + '</table>' + '</div>' + '<div class="datetimepicker-years">' + '<table class="table-condensed">' + DPGlobal.headTemplate + DPGlobal.contTemplate + DPGlobal.footTemplate + '</table>' + '</div>' + '</div>';
	  DPGlobal.templateV3 = '<div class="datetimepicker">' + '<div class="datetimepicker-minutes">' + '<table class=" table-condensed">' + DPGlobal.headTemplateV3 + DPGlobal.contTemplate + DPGlobal.footTemplate + '</table>' + '</div>' + '<div class="datetimepicker-hours">' + '<table class=" table-condensed">' + DPGlobal.headTemplateV3 + DPGlobal.contTemplate + DPGlobal.footTemplate + '</table>' + '</div>' + '<div class="datetimepicker-days">' + '<table class=" table-condensed">' + DPGlobal.headTemplateV3 + '<tbody></tbody>' + DPGlobal.footTemplate + '</table>' + '</div>' + '<div class="datetimepicker-months">' + '<table class="table-condensed">' + DPGlobal.headTemplateV3 + DPGlobal.contTemplate + DPGlobal.footTemplate + '</table>' + '</div>' + '<div class="datetimepicker-years">' + '<table class="table-condensed">' + DPGlobal.headTemplateV3 + DPGlobal.contTemplate + DPGlobal.footTemplate + '</table>' + '</div>' + '</div>';
	  $.fn.datetimepicker.DPGlobal = DPGlobal;
	
	  $.fn.datetimepicker.noConflict = function () {
	    $.fn.datetimepicker = old;
	    return this;
	  };
	
	  $(document).on('focus.datetimepicker.data-api click.datetimepicker.data-api', '[data-provide="datetimepicker"]', function (e) {
	    var $this = $(this);
	    if ($this.data('datetimepicker')) return;
	    e.preventDefault();
	
	    $this.datetimepicker('show');
	  });
	  $(function () {
	    $('[data-provide="datetimepicker-inline"]').datetimepicker();
	  });
	});

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

	var require;var require;var __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	var _typeof2 = __webpack_require__(9);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	!function (e, t, n) {
	  "use strict";
	  !function o(e, t, n) {
	    function a(s, l) {
	      if (!t[s]) {
	        if (!e[s]) {
	          var i = "function" == typeof require && require;if (!l && i) return require(s, !0);if (r) return r(s, !0);var u = new Error("Cannot find module '" + s + "'");throw u.code = "MODULE_NOT_FOUND", u;
	        }var c = t[s] = { exports: {} };e[s][0].call(c.exports, function (t) {
	          var n = e[s][1][t];return a(n ? n : t);
	        }, c, c.exports, o, e, t, n);
	      }return t[s].exports;
	    }for (var r = "function" == typeof require && require, s = 0; s < n.length; s++) {
	      a(n[s]);
	    }return a;
	  }({ 1: [function (o, a, r) {
	      function s(e) {
	        return e && e.__esModule ? e : { "default": e };
	      }var l,
	          i,
	          u,
	          _c,
	          d = o("./modules/handle-dom"),
	          f = o("./modules/utils"),
	          p = o("./modules/handle-swal-dom"),
	          m = o("./modules/handle-click"),
	          v = o("./modules/handle-key"),
	          y = s(v),
	          b = o("./modules/default-params"),
	          h = s(b),
	          g = o("./modules/set-params"),
	          w = s(g);u = _c = function c() {
	        function o(e) {
	          var t = a;return t[e] === n ? h["default"][e] : t[e];
	        }var a = arguments[0];if ((0, d.addClass)(t.body, "stop-scrolling"), (0, p.resetInput)(), a === n) return (0, f.logStr)("SweetAlert expects at least 1 attribute!"), !1;var r = (0, f.extend)({}, h["default"]);switch (typeof a === "undefined" ? "undefined" : (0, _typeof3.default)(a)) {case "string":
	            r.title = a, r.text = arguments[1] || "", r.type = arguments[2] || "";break;case "object":
	            if (a.title === n) return (0, f.logStr)('Missing "title" argument!'), !1;r.title = a.title;for (var s in h["default"]) {
	              r[s] = o(s);
	            }r.confirmButtonText = r.showCancelButton ? "Confirm" : h["default"].confirmButtonText, r.confirmButtonText = o("confirmButtonText"), r.doneFunction = arguments[1] || null;break;default:
	            return (0, f.logStr)('Unexpected type of argument! Expected "string" or "object", got ' + (typeof a === "undefined" ? "undefined" : (0, _typeof3.default)(a))), !1;}(0, w["default"])(r), (0, p.fixVerticalPosition)(), (0, p.openModal)(arguments[1]);for (var u = (0, p.getModal)(), v = u.querySelectorAll("button"), b = ["onclick", "onmouseover", "onmouseout", "onmousedown", "onmouseup", "onfocus"], g = function g(e) {
	          return (0, m.handleButton)(e, r, u);
	        }, C = 0; C < v.length; C++) {
	          for (var S = 0; S < b.length; S++) {
	            var x = b[S];v[C][x] = g;
	          }
	        }(0, p.getOverlay)().onclick = g, l = e.onkeydown;var k = function k(e) {
	          return (0, y["default"])(e, r, u);
	        };e.onkeydown = k, e.onfocus = function () {
	          setTimeout(function () {
	            i !== n && (i.focus(), i = n);
	          }, 0);
	        }, _c.enableButtons();
	      }, u.setDefaults = _c.setDefaults = function (e) {
	        if (!e) throw new Error("userParams is required");if ("object" != (typeof e === "undefined" ? "undefined" : (0, _typeof3.default)(e))) throw new Error("userParams has to be a object");(0, f.extend)(h["default"], e);
	      }, u.close = _c.close = function () {
	        var o = (0, p.getModal)();(0, d.fadeOut)((0, p.getOverlay)(), 5), (0, d.fadeOut)(o, 5), (0, d.removeClass)(o, "showSweetAlert"), (0, d.addClass)(o, "hideSweetAlert"), (0, d.removeClass)(o, "visible");var a = o.querySelector(".sa-icon.sa-success");(0, d.removeClass)(a, "animate"), (0, d.removeClass)(a.querySelector(".sa-tip"), "animateSuccessTip"), (0, d.removeClass)(a.querySelector(".sa-long"), "animateSuccessLong");var r = o.querySelector(".sa-icon.sa-error");(0, d.removeClass)(r, "animateErrorIcon"), (0, d.removeClass)(r.querySelector(".sa-x-mark"), "animateXMark");var s = o.querySelector(".sa-icon.sa-warning");return (0, d.removeClass)(s, "pulseWarning"), (0, d.removeClass)(s.querySelector(".sa-body"), "pulseWarningIns"), (0, d.removeClass)(s.querySelector(".sa-dot"), "pulseWarningIns"), setTimeout(function () {
	          var e = o.getAttribute("data-custom-class");(0, d.removeClass)(o, e);
	        }, 300), (0, d.removeClass)(t.body, "stop-scrolling"), e.onkeydown = l, e.previousActiveElement && e.previousActiveElement.focus(), i = n, clearTimeout(o.timeout), !0;
	      }, u.showInputError = _c.showInputError = function (e) {
	        var t = (0, p.getModal)(),
	            n = t.querySelector(".sa-input-error");(0, d.addClass)(n, "show");var o = t.querySelector(".sa-error-container");(0, d.addClass)(o, "show"), o.querySelector("p").innerHTML = e, setTimeout(function () {
	          u.enableButtons();
	        }, 1), t.querySelector("input").focus();
	      }, u.resetInputError = _c.resetInputError = function (e) {
	        if (e && 13 === e.keyCode) return !1;var t = (0, p.getModal)(),
	            n = t.querySelector(".sa-input-error");(0, d.removeClass)(n, "show");var o = t.querySelector(".sa-error-container");(0, d.removeClass)(o, "show");
	      }, u.disableButtons = _c.disableButtons = function (e) {
	        var t = (0, p.getModal)(),
	            n = t.querySelector("button.confirm"),
	            o = t.querySelector("button.cancel");n.disabled = !0, o.disabled = !0;
	      }, u.enableButtons = _c.enableButtons = function (e) {
	        var t = (0, p.getModal)(),
	            n = t.querySelector("button.confirm"),
	            o = t.querySelector("button.cancel");n.disabled = !1, o.disabled = !1;
	      }, "undefined" != typeof e ? e.sweetAlert = e.swal = u : (0, f.logStr)("SweetAlert is a frontend module!");
	    }, { "./modules/default-params": 2, "./modules/handle-click": 3, "./modules/handle-dom": 4, "./modules/handle-key": 5, "./modules/handle-swal-dom": 6, "./modules/set-params": 8, "./modules/utils": 9 }], 2: [function (e, t, n) {
	      Object.defineProperty(n, "__esModule", { value: !0 });var o = { title: "", text: "", type: null, allowOutsideClick: !1, showConfirmButton: !0, showCancelButton: !1, closeOnConfirm: !0, closeOnCancel: !0, confirmButtonText: "OK", confirmButtonColor: "#8CD4F5", cancelButtonText: "Cancel", imageUrl: null, imageSize: null, timer: null, customClass: "", html: !1, animation: !0, allowEscapeKey: !0, inputType: "text", inputPlaceholder: "", inputValue: "", showLoaderOnConfirm: !1 };n["default"] = o, t.exports = n["default"];
	    }, {}], 3: [function (t, n, o) {
	      Object.defineProperty(o, "__esModule", { value: !0 });var a = t("./utils"),
	          r = (t("./handle-swal-dom"), t("./handle-dom")),
	          s = function s(t, n, o) {
	        function s(e) {
	          m && n.confirmButtonColor && (p.style.backgroundColor = e);
	        }var u,
	            c,
	            d,
	            f = t || e.event,
	            p = f.target || f.srcElement,
	            m = -1 !== p.className.indexOf("confirm"),
	            v = -1 !== p.className.indexOf("sweet-overlay"),
	            y = (0, r.hasClass)(o, "visible"),
	            b = n.doneFunction && "true" === o.getAttribute("data-has-done-function");switch (m && n.confirmButtonColor && (u = n.confirmButtonColor, c = (0, a.colorLuminance)(u, -.04), d = (0, a.colorLuminance)(u, -.14)), f.type) {case "mouseover":
	            s(c);break;case "mouseout":
	            s(u);break;case "mousedown":
	            s(d);break;case "mouseup":
	            s(c);break;case "focus":
	            var h = o.querySelector("button.confirm"),
	                g = o.querySelector("button.cancel");m ? g.style.boxShadow = "none" : h.style.boxShadow = "none";break;case "click":
	            var w = o === p,
	                C = (0, r.isDescendant)(o, p);if (!w && !C && y && !n.allowOutsideClick) break;m && b && y ? l(o, n) : b && y || v ? i(o, n) : (0, r.isDescendant)(o, p) && "BUTTON" === p.tagName && sweetAlert.close();}
	      },
	          l = function l(e, t) {
	        var n = !0;(0, r.hasClass)(e, "show-input") && (n = e.querySelector("input").value, n || (n = "")), t.doneFunction(n), t.closeOnConfirm && sweetAlert.close(), t.showLoaderOnConfirm && sweetAlert.disableButtons();
	      },
	          i = function i(e, t) {
	        var n = String(t.doneFunction).replace(/\s/g, ""),
	            o = "function(" === n.substring(0, 9) && ")" !== n.substring(9, 10);o && t.doneFunction(!1), t.closeOnCancel && sweetAlert.close();
	      };o["default"] = { handleButton: s, handleConfirm: l, handleCancel: i }, n.exports = o["default"];
	    }, { "./handle-dom": 4, "./handle-swal-dom": 6, "./utils": 9 }], 4: [function (n, o, a) {
	      Object.defineProperty(a, "__esModule", { value: !0 });var r = function r(e, t) {
	        return new RegExp(" " + t + " ").test(" " + e.className + " ");
	      },
	          s = function s(e, t) {
	        r(e, t) || (e.className += " " + t);
	      },
	          l = function l(e, t) {
	        var n = " " + e.className.replace(/[\t\r\n]/g, " ") + " ";if (r(e, t)) {
	          for (; n.indexOf(" " + t + " ") >= 0;) {
	            n = n.replace(" " + t + " ", " ");
	          }e.className = n.replace(/^\s+|\s+$/g, "");
	        }
	      },
	          i = function i(e) {
	        var n = t.createElement("div");return n.appendChild(t.createTextNode(e)), n.innerHTML;
	      },
	          u = function u(e) {
	        e.style.opacity = "", e.style.display = "block";
	      },
	          c = function c(e) {
	        if (e && !e.length) return u(e);for (var t = 0; t < e.length; ++t) {
	          u(e[t]);
	        }
	      },
	          d = function d(e) {
	        e.style.opacity = "", e.style.display = "none";
	      },
	          f = function f(e) {
	        if (e && !e.length) return d(e);for (var t = 0; t < e.length; ++t) {
	          d(e[t]);
	        }
	      },
	          p = function p(e, t) {
	        for (var n = t.parentNode; null !== n;) {
	          if (n === e) return !0;n = n.parentNode;
	        }return !1;
	      },
	          m = function m(e) {
	        e.style.left = "-9999px", e.style.display = "block";var t,
	            n = e.clientHeight;return t = "undefined" != typeof getComputedStyle ? parseInt(getComputedStyle(e).getPropertyValue("padding-top"), 10) : parseInt(e.currentStyle.padding), e.style.left = "", e.style.display = "none", "-" + parseInt((n + t) / 2) + "px";
	      },
	          v = function v(e, t) {
	        if (+e.style.opacity < 1) {
	          t = t || 16, e.style.opacity = 0, e.style.display = "block";var n = +new Date(),
	              o = function a() {
	            e.style.opacity = +e.style.opacity + (new Date() - n) / 100, n = +new Date(), +e.style.opacity < 1 && setTimeout(a, t);
	          };o();
	        }e.style.display = "block";
	      },
	          y = function y(e, t) {
	        t = t || 16, e.style.opacity = 1;var n = +new Date(),
	            o = function a() {
	          e.style.opacity = +e.style.opacity - (new Date() - n) / 100, n = +new Date(), +e.style.opacity > 0 ? setTimeout(a, t) : e.style.display = "none";
	        };o();
	      },
	          b = function b(n) {
	        if ("function" == typeof MouseEvent) {
	          var o = new MouseEvent("click", { view: e, bubbles: !1, cancelable: !0 });n.dispatchEvent(o);
	        } else if (t.createEvent) {
	          var a = t.createEvent("MouseEvents");a.initEvent("click", !1, !1), n.dispatchEvent(a);
	        } else t.createEventObject ? n.fireEvent("onclick") : "function" == typeof n.onclick && n.onclick();
	      },
	          h = function h(t) {
	        "function" == typeof t.stopPropagation ? (t.stopPropagation(), t.preventDefault()) : e.event && e.event.hasOwnProperty("cancelBubble") && (e.event.cancelBubble = !0);
	      };a.hasClass = r, a.addClass = s, a.removeClass = l, a.escapeHtml = i, a._show = u, a.show = c, a._hide = d, a.hide = f, a.isDescendant = p, a.getTopMargin = m, a.fadeIn = v, a.fadeOut = y, a.fireClick = b, a.stopEventPropagation = h;
	    }, {}], 5: [function (t, o, a) {
	      Object.defineProperty(a, "__esModule", { value: !0 });var r = t("./handle-dom"),
	          s = t("./handle-swal-dom"),
	          l = function l(t, o, a) {
	        var l = t || e.event,
	            i = l.keyCode || l.which,
	            u = a.querySelector("button.confirm"),
	            c = a.querySelector("button.cancel"),
	            d = a.querySelectorAll("button[tabindex]");if (-1 !== [9, 13, 32, 27].indexOf(i)) {
	          for (var f = l.target || l.srcElement, p = -1, m = 0; m < d.length; m++) {
	            if (f === d[m]) {
	              p = m;break;
	            }
	          }9 === i ? (f = -1 === p ? u : p === d.length - 1 ? d[0] : d[p + 1], (0, r.stopEventPropagation)(l), f.focus(), o.confirmButtonColor && (0, s.setFocusStyle)(f, o.confirmButtonColor)) : 13 === i ? ("INPUT" === f.tagName && (f = u, u.focus()), f = -1 === p ? u : n) : 27 === i && o.allowEscapeKey === !0 ? (f = c, (0, r.fireClick)(f, l)) : f = n;
	        }
	      };a["default"] = l, o.exports = a["default"];
	    }, { "./handle-dom": 4, "./handle-swal-dom": 6 }], 6: [function (n, o, a) {
	      function r(e) {
	        return e && e.__esModule ? e : { "default": e };
	      }Object.defineProperty(a, "__esModule", { value: !0 });var s = n("./utils"),
	          l = n("./handle-dom"),
	          i = n("./default-params"),
	          u = r(i),
	          c = n("./injected-html"),
	          d = r(c),
	          f = ".sweet-alert",
	          p = ".sweet-overlay",
	          m = function m() {
	        var e = t.createElement("div");for (e.innerHTML = d["default"]; e.firstChild;) {
	          t.body.appendChild(e.firstChild);
	        }
	      },
	          v = function x() {
	        var e = t.querySelector(f);return e || (m(), e = x()), e;
	      },
	          y = function y() {
	        var e = v();return e ? e.querySelector("input") : void 0;
	      },
	          b = function b() {
	        return t.querySelector(p);
	      },
	          h = function h(e, t) {
	        var n = (0, s.hexToRgb)(t);e.style.boxShadow = "0 0 2px rgba(" + n + ", 0.8), inset 0 0 0 1px rgba(0, 0, 0, 0.05)";
	      },
	          g = function g(n) {
	        var o = v();(0, l.fadeIn)(b(), 10), (0, l.show)(o), (0, l.addClass)(o, "showSweetAlert"), (0, l.removeClass)(o, "hideSweetAlert"), e.previousActiveElement = t.activeElement;var a = o.querySelector("button.confirm");a.focus(), setTimeout(function () {
	          (0, l.addClass)(o, "visible");
	        }, 500);var r = o.getAttribute("data-timer");if ("null" !== r && "" !== r) {
	          var s = n;o.timeout = setTimeout(function () {
	            var e = (s || null) && "true" === o.getAttribute("data-has-done-function");e ? s(null) : sweetAlert.close();
	          }, r);
	        }
	      },
	          w = function w() {
	        var e = v(),
	            t = y();(0, l.removeClass)(e, "show-input"), t.value = u["default"].inputValue, t.setAttribute("type", u["default"].inputType), t.setAttribute("placeholder", u["default"].inputPlaceholder), C();
	      },
	          C = function C(e) {
	        if (e && 13 === e.keyCode) return !1;var t = v(),
	            n = t.querySelector(".sa-input-error");(0, l.removeClass)(n, "show");var o = t.querySelector(".sa-error-container");(0, l.removeClass)(o, "show");
	      },
	          S = function S() {
	        var e = v();e.style.marginTop = (0, l.getTopMargin)(v());
	      };a.sweetAlertInitialize = m, a.getModal = v, a.getOverlay = b, a.getInput = y, a.setFocusStyle = h, a.openModal = g, a.resetInput = w, a.resetInputError = C, a.fixVerticalPosition = S;
	    }, { "./default-params": 2, "./handle-dom": 4, "./injected-html": 7, "./utils": 9 }], 7: [function (e, t, n) {
	      Object.defineProperty(n, "__esModule", { value: !0 });var o = '<div class="sweet-overlay" tabIndex="-1"></div><div class="sweet-alert"><div class="sa-icon sa-error">\n      <span class="sa-x-mark">\n        <span class="sa-line sa-left"></span>\n        <span class="sa-line sa-right"></span>\n      </span>\n    </div><div class="sa-icon sa-warning">\n      <span class="sa-body"></span>\n      <span class="sa-dot"></span>\n    </div><div class="sa-icon sa-info"></div><div class="sa-icon sa-success">\n      <span class="sa-line sa-tip"></span>\n      <span class="sa-line sa-long"></span>\n\n      <div class="sa-placeholder"></div>\n      <div class="sa-fix"></div>\n    </div><div class="sa-icon sa-custom"></div><h2>Title</h2>\n    <p>Text</p>\n    <fieldset>\n      <input type="text" tabIndex="3" />\n      <div class="sa-input-error"></div>\n    </fieldset><div class="sa-error-container">\n      <div class="icon">!</div>\n      <p>Not valid!</p>\n    </div><div class="sa-button-container">\n      <button class="cancel" tabIndex="2">Cancel</button>\n      <div class="sa-confirm-button-container">\n        <button class="confirm" tabIndex="1">OK</button><div class="la-ball-fall">\n          <div></div>\n          <div></div>\n          <div></div>\n        </div>\n      </div>\n    </div></div>';n["default"] = o, t.exports = n["default"];
	    }, {}], 8: [function (e, t, o) {
	      Object.defineProperty(o, "__esModule", { value: !0 });var a = e("./utils"),
	          r = e("./handle-swal-dom"),
	          s = e("./handle-dom"),
	          l = ["error", "warning", "info", "success", "input", "prompt"],
	          i = function i(e) {
	        var t = (0, r.getModal)(),
	            o = t.querySelector("h2"),
	            i = t.querySelector("p"),
	            u = t.querySelector("button.cancel"),
	            c = t.querySelector("button.confirm");if (o.innerHTML = e.html ? e.title : (0, s.escapeHtml)(e.title).split("\n").join("<br>"), i.innerHTML = e.html ? e.text : (0, s.escapeHtml)(e.text || "").split("\n").join("<br>"), e.text && (0, s.show)(i), e.customClass) (0, s.addClass)(t, e.customClass), t.setAttribute("data-custom-class", e.customClass);else {
	          var d = t.getAttribute("data-custom-class");(0, s.removeClass)(t, d), t.setAttribute("data-custom-class", "");
	        }if ((0, s.hide)(t.querySelectorAll(".sa-icon")), e.type && !(0, a.isIE8)()) {
	          var f = function () {
	            for (var o = !1, a = 0; a < l.length; a++) {
	              if (e.type === l[a]) {
	                o = !0;break;
	              }
	            }if (!o) return logStr("Unknown alert type: " + e.type), { v: !1 };var i = ["success", "error", "warning", "info"],
	                u = n;-1 !== i.indexOf(e.type) && (u = t.querySelector(".sa-icon.sa-" + e.type), (0, s.show)(u));var c = (0, r.getInput)();switch (e.type) {case "success":
	                (0, s.addClass)(u, "animate"), (0, s.addClass)(u.querySelector(".sa-tip"), "animateSuccessTip"), (0, s.addClass)(u.querySelector(".sa-long"), "animateSuccessLong");break;case "error":
	                (0, s.addClass)(u, "animateErrorIcon"), (0, s.addClass)(u.querySelector(".sa-x-mark"), "animateXMark");break;case "warning":
	                (0, s.addClass)(u, "pulseWarning"), (0, s.addClass)(u.querySelector(".sa-body"), "pulseWarningIns"), (0, s.addClass)(u.querySelector(".sa-dot"), "pulseWarningIns");break;case "input":case "prompt":
	                c.setAttribute("type", e.inputType), c.value = e.inputValue, c.setAttribute("placeholder", e.inputPlaceholder), (0, s.addClass)(t, "show-input"), setTimeout(function () {
	                  c.focus(), c.addEventListener("keyup", swal.resetInputError);
	                }, 400);}
	          }();if ("object" == (typeof f === "undefined" ? "undefined" : (0, _typeof3.default)(f))) return f.v;
	        }if (e.imageUrl) {
	          var p = t.querySelector(".sa-icon.sa-custom");p.style.backgroundImage = "url(" + e.imageUrl + ")", (0, s.show)(p);var m = 80,
	              v = 80;if (e.imageSize) {
	            var y = e.imageSize.toString().split("x"),
	                b = y[0],
	                h = y[1];b && h ? (m = b, v = h) : logStr("Parameter imageSize expects value with format WIDTHxHEIGHT, got " + e.imageSize);
	          }p.setAttribute("style", p.getAttribute("style") + "width:" + m + "px; height:" + v + "px");
	        }t.setAttribute("data-has-cancel-button", e.showCancelButton), e.showCancelButton ? u.style.display = "inline-block" : (0, s.hide)(u), t.setAttribute("data-has-confirm-button", e.showConfirmButton), e.showConfirmButton ? c.style.display = "inline-block" : (0, s.hide)(c), e.cancelButtonText && (u.innerHTML = (0, s.escapeHtml)(e.cancelButtonText)), e.confirmButtonText && (c.innerHTML = (0, s.escapeHtml)(e.confirmButtonText)), e.confirmButtonColor && (c.style.backgroundColor = e.confirmButtonColor, c.style.borderLeftColor = e.confirmLoadingButtonColor, c.style.borderRightColor = e.confirmLoadingButtonColor, (0, r.setFocusStyle)(c, e.confirmButtonColor)), t.setAttribute("data-allow-outside-click", e.allowOutsideClick);var g = !!e.doneFunction;t.setAttribute("data-has-done-function", g), e.animation ? "string" == typeof e.animation ? t.setAttribute("data-animation", e.animation) : t.setAttribute("data-animation", "pop") : t.setAttribute("data-animation", "none"), t.setAttribute("data-timer", e.timer);
	      };o["default"] = i, t.exports = o["default"];
	    }, { "./handle-dom": 4, "./handle-swal-dom": 6, "./utils": 9 }], 9: [function (t, n, o) {
	      Object.defineProperty(o, "__esModule", { value: !0 });var a = function a(e, t) {
	        for (var n in t) {
	          t.hasOwnProperty(n) && (e[n] = t[n]);
	        }return e;
	      },
	          r = function r(e) {
	        var t = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(e);return t ? parseInt(t[1], 16) + ", " + parseInt(t[2], 16) + ", " + parseInt(t[3], 16) : null;
	      },
	          s = function s() {
	        return e.attachEvent && !e.addEventListener;
	      },
	          l = function l(t) {
	        e.console && e.console.log("SweetAlert: " + t);
	      },
	          i = function i(e, t) {
	        e = String(e).replace(/[^0-9a-f]/gi, ""), e.length < 6 && (e = e[0] + e[0] + e[1] + e[1] + e[2] + e[2]), t = t || 0;var n,
	            o,
	            a = "#";for (o = 0; 3 > o; o++) {
	          n = parseInt(e.substr(2 * o, 2), 16), n = Math.round(Math.min(Math.max(0, n + n * t), 255)).toString(16), a += ("00" + n).substr(n.length);
	        }return a;
	      };o.extend = a, o.hexToRgb = r, o.isIE8 = s, o.logStr = l, o.colorLuminance = i;
	    }, {}] }, {}, [1]),  true ? !(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
	    return sweetAlert;
	  }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : "undefined" != typeof module && module.exports && (module.exports = sweetAlert);
	}(window, document);

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	function getWeChatJsSdkSignature(timestamp, url) {
	    try {
	        var n = $.ajax({
	            url: common.getApi("weixin/api/wxshare?timestamp=" + timestamp + "&url=" + encodeURIComponent(url) + "&mid=" + MasterConfig.C("mid")),
	            xhrFields: {
	                withCredentials: !0
	            },
	            timeout: 3e3,
	            async: !1
	        }).responseText;
	        return JSON.parse(n).data;
	    } catch (e) {}
	    return {};
	}
	
	function getCookie(e) {
	    return document.cookie.length > 0 && (c_start = document.cookie.indexOf(e + "="), -1 != c_start) ? (c_start = c_start + e.length + 1, c_end = document.cookie.indexOf(";", c_start), -1 == c_end && (c_end = document.cookie.length), unescape(document.cookie.substring(c_start, c_end))) : "";
	}
	
	function GetRequest() {
	    var e = location.search,
	        t = new Object();
	    if (-1 != e.indexOf("?")) {
	        var r = e.substr(1);
	        strs = r.split("&");
	        for (var n = 0; n < strs.length; n++) {
	            t[strs[n].split("=")[0]] = unescape(strs[n].split("=")[1]);
	        }
	    }
	    return t;
	}
	
	function wechat_share_config() {
	    var time = Date.now();
	    var shareJsonSignature = getWeChatJsSdkSignature(time, document.URL);
	    wx.config({
	        debug: false,
	        appId: shareJsonSignature.appId,
	        timestamp: shareJsonSignature.timestamp,
	        nonceStr: shareJsonSignature.noncestr,
	        signature: shareJsonSignature.signature,
	        jsApiList: ["onMenuShareTimeline", "onMenuShareAppMessage"]
	    });
	    wx.error(function (res) {});
	}
	
	function wechat_share_override(e, t, shareLink, sucfun, failfun) {
	    wechat_share_config();
	    var sucf = function sucf() {};
	    var ff = function ff() {};
	    if (sucfun) {
	        sucf = sucfun;
	    }
	    if (failfun) {
	        ff = failfun;
	    }
	    wx.ready(function () {
	
	        wx.onMenuShareTimeline({
	            title: e.title,
	            link: shareLink,
	            imgUrl: e.imgUrl,
	            success: sucf,
	            cancel: ff
	        }), wx.onMenuShareAppMessage({
	            title: t.title,
	            desc: t.desc,
	            link: shareLink,
	            imgUrl: t.imgUrl,
	            "type": "link",
	            success: sucf,
	            cancel: ff
	        });
	    });
	}
	
	var share = {
	    override: function override(e, t) {
	        wechat_share_override(e, t, document.URL);
	    },
	    override_link: function override_link(e, t, shareLink) {
	        wechat_share_override(e, t, shareLink);
	    },
	    overrideWithCallback: function overrideWithCallback(e, t, sucfun, failfun) {
	        wechat_share_override(e, t, document.URL, sucfun, failfun);
	    },
	    overrideLinkWithCallback: function overrideLinkWithCallback(e, t, shareLink, sucfun, failfun) {
	        wechat_share_override(e, t, shareLink, sucfun, failfun);
	    },
	
	    default_send: function default_send() {
	        var e = {
	            title: shopConfig.get("share_text")["default"].title,
	            imgUrl: shopConfig.get("logo")
	        },
	            t = {
	            title: MasterConfig.C("shop_name") + "商城",
	            desc: shopConfig.get("share_text")["default"].desc,
	            imgUrl: shopConfig.get("logo")
	        };
	        wechat_share_override(e, t, "http://" + MasterConfig.C("baseMobileUrl") + shopConfig.get("contextPath") + "index.html");
	    }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof2 = __webpack_require__(9);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(function (window, document, Math) {
		var rAF = window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.oRequestAnimationFrame || window.msRequestAnimationFrame || function (callback) {
			window.setTimeout(callback, 1000 / 60);
		};
	
		var utils = function () {
			var me = {};
	
			var _elementStyle = document.createElement('div').style;
			var _vendor = function () {
				var vendors = ['t', 'webkitT', 'MozT', 'msT', 'OT'],
				    transform,
				    i = 0,
				    l = vendors.length;
	
				for (; i < l; i++) {
					transform = vendors[i] + 'ransform';
					if (transform in _elementStyle) return vendors[i].substr(0, vendors[i].length - 1);
				}
	
				return false;
			}();
	
			function _prefixStyle(style) {
				if (_vendor === false) return false;
				if (_vendor === '') return style;
				return _vendor + style.charAt(0).toUpperCase() + style.substr(1);
			}
	
			me.getTime = Date.now || function getTime() {
				return new Date().getTime();
			};
	
			me.extend = function (target, obj) {
				for (var i in obj) {
					target[i] = obj[i];
				}
			};
	
			me.addEvent = function (el, type, fn, capture) {
				el.addEventListener(type, fn, !!capture);
			};
	
			me.removeEvent = function (el, type, fn, capture) {
				el.removeEventListener(type, fn, !!capture);
			};
	
			me.prefixPointerEvent = function (pointerEvent) {
				return window.MSPointerEvent ? 'MSPointer' + pointerEvent.charAt(7).toUpperCase() + pointerEvent.substr(8) : pointerEvent;
			};
	
			me.momentum = function (current, start, time, lowerMargin, wrapperSize, deceleration) {
				var distance = current - start,
				    speed = Math.abs(distance) / time,
				    destination,
				    duration;
	
				deceleration = deceleration === undefined ? 0.0006 : deceleration;
	
				destination = current + speed * speed / (2 * deceleration) * (distance < 0 ? -1 : 1);
				duration = speed / deceleration;
	
				if (destination < lowerMargin) {
					destination = wrapperSize ? lowerMargin - wrapperSize / 2.5 * (speed / 8) : lowerMargin;
					distance = Math.abs(destination - current);
					duration = distance / speed;
				} else if (destination > 0) {
					destination = wrapperSize ? wrapperSize / 2.5 * (speed / 8) : 0;
					distance = Math.abs(current) + destination;
					duration = distance / speed;
				}
	
				return {
					destination: Math.round(destination),
					duration: duration
				};
			};
	
			var _transform = _prefixStyle('transform');
	
			me.extend(me, {
				hasTransform: _transform !== false,
				hasPerspective: _prefixStyle('perspective') in _elementStyle,
				hasTouch: 'ontouchstart' in window,
				hasPointer: !!(window.PointerEvent || window.MSPointerEvent),
				hasTransition: _prefixStyle('transition') in _elementStyle
			});
	
			me.isBadAndroid = function () {
				var appVersion = window.navigator.appVersion;
	
				if (/Android/.test(appVersion) && !/Chrome\/\d/.test(appVersion)) {
					var safariVersion = appVersion.match(/Safari\/(\d+.\d)/);
					if (safariVersion && (typeof safariVersion === 'undefined' ? 'undefined' : (0, _typeof3.default)(safariVersion)) === "object" && safariVersion.length >= 2) {
						return parseFloat(safariVersion[1]) < 535.19;
					} else {
						return true;
					}
				} else {
					return false;
				}
			}();
	
			me.extend(me.style = {}, {
				transform: _transform,
				transitionTimingFunction: _prefixStyle('transitionTimingFunction'),
				transitionDuration: _prefixStyle('transitionDuration'),
				transitionDelay: _prefixStyle('transitionDelay'),
				transformOrigin: _prefixStyle('transformOrigin'),
				touchAction: _prefixStyle('touchAction')
			});
	
			me.hasClass = function (e, c) {
				var re = new RegExp("(^|\\s)" + c + "(\\s|$)");
				return re.test(e.className);
			};
	
			me.addClass = function (e, c) {
				if (me.hasClass(e, c)) {
					return;
				}
	
				var newclass = e.className.split(' ');
				newclass.push(c);
				e.className = newclass.join(' ');
			};
	
			me.removeClass = function (e, c) {
				if (!me.hasClass(e, c)) {
					return;
				}
	
				var re = new RegExp("(^|\\s)" + c + "(\\s|$)", 'g');
				e.className = e.className.replace(re, ' ');
			};
	
			me.offset = function (el) {
				var left = -el.offsetLeft,
				    top = -el.offsetTop;
	
				while (el = el.offsetParent) {
					left -= el.offsetLeft;
					top -= el.offsetTop;
				}
	
	
				return {
					left: left,
					top: top
				};
			};
	
			me.preventDefaultException = function (el, exceptions) {
				for (var i in exceptions) {
					if (exceptions[i].test(el[i])) {
						return true;
					}
				}
	
				return false;
			};
	
			me.extend(me.eventType = {}, {
				touchstart: 1,
				touchmove: 1,
				touchend: 1,
	
				mousedown: 2,
				mousemove: 2,
				mouseup: 2,
	
				pointerdown: 3,
				pointermove: 3,
				pointerup: 3,
	
				MSPointerDown: 3,
				MSPointerMove: 3,
				MSPointerUp: 3
			});
	
			me.extend(me.ease = {}, {
				quadratic: {
					style: 'cubic-bezier(0.25, 0.46, 0.45, 0.94)',
					fn: function fn(k) {
						return k * (2 - k);
					}
				},
				circular: {
					style: 'cubic-bezier(0.1, 0.57, 0.1, 1)',
					fn: function fn(k) {
						return Math.sqrt(1 - --k * k);
					}
				},
				back: {
					style: 'cubic-bezier(0.175, 0.885, 0.32, 1.275)',
					fn: function fn(k) {
						var b = 4;
						return (k = k - 1) * k * ((b + 1) * k + b) + 1;
					}
				},
				bounce: {
					style: '',
					fn: function fn(k) {
						if ((k /= 1) < 1 / 2.75) {
							return 7.5625 * k * k;
						} else if (k < 2 / 2.75) {
							return 7.5625 * (k -= 1.5 / 2.75) * k + 0.75;
						} else if (k < 2.5 / 2.75) {
							return 7.5625 * (k -= 2.25 / 2.75) * k + 0.9375;
						} else {
							return 7.5625 * (k -= 2.625 / 2.75) * k + 0.984375;
						}
					}
				},
				elastic: {
					style: '',
					fn: function fn(k) {
						var f = 0.22,
						    e = 0.4;
	
						if (k === 0) {
							return 0;
						}
						if (k == 1) {
							return 1;
						}
	
						return e * Math.pow(2, -10 * k) * Math.sin((k - f / 4) * (2 * Math.PI) / f) + 1;
					}
				}
			});
	
			me.tap = function (e, eventName) {
				var ev = document.createEvent('Event');
				ev.initEvent(eventName, true, true);
				ev.pageX = e.pageX;
				ev.pageY = e.pageY;
				e.target.dispatchEvent(ev);
			};
	
			me.click = function (e) {
				var target = e.target,
				    ev;
	
				if (!/(SELECT|INPUT|TEXTAREA)/i.test(target.tagName)) {
					ev = document.createEvent(window.MouseEvent ? 'MouseEvents' : 'Event');
					ev.initEvent('click', true, true);
					ev.view = e.view || window;
					ev.detail = 1;
					ev.screenX = target.screenX || 0;
					ev.screenY = target.screenY || 0;
					ev.clientX = target.clientX || 0;
					ev.clientY = target.clientY || 0;
					ev.ctrlKey = !!e.ctrlKey;
					ev.altKey = !!e.altKey;
					ev.shiftKey = !!e.shiftKey;
					ev.metaKey = !!e.metaKey;
					ev.button = 0;
					ev.relatedTarget = null;
					ev._constructed = true;
					target.dispatchEvent(ev);
				}
			};
	
			me.getTouchAction = function (eventPassthrough, addPinch) {
				var touchAction = 'none';
				if (eventPassthrough === 'vertical') {
					touchAction = 'pan-y';
				} else if (eventPassthrough === 'horizontal') {
					touchAction = 'pan-x';
				}
				if (addPinch && touchAction != 'none') {
					touchAction += ' pinch-zoom';
				}
				return touchAction;
			};
	
			me.getRect = function (el) {
				if (el instanceof SVGElement) {
					var rect = el.getBoundingClientRect();
					return {
						top: rect.top,
						left: rect.left,
						width: rect.width,
						height: rect.height
					};
				} else {
					return {
						top: el.offsetTop,
						left: el.offsetLeft,
						width: el.offsetWidth,
						height: el.offsetHeight
					};
				}
			};
	
			return me;
		}();
		function IScroll(el, options) {
			this.wrapper = typeof el == 'string' ? document.querySelector(el) : el;
			this.scroller = this.wrapper.children[0];
			this.scrollerStyle = this.scroller.style;
	
			this.options = {
	
				resizeScrollbars: true,
	
				mouseWheelSpeed: 20,
	
				snapThreshold: 0.334,
	
				disablePointer: !utils.hasPointer,
				disableTouch: utils.hasPointer || !utils.hasTouch,
				disableMouse: utils.hasPointer || utils.hasTouch,
				startX: 0,
				startY: 0,
				scrollY: true,
				directionLockThreshold: 5,
				momentum: true,
	
				bounce: true,
				bounceTime: 600,
				bounceEasing: '',
	
				preventDefault: true,
				preventDefaultException: { tagName: /^(INPUT|TEXTAREA|BUTTON|SELECT)$/ },
	
				HWCompositing: true,
				useTransition: true,
				useTransform: true,
				bindToWrapper: typeof window.onmousedown === "undefined"
			};
	
			for (var i in options) {
				this.options[i] = options[i];
			}
	
			this.translateZ = this.options.HWCompositing && utils.hasPerspective ? ' translateZ(0)' : '';
	
			this.options.useTransition = utils.hasTransition && this.options.useTransition;
			this.options.useTransform = utils.hasTransform && this.options.useTransform;
	
			this.options.eventPassthrough = this.options.eventPassthrough === true ? 'vertical' : this.options.eventPassthrough;
			this.options.preventDefault = !this.options.eventPassthrough && this.options.preventDefault;
	
			this.options.scrollY = this.options.eventPassthrough == 'vertical' ? false : this.options.scrollY;
			this.options.scrollX = this.options.eventPassthrough == 'horizontal' ? false : this.options.scrollX;
	
			this.options.freeScroll = this.options.freeScroll && !this.options.eventPassthrough;
			this.options.directionLockThreshold = this.options.eventPassthrough ? 0 : this.options.directionLockThreshold;
	
			this.options.bounceEasing = typeof this.options.bounceEasing == 'string' ? utils.ease[this.options.bounceEasing] || utils.ease.circular : this.options.bounceEasing;
	
			this.options.resizePolling = this.options.resizePolling === undefined ? 60 : this.options.resizePolling;
	
			if (this.options.tap === true) {
				this.options.tap = 'tap';
			}
	
			if (!this.options.useTransition && !this.options.useTransform) {
				if (!/relative|absolute/i.test(this.scrollerStyle.position)) {
					this.scrollerStyle.position = "relative";
				}
			}
	
			if (this.options.shrinkScrollbars == 'scale') {
				this.options.useTransition = false;
			}
	
			this.options.invertWheelDirection = this.options.invertWheelDirection ? -1 : 1;
	
			if (this.options.probeType == 3) {
				this.options.useTransition = false;
			}
	
			this.x = 0;
			this.y = 0;
			this.directionX = 0;
			this.directionY = 0;
			this._events = {};
	
			this._init();
			this.refresh();
	
			this.scrollTo(this.options.startX, this.options.startY);
			this.enable();
		}
	
		IScroll.prototype = {
			version: '5.2.0-snapshot',
	
			_init: function _init() {
				this._initEvents();
	
				if (this.options.scrollbars || this.options.indicators) {
					this._initIndicators();
				}
	
				if (this.options.mouseWheel) {
					this._initWheel();
				}
	
				if (this.options.snap) {
					this._initSnap();
				}
	
				if (this.options.keyBindings) {
					this._initKeys();
				}
			},
	
			destroy: function destroy() {
				this._initEvents(true);
				clearTimeout(this.resizeTimeout);
				this.resizeTimeout = null;
				this._execEvent('destroy');
			},
	
			_transitionEnd: function _transitionEnd(e) {
				if (e.target != this.scroller || !this.isInTransition) {
					return;
				}
	
				this._transitionTime();
				if (!this.resetPosition(this.options.bounceTime)) {
					this.isInTransition = false;
					this._execEvent('scrollEnd');
				}
			},
	
			_start: function _start(e) {
				if (utils.eventType[e.type] != 1) {
					var button;
					if (!e.which) {
						button = e.button < 2 ? 0 : e.button == 4 ? 1 : 2;
					} else {
						button = e.button;
					}
					if (button !== 0) {
						return;
					}
				}
	
				if (!this.enabled || this.initiated && utils.eventType[e.type] !== this.initiated) {
					return;
				}
	
				if (this.options.preventDefault && !utils.isBadAndroid && !utils.preventDefaultException(e.target, this.options.preventDefaultException)) {
					e.preventDefault();
				}
	
				var point = e.touches ? e.touches[0] : e,
				    pos;
	
				this.initiated = utils.eventType[e.type];
				this.moved = false;
				this.distX = 0;
				this.distY = 0;
				this.directionX = 0;
				this.directionY = 0;
				this.directionLocked = 0;
	
				this.startTime = utils.getTime();
	
				if (this.options.useTransition && this.isInTransition) {
					this._transitionTime();
					this.isInTransition = false;
					pos = this.getComputedPosition();
					this._translate(Math.round(pos.x), Math.round(pos.y));
					this._execEvent('scrollEnd');
				} else if (!this.options.useTransition && this.isAnimating) {
					this.isAnimating = false;
					this._execEvent('scrollEnd');
				}
	
				this.startX = this.x;
				this.startY = this.y;
				this.absStartX = this.x;
				this.absStartY = this.y;
				this.pointX = point.pageX;
				this.pointY = point.pageY;
	
				this._execEvent('beforeScrollStart');
			},
	
			_move: function _move(e) {
				if (!this.enabled || utils.eventType[e.type] !== this.initiated) {
					return;
				}
	
				if (this.options.preventDefault) {
					e.preventDefault();
				}
	
				var point = e.touches ? e.touches[0] : e,
				    deltaX = point.pageX - this.pointX,
				    deltaY = point.pageY - this.pointY,
				    timestamp = utils.getTime(),
				    newX,
				    newY,
				    absDistX,
				    absDistY;
	
				this.pointX = point.pageX;
				this.pointY = point.pageY;
	
				this.distX += deltaX;
				this.distY += deltaY;
				absDistX = Math.abs(this.distX);
				absDistY = Math.abs(this.distY);
	
				if (timestamp - this.endTime > 300 && absDistX < 10 && absDistY < 10) {
					return;
				}
	
				if (!this.directionLocked && !this.options.freeScroll) {
					if (absDistX > absDistY + this.options.directionLockThreshold) {
						this.directionLocked = 'h';
					} else if (absDistY >= absDistX + this.options.directionLockThreshold) {
						this.directionLocked = 'v';
					} else {
						this.directionLocked = 'n';
					}
				}
	
				if (this.directionLocked == 'h') {
					if (this.options.eventPassthrough == 'vertical') {
						e.preventDefault();
					} else if (this.options.eventPassthrough == 'horizontal') {
						this.initiated = false;
						return;
					}
	
					deltaY = 0;
				} else if (this.directionLocked == 'v') {
					if (this.options.eventPassthrough == 'horizontal') {
						e.preventDefault();
					} else if (this.options.eventPassthrough == 'vertical') {
						this.initiated = false;
						return;
					}
	
					deltaX = 0;
				}
	
				deltaX = this.hasHorizontalScroll ? deltaX : 0;
				deltaY = this.hasVerticalScroll ? deltaY : 0;
	
				newX = this.x + deltaX;
				newY = this.y + deltaY;
	
				if (newX > 0 || newX < this.maxScrollX) {
					newX = this.options.bounce ? this.x + deltaX / 3 : newX > 0 ? 0 : this.maxScrollX;
				}
				if (newY > 0 || newY < this.maxScrollY) {
					newY = this.options.bounce ? this.y + deltaY / 3 : newY > 0 ? 0 : this.maxScrollY;
				}
	
				this.directionX = deltaX > 0 ? -1 : deltaX < 0 ? 1 : 0;
				this.directionY = deltaY > 0 ? -1 : deltaY < 0 ? 1 : 0;
	
				if (!this.moved) {
					this._execEvent('scrollStart');
				}
	
				this.moved = true;
	
				this._translate(newX, newY);
	
				if (timestamp - this.startTime > 300) {
					this.startTime = timestamp;
					this.startX = this.x;
					this.startY = this.y;
	
					if (this.options.probeType == 1) {
						this._execEvent('scroll');
					}
				}
	
				if (this.options.probeType > 1) {
					this._execEvent('scroll');
				}
			},
	
			_end: function _end(e) {
				if (!this.enabled || utils.eventType[e.type] !== this.initiated) {
					return;
				}
	
				if (this.options.preventDefault && !utils.preventDefaultException(e.target, this.options.preventDefaultException)) {
					e.preventDefault();
				}
	
				var point = e.changedTouches ? e.changedTouches[0] : e,
				    momentumX,
				    momentumY,
				    duration = utils.getTime() - this.startTime,
				    newX = Math.round(this.x),
				    newY = Math.round(this.y),
				    distanceX = Math.abs(newX - this.startX),
				    distanceY = Math.abs(newY - this.startY),
				    time = 0,
				    easing = '';
	
				this.isInTransition = 0;
				this.initiated = 0;
				this.endTime = utils.getTime();
	
				if (this.resetPosition(this.options.bounceTime)) {
					return;
				}
	
				this.scrollTo(newX, newY);
				if (!this.moved) {
					if (this.options.tap) {
						utils.tap(e, this.options.tap);
					}
	
					if (this.options.click) {
						utils.click(e);
					}
	
					this._execEvent('scrollCancel');
					return;
				}
	
				if (this._events.flick && duration < 200 && distanceX < 100 && distanceY < 100) {
					this._execEvent('flick');
					return;
				}
	
				if (this.options.momentum && duration < 300) {
					momentumX = this.hasHorizontalScroll ? utils.momentum(this.x, this.startX, duration, this.maxScrollX, this.options.bounce ? this.wrapperWidth : 0, this.options.deceleration) : { destination: newX, duration: 0 };
					momentumY = this.hasVerticalScroll ? utils.momentum(this.y, this.startY, duration, this.maxScrollY, this.options.bounce ? this.wrapperHeight : 0, this.options.deceleration) : { destination: newY, duration: 0 };
					newX = momentumX.destination;
					newY = momentumY.destination;
					time = Math.max(momentumX.duration, momentumY.duration);
					this.isInTransition = 1;
				}
	
				if (this.options.snap) {
					var snap = this._nearestSnap(newX, newY);
					this.currentPage = snap;
					time = this.options.snapSpeed || Math.max(Math.max(Math.min(Math.abs(newX - snap.x), 1000), Math.min(Math.abs(newY - snap.y), 1000)), 300);
					newX = snap.x;
					newY = snap.y;
	
					this.directionX = 0;
					this.directionY = 0;
					easing = this.options.bounceEasing;
				}
	
				if (newX != this.x || newY != this.y) {
					if (newX > 0 || newX < this.maxScrollX || newY > 0 || newY < this.maxScrollY) {
						easing = utils.ease.quadratic;
					}
	
					this.scrollTo(newX, newY, time, easing);
					return;
				}
	
				this._execEvent('scrollEnd');
			},
	
			_resize: function _resize() {
				var that = this;
	
				clearTimeout(this.resizeTimeout);
	
				this.resizeTimeout = setTimeout(function () {
					that.refresh();
				}, this.options.resizePolling);
			},
	
			resetPosition: function resetPosition(time) {
				var x = this.x,
				    y = this.y;
	
				time = time || 0;
	
				if (!this.hasHorizontalScroll || this.x > 0) {
					x = 0;
				} else if (this.x < this.maxScrollX) {
					x = this.maxScrollX;
				}
	
				if (!this.hasVerticalScroll || this.y > 0) {
					y = 0;
				} else if (this.y < this.maxScrollY) {
					y = this.maxScrollY;
				}
	
				if (x == this.x && y == this.y) {
					return false;
				}
	
				this.scrollTo(x, y, time, this.options.bounceEasing);
	
				return true;
			},
	
			disable: function disable() {
				this.enabled = false;
			},
	
			enable: function enable() {
				this.enabled = true;
			},
	
			refresh: function refresh() {
				utils.getRect(this.wrapper);
	
				this.wrapperWidth = this.wrapper.clientWidth;
				this.wrapperHeight = this.wrapper.clientHeight;
	
				var rect = utils.getRect(this.scroller);
	
	
				this.scrollerWidth = rect.width;
				this.scrollerHeight = rect.height;
	
				this.maxScrollX = this.wrapperWidth - this.scrollerWidth;
				this.maxScrollY = this.wrapperHeight - this.scrollerHeight;
	
				this.hasHorizontalScroll = this.options.scrollX && this.maxScrollX < 0;
				this.hasVerticalScroll = this.options.scrollY && this.maxScrollY < 0;
	
				if (!this.hasHorizontalScroll) {
					this.maxScrollX = 0;
					this.scrollerWidth = this.wrapperWidth;
				}
	
				if (!this.hasVerticalScroll) {
					this.maxScrollY = 0;
					this.scrollerHeight = this.wrapperHeight;
				}
	
				this.endTime = 0;
				this.directionX = 0;
				this.directionY = 0;
	
				if (utils.hasPointer && !this.options.disablePointer) {
					this.wrapper.style[utils.style.touchAction] = utils.getTouchAction(this.options.eventPassthrough, true);
	
					if (!this.wrapper.style[utils.style.touchAction]) {
						this.wrapper.style[utils.style.touchAction] = utils.getTouchAction(this.options.eventPassthrough, false);
					}
				}
				this.wrapperOffset = utils.offset(this.wrapper);
	
				this._execEvent('refresh');
	
				this.resetPosition();
			},
	
			on: function on(type, fn) {
				if (!this._events[type]) {
					this._events[type] = [];
				}
	
				this._events[type].push(fn);
			},
	
			off: function off(type, fn) {
				if (!this._events[type]) {
					return;
				}
	
				var index = this._events[type].indexOf(fn);
	
				if (index > -1) {
					this._events[type].splice(index, 1);
				}
			},
	
			_execEvent: function _execEvent(type) {
				if (!this._events[type]) {
					return;
				}
	
				var i = 0,
				    l = this._events[type].length;
	
				if (!l) {
					return;
				}
	
				for (; i < l; i++) {
					this._events[type][i].apply(this, [].slice.call(arguments, 1));
				}
			},
	
			scrollBy: function scrollBy(x, y, time, easing) {
				x = this.x + x;
				y = this.y + y;
				time = time || 0;
	
				this.scrollTo(x, y, time, easing);
			},
	
			scrollTo: function scrollTo(x, y, time, easing) {
				easing = easing || utils.ease.circular;
	
				this.isInTransition = this.options.useTransition && time > 0;
				var transitionType = this.options.useTransition && easing.style;
				if (!time || transitionType) {
					if (transitionType) {
						this._transitionTimingFunction(easing.style);
						this._transitionTime(time);
					}
					this._translate(x, y);
				} else {
					this._animate(x, y, time, easing.fn);
				}
			},
	
			scrollToElement: function scrollToElement(el, time, offsetX, offsetY, easing) {
				el = el.nodeType ? el : this.scroller.querySelector(el);
	
				if (!el) {
					return;
				}
	
				var pos = utils.offset(el);
	
				pos.left -= this.wrapperOffset.left;
				pos.top -= this.wrapperOffset.top;
	
				var elRect = utils.getRect(el);
				var wrapperRect = utils.getRect(this.wrapper);
				if (offsetX === true) {
					offsetX = Math.round(elRect.width / 2 - wrapperRect.width / 2);
				}
				if (offsetY === true) {
					offsetY = Math.round(elRect.height / 2 - wrapperRect.height / 2);
				}
	
				pos.left -= offsetX || 0;
				pos.top -= offsetY || 0;
	
				pos.left = pos.left > 0 ? 0 : pos.left < this.maxScrollX ? this.maxScrollX : pos.left;
				pos.top = pos.top > 0 ? 0 : pos.top < this.maxScrollY ? this.maxScrollY : pos.top;
	
				time = time === undefined || time === null || time === 'auto' ? Math.max(Math.abs(this.x - pos.left), Math.abs(this.y - pos.top)) : time;
	
				this.scrollTo(pos.left, pos.top, time, easing);
			},
	
			_transitionTime: function _transitionTime(time) {
				if (!this.options.useTransition) {
					return;
				}
				time = time || 0;
				var durationProp = utils.style.transitionDuration;
				if (!durationProp) {
					return;
				}
	
				this.scrollerStyle[durationProp] = time + 'ms';
	
				if (!time && utils.isBadAndroid) {
					this.scrollerStyle[durationProp] = '0.0001ms';
	
					var self = this;
					rAF(function () {
						if (self.scrollerStyle[durationProp] === '0.0001ms') {
							self.scrollerStyle[durationProp] = '0s';
						}
					});
				}
	
				if (this.indicators) {
					for (var i = this.indicators.length; i--;) {
						this.indicators[i].transitionTime(time);
					}
				}
			},
	
			_transitionTimingFunction: function _transitionTimingFunction(easing) {
				this.scrollerStyle[utils.style.transitionTimingFunction] = easing;
	
				if (this.indicators) {
					for (var i = this.indicators.length; i--;) {
						this.indicators[i].transitionTimingFunction(easing);
					}
				}
			},
	
			_translate: function _translate(x, y) {
				if (this.options.useTransform) {
	
					this.scrollerStyle[utils.style.transform] = 'translate(' + x + 'px,' + y + 'px)' + this.translateZ;
				} else {
					x = Math.round(x);
					y = Math.round(y);
					this.scrollerStyle.left = x + 'px';
					this.scrollerStyle.top = y + 'px';
				}
	
				this.x = x;
				this.y = y;
	
				if (this.indicators) {
					for (var i = this.indicators.length; i--;) {
						this.indicators[i].updatePosition();
					}
				}
			},
	
			_initEvents: function _initEvents(remove) {
				var eventType = remove ? utils.removeEvent : utils.addEvent,
				    target = this.options.bindToWrapper ? this.wrapper : window;
	
				eventType(window, 'orientationchange', this);
				eventType(window, 'resize', this);
	
				if (this.options.click) {
					eventType(this.wrapper, 'click', this, true);
				}
	
				if (!this.options.disableMouse) {
					eventType(this.wrapper, 'mousedown', this);
					eventType(target, 'mousemove', this);
					eventType(target, 'mousecancel', this);
					eventType(target, 'mouseup', this);
				}
	
				if (utils.hasPointer && !this.options.disablePointer) {
					eventType(this.wrapper, utils.prefixPointerEvent('pointerdown'), this);
					eventType(target, utils.prefixPointerEvent('pointermove'), this);
					eventType(target, utils.prefixPointerEvent('pointercancel'), this);
					eventType(target, utils.prefixPointerEvent('pointerup'), this);
				}
	
				if (utils.hasTouch && !this.options.disableTouch) {
					eventType(this.wrapper, 'touchstart', this);
					eventType(target, 'touchmove', this);
					eventType(target, 'touchcancel', this);
					eventType(target, 'touchend', this);
				}
	
				eventType(this.scroller, 'transitionend', this);
				eventType(this.scroller, 'webkitTransitionEnd', this);
				eventType(this.scroller, 'oTransitionEnd', this);
				eventType(this.scroller, 'MSTransitionEnd', this);
			},
	
			getComputedPosition: function getComputedPosition() {
				var matrix = window.getComputedStyle(this.scroller, null),
				    x,
				    y;
	
				if (this.options.useTransform) {
					matrix = matrix[utils.style.transform].split(')')[0].split(', ');
					x = +(matrix[12] || matrix[4]);
					y = +(matrix[13] || matrix[5]);
				} else {
					x = +matrix.left.replace(/[^-\d.]/g, '');
					y = +matrix.top.replace(/[^-\d.]/g, '');
				}
	
				return { x: x, y: y };
			},
			_initIndicators: function _initIndicators() {
				var interactive = this.options.interactiveScrollbars,
				    customStyle = typeof this.options.scrollbars != 'string',
				    indicators = [],
				    indicator;
	
				var that = this;
	
				this.indicators = [];
	
				if (this.options.scrollbars) {
					if (this.options.scrollY) {
						indicator = {
							el: createDefaultScrollbar('v', interactive, this.options.scrollbars),
							interactive: interactive,
							defaultScrollbars: true,
							customStyle: customStyle,
							resize: this.options.resizeScrollbars,
							shrink: this.options.shrinkScrollbars,
							fade: this.options.fadeScrollbars,
							listenX: false
						};
	
						this.wrapper.appendChild(indicator.el);
						indicators.push(indicator);
					}
	
					if (this.options.scrollX) {
						indicator = {
							el: createDefaultScrollbar('h', interactive, this.options.scrollbars),
							interactive: interactive,
							defaultScrollbars: true,
							customStyle: customStyle,
							resize: this.options.resizeScrollbars,
							shrink: this.options.shrinkScrollbars,
							fade: this.options.fadeScrollbars,
							listenY: false
						};
	
						this.wrapper.appendChild(indicator.el);
						indicators.push(indicator);
					}
				}
	
				if (this.options.indicators) {
					indicators = indicators.concat(this.options.indicators);
				}
	
				for (var i = indicators.length; i--;) {
					this.indicators.push(new Indicator(this, indicators[i]));
				}
	
				function _indicatorsMap(fn) {
					if (that.indicators) {
						for (var i = that.indicators.length; i--;) {
							fn.call(that.indicators[i]);
						}
					}
				}
	
				if (this.options.fadeScrollbars) {
					this.on('scrollEnd', function () {
						_indicatorsMap(function () {
							this.fade();
						});
					});
	
					this.on('scrollCancel', function () {
						_indicatorsMap(function () {
							this.fade();
						});
					});
	
					this.on('scrollStart', function () {
						_indicatorsMap(function () {
							this.fade(1);
						});
					});
	
					this.on('beforeScrollStart', function () {
						_indicatorsMap(function () {
							this.fade(1, true);
						});
					});
				}
	
				this.on('refresh', function () {
					_indicatorsMap(function () {
						this.refresh();
					});
				});
	
				this.on('destroy', function () {
					_indicatorsMap(function () {
						this.destroy();
					});
	
					delete this.indicators;
				});
			},
	
			_initWheel: function _initWheel() {
				utils.addEvent(this.wrapper, 'wheel', this);
				utils.addEvent(this.wrapper, 'mousewheel', this);
				utils.addEvent(this.wrapper, 'DOMMouseScroll', this);
	
				this.on('destroy', function () {
					clearTimeout(this.wheelTimeout);
					this.wheelTimeout = null;
					utils.removeEvent(this.wrapper, 'wheel', this);
					utils.removeEvent(this.wrapper, 'mousewheel', this);
					utils.removeEvent(this.wrapper, 'DOMMouseScroll', this);
				});
			},
	
			_wheel: function _wheel(e) {
				if (!this.enabled) {
					return;
				}
	
				e.preventDefault();
	
				var wheelDeltaX,
				    wheelDeltaY,
				    newX,
				    newY,
				    that = this;
	
				if (this.wheelTimeout === undefined) {
					that._execEvent('scrollStart');
				}
	
				clearTimeout(this.wheelTimeout);
				this.wheelTimeout = setTimeout(function () {
					if (!that.options.snap) {
						that._execEvent('scrollEnd');
					}
					that.wheelTimeout = undefined;
				}, 400);
	
				if ('deltaX' in e) {
					if (e.deltaMode === 1) {
						wheelDeltaX = -e.deltaX * this.options.mouseWheelSpeed;
						wheelDeltaY = -e.deltaY * this.options.mouseWheelSpeed;
					} else {
						wheelDeltaX = -e.deltaX;
						wheelDeltaY = -e.deltaY;
					}
				} else if ('wheelDeltaX' in e) {
					wheelDeltaX = e.wheelDeltaX / 120 * this.options.mouseWheelSpeed;
					wheelDeltaY = e.wheelDeltaY / 120 * this.options.mouseWheelSpeed;
				} else if ('wheelDelta' in e) {
					wheelDeltaX = wheelDeltaY = e.wheelDelta / 120 * this.options.mouseWheelSpeed;
				} else if ('detail' in e) {
					wheelDeltaX = wheelDeltaY = -e.detail / 3 * this.options.mouseWheelSpeed;
				} else {
					return;
				}
	
				wheelDeltaX *= this.options.invertWheelDirection;
				wheelDeltaY *= this.options.invertWheelDirection;
	
				if (!this.hasVerticalScroll) {
					wheelDeltaX = wheelDeltaY;
					wheelDeltaY = 0;
				}
	
				if (this.options.snap) {
					newX = this.currentPage.pageX;
					newY = this.currentPage.pageY;
	
					if (wheelDeltaX > 0) {
						newX--;
					} else if (wheelDeltaX < 0) {
						newX++;
					}
	
					if (wheelDeltaY > 0) {
						newY--;
					} else if (wheelDeltaY < 0) {
						newY++;
					}
	
					this.goToPage(newX, newY);
	
					return;
				}
	
				newX = this.x + Math.round(this.hasHorizontalScroll ? wheelDeltaX : 0);
				newY = this.y + Math.round(this.hasVerticalScroll ? wheelDeltaY : 0);
	
				this.directionX = wheelDeltaX > 0 ? -1 : wheelDeltaX < 0 ? 1 : 0;
				this.directionY = wheelDeltaY > 0 ? -1 : wheelDeltaY < 0 ? 1 : 0;
	
				if (newX > 0) {
					newX = 0;
				} else if (newX < this.maxScrollX) {
					newX = this.maxScrollX;
				}
	
				if (newY > 0) {
					newY = 0;
				} else if (newY < this.maxScrollY) {
					newY = this.maxScrollY;
				}
	
				this.scrollTo(newX, newY, 0);
	
				if (this.options.probeType > 1) {
					this._execEvent('scroll');
				}
			},
	
			_initSnap: function _initSnap() {
				this.currentPage = {};
	
				if (typeof this.options.snap == 'string') {
					this.options.snap = this.scroller.querySelectorAll(this.options.snap);
				}
	
				this.on('refresh', function () {
					var i = 0,
					    l,
					    m = 0,
					    n,
					    cx,
					    cy,
					    x = 0,
					    y,
					    stepX = this.options.snapStepX || this.wrapperWidth,
					    stepY = this.options.snapStepY || this.wrapperHeight,
					    el,
					    rect;
	
					this.pages = [];
	
					if (!this.wrapperWidth || !this.wrapperHeight || !this.scrollerWidth || !this.scrollerHeight) {
						return;
					}
	
					if (this.options.snap === true) {
						cx = Math.round(stepX / 2);
						cy = Math.round(stepY / 2);
	
						while (x > -this.scrollerWidth) {
							this.pages[i] = [];
							l = 0;
							y = 0;
	
							while (y > -this.scrollerHeight) {
								this.pages[i][l] = {
									x: Math.max(x, this.maxScrollX),
									y: Math.max(y, this.maxScrollY),
									width: stepX,
									height: stepY,
									cx: x - cx,
									cy: y - cy
								};
	
								y -= stepY;
								l++;
							}
	
							x -= stepX;
							i++;
						}
					} else {
						el = this.options.snap;
						l = el.length;
						n = -1;
	
						for (; i < l; i++) {
							rect = utils.getRect(el[i]);
							if (i === 0 || rect.left <= utils.getRect(el[i - 1]).left) {
								m = 0;
								n++;
							}
	
							if (!this.pages[m]) {
								this.pages[m] = [];
							}
	
							x = Math.max(-rect.left, this.maxScrollX);
							y = Math.max(-rect.top, this.maxScrollY);
							cx = x - Math.round(rect.width / 2);
							cy = y - Math.round(rect.height / 2);
	
							this.pages[m][n] = {
								x: x,
								y: y,
								width: rect.width,
								height: rect.height,
								cx: cx,
								cy: cy
							};
	
							if (x > this.maxScrollX) {
								m++;
							}
						}
					}
	
					this.goToPage(this.currentPage.pageX || 0, this.currentPage.pageY || 0, 0);
	
					if (this.options.snapThreshold % 1 === 0) {
						this.snapThresholdX = this.options.snapThreshold;
						this.snapThresholdY = this.options.snapThreshold;
					} else {
						this.snapThresholdX = Math.round(this.pages[this.currentPage.pageX][this.currentPage.pageY].width * this.options.snapThreshold);
						this.snapThresholdY = Math.round(this.pages[this.currentPage.pageX][this.currentPage.pageY].height * this.options.snapThreshold);
					}
				});
	
				this.on('flick', function () {
					var time = this.options.snapSpeed || Math.max(Math.max(Math.min(Math.abs(this.x - this.startX), 1000), Math.min(Math.abs(this.y - this.startY), 1000)), 300);
	
					this.goToPage(this.currentPage.pageX + this.directionX, this.currentPage.pageY + this.directionY, time);
				});
			},
	
			_nearestSnap: function _nearestSnap(x, y) {
				if (!this.pages.length) {
					return { x: 0, y: 0, pageX: 0, pageY: 0 };
				}
	
				var i = 0,
				    l = this.pages.length,
				    m = 0;
	
				if (Math.abs(x - this.absStartX) < this.snapThresholdX && Math.abs(y - this.absStartY) < this.snapThresholdY) {
					return this.currentPage;
				}
	
				if (x > 0) {
					x = 0;
				} else if (x < this.maxScrollX) {
					x = this.maxScrollX;
				}
	
				if (y > 0) {
					y = 0;
				} else if (y < this.maxScrollY) {
					y = this.maxScrollY;
				}
	
				for (; i < l; i++) {
					if (x >= this.pages[i][0].cx) {
						x = this.pages[i][0].x;
						break;
					}
				}
	
				l = this.pages[i].length;
	
				for (; m < l; m++) {
					if (y >= this.pages[0][m].cy) {
						y = this.pages[0][m].y;
						break;
					}
				}
	
				if (i == this.currentPage.pageX) {
					i += this.directionX;
	
					if (i < 0) {
						i = 0;
					} else if (i >= this.pages.length) {
						i = this.pages.length - 1;
					}
	
					x = this.pages[i][0].x;
				}
	
				if (m == this.currentPage.pageY) {
					m += this.directionY;
	
					if (m < 0) {
						m = 0;
					} else if (m >= this.pages[0].length) {
						m = this.pages[0].length - 1;
					}
	
					y = this.pages[0][m].y;
				}
	
				return {
					x: x,
					y: y,
					pageX: i,
					pageY: m
				};
			},
	
			goToPage: function goToPage(x, y, time, easing) {
				easing = easing || this.options.bounceEasing;
	
				if (x >= this.pages.length) {
					x = this.pages.length - 1;
				} else if (x < 0) {
					x = 0;
				}
	
				if (y >= this.pages[x].length) {
					y = this.pages[x].length - 1;
				} else if (y < 0) {
					y = 0;
				}
	
				var posX = this.pages[x][y].x,
				    posY = this.pages[x][y].y;
	
				time = time === undefined ? this.options.snapSpeed || Math.max(Math.max(Math.min(Math.abs(posX - this.x), 1000), Math.min(Math.abs(posY - this.y), 1000)), 300) : time;
	
				this.currentPage = {
					x: posX,
					y: posY,
					pageX: x,
					pageY: y
				};
	
				this.scrollTo(posX, posY, time, easing);
			},
	
			next: function next(time, easing) {
				var x = this.currentPage.pageX,
				    y = this.currentPage.pageY;
	
				x++;
	
				if (x >= this.pages.length && this.hasVerticalScroll) {
					x = 0;
					y++;
				}
	
				this.goToPage(x, y, time, easing);
			},
	
			prev: function prev(time, easing) {
				var x = this.currentPage.pageX,
				    y = this.currentPage.pageY;
	
				x--;
	
				if (x < 0 && this.hasVerticalScroll) {
					x = 0;
					y--;
				}
	
				this.goToPage(x, y, time, easing);
			},
	
			_initKeys: function _initKeys(e) {
				var keys = {
					pageUp: 33,
					pageDown: 34,
					end: 35,
					home: 36,
					left: 37,
					up: 38,
					right: 39,
					down: 40
				};
				var i;
	
				if ((0, _typeof3.default)(this.options.keyBindings) == 'object') {
					for (i in this.options.keyBindings) {
						if (typeof this.options.keyBindings[i] == 'string') {
							this.options.keyBindings[i] = this.options.keyBindings[i].toUpperCase().charCodeAt(0);
						}
					}
				} else {
					this.options.keyBindings = {};
				}
	
				for (i in keys) {
					this.options.keyBindings[i] = this.options.keyBindings[i] || keys[i];
				}
	
				utils.addEvent(window, 'keydown', this);
	
				this.on('destroy', function () {
					utils.removeEvent(window, 'keydown', this);
				});
			},
	
			_key: function _key(e) {
				if (!this.enabled) {
					return;
				}
	
				var snap = this.options.snap,
				    newX = snap ? this.currentPage.pageX : this.x,
				    newY = snap ? this.currentPage.pageY : this.y,
				    now = utils.getTime(),
				    prevTime = this.keyTime || 0,
				    acceleration = 0.250,
				    pos;
	
				if (this.options.useTransition && this.isInTransition) {
					pos = this.getComputedPosition();
	
					this._translate(Math.round(pos.x), Math.round(pos.y));
					this.isInTransition = false;
				}
	
				this.keyAcceleration = now - prevTime < 200 ? Math.min(this.keyAcceleration + acceleration, 50) : 0;
	
				switch (e.keyCode) {
					case this.options.keyBindings.pageUp:
						if (this.hasHorizontalScroll && !this.hasVerticalScroll) {
							newX += snap ? 1 : this.wrapperWidth;
						} else {
							newY += snap ? 1 : this.wrapperHeight;
						}
						break;
					case this.options.keyBindings.pageDown:
						if (this.hasHorizontalScroll && !this.hasVerticalScroll) {
							newX -= snap ? 1 : this.wrapperWidth;
						} else {
							newY -= snap ? 1 : this.wrapperHeight;
						}
						break;
					case this.options.keyBindings.end:
						newX = snap ? this.pages.length - 1 : this.maxScrollX;
						newY = snap ? this.pages[0].length - 1 : this.maxScrollY;
						break;
					case this.options.keyBindings.home:
						newX = 0;
						newY = 0;
						break;
					case this.options.keyBindings.left:
						newX += snap ? -1 : 5 + this.keyAcceleration >> 0;
						break;
					case this.options.keyBindings.up:
						newY += snap ? 1 : 5 + this.keyAcceleration >> 0;
						break;
					case this.options.keyBindings.right:
						newX -= snap ? -1 : 5 + this.keyAcceleration >> 0;
						break;
					case this.options.keyBindings.down:
						newY -= snap ? 1 : 5 + this.keyAcceleration >> 0;
						break;
					default:
						return;
				}
	
				if (snap) {
					this.goToPage(newX, newY);
					return;
				}
	
				if (newX > 0) {
					newX = 0;
					this.keyAcceleration = 0;
				} else if (newX < this.maxScrollX) {
					newX = this.maxScrollX;
					this.keyAcceleration = 0;
				}
	
				if (newY > 0) {
					newY = 0;
					this.keyAcceleration = 0;
				} else if (newY < this.maxScrollY) {
					newY = this.maxScrollY;
					this.keyAcceleration = 0;
				}
	
				this.scrollTo(newX, newY, 0);
	
				this.keyTime = now;
			},
	
			_animate: function _animate(destX, destY, duration, easingFn) {
				var that = this,
				    startX = this.x,
				    startY = this.y,
				    startTime = utils.getTime(),
				    destTime = startTime + duration;
	
				function step() {
					var now = utils.getTime(),
					    newX,
					    newY,
					    easing;
	
					if (now >= destTime) {
						that.isAnimating = false;
						that._translate(destX, destY);
	
						if (!that.resetPosition(that.options.bounceTime)) {
							that._execEvent('scrollEnd');
						}
	
						return;
					}
	
					now = (now - startTime) / duration;
					easing = easingFn(now);
					newX = (destX - startX) * easing + startX;
					newY = (destY - startY) * easing + startY;
					that._translate(newX, newY);
	
					if (that.isAnimating) {
						rAF(step);
					}
	
					if (that.options.probeType == 3) {
						that._execEvent('scroll');
					}
				}
	
				this.isAnimating = true;
				step();
			},
	
			handleEvent: function handleEvent(e) {
				switch (e.type) {
					case 'touchstart':
					case 'pointerdown':
					case 'MSPointerDown':
					case 'mousedown':
						this._start(e);
						break;
					case 'touchmove':
					case 'pointermove':
					case 'MSPointerMove':
					case 'mousemove':
						this._move(e);
						break;
					case 'touchend':
					case 'pointerup':
					case 'MSPointerUp':
					case 'mouseup':
					case 'touchcancel':
					case 'pointercancel':
					case 'MSPointerCancel':
					case 'mousecancel':
						this._end(e);
						break;
					case 'orientationchange':
					case 'resize':
						this._resize();
						break;
					case 'transitionend':
					case 'webkitTransitionEnd':
					case 'oTransitionEnd':
					case 'MSTransitionEnd':
						this._transitionEnd(e);
						break;
					case 'wheel':
					case 'DOMMouseScroll':
					case 'mousewheel':
						this._wheel(e);
						break;
					case 'keydown':
						this._key(e);
						break;
					case 'click':
						if (this.enabled && !e._constructed) {
							e.preventDefault();
							e.stopPropagation();
						}
						break;
				}
			}
		};
		function createDefaultScrollbar(direction, interactive, type) {
			var scrollbar = document.createElement('div'),
			    indicator = document.createElement('div');
	
			if (type === true) {
				scrollbar.style.cssText = 'position:absolute;z-index:9999';
				indicator.style.cssText = '-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;position:absolute;background:rgba(0,0,0,0.5);border:1px solid rgba(255,255,255,0.9);border-radius:3px';
			}
	
			indicator.className = 'iScrollIndicator';
	
			if (direction == 'h') {
				if (type === true) {
					scrollbar.style.cssText += ';height:7px;left:2px;right:2px;bottom:0';
					indicator.style.height = '100%';
				}
				scrollbar.className = 'iScrollHorizontalScrollbar';
			} else {
				if (type === true) {
					scrollbar.style.cssText += ';width:7px;bottom:2px;top:2px;right:1px';
					indicator.style.width = '100%';
				}
				scrollbar.className = 'iScrollVerticalScrollbar';
			}
	
			scrollbar.style.cssText += ';overflow:hidden';
	
			if (!interactive) {
				scrollbar.style.pointerEvents = 'none';
			}
	
			scrollbar.appendChild(indicator);
	
			return scrollbar;
		}
	
		function Indicator(scroller, options) {
			this.wrapper = typeof options.el == 'string' ? document.querySelector(options.el) : options.el;
			this.wrapperStyle = this.wrapper.style;
			this.indicator = this.wrapper.children[0];
			this.indicatorStyle = this.indicator.style;
			this.scroller = scroller;
	
			this.options = {
				listenX: true,
				listenY: true,
				interactive: false,
				resize: true,
				defaultScrollbars: false,
				shrink: false,
				fade: false,
				speedRatioX: 0,
				speedRatioY: 0
			};
	
			for (var i in options) {
				this.options[i] = options[i];
			}
	
			this.sizeRatioX = 1;
			this.sizeRatioY = 1;
			this.maxPosX = 0;
			this.maxPosY = 0;
	
			if (this.options.interactive) {
				if (!this.options.disableTouch) {
					utils.addEvent(this.indicator, 'touchstart', this);
					utils.addEvent(window, 'touchend', this);
				}
				if (!this.options.disablePointer) {
					utils.addEvent(this.indicator, utils.prefixPointerEvent('pointerdown'), this);
					utils.addEvent(window, utils.prefixPointerEvent('pointerup'), this);
				}
				if (!this.options.disableMouse) {
					utils.addEvent(this.indicator, 'mousedown', this);
					utils.addEvent(window, 'mouseup', this);
				}
			}
	
			if (this.options.fade) {
				this.wrapperStyle[utils.style.transform] = this.scroller.translateZ;
				var durationProp = utils.style.transitionDuration;
				if (!durationProp) {
					return;
				}
				this.wrapperStyle[durationProp] = utils.isBadAndroid ? '0.0001ms' : '0ms';
	
				var self = this;
				if (utils.isBadAndroid) {
					rAF(function () {
						if (self.wrapperStyle[durationProp] === '0.0001ms') {
							self.wrapperStyle[durationProp] = '0s';
						}
					});
				}
				this.wrapperStyle.opacity = '0';
			}
		}
	
		Indicator.prototype = {
			handleEvent: function handleEvent(e) {
				switch (e.type) {
					case 'touchstart':
					case 'pointerdown':
					case 'MSPointerDown':
					case 'mousedown':
						this._start(e);
						break;
					case 'touchmove':
					case 'pointermove':
					case 'MSPointerMove':
					case 'mousemove':
						this._move(e);
						break;
					case 'touchend':
					case 'pointerup':
					case 'MSPointerUp':
					case 'mouseup':
					case 'touchcancel':
					case 'pointercancel':
					case 'MSPointerCancel':
					case 'mousecancel':
						this._end(e);
						break;
				}
			},
	
			destroy: function destroy() {
				if (this.options.fadeScrollbars) {
					clearTimeout(this.fadeTimeout);
					this.fadeTimeout = null;
				}
				if (this.options.interactive) {
					utils.removeEvent(this.indicator, 'touchstart', this);
					utils.removeEvent(this.indicator, utils.prefixPointerEvent('pointerdown'), this);
					utils.removeEvent(this.indicator, 'mousedown', this);
	
					utils.removeEvent(window, 'touchmove', this);
					utils.removeEvent(window, utils.prefixPointerEvent('pointermove'), this);
					utils.removeEvent(window, 'mousemove', this);
	
					utils.removeEvent(window, 'touchend', this);
					utils.removeEvent(window, utils.prefixPointerEvent('pointerup'), this);
					utils.removeEvent(window, 'mouseup', this);
				}
	
				if (this.options.defaultScrollbars && this.wrapper.parentNode) {
					this.wrapper.parentNode.removeChild(this.wrapper);
				}
			},
	
			_start: function _start(e) {
				var point = e.touches ? e.touches[0] : e;
	
				e.preventDefault();
				e.stopPropagation();
	
				this.transitionTime();
	
				this.initiated = true;
				this.moved = false;
				this.lastPointX = point.pageX;
				this.lastPointY = point.pageY;
	
				this.startTime = utils.getTime();
	
				if (!this.options.disableTouch) {
					utils.addEvent(window, 'touchmove', this);
				}
				if (!this.options.disablePointer) {
					utils.addEvent(window, utils.prefixPointerEvent('pointermove'), this);
				}
				if (!this.options.disableMouse) {
					utils.addEvent(window, 'mousemove', this);
				}
	
				this.scroller._execEvent('beforeScrollStart');
			},
	
			_move: function _move(e) {
				var point = e.touches ? e.touches[0] : e,
				    deltaX,
				    deltaY,
				    newX,
				    newY,
				    timestamp = utils.getTime();
	
				if (!this.moved) {
					this.scroller._execEvent('scrollStart');
				}
	
				this.moved = true;
	
				deltaX = point.pageX - this.lastPointX;
				this.lastPointX = point.pageX;
	
				deltaY = point.pageY - this.lastPointY;
				this.lastPointY = point.pageY;
	
				newX = this.x + deltaX;
				newY = this.y + deltaY;
	
				this._pos(newX, newY);
	
				if (this.scroller.options.probeType == 1 && timestamp - this.startTime > 300) {
					this.startTime = timestamp;
					this.scroller._execEvent('scroll');
				} else if (this.scroller.options.probeType > 1) {
					this.scroller._execEvent('scroll');
				}
	
				e.preventDefault();
				e.stopPropagation();
			},
	
			_end: function _end(e) {
				if (!this.initiated) {
					return;
				}
	
				this.initiated = false;
	
				e.preventDefault();
				e.stopPropagation();
	
				utils.removeEvent(window, 'touchmove', this);
				utils.removeEvent(window, utils.prefixPointerEvent('pointermove'), this);
				utils.removeEvent(window, 'mousemove', this);
	
				if (this.scroller.options.snap) {
					var snap = this.scroller._nearestSnap(this.scroller.x, this.scroller.y);
	
					var time = this.options.snapSpeed || Math.max(Math.max(Math.min(Math.abs(this.scroller.x - snap.x), 1000), Math.min(Math.abs(this.scroller.y - snap.y), 1000)), 300);
	
					if (this.scroller.x != snap.x || this.scroller.y != snap.y) {
						this.scroller.directionX = 0;
						this.scroller.directionY = 0;
						this.scroller.currentPage = snap;
						this.scroller.scrollTo(snap.x, snap.y, time, this.scroller.options.bounceEasing);
					}
				}
	
				if (this.moved) {
					this.scroller._execEvent('scrollEnd');
				}
			},
	
			transitionTime: function transitionTime(time) {
				time = time || 0;
				var durationProp = utils.style.transitionDuration;
				if (!durationProp) {
					return;
				}
	
				this.indicatorStyle[durationProp] = time + 'ms';
	
				if (!time && utils.isBadAndroid) {
					this.indicatorStyle[durationProp] = '0.0001ms';
	
					var self = this;
					rAF(function () {
						if (self.indicatorStyle[durationProp] === '0.0001ms') {
							self.indicatorStyle[durationProp] = '0s';
						}
					});
				}
			},
	
			transitionTimingFunction: function transitionTimingFunction(easing) {
				this.indicatorStyle[utils.style.transitionTimingFunction] = easing;
			},
	
			refresh: function refresh() {
				this.transitionTime();
	
				if (this.options.listenX && !this.options.listenY) {
					this.indicatorStyle.display = this.scroller.hasHorizontalScroll ? 'block' : 'none';
				} else if (this.options.listenY && !this.options.listenX) {
					this.indicatorStyle.display = this.scroller.hasVerticalScroll ? 'block' : 'none';
				} else {
					this.indicatorStyle.display = this.scroller.hasHorizontalScroll || this.scroller.hasVerticalScroll ? 'block' : 'none';
				}
	
				if (this.scroller.hasHorizontalScroll && this.scroller.hasVerticalScroll) {
					utils.addClass(this.wrapper, 'iScrollBothScrollbars');
					utils.removeClass(this.wrapper, 'iScrollLoneScrollbar');
	
					if (this.options.defaultScrollbars && this.options.customStyle) {
						if (this.options.listenX) {
							this.wrapper.style.right = '8px';
						} else {
							this.wrapper.style.bottom = '8px';
						}
					}
				} else {
					utils.removeClass(this.wrapper, 'iScrollBothScrollbars');
					utils.addClass(this.wrapper, 'iScrollLoneScrollbar');
	
					if (this.options.defaultScrollbars && this.options.customStyle) {
						if (this.options.listenX) {
							this.wrapper.style.right = '2px';
						} else {
							this.wrapper.style.bottom = '2px';
						}
					}
				}
	
				utils.getRect(this.wrapper);
	
				if (this.options.listenX) {
					this.wrapperWidth = this.wrapper.clientWidth;
					if (this.options.resize) {
						this.indicatorWidth = Math.max(Math.round(this.wrapperWidth * this.wrapperWidth / (this.scroller.scrollerWidth || this.wrapperWidth || 1)), 8);
						this.indicatorStyle.width = this.indicatorWidth + 'px';
					} else {
						this.indicatorWidth = this.indicator.clientWidth;
					}
	
					this.maxPosX = this.wrapperWidth - this.indicatorWidth;
	
					if (this.options.shrink == 'clip') {
						this.minBoundaryX = -this.indicatorWidth + 8;
						this.maxBoundaryX = this.wrapperWidth - 8;
					} else {
						this.minBoundaryX = 0;
						this.maxBoundaryX = this.maxPosX;
					}
	
					this.sizeRatioX = this.options.speedRatioX || this.scroller.maxScrollX && this.maxPosX / this.scroller.maxScrollX;
				}
	
				if (this.options.listenY) {
					this.wrapperHeight = this.wrapper.clientHeight;
					if (this.options.resize) {
						this.indicatorHeight = Math.max(Math.round(this.wrapperHeight * this.wrapperHeight / (this.scroller.scrollerHeight || this.wrapperHeight || 1)), 8);
						this.indicatorStyle.height = this.indicatorHeight + 'px';
					} else {
						this.indicatorHeight = this.indicator.clientHeight;
					}
	
					this.maxPosY = this.wrapperHeight - this.indicatorHeight;
	
					if (this.options.shrink == 'clip') {
						this.minBoundaryY = -this.indicatorHeight + 8;
						this.maxBoundaryY = this.wrapperHeight - 8;
					} else {
						this.minBoundaryY = 0;
						this.maxBoundaryY = this.maxPosY;
					}
	
					this.maxPosY = this.wrapperHeight - this.indicatorHeight;
					this.sizeRatioY = this.options.speedRatioY || this.scroller.maxScrollY && this.maxPosY / this.scroller.maxScrollY;
				}
	
				this.updatePosition();
			},
	
			updatePosition: function updatePosition() {
				var x = this.options.listenX && Math.round(this.sizeRatioX * this.scroller.x) || 0,
				    y = this.options.listenY && Math.round(this.sizeRatioY * this.scroller.y) || 0;
	
				if (!this.options.ignoreBoundaries) {
					if (x < this.minBoundaryX) {
						if (this.options.shrink == 'scale') {
							this.width = Math.max(this.indicatorWidth + x, 8);
							this.indicatorStyle.width = this.width + 'px';
						}
						x = this.minBoundaryX;
					} else if (x > this.maxBoundaryX) {
						if (this.options.shrink == 'scale') {
							this.width = Math.max(this.indicatorWidth - (x - this.maxPosX), 8);
							this.indicatorStyle.width = this.width + 'px';
							x = this.maxPosX + this.indicatorWidth - this.width;
						} else {
							x = this.maxBoundaryX;
						}
					} else if (this.options.shrink == 'scale' && this.width != this.indicatorWidth) {
						this.width = this.indicatorWidth;
						this.indicatorStyle.width = this.width + 'px';
					}
	
					if (y < this.minBoundaryY) {
						if (this.options.shrink == 'scale') {
							this.height = Math.max(this.indicatorHeight + y * 3, 8);
							this.indicatorStyle.height = this.height + 'px';
						}
						y = this.minBoundaryY;
					} else if (y > this.maxBoundaryY) {
						if (this.options.shrink == 'scale') {
							this.height = Math.max(this.indicatorHeight - (y - this.maxPosY) * 3, 8);
							this.indicatorStyle.height = this.height + 'px';
							y = this.maxPosY + this.indicatorHeight - this.height;
						} else {
							y = this.maxBoundaryY;
						}
					} else if (this.options.shrink == 'scale' && this.height != this.indicatorHeight) {
						this.height = this.indicatorHeight;
						this.indicatorStyle.height = this.height + 'px';
					}
				}
	
				this.x = x;
				this.y = y;
	
				if (this.scroller.options.useTransform) {
					this.indicatorStyle[utils.style.transform] = 'translate(' + x + 'px,' + y + 'px)' + this.scroller.translateZ;
				} else {
					this.indicatorStyle.left = x + 'px';
					this.indicatorStyle.top = y + 'px';
				}
			},
	
			_pos: function _pos(x, y) {
				if (x < 0) {
					x = 0;
				} else if (x > this.maxPosX) {
					x = this.maxPosX;
				}
	
				if (y < 0) {
					y = 0;
				} else if (y > this.maxPosY) {
					y = this.maxPosY;
				}
	
				x = this.options.listenX ? Math.round(x / this.sizeRatioX) : this.scroller.x;
				y = this.options.listenY ? Math.round(y / this.sizeRatioY) : this.scroller.y;
	
				this.scroller.scrollTo(x, y);
			},
	
			fade: function fade(val, hold) {
				if (hold && !this.visible) {
					return;
				}
	
				clearTimeout(this.fadeTimeout);
				this.fadeTimeout = null;
	
				var time = val ? 250 : 500,
				    delay = val ? 0 : 300;
				val = val ? '1' : '0';
	
				this.wrapperStyle[utils.style.transitionDuration] = time + 'ms';
	
				this.fadeTimeout = setTimeout(function (val) {
					this.wrapperStyle.opacity = val;
					this.visible = +val;
				}.bind(this, val), delay);
			}
		};
	
		IScroll.utils = utils;
	
		if (typeof module != 'undefined' && module.exports) {
			module.exports = IScroll;
		} else if (true) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return IScroll;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.IScroll = IScroll;
		}
	})(window, document, Math);

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _iscrollProbe = __webpack_require__(91);
	
	var _iscrollProbe2 = _interopRequireDefault(_iscrollProbe);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var extend = function extend(oldObj, newObj) {
	  for (var key in newObj) {
	    oldObj[key] = newObj[key];
	  }
	  return oldObj;
	};
	
	var Scroll = function Scroll(selector, opts) {
	  var $scroll;
	  var options = {
	    probeType: 2,
	    scrollbars: 'custom',
	    mouseWheel: true,
	    fadeScrollbars: true,
	    bounce: true,
	    listenX: false,
	    interactiveScrollbars: true,
	    shrinkScrollbars: 'scale',
	    click: true,
	    momentum: true,
	    preventDefaultException: { tagName: /^(INPUT|TEXTAREA|BUTTON|SELECT|IMG)$/ }
	  };
	  options = extend(options, opts || {});
	
	  _iscrollProbe2.default.utils.isBadAndroid = false;
	  $scroll = new _iscrollProbe2.default(selector, options);
	
	  $scroll.refresh();
	  return $scroll;
	};
	
	if (typeof module != 'undefined' && module.exports) {
	  module.exports = Scroll;
	} else {
	  window.scroll = Scroll;
	}

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (Vue) {
	  Vue.component('pagination', _pagination2.default);
	  Vue.component('loading', _loading2.default);
	  Vue.component('bread-crumb', _breadCrumb2.default);
	  Vue.component('modal', _modal2.default);
	  Vue.component('iconselect', _iconselect2.default);
	  Vue.component('treeselect', _treeselect2.default);
	  Vue.component('treejurisdiction', _treejurisdiction2.default);
	  Vue.component('upload-img', _uploadImg2.default);
	  Vue.component('modify-modal', _modifyModal2.default);
	  Vue.component('topbar', _topbar2.default);
	};
	
	var _pagination = __webpack_require__(184);
	
	var _pagination2 = _interopRequireDefault(_pagination);
	
	var _loading = __webpack_require__(181);
	
	var _loading2 = _interopRequireDefault(_loading);
	
	var _breadCrumb = __webpack_require__(179);
	
	var _breadCrumb2 = _interopRequireDefault(_breadCrumb);
	
	var _modal = __webpack_require__(182);
	
	var _modal2 = _interopRequireDefault(_modal);
	
	var _iconselect = __webpack_require__(180);
	
	var _iconselect2 = _interopRequireDefault(_iconselect);
	
	var _treeselect = __webpack_require__(187);
	
	var _treeselect2 = _interopRequireDefault(_treeselect);
	
	var _treejurisdiction = __webpack_require__(186);
	
	var _treejurisdiction2 = _interopRequireDefault(_treejurisdiction);
	
	var _uploadImg = __webpack_require__(188);
	
	var _uploadImg2 = _interopRequireDefault(_uploadImg);
	
	var _modifyModal = __webpack_require__(183);
	
	var _modifyModal2 = _interopRequireDefault(_modifyModal);
	
	var _topbar = __webpack_require__(185);
	
	var _topbar2 = _interopRequireDefault(_topbar);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = authConfig;
	
	var _constants = __webpack_require__(5);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function authConfig(Vue) {
	
	    Vue.http.interceptors.push(function (request, next) {
	
	        request.credentials = true;
	        var headers, tokens;
	
	        tokens = localStorage.getItem("tokens");
	        headers = request.headers || (request.headers = {});
	        if (tokens !== null && tokens !== 'undefined') {
	            request.headers.set('mem_access_token', tokens);
	            request.headers.set('Accept', 'application/json');
	        }
	
	        next(function (response) {
	            if (response.status && response.status.code === 201) {
	                localStorage.removeItem(_constants2.default.AUTH_TOKEN_KEY);
	            }
	            if (response.headers && response.headers.Authorization) {
	                localStorage.setItem(_constants2.default.AUTH_TOKEN_KEY, response.headers.Authorization);
	            }
	            if (response.entity && response.entity.token && response.entity.token.length > 10) {
	                localStorage.setItem(_constants2.default.AUTH_TOKEN_KEY, response.entity.token);
	            }
	            return response;
	        });
	    });
	}

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	__webpack_require__(163);
	
	__webpack_require__(164);
	
	var _sweetalert = __webpack_require__(89);
	
	var _sweetalert2 = _interopRequireDefault(_sweetalert);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  install: function install(vue) {
	    "use strict";
	
	    vue.prototype.$swal = _sweetalert2.default;
	
	    vue.prototype.$alert = function () {
	      var title = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "确定要这样吗？";
	      var text = arguments[1];
	      var callbackOk = arguments[2];
	
	
	      if (typeof text === 'function') {
	        callbackOk = arguments[1];
	        text = undefined;
	      }
	
	      return (0, _sweetalert2.default)({
	        title: title,
	        text: text,
	        confirmButtonText: '确定'
	      }, function () {
	        typeof callbackOk === 'function' && callbackOk();
	      });
	    };
	
	    vue.prototype.$confirm = function () {
	      var title = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "确定要这样吗？";
	      var text = arguments[1];
	      var callbackOk = arguments[2];
	      var callbackCancel = arguments[3];
	
	      if (typeof text === 'function') {
	        callbackCancel = arguments[2];
	        callbackOk = arguments[1];
	        text = undefined;
	      }
	      return (0, _sweetalert2.default)({
	        title: title,
	        text: text,
	        showCancelButton: true,
	        cancelButtonText: '取消',
	        confirmButtonText: '确定'
	      }, function (isConfirm) {
	        if (isConfirm) {
	          typeof callbackOk === 'function' && callbackOk();
	        } else {
	          typeof callbackCancel === 'function' && callbackCancel();
	        }
	      });
	    };
	
	    vue.prototype.$prompt = function () {
	      var title = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "确定要这样吗？";
	      var text = arguments[1];
	      var callbackOk = arguments[2];
	      var callbackCancel = arguments[3];
	
	      if (typeof text === 'function') {
	        callbackCancel = arguments[2];
	        callbackOk = arguments[1];
	        text = undefined;
	      }
	      return (0, _sweetalert2.default)({
	        title: title,
	        text: text,
	        type: "input",
	        showCancelButton: true,
	        cancelButtonText: '取消',
	        confirmButtonText: '确定',
	        closeOnConfirm: false
	      }, function (inputValue) {
	        if (inputValue === false) {
	          typeof callbackCancel === 'function' && callbackCancel();
	          return false;
	        } else {
	          typeof callbackOk === 'function' && callbackOk(inputValue);
	        }
	      });
	    };
	
	    vue.prototype.$toast = function (title) {
	      var time = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 3000;
	
	      return (0, _sweetalert2.default)({
	        title: title,
	        text: '',
	        type: "success",
	        showCancelButton: false,
	        showConfirmButton: false,
	        timer: time,
	        allowOutsideClick: true
	      });
	    };
	  }
	
	};

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(100), __esModule: true };

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(101), __esModule: true };

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(102), __esModule: true };

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

	var core = __webpack_require__(7);
	var $JSON = core.JSON || (core.JSON = { stringify: JSON.stringify });
	module.exports = function stringify(it) { // eslint-disable-line no-unused-vars
	  return $JSON.stringify.apply($JSON, arguments);
	};


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(54);
	__webpack_require__(55);
	__webpack_require__(56);
	__webpack_require__(129);
	__webpack_require__(131);
	__webpack_require__(132);
	module.exports = __webpack_require__(7).Promise;


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(130);
	__webpack_require__(54);
	__webpack_require__(133);
	__webpack_require__(134);
	module.exports = __webpack_require__(7).Symbol;


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(55);
	__webpack_require__(56);
	module.exports = __webpack_require__(37).f('iterator');


/***/ }),
/* 103 */
/***/ (function(module, exports) {

	module.exports = function () { /* empty */ };


/***/ }),
/* 104 */
/***/ (function(module, exports) {

	module.exports = function (it, Constructor, name, forbiddenField) {
	  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
	    throw TypeError(name + ': incorrect invocation!');
	  } return it;
	};


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(15);
	var toLength = __webpack_require__(52);
	var toAbsoluteIndex = __webpack_require__(125);
	module.exports = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIObject($this);
	    var length = toLength(O.length);
	    var index = toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare
	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare
	      if (value != value) return true;
	    // Array#indexOf ignores holes, Array#includes - not
	    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
	      if (O[index] === el) return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

	// all enumerable object keys, includes symbols
	var getKeys = __webpack_require__(30);
	var gOPS = __webpack_require__(45);
	var pIE = __webpack_require__(31);
	module.exports = function (it) {
	  var result = getKeys(it);
	  var getSymbols = gOPS.f;
	  if (getSymbols) {
	    var symbols = getSymbols(it);
	    var isEnum = pIE.f;
	    var i = 0;
	    var key;
	    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
	  } return result;
	};


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

	var ctx = __webpack_require__(21);
	var call = __webpack_require__(112);
	var isArrayIter = __webpack_require__(110);
	var anObject = __webpack_require__(8);
	var toLength = __webpack_require__(52);
	var getIterFn = __webpack_require__(127);
	var BREAK = {};
	var RETURN = {};
	var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
	  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
	  var f = ctx(fn, that, entries ? 2 : 1);
	  var index = 0;
	  var length, step, iterator, result;
	  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
	  // fast case for arrays with default iterator
	  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
	    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
	    if (result === BREAK || result === RETURN) return result;
	  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
	    result = call(iterator, f, step.value, entries);
	    if (result === BREAK || result === RETURN) return result;
	  }
	};
	exports.BREAK = BREAK;
	exports.RETURN = RETURN;


/***/ }),
/* 108 */
/***/ (function(module, exports) {

	// fast apply, http://jsperf.lnkit.com/fast-apply/5
	module.exports = function (fn, args, that) {
	  var un = that === undefined;
	  switch (args.length) {
	    case 0: return un ? fn()
	                      : fn.call(that);
	    case 1: return un ? fn(args[0])
	                      : fn.call(that, args[0]);
	    case 2: return un ? fn(args[0], args[1])
	                      : fn.call(that, args[0], args[1]);
	    case 3: return un ? fn(args[0], args[1], args[2])
	                      : fn.call(that, args[0], args[1], args[2]);
	    case 4: return un ? fn(args[0], args[1], args[2], args[3])
	                      : fn.call(that, args[0], args[1], args[2], args[3]);
	  } return fn.apply(that, args);
	};


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(16);
	// eslint-disable-next-line no-prototype-builtins
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

	// check on default Array iterator
	var Iterators = __webpack_require__(18);
	var ITERATOR = __webpack_require__(4)('iterator');
	var ArrayProto = Array.prototype;
	
	module.exports = function (it) {
	  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
	};


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.2.2 IsArray(argument)
	var cof = __webpack_require__(16);
	module.exports = Array.isArray || function isArray(arg) {
	  return cof(arg) == 'Array';
	};


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

	// call something on iterator step with safe closing on error
	var anObject = __webpack_require__(8);
	module.exports = function (iterator, fn, value, entries) {
	  try {
	    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
	  // 7.4.6 IteratorClose(iterator, completion)
	  } catch (e) {
	    var ret = iterator['return'];
	    if (ret !== undefined) anObject(ret.call(iterator));
	    throw e;
	  }
	};


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var create = __webpack_require__(43);
	var descriptor = __webpack_require__(23);
	var setToStringTag = __webpack_require__(24);
	var IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(12)(IteratorPrototype, __webpack_require__(4)('iterator'), function () { return this; });
	
	module.exports = function (Constructor, NAME, next) {
	  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
	  setToStringTag(Constructor, NAME + ' Iterator');
	};


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

	var ITERATOR = __webpack_require__(4)('iterator');
	var SAFE_CLOSING = false;
	
	try {
	  var riter = [7][ITERATOR]();
	  riter['return'] = function () { SAFE_CLOSING = true; };
	  // eslint-disable-next-line no-throw-literal
	  Array.from(riter, function () { throw 2; });
	} catch (e) { /* empty */ }
	
	module.exports = function (exec, skipClosing) {
	  if (!skipClosing && !SAFE_CLOSING) return false;
	  var safe = false;
	  try {
	    var arr = [7];
	    var iter = arr[ITERATOR]();
	    iter.next = function () { return { done: safe = true }; };
	    arr[ITERATOR] = function () { return iter; };
	    exec(arr);
	  } catch (e) { /* empty */ }
	  return safe;
	};


/***/ }),
/* 115 */
/***/ (function(module, exports) {

	module.exports = function (done, value) {
	  return { value: value, done: !!done };
	};


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

	var META = __webpack_require__(25)('meta');
	var isObject = __webpack_require__(13);
	var has = __webpack_require__(11);
	var setDesc = __webpack_require__(14).f;
	var id = 0;
	var isExtensible = Object.isExtensible || function () {
	  return true;
	};
	var FREEZE = !__webpack_require__(22)(function () {
	  return isExtensible(Object.preventExtensions({}));
	});
	var setMeta = function (it) {
	  setDesc(it, META, { value: {
	    i: 'O' + ++id, // object ID
	    w: {}          // weak collections IDs
	  } });
	};
	var fastKey = function (it, create) {
	  // return primitive with prefix
	  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return 'F';
	    // not necessary to add metadata
	    if (!create) return 'E';
	    // add missing metadata
	    setMeta(it);
	  // return object ID
	  } return it[META].i;
	};
	var getWeak = function (it, create) {
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return true;
	    // not necessary to add metadata
	    if (!create) return false;
	    // add missing metadata
	    setMeta(it);
	  // return hash weak collections IDs
	  } return it[META].w;
	};
	// add metadata on freeze-family methods calling
	var onFreeze = function (it) {
	  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
	  return it;
	};
	var meta = module.exports = {
	  KEY: META,
	  NEED: false,
	  fastKey: fastKey,
	  getWeak: getWeak,
	  onFreeze: onFreeze
	};


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(3);
	var macrotask = __webpack_require__(51).set;
	var Observer = global.MutationObserver || global.WebKitMutationObserver;
	var process = global.process;
	var Promise = global.Promise;
	var isNode = __webpack_require__(16)(process) == 'process';
	
	module.exports = function () {
	  var head, last, notify;
	
	  var flush = function () {
	    var parent, fn;
	    if (isNode && (parent = process.domain)) parent.exit();
	    while (head) {
	      fn = head.fn;
	      head = head.next;
	      try {
	        fn();
	      } catch (e) {
	        if (head) notify();
	        else last = undefined;
	        throw e;
	      }
	    } last = undefined;
	    if (parent) parent.enter();
	  };
	
	  // Node.js
	  if (isNode) {
	    notify = function () {
	      process.nextTick(flush);
	    };
	  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
	  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
	    var toggle = true;
	    var node = document.createTextNode('');
	    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
	    notify = function () {
	      node.data = toggle = !toggle;
	    };
	  // environments with maybe non-completely correct, but existent Promise
	  } else if (Promise && Promise.resolve) {
	    // Promise.resolve without an argument throws an error in LG WebOS 2
	    var promise = Promise.resolve(undefined);
	    notify = function () {
	      promise.then(flush);
	    };
	  // for other environments - macrotask based on:
	  // - setImmediate
	  // - MessageChannel
	  // - window.postMessag
	  // - onreadystatechange
	  // - setTimeout
	  } else {
	    notify = function () {
	      // strange IE + webpack dev server bug - use .call(global)
	      macrotask.call(global, flush);
	    };
	  }
	
	  return function (fn) {
	    var task = { fn: fn, next: undefined };
	    if (last) last.next = task;
	    if (!head) {
	      head = task;
	      notify();
	    } last = task;
	  };
	};


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(14);
	var anObject = __webpack_require__(8);
	var getKeys = __webpack_require__(30);
	
	module.exports = __webpack_require__(10) ? Object.defineProperties : function defineProperties(O, Properties) {
	  anObject(O);
	  var keys = getKeys(Properties);
	  var length = keys.length;
	  var i = 0;
	  var P;
	  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

	var pIE = __webpack_require__(31);
	var createDesc = __webpack_require__(23);
	var toIObject = __webpack_require__(15);
	var toPrimitive = __webpack_require__(35);
	var has = __webpack_require__(11);
	var IE8_DOM_DEFINE = __webpack_require__(41);
	var gOPD = Object.getOwnPropertyDescriptor;
	
	exports.f = __webpack_require__(10) ? gOPD : function getOwnPropertyDescriptor(O, P) {
	  O = toIObject(O);
	  P = toPrimitive(P, true);
	  if (IE8_DOM_DEFINE) try {
	    return gOPD(O, P);
	  } catch (e) { /* empty */ }
	  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
	};


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	var toIObject = __webpack_require__(15);
	var gOPN = __webpack_require__(44).f;
	var toString = {}.toString;
	
	var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];
	
	var getWindowNames = function (it) {
	  try {
	    return gOPN(it);
	  } catch (e) {
	    return windowNames.slice();
	  }
	};
	
	module.exports.f = function getOwnPropertyNames(it) {
	  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
	};


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has = __webpack_require__(11);
	var toObject = __webpack_require__(53);
	var IE_PROTO = __webpack_require__(32)('IE_PROTO');
	var ObjectProto = Object.prototype;
	
	module.exports = Object.getPrototypeOf || function (O) {
	  O = toObject(O);
	  if (has(O, IE_PROTO)) return O[IE_PROTO];
	  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

	var hide = __webpack_require__(12);
	module.exports = function (target, src, safe) {
	  for (var key in src) {
	    if (safe && target[key]) target[key] = src[key];
	    else hide(target, key, src[key]);
	  } return target;
	};


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(3);
	var core = __webpack_require__(7);
	var dP = __webpack_require__(14);
	var DESCRIPTORS = __webpack_require__(10);
	var SPECIES = __webpack_require__(4)('species');
	
	module.exports = function (KEY) {
	  var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
	  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
	    configurable: true,
	    get: function () { return this; }
	  });
	};


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(34);
	var defined = __webpack_require__(26);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function (TO_STRING) {
	  return function (that, pos) {
	    var s = String(defined(that));
	    var i = toInteger(pos);
	    var l = s.length;
	    var a, b;
	    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(34);
	var max = Math.max;
	var min = Math.min;
	module.exports = function (index, length) {
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(3);
	var navigator = global.navigator;
	
	module.exports = navigator && navigator.userAgent || '';


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

	var classof = __webpack_require__(39);
	var ITERATOR = __webpack_require__(4)('iterator');
	var Iterators = __webpack_require__(18);
	module.exports = __webpack_require__(7).getIteratorMethod = function (it) {
	  if (it != undefined) return it[ITERATOR]
	    || it['@@iterator']
	    || Iterators[classof(it)];
	};


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var addToUnscopables = __webpack_require__(103);
	var step = __webpack_require__(115);
	var Iterators = __webpack_require__(18);
	var toIObject = __webpack_require__(15);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(42)(Array, 'Array', function (iterated, kind) {
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var kind = this._k;
	  var index = this._i++;
	  if (!O || index >= O.length) {
	    this._t = undefined;
	    return step(1);
	  }
	  if (kind == 'keys') return step(0, index);
	  if (kind == 'values') return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(19);
	var global = __webpack_require__(3);
	var ctx = __webpack_require__(21);
	var classof = __webpack_require__(39);
	var $export = __webpack_require__(17);
	var isObject = __webpack_require__(13);
	var aFunction = __webpack_require__(20);
	var anInstance = __webpack_require__(104);
	var forOf = __webpack_require__(107);
	var speciesConstructor = __webpack_require__(50);
	var task = __webpack_require__(51).set;
	var microtask = __webpack_require__(117)();
	var newPromiseCapabilityModule = __webpack_require__(29);
	var perform = __webpack_require__(47);
	var userAgent = __webpack_require__(126);
	var promiseResolve = __webpack_require__(48);
	var PROMISE = 'Promise';
	var TypeError = global.TypeError;
	var process = global.process;
	var versions = process && process.versions;
	var v8 = versions && versions.v8 || '';
	var $Promise = global[PROMISE];
	var isNode = classof(process) == 'process';
	var empty = function () { /* empty */ };
	var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
	var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;
	
	var USE_NATIVE = !!function () {
	  try {
	    // correct subclassing with @@species support
	    var promise = $Promise.resolve(1);
	    var FakePromise = (promise.constructor = {})[__webpack_require__(4)('species')] = function (exec) {
	      exec(empty, empty);
	    };
	    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
	    return (isNode || typeof PromiseRejectionEvent == 'function')
	      && promise.then(empty) instanceof FakePromise
	      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
	      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
	      // we can't detect it synchronously, so just check versions
	      && v8.indexOf('6.6') !== 0
	      && userAgent.indexOf('Chrome/66') === -1;
	  } catch (e) { /* empty */ }
	}();
	
	// helpers
	var isThenable = function (it) {
	  var then;
	  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
	};
	var notify = function (promise, isReject) {
	  if (promise._n) return;
	  promise._n = true;
	  var chain = promise._c;
	  microtask(function () {
	    var value = promise._v;
	    var ok = promise._s == 1;
	    var i = 0;
	    var run = function (reaction) {
	      var handler = ok ? reaction.ok : reaction.fail;
	      var resolve = reaction.resolve;
	      var reject = reaction.reject;
	      var domain = reaction.domain;
	      var result, then, exited;
	      try {
	        if (handler) {
	          if (!ok) {
	            if (promise._h == 2) onHandleUnhandled(promise);
	            promise._h = 1;
	          }
	          if (handler === true) result = value;
	          else {
	            if (domain) domain.enter();
	            result = handler(value); // may throw
	            if (domain) {
	              domain.exit();
	              exited = true;
	            }
	          }
	          if (result === reaction.promise) {
	            reject(TypeError('Promise-chain cycle'));
	          } else if (then = isThenable(result)) {
	            then.call(result, resolve, reject);
	          } else resolve(result);
	        } else reject(value);
	      } catch (e) {
	        if (domain && !exited) domain.exit();
	        reject(e);
	      }
	    };
	    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
	    promise._c = [];
	    promise._n = false;
	    if (isReject && !promise._h) onUnhandled(promise);
	  });
	};
	var onUnhandled = function (promise) {
	  task.call(global, function () {
	    var value = promise._v;
	    var unhandled = isUnhandled(promise);
	    var result, handler, console;
	    if (unhandled) {
	      result = perform(function () {
	        if (isNode) {
	          process.emit('unhandledRejection', value, promise);
	        } else if (handler = global.onunhandledrejection) {
	          handler({ promise: promise, reason: value });
	        } else if ((console = global.console) && console.error) {
	          console.error('Unhandled promise rejection', value);
	        }
	      });
	      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
	      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
	    } promise._a = undefined;
	    if (unhandled && result.e) throw result.v;
	  });
	};
	var isUnhandled = function (promise) {
	  return promise._h !== 1 && (promise._a || promise._c).length === 0;
	};
	var onHandleUnhandled = function (promise) {
	  task.call(global, function () {
	    var handler;
	    if (isNode) {
	      process.emit('rejectionHandled', promise);
	    } else if (handler = global.onrejectionhandled) {
	      handler({ promise: promise, reason: promise._v });
	    }
	  });
	};
	var $reject = function (value) {
	  var promise = this;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  promise._v = value;
	  promise._s = 2;
	  if (!promise._a) promise._a = promise._c.slice();
	  notify(promise, true);
	};
	var $resolve = function (value) {
	  var promise = this;
	  var then;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  try {
	    if (promise === value) throw TypeError("Promise can't be resolved itself");
	    if (then = isThenable(value)) {
	      microtask(function () {
	        var wrapper = { _w: promise, _d: false }; // wrap
	        try {
	          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
	        } catch (e) {
	          $reject.call(wrapper, e);
	        }
	      });
	    } else {
	      promise._v = value;
	      promise._s = 1;
	      notify(promise, false);
	    }
	  } catch (e) {
	    $reject.call({ _w: promise, _d: false }, e); // wrap
	  }
	};
	
	// constructor polyfill
	if (!USE_NATIVE) {
	  // 25.4.3.1 Promise(executor)
	  $Promise = function Promise(executor) {
	    anInstance(this, $Promise, PROMISE, '_h');
	    aFunction(executor);
	    Internal.call(this);
	    try {
	      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
	    } catch (err) {
	      $reject.call(this, err);
	    }
	  };
	  // eslint-disable-next-line no-unused-vars
	  Internal = function Promise(executor) {
	    this._c = [];             // <- awaiting reactions
	    this._a = undefined;      // <- checked in isUnhandled reactions
	    this._s = 0;              // <- state
	    this._d = false;          // <- done
	    this._v = undefined;      // <- value
	    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
	    this._n = false;          // <- notify
	  };
	  Internal.prototype = __webpack_require__(122)($Promise.prototype, {
	    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
	    then: function then(onFulfilled, onRejected) {
	      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
	      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
	      reaction.fail = typeof onRejected == 'function' && onRejected;
	      reaction.domain = isNode ? process.domain : undefined;
	      this._c.push(reaction);
	      if (this._a) this._a.push(reaction);
	      if (this._s) notify(this, false);
	      return reaction.promise;
	    },
	    // 25.4.5.1 Promise.prototype.catch(onRejected)
	    'catch': function (onRejected) {
	      return this.then(undefined, onRejected);
	    }
	  });
	  OwnPromiseCapability = function () {
	    var promise = new Internal();
	    this.promise = promise;
	    this.resolve = ctx($resolve, promise, 1);
	    this.reject = ctx($reject, promise, 1);
	  };
	  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
	    return C === $Promise || C === Wrapper
	      ? new OwnPromiseCapability(C)
	      : newGenericPromiseCapability(C);
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
	__webpack_require__(24)($Promise, PROMISE);
	__webpack_require__(123)(PROMISE);
	Wrapper = __webpack_require__(7)[PROMISE];
	
	// statics
	$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
	  // 25.4.4.5 Promise.reject(r)
	  reject: function reject(r) {
	    var capability = newPromiseCapability(this);
	    var $$reject = capability.reject;
	    $$reject(r);
	    return capability.promise;
	  }
	});
	$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
	  // 25.4.4.6 Promise.resolve(x)
	  resolve: function resolve(x) {
	    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
	  }
	});
	$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(114)(function (iter) {
	  $Promise.all(iter)['catch'](empty);
	})), PROMISE, {
	  // 25.4.4.1 Promise.all(iterable)
	  all: function all(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var resolve = capability.resolve;
	    var reject = capability.reject;
	    var result = perform(function () {
	      var values = [];
	      var index = 0;
	      var remaining = 1;
	      forOf(iterable, false, function (promise) {
	        var $index = index++;
	        var alreadyCalled = false;
	        values.push(undefined);
	        remaining++;
	        C.resolve(promise).then(function (value) {
	          if (alreadyCalled) return;
	          alreadyCalled = true;
	          values[$index] = value;
	          --remaining || resolve(values);
	        }, reject);
	      });
	      --remaining || resolve(values);
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  },
	  // 25.4.4.4 Promise.race(iterable)
	  race: function race(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var reject = capability.reject;
	    var result = perform(function () {
	      forOf(iterable, false, function (promise) {
	        C.resolve(promise).then(capability.resolve, reject);
	      });
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  }
	});


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// ECMAScript 6 symbols shim
	var global = __webpack_require__(3);
	var has = __webpack_require__(11);
	var DESCRIPTORS = __webpack_require__(10);
	var $export = __webpack_require__(17);
	var redefine = __webpack_require__(49);
	var META = __webpack_require__(116).KEY;
	var $fails = __webpack_require__(22);
	var shared = __webpack_require__(33);
	var setToStringTag = __webpack_require__(24);
	var uid = __webpack_require__(25);
	var wks = __webpack_require__(4);
	var wksExt = __webpack_require__(37);
	var wksDefine = __webpack_require__(36);
	var enumKeys = __webpack_require__(106);
	var isArray = __webpack_require__(111);
	var anObject = __webpack_require__(8);
	var isObject = __webpack_require__(13);
	var toObject = __webpack_require__(53);
	var toIObject = __webpack_require__(15);
	var toPrimitive = __webpack_require__(35);
	var createDesc = __webpack_require__(23);
	var _create = __webpack_require__(43);
	var gOPNExt = __webpack_require__(120);
	var $GOPD = __webpack_require__(119);
	var $GOPS = __webpack_require__(45);
	var $DP = __webpack_require__(14);
	var $keys = __webpack_require__(30);
	var gOPD = $GOPD.f;
	var dP = $DP.f;
	var gOPN = gOPNExt.f;
	var $Symbol = global.Symbol;
	var $JSON = global.JSON;
	var _stringify = $JSON && $JSON.stringify;
	var PROTOTYPE = 'prototype';
	var HIDDEN = wks('_hidden');
	var TO_PRIMITIVE = wks('toPrimitive');
	var isEnum = {}.propertyIsEnumerable;
	var SymbolRegistry = shared('symbol-registry');
	var AllSymbols = shared('symbols');
	var OPSymbols = shared('op-symbols');
	var ObjectProto = Object[PROTOTYPE];
	var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
	var QObject = global.QObject;
	// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
	var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;
	
	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var setSymbolDesc = DESCRIPTORS && $fails(function () {
	  return _create(dP({}, 'a', {
	    get: function () { return dP(this, 'a', { value: 7 }).a; }
	  })).a != 7;
	}) ? function (it, key, D) {
	  var protoDesc = gOPD(ObjectProto, key);
	  if (protoDesc) delete ObjectProto[key];
	  dP(it, key, D);
	  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
	} : dP;
	
	var wrap = function (tag) {
	  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
	  sym._k = tag;
	  return sym;
	};
	
	var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
	  return typeof it == 'symbol';
	} : function (it) {
	  return it instanceof $Symbol;
	};
	
	var $defineProperty = function defineProperty(it, key, D) {
	  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
	  anObject(it);
	  key = toPrimitive(key, true);
	  anObject(D);
	  if (has(AllSymbols, key)) {
	    if (!D.enumerable) {
	      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
	      it[HIDDEN][key] = true;
	    } else {
	      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
	      D = _create(D, { enumerable: createDesc(0, false) });
	    } return setSymbolDesc(it, key, D);
	  } return dP(it, key, D);
	};
	var $defineProperties = function defineProperties(it, P) {
	  anObject(it);
	  var keys = enumKeys(P = toIObject(P));
	  var i = 0;
	  var l = keys.length;
	  var key;
	  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
	  return it;
	};
	var $create = function create(it, P) {
	  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
	};
	var $propertyIsEnumerable = function propertyIsEnumerable(key) {
	  var E = isEnum.call(this, key = toPrimitive(key, true));
	  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
	  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
	};
	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
	  it = toIObject(it);
	  key = toPrimitive(key, true);
	  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
	  var D = gOPD(it, key);
	  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
	  return D;
	};
	var $getOwnPropertyNames = function getOwnPropertyNames(it) {
	  var names = gOPN(toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
	  } return result;
	};
	var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
	  var IS_OP = it === ObjectProto;
	  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
	  } return result;
	};
	
	// 19.4.1.1 Symbol([description])
	if (!USE_NATIVE) {
	  $Symbol = function Symbol() {
	    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
	    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
	    var $set = function (value) {
	      if (this === ObjectProto) $set.call(OPSymbols, value);
	      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
	      setSymbolDesc(this, tag, createDesc(1, value));
	    };
	    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
	    return wrap(tag);
	  };
	  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
	    return this._k;
	  });
	
	  $GOPD.f = $getOwnPropertyDescriptor;
	  $DP.f = $defineProperty;
	  __webpack_require__(44).f = gOPNExt.f = $getOwnPropertyNames;
	  __webpack_require__(31).f = $propertyIsEnumerable;
	  $GOPS.f = $getOwnPropertySymbols;
	
	  if (DESCRIPTORS && !__webpack_require__(19)) {
	    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
	  }
	
	  wksExt.f = function (name) {
	    return wrap(wks(name));
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });
	
	for (var es6Symbols = (
	  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
	  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
	).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);
	
	for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);
	
	$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
	  // 19.4.2.1 Symbol.for(key)
	  'for': function (key) {
	    return has(SymbolRegistry, key += '')
	      ? SymbolRegistry[key]
	      : SymbolRegistry[key] = $Symbol(key);
	  },
	  // 19.4.2.5 Symbol.keyFor(sym)
	  keyFor: function keyFor(sym) {
	    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
	    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
	  },
	  useSetter: function () { setter = true; },
	  useSimple: function () { setter = false; }
	});
	
	$export($export.S + $export.F * !USE_NATIVE, 'Object', {
	  // 19.1.2.2 Object.create(O [, Properties])
	  create: $create,
	  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
	  defineProperty: $defineProperty,
	  // 19.1.2.3 Object.defineProperties(O, Properties)
	  defineProperties: $defineProperties,
	  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
	  // 19.1.2.7 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $getOwnPropertyNames,
	  // 19.1.2.8 Object.getOwnPropertySymbols(O)
	  getOwnPropertySymbols: $getOwnPropertySymbols
	});
	
	// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
	// https://bugs.chromium.org/p/v8/issues/detail?id=3443
	var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });
	
	$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
	  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
	    return $GOPS.f(toObject(it));
	  }
	});
	
	// 24.3.2 JSON.stringify(value [, replacer [, space]])
	$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
	  var S = $Symbol();
	  // MS Edge converts symbol values to JSON as {}
	  // WebKit converts symbol values to JSON as null
	  // V8 throws on boxed symbols
	  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
	})), 'JSON', {
	  stringify: function stringify(it) {
	    var args = [it];
	    var i = 1;
	    var replacer, $replacer;
	    while (arguments.length > i) args.push(arguments[i++]);
	    $replacer = replacer = args[1];
	    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
	    if (!isArray(replacer)) replacer = function (key, value) {
	      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
	      if (!isSymbol(value)) return value;
	    };
	    args[1] = replacer;
	    return _stringify.apply($JSON, args);
	  }
	});
	
	// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
	$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(12)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
	// 19.4.3.5 Symbol.prototype[@@toStringTag]
	setToStringTag($Symbol, 'Symbol');
	// 20.2.1.9 Math[@@toStringTag]
	setToStringTag(Math, 'Math', true);
	// 24.3.3 JSON[@@toStringTag]
	setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-promise-finally
	'use strict';
	var $export = __webpack_require__(17);
	var core = __webpack_require__(7);
	var global = __webpack_require__(3);
	var speciesConstructor = __webpack_require__(50);
	var promiseResolve = __webpack_require__(48);
	
	$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
	  var C = speciesConstructor(this, core.Promise || global.Promise);
	  var isFunction = typeof onFinally == 'function';
	  return this.then(
	    isFunction ? function (x) {
	      return promiseResolve(C, onFinally()).then(function () { return x; });
	    } : onFinally,
	    isFunction ? function (e) {
	      return promiseResolve(C, onFinally()).then(function () { throw e; });
	    } : onFinally
	  );
	} });


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-promise-try
	var $export = __webpack_require__(17);
	var newPromiseCapability = __webpack_require__(29);
	var perform = __webpack_require__(47);
	
	$export($export.S, 'Promise', { 'try': function (callbackfn) {
	  var promiseCapability = newPromiseCapability.f(this);
	  var result = perform(callbackfn);
	  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
	  return promiseCapability.promise;
	} });


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(36)('asyncIterator');


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(36)('observable');


/***/ }),
/* 135 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 136 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 137 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 138 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 139 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 140 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 141 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 142 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 143 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 144 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 145 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 146 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 147 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 148 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 149 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 150 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 151 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 152 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 153 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 154 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 155 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 156 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 157 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 158 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 159 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 160 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 161 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 162 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 163 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 164 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// identity function for calling harmony imports with the correct context
	/******/ 	__webpack_require__.i = function(value) { return value; };
	
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, {
	/******/ 				configurable: false,
	/******/ 				enumerable: true,
	/******/ 				get: getter
	/******/ 			});
	/******/ 		}
	/******/ 	};
	
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 202);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ function(module, exports) {
	
	/* globals __VUE_SSR_CONTEXT__ */
	
	// this module is a runtime utility for cleaner component module output and will
	// be included in the final webpack user bundle
	
	module.exports = function normalizeComponent (
	  rawScriptExports,
	  compiledTemplate,
	  injectStyles,
	  scopeId,
	  moduleIdentifier /* server only */
	) {
	  var esModule
	  var scriptExports = rawScriptExports = rawScriptExports || {}
	
	  // ES6 modules interop
	  var type = typeof rawScriptExports.default
	  if (type === 'object' || type === 'function') {
	    esModule = rawScriptExports
	    scriptExports = rawScriptExports.default
	  }
	
	  // Vue.extend constructor export interop
	  var options = typeof scriptExports === 'function'
	    ? scriptExports.options
	    : scriptExports
	
	  // render functions
	  if (compiledTemplate) {
	    options.render = compiledTemplate.render
	    options.staticRenderFns = compiledTemplate.staticRenderFns
	  }
	
	  // scopedId
	  if (scopeId) {
	    options._scopeId = scopeId
	  }
	
	  var hook
	  if (moduleIdentifier) { // server build
	    hook = function (context) {
	      // 2.3 injection
	      context =
	        context || // cached call
	        (this.$vnode && this.$vnode.ssrContext) || // stateful
	        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
	      // 2.2 with runInNewContext: true
	      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
	        context = __VUE_SSR_CONTEXT__
	      }
	      // inject component styles
	      if (injectStyles) {
	        injectStyles.call(this, context)
	      }
	      // register component module identifier for async chunk inferrence
	      if (context && context._registeredComponents) {
	        context._registeredComponents.add(moduleIdentifier)
	      }
	    }
	    // used by ssr in case component is cached and beforeCreate
	    // never gets called
	    options._ssrRegister = hook
	  } else if (injectStyles) {
	    hook = injectStyles
	  }
	
	  if (hook) {
	    var functional = options.functional
	    var existing = functional
	      ? options.render
	      : options.beforeCreate
	    if (!functional) {
	      // inject component registration as beforeCreate hook
	      options.beforeCreate = existing
	        ? [].concat(existing, hook)
	        : [hook]
	    } else {
	      // register for functioal component in vue file
	      options.render = function renderWithStyleInjection (h, context) {
	        hook.call(context)
	        return existing(h, context)
	      }
	    }
	  }
	
	  return {
	    esModule: esModule,
	    exports: scriptExports,
	    options: options
	  }
	}
	
	
	/***/ },
	/* 1 */
	/***/ function(module, exports) {
	
	module.exports = __webpack_require__(57);
	
	/***/ },
	/* 2 */
	/***/ function(module, exports, __webpack_require__) {
	
	"use strict";
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_cell_vue__ = __webpack_require__(132);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_cell_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__src_cell_vue__);
	/* harmony reexport (default from non-hamory) */ __webpack_require__.d(exports, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__src_cell_vue___default.a; });
	
	
	
	/***/ },
	/* 3 */
	/***/ function(module, exports, __webpack_require__) {
	
	"use strict";
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
	/* unused harmony export on */
	/* unused harmony export off */
	/* harmony export (binding) */ __webpack_require__.d(exports, "c", function() { return once; });
	/* unused harmony export hasClass */
	/* harmony export (immutable) */ exports["a"] = addClass;
	/* harmony export (immutable) */ exports["b"] = removeClass;
	/* unused harmony export getStyle */
	/* unused harmony export setStyle */
	/* istanbul ignore next */
	
	
	
	var isServer = __WEBPACK_IMPORTED_MODULE_0_vue___default.a.prototype.$isServer;
	var SPECIAL_CHARS_REGEXP = /([\:\-\_]+(.))/g;
	var MOZ_HACK_REGEXP = /^moz([A-Z])/;
	var ieVersion = isServer ? 0 : Number(document.documentMode);
	
	/* istanbul ignore next */
	var trim = function(string) {
	  return (string || '').replace(/^[\s\uFEFF]+|[\s\uFEFF]+$/g, '');
	};
	/* istanbul ignore next */
	var camelCase = function(name) {
	  return name.replace(SPECIAL_CHARS_REGEXP, function(_, separator, letter, offset) {
	    return offset ? letter.toUpperCase() : letter;
	  }).replace(MOZ_HACK_REGEXP, 'Moz$1');
	};
	
	/* istanbul ignore next */
	var on = (function() {
	  if (!isServer && document.addEventListener) {
	    return function(element, event, handler) {
	      if (element && event && handler) {
	        element.addEventListener(event, handler, false);
	      }
	    };
	  } else {
	    return function(element, event, handler) {
	      if (element && event && handler) {
	        element.attachEvent('on' + event, handler);
	      }
	    };
	  }
	})();
	
	/* istanbul ignore next */
	var off = (function() {
	  if (!isServer && document.removeEventListener) {
	    return function(element, event, handler) {
	      if (element && event) {
	        element.removeEventListener(event, handler, false);
	      }
	    };
	  } else {
	    return function(element, event, handler) {
	      if (element && event) {
	        element.detachEvent('on' + event, handler);
	      }
	    };
	  }
	})();
	
	/* istanbul ignore next */
	var once = function(el, event, fn) {
	  var listener = function() {
	    if (fn) {
	      fn.apply(this, arguments);
	    }
	    off(el, event, listener);
	  };
	  on(el, event, listener);
	};
	
	/* istanbul ignore next */
	function hasClass(el, cls) {
	  if (!el || !cls) return false;
	  if (cls.indexOf(' ') !== -1) throw new Error('className should not contain space.');
	  if (el.classList) {
	    return el.classList.contains(cls);
	  } else {
	    return (' ' + el.className + ' ').indexOf(' ' + cls + ' ') > -1;
	  }
	};
	
	/* istanbul ignore next */
	function addClass(el, cls) {
	  if (!el) return;
	  var curClass = el.className;
	  var classes = (cls || '').split(' ');
	
	  for (var i = 0, j = classes.length; i < j; i++) {
	    var clsName = classes[i];
	    if (!clsName) continue;
	
	    if (el.classList) {
	      el.classList.add(clsName);
	    } else {
	      if (!hasClass(el, clsName)) {
	        curClass += ' ' + clsName;
	      }
	    }
	  }
	  if (!el.classList) {
	    el.className = curClass;
	  }
	};
	
	/* istanbul ignore next */
	function removeClass(el, cls) {
	  if (!el || !cls) return;
	  var classes = cls.split(' ');
	  var curClass = ' ' + el.className + ' ';
	
	  for (var i = 0, j = classes.length; i < j; i++) {
	    var clsName = classes[i];
	    if (!clsName) continue;
	
	    if (el.classList) {
	      el.classList.remove(clsName);
	    } else {
	      if (hasClass(el, clsName)) {
	        curClass = curClass.replace(' ' + clsName + ' ', ' ');
	      }
	    }
	  }
	  if (!el.classList) {
	    el.className = trim(curClass);
	  }
	};
	
	/* istanbul ignore next */
	var getStyle = ieVersion < 9 ? function(element, styleName) {
	  if (isServer) return;
	  if (!element || !styleName) return null;
	  styleName = camelCase(styleName);
	  if (styleName === 'float') {
	    styleName = 'styleFloat';
	  }
	  try {
	    switch (styleName) {
	      case 'opacity':
	        try {
	          return element.filters.item('alpha').opacity / 100;
	        } catch (e) {
	          return 1.0;
	        }
	      default:
	        return (element.style[styleName] || element.currentStyle ? element.currentStyle[styleName] : null);
	    }
	  } catch (e) {
	    return element.style[styleName];
	  }
	} : function(element, styleName) {
	  if (isServer) return;
	  if (!element || !styleName) return null;
	  styleName = camelCase(styleName);
	  if (styleName === 'float') {
	    styleName = 'cssFloat';
	  }
	  try {
	    var computed = document.defaultView.getComputedStyle(element, '');
	    return element.style[styleName] || computed ? computed[styleName] : null;
	  } catch (e) {
	    return element.style[styleName];
	  }
	};
	
	/* istanbul ignore next */
	function setStyle(element, styleName, value) {
	  if (!element || !styleName) return;
	
	  if (typeof styleName === 'object') {
	    for (var prop in styleName) {
	      if (styleName.hasOwnProperty(prop)) {
	        setStyle(element, prop, styleName[prop]);
	      }
	    }
	  } else {
	    styleName = camelCase(styleName);
	    if (styleName === 'opacity' && ieVersion < 9) {
	      element.style.filter = isNaN(value) ? '' : 'alpha(opacity=' + value * 100 + ')';
	    } else {
	      element.style[styleName] = value;
	    }
	  }
	};
	
	
	/***/ },
	/* 4 */
	/***/ function(module, exports) {
	
	// removed by extract-text-webpack-plugin
	
	/***/ },
	/* 5 */
	/***/ function(module, exports, __webpack_require__) {
	
	var Component = __webpack_require__(0)(
	  /* script */
	  __webpack_require__(39),
	  /* template */
	  null,
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports
	
	
	/***/ },
	/* 6 */
	/***/ function(module, exports, __webpack_require__) {
	
	"use strict";
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mint_ui_src_utils_merge__ = __webpack_require__(11);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mint_ui_src_utils_popup_popup_manager__ = __webpack_require__(90);
	/* unused harmony reexport PopupManager */
	
	
	
	
	var idSeed = 1;
	var transitions = [];
	
	var hookTransition = function (transition) {
	  if (transitions.indexOf(transition) !== -1) return;
	
	  var getVueInstance = function (element) {
	    var instance = element.__vue__;
	    if (!instance) {
	      var textNode = element.previousSibling;
	      if (textNode.__vue__) {
	        instance = textNode.__vue__;
	      }
	    }
	    return instance;
	  };
	
	  __WEBPACK_IMPORTED_MODULE_0_vue___default.a.transition(transition, {
	    afterEnter: function afterEnter(el) {
	      var instance = getVueInstance(el);
	
	      if (instance) {
	        instance.doAfterOpen && instance.doAfterOpen();
	      }
	    },
	    afterLeave: function afterLeave(el) {
	      var instance = getVueInstance(el);
	
	      if (instance) {
	        instance.doAfterClose && instance.doAfterClose();
	      }
	    }
	  });
	};
	
	var scrollBarWidth;
	var getScrollBarWidth = function () {
	  if (__WEBPACK_IMPORTED_MODULE_0_vue___default.a.prototype.$isServer) return;
	  if (scrollBarWidth !== undefined) return scrollBarWidth;
	
	  var outer = document.createElement('div');
	  outer.style.visibility = 'hidden';
	  outer.style.width = '100px';
	  outer.style.position = 'absolute';
	  outer.style.top = '-9999px';
	  document.body.appendChild(outer);
	
	  var widthNoScroll = outer.offsetWidth;
	  outer.style.overflow = 'scroll';
	
	  var inner = document.createElement('div');
	  inner.style.width = '100%';
	  outer.appendChild(inner);
	
	  var widthWithScroll = inner.offsetWidth;
	  outer.parentNode.removeChild(outer);
	
	  return widthNoScroll - widthWithScroll;
	};
	
	var getDOM = function(dom) {
	  if (dom.nodeType === 3) {
	    dom = dom.nextElementSibling || dom.nextSibling;
	    getDOM(dom);
	  }
	  return dom;
	};
	
	/* harmony default export */ exports["a"] = {
	  props: {
	    value: {
	      type: Boolean,
	      default: false
	    },
	    transition: {
	      type: String,
	      default: ''
	    },
	    openDelay: {},
	    closeDelay: {},
	    zIndex: {},
	    modal: {
	      type: Boolean,
	      default: false
	    },
	    modalFade: {
	      type: Boolean,
	      default: true
	    },
	    modalClass: {
	    },
	    lockScroll: {
	      type: Boolean,
	      default: true
	    },
	    closeOnPressEscape: {
	      type: Boolean,
	      default: false
	    },
	    closeOnClickModal: {
	      type: Boolean,
	      default: false
	    }
	  },
	
	  created: function created() {
	    if (this.transition) {
	      hookTransition(this.transition);
	    }
	  },
	
	  beforeMount: function beforeMount() {
	    this._popupId = 'popup-' + idSeed++;
	    __WEBPACK_IMPORTED_MODULE_2_mint_ui_src_utils_popup_popup_manager__["a" /* default */].register(this._popupId, this);
	  },
	
	  beforeDestroy: function beforeDestroy() {
	    __WEBPACK_IMPORTED_MODULE_2_mint_ui_src_utils_popup_popup_manager__["a" /* default */].deregister(this._popupId);
	    __WEBPACK_IMPORTED_MODULE_2_mint_ui_src_utils_popup_popup_manager__["a" /* default */].closeModal(this._popupId);
	    if (this.modal && this.bodyOverflow !== null && this.bodyOverflow !== 'hidden') {
	      document.body.style.overflow = this.bodyOverflow;
	      document.body.style.paddingRight = this.bodyPaddingRight;
	    }
	    this.bodyOverflow = null;
	    this.bodyPaddingRight = null;
	  },
	
	  data: function data() {
	    return {
	      opened: false,
	      bodyOverflow: null,
	      bodyPaddingRight: null,
	      rendered: false
	    };
	  },
	
	  watch: {
	    value: function value(val) {
	      var this$1 = this;
	
	      if (val) {
	        if (this._opening) return;
	        if (!this.rendered) {
	          this.rendered = true;
	          __WEBPACK_IMPORTED_MODULE_0_vue___default.a.nextTick(function () {
	            this$1.open();
	          });
	        } else {
	          this.open();
	        }
	      } else {
	        this.close();
	      }
	    }
	  },
	
	  methods: {
	    open: function open(options) {
	      var this$1 = this;
	
	      if (!this.rendered) {
	        this.rendered = true;
	        this.$emit('input', true);
	      }
	
	      var props = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_mint_ui_src_utils_merge__["a" /* default */])({}, this, options, this.$props);
	
	      if (this._closeTimer) {
	        clearTimeout(this._closeTimer);
	        this._closeTimer = null;
	      }
	      clearTimeout(this._openTimer);
	
	      var openDelay = Number(props.openDelay);
	      if (openDelay > 0) {
	        this._openTimer = setTimeout(function () {
	          this$1._openTimer = null;
	          this$1.doOpen(props);
	        }, openDelay);
	      } else {
	        this.doOpen(props);
	      }
	    },
	
	    doOpen: function doOpen(props) {
	      if (this.$isServer) return;
	      if (this.willOpen && !this.willOpen()) return;
	      if (this.opened) return;
	
	      this._opening = true;
	
	      // 使用 vue-popup 的组件，如果需要和父组件通信显示的状态，应该使用 value，它是一个 prop，
	      // 这样在父组件中用 v-model 即可；否则可以使用 visible，它是一个 data
	      this.visible = true;
	      this.$emit('input', true);
	
	      var dom = getDOM(this.$el);
	
	      var modal = props.modal;
	
	      var zIndex = props.zIndex;
	      if (zIndex) {
	        __WEBPACK_IMPORTED_MODULE_2_mint_ui_src_utils_popup_popup_manager__["a" /* default */].zIndex = zIndex;
	      }
	
	      if (modal) {
	        if (this._closing) {
	          __WEBPACK_IMPORTED_MODULE_2_mint_ui_src_utils_popup_popup_manager__["a" /* default */].closeModal(this._popupId);
	          this._closing = false;
	        }
	        __WEBPACK_IMPORTED_MODULE_2_mint_ui_src_utils_popup_popup_manager__["a" /* default */].openModal(this._popupId, __WEBPACK_IMPORTED_MODULE_2_mint_ui_src_utils_popup_popup_manager__["a" /* default */].nextZIndex(), dom, props.modalClass, props.modalFade);
	        if (props.lockScroll) {
	          if (!this.bodyOverflow) {
	            this.bodyPaddingRight = document.body.style.paddingRight;
	            this.bodyOverflow = document.body.style.overflow;
	          }
	          scrollBarWidth = getScrollBarWidth();
	          var bodyHasOverflow = document.documentElement.clientHeight < document.body.scrollHeight;
	          if (scrollBarWidth > 0 && bodyHasOverflow) {
	            document.body.style.paddingRight = scrollBarWidth + 'px';
	          }
	          document.body.style.overflow = 'hidden';
	        }
	      }
	
	      if (getComputedStyle(dom).position === 'static') {
	        dom.style.position = 'absolute';
	      }
	
	      dom.style.zIndex = __WEBPACK_IMPORTED_MODULE_2_mint_ui_src_utils_popup_popup_manager__["a" /* default */].nextZIndex();
	      this.opened = true;
	
	      this.onOpen && this.onOpen();
	
	      if (!this.transition) {
	        this.doAfterOpen();
	      }
	    },
	
	    doAfterOpen: function doAfterOpen() {
	      this._opening = false;
	    },
	
	    close: function close() {
	      var this$1 = this;
	
	      if (this.willClose && !this.willClose()) return;
	
	      if (this._openTimer !== null) {
	        clearTimeout(this._openTimer);
	        this._openTimer = null;
	      }
	      clearTimeout(this._closeTimer);
	
	      var closeDelay = Number(this.closeDelay);
	
	      if (closeDelay > 0) {
	        this._closeTimer = setTimeout(function () {
	          this$1._closeTimer = null;
	          this$1.doClose();
	        }, closeDelay);
	      } else {
	        this.doClose();
	      }
	    },
	
	    doClose: function doClose() {
	      var this$1 = this;
	
	      this.visible = false;
	      this.$emit('input', false);
	      this._closing = true;
	
	      this.onClose && this.onClose();
	
	      if (this.lockScroll) {
	        setTimeout(function () {
	          if (this$1.modal && this$1.bodyOverflow !== 'hidden') {
	            document.body.style.overflow = this$1.bodyOverflow;
	            document.body.style.paddingRight = this$1.bodyPaddingRight;
	          }
	          this$1.bodyOverflow = null;
	          this$1.bodyPaddingRight = null;
	        }, 200);
	      }
	
	      this.opened = false;
	
	      if (!this.transition) {
	        this.doAfterClose();
	      }
	    },
	
	    doAfterClose: function doAfterClose() {
	      __WEBPACK_IMPORTED_MODULE_2_mint_ui_src_utils_popup_popup_manager__["a" /* default */].closeModal(this._popupId);
	      this._closing = false;
	    }
	  }
	};
	
	
	
	
	/***/ },
	/* 7 */
	/***/ function(module, exports, __webpack_require__) {
	
	"use strict";
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_picker_vue__ = __webpack_require__(145);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_picker_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__src_picker_vue__);
	/* harmony reexport (default from non-hamory) */ __webpack_require__.d(exports, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__src_picker_vue___default.a; });
	
	
	
	/***/ },
	/* 8 */
	/***/ function(module, exports, __webpack_require__) {
	
	"use strict";
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_popup_vue__ = __webpack_require__(146);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_popup_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__src_popup_vue__);
	/* harmony reexport (default from non-hamory) */ __webpack_require__.d(exports, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__src_popup_vue___default.a; });
	
	
	
	/***/ },
	/* 9 */
	/***/ function(module, exports, __webpack_require__) {
	
	"use strict";
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_spinner__ = __webpack_require__(151);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__src_spinner__);
	/* harmony reexport (default from non-hamory) */ __webpack_require__.d(exports, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__src_spinner___default.a; });
	
	
	
	/***/ },
	/* 10 */
	/***/ function(module, exports, __webpack_require__) {
	
	"use strict";
	/**
	 * v-clickoutside
	 * @desc 点击元素外面才会触发的事件
	 * @example
	 * ```vue
	 * <div v-element-clickoutside="handleClose">
	 * ```
	 */
	var clickoutsideContext = '@@clickoutsideContext';
	
	/* harmony default export */ exports["a"] = {
	  bind: function bind(el, binding, vnode) {
	    var documentHandler = function(e) {
	      if (vnode.context && !el.contains(e.target)) {
	        vnode.context[el[clickoutsideContext].methodName]();
	      }
	    };
	    el[clickoutsideContext] = {
	      documentHandler: documentHandler,
	      methodName: binding.expression,
	      arg: binding.arg || 'click'
	    };
	    document.addEventListener(el[clickoutsideContext].arg, documentHandler);
	  },
	
	  update: function update(el, binding) {
	    el[clickoutsideContext].methodName = binding.expression;
	  },
	
	  unbind: function unbind(el) {
	    document.removeEventListener(
	      el[clickoutsideContext].arg,
	      el[clickoutsideContext].documentHandler);
	  },
	
	  install: function install(Vue) {
	    Vue.directive('clickoutside', {
	      bind: this.bind,
	      unbind: this.unbind
	    });
	  }
	};
	
	
	/***/ },
	/* 11 */
	/***/ function(module, exports, __webpack_require__) {
	
	"use strict";
	/* harmony default export */ exports["a"] = function(target) {
	  var arguments$1 = arguments;
	
	  for (var i = 1, j = arguments.length; i < j; i++) {
	    var source = arguments$1[i] || {};
	    for (var prop in source) {
	      if (source.hasOwnProperty(prop)) {
	        var value = source[prop];
	        if (value !== undefined) {
	          target[prop] = value;
	        }
	      }
	    }
	  }
	
	  return target;
	};;
	
	
	/***/ },
	/* 12 */
	/***/ function(module, exports) {
	
	// removed by extract-text-webpack-plugin
	
	/***/ },
	/* 13 */
	/***/ function(module, exports, __webpack_require__) {
	
	function injectStyle (ssrContext) {
	  __webpack_require__(104)
	}
	var Component = __webpack_require__(0)(
	  /* script */
	  __webpack_require__(41),
	  /* template */
	  __webpack_require__(175),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports
	
	
	/***/ },
	/* 14 */
	/***/ function(module, exports, __webpack_require__) {
	
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__packages_header__ = __webpack_require__(59);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__packages_button__ = __webpack_require__(54);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__packages_cell__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__packages_cell_swipe__ = __webpack_require__(55);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__packages_field__ = __webpack_require__(58);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__packages_badge__ = __webpack_require__(53);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__packages_switch__ = __webpack_require__(82);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__packages_spinner__ = __webpack_require__(9);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__packages_tab_item__ = __webpack_require__(85);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__packages_tab_container_item__ = __webpack_require__(83);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__packages_tab_container__ = __webpack_require__(84);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__packages_navbar__ = __webpack_require__(71);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__packages_tabbar__ = __webpack_require__(86);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__packages_search__ = __webpack_require__(79);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__packages_checklist__ = __webpack_require__(56);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__packages_radio__ = __webpack_require__(76);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__packages_loadmore__ = __webpack_require__(68);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__packages_actionsheet__ = __webpack_require__(52);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__packages_popup__ = __webpack_require__(8);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__packages_swipe__ = __webpack_require__(81);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__packages_swipe_item__ = __webpack_require__(80);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__packages_range__ = __webpack_require__(77);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__packages_picker__ = __webpack_require__(7);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__packages_progress__ = __webpack_require__(75);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__packages_toast__ = __webpack_require__(87);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__packages_indicator__ = __webpack_require__(62);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__packages_message_box__ = __webpack_require__(69);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__packages_infinite_scroll__ = __webpack_require__(63);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__packages_lazyload__ = __webpack_require__(66);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__packages_datetime_picker__ = __webpack_require__(57);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__packages_index_list__ = __webpack_require__(60);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__packages_index_section__ = __webpack_require__(61);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__packages_palette_button__ = __webpack_require__(72);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__src_assets_font_iconfont_css__ = __webpack_require__(91);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__src_assets_font_iconfont_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33__src_assets_font_iconfont_css__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__utils_merge__ = __webpack_require__(11);
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	var version = '2.2.13';
	var install = function(Vue, config) {
	  if ( config === void 0 ) config = {};
	
	  if (install.installed) return;
	
	  Vue.component(__WEBPACK_IMPORTED_MODULE_0__packages_header__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_0__packages_header__["a" /* default */]);
	  Vue.component(__WEBPACK_IMPORTED_MODULE_1__packages_button__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_1__packages_button__["a" /* default */]);
	  Vue.component(__WEBPACK_IMPORTED_MODULE_2__packages_cell__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_2__packages_cell__["a" /* default */]);
	  Vue.component(__WEBPACK_IMPORTED_MODULE_3__packages_cell_swipe__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_3__packages_cell_swipe__["a" /* default */]);
	  Vue.component(__WEBPACK_IMPORTED_MODULE_4__packages_field__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_4__packages_field__["a" /* default */]);
	  Vue.component(__WEBPACK_IMPORTED_MODULE_5__packages_badge__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_5__packages_badge__["a" /* default */]);
	  Vue.component(__WEBPACK_IMPORTED_MODULE_6__packages_switch__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_6__packages_switch__["a" /* default */]);
	  Vue.component(__WEBPACK_IMPORTED_MODULE_7__packages_spinner__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_7__packages_spinner__["a" /* default */]);
	  Vue.component(__WEBPACK_IMPORTED_MODULE_8__packages_tab_item__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_8__packages_tab_item__["a" /* default */]);
	  Vue.component(__WEBPACK_IMPORTED_MODULE_9__packages_tab_container_item__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_9__packages_tab_container_item__["a" /* default */]);
	  Vue.component(__WEBPACK_IMPORTED_MODULE_10__packages_tab_container__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_10__packages_tab_container__["a" /* default */]);
	  Vue.component(__WEBPACK_IMPORTED_MODULE_11__packages_navbar__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_11__packages_navbar__["a" /* default */]);
	  Vue.component(__WEBPACK_IMPORTED_MODULE_12__packages_tabbar__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_12__packages_tabbar__["a" /* default */]);
	  Vue.component(__WEBPACK_IMPORTED_MODULE_13__packages_search__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_13__packages_search__["a" /* default */]);
	  Vue.component(__WEBPACK_IMPORTED_MODULE_14__packages_checklist__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_14__packages_checklist__["a" /* default */]);
	  Vue.component(__WEBPACK_IMPORTED_MODULE_15__packages_radio__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_15__packages_radio__["a" /* default */]);
	  Vue.component(__WEBPACK_IMPORTED_MODULE_16__packages_loadmore__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_16__packages_loadmore__["a" /* default */]);
	  Vue.component(__WEBPACK_IMPORTED_MODULE_17__packages_actionsheet__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_17__packages_actionsheet__["a" /* default */]);
	  Vue.component(__WEBPACK_IMPORTED_MODULE_18__packages_popup__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_18__packages_popup__["a" /* default */]);
	  Vue.component(__WEBPACK_IMPORTED_MODULE_19__packages_swipe__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_19__packages_swipe__["a" /* default */]);
	  Vue.component(__WEBPACK_IMPORTED_MODULE_20__packages_swipe_item__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_20__packages_swipe_item__["a" /* default */]);
	  Vue.component(__WEBPACK_IMPORTED_MODULE_21__packages_range__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_21__packages_range__["a" /* default */]);
	  Vue.component(__WEBPACK_IMPORTED_MODULE_22__packages_picker__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_22__packages_picker__["a" /* default */]);
	  Vue.component(__WEBPACK_IMPORTED_MODULE_23__packages_progress__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_23__packages_progress__["a" /* default */]);
	  Vue.component(__WEBPACK_IMPORTED_MODULE_29__packages_datetime_picker__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_29__packages_datetime_picker__["a" /* default */]);
	  Vue.component(__WEBPACK_IMPORTED_MODULE_30__packages_index_list__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_30__packages_index_list__["a" /* default */]);
	  Vue.component(__WEBPACK_IMPORTED_MODULE_31__packages_index_section__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_31__packages_index_section__["a" /* default */]);
	  Vue.component(__WEBPACK_IMPORTED_MODULE_32__packages_palette_button__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_32__packages_palette_button__["a" /* default */]);
	  Vue.use(__WEBPACK_IMPORTED_MODULE_27__packages_infinite_scroll__["a" /* default */]);
	  Vue.use(__WEBPACK_IMPORTED_MODULE_28__packages_lazyload__["a" /* default */], __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_34__utils_merge__["a" /* default */])({
	    loading: __webpack_require__(127),
	    attempt: 3
	  }, config.lazyload));
	
	  Vue.$messagebox = Vue.prototype.$messagebox = __WEBPACK_IMPORTED_MODULE_26__packages_message_box__["a" /* default */];
	  Vue.$toast = Vue.prototype.$toast = __WEBPACK_IMPORTED_MODULE_24__packages_toast__["a" /* default */];
	  Vue.$indicator = Vue.prototype.$indicator = __WEBPACK_IMPORTED_MODULE_25__packages_indicator__["a" /* default */];
	};
	
	// auto install
	if (typeof window !== 'undefined' && window.Vue) {
	  install(window.Vue);
	};
	
	module.exports = {
	  install: install,
	  version: version,
	  Header: __WEBPACK_IMPORTED_MODULE_0__packages_header__["a" /* default */],
	  Button: __WEBPACK_IMPORTED_MODULE_1__packages_button__["a" /* default */],
	  Cell: __WEBPACK_IMPORTED_MODULE_2__packages_cell__["a" /* default */],
	  CellSwipe: __WEBPACK_IMPORTED_MODULE_3__packages_cell_swipe__["a" /* default */],
	  Field: __WEBPACK_IMPORTED_MODULE_4__packages_field__["a" /* default */],
	  Badge: __WEBPACK_IMPORTED_MODULE_5__packages_badge__["a" /* default */],
	  Switch: __WEBPACK_IMPORTED_MODULE_6__packages_switch__["a" /* default */],
	  Spinner: __WEBPACK_IMPORTED_MODULE_7__packages_spinner__["a" /* default */],
	  TabItem: __WEBPACK_IMPORTED_MODULE_8__packages_tab_item__["a" /* default */],
	  TabContainerItem: __WEBPACK_IMPORTED_MODULE_9__packages_tab_container_item__["a" /* default */],
	  TabContainer: __WEBPACK_IMPORTED_MODULE_10__packages_tab_container__["a" /* default */],
	  Navbar: __WEBPACK_IMPORTED_MODULE_11__packages_navbar__["a" /* default */],
	  Tabbar: __WEBPACK_IMPORTED_MODULE_12__packages_tabbar__["a" /* default */],
	  Search: __WEBPACK_IMPORTED_MODULE_13__packages_search__["a" /* default */],
	  Checklist: __WEBPACK_IMPORTED_MODULE_14__packages_checklist__["a" /* default */],
	  Radio: __WEBPACK_IMPORTED_MODULE_15__packages_radio__["a" /* default */],
	  Loadmore: __WEBPACK_IMPORTED_MODULE_16__packages_loadmore__["a" /* default */],
	  Actionsheet: __WEBPACK_IMPORTED_MODULE_17__packages_actionsheet__["a" /* default */],
	  Popup: __WEBPACK_IMPORTED_MODULE_18__packages_popup__["a" /* default */],
	  Swipe: __WEBPACK_IMPORTED_MODULE_19__packages_swipe__["a" /* default */],
	  SwipeItem: __WEBPACK_IMPORTED_MODULE_20__packages_swipe_item__["a" /* default */],
	  Range: __WEBPACK_IMPORTED_MODULE_21__packages_range__["a" /* default */],
	  Picker: __WEBPACK_IMPORTED_MODULE_22__packages_picker__["a" /* default */],
	  Progress: __WEBPACK_IMPORTED_MODULE_23__packages_progress__["a" /* default */],
	  Toast: __WEBPACK_IMPORTED_MODULE_24__packages_toast__["a" /* default */],
	  Indicator: __WEBPACK_IMPORTED_MODULE_25__packages_indicator__["a" /* default */],
	  MessageBox: __WEBPACK_IMPORTED_MODULE_26__packages_message_box__["a" /* default */],
	  InfiniteScroll: __WEBPACK_IMPORTED_MODULE_27__packages_infinite_scroll__["a" /* default */],
	  Lazyload: __WEBPACK_IMPORTED_MODULE_28__packages_lazyload__["a" /* default */],
	  DatetimePicker: __WEBPACK_IMPORTED_MODULE_29__packages_datetime_picker__["a" /* default */],
	  IndexList: __WEBPACK_IMPORTED_MODULE_30__packages_index_list__["a" /* default */],
	  IndexSection: __WEBPACK_IMPORTED_MODULE_31__packages_index_section__["a" /* default */],
	  PaletteButton: __WEBPACK_IMPORTED_MODULE_32__packages_palette_button__["a" /* default */]
	};
	
	
	/***/ },
	/* 15 */
	/***/ function(module, exports, __webpack_require__) {
	
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mint_ui_src_utils_popup__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mint_ui_src_style_popup_css__ = __webpack_require__(12);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mint_ui_src_style_popup_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mint_ui_src_style_popup_css__);
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	/* harmony default export */ exports["default"] = {
	  name: 'mt-actionsheet',
	
	  mixins: [__WEBPACK_IMPORTED_MODULE_0_mint_ui_src_utils_popup__["a" /* default */]],
	
	  props: {
	    modal: {
	      default: true
	    },
	
	    modalFade: {
	      default: false
	    },
	
	    lockScroll: {
	      default: false
	    },
	
	    closeOnClickModal: {
	      default: true
	    },
	
	    cancelText: {
	      type: String,
	      default: '取消'
	    },
	
	    actions: {
	      type: Array,
	      default: function () { return []; }
	    }
	  },
	
	  data: function data() {
	    return {
	      currentValue: false
	    };
	  },
	
	  watch: {
	    currentValue: function currentValue(val) {
	      this.$emit('input', val);
	    },
	
	    value: function value(val) {
	      this.currentValue = val;
	    }
	  },
	
	  methods: {
	    itemClick: function itemClick(item, index) {
	      if (item.method && typeof item.method === 'function') {
	        item.method(item, index);
	      }
	      this.currentValue = false;
	    }
	  },
	
	  mounted: function mounted() {
	    if (this.value) {
	      this.rendered = true;
	      this.currentValue = true;
	      this.open();
	    }
	  }
	};
	
	
	/***/ },
	/* 16 */
	/***/ function(module, exports, __webpack_require__) {
	
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	/**
	 * mt-badge
	 * @module components/badge
	 * @desc 徽章
	 * @param {string} [type=primary] 组件样式，可选 primary, error, success, warning
	 * @param {string} [color] - 传入颜色值
	 * @param {string} [size=normal] - 尺寸，接受 normal, small, large
	 *
	 * @example
	 * <mt-badge color="error">错误</mt-badge>
	 * <mt-badge color="#333">30</mt-badge>
	 */
	/* harmony default export */ exports["default"] = {
	  name: 'mt-badge',
	
	  props: {
	    color: String,
	    type: {
	      type: String,
	      default: 'primary'
	    },
	    size: {
	      type: String,
	      default: 'normal'
	    }
	  }
	};
	
	
	/***/ },
	/* 17 */
	/***/ function(module, exports, __webpack_require__) {
	
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	if (false) {
	  require('mint-ui/packages/font/style.css');
	}
	
	/**
	 * mt-header
	 * @module components/button
	 * @desc 按钮
	 * @param {string} [type=default] - 显示类型，接受 default, primary, danger
	 * @param {boolean} [disabled=false] - 禁用
	 * @param {boolean} [plain=false] - 幽灵按钮
	 * @param {string} [size=normal] - 尺寸，接受 normal, small, large
	 * @param {string} [native-type] - 原生 type 属性
	 * @param {string} [icon] - 图标，提供 more, back，或者自定义的图标（传入不带前缀的图标类名，最后拼接成 .mintui-xxx）
	 * @param {slot} - 显示文本
	 * @param {slot} [icon] 显示图标
	 *
	 * @example
	 * <mt-button size="large" icon="back" type="primary">按钮</mt-button>
	 */
	/* harmony default export */ exports["default"] = {
	  name: 'mt-button',
	
	  methods: {
	    handleClick: function handleClick(evt) {
	      this.$emit('click', evt);
	    }
	  },
	
	  props: {
	    icon: String,
	    disabled: Boolean,
	    nativeType: String,
	    plain: Boolean,
	    type: {
	      type: String,
	      default: 'default',
	      validator: function validator(value) {
	        return [
	          'default',
	          'danger',
	          'primary'
	        ].indexOf(value) > -1;
	      }
	    },
	    size: {
	      type: String,
	      default: 'normal',
	      validator: function validator$1(value) {
	        return [
	          'small',
	          'normal',
	          'large'
	        ].indexOf(value) > -1;
	      }
	    }
	  }
	};
	
	
	/***/ },
	/* 18 */
	/***/ function(module, exports, __webpack_require__) {
	
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mint_ui_src_utils_dom__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mint_ui_packages_cell_index_js__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mint_ui_src_utils_clickoutside__ = __webpack_require__(10);
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	if (false) {
	  require('mint-ui/packages/cell/style.css');
	}
	
	/**
	 * mt-cell-swipe
	 * @desc 类似 iOS 滑动 Cell 的效果
	 * @module components/cell-swipe
	 *
	 * @example
	 * <mt-cell-swipe
	 *   :left=[
	 *     {
	 *       content: 'text',
	 *       style: {color: 'white', backgroundColor: 'red'},
	 *       handler(e) => console.log(123)
	 *     }
	 *   ]
	 *   :right=[{ content: 'allowed HTML' }]>
	 *   swipe me
	 * </mt-cell-swipe>
	 */
	/* harmony default export */ exports["default"] = {
	  name: 'mt-cell-swipe',
	
	  components: { XCell: __WEBPACK_IMPORTED_MODULE_1_mint_ui_packages_cell_index_js__["a" /* default */] },
	
	  directives: { Clickoutside: __WEBPACK_IMPORTED_MODULE_2_mint_ui_src_utils_clickoutside__["a" /* default */] },
	
	  props: {
	    to: String,
	    left: Array,
	    right: Array,
	    icon: String,
	    title: String,
	    label: String,
	    isLink: Boolean,
	    value: {}
	  },
	
	  data: function data() {
	    return {
	      start: { x: 0, y: 0 }
	    };
	  },
	
	  mounted: function mounted() {
	    this.wrap = this.$refs.cell.$el.querySelector('.mint-cell-wrapper');
	    this.leftElm = this.$refs.left;
	    this.rightElm = this.$refs.right;
	    this.leftWrapElm = this.leftElm.parentNode;
	    this.rightWrapElm = this.rightElm.parentNode;
	    this.leftWidth = this.leftElm.getBoundingClientRect().width;
	    this.rightWidth = this.rightElm.getBoundingClientRect().width;
	
	    this.leftDefaultTransform = this.translate3d(-this.leftWidth - 1);
	    this.rightDefaultTransform = this.translate3d(this.rightWidth);
	
	    this.rightWrapElm.style.webkitTransform = this.rightDefaultTransform;
	    this.leftWrapElm.style.webkitTransform = this.leftDefaultTransform;
	  },
	
	  methods: {
	    resetSwipeStatus: function resetSwipeStatus() {
	      this.swiping = false;
	      this.opened = true;
	      this.offsetLeft = 0;
	    },
	
	    translate3d: function translate3d(offset) {
	      return ("translate3d(" + offset + "px, 0, 0)");
	    },
	
	    setAnimations: function setAnimations(val) {
	      this.wrap.style.transitionDuration = val;
	      this.rightWrapElm.style.transitionDuration = val;
	      this.leftWrapElm.style.transitionDuration = val;
	    },
	
	    swipeMove: function swipeMove(offset) {
	      if ( offset === void 0 ) offset = 0;
	
	      this.wrap.style.webkitTransform = this.translate3d(offset);
	      this.rightWrapElm.style.webkitTransform = this.translate3d(this.rightWidth + offset);
	      this.leftWrapElm.style.webkitTransform = this.translate3d(-this.leftWidth + offset);
	      offset && (this.swiping = true);
	    },
	
	    swipeLeaveTransition: function swipeLeaveTransition(direction) {
	      var this$1 = this;
	
	      setTimeout(function () {
	        this$1.swipeLeave = true;
	
	        // left
	        if (direction > 0 && -this$1.offsetLeft > this$1.rightWidth * 0.4) {
	          this$1.swipeMove(-this$1.rightWidth);
	          this$1.resetSwipeStatus();
	          return;
	        // right
	        } else if (direction < 0 && this$1.offsetLeft > this$1.leftWidth * 0.4) {
	          this$1.swipeMove(this$1.leftWidth);
	          this$1.resetSwipeStatus();
	          return;
	        }
	
	        this$1.swipeMove(0);
	        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_mint_ui_src_utils_dom__["c" /* once */])(this$1.wrap, 'webkitTransitionEnd', function (_) {
	          this$1.wrap.style.webkitTransform = '';
	          this$1.rightWrapElm.style.webkitTransform = this$1.rightDefaultTransform;
	          this$1.leftWrapElm.style.webkitTransform = this$1.leftDefaultTransform;
	          this$1.swipeLeave = false;
	          this$1.swiping = false;
	        });
	      }, 0);
	    },
	
	    startDrag: function startDrag(evt) {
	      evt = evt.changedTouches ? evt.changedTouches[0] : evt;
	      this.dragging = true;
	      this.start.x = evt.pageX;
	      this.start.y = evt.pageY;
	      this.direction = '';
	    },
	
	    onDrag: function onDrag(evt) {
	      if (this.opened) {
	        if (!this.swiping) {
	          this.swipeMove(0);
	          this.setAnimations('');
	        }
	        this.opened = false;
	        return;
	      }
	      if (!this.dragging) return;
	
	      var swiping;
	      var e = evt.changedTouches ? evt.changedTouches[0] : evt;
	      var offsetTop = e.pageY - this.start.y;
	      var offsetLeft = this.offsetLeft = e.pageX - this.start.x;
	
	      var y = Math.abs(offsetTop);
	      var x = Math.abs(offsetLeft);
	
	      this.setAnimations('0ms');
	
	      if (this.direction === '') {
	        this.direction = x > y ? 'horizonal' : 'vertical';
	      }
	
	      if (this.direction === 'horizonal') {
	        evt.preventDefault();
	        evt.stopPropagation();
	
	        swiping = !(x < 5 || (x >= 5 && y >= x * 1.73));
	        if (!swiping) return;
	
	        if ((offsetLeft < 0 && -offsetLeft > this.rightWidth) ||
	          (offsetLeft > 0 && offsetLeft > this.leftWidth) ||
	          (offsetLeft > 0 && !this.leftWidth) ||
	          (offsetLeft < 0 && !this.rightWidth)) {
	        } else {
	          this.swipeMove(offsetLeft);
	        }
	      }
	    },
	
	    endDrag: function endDrag() {
	      this.direction = '';
	      this.setAnimations('');
	      if (!this.swiping) return;
	      this.swipeLeaveTransition(this.offsetLeft > 0 ? -1 : 1);
	    }
	  }
	};
	
	
	/***/ },
	/* 19 */
	/***/ function(module, exports, __webpack_require__) {
	
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	if (false) {
	  require('mint-ui/packages/font/style.css');
	}
	
	/**
	 * mt-cell
	 * @module components/cell
	 * @desc 单元格
	 * @param {string|Object} [to] - 跳转链接，使用 vue-router 的情况下 to 会传递给 router.push，否则作为 a 标签的 href 属性处理
	 * @param {string} [icon] - 图标，提供 more, back，或者自定义的图标（传入不带前缀的图标类名，最后拼接成 .mintui-xxx）
	 * @param {string} [title] - 标题
	 * @param {string} [label] - 备注信息
	 * @param {boolean} [is-link=false] - 可点击的链接
	 * @param {string} [value] - 右侧显示文字
	 * @param {slot} - 同 value, 会覆盖 value 属性
	 * @param {slot} [title] - 同 title, 会覆盖 title 属性
	 * @param {slot} [icon] - 同 icon, 会覆盖 icon 属性，例如可以传入图片
	 *
	 * @example
	 * <mt-cell title="标题文字" icon="back" is-link value="描述文字"></mt-cell>
	 * <mt-cell title="标题文字" icon="back">
	 *   <div slot="value">描述文字啊哈</div>
	 * </mt-cell>
	 */
	/* harmony default export */ exports["default"] = {
	  name: 'mt-cell',
	
	  props: {
	    to: [String, Object],
	    icon: String,
	    title: String,
	    label: String,
	    isLink: Boolean,
	    value: {}
	  },
	
	  computed: {
	    href: function href() {
	      var this$1 = this;
	
	      if (this.to && !this.added && this.$router) {
	        var resolved = this.$router.match(this.to);
	        if (!resolved.matched.length) return this.to;
	
	        this.$nextTick(function () {
	          this$1.added = true;
	          this$1.$el.addEventListener('click', this$1.handleClick);
	        });
	        return resolved.fullPath || resolved.path;
	      }
	      return this.to;
	    }
	  },
	
	  methods: {
	    handleClick: function handleClick($event) {
	      $event.preventDefault();
	      this.$router.push(this.href);
	    }
	  }
	};
	
	
	/***/ },
	/* 20 */
	/***/ function(module, exports, __webpack_require__) {
	
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mint_ui_packages_cell_index_js__ = __webpack_require__(2);
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	if (false) {
	  require('mint-ui/packages/cell/style.css');
	}
	
	/**
	 * mt-checklist
	 * @module components/checklist
	 * @desc 复选框列表，依赖 cell 组件
	 *
	 * @param {(string[]|object[])} options - 选项数组，可以传入 [{label: 'label', value: 'value', disabled: true}] 或者 ['ab', 'cd', 'ef']
	 * @param {string[]} value - 选中值的数组
	 * @param {string} title - 标题
	 * @param {number} [max] - 最多可选的个数
	 * @param {string} [align=left] - checkbox 对齐位置，`left`, `right`
	 *
	 *
	 * @example
	 * <mt-checklist :v-model="value" :options="['a', 'b', 'c']"></mt-checklist>
	 */
	/* harmony default export */ exports["default"] = {
	  name: 'mt-checklist',
	
	  props: {
	    max: Number,
	    title: String,
	    align: String,
	    options: {
	      type: Array,
	      required: true
	    },
	    value: Array
	  },
	
	  components: { XCell: __WEBPACK_IMPORTED_MODULE_0_mint_ui_packages_cell_index_js__["a" /* default */] },
	
	  data: function data() {
	    return {
	      currentValue: this.value
	    };
	  },
	
	  computed: {
	    limit: function limit() {
	      return this.max < this.currentValue.length;
	    }
	  },
	
	  watch: {
	    value: function value(val) {
	      this.currentValue = val;
	    },
	
	    currentValue: function currentValue(val) {
	      if (this.limit) val.pop();
	      this.$emit('input', val);
	    }
	  }
	};
	
	
	/***/ },
	/* 21 */
	/***/ function(module, exports, __webpack_require__) {
	
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mint_ui_packages_picker_index_js__ = __webpack_require__(7);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mint_ui_packages_popup_index_js__ = __webpack_require__(8);
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	if (false) {
	  require('mint-ui/packages/picker/style.css');
	  require('mint-ui/packages/popup/style.css');
	}
	
	var FORMAT_MAP = {
	  Y: 'year',
	  M: 'month',
	  D: 'date',
	  H: 'hour',
	  m: 'minute'
	};
	
	/* harmony default export */ exports["default"] = {
	  name: 'mt-datetime-picker',
	
	  props: {
	    cancelText: {
	      type: String,
	      default: '取消'
	    },
	    confirmText: {
	      type: String,
	      default: '确定'
	    },
	    type: {
	      type: String,
	      default: 'datetime'
	    },
	    startDate: {
	      type: Date,
	      default: function default$1() {
	        return new Date(new Date().getFullYear() - 10, 0, 1);
	      }
	    },
	    endDate: {
	      type: Date,
	      default: function default$2() {
	        return new Date(new Date().getFullYear() + 10, 11, 31);
	      }
	    },
	    startHour: {
	      type: Number,
	      default: 0
	    },
	    endHour: {
	      type: Number,
	      default: 23
	    },
	    yearFormat: {
	      type: String,
	      default: '{value}'
	    },
	    monthFormat: {
	      type: String,
	      default: '{value}'
	    },
	    dateFormat: {
	      type: String,
	      default: '{value}'
	    },
	    hourFormat: {
	      type: String,
	      default: '{value}'
	    },
	    minuteFormat: {
	      type: String,
	      default: '{value}'
	    },
	    visibleItemCount: {
	      type: Number,
	      default: 7
	    },
	    closeOnClickModal: {
	      type: Boolean,
	      default: true
	    },
	    value: null
	  },
	
	  data: function data() {
	    return {
	      visible: false,
	      startYear: null,
	      endYear: null,
	      startMonth: 1,
	      endMonth: 12,
	      startDay: 1,
	      endDay: 31,
	      currentValue: null,
	      selfTriggered: false,
	      dateSlots: [],
	      shortMonthDates: [],
	      longMonthDates: [],
	      febDates: [],
	      leapFebDates: []
	    };
	  },
	
	  components: {
	    'mt-picker': __WEBPACK_IMPORTED_MODULE_0_mint_ui_packages_picker_index_js__["a" /* default */],
	    'mt-popup': __WEBPACK_IMPORTED_MODULE_1_mint_ui_packages_popup_index_js__["a" /* default */]
	  },
	
	  methods: {
	    open: function open() {
	      this.visible = true;
	    },
	
	    close: function close() {
	      this.visible = false;
	    },
	
	    isLeapYear: function isLeapYear(year) {
	      return (year % 400 === 0) || (year % 100 !== 0 && year % 4 === 0);
	    },
	
	    isShortMonth: function isShortMonth(month) {
	      return [4, 6, 9, 11].indexOf(month) > -1;
	    },
	
	    getMonthEndDay: function getMonthEndDay(year, month) {
	      if (this.isShortMonth(month)) {
	        return 30;
	      } else if (month === 2) {
	        return this.isLeapYear(year) ? 29 : 28;
	      } else {
	        return 31;
	      }
	    },
	
	    getTrueValue: function getTrueValue(formattedValue) {
	      if (!formattedValue) return;
	      while (isNaN(parseInt(formattedValue, 10))) {
	        formattedValue = formattedValue.slice(1);
	      }
	      return parseInt(formattedValue, 10);
	    },
	
	    getValue: function getValue(values) {
	      var this$1 = this;
	
	      var value;
	      if (this.type === 'time') {
	        value = values.map(function (value) { return ('0' + this$1.getTrueValue(value)).slice(-2); }).join(':');
	      } else {
	        var year = this.getTrueValue(values[0]);
	        var month = this.getTrueValue(values[1]);
	        var date = this.getTrueValue(values[2]);
	        var maxDate = this.getMonthEndDay(year, month);
	        if (date > maxDate) {
	          this.selfTriggered = true;
	          date = 1;
	        }
	        var hour = this.typeStr.indexOf('H') > -1 ? this.getTrueValue(values[this.typeStr.indexOf('H')]) : 0;
	        var minute = this.typeStr.indexOf('m') > -1 ? this.getTrueValue(values[this.typeStr.indexOf('m')]) : 0;
	        value = new Date(year, month - 1, date, hour, minute);
	      }
	      return value;
	    },
	
	    onChange: function onChange(picker) {
	      var values = picker.$children.filter(function (child) { return child.currentValue !== undefined; }).map(function (child) { return child.currentValue; });
	      if (this.selfTriggered) {
	        this.selfTriggered = false;
	        return;
	      }
	      if (values.length !== 0) {
	        this.currentValue = this.getValue(values);
	        this.handleValueChange();
	      }
	    },
	
	    fillValues: function fillValues(type, start, end) {
	      var this$1 = this;
	
	      var values = [];
	      for (var i = start; i <= end; i++) {
	        if (i < 10) {
	          values.push(this$1[((FORMAT_MAP[type]) + "Format")].replace('{value}', ('0' + i).slice(-2)));
	        } else {
	          values.push(this$1[((FORMAT_MAP[type]) + "Format")].replace('{value}', i));
	        }
	      }
	      return values;
	    },
	
	    pushSlots: function pushSlots(slots, type, start, end) {
	      slots.push({
	        flex: 1,
	        values: this.fillValues(type, start, end)
	      });
	    },
	
	    generateSlots: function generateSlots() {
	      var this$1 = this;
	
	      var dateSlots = [];
	      var INTERVAL_MAP = {
	        Y: this.rims.year,
	        M: this.rims.month,
	        D: this.rims.date,
	        H: this.rims.hour,
	        m: this.rims.min
	      };
	      var typesArr = this.typeStr.split('');
	      typesArr.forEach(function (type) {
	        if (INTERVAL_MAP[type]) {
	          this$1.pushSlots.apply(null, [dateSlots, type].concat(INTERVAL_MAP[type]));
	        }
	      });
	      if (this.typeStr === 'Hm') {
	        dateSlots.splice(1, 0, {
	          divider: true,
	          content: ':'
	        });
	      }
	      this.dateSlots = dateSlots;
	      this.handleExceededValue();
	    },
	
	    handleExceededValue: function handleExceededValue() {
	      var this$1 = this;
	
	      var values = [];
	      if (this.type === 'time') {
	        var currentValue = this.currentValue.split(':');
	        values = [
	          this.hourFormat.replace('{value}', currentValue[0]),
	          this.minuteFormat.replace('{value}', currentValue[1])
	        ];
	      } else {
	        values = [
	          this.yearFormat.replace('{value}', this.getYear(this.currentValue)),
	          this.monthFormat.replace('{value}', ('0' + this.getMonth(this.currentValue)).slice(-2)),
	          this.dateFormat.replace('{value}', ('0' + this.getDate(this.currentValue)).slice(-2))
	        ];
	        if (this.type === 'datetime') {
	          values.push(
	            this.hourFormat.replace('{value}', ('0' + this.getHour(this.currentValue)).slice(-2)),
	            this.minuteFormat.replace('{value}', ('0' + this.getMinute(this.currentValue)).slice(-2))
	          );
	        }
	      }
	      this.dateSlots.filter(function (child) { return child.values !== undefined; })
	        .map(function (slot) { return slot.values; }).forEach(function (slotValues, index) {
	          if (slotValues.indexOf(values[index]) === -1) {
	            values[index] = slotValues[0];
	          }
	        });
	      this.$nextTick(function () {
	        this$1.setSlotsByValues(values);
	      });
	    },
	
	    setSlotsByValues: function setSlotsByValues(values) {
	      var setSlotValue = this.$refs.picker.setSlotValue;
	      if (this.type === 'time') {
	        setSlotValue(0, values[0]);
	        setSlotValue(1, values[1]);
	      }
	      if (this.type !== 'time') {
	        setSlotValue(0, values[0]);
	        setSlotValue(1, values[1]);
	        setSlotValue(2, values[2]);
	        if (this.type === 'datetime') {
	          setSlotValue(3, values[3]);
	          setSlotValue(4, values[4]);
	        }
	      }
	      [].forEach.call(this.$refs.picker.$children, function (child) { return child.doOnValueChange(); });
	    },
	
	    rimDetect: function rimDetect(result, rim) {
	      var position = rim === 'start' ? 0 : 1;
	      var rimDate = rim === 'start' ? this.startDate : this.endDate;
	      if (this.getYear(this.currentValue) === rimDate.getFullYear()) {
	        result.month[position] = rimDate.getMonth() + 1;
	        if (this.getMonth(this.currentValue) === rimDate.getMonth() + 1) {
	          result.date[position] = rimDate.getDate();
	          if (this.getDate(this.currentValue) === rimDate.getDate()) {
	            result.hour[position] = rimDate.getHours();
	            if (this.getHour(this.currentValue) === rimDate.getHours()) {
	              result.min[position] = rimDate.getMinutes();
	            }
	          }
	        }
	      }
	    },
	
	    isDateString: function isDateString(str) {
	      return /\d{4}(\-|\/|.)\d{1,2}\1\d{1,2}/.test(str);
	    },
	
	    getYear: function getYear(value) {
	      return this.isDateString(value) ? value.split(' ')[0].split(/-|\/|\./)[0] : value.getFullYear();
	    },
	
	    getMonth: function getMonth(value) {
	      return this.isDateString(value) ? value.split(' ')[0].split(/-|\/|\./)[1] : value.getMonth() + 1;
	    },
	
	    getDate: function getDate(value) {
	      return this.isDateString(value) ? value.split(' ')[0].split(/-|\/|\./)[2] : value.getDate();
	    },
	
	    getHour: function getHour(value) {
	      if (this.isDateString(value)) {
	        var str = value.split(' ')[1] || '00:00:00';
	        return str.split(':')[0];
	      }
	      return value.getHours();
	    },
	
	    getMinute: function getMinute(value) {
	      if (this.isDateString(value)) {
	        var str = value.split(' ')[1] || '00:00:00';
	        return str.split(':')[1];
	      }
	      return value.getMinutes();
	    },
	
	    confirm: function confirm() {
	      this.visible = false;
	      this.$emit('confirm', this.currentValue);
	    },
	
	    handleValueChange: function handleValueChange() {
	      this.$emit('input', this.currentValue);
	    }
	  },
	
	  computed: {
	    rims: function rims() {
	      if (!this.currentValue) return { year: [], month: [], date: [], hour: [], min: [] };
	      var result;
	      if (this.type === 'time') {
	        result = {
	          hour: [this.startHour, this.endHour],
	          min: [0, 59]
	        };
	        return result;
	      }
	      result = {
	        year: [this.startDate.getFullYear(), this.endDate.getFullYear()],
	        month: [1, 12],
	        date: [1, this.getMonthEndDay(this.getYear(this.currentValue), this.getMonth(this.currentValue))],
	        hour: [0, 23],
	        min: [0, 59]
	      };
	      this.rimDetect(result, 'start');
	      this.rimDetect(result, 'end');
	      return result;
	    },
	
	    typeStr: function typeStr() {
	      if (this.type === 'time') {
	        return 'Hm';
	      } else if (this.type === 'date') {
	        return 'YMD';
	      } else {
	        return 'YMDHm';
	      }
	    }
	  },
	
	  watch: {
	    value: function value(val) {
	      this.currentValue = val;
	    },
	
	    rims: function rims$1() {
	      this.generateSlots();
	    },
	
	    visible: function visible(val) {
	      this.$emit('visible-change', val);
	    }
	  },
	
	  mounted: function mounted() {
	    this.currentValue = this.value;
	    if (!this.value) {
	      if (this.type.indexOf('date') > -1) {
	        this.currentValue = this.startDate;
	      } else {
	        this.currentValue = (('0' + this.startHour).slice(-2)) + ":00";
	      }
	    }
	    this.generateSlots();
	  }
	};
	
	
	/***/ },
	/* 22 */
	/***/ function(module, exports, __webpack_require__) {
	
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mint_ui_packages_cell_index_js__ = __webpack_require__(2);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mint_ui_src_utils_clickoutside__ = __webpack_require__(10);
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	if (false) {
	  require('mint-ui/packages/cell/style.css');
	}
	
	/**
	 * mt-field
	 * @desc 编辑器，依赖 cell
	 * @module components/field
	 *
	 * @param {string} [type=text] - field 类型，接受 text, textarea 等
	 * @param {string} [label] - 标签
	 * @param {string} [rows] - textarea 的 rows
	 * @param {string} [placeholder] - placeholder
	 * @param {string} [disabled] - disabled
	 * @param {string} [readonly] - readonly
	 * @param {string} [state] - 表单校验状态样式，接受 error, warning, success
	 *
	 * @example
	 * <mt-field v-model="value" label="用户名"></mt-field>
	 * <mt-field v-model="value" label="密码" placeholder="请输入密码"></mt-field>
	 * <mt-field v-model="value" label="自我介绍" placeholder="自我介绍" type="textarea" rows="4"></mt-field>
	 * <mt-field v-model="value" label="邮箱" placeholder="成功状态" state="success"></mt-field>
	 */
	/* harmony default export */ exports["default"] = {
	  name: 'mt-field',
	
	  data: function data() {
	    return {
	      active: false,
	      currentValue: this.value
	    };
	  },
	
	  directives: {
	    Clickoutside: __WEBPACK_IMPORTED_MODULE_1_mint_ui_src_utils_clickoutside__["a" /* default */]
	  },
	
	  props: {
	    type: {
	      type: String,
	      default: 'text'
	    },
	    rows: String,
	    label: String,
	    placeholder: String,
	    readonly: Boolean,
	    disabled: Boolean,
	    disableClear: Boolean,
	    state: {
	      type: String,
	      default: 'default'
	    },
	    value: {},
	    attr: Object
	  },
	
	  components: { XCell: __WEBPACK_IMPORTED_MODULE_0_mint_ui_packages_cell_index_js__["a" /* default */] },
	
	  methods: {
	    doCloseActive: function doCloseActive() {
	      this.active = false;
	    },
	
	    handleInput: function handleInput(evt) {
	      this.currentValue = evt.target.value;
	    },
	
	    handleClear: function handleClear() {
	      if (this.disabled || this.readonly) return;
	      this.currentValue = '';
	    }
	  },
	
	  watch: {
	    value: function value(val) {
	      this.currentValue = val;
	    },
	
	    currentValue: function currentValue(val) {
	      this.$emit('input', val);
	    },
	
	    attr: {
	      immediate: true,
	      handler: function handler(attrs) {
	        var this$1 = this;
	
	        this.$nextTick(function () {
	          var target = [this$1.$refs.input, this$1.$refs.textarea];
	          target.forEach(function (el) {
	            if (!el || !attrs) return;
	            Object.keys(attrs).map(function (name) { return el.setAttribute(name, attrs[name]); });
	          });
	        });
	      }
	    }
	  }
	};
	
	
	/***/ },
	/* 23 */
	/***/ function(module, exports, __webpack_require__) {
	
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	/**
	 * mt-header
	 * @module components/header
	 * @desc 顶部导航
	 * @param {boolean} [fixed=false] - 固定顶部
	 * @param {string} [title] - 标题
	 * @param {slot} [left] - 显示在左侧区域
	 * @param {slot} [right] - 显示在右侧区域
	 *
	 * @example
	 * <mt-header title="我是标题" fixed>
	 *   <mt-button slot="left" icon="back" @click="handleBack">返回</mt-button>
	 *   <mt-button slot="right" icon="more"></mt-button>
	 * </mt-header>
	 */
	/* harmony default export */ exports["default"] = {
	  name: 'mt-header',
	
	  props: {
	    fixed: Boolean,
	    title: String
	  }
	};
	
	
	/***/ },
	/* 24 */
	/***/ function(module, exports, __webpack_require__) {
	
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	/* harmony default export */ exports["default"] = {
	  name: 'mt-index-list',
	
	  props: {
	    height: Number,
	    showIndicator: {
	      type: Boolean,
	      default: true
	    }
	  },
	
	  data: function data() {
	    return {
	      sections: [],
	      navWidth: 0,
	      indicatorTime: null,
	      moving: false,
	      firstSection: null,
	      currentIndicator: '',
	      currentHeight: this.height,
	      navOffsetX: 0
	    };
	  },
	
	  watch: {
	    sections: function sections() {
	      this.init();
	    },
	    height: function height(val) {
	      if (val) {
	        this.currentHeight = val;
	      }
	    }
	  },
	
	  methods: {
	    init: function init() {
	      var this$1 = this;
	
	      this.$nextTick(function () {
	        this$1.navWidth = this$1.$refs.nav.clientWidth;
	      });
	      var listItems = this.$refs.content.getElementsByTagName('li');
	      if (listItems.length > 0) {
	        this.firstSection = listItems[0];
	      }
	    },
	
	    handleTouchStart: function handleTouchStart(e) {
	      if (e.target.tagName !== 'LI') {
	        return;
	      }
	      this.navOffsetX = e.changedTouches[0].clientX;
	      this.scrollList(e.changedTouches[0].clientY);
	      if (this.indicatorTime) {
	        clearTimeout(this.indicatorTime);
	      }
	      this.moving = true;
	      window.addEventListener('touchmove', this.handleTouchMove);
	      window.addEventListener('touchend', this.handleTouchEnd);
	    },
	
	    handleTouchMove: function handleTouchMove(e) {
	      e.preventDefault();
	      this.scrollList(e.changedTouches[0].clientY);
	    },
	
	    handleTouchEnd: function handleTouchEnd() {
	      var this$1 = this;
	
	      this.indicatorTime = setTimeout(function () {
	        this$1.moving = false;
	        this$1.currentIndicator = '';
	      }, 500);
	      window.removeEventListener('touchmove', this.handleTouchMove);
	      window.removeEventListener('touchend', this.handleTouchEnd);
	    },
	
	    scrollList: function scrollList(y) {
	      var currentItem = document.elementFromPoint(this.navOffsetX, y);
	      if (!currentItem || !currentItem.classList.contains('mint-indexlist-navitem')) {
	        return;
	      }
	      this.currentIndicator = currentItem.innerText;
	      var targets = this.sections.filter(function (section) { return section.index === currentItem.innerText; });
	      var targetDOM;
	      if (targets.length > 0) {
	        targetDOM = targets[0].$el;
	        this.$refs.content.scrollTop = targetDOM.getBoundingClientRect().top - this.firstSection.getBoundingClientRect().top;
	      }
	    }
	  },
	
	  mounted: function mounted() {
	    var this$1 = this;
	
	    if (!this.currentHeight) {
	      window.scrollTo(0, 0);
	      requestAnimationFrame(function (){
	        this$1.currentHeight = document.documentElement.clientHeight - this$1.$refs.content.getBoundingClientRect().top;
	      });
	    }
	    this.init();
	  }
	};
	
	
	/***/ },
	/* 25 */
	/***/ function(module, exports, __webpack_require__) {
	
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	/* harmony default export */ exports["default"] = {
	  name: 'mt-index-section',
	
	  props: {
	    index: {
	      type: String,
	      required: true
	    }
	  },
	
	  mounted: function mounted() {
	    this.$parent.sections.push(this);
	  },
	
	  beforeDestroy: function beforeDestroy() {
	    var index = this.$parent.sections.indexOf(this);
	    if (index > -1) {
	      this.$parent.sections.splice(index, 1);
	    }
	  }
	};
	
	
	/***/ },
	/* 26 */
	/***/ function(module, exports, __webpack_require__) {
	
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mint_ui_packages_spinner_index_js__ = __webpack_require__(9);
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	if (false) {
	  require('mint-ui/packages/spinner/style.css');
	}
	
	/* harmony default export */ exports["default"] = {
	  data: function data() {
	    return {
	      visible: false
	    };
	  },
	
	  components: {
	    Spinner: __WEBPACK_IMPORTED_MODULE_0_mint_ui_packages_spinner_index_js__["a" /* default */]
	  },
	
	  computed: {
	    convertedSpinnerType: function convertedSpinnerType() {
	      switch (this.spinnerType) {
	        case 'double-bounce':
	          return 1;
	        case 'triple-bounce':
	          return 2;
	        case 'fading-circle':
	          return 3;
	        default:
	          return 0;
	      }
	    }
	  },
	
	  props: {
	    text: String,
	    spinnerType: {
	      type: String,
	      default: 'snake'
	    }
	  }
	};
	
	
	/***/ },
	/* 27 */
	/***/ function(module, exports, __webpack_require__) {
	
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mint_ui_packages_spinner_src_spinner_fading_circle_vue__ = __webpack_require__(13);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mint_ui_packages_spinner_src_spinner_fading_circle_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_mint_ui_packages_spinner_src_spinner_fading_circle_vue__);
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	/* harmony default export */ exports["default"] = {
	  name: 'mt-loadmore',
	  components: {
	    'spinner': __WEBPACK_IMPORTED_MODULE_0_mint_ui_packages_spinner_src_spinner_fading_circle_vue___default.a
	  },
	
	  props: {
	    maxDistance: {
	      type: Number,
	      default: 0
	    },
	    autoFill: {
	      type: Boolean,
	      default: true
	    },
	    distanceIndex: {
	      type: Number,
	      default: 2
	    },
	    topPullText: {
	      type: String,
	      default: '下拉刷新'
	    },
	    topDropText: {
	      type: String,
	      default: '释放更新'
	    },
	    topLoadingText: {
	      type: String,
	      default: '加载中...'
	    },
	    topDistance: {
	      type: Number,
	      default: 70
	    },
	    topMethod: {
	      type: Function
	    },
	    bottomPullText: {
	      type: String,
	      default: '上拉刷新'
	    },
	    bottomDropText: {
	      type: String,
	      default: '释放更新'
	    },
	    bottomLoadingText: {
	      type: String,
	      default: '加载中...'
	    },
	    bottomDistance: {
	      type: Number,
	      default: 70
	    },
	    bottomMethod: {
	      type: Function
	    },
	    bottomAllLoaded: {
	      type: Boolean,
	      default: false
	    }
	  },
	
	  data: function data() {
	    return {
	      translate: 0,
	      scrollEventTarget: null,
	      containerFilled: false,
	      topText: '',
	      topDropped: false,
	      bottomText: '',
	      bottomDropped: false,
	      bottomReached: false,
	      direction: '',
	      startY: 0,
	      startScrollTop: 0,
	      currentY: 0,
	      topStatus: '',
	      bottomStatus: ''
	    };
	  },
	
	  computed: {
	    transform: function transform() {
	      return this.translate === 0 ? null : 'translate3d(0, ' + this.translate + 'px, 0)';
	    }
	  },
	
	  watch: {
	    topStatus: function topStatus(val) {
	      this.$emit('top-status-change', val);
	      switch (val) {
	        case 'pull':
	          this.topText = this.topPullText;
	          break;
	        case 'drop':
	          this.topText = this.topDropText;
	          break;
	        case 'loading':
	          this.topText = this.topLoadingText;
	          break;
	      }
	    },
	
	    bottomStatus: function bottomStatus(val) {
	      this.$emit('bottom-status-change', val);
	      switch (val) {
	        case 'pull':
	          this.bottomText = this.bottomPullText;
	          break;
	        case 'drop':
	          this.bottomText = this.bottomDropText;
	          break;
	        case 'loading':
	          this.bottomText = this.bottomLoadingText;
	          break;
	      }
	    }
	  },
	
	  methods: {
	    onTopLoaded: function onTopLoaded() {
	      var this$1 = this;
	
	      this.translate = 0;
	      setTimeout(function () {
	        this$1.topStatus = 'pull';
	      }, 200);
	    },
	
	    onBottomLoaded: function onBottomLoaded() {
	      var this$1 = this;
	
	      this.bottomStatus = 'pull';
	      this.bottomDropped = false;
	      this.$nextTick(function () {
	        if (this$1.scrollEventTarget === window) {
	          document.body.scrollTop += 50;
	        } else {
	          this$1.scrollEventTarget.scrollTop += 50;
	        }
	        this$1.translate = 0;
	      });
	      if (!this.bottomAllLoaded && !this.containerFilled) {
	        this.fillContainer();
	      }
	    },
	
	    getScrollEventTarget: function getScrollEventTarget(element) {
	      var currentNode = element;
	      while (currentNode && currentNode.tagName !== 'HTML' &&
	        currentNode.tagName !== 'BODY' && currentNode.nodeType === 1) {
	        var overflowY = document.defaultView.getComputedStyle(currentNode).overflowY;
	        if (overflowY === 'scroll' || overflowY === 'auto') {
	          return currentNode;
	        }
	        currentNode = currentNode.parentNode;
	      }
	      return window;
	    },
	
	    getScrollTop: function getScrollTop(element) {
	      if (element === window) {
	        return Math.max(window.pageYOffset || 0, document.documentElement.scrollTop);
	      } else {
	        return element.scrollTop;
	      }
	    },
	
	    bindTouchEvents: function bindTouchEvents() {
	      this.$el.addEventListener('touchstart', this.handleTouchStart);
	      this.$el.addEventListener('touchmove', this.handleTouchMove);
	      this.$el.addEventListener('touchend', this.handleTouchEnd);
	    },
	
	    init: function init() {
	      this.topStatus = 'pull';
	      this.bottomStatus = 'pull';
	      this.topText = this.topPullText;
	      this.scrollEventTarget = this.getScrollEventTarget(this.$el);
	      if (typeof this.bottomMethod === 'function') {
	        this.fillContainer();
	        this.bindTouchEvents();
	      }
	      if (typeof this.topMethod === 'function') {
	        this.bindTouchEvents();
	      }
	    },
	
	    fillContainer: function fillContainer() {
	      var this$1 = this;
	
	      if (this.autoFill) {
	        this.$nextTick(function () {
	          if (this$1.scrollEventTarget === window) {
	            this$1.containerFilled = this$1.$el.getBoundingClientRect().bottom >=
	              document.documentElement.getBoundingClientRect().bottom;
	          } else {
	            this$1.containerFilled = this$1.$el.getBoundingClientRect().bottom >=
	              this$1.scrollEventTarget.getBoundingClientRect().bottom;
	          }
	          if (!this$1.containerFilled) {
	            this$1.bottomStatus = 'loading';
	            this$1.bottomMethod();
	          }
	        });
	      }
	    },
	
	    checkBottomReached: function checkBottomReached() {
	      if (this.scrollEventTarget === window) {
	        return document.body.scrollTop + document.documentElement.clientHeight >= document.body.scrollHeight;
	      } else {
	        return this.$el.getBoundingClientRect().bottom <= this.scrollEventTarget.getBoundingClientRect().bottom + 1;
	      }
	    },
	
	    handleTouchStart: function handleTouchStart(event) {
	      this.startY = event.touches[0].clientY;
	      this.startScrollTop = this.getScrollTop(this.scrollEventTarget);
	      this.bottomReached = false;
	      if (this.topStatus !== 'loading') {
	        this.topStatus = 'pull';
	        this.topDropped = false;
	      }
	      if (this.bottomStatus !== 'loading') {
	        this.bottomStatus = 'pull';
	        this.bottomDropped = false;
	      }
	    },
	
	    handleTouchMove: function handleTouchMove(event) {
	      if (this.startY < this.$el.getBoundingClientRect().top && this.startY > this.$el.getBoundingClientRect().bottom) {
	        return;
	      }
	      this.currentY = event.touches[0].clientY;
	      var distance = (this.currentY - this.startY) / this.distanceIndex;
	      this.direction = distance > 0 ? 'down' : 'up';
	      if (typeof this.topMethod === 'function' && this.direction === 'down' &&
	        this.getScrollTop(this.scrollEventTarget) === 0 && this.topStatus !== 'loading') {
	        event.preventDefault();
	        event.stopPropagation();
	        if (this.maxDistance > 0) {
	          this.translate = distance <= this.maxDistance ? distance - this.startScrollTop : this.translate;
	        } else {
	          this.translate = distance - this.startScrollTop;
	        }
	        if (this.translate < 0) {
	          this.translate = 0;
	        }
	        this.topStatus = this.translate >= this.topDistance ? 'drop' : 'pull';
	      }
	
	      if (this.direction === 'up') {
	        this.bottomReached = this.bottomReached || this.checkBottomReached();
	      }
	      if (typeof this.bottomMethod === 'function' && this.direction === 'up' &&
	        this.bottomReached && this.bottomStatus !== 'loading' && !this.bottomAllLoaded) {
	        event.preventDefault();
	        event.stopPropagation();
	        if (this.maxDistance > 0) {
	          this.translate = Math.abs(distance) <= this.maxDistance
	            ? this.getScrollTop(this.scrollEventTarget) - this.startScrollTop + distance : this.translate;
	        } else {
	          this.translate = this.getScrollTop(this.scrollEventTarget) - this.startScrollTop + distance;
	        }
	        if (this.translate > 0) {
	          this.translate = 0;
	        }
	        this.bottomStatus = -this.translate >= this.bottomDistance ? 'drop' : 'pull';
	      }
	      this.$emit('translate-change', this.translate);
	    },
	
	    handleTouchEnd: function handleTouchEnd() {
	      if (this.direction === 'down' && this.getScrollTop(this.scrollEventTarget) === 0 && this.translate > 0) {
	        this.topDropped = true;
	        if (this.topStatus === 'drop') {
	          this.translate = '50';
	          this.topStatus = 'loading';
	          this.topMethod();
	        } else {
	          this.translate = '0';
	          this.topStatus = 'pull';
	        }
	      }
	      if (this.direction === 'up' && this.bottomReached && this.translate < 0) {
	        this.bottomDropped = true;
	        this.bottomReached = false;
	        if (this.bottomStatus === 'drop') {
	          this.translate = '-50';
	          this.bottomStatus = 'loading';
	          this.bottomMethod();
	        } else {
	          this.translate = '0';
	          this.bottomStatus = 'pull';
	        }
	      }
	      this.$emit('translate-change', this.translate);
	      this.direction = '';
	    }
	  },
	
	  mounted: function mounted() {
	    this.init();
	  }
	};
	
	
	/***/ },
	/* 28 */
	/***/ function(module, exports, __webpack_require__) {
	
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mint_ui_src_utils_popup__ = __webpack_require__(6);
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	var CONFIRM_TEXT = '确定';
	var CANCEL_TEXT = '取消';
	
	
	
	/* harmony default export */ exports["default"] = {
	  mixins: [ __WEBPACK_IMPORTED_MODULE_0_mint_ui_src_utils_popup__["a" /* default */] ],
	
	  props: {
	    modal: {
	      default: true
	    },
	    showClose: {
	      type: Boolean,
	      default: true
	    },
	    lockScroll: {
	      type: Boolean,
	      default: false
	    },
	    closeOnClickModal: {
	      default: true
	    },
	    closeOnPressEscape: {
	      default: true
	    },
	    inputType: {
	      type: String,
	      default: 'text'
	    }
	  },
	
	  computed: {
	    confirmButtonClasses: function confirmButtonClasses() {
	      var classes = 'mint-msgbox-btn mint-msgbox-confirm ' + this.confirmButtonClass;
	      if (this.confirmButtonHighlight) {
	        classes += ' mint-msgbox-confirm-highlight';
	      }
	      return classes;
	    },
	    cancelButtonClasses: function cancelButtonClasses() {
	      var classes = 'mint-msgbox-btn mint-msgbox-cancel ' + this.cancelButtonClass;
	      if (this.cancelButtonHighlight) {
	        classes += ' mint-msgbox-cancel-highlight';
	      }
	      return classes;
	    }
	  },
	
	  methods: {
	    doClose: function doClose() {
	      var this$1 = this;
	
	      this.value = false;
	      this._closing = true;
	
	      this.onClose && this.onClose();
	
	      setTimeout(function () {
	        if (this$1.modal && this$1.bodyOverflow !== 'hidden') {
	          document.body.style.overflow = this$1.bodyOverflow;
	          document.body.style.paddingRight = this$1.bodyPaddingRight;
	        }
	        this$1.bodyOverflow = null;
	        this$1.bodyPaddingRight = null;
	      }, 200);
	      this.opened = false;
	
	      if (!this.transition) {
	        this.doAfterClose();
	      }
	    },
	
	    handleAction: function handleAction(action) {
	      if (this.$type === 'prompt' && action === 'confirm' && !this.validate()) {
	        return;
	      }
	      var callback = this.callback;
	      this.value = false;
	      callback(action);
	    },
	
	    validate: function validate() {
	      if (this.$type === 'prompt') {
	        var inputPattern = this.inputPattern;
	        if (inputPattern && !inputPattern.test(this.inputValue || '')) {
	          this.editorErrorMessage = this.inputErrorMessage || '输入的数据不合法!';
	          this.$refs.input.classList.add('invalid');
	          return false;
	        }
	        var inputValidator = this.inputValidator;
	        if (typeof inputValidator === 'function') {
	          var validateResult = inputValidator(this.inputValue);
	          if (validateResult === false) {
	            this.editorErrorMessage = this.inputErrorMessage || '输入的数据不合法!';
	            this.$refs.input.classList.add('invalid');
	            return false;
	          }
	          if (typeof validateResult === 'string') {
	            this.editorErrorMessage = validateResult;
	            return false;
	          }
	        }
	      }
	      this.editorErrorMessage = '';
	      this.$refs.input.classList.remove('invalid');
	      return true;
	    },
	
	    handleInputType: function handleInputType(val) {
	      if (val === 'range' || !this.$refs.input) return;
	      this.$refs.input.type = val;
	    }
	  },
	
	  watch: {
	    inputValue: function inputValue() {
	      if (this.$type === 'prompt') {
	        this.validate();
	      }
	    },
	
	    value: function value(val) {
	      var this$1 = this;
	
	      this.handleInputType(this.inputType);
	      if (val && this.$type === 'prompt') {
	        setTimeout(function () {
	          if (this$1.$refs.input) {
	            this$1.$refs.input.focus();
	          }
	        }, 500);
	      }
	    },
	
	    inputType: function inputType(val) {
	      this.handleInputType(val);
	    }
	  },
	
	  data: function data() {
	    return {
	      title: '',
	      message: '',
	      type: '',
	      showInput: false,
	      inputValue: null,
	      inputPlaceholder: '',
	      inputPattern: null,
	      inputValidator: null,
	      inputErrorMessage: '',
	      showConfirmButton: true,
	      showCancelButton: false,
	      confirmButtonText: CONFIRM_TEXT,
	      cancelButtonText: CANCEL_TEXT,
	      confirmButtonClass: '',
	      confirmButtonDisabled: false,
	      cancelButtonClass: '',
	      editorErrorMessage: null,
	      callback: null
	    };
	  }
	};
	
	
	/***/ },
	/* 29 */
	/***/ function(module, exports, __webpack_require__) {
	
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	//
	//
	//
	//
	//
	//
	
	/**
	 * mt-navbar
	 * @module components/navbar
	 * @desc 顶部 tab，依赖 tab-item
	 *
	 * @param {boolean} [fixed=false] - 固定底部
	 * @param {*} selected - 返回 item component 传入的 value
	 *
	 * @example
	 * <mt-navbar :selected.sync="selected">
	 *   <mt-tab-item value="订单">
	 *     <span slot="label">订单</span>
	 *   </mt-tab-item>
	 * </mt-navbar>
	 *
	 * <mt-navbar :selected.sync="selected" fixed>
	 *   <mt-tab-item :value="['传入数组', '也是可以的']">
	 *     <span slot="label">订单</span>
	 *   </mt-tab-item>
	 * </mt-navbar>
	 *
	 */
	/* harmony default export */ exports["default"] = {
	  name: 'mt-navbar',
	
	  props: {
	    fixed: Boolean,
	    value: {}
	  }
	};
	
	
	/***/ },
	/* 30 */
	/***/ function(module, exports, __webpack_require__) {
	
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	/* harmony default export */ exports["default"] = {
	  name: 'mt-palette-button',
	
	  data: function() {
	    return {
	      transforming: false,    // 是否正在执行动画
	      expanded: false           // 是否已经展开子按钮
	    };
	  },
	
	  props: {
	    content: {
	      type: String,
	      default: ''
	    },
	
	    offset: {
	      type: Number,           // 扇面偏移角，默认是四分之π，配合默认方向lt
	      default: Math.PI / 4
	    },
	
	    direction: {
	      type: String,
	      default: 'lt'           // lt t rt this.radius rb b lb l 取值有8个方向，左上、上、右上、右、右下、下、左下、左，默认为左上
	    },
	
	    radius: {
	      type: Number,
	      default: 90
	    },
	
	    mainButtonStyle: {
	      type: String,           // 应用到 mint-main-button 上的 class
	      default: ''
	    }
	  },
	  methods: {
	    toggle: function toggle(event) {
	      if (!this.transforming) {
	        if (this.expanded) {
	          this.collapse(event);
	        } else {
	          this.expand(event);
	        }
	      }
	    },
	
	    onMainAnimationEnd: function onMainAnimationEnd(event) {
	      this.transforming = false;
	      this.$emit('expanded');
	    },
	
	    expand: function expand(event) {
	      this.expanded = true;
	      this.transforming = true;
	      this.$emit('expand', event);
	    },
	
	    collapse: function collapse(event) {
	      this.expanded = false;
	      this.$emit('collapse', event);
	    }
	  },
	  mounted: function mounted() {
	    var this$1 = this;
	
	    this.slotChildren = [];
	    for (var i = 0; i < this.$slots.default.length; i++) {
	      if (this$1.$slots.default[i].elm.nodeType !== 3) {
	        this$1.slotChildren.push(this$1.$slots.default[i]);
	      }
	    }
	
	    var css = '';
	    var direction_arc = Math.PI * (3 + Math.max(['lt', 't', 'rt', 'r', 'rb', 'b', 'lb', 'l'].indexOf(this.direction), 0)) / 4;
	    for (var i$1 = 0; i$1 < this.slotChildren.length; i$1++) {
	      var arc = (Math.PI - this$1.offset * 2) / (this$1.slotChildren.length - 1) * i$1 + this$1.offset + direction_arc;
	      var x = (Math.cos(arc) * this$1.radius).toFixed(2);
	      var y = (Math.sin(arc) * this$1.radius).toFixed(2);
	      var item_css = '.expand .palette-button-' + this$1._uid + '-sub-' + i$1 + '{transform:translate(' + x + 'px,' + y + 'px) rotate(720deg);transition-delay:' + 0.03 * i$1 + 's}';
	      css += item_css;
	
	      this$1.slotChildren[i$1].elm.className += (' palette-button-' + this$1._uid + '-sub-' + i$1);
	    }
	
	    this.styleNode = document.createElement('style');
	    this.styleNode.type = 'text/css';
	    this.styleNode.rel = 'stylesheet';
	    this.styleNode.title = 'palette button style';
	    this.styleNode.appendChild(document.createTextNode(css));
	    document.getElementsByTagName('head')[0].appendChild(this.styleNode);
	  },
	
	  destroyed: function destroyed() {
	    if (this.styleNode) {
	      this.styleNode.parentNode.removeChild(this.styleNode);
	    }
	  }
	};
	
	
	/***/ },
	/* 31 */
	/***/ function(module, exports, __webpack_require__) {
	
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__draggable__ = __webpack_require__(73);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__translate__ = __webpack_require__(74);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mint_ui_src_utils_dom__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mint_ui_src_mixins_emitter__ = __webpack_require__(89);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue__);
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	
	
	if (!__WEBPACK_IMPORTED_MODULE_4_vue___default.a.prototype.$isServer) {
	  __webpack_require__(200);
	}
	
	var rotateElement = function(element, angle) {
	  if (!element) return;
	  var transformProperty = __WEBPACK_IMPORTED_MODULE_1__translate__["a" /* default */].transformProperty;
	
	  element.style[transformProperty] = element.style[transformProperty].replace(/rotateX\(.+?deg\)/gi, '') + " rotateX(" + angle + "deg)";
	};
	
	var ITEM_HEIGHT = 36;
	var VISIBLE_ITEMS_ANGLE_MAP = {
	  3: -45,
	  5: -20,
	  7: -15
	};
	
	/* harmony default export */ exports["default"] = {
	  name: 'picker-slot',
	
	  props: {
	    values: {
	      type: Array,
	      default: function default$1() {
	        return [];
	      }
	    },
	    value: {},
	    visibleItemCount: {
	      type: Number,
	      default: 5
	    },
	    valueKey: String,
	    rotateEffect: {
	      type: Boolean,
	      default: false
	    },
	    divider: {
	      type: Boolean,
	      default: false
	    },
	    textAlign: {
	      type: String,
	      default: 'center'
	    },
	    flex: {},
	    className: {},
	    content: {},
	    itemHeight: {
	      type: Number,
	      default: ITEM_HEIGHT
	    },
	    defaultIndex: {
	      type: Number,
	      default: 0,
	      require: false
	    }
	  },
	
	  data: function data() {
	    return {
	      currentValue: this.value,
	      mutatingValues: this.values,
	      dragging: false,
	      animationFrameId: null
	    };
	  },
	
	  mixins: [__WEBPACK_IMPORTED_MODULE_3_mint_ui_src_mixins_emitter__["a" /* default */]],
	
	  computed: {
	    flexStyle: function flexStyle() {
	      return {
	        'flex': this.flex,
	        '-webkit-box-flex': this.flex,
	        '-moz-box-flex': this.flex,
	        '-ms-flex': this.flex
	      };
	    },
	    classNames: function classNames() {
	      var PREFIX = 'picker-slot-';
	      var resultArray = [];
	
	      if (this.rotateEffect) {
	        resultArray.push(PREFIX + 'absolute');
	      }
	
	      var textAlign = this.textAlign || 'center';
	      resultArray.push(PREFIX + textAlign);
	
	      if (this.divider) {
	        resultArray.push(PREFIX + 'divider');
	      }
	
	      if (this.className) {
	        resultArray.push(this.className);
	      }
	
	      return resultArray.join(' ');
	    },
	    contentHeight: function contentHeight() {
	      return this.itemHeight * this.visibleItemCount;
	    },
	    valueIndex: function valueIndex() {
	      var this$1 = this;
	
	      var valueKey = this.valueKey;
	      if (this.currentValue instanceof Object) {
	        for (var i = 0, len = this.mutatingValues.length; i < len ; i++) {
	          if (this$1.currentValue[valueKey] === this$1.mutatingValues[i][valueKey]) {
	            return i;
	          }
	        }
	        return -1;
	      } else {
	        return this.mutatingValues.indexOf(this.currentValue);
	      }
	    },
	    dragRange: function dragRange() {
	      var values = this.mutatingValues;
	      var visibleItemCount = this.visibleItemCount;
	      var itemHeight = this.itemHeight;
	
	      return [ -itemHeight * (values.length - Math.ceil(visibleItemCount / 2)), itemHeight * Math.floor(visibleItemCount / 2) ];
	    },
	    minTranslateY: function minTranslateY() {
	      return this.itemHeight * (Math.ceil(this.visibleItemCount / 2) - this.mutatingValues.length);
	    },
	    maxTranslateY: function maxTranslateY() {
	      return this.itemHeight * Math.floor(this.visibleItemCount / 2);
	    }
	  },
	
	  methods: {
	    value2Translate: function value2Translate(value) {
	      var values = this.mutatingValues;
	      var valueIndex = values.indexOf(value);
	      var offset = Math.floor(this.visibleItemCount / 2);
	      var itemHeight = this.itemHeight;
	
	      if (valueIndex !== -1) {
	        return (valueIndex - offset) * -itemHeight;
	      }
	    },
	
	    translate2Value: function translate2Value(translate) {
	      var itemHeight = this.itemHeight;
	      translate = Math.round(translate / itemHeight) * itemHeight;
	      var index = -(translate - Math.floor(this.visibleItemCount / 2) * itemHeight) / itemHeight;
	
	      return this.mutatingValues[index];
	    },
	
	    updateRotate: function(currentTranslate, pickerItems) {
	      var this$1 = this;
	
	      if (this.divider) return;
	      var dragRange = this.dragRange;
	      var wrapper = this.$refs.wrapper;
	
	      if (!pickerItems) {
	        pickerItems = wrapper.querySelectorAll('.picker-item');
	      }
	
	      if (currentTranslate === undefined) {
	        currentTranslate = __WEBPACK_IMPORTED_MODULE_1__translate__["a" /* default */].getElementTranslate(wrapper).top;
	      }
	
	      var itemsFit = Math.ceil(this.visibleItemCount / 2);
	      var angleUnit = VISIBLE_ITEMS_ANGLE_MAP[this.visibleItemCount] || -20;
	
	      [].forEach.call(pickerItems, function (item, index) {
	        var itemOffsetTop = index * this$1.itemHeight;
	        var translateOffset = dragRange[1] - currentTranslate;
	        var itemOffset = itemOffsetTop - translateOffset;
	        var percentage = itemOffset / this$1.itemHeight;
	
	        var angle = angleUnit * percentage;
	        if (angle > 180) angle = 180;
	        if (angle < -180) angle = -180;
	
	        rotateElement(item, angle);
	
	        if (Math.abs(percentage) > itemsFit) {
	          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_mint_ui_src_utils_dom__["a" /* addClass */])(item, 'picker-item-far');
	        } else {
	          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_mint_ui_src_utils_dom__["b" /* removeClass */])(item, 'picker-item-far');
	        }
	      });
	    },
	
	    planUpdateRotate: function() {
	      var this$1 = this;
	
	      var el = this.$refs.wrapper;
	      cancelAnimationFrame(this.animationFrameId);
	
	      this.animationFrameId = requestAnimationFrame(function () {
	        this$1.updateRotate();
	      });
	
	      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_mint_ui_src_utils_dom__["c" /* once */])(el, __WEBPACK_IMPORTED_MODULE_1__translate__["a" /* default */].transitionEndProperty, function () {
	        cancelAnimationFrame(this$1.animationFrameId);
	        this$1.animationFrameId = null;
	      });
	    },
	
	    initEvents: function initEvents() {
	      var this$1 = this;
	
	      var el = this.$refs.wrapper;
	      var dragState = {};
	
	      var velocityTranslate, prevTranslate, pickerItems;
	
	      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__draggable__["a" /* default */])(el, {
	        start: function (event) {
	          cancelAnimationFrame(this$1.animationFrameId);
	          this$1.animationFrameId = null;
	          dragState = {
	            range: this$1.dragRange,
	            start: new Date(),
	            startLeft: event.pageX,
	            startTop: event.pageY,
	            startTranslateTop: __WEBPACK_IMPORTED_MODULE_1__translate__["a" /* default */].getElementTranslate(el).top
	          };
	          pickerItems = el.querySelectorAll('.picker-item');
	        },
	
	        drag: function (event) {
	          this$1.dragging = true;
	
	          dragState.left = event.pageX;
	          dragState.top = event.pageY;
	
	          var deltaY = dragState.top - dragState.startTop;
	          var translate = dragState.startTranslateTop + deltaY;
	
	          __WEBPACK_IMPORTED_MODULE_1__translate__["a" /* default */].translateElement(el, null, translate);
	
	          velocityTranslate = translate - prevTranslate || translate;
	
	          prevTranslate = translate;
	
	          if (this$1.rotateEffect) {
	            this$1.updateRotate(prevTranslate, pickerItems);
	          }
	        },
	
	        end: function (event) {
	          this$1.dragging = false;
	
	          var momentumRatio = 7;
	          var currentTranslate = __WEBPACK_IMPORTED_MODULE_1__translate__["a" /* default */].getElementTranslate(el).top;
	          var duration = new Date() - dragState.start;
	          var distance = Math.abs(dragState.startTranslateTop - currentTranslate);
	          var itemHeight = this$1.itemHeight;
	          var visibleItemCount = this$1.visibleItemCount;
	
	          var rect, offset;
	          if (distance < 6) {
	            rect = this$1.$el.getBoundingClientRect();
	            offset = Math.floor((event.clientY - (rect.top + (visibleItemCount - 1) * itemHeight / 2)) / itemHeight) * itemHeight;
	
	            if (offset > this$1.maxTranslateY) {
	              offset = this$1.maxTranslateY;
	            }
	
	            velocityTranslate = 0;
	            currentTranslate -= offset;
	          }
	
	          var momentumTranslate;
	          if (duration < 300) {
	            momentumTranslate = currentTranslate + velocityTranslate * momentumRatio;
	          }
	
	          var dragRange = dragState.range;
	
	          this$1.$nextTick(function () {
	            var translate;
	            if (momentumTranslate) {
	              translate = Math.round(momentumTranslate / itemHeight) * itemHeight;
	            } else {
	              translate = Math.round(currentTranslate / itemHeight) * itemHeight;
	            }
	
	            translate = Math.max(Math.min(translate, dragRange[1]), dragRange[0]);
	
	            __WEBPACK_IMPORTED_MODULE_1__translate__["a" /* default */].translateElement(el, null, translate);
	
	            this$1.currentValue = this$1.translate2Value(translate);
	
	            if (this$1.rotateEffect) {
	              this$1.planUpdateRotate();
	            }
	          });
	
	          dragState = {};
	        }
	      });
	    },
	
	    doOnValueChange: function doOnValueChange() {
	      var value = this.currentValue;
	      var wrapper = this.$refs.wrapper;
	
	      __WEBPACK_IMPORTED_MODULE_1__translate__["a" /* default */].translateElement(wrapper, null, this.value2Translate(value));
	    },
	
	    doOnValuesChange: function doOnValuesChange() {
	      var this$1 = this;
	
	      var el = this.$el;
	      var items = el.querySelectorAll('.picker-item');
	      [].forEach.call(items, function (item, index) {
	        __WEBPACK_IMPORTED_MODULE_1__translate__["a" /* default */].translateElement(item, null, this$1.itemHeight * index);
	      });
	      if (this.rotateEffect) {
	        this.planUpdateRotate();
	      }
	    }
	  },
	
	  mounted: function mounted() {
	    this.ready = true;
	
	    if (!this.divider) {
	      this.initEvents();
	      this.doOnValueChange();
	    }
	
	    if (this.rotateEffect) {
	      this.doOnValuesChange();
	    }
	  },
	
	  watch: {
	    values: function values(val) {
	      this.mutatingValues = val;
	    },
	
	    mutatingValues: function mutatingValues(val) {
	      var this$1 = this;
	
	      if (this.valueIndex === -1) {
	        this.currentValue = (val || [])[0];
	      }
	      if (this.rotateEffect) {
	        this.$nextTick(function () {
	          this$1.doOnValuesChange();
	        });
	      }
	    },
	    currentValue: function currentValue(val) {
	      this.doOnValueChange();
	      if (this.rotateEffect) {
	        this.planUpdateRotate();
	      }
	      this.$emit('input', val);
	      this.dispatch('picker', 'slotValueChange', this);
	    },
	    defaultIndex: function defaultIndex(val) {
	      if ((this.mutatingValues[val] !== undefined) && (this.mutatingValues.length >= val + 1)) {
	        this.currentValue = this.mutatingValues[val];
	      }
	    }
	  }
	};
	
	
	/***/ },
	/* 32 */
	/***/ function(module, exports, __webpack_require__) {
	
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	/* harmony default export */ exports["default"] = {
	  name: 'mt-picker',
	
	  componentName: 'picker',
	
	  props: {
	    slots: {
	      type: Array
	    },
	    showToolbar: {
	      type: Boolean,
	      default: false
	    },
	    visibleItemCount: {
	      type: Number,
	      default: 5
	    },
	    valueKey: String,
	    rotateEffect: {
	      type: Boolean,
	      default: false
	    },
	    itemHeight: {
	      type: Number,
	      default: 36
	    }
	  },
	
	  created: function created() {
	    this.$on('slotValueChange', this.slotValueChange);
	    this.slotValueChange();
	  },
	
	  methods: {
	    slotValueChange: function slotValueChange() {
	      this.$emit('change', this, this.values);
	    },
	
	    getSlot: function getSlot(slotIndex) {
	      var slots = this.slots || [];
	      var count = 0;
	      var target;
	      var children = this.$children.filter(function (child) { return child.$options.name === 'picker-slot'; });
	
	      slots.forEach(function(slot, index) {
	        if (!slot.divider) {
	          if (slotIndex === count) {
	            target = children[index];
	          }
	          count++;
	        }
	      });
	
	      return target;
	    },
	    getSlotValue: function getSlotValue(index) {
	      var slot = this.getSlot(index);
	      if (slot) {
	        return slot.currentValue;
	      }
	      return null;
	    },
	    setSlotValue: function setSlotValue(index, value) {
	      var slot = this.getSlot(index);
	      if (slot) {
	        slot.currentValue = value;
	      }
	    },
	    getSlotValues: function getSlotValues(index) {
	      var slot = this.getSlot(index);
	      if (slot) {
	        return slot.mutatingValues;
	      }
	      return null;
	    },
	    setSlotValues: function setSlotValues(index, values) {
	      var slot = this.getSlot(index);
	      if (slot) {
	        slot.mutatingValues = values;
	      }
	    },
	    getValues: function getValues() {
	      return this.values;
	    },
	    setValues: function setValues(values) {
	      var this$1 = this;
	
	      var slotCount = this.slotCount;
	      values = values || [];
	      if (slotCount !== values.length) {
	        throw new Error('values length is not equal slot count.');
	      }
	      values.forEach(function (value, index) {
	        this$1.setSlotValue(index, value);
	      });
	    }
	  },
	
	  computed: {
	    values: {
	      get: function get() {
	        var slots = this.slots || [];
	        var values = [];
	        var valueIndexCount = 0;
	        slots.forEach(function (slot) {
	          if (!slot.divider) {
	            slot.valueIndex = valueIndexCount++;
	            values[slot.valueIndex] = (slot.values || [])[slot.defaultIndex || 0];
	          }
	        });
	        return values;
	      }
	    },
	    slotCount: function slotCount() {
	      var slots = this.slots || [];
	      var result = 0;
	      slots.forEach(function(slot) {
	        if (!slot.divider) result++;
	      });
	      return result;
	    }
	  },
	
	  components: {
	    PickerSlot: __webpack_require__(144)
	  }
	};
	
	
	/***/ },
	/* 33 */
	/***/ function(module, exports, __webpack_require__) {
	
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mint_ui_src_utils_popup__ = __webpack_require__(6);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue__);
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	if (!__WEBPACK_IMPORTED_MODULE_1_vue___default.a.prototype.$isServer) {
	  __webpack_require__(12);
	}
	
	/* harmony default export */ exports["default"] = {
	  name: 'mt-popup',
	
	  mixins: [__WEBPACK_IMPORTED_MODULE_0_mint_ui_src_utils_popup__["a" /* default */]],
	
	  props: {
	    modal: {
	      default: true
	    },
	
	    modalFade: {
	      default: false
	    },
	
	    lockScroll: {
	      default: false
	    },
	
	    closeOnClickModal: {
	      default: true
	    },
	
	    popupTransition: {
	      type: String,
	      default: 'popup-slide'
	    },
	
	    position: {
	      type: String,
	      default: ''
	    }
	  },
	
	  data: function data() {
	    return {
	      currentValue: false,
	      currentTransition: this.popupTransition
	    };
	  },
	
	  watch: {
	    currentValue: function currentValue(val) {
	      this.$emit('input', val);
	    },
	
	    value: function value(val) {
	      this.currentValue = val;
	    }
	  },
	
	  beforeMount: function beforeMount() {
	    if (this.popupTransition !== 'popup-fade') {
	      this.currentTransition = "popup-slide-" + (this.position);
	    }
	  },
	
	  mounted: function mounted() {
	    if (this.value) {
	      this.rendered = true;
	      this.currentValue = true;
	      this.open();
	    }
	  }
	};
	
	
	/***/ },
	/* 34 */
	/***/ function(module, exports, __webpack_require__) {
	
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	/* harmony default export */ exports["default"] = {
	  name: 'mt-progress',
	
	  props: {
	    value: Number,
	    barHeight: {
	      type: Number,
	      default: 3
	    }
	  }
	};
	
	
	/***/ },
	/* 35 */
	/***/ function(module, exports, __webpack_require__) {
	
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mint_ui_packages_cell_index_js__ = __webpack_require__(2);
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	if (false) {
	  require('mint-ui/packages/cell/style.css');
	}
	/**
	 * mt-radio
	 * @module components/radio
	 * @desc 单选框列表，依赖 cell 组件
	 *
	 * @param {string[], object[]} options - 选项数组，可以传入 [{label: 'label', value: 'value', disabled: true}] 或者 ['ab', 'cd', 'ef']
	 * @param {string} value - 选中值
	 * @param {string} title - 标题
	 * @param {string} [align=left] - checkbox 对齐位置，`left`, `right`
	 *
	 * @example
	 * <mt-radio v-model="value" :options="['a', 'b', 'c']"></mt-radio>
	 */
	/* harmony default export */ exports["default"] = {
	  name: 'mt-radio',
	
	  props: {
	    title: String,
	    align: String,
	    options: {
	      type: Array,
	      required: true
	    },
	    value: String
	  },
	
	  data: function data() {
	    return {
	      currentValue: this.value
	    };
	  },
	
	  watch: {
	    value: function value(val) {
	      this.currentValue = val;
	    },
	
	    currentValue: function currentValue(val) {
	      this.$emit('input', val);
	    }
	  },
	
	  components: {
	    XCell: __WEBPACK_IMPORTED_MODULE_0_mint_ui_packages_cell_index_js__["a" /* default */]
	  }
	};
	
	
	/***/ },
	/* 36 */
	/***/ function(module, exports, __webpack_require__) {
	
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__draggable__ = __webpack_require__(78);
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	/* harmony default export */ exports["default"] = {
	  name: 'mt-range',
	
	  props: {
	    min: {
	      type: Number,
	      default: 0
	    },
	    max: {
	      type: Number,
	      default: 100
	    },
	    step: {
	      type: Number,
	      default: 1
	    },
	    disabled: {
	      type: Boolean,
	      default: false
	    },
	    value: {
	      type: Number
	    },
	    barHeight: {
	      type: Number,
	      default: 1
	    }
	  },
	
	  computed: {
	    progress: function progress() {
	      var value = this.value;
	      if (typeof value === 'undefined' || value === null) return 0;
	      return Math.floor((value - this.min) / (this.max - this.min) * 100);
	    }
	  },
	
	  mounted: function mounted() {
	    var this$1 = this;
	
	    var thumb = this.$refs.thumb;
	    var content = this.$refs.content;
	
	    var getThumbPosition = function () {
	      var contentBox = content.getBoundingClientRect();
	      var thumbBox = thumb.getBoundingClientRect();
	      return {
	        left: thumbBox.left - contentBox.left,
	        top: thumbBox.top - contentBox.top,
	        thumbBoxLeft: thumbBox.left
	      };
	    };
	
	    var dragState = {};
	    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__draggable__["a" /* default */])(thumb, {
	      start: function (event) {
	        if (this$1.disabled) return;
	        var position = getThumbPosition();
	        var thumbClickDetalX = event.clientX - position.thumbBoxLeft;
	        dragState = {
	          thumbStartLeft: position.left,
	          thumbStartTop: position.top,
	          thumbClickDetalX: thumbClickDetalX
	        };
	      },
	      drag: function (event) {
	        if (this$1.disabled) return;
	        var contentBox = content.getBoundingClientRect();
	        var deltaX = event.pageX - contentBox.left - dragState.thumbStartLeft - dragState.thumbClickDetalX;
	        var stepCount = Math.ceil((this$1.max - this$1.min) / this$1.step);
	        var newPosition = (dragState.thumbStartLeft + deltaX) - (dragState.thumbStartLeft + deltaX) % (contentBox.width / stepCount);
	
	        var newProgress = newPosition / contentBox.width;
	
	        if (newProgress < 0) {
	          newProgress = 0;
	        } else if (newProgress > 1) {
	          newProgress = 1;
	        }
	
	        this$1.$emit('input', Math.round(this$1.min + newProgress * (this$1.max - this$1.min)));
	      },
	      end: function () {
	        if (this$1.disabled) return;
	        this$1.$emit('change', this$1.value);
	        dragState = {};
	      }
	    });
	  }
	};
	
	
	/***/ },
	/* 37 */
	/***/ function(module, exports, __webpack_require__) {
	
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mint_ui_packages_cell_index_js__ = __webpack_require__(2);
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	if (false) {
	  require('mint-ui/packages/cell/style.css');
	}
	
	/**
	 * mt-search
	 * @module components/search
	 * @desc 搜索框
	 * @param {string} value - 绑定值
	 * @param {string} [cancel-text=取消] - 取消按钮文字
	 * @param {string} [placeholder=取消] - 搜索框占位内容
	 * @param {boolean} [autofocus=false] - 自动 focus
	 * @param {boolean} [show=false] - 始终显示列表
	 * @param {string[]} [result] - 结果列表
	 * @param {slot} 结果列表
	 *
	 * @example
	 * <mt-search :value.sync="value" :result.sync="result"></mt-search>
	 * <mt-search :value.sync="value">
	 *   <mt-cell v-for="item in result" :title="item"></mt-cell>
	 * </mt-search>
	 */
	/* harmony default export */ exports["default"] = {
	  name: 'mt-search',
	
	  data: function data() {
	    return {
	      visible: false,
	      currentValue: this.value
	    };
	  },
	
	  components: { XCell: __WEBPACK_IMPORTED_MODULE_0_mint_ui_packages_cell_index_js__["a" /* default */] },
	
	  watch: {
	    currentValue: function currentValue(val) {
	      this.$emit('input', val);
	    },
	
	    value: function value(val) {
	      this.currentValue = val;
	    }
	  },
	
	  props: {
	    value: String,
	    autofocus: Boolean,
	    show: Boolean,
	    cancelText: {
	      default: '取消'
	    },
	    placeholder: {
	      default: '搜索'
	    },
	    result: Array
	  },
	
	  mounted: function mounted() {
	    this.autofocus && this.$refs.input.focus();
	  }
	};
	
	
	/***/ },
	/* 38 */
	/***/ function(module, exports, __webpack_require__) {
	
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	//
	//
	//
	//
	
	var SPINNERS = [
	  'snake',
	  'double-bounce',
	  'triple-bounce',
	  'fading-circle'
	];
	var parseSpinner = function(index) {
	  if ({}.toString.call(index) === '[object Number]') {
	    if (SPINNERS.length <= index) {
	      console.warn(("'" + index + "' spinner not found, use the default spinner."));
	      index = 0;
	    }
	    return SPINNERS[index];
	  }
	
	  if (SPINNERS.indexOf(index) === -1) {
	    console.warn(("'" + index + "' spinner not found, use the default spinner."));
	    index = SPINNERS[0];
	  }
	  return index;
	};
	
	/**
	 * mt-spinner
	 * @module components/spinner
	 * @desc 加载动画
	 * @param {(string|number)} [type=snake] - 显示类型，传入类型名或者类型 id，可选 `snake`, `dobule-bounce`, `triple-bounce`, `fading-circle`
	 * @param {number} size - 尺寸
	 * @param {string} color - 颜色
	 *
	 * @example
	 * <mt-spinner type="snake"></mt-spinner>
	 *
	 * <!-- double-bounce -->
	 * <mt-spinner :type="1"></mt-spinner>
	 *
	 * <!-- default snake -->
	 * <mt-spinner :size="30" color="#999"></mt-spinner>
	 */
	/* harmony default export */ exports["default"] = {
	  name: 'mt-spinner',
	
	  computed: {
	    spinner: function spinner() {
	      return ("spinner-" + (parseSpinner(this.type)));
	    }
	  },
	
	  components: {
	    SpinnerSnake: __webpack_require__(153),
	    SpinnerDoubleBounce: __webpack_require__(152),
	    SpinnerTripleBounce: __webpack_require__(154),
	    SpinnerFadingCircle: __webpack_require__(13)
	  },
	
	  props: {
	    type: {
	      default: 0
	    },
	    size: {
	      type: Number,
	      default: 28
	    },
	    color: {
	      type: String,
	      default: '#ccc'
	    }
	  }
	};
	
	
	/***/ },
	/* 39 */
	/***/ function(module, exports, __webpack_require__) {
	
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	
	/* harmony default export */ exports["default"] = {
	  computed: {
	    spinnerColor: function spinnerColor() {
	      return this.color || this.$parent.color || '#ccc';
	    },
	
	    spinnerSize: function spinnerSize() {
	      return (this.size || this.$parent.size || 28) + 'px';
	    }
	  },
	
	  props: {
	    size: Number,
	    color: String
	  }
	};
	
	
	/***/ },
	/* 40 */
	/***/ function(module, exports, __webpack_require__) {
	
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_vue__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__common_vue__);
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	/* harmony default export */ exports["default"] = {
	  name: 'double-bounce',
	
	  mixins: [__WEBPACK_IMPORTED_MODULE_0__common_vue___default.a]
	};
	
	
	/***/ },
	/* 41 */
	/***/ function(module, exports, __webpack_require__) {
	
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_vue__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__common_vue__);
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	/* harmony default export */ exports["default"] = {
	  name: 'fading-circle',
	
	  mixins: [__WEBPACK_IMPORTED_MODULE_0__common_vue___default.a],
	
	  created: function created() {
	    if (this.$isServer) return;
	    this.styleNode = document.createElement('style');
	    var css = ".circle-color-" + (this._uid) + " > div::before { background-color: " + (this.spinnerColor) + "; }";
	
	    this.styleNode.type = 'text/css';
	    this.styleNode.rel = 'stylesheet';
	    this.styleNode.title = 'fading circle style';
	    document.getElementsByTagName('head')[0].appendChild(this.styleNode);
	    this.styleNode.appendChild(document.createTextNode(css));
	  },
	
	  destroyed: function destroyed() {
	    if (this.styleNode) {
	      this.styleNode.parentNode.removeChild(this.styleNode);
	    }
	  }
	};
	
	
	/***/ },
	/* 42 */
	/***/ function(module, exports, __webpack_require__) {
	
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_vue__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__common_vue__);
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	/* harmony default export */ exports["default"] = {
	  name: 'snake',
	
	  mixins: [__WEBPACK_IMPORTED_MODULE_0__common_vue___default.a]
	};
	
	
	/***/ },
	/* 43 */
	/***/ function(module, exports, __webpack_require__) {
	
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_vue__ = __webpack_require__(5);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__common_vue__);
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	/* harmony default export */ exports["default"] = {
	  name: 'triple-bounce',
	
	  mixins: [__WEBPACK_IMPORTED_MODULE_0__common_vue___default.a],
	
	  computed: {
	    spinnerSize: function spinnerSize() {
	      return ((this.size || this.$parent.size || 28) / 3) + 'px';
	    },
	
	    bounceStyle: function bounceStyle() {
	      return {
	        width: this.spinnerSize,
	        height: this.spinnerSize,
	        backgroundColor: this.spinnerColor
	      };
	    }
	  }
	};
	
	
	/***/ },
	/* 44 */
	/***/ function(module, exports, __webpack_require__) {
	
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	//
	//
	//
	//
	//
	//
	
	/* harmony default export */ exports["default"] = {
	  name: 'mt-swipe-item',
	
	  mounted: function mounted() {
	    this.$parent && this.$parent.swipeItemCreated(this);
	  },
	
	  destroyed: function destroyed() {
	    this.$parent && this.$parent.swipeItemDestroyed(this);
	  }
	};
	
	
	/***/ },
	/* 45 */
	/***/ function(module, exports, __webpack_require__) {
	
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mint_ui_src_utils_dom__ = __webpack_require__(3);
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	/* harmony default export */ exports["default"] = {
	  name: 'mt-swipe',
	
	  created: function created() {
	    this.dragState = {};
	  },
	
	  data: function data() {
	    return {
	      ready: false,
	      dragging: false,
	      userScrolling: false,
	      animating: false,
	      index: 0,
	      pages: [],
	      timer: null,
	      reInitTimer: null,
	      noDrag: false,
	      isDone: false
	    };
	  },
	
	  props: {
	    speed: {
	      type: Number,
	      default: 300
	    },
	
	    defaultIndex: {
	      type: Number,
	      default: 0
	    },
	
	    auto: {
	      type: Number,
	      default: 3000
	    },
	
	    continuous: {
	      type: Boolean,
	      default: true
	    },
	
	    showIndicators: {
	      type: Boolean,
	      default: true
	    },
	
	    noDragWhenSingle: {
	      type: Boolean,
	      default: true
	    },
	
	    prevent: {
	      type: Boolean,
	      default: false
	    },
	
	    stopPropagation: {
	      type: Boolean,
	      default: false
	    }
	  },
	
	  watch: {
	    index: function index(newIndex) {
	      this.$emit('change', newIndex);
	    }
	  },
	
	  methods: {
	    swipeItemCreated: function swipeItemCreated() {
	      var this$1 = this;
	
	      if (!this.ready) return;
	
	      clearTimeout(this.reInitTimer);
	      this.reInitTimer = setTimeout(function () {
	        this$1.reInitPages();
	      }, 100);
	    },
	
	    swipeItemDestroyed: function swipeItemDestroyed() {
	      var this$1 = this;
	
	      if (!this.ready) return;
	
	      clearTimeout(this.reInitTimer);
	      this.reInitTimer = setTimeout(function () {
	        this$1.reInitPages();
	      }, 100);
	    },
	
	    rafTranslate: function rafTranslate(element, initOffset, offset, callback, nextElement) {
	      var ALPHA = 0.88;
	      this.animating = true;
	      var _offset = initOffset;
	      var raf = 0;
	
	      function animationLoop() {
	        if (Math.abs(_offset - offset) < 0.5) {
	          this.animating = false;
	          _offset = offset;
	          element.style.webkitTransform = '';
	          if (nextElement) {
	            nextElement.style.webkitTransform = '';
	          }
	          cancelAnimationFrame(raf);
	
	          if (callback) {
	            callback();
	          }
	
	          return;
	        }
	
	        _offset = ALPHA * _offset + (1.0 - ALPHA) * offset;
	        element.style.webkitTransform = "translate3d(" + _offset + "px, 0, 0)";
	
	        if (nextElement) {
	          nextElement.style.webkitTransform = "translate3d(" + (_offset - offset) + "px, 0, 0)";
	        }
	
	        raf = requestAnimationFrame(animationLoop.bind(this));
	      }
	
	      animationLoop.call(this);
	    },
	
	    translate: function translate(element, offset, speed, callback) {
	      var arguments$1 = arguments;
	      var this$1 = this;
	
	      if (speed) {
	        this.animating = true;
	        element.style.webkitTransition = '-webkit-transform ' + speed + 'ms ease-in-out';
	        setTimeout(function () {
	          element.style.webkitTransform = "translate3d(" + offset + "px, 0, 0)";
	        }, 50);
	
	        var called = false;
	
	        var transitionEndCallback = function () {
	          if (called) return;
	          called = true;
	          this$1.animating = false;
	          element.style.webkitTransition = '';
	          element.style.webkitTransform = '';
	          if (callback) {
	            callback.apply(this$1, arguments$1);
	          }
	        };
	
	        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_mint_ui_src_utils_dom__["c" /* once */])(element, 'webkitTransitionEnd', transitionEndCallback);
	        setTimeout(transitionEndCallback, speed + 100); // webkitTransitionEnd maybe not fire on lower version android.
	      } else {
	        element.style.webkitTransition = '';
	        element.style.webkitTransform = "translate3d(" + offset + "px, 0, 0)";
	      }
	    },
	
	    reInitPages: function reInitPages() {
	      var children = this.$children;
	      this.noDrag = children.length === 1 && this.noDragWhenSingle;
	
	      var pages = [];
	      var intDefaultIndex = Math.floor(this.defaultIndex);
	      var defaultIndex = (intDefaultIndex >= 0 && intDefaultIndex < children.length) ? intDefaultIndex : 0;
	      this.index = defaultIndex;
	
	      children.forEach(function(child, index) {
	        pages.push(child.$el);
	
	        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_mint_ui_src_utils_dom__["b" /* removeClass */])(child.$el, 'is-active');
	
	        if (index === defaultIndex) {
	          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_mint_ui_src_utils_dom__["a" /* addClass */])(child.$el, 'is-active');
	        }
	      });
	
	      this.pages = pages;
	    },
	
	    doAnimate: function doAnimate(towards, options) {
	      var this$1 = this;
	
	      if (this.$children.length === 0) return;
	      if (!options && this.$children.length < 2) return;
	
	      var prevPage, nextPage, currentPage, pageWidth, offsetLeft, speedX;
	      var speed = this.speed || 300;
	      var index = this.index;
	      var pages = this.pages;
	      var pageCount = pages.length;
	
	      if (!options) {
	        pageWidth = this.$el.clientWidth;
	        currentPage = pages[index];
	        prevPage = pages[index - 1];
	        nextPage = pages[index + 1];
	        if (this.continuous && pages.length > 1) {
	          if (!prevPage) {
	            prevPage = pages[pages.length - 1];
	          }
	          if (!nextPage) {
	            nextPage = pages[0];
	          }
	        }
	        if (prevPage) {
	          prevPage.style.display = 'block';
	          this.translate(prevPage, -pageWidth);
	        }
	        if (nextPage) {
	          nextPage.style.display = 'block';
	          this.translate(nextPage, pageWidth);
	        }
	      } else {
	        prevPage = options.prevPage;
	        currentPage = options.currentPage;
	        nextPage = options.nextPage;
	        pageWidth = options.pageWidth;
	        offsetLeft = options.offsetLeft;
	        speedX = options.speedX;
	      }
	
	      var newIndex;
	
	      var oldPage = this.$children[index].$el;
	
	      if (towards === 'prev') {
	        if (index > 0) {
	          newIndex = index - 1;
	        }
	        if (this.continuous && index === 0) {
	          newIndex = pageCount - 1;
	        }
	      } else if (towards === 'next') {
	        if (index < pageCount - 1) {
	          newIndex = index + 1;
	        }
	        if (this.continuous && index === pageCount - 1) {
	          newIndex = 0;
	        }
	      }
	
	      var callback = function () {
	        if (newIndex !== undefined) {
	          var newPage = this$1.$children[newIndex].$el;
	          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_mint_ui_src_utils_dom__["b" /* removeClass */])(oldPage, 'is-active');
	          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_mint_ui_src_utils_dom__["a" /* addClass */])(newPage, 'is-active');
	
	          this$1.index = newIndex;
	        }
	        if (this$1.isDone) {
	          this$1.end();
	        }
	
	        if (prevPage) {
	          prevPage.style.display = '';
	        }
	
	        if (nextPage) {
	          nextPage.style.display = '';
	        }
	      };
	
	      setTimeout(function () {
	        if (towards === 'next') {
	          this$1.isDone = true;
	          this$1.before(currentPage);
	          if (speedX) {
	            this$1.rafTranslate(currentPage, offsetLeft, -pageWidth, callback, nextPage);
	          } else {
	            this$1.translate(currentPage, -pageWidth, speed, callback);
	            if (nextPage) {
	              this$1.translate(nextPage, 0, speed);
	            }
	          }
	        } else if (towards === 'prev') {
	          this$1.isDone = true;
	          this$1.before(currentPage);
	          if (speedX) {
	            this$1.rafTranslate(currentPage, offsetLeft, pageWidth, callback, prevPage);
	          } else {
	            this$1.translate(currentPage, pageWidth, speed, callback);
	            if (prevPage) {
	              this$1.translate(prevPage, 0, speed);
	            }
	          }
	        } else {
	          this$1.isDone = false;
	          this$1.translate(currentPage, 0, speed, callback);
	          if (typeof offsetLeft !== 'undefined') {
	            if (prevPage && offsetLeft > 0) {
	              this$1.translate(prevPage, pageWidth * -1, speed);
	            }
	            if (nextPage && offsetLeft < 0) {
	              this$1.translate(nextPage, pageWidth, speed);
	            }
	          } else {
	            if (prevPage) {
	              this$1.translate(prevPage, pageWidth * -1, speed);
	            }
	            if (nextPage) {
	              this$1.translate(nextPage, pageWidth, speed);
	            }
	          }
	        }
	      }, 10);
	    },
	
	    next: function next() {
	      this.doAnimate('next');
	    },
	
	    prev: function prev() {
	      this.doAnimate('prev');
	    },
	
	    before: function before() {
	      this.$emit('before', this.index);
	    },
	
	    end: function end() {
	      this.$emit('end', this.index);
	    },
	
	    doOnTouchStart: function doOnTouchStart(event) {
	      if (this.noDrag) return;
	
	      var element = this.$el;
	      var dragState = this.dragState;
	      var touch = event.touches[0];
	
	      dragState.startTime = new Date();
	      dragState.startLeft = touch.pageX;
	      dragState.startTop = touch.pageY;
	      dragState.startTopAbsolute = touch.clientY;
	
	      dragState.pageWidth = element.offsetWidth;
	      dragState.pageHeight = element.offsetHeight;
	
	      var prevPage = this.$children[this.index - 1];
	      var dragPage = this.$children[this.index];
	      var nextPage = this.$children[this.index + 1];
	
	      if (this.continuous && this.pages.length > 1) {
	        if (!prevPage) {
	          prevPage = this.$children[this.$children.length - 1];
	        }
	        if (!nextPage) {
	          nextPage = this.$children[0];
	        }
	      }
	
	      dragState.prevPage = prevPage ? prevPage.$el : null;
	      dragState.dragPage = dragPage ? dragPage.$el : null;
	      dragState.nextPage = nextPage ? nextPage.$el : null;
	
	      if (dragState.prevPage) {
	        dragState.prevPage.style.display = 'block';
	      }
	
	      if (dragState.nextPage) {
	        dragState.nextPage.style.display = 'block';
	      }
	    },
	
	    doOnTouchMove: function doOnTouchMove(event) {
	      if (this.noDrag) return;
	
	      var dragState = this.dragState;
	      var touch = event.touches[0];
	
	      dragState.speedX = touch.pageX - dragState.currentLeft;
	      dragState.currentLeft = touch.pageX;
	      dragState.currentTop = touch.pageY;
	      dragState.currentTopAbsolute = touch.clientY;
	
	      var offsetLeft = dragState.currentLeft - dragState.startLeft;
	      var offsetTop = dragState.currentTopAbsolute - dragState.startTopAbsolute;
	
	      var distanceX = Math.abs(offsetLeft);
	      var distanceY = Math.abs(offsetTop);
	      if (distanceX < 5 || (distanceX >= 5 && distanceY >= 1.73 * distanceX)) {
	        this.userScrolling = true;
	        return;
	      } else {
	        this.userScrolling = false;
	        event.preventDefault();
	      }
	      offsetLeft = Math.min(Math.max(-dragState.pageWidth + 1, offsetLeft), dragState.pageWidth - 1);
	
	      var towards = offsetLeft < 0 ? 'next' : 'prev';
	
	      if (dragState.prevPage && towards === 'prev') {
	        this.translate(dragState.prevPage, offsetLeft - dragState.pageWidth);
	      }
	      this.translate(dragState.dragPage, offsetLeft);
	      if (dragState.nextPage && towards === 'next') {
	        this.translate(dragState.nextPage, offsetLeft + dragState.pageWidth);
	      }
	    },
	
	    doOnTouchEnd: function doOnTouchEnd() {
	      if (this.noDrag) return;
	
	      var dragState = this.dragState;
	
	      var dragDuration = new Date() - dragState.startTime;
	      var towards = null;
	
	      var offsetLeft = dragState.currentLeft - dragState.startLeft;
	      var offsetTop = dragState.currentTop - dragState.startTop;
	      var pageWidth = dragState.pageWidth;
	      var index = this.index;
	      var pageCount = this.pages.length;
	
	      if (dragDuration < 300) {
	        var fireTap = Math.abs(offsetLeft) < 5 && Math.abs(offsetTop) < 5;
	        if (isNaN(offsetLeft) || isNaN(offsetTop)) {
	          fireTap = true;
	        }
	        if (fireTap) {
	          this.$children[this.index].$emit('tap');
	        }
	      }
	
	      if (dragDuration < 300 && dragState.currentLeft === undefined) return;
	
	      if (dragDuration < 300 || Math.abs(offsetLeft) > pageWidth / 2) {
	        towards = offsetLeft < 0 ? 'next' : 'prev';
	      }
	
	      if (!this.continuous) {
	        if ((index === 0 && towards === 'prev') || (index === pageCount - 1 && towards === 'next')) {
	          towards = null;
	        }
	      }
	
	      if (this.$children.length < 2) {
	        towards = null;
	      }
	
	      this.doAnimate(towards, {
	        offsetLeft: offsetLeft,
	        pageWidth: dragState.pageWidth,
	        prevPage: dragState.prevPage,
	        currentPage: dragState.dragPage,
	        nextPage: dragState.nextPage,
	        speedX: dragState.speedX
	      });
	
	      this.dragState = {};
	    },
	
	    initTimer: function initTimer() {
	      var this$1 = this;
	
	      if (this.auto > 0 && !this.timer) {
	        this.timer = setInterval(function () {
	          if (!this$1.continuous && (this$1.index >= this$1.pages.length - 1)) {
	            return this$1.clearTimer();
	          }
	          if (!this$1.dragging && !this$1.animating) {
	            this$1.next();
	          }
	        }, this.auto);
	      }
	    },
	
	    clearTimer: function clearTimer() {
	      clearInterval(this.timer);
	      this.timer = null;
	    }
	  },
	
	  destroyed: function destroyed() {
	    if (this.timer) {
	      this.clearTimer();
	    }
	    if (this.reInitTimer) {
	      clearTimeout(this.reInitTimer);
	      this.reInitTimer = null;
	    }
	  },
	
	  mounted: function mounted() {
	    var this$1 = this;
	
	    this.ready = true;
	
	    this.initTimer();
	
	    this.reInitPages();
	
	    var element = this.$el;
	
	    element.addEventListener('touchstart', function (event) {
	      if (this$1.prevent) event.preventDefault();
	      if (this$1.stopPropagation) event.stopPropagation();
	      if (this$1.animating) return;
	      this$1.dragging = true;
	      this$1.userScrolling = false;
	      this$1.doOnTouchStart(event);
	    });
	
	    element.addEventListener('touchmove', function (event) {
	      if (!this$1.dragging) return;
	      if (this$1.timer) this$1.clearTimer();
	      this$1.doOnTouchMove(event);
	    });
	
	    element.addEventListener('touchend', function (event) {
	      if (this$1.userScrolling) {
	        this$1.dragging = false;
	        this$1.dragState = {};
	        return;
	      }
	      if (!this$1.dragging) return;
	      this$1.initTimer();
	      this$1.doOnTouchEnd(event);
	      this$1.dragging = false;
	    });
	  }
	};
	
	
	/***/ },
	/* 46 */
	/***/ function(module, exports, __webpack_require__) {
	
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	//
	//
	//
	//
	//
	//
	//
	//
	
	/**
	 * mt-switch
	 * @module components/switch
	 * @desc 切换按钮
	 * @param {boolean} [value] - 绑定值，支持双向绑定
	 * @param {slot} - 显示内容
	 *
	 * @example
	 * <mt-switch v-model="value"></mt-switch>
	 */
	/* harmony default export */ exports["default"] = {
	  name: 'mt-switch',
	
	  props: {
	    value: Boolean,
	    disabled: {
	      type: Boolean,
	      default: false
	    }
	  },
	  computed: {
	    currentValue: {
	      get: function get() {
	        return this.value;
	      },
	      set: function set(val) {
	        this.$emit('input', val);
	      }
	    }
	  }
	};
	
	
	/***/ },
	/* 47 */
	/***/ function(module, exports, __webpack_require__) {
	
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	//
	//
	//
	//
	//
	//
	//
	//
	
	/**
	 * mt-tab-container-item
	 * @desc 搭配 tab-container 使用
	 * @module components/tab-container-item
	 *
	 * @param {number|string} [id] - 该项的 id
	 *
	 * @example
	 * <mt-tab-container v-model="selected">
	 *   <mt-tab-container-item id="1"> 内容A </mt-tab-container-item>
	 *   <mt-tab-container-item id="2"> 内容B </mt-tab-container-item>
	 *   <mt-tab-container-item id="3"> 内容C </mt-tab-container-item>
	 * </mt-tab-container>
	 */
	/* harmony default export */ exports["default"] = {
	  name: 'mt-tab-container-item',
	
	  props: ['id']
	};
	
	
	/***/ },
	/* 48 */
	/***/ function(module, exports, __webpack_require__) {
	
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mint_ui_src_utils_dom__ = __webpack_require__(3);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_array_find_index__ = __webpack_require__(199);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_array_find_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_array_find_index__);
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	
	
	
	/**
	 * mt-tab-container
	 * @desc 面板，搭配 tab-container-item 使用
	 * @module components/tab-container
	 *
	 * @param {number|string} [value] - 当前激活的 tabId
	 *
	 * @example
	 * <mt-tab-container v-model="selected">
	 *   <mt-tab-container-item id="1"> 内容A </mt-tab-container-item>
	 *   <mt-tab-container-item id="2"> 内容B </mt-tab-container-item>
	 *   <mt-tab-container-item id="3"> 内容C </mt-tab-container-item>
	 * </mt-tab-container>
	 */
	/* harmony default export */ exports["default"] = {
	  name: 'mt-tab-container',
	
	  props: {
	    value: {},
	    swipeable: Boolean
	  },
	
	  data: function data() {
	    return {
	      start: { x: 0, y: 0 },
	      swiping: false,
	      activeItems: [],
	      pageWidth: 0,
	      currentActive: this.value
	    };
	  },
	
	  watch: {
	    value: function value(val) {
	      this.currentActive = val;
	    },
	
	    currentActive: function currentActive(val, oldValue) {
	      this.$emit('input', val);
	      if (!this.swipeable) return;
	      var lastIndex = __WEBPACK_IMPORTED_MODULE_1_array_find_index___default()(this.$children,
	        function (item) { return item.id === oldValue; });
	      this.swipeLeaveTransition(lastIndex);
	    }
	  },
	
	  mounted: function mounted() {
	    if (!this.swipeable) return;
	
	    this.wrap = this.$refs.wrap;
	    this.pageWidth = this.wrap.clientWidth;
	    this.limitWidth = this.pageWidth / 4;
	  },
	
	  methods: {
	    swipeLeaveTransition: function swipeLeaveTransition(lastIndex) {
	      var this$1 = this;
	      if ( lastIndex === void 0 ) lastIndex = 0;
	
	      if (typeof this.index !== 'number') {
	        this.index = __WEBPACK_IMPORTED_MODULE_1_array_find_index___default()(this.$children,
	          function (item) { return item.id === this$1.currentActive; });
	        this.swipeMove(-lastIndex * this.pageWidth);
	      }
	
	      setTimeout(function () {
	        this$1.wrap.classList.add('swipe-transition');
	        this$1.swipeMove(-this$1.index * this$1.pageWidth);
	
	        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_mint_ui_src_utils_dom__["c" /* once */])(this$1.wrap, 'webkitTransitionEnd', function (_) {
	          this$1.wrap.classList.remove('swipe-transition');
	          this$1.wrap.style.webkitTransform = '';
	          this$1.swiping = false;
	          this$1.index = null;
	        });
	      }, 0);
	    },
	
	    swipeMove: function swipeMove(offset) {
	      this.wrap.style.webkitTransform = "translate3d(" + offset + "px, 0, 0)";
	      this.swiping = true;
	    },
	
	    startDrag: function startDrag(evt) {
	      if (!this.swipeable) return;
	      evt = evt.changedTouches ? evt.changedTouches[0] : evt;
	      this.dragging = true;
	      this.start.x = evt.pageX;
	      this.start.y = evt.pageY;
	    },
	
	    onDrag: function onDrag(evt) {
	      var this$1 = this;
	
	      if (!this.dragging) return;
	      var swiping;
	      var e = evt.changedTouches ? evt.changedTouches[0] : evt;
	      var offsetTop = e.pageY - this.start.y;
	      var offsetLeft = e.pageX - this.start.x;
	      var y = Math.abs(offsetTop);
	      var x = Math.abs(offsetLeft);
	
	      swiping = !(x < 5 || (x >= 5 && y >= x * 1.73));
	      if (!swiping) return;
	      evt.preventDefault();
	
	      var len = this.$children.length - 1;
	      var index = __WEBPACK_IMPORTED_MODULE_1_array_find_index___default()(this.$children,
	        function (item) { return item.id === this$1.currentActive; });
	      var currentPageOffset = index * this.pageWidth;
	      var offset = offsetLeft - currentPageOffset;
	      var absOffset = Math.abs(offset);
	
	      if (absOffset > len * this.pageWidth ||
	          (offset > 0 && offset < this.pageWidth)) {
	        this.swiping = false;
	        return;
	      }
	
	      this.offsetLeft = offsetLeft;
	      this.index = index;
	      this.swipeMove(offset);
	    },
	
	    endDrag: function endDrag() {
	      if (!this.swiping) return;
	      this.dragging = false;
	      var direction = this.offsetLeft > 0 ? -1 : 1;
	      var isChange = Math.abs(this.offsetLeft) > this.limitWidth;
	
	      if (isChange) {
	        this.index += direction;
	        var child = this.$children[this.index];
	        if (child) {
	          this.currentActive = child.id;
	          return;
	        }
	      }
	
	      this.swipeLeaveTransition();
	    }
	  }
	};
	
	
	/***/ },
	/* 49 */
	/***/ function(module, exports, __webpack_require__) {
	
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	/**
	 * mt-tab-item
	 * @module components/tab-item
	 * @desc 搭配 tabbar 或 navbar 使用
	 * @param {*} id - 选中后的返回值，任意类型
	 * @param {slot} [icon] - icon 图标
	 * @param {slot} - 文字
	 *
	 * @example
	 * <mt-tab-item>
	 *   <img slot="icon" src="http://placehold.it/100x100">
	 *   订单
	 * </mt-tab-item>
	 */
	/* harmony default export */ exports["default"] = {
	  name: 'mt-tab-item',
	
	  props: ['id']
	};
	
	
	/***/ },
	/* 50 */
	/***/ function(module, exports, __webpack_require__) {
	
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	//
	//
	//
	//
	//
	//
	//
	//
	
	/**
	 * mt-tabbar
	 * @module components/tabbar
	 * @desc 底部 tab，依赖 tab-item
	 * @param {boolean} [fixed=false] - 固定底部
	 * @param {*} value - 返回 item component 传入的 id
	 *
	 * @example
	 * <mt-tabbar v-model="selected">
	 *   <mt-tab-item id="订单">
	 *     <img slot="icon" src="http://placehold.it/100x100">
	 *     <span slot="label">订单</span>
	 *   </mt-tab-item>
	 * </mt-tabbar>
	 *
	 * <mt-tabbar v-model="selected" fixed>
	 *   <mt-tab-item :id="['传入数组', '也是可以的']">
	 *     <img slot="icon" src="http://placehold.it/100x100">
	 *     <span slot="label">订单</span>
	 *   </mt-tab-item>
	 * </mt-tabbar>
	 */
	/* harmony default export */ exports["default"] = {
	  name: 'mt-tabbar',
	
	  props: {
	    fixed: Boolean,
	    value: {}
	  }
	};
	
	
	/***/ },
	/* 51 */
	/***/ function(module, exports, __webpack_require__) {
	
	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	/* harmony default export */ exports["default"] = {
	  props: {
	    message: String,
	    className: {
	      type: String,
	      default: ''
	    },
	    position: {
	      type: String,
	      default: 'middle'
	    },
	    iconClass: {
	      type: String,
	      default: ''
	    }
	  },
	
	  data: function data() {
	    return {
	      visible: false
	    };
	  },
	
	  computed: {
	    customClass: function customClass() {
	      var classes = [];
	      switch (this.position) {
	        case 'top':
	          classes.push('is-placetop');
	          break;
	        case 'bottom':
	          classes.push('is-placebottom');
	          break;
	        default:
	          classes.push('is-placemiddle');
	      }
	      classes.push(this.className);
	
	      return classes.join(' ');
	    }
	  }
	};
	
	
	/***/ },
	/* 52 */
	/***/ function(module, exports, __webpack_require__) {
	
	"use strict";
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_actionsheet_vue__ = __webpack_require__(128);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_actionsheet_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__src_actionsheet_vue__);
	/* harmony reexport (default from non-hamory) */ __webpack_require__.d(exports, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__src_actionsheet_vue___default.a; });
	
	
	
	/***/ },
	/* 53 */
	/***/ function(module, exports, __webpack_require__) {
	
	"use strict";
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_badge_vue__ = __webpack_require__(129);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_badge_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__src_badge_vue__);
	/* harmony reexport (default from non-hamory) */ __webpack_require__.d(exports, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__src_badge_vue___default.a; });
	
	
	
	/***/ },
	/* 54 */
	/***/ function(module, exports, __webpack_require__) {
	
	"use strict";
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_button_vue__ = __webpack_require__(130);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_button_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__src_button_vue__);
	/* harmony reexport (default from non-hamory) */ __webpack_require__.d(exports, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__src_button_vue___default.a; });
	
	
	
	/***/ },
	/* 55 */
	/***/ function(module, exports, __webpack_require__) {
	
	"use strict";
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_cell_swipe_vue__ = __webpack_require__(131);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_cell_swipe_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__src_cell_swipe_vue__);
	/* harmony reexport (default from non-hamory) */ __webpack_require__.d(exports, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__src_cell_swipe_vue___default.a; });
	
	
	
	/***/ },
	/* 56 */
	/***/ function(module, exports, __webpack_require__) {
	
	"use strict";
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_checklist_vue__ = __webpack_require__(133);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_checklist_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__src_checklist_vue__);
	/* harmony reexport (default from non-hamory) */ __webpack_require__.d(exports, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__src_checklist_vue___default.a; });
	
	
	
	/***/ },
	/* 57 */
	/***/ function(module, exports, __webpack_require__) {
	
	"use strict";
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_datetime_picker_vue__ = __webpack_require__(134);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_datetime_picker_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__src_datetime_picker_vue__);
	/* harmony reexport (default from non-hamory) */ __webpack_require__.d(exports, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__src_datetime_picker_vue___default.a; });
	
	
	
	/***/ },
	/* 58 */
	/***/ function(module, exports, __webpack_require__) {
	
	"use strict";
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_field_vue__ = __webpack_require__(135);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_field_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__src_field_vue__);
	/* harmony reexport (default from non-hamory) */ __webpack_require__.d(exports, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__src_field_vue___default.a; });
	
	
	
	/***/ },
	/* 59 */
	/***/ function(module, exports, __webpack_require__) {
	
	"use strict";
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_header_vue__ = __webpack_require__(136);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_header_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__src_header_vue__);
	/* harmony reexport (default from non-hamory) */ __webpack_require__.d(exports, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__src_header_vue___default.a; });
	
	
	
	/***/ },
	/* 60 */
	/***/ function(module, exports, __webpack_require__) {
	
	"use strict";
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_index_list_vue__ = __webpack_require__(137);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_index_list_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__src_index_list_vue__);
	/* harmony reexport (default from non-hamory) */ __webpack_require__.d(exports, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index_list_vue___default.a; });
	
	
	
	/***/ },
	/* 61 */
	/***/ function(module, exports, __webpack_require__) {
	
	"use strict";
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_index_section_vue__ = __webpack_require__(138);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_index_section_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__src_index_section_vue__);
	/* harmony reexport (default from non-hamory) */ __webpack_require__.d(exports, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index_section_vue___default.a; });
	
	
	
	/***/ },
	/* 62 */
	/***/ function(module, exports, __webpack_require__) {
	
	"use strict";
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
	
	
	var Indicator = __WEBPACK_IMPORTED_MODULE_0_vue___default.a.extend(__webpack_require__(139));
	var instance;
	
	/* harmony default export */ exports["a"] = {
	  open: function open(options) {
	    if ( options === void 0 ) options = {};
	
	    if (!instance) {
	      instance = new Indicator({
	        el: document.createElement('div')
	      });
	    }
	    if (instance.visible) return;
	    instance.text = typeof options === 'string' ? options : options.text || '';
	    instance.spinnerType = options.spinnerType || 'snake';
	    document.body.appendChild(instance.$el);
	
	    __WEBPACK_IMPORTED_MODULE_0_vue___default.a.nextTick(function () {
	      instance.visible = true;
	    });
	  },
	
	  close: function close() {
	    if (instance) {
	      instance.visible = false;
	    }
	  }
	};
	
	
	/***/ },
	/* 63 */
	/***/ function(module, exports, __webpack_require__) {
	
	"use strict";
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mint_ui_src_style_empty_css__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mint_ui_src_style_empty_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_mint_ui_src_style_empty_css__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_infinite_scroll_js__ = __webpack_require__(65);
	/* harmony reexport (binding) */ __webpack_require__.d(exports, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__src_infinite_scroll_js__["a"]; });
	
	
	
	
	/***/ },
	/* 64 */
	/***/ function(module, exports, __webpack_require__) {
	
	"use strict";
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
	
	var ctx = '@@InfiniteScroll';
	
	var throttle = function(fn, delay) {
	  var now, lastExec, timer, context, args; //eslint-disable-line
	
	  var execute = function() {
	    fn.apply(context, args);
	    lastExec = now;
	  };
	
	  return function() {
	    context = this;
	    args = arguments;
	
	    now = Date.now();
	
	    if (timer) {
	      clearTimeout(timer);
	      timer = null;
	    }
	
	    if (lastExec) {
	      var diff = delay - (now - lastExec);
	      if (diff < 0) {
	        execute();
	      } else {
	        timer = setTimeout(function () {
	          execute();
	        }, diff);
	      }
	    } else {
	      execute();
	    }
	  };
	};
	
	var getScrollTop = function(element) {
	  if (element === window) {
	    return Math.max(window.pageYOffset || 0, document.documentElement.scrollTop);
	  }
	
	  return element.scrollTop;
	};
	
	var getComputedStyle = __WEBPACK_IMPORTED_MODULE_0_vue___default.a.prototype.$isServer ? {} : document.defaultView.getComputedStyle;
	
	var getScrollEventTarget = function(element) {
	  var currentNode = element;
	  // bugfix, see http://w3help.org/zh-cn/causes/SD9013 and http://stackoverflow.com/questions/17016740/onscroll-function-is-not-working-for-chrome
	  while (currentNode && currentNode.tagName !== 'HTML' && currentNode.tagName !== 'BODY' && currentNode.nodeType === 1) {
	    var overflowY = getComputedStyle(currentNode).overflowY;
	    if (overflowY === 'scroll' || overflowY === 'auto') {
	      return currentNode;
	    }
	    currentNode = currentNode.parentNode;
	  }
	  return window;
	};
	
	var getVisibleHeight = function(element) {
	  if (element === window) {
	    return document.documentElement.clientHeight;
	  }
	
	  return element.clientHeight;
	};
	
	var getElementTop = function(element) {
	  if (element === window) {
	    return getScrollTop(window);
	  }
	  return element.getBoundingClientRect().top + getScrollTop(window);
	};
	
	var isAttached = function(element) {
	  var currentNode = element.parentNode;
	  while (currentNode) {
	    if (currentNode.tagName === 'HTML') {
	      return true;
	    }
	    if (currentNode.nodeType === 11) {
	      return false;
	    }
	    currentNode = currentNode.parentNode;
	  }
	  return false;
	};
	
	var doBind = function() {
	  if (this.binded) return; // eslint-disable-line
	  this.binded = true;
	
	  var directive = this;
	  var element = directive.el;
	
	  directive.scrollEventTarget = getScrollEventTarget(element);
	  directive.scrollListener = throttle(doCheck.bind(directive), 200);
	  directive.scrollEventTarget.addEventListener('scroll', directive.scrollListener);
	
	  var disabledExpr = element.getAttribute('infinite-scroll-disabled');
	  var disabled = false;
	
	  if (disabledExpr) {
	    this.vm.$watch(disabledExpr, function(value) {
	      directive.disabled = value;
	      if (!value && directive.immediateCheck) {
	        doCheck.call(directive);
	      }
	    });
	    disabled = Boolean(directive.vm[disabledExpr]);
	  }
	  directive.disabled = disabled;
	
	  var distanceExpr = element.getAttribute('infinite-scroll-distance');
	  var distance = 0;
	  if (distanceExpr) {
	    distance = Number(directive.vm[distanceExpr] || distanceExpr);
	    if (isNaN(distance)) {
	      distance = 0;
	    }
	  }
	  directive.distance = distance;
	
	  var immediateCheckExpr = element.getAttribute('infinite-scroll-immediate-check');
	  var immediateCheck = true;
	  if (immediateCheckExpr) {
	    immediateCheck = Boolean(directive.vm[immediateCheckExpr]);
	  }
	  directive.immediateCheck = immediateCheck;
	
	  if (immediateCheck) {
	    doCheck.call(directive);
	  }
	
	  var eventName = element.getAttribute('infinite-scroll-listen-for-event');
	  if (eventName) {
	    directive.vm.$on(eventName, function() {
	      doCheck.call(directive);
	    });
	  }
	};
	
	var doCheck = function(force) {
	  var scrollEventTarget = this.scrollEventTarget;
	  var element = this.el;
	  var distance = this.distance;
	
	  if (force !== true && this.disabled) return; //eslint-disable-line
	  var viewportScrollTop = getScrollTop(scrollEventTarget);
	  var viewportBottom = viewportScrollTop + getVisibleHeight(scrollEventTarget);
	
	  var shouldTrigger = false;
	
	  if (scrollEventTarget === element) {
	    shouldTrigger = scrollEventTarget.scrollHeight - viewportBottom <= distance;
	  } else {
	    var elementBottom = getElementTop(element) - getElementTop(scrollEventTarget) + element.offsetHeight + viewportScrollTop;
	
	    shouldTrigger = viewportBottom + distance >= elementBottom;
	  }
	
	  if (shouldTrigger && this.expression) {
	    this.expression();
	  }
	};
	
	/* harmony default export */ exports["a"] = {
	  bind: function bind(el, binding, vnode) {
	    el[ctx] = {
	      el: el,
	      vm: vnode.context,
	      expression: binding.value
	    };
	    var args = arguments;
	    var cb = function() {
	      el[ctx].vm.$nextTick(function() {
	        if (isAttached(el)) {
	          doBind.call(el[ctx], args);
	        }
	
	        el[ctx].bindTryCount = 0;
	
	        var tryBind = function() {
	          if (el[ctx].bindTryCount > 10) return; //eslint-disable-line
	          el[ctx].bindTryCount++;
	          if (isAttached(el)) {
	            doBind.call(el[ctx], args);
	          } else {
	            setTimeout(tryBind, 50);
	          }
	        };
	
	        tryBind();
	      });
	    };
	    if (el[ctx].vm._isMounted) {
	      cb();
	      return;
	    }
	    el[ctx].vm.$on('hook:mounted', cb);
	  },
	
	  unbind: function unbind(el) {
	    if (el[ctx] && el[ctx].scrollEventTarget) {
	      el[ctx].scrollEventTarget.removeEventListener('scroll', el[ctx].scrollListener);
	    }
	  }
	};
	
	
	/***/ },
	/* 65 */
	/***/ function(module, exports, __webpack_require__) {
	
	"use strict";
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__directive__ = __webpack_require__(64);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mint_ui_src_style_empty_css__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mint_ui_src_style_empty_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mint_ui_src_style_empty_css__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue__);
	
	
	
	
	var install = function(Vue) {
	  Vue.directive('InfiniteScroll', __WEBPACK_IMPORTED_MODULE_0__directive__["a" /* default */]);
	};
	
	if (!__WEBPACK_IMPORTED_MODULE_2_vue___default.a.prototype.$isServer && window.Vue) {
	  window.infiniteScroll = __WEBPACK_IMPORTED_MODULE_0__directive__["a" /* default */];
	  __WEBPACK_IMPORTED_MODULE_2_vue___default.a.use(install); // eslint-disable-line
	}
	
	__WEBPACK_IMPORTED_MODULE_0__directive__["a" /* default */].install = install;
	/* harmony default export */ exports["a"] = __WEBPACK_IMPORTED_MODULE_0__directive__["a" /* default */];
	
	
	/***/ },
	/* 66 */
	/***/ function(module, exports, __webpack_require__) {
	
	"use strict";
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mint_ui_src_style_empty_css__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mint_ui_src_style_empty_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_mint_ui_src_style_empty_css__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_lazyload_js__ = __webpack_require__(67);
	/* harmony reexport (binding) */ __webpack_require__.d(exports, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__src_lazyload_js__["a"]; });
	
	
	
	
	/***/ },
	/* 67 */
	/***/ function(module, exports, __webpack_require__) {
	
	"use strict";
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_lazyload__ = __webpack_require__(201);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_lazyload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_lazyload__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mint_ui_src_style_empty_css__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mint_ui_src_style_empty_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mint_ui_src_style_empty_css__);
	
	
	
	/* harmony default export */ exports["a"] = __WEBPACK_IMPORTED_MODULE_0_vue_lazyload___default.a;
	
	
	/***/ },
	/* 68 */
	/***/ function(module, exports, __webpack_require__) {
	
	"use strict";
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_loadmore_vue__ = __webpack_require__(140);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_loadmore_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__src_loadmore_vue__);
	/* harmony reexport (default from non-hamory) */ __webpack_require__.d(exports, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__src_loadmore_vue___default.a; });
	
	
	
	/***/ },
	/* 69 */
	/***/ function(module, exports, __webpack_require__) {
	
	"use strict";
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_message_box_js__ = __webpack_require__(70);
	/* harmony reexport (binding) */ __webpack_require__.d(exports, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__src_message_box_js__["a"]; });
	
	
	
	/***/ },
	/* 70 */
	/***/ function(module, exports, __webpack_require__) {
	
	"use strict";
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__message_box_vue__ = __webpack_require__(141);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__message_box_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__message_box_vue__);
	/* unused harmony export MessageBox */
	var CONFIRM_TEXT = '确定';
	var CANCEL_TEXT = '取消';
	
	var defaults = {
	  title: '提示',
	  message: '',
	  type: '',
	  showInput: false,
	  showClose: true,
	  modalFade: false,
	  lockScroll: false,
	  closeOnClickModal: true,
	  inputValue: null,
	  inputPlaceholder: '',
	  inputPattern: null,
	  inputValidator: null,
	  inputErrorMessage: '',
	  showConfirmButton: true,
	  showCancelButton: false,
	  confirmButtonPosition: 'right',
	  confirmButtonHighlight: false,
	  cancelButtonHighlight: false,
	  confirmButtonText: CONFIRM_TEXT,
	  cancelButtonText: CANCEL_TEXT,
	  confirmButtonClass: '',
	  cancelButtonClass: ''
	};
	
	
	
	
	var merge = function(target) {
	  var arguments$1 = arguments;
	
	  for (var i = 1, j = arguments.length; i < j; i++) {
	    var source = arguments$1[i];
	    for (var prop in source) {
	      if (source.hasOwnProperty(prop)) {
	        var value = source[prop];
	        if (value !== undefined) {
	          target[prop] = value;
	        }
	      }
	    }
	  }
	
	  return target;
	};
	
	var MessageBoxConstructor = __WEBPACK_IMPORTED_MODULE_0_vue___default.a.extend(__WEBPACK_IMPORTED_MODULE_1__message_box_vue___default.a);
	
	var currentMsg, instance;
	var msgQueue = [];
	
	var defaultCallback = function (action) {
	  if (currentMsg) {
	    var callback = currentMsg.callback;
	    if (typeof callback === 'function') {
	      if (instance.showInput) {
	        callback(instance.inputValue, action);
	      } else {
	        callback(action);
	      }
	    }
	    if (currentMsg.resolve) {
	      var $type = currentMsg.options.$type;
	      if ($type === 'confirm' || $type === 'prompt') {
	        if (action === 'confirm') {
	          if (instance.showInput) {
	            currentMsg.resolve({ value: instance.inputValue, action: action });
	          } else {
	            currentMsg.resolve(action);
	          }
	        } else if (action === 'cancel' && currentMsg.reject) {
	          currentMsg.reject(action);
	        }
	      } else {
	        currentMsg.resolve(action);
	      }
	    }
	  }
	};
	
	var initInstance = function() {
	  instance = new MessageBoxConstructor({
	    el: document.createElement('div')
	  });
	
	  instance.callback = defaultCallback;
	};
	
	var showNextMsg = function() {
	  if (!instance) {
	    initInstance();
	  }
	
	  if (!instance.value || instance.closeTimer) {
	    if (msgQueue.length > 0) {
	      currentMsg = msgQueue.shift();
	
	      var options = currentMsg.options;
	      for (var prop in options) {
	        if (options.hasOwnProperty(prop)) {
	          instance[prop] = options[prop];
	        }
	      }
	      if (options.callback === undefined) {
	        instance.callback = defaultCallback;
	      }
	      ['modal', 'showClose', 'closeOnClickModal', 'closeOnPressEscape'].forEach(function (prop) {
	        if (instance[prop] === undefined) {
	          instance[prop] = true;
	        }
	      });
	      document.body.appendChild(instance.$el);
	
	      __WEBPACK_IMPORTED_MODULE_0_vue___default.a.nextTick(function () {
	        instance.value = true;
	      });
	    }
	  }
	};
	
	var MessageBox = function(options, callback) {
	  if (typeof options === 'string') {
	    options = {
	      title: options
	    };
	    if (arguments[1]) {
	      options.message = arguments[1];
	    }
	    if (arguments[2]) {
	      options.type = arguments[2];
	    }
	  } else if (options.callback && !callback) {
	    callback = options.callback;
	  }
	
	  if (typeof Promise !== 'undefined') {
	    return new Promise(function(resolve, reject) { // eslint-disable-line
	      msgQueue.push({
	        options: merge({}, defaults, MessageBox.defaults || {}, options),
	        callback: callback,
	        resolve: resolve,
	        reject: reject
	      });
	
	      showNextMsg();
	    });
	  } else {
	    msgQueue.push({
	      options: merge({}, defaults, MessageBox.defaults || {}, options),
	      callback: callback
	    });
	
	    showNextMsg();
	  }
	};
	
	MessageBox.setDefaults = function(defaults) {
	  MessageBox.defaults = defaults;
	};
	
	MessageBox.alert = function(message, title, options) {
	  if (typeof title === 'object') {
	    options = title;
	    title = '';
	  }
	  return MessageBox(merge({
	    title: title,
	    message: message,
	    $type: 'alert',
	    closeOnPressEscape: false,
	    closeOnClickModal: false
	  }, options));
	};
	
	MessageBox.confirm = function(message, title, options) {
	  if (typeof title === 'object') {
	    options = title;
	    title = '';
	  }
	  return MessageBox(merge({
	    title: title,
	    message: message,
	    $type: 'confirm',
	    showCancelButton: true
	  }, options));
	};
	
	MessageBox.prompt = function(message, title, options) {
	  if (typeof title === 'object') {
	    options = title;
	    title = '';
	  }
	  return MessageBox(merge({
	    title: title,
	    message: message,
	    showCancelButton: true,
	    showInput: true,
	    $type: 'prompt'
	  }, options));
	};
	
	MessageBox.close = function() {
	  if (!instance) return;
	  instance.value = false;
	  msgQueue = [];
	  currentMsg = null;
	};
	
	/* harmony default export */ exports["a"] = MessageBox;
	
	
	
	/***/ },
	/* 71 */
	/***/ function(module, exports, __webpack_require__) {
	
	"use strict";
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_navbar_vue__ = __webpack_require__(142);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_navbar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__src_navbar_vue__);
	/* harmony reexport (default from non-hamory) */ __webpack_require__.d(exports, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__src_navbar_vue___default.a; });
	
	
	
	/***/ },
	/* 72 */
	/***/ function(module, exports, __webpack_require__) {
	
	"use strict";
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_palette_button_vue__ = __webpack_require__(143);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_palette_button_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__src_palette_button_vue__);
	/* harmony reexport (default from non-hamory) */ __webpack_require__.d(exports, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__src_palette_button_vue___default.a; });
	
	
	
	/***/ },
	/* 73 */
	/***/ function(module, exports, __webpack_require__) {
	
	"use strict";
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
	var isDragging = false;
	
	
	var supportTouch = !__WEBPACK_IMPORTED_MODULE_0_vue___default.a.prototype.$isServer && 'ontouchstart' in window;
	
	/* harmony default export */ exports["a"] = function(element, options) {
	  var moveFn = function(event) {
	    if (options.drag) {
	      options.drag(supportTouch ? event.changedTouches[0] || event.touches[0] : event);
	    }
	  };
	
	  var endFn = function(event) {
	    if (!supportTouch) {
	      document.removeEventListener('mousemove', moveFn);
	      document.removeEventListener('mouseup', endFn);
	    }
	    document.onselectstart = null;
	    document.ondragstart = null;
	
	    isDragging = false;
	
	    if (options.end) {
	      options.end(supportTouch ? event.changedTouches[0] || event.touches[0] : event);
	    }
	  };
	
	  element.addEventListener(supportTouch ? 'touchstart' : 'mousedown', function(event) {
	    if (isDragging) return;
	    document.onselectstart = function() { return false; };
	    document.ondragstart = function() { return false; };
	
	    if (!supportTouch) {
	      document.addEventListener('mousemove', moveFn);
	      document.addEventListener('mouseup', endFn);
	    }
	    isDragging = true;
	
	    if (options.start) {
	      event.preventDefault();
	      options.start(supportTouch ? event.changedTouches[0] || event.touches[0] : event);
	    }
	  });
	
	  if (supportTouch) {
	    element.addEventListener('touchmove', moveFn);
	    element.addEventListener('touchend', endFn);
	    element.addEventListener('touchcancel', endFn);
	  }
	};;
	
	
	/***/ },
	/* 74 */
	/***/ function(module, exports, __webpack_require__) {
	
	"use strict";
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
	var exportObj = {};
	
	if (!__WEBPACK_IMPORTED_MODULE_0_vue___default.a.prototype.$isServer) {
	  var docStyle = document.documentElement.style;
	  var engine;
	  var translate3d = false;
	
	  if (window.opera && Object.prototype.toString.call(opera) === '[object Opera]') {
	    engine = 'presto';
	  } else if ('MozAppearance' in docStyle) {
	    engine = 'gecko';
	  } else if ('WebkitAppearance' in docStyle) {
	    engine = 'webkit';
	  } else if (typeof navigator.cpuClass === 'string') {
	    engine = 'trident';
	  }
	
	  var cssPrefix = {trident: '-ms-', gecko: '-moz-', webkit: '-webkit-', presto: '-o-'}[engine];
	
	  var vendorPrefix = {trident: 'ms', gecko: 'Moz', webkit: 'Webkit', presto: 'O'}[engine];
	
	  var helperElem = document.createElement('div');
	  var perspectiveProperty = vendorPrefix + 'Perspective';
	  var transformProperty = vendorPrefix + 'Transform';
	  var transformStyleName = cssPrefix + 'transform';
	  var transitionProperty = vendorPrefix + 'Transition';
	  var transitionStyleName = cssPrefix + 'transition';
	  var transitionEndProperty = vendorPrefix.toLowerCase() + 'TransitionEnd';
	
	  if (helperElem.style[perspectiveProperty] !== undefined) {
	    translate3d = true;
	  }
	
	  var getTranslate = function(element) {
	    var result = {left: 0, top: 0};
	    if (element === null || element.style === null) return result;
	
	    var transform = element.style[transformProperty];
	    var matches = /translate\(\s*(-?\d+(\.?\d+?)?)px,\s*(-?\d+(\.\d+)?)px\)\s*translateZ\(0px\)/ig.exec(transform);
	    if (matches) {
	      result.left = +matches[1];
	      result.top = +matches[3];
	    }
	
	    return result;
	  };
	
	  var translateElement = function(element, x, y) {
	    if (x === null && y === null) return;
	
	    if (element === null || element === undefined || element.style === null) return;
	
	    if (!element.style[transformProperty] && x === 0 && y === 0) return;
	
	    if (x === null || y === null) {
	      var translate = getTranslate(element);
	      if (x === null) {
	        x = translate.left;
	      }
	      if (y === null) {
	        y = translate.top;
	      }
	    }
	
	    cancelTranslateElement(element);
	
	    if (translate3d) {
	      element.style[transformProperty] += ' translate(' + (x ? (x + 'px') : '0px') + ',' + (y ? (y + 'px') : '0px') + ') translateZ(0px)';
	    } else {
	      element.style[transformProperty] += ' translate(' + (x ? (x + 'px') : '0px') + ',' + (y ? (y + 'px') : '0px') + ')';
	    }
	  };
	
	  var cancelTranslateElement = function(element) {
	    if (element === null || element.style === null) return;
	    var transformValue = element.style[transformProperty];
	    if (transformValue) {
	      transformValue = transformValue.replace(/translate\(\s*(-?\d+(\.?\d+?)?)px,\s*(-?\d+(\.\d+)?)px\)\s*translateZ\(0px\)/g, '');
	      element.style[transformProperty] = transformValue;
	    }
	  };
	  exportObj = {
	    transformProperty: transformProperty,
	    transformStyleName: transformStyleName,
	    transitionProperty: transitionProperty,
	    transitionStyleName: transitionStyleName,
	    transitionEndProperty: transitionEndProperty,
	    getElementTranslate: getTranslate,
	    translateElement: translateElement,
	    cancelTranslateElement: cancelTranslateElement
	  };
	};
	
	/* harmony default export */ exports["a"] = exportObj;
	
	
	/***/ },
	/* 75 */
	/***/ function(module, exports, __webpack_require__) {
	
	"use strict";
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_progress_vue__ = __webpack_require__(147);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_progress_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__src_progress_vue__);
	/* harmony reexport (default from non-hamory) */ __webpack_require__.d(exports, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__src_progress_vue___default.a; });
	
	
	
	/***/ },
	/* 76 */
	/***/ function(module, exports, __webpack_require__) {
	
	"use strict";
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_radio_vue__ = __webpack_require__(148);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_radio_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__src_radio_vue__);
	/* harmony reexport (default from non-hamory) */ __webpack_require__.d(exports, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__src_radio_vue___default.a; });
	
	
	
	/***/ },
	/* 77 */
	/***/ function(module, exports, __webpack_require__) {
	
	"use strict";
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_index_vue__ = __webpack_require__(149);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__src_index_vue__);
	/* harmony reexport (default from non-hamory) */ __webpack_require__.d(exports, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__src_index_vue___default.a; });
	
	
	
	/***/ },
	/* 78 */
	/***/ function(module, exports, __webpack_require__) {
	
	"use strict";
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
	var isDragging = false;
	
	var supportTouch = !__WEBPACK_IMPORTED_MODULE_0_vue___default.a.prototype.$isServer && 'ontouchstart' in window;
	
	/* harmony default export */ exports["a"] = function(element, options) {
	  var moveFn = function(event) {
	    if (options.drag) {
	      options.drag(supportTouch ? event.changedTouches[0] || event.touches[0] : event);
	    }
	  };
	
	  var endFn = function(event) {
	    if (!supportTouch) {
	      document.removeEventListener('mousemove', moveFn);
	      document.removeEventListener('mouseup', endFn);
	    }
	    document.onselectstart = null;
	    document.ondragstart = null;
	
	    isDragging = false;
	
	    if (options.end) {
	      options.end(supportTouch ? event.changedTouches[0] || event.touches[0] : event);
	    }
	  };
	
	  element.addEventListener(supportTouch ? 'touchstart' : 'mousedown', function(event) {
	    if (isDragging) return;
	    event.preventDefault();
	    document.onselectstart = function() { return false; };
	    document.ondragstart = function() { return false; };
	
	    if (!supportTouch) {
	      document.addEventListener('mousemove', moveFn);
	      document.addEventListener('mouseup', endFn);
	    }
	    isDragging = true;
	
	    if (options.start) {
	      options.start(supportTouch ? event.changedTouches[0] || event.touches[0] : event);
	    }
	  });
	
	  if (supportTouch) {
	    element.addEventListener('touchmove', moveFn);
	    element.addEventListener('touchend', endFn);
	    element.addEventListener('touchcancel', endFn);
	  }
	};;
	
	
	/***/ },
	/* 79 */
	/***/ function(module, exports, __webpack_require__) {
	
	"use strict";
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_search_vue__ = __webpack_require__(150);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_search_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__src_search_vue__);
	/* harmony reexport (default from non-hamory) */ __webpack_require__.d(exports, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__src_search_vue___default.a; });
	
	
	
	/***/ },
	/* 80 */
	/***/ function(module, exports, __webpack_require__) {
	
	"use strict";
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mint_ui_src_style_empty_css__ = __webpack_require__(4);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mint_ui_src_style_empty_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_mint_ui_src_style_empty_css__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__swipe_src_swipe_item_vue__ = __webpack_require__(155);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__swipe_src_swipe_item_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__swipe_src_swipe_item_vue__);
	/* harmony reexport (default from non-hamory) */ __webpack_require__.d(exports, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__swipe_src_swipe_item_vue___default.a; });
	
	
	
	
	/***/ },
	/* 81 */
	/***/ function(module, exports, __webpack_require__) {
	
	"use strict";
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_swipe_vue__ = __webpack_require__(156);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_swipe_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__src_swipe_vue__);
	/* harmony reexport (default from non-hamory) */ __webpack_require__.d(exports, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__src_swipe_vue___default.a; });
	
	
	
	/***/ },
	/* 82 */
	/***/ function(module, exports, __webpack_require__) {
	
	"use strict";
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_switch_vue__ = __webpack_require__(157);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_switch_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__src_switch_vue__);
	/* harmony reexport (default from non-hamory) */ __webpack_require__.d(exports, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__src_switch_vue___default.a; });
	
	
	
	/***/ },
	/* 83 */
	/***/ function(module, exports, __webpack_require__) {
	
	"use strict";
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_tab_container_item_vue__ = __webpack_require__(158);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_tab_container_item_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__src_tab_container_item_vue__);
	/* harmony reexport (default from non-hamory) */ __webpack_require__.d(exports, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__src_tab_container_item_vue___default.a; });
	
	
	
	/***/ },
	/* 84 */
	/***/ function(module, exports, __webpack_require__) {
	
	"use strict";
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_tab_container_vue__ = __webpack_require__(159);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_tab_container_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__src_tab_container_vue__);
	/* harmony reexport (default from non-hamory) */ __webpack_require__.d(exports, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__src_tab_container_vue___default.a; });
	
	
	
	/***/ },
	/* 85 */
	/***/ function(module, exports, __webpack_require__) {
	
	"use strict";
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_tab_item_vue__ = __webpack_require__(160);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_tab_item_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__src_tab_item_vue__);
	/* harmony reexport (default from non-hamory) */ __webpack_require__.d(exports, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__src_tab_item_vue___default.a; });
	
	
	
	/***/ },
	/* 86 */
	/***/ function(module, exports, __webpack_require__) {
	
	"use strict";
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_tabbar_vue__ = __webpack_require__(161);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_tabbar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__src_tabbar_vue__);
	/* harmony reexport (default from non-hamory) */ __webpack_require__.d(exports, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__src_tabbar_vue___default.a; });
	
	
	
	/***/ },
	/* 87 */
	/***/ function(module, exports, __webpack_require__) {
	
	"use strict";
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_toast_js__ = __webpack_require__(88);
	/* harmony reexport (binding) */ __webpack_require__.d(exports, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__src_toast_js__["a"]; });
	
	
	
	/***/ },
	/* 88 */
	/***/ function(module, exports, __webpack_require__) {
	
	"use strict";
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
	
	
	var ToastConstructor = __WEBPACK_IMPORTED_MODULE_0_vue___default.a.extend(__webpack_require__(162));
	var toastPool = [];
	
	var getAnInstance = function () {
	  if (toastPool.length > 0) {
	    var instance = toastPool[0];
	    toastPool.splice(0, 1);
	    return instance;
	  }
	  return new ToastConstructor({
	    el: document.createElement('div')
	  });
	};
	
	var returnAnInstance = function (instance) {
	  if (instance) {
	    toastPool.push(instance);
	  }
	};
	
	var removeDom = function (event) {
	  if (event.target.parentNode) {
	    event.target.parentNode.removeChild(event.target);
	  }
	};
	
	ToastConstructor.prototype.close = function() {
	  this.visible = false;
	  this.$el.addEventListener('transitionend', removeDom);
	  this.closed = true;
	  returnAnInstance(this);
	};
	
	var Toast = function (options) {
	  if ( options === void 0 ) options = {};
	
	  var duration = options.duration || 3000;
	
	  var instance = getAnInstance();
	  instance.closed = false;
	  clearTimeout(instance.timer);
	  instance.message = typeof options === 'string' ? options : options.message;
	  instance.position = options.position || 'middle';
	  instance.className = options.className || '';
	  instance.iconClass = options.iconClass || '';
	
	  document.body.appendChild(instance.$el);
	  __WEBPACK_IMPORTED_MODULE_0_vue___default.a.nextTick(function() {
	    instance.visible = true;
	    instance.$el.removeEventListener('transitionend', removeDom);
	    ~duration && (instance.timer = setTimeout(function() {
	      if (instance.closed) return;
	      instance.close();
	    }, duration));
	  });
	  return instance;
	};
	
	/* harmony default export */ exports["a"] = Toast;
	
	
	/***/ },
	/* 89 */
	/***/ function(module, exports, __webpack_require__) {
	
	"use strict";
	function broadcast(componentName, eventName, params) {
	  this.$children.forEach(function (child) {
	    var name = child.$options.componentName;
	
	    if (name === componentName) {
	      child.$emit.apply(child, [eventName].concat(params));
	    } else {
	      broadcast.apply(child, [componentName, eventName].concat(params));
	    }
	  });
	}
	/* harmony default export */ exports["a"] = {
	  methods: {
	    dispatch: function dispatch(componentName, eventName, params) {
	      var parent = this.$parent;
	      var name = parent.$options.componentName;
	
	      while (parent && (!name || name !== componentName)) {
	        parent = parent.$parent;
	
	        if (parent) {
	          name = parent.$options.componentName;
	        }
	      }
	      if (parent) {
	        parent.$emit.apply(parent, [eventName].concat(params));
	      }
	    },
	    broadcast: function broadcast$1(componentName, eventName, params) {
	      broadcast.call(this, componentName, eventName, params);
	    }
	  }
	};
	
	
	/***/ },
	/* 90 */
	/***/ function(module, exports, __webpack_require__) {
	
	"use strict";
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
	/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mint_ui_src_utils_dom__ = __webpack_require__(3);
	
	
	
	var hasModal = false;
	
	var getModal = function() {
	  if (__WEBPACK_IMPORTED_MODULE_0_vue___default.a.prototype.$isServer) return;
	  var modalDom = PopupManager.modalDom;
	  if (modalDom) {
	    hasModal = true;
	  } else {
	    hasModal = false;
	    modalDom = document.createElement('div');
	    PopupManager.modalDom = modalDom;
	
	    modalDom.addEventListener('touchmove', function(event) {
	      event.preventDefault();
	      event.stopPropagation();
	    });
	
	    modalDom.addEventListener('click', function() {
	      PopupManager.doOnModalClick && PopupManager.doOnModalClick();
	    });
	  }
	
	  return modalDom;
	};
	
	var instances = {};
	
	var PopupManager = {
	  zIndex: 2000,
	
	  modalFade: true,
	
	  getInstance: function(id) {
	    return instances[id];
	  },
	
	  register: function(id, instance) {
	    if (id && instance) {
	      instances[id] = instance;
	    }
	  },
	
	  deregister: function(id) {
	    if (id) {
	      instances[id] = null;
	      delete instances[id];
	    }
	  },
	
	  nextZIndex: function() {
	    return PopupManager.zIndex++;
	  },
	
	  modalStack: [],
	
	  doOnModalClick: function() {
	    var topItem = PopupManager.modalStack[PopupManager.modalStack.length - 1];
	    if (!topItem) return;
	
	    var instance = PopupManager.getInstance(topItem.id);
	    if (instance && instance.closeOnClickModal) {
	      instance.close();
	    }
	  },
	
	  openModal: function(id, zIndex, dom, modalClass, modalFade) {
	    if (__WEBPACK_IMPORTED_MODULE_0_vue___default.a.prototype.$isServer) return;
	    if (!id || zIndex === undefined) return;
	    this.modalFade = modalFade;
	
	    var modalStack = this.modalStack;
	
	    for (var i = 0, j = modalStack.length; i < j; i++) {
	      var item = modalStack[i];
	      if (item.id === id) {
	        return;
	      }
	    }
	
	    var modalDom = getModal();
	
	    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_mint_ui_src_utils_dom__["a" /* addClass */])(modalDom, 'v-modal');
	    if (this.modalFade && !hasModal) {
	      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_mint_ui_src_utils_dom__["a" /* addClass */])(modalDom, 'v-modal-enter');
	    }
	    if (modalClass) {
	      var classArr = modalClass.trim().split(/\s+/);
	      classArr.forEach(function (item) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_mint_ui_src_utils_dom__["a" /* addClass */])(modalDom, item); });
	    }
	    setTimeout(function () {
	      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_mint_ui_src_utils_dom__["b" /* removeClass */])(modalDom, 'v-modal-enter');
	    }, 200);
	
	    if (dom && dom.parentNode && dom.parentNode.nodeType !== 11) {
	      dom.parentNode.appendChild(modalDom);
	    } else {
	      document.body.appendChild(modalDom);
	    }
	
	    if (zIndex) {
	      modalDom.style.zIndex = zIndex;
	    }
	    modalDom.style.display = '';
	
	    this.modalStack.push({ id: id, zIndex: zIndex, modalClass: modalClass });
	  },
	
	  closeModal: function(id) {
	    var modalStack = this.modalStack;
	    var modalDom = getModal();
	
	    if (modalStack.length > 0) {
	      var topItem = modalStack[modalStack.length - 1];
	      if (topItem.id === id) {
	        if (topItem.modalClass) {
	          var classArr = topItem.modalClass.trim().split(/\s+/);
	          classArr.forEach(function (item) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_mint_ui_src_utils_dom__["b" /* removeClass */])(modalDom, item); });
	        }
	
	        modalStack.pop();
	        if (modalStack.length > 0) {
	          modalDom.style.zIndex = modalStack[modalStack.length - 1].zIndex;
	        }
	      } else {
	        for (var i = modalStack.length - 1; i >= 0; i--) {
	          if (modalStack[i].id === id) {
	            modalStack.splice(i, 1);
	            break;
	          }
	        }
	      }
	    }
	
	    if (modalStack.length === 0) {
	      if (this.modalFade) {
	        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_mint_ui_src_utils_dom__["a" /* addClass */])(modalDom, 'v-modal-leave');
	      }
	      setTimeout(function () {
	        if (modalStack.length === 0) {
	          if (modalDom.parentNode) modalDom.parentNode.removeChild(modalDom);
	          modalDom.style.display = 'none';
	          PopupManager.modalDom = undefined;
	        }
	        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_mint_ui_src_utils_dom__["b" /* removeClass */])(modalDom, 'v-modal-leave');
	      }, 200);
	    }
	  }
	};
	!__WEBPACK_IMPORTED_MODULE_0_vue___default.a.prototype.$isServer && window.addEventListener('keydown', function(event) {
	  if (event.keyCode === 27) { // ESC
	    if (PopupManager.modalStack.length > 0) {
	      var topItem = PopupManager.modalStack[PopupManager.modalStack.length - 1];
	      if (!topItem) return;
	      var instance = PopupManager.getInstance(topItem.id);
	      if (instance.closeOnPressEscape) {
	        instance.close();
	      }
	    }
	  }
	});
	
	/* harmony default export */ exports["a"] = PopupManager;
	
	
	/***/ },
	/* 91 */
	/***/ function(module, exports) {
	
	// removed by extract-text-webpack-plugin
	
	/***/ },
	/* 92 */
	/***/ function(module, exports) {
	
	// removed by extract-text-webpack-plugin
	
	/***/ },
	/* 93 */
	/***/ function(module, exports) {
	
	// removed by extract-text-webpack-plugin
	
	/***/ },
	/* 94 */
	/***/ function(module, exports) {
	
	// removed by extract-text-webpack-plugin
	
	/***/ },
	/* 95 */
	/***/ function(module, exports) {
	
	// removed by extract-text-webpack-plugin
	
	/***/ },
	/* 96 */
	/***/ function(module, exports) {
	
	// removed by extract-text-webpack-plugin
	
	/***/ },
	/* 97 */
	/***/ function(module, exports) {
	
	// removed by extract-text-webpack-plugin
	
	/***/ },
	/* 98 */
	/***/ function(module, exports) {
	
	// removed by extract-text-webpack-plugin
	
	/***/ },
	/* 99 */
	/***/ function(module, exports) {
	
	// removed by extract-text-webpack-plugin
	
	/***/ },
	/* 100 */
	/***/ function(module, exports) {
	
	// removed by extract-text-webpack-plugin
	
	/***/ },
	/* 101 */
	/***/ function(module, exports) {
	
	// removed by extract-text-webpack-plugin
	
	/***/ },
	/* 102 */
	/***/ function(module, exports) {
	
	// removed by extract-text-webpack-plugin
	
	/***/ },
	/* 103 */
	/***/ function(module, exports) {
	
	// removed by extract-text-webpack-plugin
	
	/***/ },
	/* 104 */
	/***/ function(module, exports) {
	
	// removed by extract-text-webpack-plugin
	
	/***/ },
	/* 105 */
	/***/ function(module, exports) {
	
	// removed by extract-text-webpack-plugin
	
	/***/ },
	/* 106 */
	/***/ function(module, exports) {
	
	// removed by extract-text-webpack-plugin
	
	/***/ },
	/* 107 */
	/***/ function(module, exports) {
	
	// removed by extract-text-webpack-plugin
	
	/***/ },
	/* 108 */
	/***/ function(module, exports) {
	
	// removed by extract-text-webpack-plugin
	
	/***/ },
	/* 109 */
	/***/ function(module, exports) {
	
	// removed by extract-text-webpack-plugin
	
	/***/ },
	/* 110 */
	/***/ function(module, exports) {
	
	// removed by extract-text-webpack-plugin
	
	/***/ },
	/* 111 */
	/***/ function(module, exports) {
	
	// removed by extract-text-webpack-plugin
	
	/***/ },
	/* 112 */
	/***/ function(module, exports) {
	
	// removed by extract-text-webpack-plugin
	
	/***/ },
	/* 113 */
	/***/ function(module, exports) {
	
	// removed by extract-text-webpack-plugin
	
	/***/ },
	/* 114 */
	/***/ function(module, exports) {
	
	// removed by extract-text-webpack-plugin
	
	/***/ },
	/* 115 */
	/***/ function(module, exports) {
	
	// removed by extract-text-webpack-plugin
	
	/***/ },
	/* 116 */
	/***/ function(module, exports) {
	
	// removed by extract-text-webpack-plugin
	
	/***/ },
	/* 117 */
	/***/ function(module, exports) {
	
	// removed by extract-text-webpack-plugin
	
	/***/ },
	/* 118 */
	/***/ function(module, exports) {
	
	// removed by extract-text-webpack-plugin
	
	/***/ },
	/* 119 */
	/***/ function(module, exports) {
	
	// removed by extract-text-webpack-plugin
	
	/***/ },
	/* 120 */
	/***/ function(module, exports) {
	
	// removed by extract-text-webpack-plugin
	
	/***/ },
	/* 121 */
	/***/ function(module, exports) {
	
	// removed by extract-text-webpack-plugin
	
	/***/ },
	/* 122 */
	/***/ function(module, exports) {
	
	// removed by extract-text-webpack-plugin
	
	/***/ },
	/* 123 */
	/***/ function(module, exports) {
	
	// removed by extract-text-webpack-plugin
	
	/***/ },
	/* 124 */
	/***/ function(module, exports) {
	
	// removed by extract-text-webpack-plugin
	
	/***/ },
	/* 125 */
	/***/ function(module, exports) {
	
	// removed by extract-text-webpack-plugin
	
	/***/ },
	/* 126 */
	/***/ function(module, exports) {
	
	// removed by extract-text-webpack-plugin
	
	/***/ },
	/* 127 */
	/***/ function(module, exports) {
	
	module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzMiAzMiIgd2lkdGg9IjMyIiBoZWlnaHQ9IjMyIiBmaWxsPSJ3aGl0ZSI+CiAgPHBhdGggb3BhY2l0eT0iLjI1IiBkPSJNMTYgMCBBMTYgMTYgMCAwIDAgMTYgMzIgQTE2IDE2IDAgMCAwIDE2IDAgTTE2IDQgQTEyIDEyIDAgMCAxIDE2IDI4IEExMiAxMiAwIDAgMSAxNiA0Ii8+CiAgPHBhdGggZD0iTTE2IDAgQTE2IDE2IDAgMCAxIDMyIDE2IEwyOCAxNiBBMTIgMTIgMCAwIDAgMTYgNHoiPgogICAgPGFuaW1hdGVUcmFuc2Zvcm0gYXR0cmlidXRlTmFtZT0idHJhbnNmb3JtIiB0eXBlPSJyb3RhdGUiIGZyb209IjAgMTYgMTYiIHRvPSIzNjAgMTYgMTYiIGR1cj0iMC44cyIgcmVwZWF0Q291bnQ9ImluZGVmaW5pdGUiIC8+CiAgPC9wYXRoPgo8L3N2Zz4K"
	
	/***/ },
	/* 128 */
	/***/ function(module, exports, __webpack_require__) {
	
	function injectStyle (ssrContext) {
	  __webpack_require__(100)
	}
	var Component = __webpack_require__(0)(
	  /* script */
	  __webpack_require__(15),
	  /* template */
	  __webpack_require__(171),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports
	
	
	/***/ },
	/* 129 */
	/***/ function(module, exports, __webpack_require__) {
	
	function injectStyle (ssrContext) {
	  __webpack_require__(102)
	}
	var Component = __webpack_require__(0)(
	  /* script */
	  __webpack_require__(16),
	  /* template */
	  __webpack_require__(173),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports
	
	
	/***/ },
	/* 130 */
	/***/ function(module, exports, __webpack_require__) {
	
	function injectStyle (ssrContext) {
	  __webpack_require__(106)
	}
	var Component = __webpack_require__(0)(
	  /* script */
	  __webpack_require__(17),
	  /* template */
	  __webpack_require__(177),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports
	
	
	/***/ },
	/* 131 */
	/***/ function(module, exports, __webpack_require__) {
	
	function injectStyle (ssrContext) {
	  __webpack_require__(98)
	}
	var Component = __webpack_require__(0)(
	  /* script */
	  __webpack_require__(18),
	  /* template */
	  __webpack_require__(169),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports
	
	
	/***/ },
	/* 132 */
	/***/ function(module, exports, __webpack_require__) {
	
	function injectStyle (ssrContext) {
	  __webpack_require__(113)
	}
	var Component = __webpack_require__(0)(
	  /* script */
	  __webpack_require__(19),
	  /* template */
	  __webpack_require__(185),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports
	
	
	/***/ },
	/* 133 */
	/***/ function(module, exports, __webpack_require__) {
	
	function injectStyle (ssrContext) {
	  __webpack_require__(124)
	}
	var Component = __webpack_require__(0)(
	  /* script */
	  __webpack_require__(20),
	  /* template */
	  __webpack_require__(196),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports
	
	
	/***/ },
	/* 134 */
	/***/ function(module, exports, __webpack_require__) {
	
	function injectStyle (ssrContext) {
	  __webpack_require__(109)
	}
	var Component = __webpack_require__(0)(
	  /* script */
	  __webpack_require__(21),
	  /* template */
	  __webpack_require__(181),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports
	
	
	/***/ },
	/* 135 */
	/***/ function(module, exports, __webpack_require__) {
	
	function injectStyle (ssrContext) {
	  __webpack_require__(116)
	}
	var Component = __webpack_require__(0)(
	  /* script */
	  __webpack_require__(22),
	  /* template */
	  __webpack_require__(187),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports
	
	
	/***/ },
	/* 136 */
	/***/ function(module, exports, __webpack_require__) {
	
	function injectStyle (ssrContext) {
	  __webpack_require__(108)
	}
	var Component = __webpack_require__(0)(
	  /* script */
	  __webpack_require__(23),
	  /* template */
	  __webpack_require__(179),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports
	
	
	/***/ },
	/* 137 */
	/***/ function(module, exports, __webpack_require__) {
	
	function injectStyle (ssrContext) {
	  __webpack_require__(93)
	}
	var Component = __webpack_require__(0)(
	  /* script */
	  __webpack_require__(24),
	  /* template */
	  __webpack_require__(164),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports
	
	
	/***/ },
	/* 138 */
	/***/ function(module, exports, __webpack_require__) {
	
	function injectStyle (ssrContext) {
	  __webpack_require__(94)
	}
	var Component = __webpack_require__(0)(
	  /* script */
	  __webpack_require__(25),
	  /* template */
	  __webpack_require__(165),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports
	
	
	/***/ },
	/* 139 */
	/***/ function(module, exports, __webpack_require__) {
	
	function injectStyle (ssrContext) {
	  __webpack_require__(119)
	}
	var Component = __webpack_require__(0)(
	  /* script */
	  __webpack_require__(26),
	  /* template */
	  __webpack_require__(191),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports
	
	
	/***/ },
	/* 140 */
	/***/ function(module, exports, __webpack_require__) {
	
	function injectStyle (ssrContext) {
	  __webpack_require__(121)
	}
	var Component = __webpack_require__(0)(
	  /* script */
	  __webpack_require__(27),
	  /* template */
	  __webpack_require__(193),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports
	
	
	/***/ },
	/* 141 */
	/***/ function(module, exports, __webpack_require__) {
	
	function injectStyle (ssrContext) {
	  __webpack_require__(114)
	  __webpack_require__(115)
	}
	var Component = __webpack_require__(0)(
	  /* script */
	  __webpack_require__(28),
	  /* template */
	  __webpack_require__(186),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports
	
	
	/***/ },
	/* 142 */
	/***/ function(module, exports, __webpack_require__) {
	
	function injectStyle (ssrContext) {
	  __webpack_require__(123)
	}
	var Component = __webpack_require__(0)(
	  /* script */
	  __webpack_require__(29),
	  /* template */
	  __webpack_require__(195),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports
	
	
	/***/ },
	/* 143 */
	/***/ function(module, exports, __webpack_require__) {
	
	function injectStyle (ssrContext) {
	  __webpack_require__(112)
	}
	var Component = __webpack_require__(0)(
	  /* script */
	  __webpack_require__(30),
	  /* template */
	  __webpack_require__(184),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports
	
	
	/***/ },
	/* 144 */
	/***/ function(module, exports, __webpack_require__) {
	
	function injectStyle (ssrContext) {
	  __webpack_require__(92)
	}
	var Component = __webpack_require__(0)(
	  /* script */
	  __webpack_require__(31),
	  /* template */
	  __webpack_require__(163),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports
	
	
	/***/ },
	/* 145 */
	/***/ function(module, exports, __webpack_require__) {
	
	function injectStyle (ssrContext) {
	  __webpack_require__(126)
	}
	var Component = __webpack_require__(0)(
	  /* script */
	  __webpack_require__(32),
	  /* template */
	  __webpack_require__(198),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports
	
	
	/***/ },
	/* 146 */
	/***/ function(module, exports, __webpack_require__) {
	
	function injectStyle (ssrContext) {
	  __webpack_require__(120)
	}
	var Component = __webpack_require__(0)(
	  /* script */
	  __webpack_require__(33),
	  /* template */
	  __webpack_require__(192),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports
	
	
	/***/ },
	/* 147 */
	/***/ function(module, exports, __webpack_require__) {
	
	function injectStyle (ssrContext) {
	  __webpack_require__(96)
	}
	var Component = __webpack_require__(0)(
	  /* script */
	  __webpack_require__(34),
	  /* template */
	  __webpack_require__(167),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports
	
	
	/***/ },
	/* 148 */
	/***/ function(module, exports, __webpack_require__) {
	
	function injectStyle (ssrContext) {
	  __webpack_require__(118)
	}
	var Component = __webpack_require__(0)(
	  /* script */
	  __webpack_require__(35),
	  /* template */
	  __webpack_require__(190),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports
	
	
	/***/ },
	/* 149 */
	/***/ function(module, exports, __webpack_require__) {
	
	function injectStyle (ssrContext) {
	  __webpack_require__(122)
	}
	var Component = __webpack_require__(0)(
	  /* script */
	  __webpack_require__(36),
	  /* template */
	  __webpack_require__(194),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports
	
	
	/***/ },
	/* 150 */
	/***/ function(module, exports, __webpack_require__) {
	
	function injectStyle (ssrContext) {
	  __webpack_require__(125)
	}
	var Component = __webpack_require__(0)(
	  /* script */
	  __webpack_require__(37),
	  /* template */
	  __webpack_require__(197),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports
	
	
	/***/ },
	/* 151 */
	/***/ function(module, exports, __webpack_require__) {
	
	var Component = __webpack_require__(0)(
	  /* script */
	  __webpack_require__(38),
	  /* template */
	  __webpack_require__(189),
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports
	
	
	/***/ },
	/* 152 */
	/***/ function(module, exports, __webpack_require__) {
	
	function injectStyle (ssrContext) {
	  __webpack_require__(111)
	}
	var Component = __webpack_require__(0)(
	  /* script */
	  __webpack_require__(40),
	  /* template */
	  __webpack_require__(183),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports
	
	
	/***/ },
	/* 153 */
	/***/ function(module, exports, __webpack_require__) {
	
	function injectStyle (ssrContext) {
	  __webpack_require__(103)
	}
	var Component = __webpack_require__(0)(
	  /* script */
	  __webpack_require__(42),
	  /* template */
	  __webpack_require__(174),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports
	
	
	/***/ },
	/* 154 */
	/***/ function(module, exports, __webpack_require__) {
	
	function injectStyle (ssrContext) {
	  __webpack_require__(99)
	}
	var Component = __webpack_require__(0)(
	  /* script */
	  __webpack_require__(43),
	  /* template */
	  __webpack_require__(170),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports
	
	
	/***/ },
	/* 155 */
	/***/ function(module, exports, __webpack_require__) {
	
	var Component = __webpack_require__(0)(
	  /* script */
	  __webpack_require__(44),
	  /* template */
	  __webpack_require__(180),
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports
	
	
	/***/ },
	/* 156 */
	/***/ function(module, exports, __webpack_require__) {
	
	function injectStyle (ssrContext) {
	  __webpack_require__(95)
	}
	var Component = __webpack_require__(0)(
	  /* script */
	  __webpack_require__(45),
	  /* template */
	  __webpack_require__(166),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports
	
	
	/***/ },
	/* 157 */
	/***/ function(module, exports, __webpack_require__) {
	
	function injectStyle (ssrContext) {
	  __webpack_require__(107)
	}
	var Component = __webpack_require__(0)(
	  /* script */
	  __webpack_require__(46),
	  /* template */
	  __webpack_require__(178),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports
	
	
	/***/ },
	/* 158 */
	/***/ function(module, exports, __webpack_require__) {
	
	function injectStyle (ssrContext) {
	  __webpack_require__(117)
	}
	var Component = __webpack_require__(0)(
	  /* script */
	  __webpack_require__(47),
	  /* template */
	  __webpack_require__(188),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports
	
	
	/***/ },
	/* 159 */
	/***/ function(module, exports, __webpack_require__) {
	
	function injectStyle (ssrContext) {
	  __webpack_require__(101)
	}
	var Component = __webpack_require__(0)(
	  /* script */
	  __webpack_require__(48),
	  /* template */
	  __webpack_require__(172),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports
	
	
	/***/ },
	/* 160 */
	/***/ function(module, exports, __webpack_require__) {
	
	function injectStyle (ssrContext) {
	  __webpack_require__(105)
	}
	var Component = __webpack_require__(0)(
	  /* script */
	  __webpack_require__(49),
	  /* template */
	  __webpack_require__(176),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports
	
	
	/***/ },
	/* 161 */
	/***/ function(module, exports, __webpack_require__) {
	
	function injectStyle (ssrContext) {
	  __webpack_require__(110)
	}
	var Component = __webpack_require__(0)(
	  /* script */
	  __webpack_require__(50),
	  /* template */
	  __webpack_require__(182),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports
	
	
	/***/ },
	/* 162 */
	/***/ function(module, exports, __webpack_require__) {
	
	function injectStyle (ssrContext) {
	  __webpack_require__(97)
	}
	var Component = __webpack_require__(0)(
	  /* script */
	  __webpack_require__(51),
	  /* template */
	  __webpack_require__(168),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports
	
	
	/***/ },
	/* 163 */
	/***/ function(module, exports) {
	
	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "picker-slot",
	    class: _vm.classNames,
	    style: (_vm.flexStyle)
	  }, [(!_vm.divider) ? _c('div', {
	    ref: "wrapper",
	    staticClass: "picker-slot-wrapper",
	    class: {
	      dragging: _vm.dragging
	    },
	    style: ({
	      height: _vm.contentHeight + 'px'
	    })
	  }, _vm._l((_vm.mutatingValues), function(itemValue) {
	    return _c('div', {
	      staticClass: "picker-item",
	      class: {
	        'picker-selected': itemValue === _vm.currentValue
	      },
	      style: ({
	        height: _vm.itemHeight + 'px',
	        lineHeight: _vm.itemHeight + 'px'
	      })
	    }, [_vm._v("\n      " + _vm._s(typeof itemValue === 'object' && itemValue[_vm.valueKey] ? itemValue[_vm.valueKey] : itemValue) + "\n    ")])
	  })) : _vm._e(), _vm._v(" "), (_vm.divider) ? _c('div', [_vm._v(_vm._s(_vm.content))]) : _vm._e()])
	},staticRenderFns: []}
	
	/***/ },
	/* 164 */
	/***/ function(module, exports) {
	
	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "mint-indexlist"
	  }, [_c('ul', {
	    ref: "content",
	    staticClass: "mint-indexlist-content",
	    style: ({
	      'height': _vm.currentHeight + 'px',
	      'margin-right': _vm.navWidth + 'px'
	    })
	  }, [_vm._t("default")], 2), _vm._v(" "), _c('div', {
	    ref: "nav",
	    staticClass: "mint-indexlist-nav",
	    on: {
	      "touchstart": _vm.handleTouchStart
	    }
	  }, [_c('ul', {
	    staticClass: "mint-indexlist-navlist"
	  }, _vm._l((_vm.sections), function(section) {
	    return _c('li', {
	      staticClass: "mint-indexlist-navitem"
	    }, [_vm._v(_vm._s(section.index))])
	  }))]), _vm._v(" "), (_vm.showIndicator) ? _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.moving),
	      expression: "moving"
	    }],
	    staticClass: "mint-indexlist-indicator"
	  }, [_vm._v(_vm._s(_vm.currentIndicator))]) : _vm._e()])
	},staticRenderFns: []}
	
	/***/ },
	/* 165 */
	/***/ function(module, exports) {
	
	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('li', {
	    staticClass: "mint-indexsection"
	  }, [_c('p', {
	    staticClass: "mint-indexsection-index"
	  }, [_vm._v(_vm._s(_vm.index))]), _vm._v(" "), _c('ul', [_vm._t("default")], 2)])
	},staticRenderFns: []}
	
	/***/ },
	/* 166 */
	/***/ function(module, exports) {
	
	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "mint-swipe"
	  }, [_c('div', {
	    ref: "wrap",
	    staticClass: "mint-swipe-items-wrap"
	  }, [_vm._t("default")], 2), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.showIndicators),
	      expression: "showIndicators"
	    }],
	    staticClass: "mint-swipe-indicators"
	  }, _vm._l((_vm.pages), function(page, $index) {
	    return _c('div', {
	      staticClass: "mint-swipe-indicator",
	      class: {
	        'is-active': $index === _vm.index
	      }
	    })
	  }))])
	},staticRenderFns: []}
	
	/***/ },
	/* 167 */
	/***/ function(module, exports) {
	
	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "mt-progress"
	  }, [_vm._t("start"), _vm._v(" "), _c('div', {
	    staticClass: "mt-progress-content"
	  }, [_c('div', {
	    staticClass: "mt-progress-runway",
	    style: ({
	      height: _vm.barHeight + 'px'
	    })
	  }), _vm._v(" "), _c('div', {
	    staticClass: "mt-progress-progress",
	    style: ({
	      width: _vm.value + '%',
	      height: _vm.barHeight + 'px'
	    })
	  })]), _vm._v(" "), _vm._t("end")], 2)
	},staticRenderFns: []}
	
	/***/ },
	/* 168 */
	/***/ function(module, exports) {
	
	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('transition', {
	    attrs: {
	      "name": "mint-toast-pop"
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.visible),
	      expression: "visible"
	    }],
	    staticClass: "mint-toast",
	    class: _vm.customClass,
	    style: ({
	      'padding': _vm.iconClass === '' ? '10px' : '20px'
	    })
	  }, [(_vm.iconClass !== '') ? _c('i', {
	    staticClass: "mint-toast-icon",
	    class: _vm.iconClass
	  }) : _vm._e(), _vm._v(" "), _c('span', {
	    staticClass: "mint-toast-text",
	    style: ({
	      'padding-top': _vm.iconClass === '' ? '0' : '10px'
	    })
	  }, [_vm._v(_vm._s(_vm.message))])])])
	},staticRenderFns: []}
	
	/***/ },
	/* 169 */
	/***/ function(module, exports) {
	
	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('x-cell', {
	    directives: [{
	      name: "clickoutside",
	      rawName: "v-clickoutside:touchstart",
	      value: (_vm.swipeMove),
	      expression: "swipeMove",
	      arg: "touchstart"
	    }],
	    ref: "cell",
	    staticClass: "mint-cell-swipe",
	    attrs: {
	      "title": _vm.title,
	      "icon": _vm.icon,
	      "label": _vm.label,
	      "to": _vm.to,
	      "is-link": _vm.isLink,
	      "value": _vm.value
	    },
	    nativeOn: {
	      "click": function($event) {
	        _vm.swipeMove()
	      },
	      "touchstart": function($event) {
	        _vm.startDrag($event)
	      },
	      "touchmove": function($event) {
	        _vm.onDrag($event)
	      },
	      "touchend": function($event) {
	        _vm.endDrag($event)
	      }
	    }
	  }, [_c('div', {
	    ref: "right",
	    staticClass: "mint-cell-swipe-buttongroup",
	    slot: "right"
	  }, _vm._l((_vm.right), function(btn) {
	    return _c('a', {
	      staticClass: "mint-cell-swipe-button",
	      style: (btn.style),
	      domProps: {
	        "innerHTML": _vm._s(btn.content)
	      },
	      on: {
	        "click": function($event) {
	          $event.preventDefault();
	          $event.stopPropagation();
	          btn.handler && btn.handler(), _vm.swipeMove()
	        }
	      }
	    })
	  })), _vm._v(" "), _c('div', {
	    ref: "left",
	    staticClass: "mint-cell-swipe-buttongroup",
	    slot: "left"
	  }, _vm._l((_vm.left), function(btn) {
	    return _c('a', {
	      staticClass: "mint-cell-swipe-button",
	      style: (btn.style),
	      domProps: {
	        "innerHTML": _vm._s(btn.content)
	      },
	      on: {
	        "click": function($event) {
	          $event.preventDefault();
	          $event.stopPropagation();
	          btn.handler && btn.handler(), _vm.swipeMove()
	        }
	      }
	    })
	  })), _vm._v(" "), _vm._t("default"), _vm._v(" "), (_vm.$slots.title) ? _c('span', {
	    slot: "title"
	  }, [_vm._t("title")], 2) : _vm._e(), _vm._v(" "), (_vm.$slots.icon) ? _c('span', {
	    slot: "icon"
	  }, [_vm._t("icon")], 2) : _vm._e()], 2)
	},staticRenderFns: []}
	
	/***/ },
	/* 170 */
	/***/ function(module, exports) {
	
	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "mint-spinner-triple-bounce"
	  }, [_c('div', {
	    staticClass: "mint-spinner-triple-bounce-bounce1",
	    style: (_vm.bounceStyle)
	  }), _vm._v(" "), _c('div', {
	    staticClass: "mint-spinner-triple-bounce-bounce2",
	    style: (_vm.bounceStyle)
	  }), _vm._v(" "), _c('div', {
	    staticClass: "mint-spinner-triple-bounce-bounce3",
	    style: (_vm.bounceStyle)
	  })])
	},staticRenderFns: []}
	
	/***/ },
	/* 171 */
	/***/ function(module, exports) {
	
	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('transition', {
	    attrs: {
	      "name": "actionsheet-float"
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.currentValue),
	      expression: "currentValue"
	    }],
	    staticClass: "mint-actionsheet"
	  }, [_c('ul', {
	    staticClass: "mint-actionsheet-list",
	    style: ({
	      'margin-bottom': _vm.cancelText ? '5px' : '0'
	    })
	  }, _vm._l((_vm.actions), function(item, index) {
	    return _c('li', {
	      staticClass: "mint-actionsheet-listitem",
	      on: {
	        "click": function($event) {
	          $event.stopPropagation();
	          _vm.itemClick(item, index)
	        }
	      }
	    }, [_vm._v(_vm._s(item.name))])
	  })), _vm._v(" "), (_vm.cancelText) ? _c('a', {
	    staticClass: "mint-actionsheet-button",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        _vm.currentValue = false
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.cancelText))]) : _vm._e()])])
	},staticRenderFns: []}
	
	/***/ },
	/* 172 */
	/***/ function(module, exports) {
	
	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "mint-tab-container",
	    on: {
	      "touchstart": _vm.startDrag,
	      "mousedown": _vm.startDrag,
	      "touchmove": _vm.onDrag,
	      "mousemove": _vm.onDrag,
	      "mouseup": _vm.endDrag,
	      "touchend": _vm.endDrag
	    }
	  }, [_c('div', {
	    ref: "wrap",
	    staticClass: "mint-tab-container-wrap"
	  }, [_vm._t("default")], 2)])
	},staticRenderFns: []}
	
	/***/ },
	/* 173 */
	/***/ function(module, exports) {
	
	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "mint-badge",
	    class: ['is-' + _vm.type, 'is-size-' + _vm.size],
	    style: ({
	      backgroundColor: _vm.color
	    })
	  }, [_vm._t("default")], 2)
	},staticRenderFns: []}
	
	/***/ },
	/* 174 */
	/***/ function(module, exports) {
	
	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "mint-spinner-snake",
	    style: ({
	      'border-top-color': _vm.spinnerColor,
	      'border-left-color': _vm.spinnerColor,
	      'border-bottom-color': _vm.spinnerColor,
	      'height': _vm.spinnerSize,
	      'width': _vm.spinnerSize
	    })
	  })
	},staticRenderFns: []}
	
	/***/ },
	/* 175 */
	/***/ function(module, exports) {
	
	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    class: ['mint-spinner-fading-circle circle-color-' + _vm._uid],
	    style: ({
	      width: _vm.spinnerSize,
	      height: _vm.spinnerSize
	    })
	  }, _vm._l((12), function(n) {
	    return _c('div', {
	      staticClass: "mint-spinner-fading-circle-circle",
	      class: ['is-circle' + (n + 1)]
	    })
	  }))
	},staticRenderFns: []}
	
	/***/ },
	/* 176 */
	/***/ function(module, exports) {
	
	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('a', {
	    staticClass: "mint-tab-item",
	    class: {
	      'is-selected': _vm.$parent.value === _vm.id
	    },
	    on: {
	      "click": function($event) {
	        _vm.$parent.$emit('input', _vm.id)
	      }
	    }
	  }, [_c('div', {
	    staticClass: "mint-tab-item-icon"
	  }, [_vm._t("icon")], 2), _vm._v(" "), _c('div', {
	    staticClass: "mint-tab-item-label"
	  }, [_vm._t("default")], 2)])
	},staticRenderFns: []}
	
	/***/ },
	/* 177 */
	/***/ function(module, exports) {
	
	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('button', {
	    staticClass: "mint-button",
	    class: ['mint-button--' + _vm.type, 'mint-button--' + _vm.size, {
	      'is-disabled': _vm.disabled,
	      'is-plain': _vm.plain
	    }],
	    attrs: {
	      "type": _vm.nativeType,
	      "disabled": _vm.disabled
	    },
	    on: {
	      "click": _vm.handleClick
	    }
	  }, [(_vm.icon || _vm.$slots.icon) ? _c('span', {
	    staticClass: "mint-button-icon"
	  }, [_vm._t("icon", [(_vm.icon) ? _c('i', {
	    staticClass: "mintui",
	    class: 'mintui-' + _vm.icon
	  }) : _vm._e()])], 2) : _vm._e(), _vm._v(" "), _c('label', {
	    staticClass: "mint-button-text"
	  }, [_vm._t("default")], 2)])
	},staticRenderFns: []}
	
	/***/ },
	/* 178 */
	/***/ function(module, exports) {
	
	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('label', {
	    staticClass: "mint-switch"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.currentValue),
	      expression: "currentValue"
	    }],
	    staticClass: "mint-switch-input",
	    attrs: {
	      "disabled": _vm.disabled,
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.currentValue) ? _vm._i(_vm.currentValue, null) > -1 : (_vm.currentValue)
	    },
	    on: {
	      "change": function($event) {
	        _vm.$emit('change', _vm.currentValue)
	      },
	      "__c": function($event) {
	        var $$a = _vm.currentValue,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$c) {
	            $$i < 0 && (_vm.currentValue = $$a.concat($$v))
	          } else {
	            $$i > -1 && (_vm.currentValue = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.currentValue = $$c
	        }
	      }
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "mint-switch-core"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "mint-switch-label"
	  }, [_vm._t("default")], 2)])
	},staticRenderFns: []}
	
	/***/ },
	/* 179 */
	/***/ function(module, exports) {
	
	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('header', {
	    staticClass: "mint-header",
	    class: {
	      'is-fixed': _vm.fixed
	    }
	  }, [_c('div', {
	    staticClass: "mint-header-button is-left"
	  }, [_vm._t("left")], 2), _vm._v(" "), _c('h1', {
	    staticClass: "mint-header-title",
	    domProps: {
	      "textContent": _vm._s(_vm.title)
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "mint-header-button is-right"
	  }, [_vm._t("right")], 2)])
	},staticRenderFns: []}
	
	/***/ },
	/* 180 */
	/***/ function(module, exports) {
	
	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "mint-swipe-item"
	  }, [_vm._t("default")], 2)
	},staticRenderFns: []}
	
	/***/ },
	/* 181 */
	/***/ function(module, exports) {
	
	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('mt-popup', {
	    staticClass: "mint-datetime",
	    attrs: {
	      "closeOnClickModal": _vm.closeOnClickModal,
	      "position": "bottom"
	    },
	    model: {
	      value: (_vm.visible),
	      callback: function($$v) {
	        _vm.visible = $$v
	      },
	      expression: "visible"
	    }
	  }, [_c('mt-picker', {
	    ref: "picker",
	    staticClass: "mint-datetime-picker",
	    attrs: {
	      "slots": _vm.dateSlots,
	      "visible-item-count": _vm.visibleItemCount,
	      "show-toolbar": ""
	    },
	    on: {
	      "change": _vm.onChange
	    }
	  }, [_c('span', {
	    staticClass: "mint-datetime-action mint-datetime-cancel",
	    on: {
	      "click": function($event) {
	        _vm.visible = false;
	        _vm.$emit('cancel')
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.cancelText))]), _vm._v(" "), _c('span', {
	    staticClass: "mint-datetime-action mint-datetime-confirm",
	    on: {
	      "click": _vm.confirm
	    }
	  }, [_vm._v(_vm._s(_vm.confirmText))])])], 1)
	},staticRenderFns: []}
	
	/***/ },
	/* 182 */
	/***/ function(module, exports) {
	
	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "mint-tabbar",
	    class: {
	      'is-fixed': _vm.fixed
	    }
	  }, [_vm._t("default")], 2)
	},staticRenderFns: []}
	
	/***/ },
	/* 183 */
	/***/ function(module, exports) {
	
	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "mint-spinner-double-bounce",
	    style: ({
	      width: _vm.spinnerSize,
	      height: _vm.spinnerSize
	    })
	  }, [_c('div', {
	    staticClass: "mint-spinner-double-bounce-bounce1",
	    style: ({
	      backgroundColor: _vm.spinnerColor
	    })
	  }), _vm._v(" "), _c('div', {
	    staticClass: "mint-spinner-double-bounce-bounce2",
	    style: ({
	      backgroundColor: _vm.spinnerColor
	    })
	  })])
	},staticRenderFns: []}
	
	/***/ },
	/* 184 */
	/***/ function(module, exports) {
	
	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "mint-palette-button",
	    class: {
	      expand: _vm.expanded, 'mint-palette-button-active': _vm.transforming
	    },
	    on: {
	      "animationend": _vm.onMainAnimationEnd,
	      "webkitAnimationEnd": _vm.onMainAnimationEnd,
	      "mozAnimationEnd": _vm.onMainAnimationEnd
	    }
	  }, [_c('div', {
	    staticClass: "mint-sub-button-container"
	  }, [_vm._t("default")], 2), _vm._v(" "), _c('div', {
	    staticClass: "mint-main-button",
	    style: (_vm.mainButtonStyle),
	    on: {
	      "touchstart": _vm.toggle
	    }
	  }, [_vm._v("\n    " + _vm._s(_vm.content) + "\n  ")])])
	},staticRenderFns: []}
	
	/***/ },
	/* 185 */
	/***/ function(module, exports) {
	
	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('a', {
	    staticClass: "mint-cell",
	    attrs: {
	      "href": _vm.href
	    }
	  }, [(_vm.isLink) ? _c('span', {
	    staticClass: "mint-cell-mask"
	  }) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "mint-cell-left"
	  }, [_vm._t("left")], 2), _vm._v(" "), _c('div', {
	    staticClass: "mint-cell-wrapper"
	  }, [_c('div', {
	    staticClass: "mint-cell-title"
	  }, [_vm._t("icon", [(_vm.icon) ? _c('i', {
	    staticClass: "mintui",
	    class: 'mintui-' + _vm.icon
	  }) : _vm._e()]), _vm._v(" "), _vm._t("title", [_c('span', {
	    staticClass: "mint-cell-text",
	    domProps: {
	      "textContent": _vm._s(_vm.title)
	    }
	  }), _vm._v(" "), (_vm.label) ? _c('span', {
	    staticClass: "mint-cell-label",
	    domProps: {
	      "textContent": _vm._s(_vm.label)
	    }
	  }) : _vm._e()])], 2), _vm._v(" "), _c('div', {
	    staticClass: "mint-cell-value",
	    class: {
	      'is-link': _vm.isLink
	    }
	  }, [_vm._t("default", [_c('span', {
	    domProps: {
	      "textContent": _vm._s(_vm.value)
	    }
	  })])], 2), _vm._v(" "), (_vm.isLink) ? _c('i', {
	    staticClass: "mint-cell-allow-right"
	  }) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "mint-cell-right"
	  }, [_vm._t("right")], 2)])
	},staticRenderFns: []}
	
	/***/ },
	/* 186 */
	/***/ function(module, exports) {
	
	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "mint-msgbox-wrapper"
	  }, [_c('transition', {
	    attrs: {
	      "name": "msgbox-bounce"
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.value),
	      expression: "value"
	    }],
	    staticClass: "mint-msgbox"
	  }, [(_vm.title !== '') ? _c('div', {
	    staticClass: "mint-msgbox-header"
	  }, [_c('div', {
	    staticClass: "mint-msgbox-title"
	  }, [_vm._v(_vm._s(_vm.title))])]) : _vm._e(), _vm._v(" "), (_vm.message !== '') ? _c('div', {
	    staticClass: "mint-msgbox-content"
	  }, [_c('div', {
	    staticClass: "mint-msgbox-message",
	    domProps: {
	      "innerHTML": _vm._s(_vm.message)
	    }
	  }), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.showInput),
	      expression: "showInput"
	    }],
	    staticClass: "mint-msgbox-input"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.inputValue),
	      expression: "inputValue"
	    }],
	    ref: "input",
	    attrs: {
	      "placeholder": _vm.inputPlaceholder
	    },
	    domProps: {
	      "value": (_vm.inputValue)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.inputValue = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "mint-msgbox-errormsg",
	    style: ({
	      visibility: !!_vm.editorErrorMessage ? 'visible' : 'hidden'
	    })
	  }, [_vm._v(_vm._s(_vm.editorErrorMessage))])])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "mint-msgbox-btns"
	  }, [_c('button', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.showCancelButton),
	      expression: "showCancelButton"
	    }],
	    class: [_vm.cancelButtonClasses],
	    on: {
	      "click": function($event) {
	        _vm.handleAction('cancel')
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.cancelButtonText))]), _vm._v(" "), _c('button', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.showConfirmButton),
	      expression: "showConfirmButton"
	    }],
	    class: [_vm.confirmButtonClasses],
	    on: {
	      "click": function($event) {
	        _vm.handleAction('confirm')
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.confirmButtonText))])])])])], 1)
	},staticRenderFns: []}
	
	/***/ },
	/* 187 */
	/***/ function(module, exports) {
	
	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('x-cell', {
	    directives: [{
	      name: "clickoutside",
	      rawName: "v-clickoutside",
	      value: (_vm.doCloseActive),
	      expression: "doCloseActive"
	    }],
	    staticClass: "mint-field",
	    class: [{
	      'is-textarea': _vm.type === 'textarea',
	      'is-nolabel': !_vm.label
	    }],
	    attrs: {
	      "title": _vm.label
	    }
	  }, [(_vm.type === 'textarea') ? _c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.currentValue),
	      expression: "currentValue"
	    }],
	    ref: "textarea",
	    staticClass: "mint-field-core",
	    attrs: {
	      "placeholder": _vm.placeholder,
	      "rows": _vm.rows,
	      "disabled": _vm.disabled,
	      "readonly": _vm.readonly
	    },
	    domProps: {
	      "value": (_vm.currentValue)
	    },
	    on: {
	      "change": function($event) {
	        _vm.$emit('change', _vm.currentValue)
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.currentValue = $event.target.value
	      }
	    }
	  }) : _c('input', {
	    ref: "input",
	    staticClass: "mint-field-core",
	    attrs: {
	      "placeholder": _vm.placeholder,
	      "number": _vm.type === 'number',
	      "type": _vm.type,
	      "disabled": _vm.disabled,
	      "readonly": _vm.readonly
	    },
	    domProps: {
	      "value": _vm.currentValue
	    },
	    on: {
	      "change": function($event) {
	        _vm.$emit('change', _vm.currentValue)
	      },
	      "focus": function($event) {
	        _vm.active = true
	      },
	      "input": _vm.handleInput
	    }
	  }), _vm._v(" "), (!_vm.disableClear) ? _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.currentValue && _vm.type !== 'textarea' && _vm.active),
	      expression: "currentValue && type !== 'textarea' && active"
	    }],
	    staticClass: "mint-field-clear",
	    on: {
	      "click": _vm.handleClear
	    }
	  }, [_c('i', {
	    staticClass: "mintui mintui-field-error"
	  })]) : _vm._e(), _vm._v(" "), (_vm.state) ? _c('span', {
	    staticClass: "mint-field-state",
	    class: ['is-' + _vm.state]
	  }, [_c('i', {
	    staticClass: "mintui",
	    class: ['mintui-field-' + _vm.state]
	  })]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "mint-field-other"
	  }, [_vm._t("default")], 2)])
	},staticRenderFns: []}
	
	/***/ },
	/* 188 */
	/***/ function(module, exports) {
	
	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.$parent.swiping || _vm.id === _vm.$parent.currentActive),
	      expression: "$parent.swiping || id === $parent.currentActive"
	    }],
	    staticClass: "mint-tab-container-item"
	  }, [_vm._t("default")], 2)
	},staticRenderFns: []}
	
	/***/ },
	/* 189 */
	/***/ function(module, exports) {
	
	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', [_c(_vm.spinner, {
	    tag: "component"
	  })], 1)
	},staticRenderFns: []}
	
	/***/ },
	/* 190 */
	/***/ function(module, exports) {
	
	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "mint-radiolist",
	    on: {
	      "change": function($event) {
	        _vm.$emit('change', _vm.currentValue)
	      }
	    }
	  }, [_c('label', {
	    staticClass: "mint-radiolist-title",
	    domProps: {
	      "textContent": _vm._s(_vm.title)
	    }
	  }), _vm._v(" "), _vm._l((_vm.options), function(option) {
	    return _c('x-cell', [_c('label', {
	      staticClass: "mint-radiolist-label",
	      slot: "title"
	    }, [_c('span', {
	      staticClass: "mint-radio",
	      class: {
	        'is-right': _vm.align === 'right'
	      }
	    }, [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (_vm.currentValue),
	        expression: "currentValue"
	      }],
	      staticClass: "mint-radio-input",
	      attrs: {
	        "type": "radio",
	        "disabled": option.disabled
	      },
	      domProps: {
	        "value": option.value || option,
	        "checked": _vm._q(_vm.currentValue, option.value || option)
	      },
	      on: {
	        "__c": function($event) {
	          _vm.currentValue = option.value || option
	        }
	      }
	    }), _vm._v(" "), _c('span', {
	      staticClass: "mint-radio-core"
	    })]), _vm._v(" "), _c('span', {
	      staticClass: "mint-radio-label",
	      domProps: {
	        "textContent": _vm._s(option.label || option)
	      }
	    })])])
	  })], 2)
	},staticRenderFns: []}
	
	/***/ },
	/* 191 */
	/***/ function(module, exports) {
	
	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('transition', {
	    attrs: {
	      "name": "mint-indicator"
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.visible),
	      expression: "visible"
	    }],
	    staticClass: "mint-indicator"
	  }, [_c('div', {
	    staticClass: "mint-indicator-wrapper",
	    style: ({
	      'padding': _vm.text ? '20px' : '15px'
	    })
	  }, [_c('spinner', {
	    staticClass: "mint-indicator-spin",
	    attrs: {
	      "type": _vm.convertedSpinnerType,
	      "size": 32
	    }
	  }), _vm._v(" "), _c('span', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.text),
	      expression: "text"
	    }],
	    staticClass: "mint-indicator-text"
	  }, [_vm._v(_vm._s(_vm.text))])], 1), _vm._v(" "), _c('div', {
	    staticClass: "mint-indicator-mask",
	    on: {
	      "touchmove": function($event) {
	        $event.stopPropagation();
	        $event.preventDefault();
	      }
	    }
	  })])])
	},staticRenderFns: []}
	
	/***/ },
	/* 192 */
	/***/ function(module, exports) {
	
	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('transition', {
	    attrs: {
	      "name": _vm.currentTransition
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.currentValue),
	      expression: "currentValue"
	    }],
	    staticClass: "mint-popup",
	    class: [_vm.position ? 'mint-popup-' + _vm.position : '']
	  }, [_vm._t("default")], 2)])
	},staticRenderFns: []}
	
	/***/ },
	/* 193 */
	/***/ function(module, exports) {
	
	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "mint-loadmore"
	  }, [_c('div', {
	    staticClass: "mint-loadmore-content",
	    class: {
	      'is-dropped': _vm.topDropped || _vm.bottomDropped
	    },
	    style: ({
	      'transform': _vm.transform
	    })
	  }, [_vm._t("top", [(_vm.topMethod) ? _c('div', {
	    staticClass: "mint-loadmore-top"
	  }, [(_vm.topStatus === 'loading') ? _c('spinner', {
	    staticClass: "mint-loadmore-spinner",
	    attrs: {
	      "size": 20,
	      "type": "fading-circle"
	    }
	  }) : _vm._e(), _vm._v(" "), _c('span', {
	    staticClass: "mint-loadmore-text"
	  }, [_vm._v(_vm._s(_vm.topText))])], 1) : _vm._e()]), _vm._v(" "), _vm._t("default"), _vm._v(" "), _vm._t("bottom", [(_vm.bottomMethod) ? _c('div', {
	    staticClass: "mint-loadmore-bottom"
	  }, [(_vm.bottomStatus === 'loading') ? _c('spinner', {
	    staticClass: "mint-loadmore-spinner",
	    attrs: {
	      "size": 20,
	      "type": "fading-circle"
	    }
	  }) : _vm._e(), _vm._v(" "), _c('span', {
	    staticClass: "mint-loadmore-text"
	  }, [_vm._v(_vm._s(_vm.bottomText))])], 1) : _vm._e()])], 2)])
	},staticRenderFns: []}
	
	/***/ },
	/* 194 */
	/***/ function(module, exports) {
	
	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "mt-range",
	    class: {
	      'mt-range--disabled': _vm.disabled
	    }
	  }, [_vm._t("start"), _vm._v(" "), _c('div', {
	    ref: "content",
	    staticClass: "mt-range-content"
	  }, [_c('div', {
	    staticClass: "mt-range-runway",
	    style: ({
	      'border-top-width': _vm.barHeight + 'px'
	    })
	  }), _vm._v(" "), _c('div', {
	    staticClass: "mt-range-progress",
	    style: ({
	      width: _vm.progress + '%',
	      height: _vm.barHeight + 'px'
	    })
	  }), _vm._v(" "), _c('div', {
	    ref: "thumb",
	    staticClass: "mt-range-thumb",
	    style: ({
	      left: _vm.progress + '%'
	    })
	  })]), _vm._v(" "), _vm._t("end")], 2)
	},staticRenderFns: []}
	
	/***/ },
	/* 195 */
	/***/ function(module, exports) {
	
	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "mint-navbar",
	    class: {
	      'is-fixed': _vm.fixed
	    }
	  }, [_vm._t("default")], 2)
	},staticRenderFns: []}
	
	/***/ },
	/* 196 */
	/***/ function(module, exports) {
	
	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "mint-checklist",
	    class: {
	      'is-limit': _vm.max <= _vm.currentValue.length
	    },
	    on: {
	      "change": function($event) {
	        _vm.$emit('change', _vm.currentValue)
	      }
	    }
	  }, [_c('label', {
	    staticClass: "mint-checklist-title",
	    domProps: {
	      "textContent": _vm._s(_vm.title)
	    }
	  }), _vm._v(" "), _vm._l((_vm.options), function(option) {
	    return _c('x-cell', [_c('label', {
	      staticClass: "mint-checklist-label",
	      slot: "title"
	    }, [_c('span', {
	      staticClass: "mint-checkbox",
	      class: {
	        'is-right': _vm.align === 'right'
	      }
	    }, [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (_vm.currentValue),
	        expression: "currentValue"
	      }],
	      staticClass: "mint-checkbox-input",
	      attrs: {
	        "type": "checkbox",
	        "disabled": option.disabled
	      },
	      domProps: {
	        "value": option.value || option,
	        "checked": Array.isArray(_vm.currentValue) ? _vm._i(_vm.currentValue, option.value || option) > -1 : (_vm.currentValue)
	      },
	      on: {
	        "__c": function($event) {
	          var $$a = _vm.currentValue,
	            $$el = $event.target,
	            $$c = $$el.checked ? (true) : (false);
	          if (Array.isArray($$a)) {
	            var $$v = option.value || option,
	              $$i = _vm._i($$a, $$v);
	            if ($$c) {
	              $$i < 0 && (_vm.currentValue = $$a.concat($$v))
	            } else {
	              $$i > -1 && (_vm.currentValue = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	            }
	          } else {
	            _vm.currentValue = $$c
	          }
	        }
	      }
	    }), _vm._v(" "), _c('span', {
	      staticClass: "mint-checkbox-core"
	    })]), _vm._v(" "), _c('span', {
	      staticClass: "mint-checkbox-label",
	      domProps: {
	        "textContent": _vm._s(option.label || option)
	      }
	    })])])
	  })], 2)
	},staticRenderFns: []}
	
	/***/ },
	/* 197 */
	/***/ function(module, exports) {
	
	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "mint-search"
	  }, [_c('div', {
	    staticClass: "mint-searchbar"
	  }, [_c('div', {
	    staticClass: "mint-searchbar-inner"
	  }, [_c('i', {
	    staticClass: "mintui mintui-search"
	  }), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.currentValue),
	      expression: "currentValue"
	    }],
	    ref: "input",
	    staticClass: "mint-searchbar-core",
	    attrs: {
	      "type": "search",
	      "placeholder": _vm.placeholder
	    },
	    domProps: {
	      "value": (_vm.currentValue)
	    },
	    on: {
	      "click": function($event) {
	        _vm.visible = true
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.currentValue = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('a', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.visible),
	      expression: "visible"
	    }],
	    staticClass: "mint-searchbar-cancel",
	    domProps: {
	      "textContent": _vm._s(_vm.cancelText)
	    },
	    on: {
	      "click": function($event) {
	        _vm.visible = false, _vm.currentValue = ''
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.show || _vm.currentValue),
	      expression: "show || currentValue"
	    }],
	    staticClass: "mint-search-list"
	  }, [_c('div', {
	    staticClass: "mint-search-list-warp"
	  }, [_vm._t("default", _vm._l((_vm.result), function(item, index) {
	    return _c('x-cell', {
	      key: index,
	      attrs: {
	        "title": item
	      }
	    })
	  }))], 2)])])
	},staticRenderFns: []}
	
	/***/ },
	/* 198 */
	/***/ function(module, exports) {
	
	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "picker",
	    class: {
	      'picker-3d': _vm.rotateEffect
	    }
	  }, [(_vm.showToolbar) ? _c('div', {
	    staticClass: "picker-toolbar"
	  }, [_vm._t("default")], 2) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "picker-items"
	  }, [_vm._l((_vm.slots), function(slot) {
	    return _c('picker-slot', {
	      attrs: {
	        "valueKey": _vm.valueKey,
	        "values": slot.values || [],
	        "text-align": slot.textAlign || 'center',
	        "visible-item-count": _vm.visibleItemCount,
	        "class-name": slot.className,
	        "flex": slot.flex,
	        "rotate-effect": _vm.rotateEffect,
	        "divider": slot.divider,
	        "content": slot.content,
	        "itemHeight": _vm.itemHeight,
	        "default-index": slot.defaultIndex
	      },
	      model: {
	        value: (_vm.values[slot.valueIndex]),
	        callback: function($$v) {
	          var $$exp = _vm.values,
	            $$idx = slot.valueIndex;
	          if (!Array.isArray($$exp)) {
	            _vm.values[slot.valueIndex] = $$v
	          } else {
	            $$exp.splice($$idx, 1, $$v)
	          }
	        },
	        expression: "values[slot.valueIndex]"
	      }
	    })
	  }), _vm._v(" "), _c('div', {
	    staticClass: "picker-center-highlight",
	    style: ({
	      height: _vm.itemHeight + 'px',
	      marginTop: -_vm.itemHeight / 2 + 'px'
	    })
	  })], 2)])
	},staticRenderFns: []}
	
	/***/ },
	/* 199 */
	/***/ function(module, exports) {
	
	module.exports = __webpack_require__(59);
	
	/***/ },
	/* 200 */
	/***/ function(module, exports) {
	
	module.exports = __webpack_require__(167);
	
	/***/ },
	/* 201 */
	/***/ function(module, exports) {
	
	module.exports = __webpack_require__(178);
	
	/***/ },
	/* 202 */
	/***/ function(module, exports, __webpack_require__) {
	
	module.exports = __webpack_require__(14);
	
	
	/***/ }
	/******/ ]);

/***/ }),
/* 166 */
/***/ (function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ }),
/* 167 */
/***/ (function(module, exports) {

	/*
	 * raf.js
	 * https://github.com/ngryman/raf.js
	 *
	 * original requestAnimationFrame polyfill by Erik Möller
	 * inspired from paul_irish gist and post
	 *
	 * Copyright (c) 2013 ngryman
	 * Licensed under the MIT license.
	 */
	
	(function(window) {
		var lastTime = 0,
			vendors = ['webkit', 'moz'],
			requestAnimationFrame = window.requestAnimationFrame,
			cancelAnimationFrame = window.cancelAnimationFrame,
			i = vendors.length;
	
		// try to un-prefix existing raf
		while (--i >= 0 && !requestAnimationFrame) {
			requestAnimationFrame = window[vendors[i] + 'RequestAnimationFrame'];
			cancelAnimationFrame = window[vendors[i] + 'CancelAnimationFrame'];
		}
	
		// polyfill with setTimeout fallback
		// heavily inspired from @darius gist mod: https://gist.github.com/paulirish/1579671#comment-837945
		if (!requestAnimationFrame || !cancelAnimationFrame) {
			requestAnimationFrame = function(callback) {
				var now = +new Date(), nextTime = Math.max(lastTime + 16, now);
				return setTimeout(function() {
					callback(lastTime = nextTime);
				}, nextTime - now);
			};
	
			cancelAnimationFrame = clearTimeout;
		}
	
		// export to window
		window.requestAnimationFrame = requestAnimationFrame;
		window.cancelAnimationFrame = cancelAnimationFrame;
	}(window));


/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
	    "use strict";
	
	    if (global.setImmediate) {
	        return;
	    }
	
	    var nextHandle = 1; // Spec says greater than zero
	    var tasksByHandle = {};
	    var currentlyRunningATask = false;
	    var doc = global.document;
	    var registerImmediate;
	
	    function setImmediate(callback) {
	      // Callback can either be a function or a string
	      if (typeof callback !== "function") {
	        callback = new Function("" + callback);
	      }
	      // Copy function arguments
	      var args = new Array(arguments.length - 1);
	      for (var i = 0; i < args.length; i++) {
	          args[i] = arguments[i + 1];
	      }
	      // Store and register the task
	      var task = { callback: callback, args: args };
	      tasksByHandle[nextHandle] = task;
	      registerImmediate(nextHandle);
	      return nextHandle++;
	    }
	
	    function clearImmediate(handle) {
	        delete tasksByHandle[handle];
	    }
	
	    function run(task) {
	        var callback = task.callback;
	        var args = task.args;
	        switch (args.length) {
	        case 0:
	            callback();
	            break;
	        case 1:
	            callback(args[0]);
	            break;
	        case 2:
	            callback(args[0], args[1]);
	            break;
	        case 3:
	            callback(args[0], args[1], args[2]);
	            break;
	        default:
	            callback.apply(undefined, args);
	            break;
	        }
	    }
	
	    function runIfPresent(handle) {
	        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
	        // So if we're currently running a task, we'll need to delay this invocation.
	        if (currentlyRunningATask) {
	            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
	            // "too much recursion" error.
	            setTimeout(runIfPresent, 0, handle);
	        } else {
	            var task = tasksByHandle[handle];
	            if (task) {
	                currentlyRunningATask = true;
	                try {
	                    run(task);
	                } finally {
	                    clearImmediate(handle);
	                    currentlyRunningATask = false;
	                }
	            }
	        }
	    }
	
	    function installNextTickImplementation() {
	        registerImmediate = function(handle) {
	            process.nextTick(function () { runIfPresent(handle); });
	        };
	    }
	
	    function canUsePostMessage() {
	        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
	        // where `global.postMessage` means something completely different and can't be used for this purpose.
	        if (global.postMessage && !global.importScripts) {
	            var postMessageIsAsynchronous = true;
	            var oldOnMessage = global.onmessage;
	            global.onmessage = function() {
	                postMessageIsAsynchronous = false;
	            };
	            global.postMessage("", "*");
	            global.onmessage = oldOnMessage;
	            return postMessageIsAsynchronous;
	        }
	    }
	
	    function installPostMessageImplementation() {
	        // Installs an event handler on `global` for the `message` event: see
	        // * https://developer.mozilla.org/en/DOM/window.postMessage
	        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages
	
	        var messagePrefix = "setImmediate$" + Math.random() + "$";
	        var onGlobalMessage = function(event) {
	            if (event.source === global &&
	                typeof event.data === "string" &&
	                event.data.indexOf(messagePrefix) === 0) {
	                runIfPresent(+event.data.slice(messagePrefix.length));
	            }
	        };
	
	        if (global.addEventListener) {
	            global.addEventListener("message", onGlobalMessage, false);
	        } else {
	            global.attachEvent("onmessage", onGlobalMessage);
	        }
	
	        registerImmediate = function(handle) {
	            global.postMessage(messagePrefix + handle, "*");
	        };
	    }
	
	    function installMessageChannelImplementation() {
	        var channel = new MessageChannel();
	        channel.port1.onmessage = function(event) {
	            var handle = event.data;
	            runIfPresent(handle);
	        };
	
	        registerImmediate = function(handle) {
	            channel.port2.postMessage(handle);
	        };
	    }
	
	    function installReadyStateChangeImplementation() {
	        var html = doc.documentElement;
	        registerImmediate = function(handle) {
	            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
	            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
	            var script = doc.createElement("script");
	            script.onreadystatechange = function () {
	                runIfPresent(handle);
	                script.onreadystatechange = null;
	                html.removeChild(script);
	                script = null;
	            };
	            html.appendChild(script);
	        };
	    }
	
	    function installSetTimeoutImplementation() {
	        registerImmediate = function(handle) {
	            setTimeout(runIfPresent, 0, handle);
	        };
	    }
	
	    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
	    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
	    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;
	
	    // Don't get fooled by e.g. browserify environments.
	    if ({}.toString.call(global.process) === "[object process]") {
	        // For Node.js before 0.9
	        installNextTickImplementation();
	
	    } else if (canUsePostMessage()) {
	        // For non-IE10 modern browsers
	        installPostMessageImplementation();
	
	    } else if (global.MessageChannel) {
	        // For web workers, where supported
	        installMessageChannelImplementation();
	
	    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
	        // For IE 6–8
	        installReadyStateChangeImplementation();
	
	    } else {
	        // For older browsers
	        installSetTimeoutImplementation();
	    }
	
	    attachTo.setImmediate = setImmediate;
	    attachTo.clearImmediate = clearImmediate;
	}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(166)))

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
	            (typeof self !== "undefined" && self) ||
	            window;
	var apply = Function.prototype.apply;
	
	// DOM APIs, for completeness
	
	exports.setTimeout = function() {
	  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
	};
	exports.setInterval = function() {
	  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
	};
	exports.clearTimeout =
	exports.clearInterval = function(timeout) {
	  if (timeout) {
	    timeout.close();
	  }
	};
	
	function Timeout(id, clearFn) {
	  this._id = id;
	  this._clearFn = clearFn;
	}
	Timeout.prototype.unref = Timeout.prototype.ref = function() {};
	Timeout.prototype.close = function() {
	  this._clearFn.call(scope, this._id);
	};
	
	// Does not start the time, just sets up the members needed.
	exports.enroll = function(item, msecs) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = msecs;
	};
	
	exports.unenroll = function(item) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = -1;
	};
	
	exports._unrefActive = exports.active = function(item) {
	  clearTimeout(item._idleTimeoutId);
	
	  var msecs = item._idleTimeout;
	  if (msecs >= 0) {
	    item._idleTimeoutId = setTimeout(function onTimeout() {
	      if (item._onTimeout)
	        item._onTimeout();
	    }, msecs);
	  }
	};
	
	// setimmediate attaches itself to the global object
	__webpack_require__(168);
	// On some exotic environments, it's not clear which object `setimmediate` was
	// able to install onto.  Search each possibility in the same order as the
	// `setimmediate` library.
	exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
	                       (typeof global !== "undefined" && global.setImmediate) ||
	                       (this && this.setImmediate);
	exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
	                         (typeof global !== "undefined" && global.clearImmediate) ||
	                         (this && this.clearImmediate);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/context_img.9ba4cf4.png";

/***/ }),
/* 171 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 172 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAZCAMAAAAPIl6bAAAAY1BMVEUAAADHx8zHx8zHx8zHx8zHx8zHx8zHx8zHx8zHx8zHx8zHx8zHx8zHx8zHx8zHx8zHx8zHx8zHx8zHx8zHx8zHx8zHx8zHx8zHx8zHx8zHx8zHx8zHx8zHx8zHx8zHx8zHx8zpBlTOAAAAIHRSTlMAEODoyzEWCO/SJiEa+tvWxLW9aGIqHgOrpZ2IdE9AOY8mEdcAAAB8SURBVBjTbc/ZEkQwEIXhiGEYmdj3Le//lHQUfYJz939VqkUIUQ2twJXG9K3T+7ovw2hoOcj0kOpPUoDMVjKQJbLisQQ+yQfkJ62ELComiUG8jCRV8NVx/epGU8vk7ES+tW7cq1pd7bsX6qNDbPyn4N4Rv4uBGoQat+bYG1DsDwzif9epAAAAAElFTkSuQmCC"

/***/ }),
/* 173 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 174 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMgAAADICAYAAACtWK6eAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyNpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMDE0IDc5LjE1Njc5NywgMjAxNC8wOC8yMC0wOTo1MzowMiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6OTk2QkI4RkE3NjE2MTFFNUE4NEU4RkIxNjQ5MTYyRDgiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6OTk2QkI4Rjk3NjE2MTFFNUE4NEU4RkIxNjQ5MTYyRDgiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIChNYWNpbnRvc2gpIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6NjU2QTEyNzk3NjkyMTFFMzkxODk4RDkwQkY4Q0U0NzYiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6NjU2QTEyN0E3NjkyMTFFMzkxODk4RDkwQkY4Q0U0NzYiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz5WHowqAAAXNElEQVR42uxda4xd1XVe53XvvD2eGQ/lXQcKuDwc2eFlCAGnUn7kT6T86J/+aNTgsWPchJJYciEOCQ8hF+G0hFCIHRSEqAuJBCqRaUEIEbmBppAIBGnESwZje8COZ+y587j3PLq+ffadGJix53HvPevcuz60xPjec89ZZ+39nf04+9vLSZKEFArFzHA1BAqFEkShUIIoFEoQhUIJolAoQRQKJYhCoQRRKJQgCoUSRKFQKEEUCiWIQrFo+Gv/8/YH+f/nsMWSHHMChyhxqPTTdyncWyJ3ScD/ztipiB3wXSqu6P17avN+TyFC5ggv4tRnmoxWTP1+5F+Mz17GPvPl49EKBWd3UsfXllPiso8VcYtmPba3fNuKrBVXrGFCbrdPwXndFL49ltI367roOpSUI4pGypv9s7q+ltj6JxqOQ07Bo/DgxGb2/a8cX0CnAWXJ5etz2TqdHiXHKlKj9w6i9XX8Ic41DmI8FVHhmmXk85MmRhCzJoiTWnig9LfJRHihgydxzAxJhBr7Bh/hK3yu+p9568FliTJF2aKMZfVd/kQOcKP6OBmS9+Rjm4zJ6faoeN0gOUn61MncLX4CJ+MRhe+P/dRxhfew2Df4CF/hs4jWg8vQYUKYMuWyRRkLjeHQ8YP0Z9mekVjA8Qj3VVcuoeDiXu63lkUE0ym6FA5PXBaNVr7qtPumGyPR4Bt8hK/wWUR5chn6XJYoU5StUHL8l+XEx2axhkS6yk+chJuP4rXLyOkIKJkS0B67adcqfL/0Y4pixxSysK6V8Yl9Mz7i3272NRFlhzJsu24Z5l9E9Ahmwfrpoj7uw3fZtktsRZKjIXnndlLxin7+W8ZTBwPf6I+Tg9HwxK2Ob8citbCoBoaxBxMCvsFH+CqjHCtUvLzflKWUcpwB91gupG5f9/Rtx39ZZBtmWyJtphKzHTQW0diP36b4aJmcLj/zGaSkHJPb4SWFi/tOJd8bTqd9s48VBRh4RKeUX/vjgXg8cpyCmz05xkJylxSoa8M5RF0eJaVIIkGOsg2yTc3UgpD94psiWxEOqDNYoOIXuHnGwE5AXUTFi46FTnRw4l/dwEm7/pSxcYnCF/gE3zInh52RRJkVP7/MlKFQcgCbjifHTAQBfsb2qsgBO3e1Cpf3UXBej3nRJKKrxU/rcH/pKzz4vNIQuRJTEmZklbg6EL4SPsE3GQPzinmfhbJDGQolB+r8w58abs5y8DqRt4ABeptLRR7koY9NleybEYw/MPisvF/ayT1/SvDewcnIcG32wfiCAbEvoCZyGaGsitdyz6XdTctQJq6fcT5mloNfYvu5yFZkpEz+RT0UrFoqpxVBV+vQxIrkaPnrbqdvXs6hcjbU+Jq4Nvvwd/BFRNeq2npwWfkX95iyE9p6PM72P/MhCPANTBSKu5WITHcC074Y9CUTkYglKBgcV/aVtlM5Kpp/RHFjDdfka7MP/2wG6m72661QNigjlBXKTGBtsjWKNs5atCf44Uds3xc5YD8Wknd2BxWuGjCzIxLWQzlFj+IjU108OL7bafM5sm5DDdfka/8T+9AJXyTMpqFsUEYoK5SZ0NbjVlvX500Q4Ha2A+JuCcEvhVS8qp/8MzspHhMSfO7mVPaP35BMRp9JsCQldbX+hmvxNfnamzJfqVvtWnGZoGxQRigroYs6UbfvOGHn4ORVkTaIbEWwtqg3MNO+Zql0JGCdVuCayhDuG9uJB7vp+oR17FbZc+NauCauLWLmKkqXr6NsUEYoK6GtxwY6CXXnEs0n2faIHLCPhhR8bikFKwRN+xZddHWu5a7Ol9yCZ2ZwHKdOxufGNeKRqS/hmnLWW1VMmQSrl5oyEkqOPbZu02IJAsic9sU7B+5uF9cOmqUfeLOdOaAZYb/CA+M/Ic9NxUoYMNfD/PT84f7xB807EAnrrbgMUBZt1w1SEpCIqfjF1Om5EuQNth0iu1r8tPLP76LCpX2yWpHDk2dGH018p6brtD5hOHf04cR3okOTZ0lqPVAW3gVdlMhdrfsTW6drRhDgRrYJcbeKZQxTkenvegNt6YBQwrQvOxG+P3ZHEia9TuClS9Br1XKge8XnxLlxjelzZ/2w4tijDMxyoHIsVQg1zvYPcy7KeZx4jG2zyFakFJF7Whu1XT2QvhfJeryeVNdplYPo4Pi9hKd7VVxVC8O5cH4+N65hXgoKuGfEHmWAskjGxI49Ntu6XHOCAD9ie1PcLSepjDNY00fB8m6KpSyJx/jgg9LfJEfLK40818w+LXY5e5zKaMfKl+DcIlSCZp0cd3U59igDI4+WOa2LunvfvDoD9RrcNLqAjDy3yzfrtKqbAkggSDIZmSlYxzz9a8BaJ101zF2rh3BuSTJaCKGMDEGujHbedXch0X2ebbdEkkDC6a9cQoWVguS53P0JP5xcHY1W/tppD9KxgrdAw5QxnwPn4nOukrPeqkzBJb0m9oJltLtt3a07QYD1IkMAeS7/hw0BXMhzJwXJc/eV7kuiyIN8OOGuUhLP06JUeoxz4FxiZLRouTsDM9WO2OdBRtsIgrzHtk3kgH00JO+cTipc2S9jqyCaluf2xwcnfuB6LndHuEsSzdP4N/gtzoFzSZHRIsaQQiPmidyXgttsnW0YQYDvsh2ROGBPxkMqXjNA/qlCFsnZ8UdlX+kfk0pymlnMWH2JOBfz0sWI+C3OMS1dzPphhPVWHOPC5wdMzIUOzFFHb1lwB2ARF+ZOPt0gshWBPLe/wCRZlu6CIkSei/cE0fD4g2ZbVWceyxH5WPwGvzXrrSTJaDnG7oBoGS3qaCULggCPsv1W5IAd8tzLllJwvpx1WthMIfyg9OVotHy1WVQ4V37wsfgNfkuSZLQcW8Q4lruU/RVbRykrggDXiwwN3uQWnXTa1xMkz2W/on2lndNajpNtAGePw2/MOicBMlqs+8K7GBNbjrFgGe2iX0nUgiAvs+0S2YpgndaFPVRc3SdmVanZlfGjifOiw5PrT/oGvPpG/vDkEH4jZ70Vt86rl5rYimmdP41/s3Uzc4Isup9XNxwvz+0tyNAlONPrtO6hctR+QnluKqNt52O3pxvtClhvxTH0egtmEwbBMlrUxU21OFGtCHKYbavIATv3j90z26kIea4QZRtahfhIuT0anrjH7O3rpjNVHzPIaLG3Lh8Tj5TbRQihjlNyehxTwTLarbZOiiEIcBfbPnGhMtroChXW9JN/VqeYdyPEY4nwwPj6ZCL8C1T+T61JhDqRv8MxZgwlJG2BxzEsrBmgeEzseqt9ti6SNIIA8t6wm901eFDZ66d7M4UkQ56LVgTTvvtKaRqFqoTWymjxGb6LpUzrImYcuzaOIWKJmAptPWpaB2sd+V+yvSB1wB6s7qXgwiUyBpbJdBqFq6MjU18mKCKhRsTyEbx558/wnRmYJzLiV+DYBat6JQ/MX7B1UCxBAKHy3IQrH6W7MhY9MWkUMNAN948/8Mm35/jMDIKlpC3gmBWQtsAjifkE61b36kGQP7DdL7KrVZXnXiYpjYKZxj09Gh7f4kB4yIa/8ZmU1brIIYiYIXaJ3Nbjflv3xBME+DZbSVwIzfIIK89dJkSea18Ihu+XflD9yPztCJnW5Ri5VRntpNh8giVb5ygvBIHu9yaRrchYRO6fFU0CSTPQlDLte6zshx9O3g3D3yJajySd4EDaAsQMsRPaetxk61zty+YTCXRqjf9jO19cOLnyYV+p8QffpcreMXJ7BeRgh77Ds6SIYhGbMBgB2tld1DW0nGL4VxbZfKBbdUHdhol1dl7mOi0MOjttGgWT11lAwU9r1mMSsX0oxwSxgYyWOvKXtiAvBPkV239I7GqZdVqX9FDw2V5+UoYipn2nt/WRMK3LMQlW9poYCZ7WfcrWsdwSBNggMrRYdcLdhjas0+q28lzJOc8bOU7jWLh2AwzEyLxclYm6Z2ZuBEE+YLtTZEVA9tzPdBh5biJ3q5rGD8yRjXbNAPkcm0RuyjTUqf3NQBDge2yHJFaGeDyi4tUD5J3WIXmzs8Y9NDgG3un80OCYIDZCHxqHbJ2iZiEIGmnB8twgzYIkd7vMxiBON59GLJyBQLKMdiM1qOPXyMn2f2f7X5EDdshzkUbhAtED0oZMXCAGiIXgtAW/YXusURdr9NsoufLcgmP20zKy2ErrNSNGRuunMUAshL7zABq61q/RBPkd2yNSn57+X3ZTQZA8t7H3H5p7RwwEt6KP2DrUtAQBIIUsiwt99Kf+tydFntuocVhVRltNWyBTRlumGslopRNkhO1mkRVlLCT3jHYzqyU48WSN+1ZWRou0BZDRyp3Ju9nWnaYnCHA3216JlQWy0gKy557dJSaNQn0nKNL1VrhnwTLavbbOUKsQBBApzzVpFHqsPFdIGoW6AfeG7cMwrcv3TC0io80LQZ5me07kU3WkYqSlhYvkpFGoz8C8bO7RyGjlpi14ztaVliMIIFOeizQKbpI+WdsDGfLcWvcmsaK53b4gdUW3lENZXjxrgrzNdq/IAftohbzzOql4eV/zjUUcu96K7w33KFhGi7rxVisTBEBSxWPiiqYqz71mGfmDQuS5tSIHstHyPZnd7+XKaI+RgKSxEggySWmKaXkVaSwi5xSbRmGiSdZpxVZGy/eEexMso73R1o2WJwiwk+11kQNZrNO6oo+Cc7vz39Wy07q4l+CKfnNvQu/ndVsnSAkifcCOAXq7R8W1y9JdRvI87QvfnTRtgdPeujLavBLkv9meEPnUHS2Tf1EPFT67lOKRnE77munrsrkH/+IeydPXqAO/VoLMDMhz5T2irTzXpFHoKeRPnluV0XYX0mlduTLamIRJtKUR5CDbbSIrGPfX/eUdVFyTQ3luku6OaNIW/HmH5LQFt9k6oAQ5Ab7PNiyxkmGndUhRvTNyJM9F1wrZaM9IZbQmG63MocewxIejRIKg+DaKbEXGI3KWBtT2hUFKyonUZeEfB3xkX4vsM3wXvIx/IwmMqCu0WH/B9qLIpzG6Wp/rpWBFj/x1WnaCAb4G7LPgad0XbZmTEmTukDnti0yzgZvKcwNPtDzXyGjZR5ONFincVEbbVAR5je0hkU/lkTL5F3TZzQ2EvjysJr1hH/0LuiVPTz9ky1oJsgB8iwQsN5hplISns5Hn9hXl9eurMlr2zUzrVsQuk5m0ZUxKkIXhKNsWkQN2yHNPhzx3WbqQMRZGYCOjXWZ8FDzjtsWWsRJkEfgh2zvyOvhWnovsucu75GTPtdlo4RN8i+W+s3nHli0pQRaPIXEeVeW53V46YJciz2Uf4IvxiX0juW/9h/JQ8fJCkGfZnpE5YK9QsHIJBZcIkOdW141d3Gt8EiyjfcaWqRKk6Z84kOc6duODjmzluUZGyz4g6Q18UhltaxHkXbbtIgfsRyvknQt5bobZc6dltP3Gl0SudmW7LUslSJ1mPUbFeWVUepDnDpB3SgazRtW0BXxt+ABfhE7rypyVbCKCTLF9U2QrgjQKg3b7zskGv3eI0+XsuDZ8EJy2YJMtQyVIHfEztldFDtghz728j4LzGphGoZq2gK9ZMDuwiH3ngTJ7OG+VLY8EAeTKc9ts9lwk42zEOi2st+JrYZIA1xYso12Xx4qWV4K8xPZzka3ISCrPDVY1YJ1WtfVYZWW0ctdbPW7LTAnSQHyDJCoykEYhTNdpuUsK6YDZqQ85cG5cw6y3CsWmLYBXG/NayfJMkI8oVR/KG7AfC8k7u4MKVw2kM1r1eB2RpDNXuAauJVhGe6stKyVIBrid7YA4r6o5N5BG4cxOI3mtaeWtymj53LiG4FwmKJs78lzB8k4QVIsN4ryqynN7AzP1ShXIc2tYg3GuSpJO6/aKltHK3KWmhQgCPMm2R+SAfTSkANlzV9Rw2rc6MDcyWtHZaPfYsiElSPaQOYVYiSnxiIprB8kpeGn+v8U2mZD8FjxzTpybKjqtqwQ5Od5g2yGyq4Xsued3UeHSvsW3IlUZLZ8L5xSctmCHLRMliCBgN/AJcV7F6SpbjBe8gUWkUaimLeBzmOUsU2JltOMkcbd+JQiNkYB8ErNVbPe0Nmq72i4kXMiwNUnfe+AcOJfgfCWbbVkoQQTiR2xvivPKynODNX0ULF9AGoVq2gL+Lc4hWEaL2N/XTBWq2Qgic3BYled2+ekeVfOV51az0WKNF59DsIx2XbNVpmYkyPNsuyWSBBJYf+USKsxHnlvNRsu/8WXLaHfb2CtBcoD1Ir2CPJf/wxSt2xmkupGT9c6QtoCPNdO66FfJldGub8aK1KwEeY9tm8gB+2hI3jmdVLii/+RbBdktfHAsfpPIfSm4zcZcCZIjfJftiMQBO1IQQBrrn3qCRYZ20SOOMTLacbHrrRDjW5q1EjUzQbiTTzeIbEUgz+232XNne59RfX+CbLT9omW0iHFFCZJPPMr2W5EDdshzL1tKwfkzrNOqrrfi73CMYBntKzbGpATJL64X6RXWZRVtxlnP+VgaBZO2wEu/wzGatkAJUk+8zLZLZCuCdVoXciux+rhVuXYVMD7Dd7Hc9Va7bGyVIE0Amf3kaXnuIHm9qTwXhr/xmWAZbUXk+E4JsmAcZtsqcsAOee6Z7VS08lwY/sZngmW0W21MlSBNhLvY9onzCqtIxipUuKqf3L6iMfyNz4RO6+6zsWwJ+NRawNvep8S1IhMxucie+8VT0o+6PIqPiB17rG+lCtNqBPkl2wts14gbsCONwqVLzT8Fr7d6wcawZeBS60Hm1GSSTu+a6d5EY6cEyQ5/YLtf4oCd4iQ1ma3H/TZ2SpAWwLfZSqSYK0o2ZqQEaQ1AN32T1vs54yYbMyVIC+GBVuwyLLBL+kCr3rzb4oV/vdZ/jZESZHb8iqS9F5GFp2yMlCAtjCENgcZGCTI79rPdqWH4FO60sVGCKOh7bIc0DNM4ZGNCShAFEFKOsyDVARttTJQgGoJpPMb2Gw2DicFjGgYlyExYpyHQGChBZsfv2B5p4ft/xMZAoQSZFZso3TKo1VC2965QgpwQI2w3t+B932zvXaEEOSnuZtvbQve7196zQgkyZ6zXe1UoQWbH02zPtcB9PmfvVaEEmTeG9B6VIIrZ8RbbvU18f/fae1QoQRYMJKU81oT3dYwkJj1VguQOk9REaY2Pw4323hRKkEVjJ9vrTXQ/r9t7UihBaobr9V6UIIrZ8Wu2J5rgPp6w96JQgtQcG2jmhGl5QWzvQaEEqQsOst2WY/9vs/egUILUtZIN59Dv4ZyTWwmSEyDnUx7luRtJar4qJUjT4RdsL+bI3xetzwolSMOwTn1Vgihmx2tsD+XAz4esrwolSMPxLZK9XGPS+qhQgmSCo2xbBPu3xfqoUIJkhh+yvSPQr3esbwolSOYYUp+UIIrZ8SzbM4L8ecb6pFCC6BNbWw8lSB7wLtt2AX5st74olCDikPWskfRZNSVIi2OKst2+c5P1QaEEEYuH2V7N4Lqv2msrlCDisa5FrqkEUSwIL7E93sDrPW6vqVCC5AaN0l/kVZ+iBGlxfMR2awOuc6u9lkIJkjvcwXagjuc/YK+hUILkEgnVdxeRDfYaCiVIbvEk2546nHePPbdCCZJ7rMvJORVKkEzwBtuOGp5vhz2nQgnSNMBu6uM1OM84Nedu80qQFscY1SYfx2Z7LoUSpOlwH9ubi/j9m/YcCiWIDth1YK4EaUU8z7Z7Ab/bbX+rUII0PdY36DcKJUgu8R7btnkcv83+RqEEaRncwnZkDscdsccqlCAthQrbDXM47gZ7rEIJ0nJ4lO2VE3z/ij1GoQRpWaxb4HcKJUhL4GW2XTN8vst+p1CCtDw+Oc6Y6/hEoQRpCRxm23rcv7fazxRKEIXFXZRuwBDZvxUC4GsIREHflguDkyQqaVYotIulUChBFAoliEKhBFEolCAKhRJEoVCCKBRKEIVCCaJQKJQgCoUSRKFQgigUShCFIhP8vwADACog5YM65zugAAAAAElFTkSuQmCC"

/***/ }),
/* 175 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACEAAAAhCAYAAABX5MJvAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA2lpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDIxIDc5LjE1NDkxMSwgMjAxMy8xMC8yOS0xMTo0NzoxNiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDpBNTUyMjA5OEJDREVFNjExQThERUI3MjI5QTdBQUFCQiIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDoyMUMxNDdDNTkzQUQxMUU3ODUzMUU1N0VERkUwMDgyNCIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDoyMUMxNDdDNDkzQUQxMUU3ODUzMUU1N0VERkUwMDgyNCIgeG1wOkNyZWF0b3JUb29sPSJBZG9iZSBQaG90b3Nob3AgQ0MgKFdpbmRvd3MpIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6NDUyYmYxNDctZmUzZC04MDQzLTkyZTktMzQxNjg5ZGU5ZTllIiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOkE1NTIyMDk4QkNERUU2MTFBOERFQjcyMjlBN0FBQUJCIi8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+IpPY/AAAAXNJREFUeNpi/P//P8NAAyaGQQBGHQEDLNQySHbbakYgNQ2Io4DY7bFX6MmBCAmQAzKAmA+Id9E9OoCh0AF1AAycpasjoA4oRxLaD8Q+pJjBSEk5gcUBx4HYBZgevtElJIAOqERzwCkg9iTVAWQ7AuiACiDVhuYAUI74SI55JEcH1AHtSEIXgNiBXAeQ7AigA7KB1BQkoStA7AR0wGu6lJhAB2TSwgFEhwTUAdOQhG4AsR01HECUI4AOiANSC5GE7kLTwBN6VmDz0PgZ1HQAsY4oQOP3A0NHlK6OAPoalBgrkYR0gHgn0CH8dG1PAB3SgeYQQ1BNSS2HEJ1FoQ6pRhIyo5ZDSCq2gQ4BFdWdaA7ZBnQIF12bd0CHVKA5xAqIt1DiELIqMCwOcaTEIZQ0akAJdQaaQzYCHcJGN0cAQwNU1GahOcQFiNeQ6hCKmnc4HOILcghd25hIDlmGFiL0bW1DHRIHdch3ujZ0R/uiw9IRAAEGAOcqjTno3uoVAAAAAElFTkSuQmCC"

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/vip.e60b72e.png";

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

	(function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory();
		else if(typeof define === 'function' && define.amd)
			define([], factory);
		else if(typeof exports === 'object')
			exports["vue-filter"] = factory();
		else
			root["vue-filter"] = factory();
	})(this, function() {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// identity function for calling harmony imports with the correct context
	/******/ 	__webpack_require__.i = function(value) { return value; };
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, {
	/******/ 				configurable: false,
	/******/ 				enumerable: true,
	/******/ 				get: getter
	/******/ 			});
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 8);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ (function(module, exports, __webpack_require__) {
	
	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;//     Underscore.js 1.8.3
	//     http://underscorejs.org
	//     (c) 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	//     Underscore may be freely distributed under the MIT license.
	
	(function() {
	
	  // Baseline setup
	  // --------------
	
	  // Establish the root object, `window` in the browser, or `exports` on the server.
	  var root = this;
	
	  // Save the previous value of the `_` variable.
	  var previousUnderscore = root._;
	
	  // Save bytes in the minified (but not gzipped) version:
	  var ArrayProto = Array.prototype, ObjProto = Object.prototype, FuncProto = Function.prototype;
	
	  // Create quick reference variables for speed access to core prototypes.
	  var
	    push             = ArrayProto.push,
	    slice            = ArrayProto.slice,
	    toString         = ObjProto.toString,
	    hasOwnProperty   = ObjProto.hasOwnProperty;
	
	  // All **ECMAScript 5** native function implementations that we hope to use
	  // are declared here.
	  var
	    nativeIsArray      = Array.isArray,
	    nativeKeys         = Object.keys,
	    nativeBind         = FuncProto.bind,
	    nativeCreate       = Object.create;
	
	  // Naked function reference for surrogate-prototype-swapping.
	  var Ctor = function(){};
	
	  // Create a safe reference to the Underscore object for use below.
	  var _ = function(obj) {
	    if (obj instanceof _) return obj;
	    if (!(this instanceof _)) return new _(obj);
	    this._wrapped = obj;
	  };
	
	  // Export the Underscore object for **Node.js**, with
	  // backwards-compatibility for the old `require()` API. If we're in
	  // the browser, add `_` as a global object.
	  if (true) {
	    if (typeof module !== 'undefined' && module.exports) {
	      exports = module.exports = _;
	    }
	    exports._ = _;
	  } else {
	    root._ = _;
	  }
	
	  // Current version.
	  _.VERSION = '1.8.3';
	
	  // Internal function that returns an efficient (for current engines) version
	  // of the passed-in callback, to be repeatedly applied in other Underscore
	  // functions.
	  var optimizeCb = function(func, context, argCount) {
	    if (context === void 0) return func;
	    switch (argCount == null ? 3 : argCount) {
	      case 1: return function(value) {
	        return func.call(context, value);
	      };
	      case 2: return function(value, other) {
	        return func.call(context, value, other);
	      };
	      case 3: return function(value, index, collection) {
	        return func.call(context, value, index, collection);
	      };
	      case 4: return function(accumulator, value, index, collection) {
	        return func.call(context, accumulator, value, index, collection);
	      };
	    }
	    return function() {
	      return func.apply(context, arguments);
	    };
	  };
	
	  // A mostly-internal function to generate callbacks that can be applied
	  // to each element in a collection, returning the desired result — either
	  // identity, an arbitrary callback, a property matcher, or a property accessor.
	  var cb = function(value, context, argCount) {
	    if (value == null) return _.identity;
	    if (_.isFunction(value)) return optimizeCb(value, context, argCount);
	    if (_.isObject(value)) return _.matcher(value);
	    return _.property(value);
	  };
	  _.iteratee = function(value, context) {
	    return cb(value, context, Infinity);
	  };
	
	  // An internal function for creating assigner functions.
	  var createAssigner = function(keysFunc, undefinedOnly) {
	    return function(obj) {
	      var length = arguments.length;
	      if (length < 2 || obj == null) return obj;
	      for (var index = 1; index < length; index++) {
	        var source = arguments[index],
	            keys = keysFunc(source),
	            l = keys.length;
	        for (var i = 0; i < l; i++) {
	          var key = keys[i];
	          if (!undefinedOnly || obj[key] === void 0) obj[key] = source[key];
	        }
	      }
	      return obj;
	    };
	  };
	
	  // An internal function for creating a new object that inherits from another.
	  var baseCreate = function(prototype) {
	    if (!_.isObject(prototype)) return {};
	    if (nativeCreate) return nativeCreate(prototype);
	    Ctor.prototype = prototype;
	    var result = new Ctor;
	    Ctor.prototype = null;
	    return result;
	  };
	
	  var property = function(key) {
	    return function(obj) {
	      return obj == null ? void 0 : obj[key];
	    };
	  };
	
	  // Helper for collection methods to determine whether a collection
	  // should be iterated as an array or as an object
	  // Related: http://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength
	  // Avoids a very nasty iOS 8 JIT bug on ARM-64. #2094
	  var MAX_ARRAY_INDEX = Math.pow(2, 53) - 1;
	  var getLength = property('length');
	  var isArrayLike = function(collection) {
	    var length = getLength(collection);
	    return typeof length == 'number' && length >= 0 && length <= MAX_ARRAY_INDEX;
	  };
	
	  // Collection Functions
	  // --------------------
	
	  // The cornerstone, an `each` implementation, aka `forEach`.
	  // Handles raw objects in addition to array-likes. Treats all
	  // sparse array-likes as if they were dense.
	  _.each = _.forEach = function(obj, iteratee, context) {
	    iteratee = optimizeCb(iteratee, context);
	    var i, length;
	    if (isArrayLike(obj)) {
	      for (i = 0, length = obj.length; i < length; i++) {
	        iteratee(obj[i], i, obj);
	      }
	    } else {
	      var keys = _.keys(obj);
	      for (i = 0, length = keys.length; i < length; i++) {
	        iteratee(obj[keys[i]], keys[i], obj);
	      }
	    }
	    return obj;
	  };
	
	  // Return the results of applying the iteratee to each element.
	  _.map = _.collect = function(obj, iteratee, context) {
	    iteratee = cb(iteratee, context);
	    var keys = !isArrayLike(obj) && _.keys(obj),
	        length = (keys || obj).length,
	        results = Array(length);
	    for (var index = 0; index < length; index++) {
	      var currentKey = keys ? keys[index] : index;
	      results[index] = iteratee(obj[currentKey], currentKey, obj);
	    }
	    return results;
	  };
	
	  // Create a reducing function iterating left or right.
	  function createReduce(dir) {
	    // Optimized iterator function as using arguments.length
	    // in the main function will deoptimize the, see #1991.
	    function iterator(obj, iteratee, memo, keys, index, length) {
	      for (; index >= 0 && index < length; index += dir) {
	        var currentKey = keys ? keys[index] : index;
	        memo = iteratee(memo, obj[currentKey], currentKey, obj);
	      }
	      return memo;
	    }
	
	    return function(obj, iteratee, memo, context) {
	      iteratee = optimizeCb(iteratee, context, 4);
	      var keys = !isArrayLike(obj) && _.keys(obj),
	          length = (keys || obj).length,
	          index = dir > 0 ? 0 : length - 1;
	      // Determine the initial value if none is provided.
	      if (arguments.length < 3) {
	        memo = obj[keys ? keys[index] : index];
	        index += dir;
	      }
	      return iterator(obj, iteratee, memo, keys, index, length);
	    };
	  }
	
	  // **Reduce** builds up a single result from a list of values, aka `inject`,
	  // or `foldl`.
	  _.reduce = _.foldl = _.inject = createReduce(1);
	
	  // The right-associative version of reduce, also known as `foldr`.
	  _.reduceRight = _.foldr = createReduce(-1);
	
	  // Return the first value which passes a truth test. Aliased as `detect`.
	  _.find = _.detect = function(obj, predicate, context) {
	    var key;
	    if (isArrayLike(obj)) {
	      key = _.findIndex(obj, predicate, context);
	    } else {
	      key = _.findKey(obj, predicate, context);
	    }
	    if (key !== void 0 && key !== -1) return obj[key];
	  };
	
	  // Return all the elements that pass a truth test.
	  // Aliased as `select`.
	  _.filter = _.select = function(obj, predicate, context) {
	    var results = [];
	    predicate = cb(predicate, context);
	    _.each(obj, function(value, index, list) {
	      if (predicate(value, index, list)) results.push(value);
	    });
	    return results;
	  };
	
	  // Return all the elements for which a truth test fails.
	  _.reject = function(obj, predicate, context) {
	    return _.filter(obj, _.negate(cb(predicate)), context);
	  };
	
	  // Determine whether all of the elements match a truth test.
	  // Aliased as `all`.
	  _.every = _.all = function(obj, predicate, context) {
	    predicate = cb(predicate, context);
	    var keys = !isArrayLike(obj) && _.keys(obj),
	        length = (keys || obj).length;
	    for (var index = 0; index < length; index++) {
	      var currentKey = keys ? keys[index] : index;
	      if (!predicate(obj[currentKey], currentKey, obj)) return false;
	    }
	    return true;
	  };
	
	  // Determine if at least one element in the object matches a truth test.
	  // Aliased as `any`.
	  _.some = _.any = function(obj, predicate, context) {
	    predicate = cb(predicate, context);
	    var keys = !isArrayLike(obj) && _.keys(obj),
	        length = (keys || obj).length;
	    for (var index = 0; index < length; index++) {
	      var currentKey = keys ? keys[index] : index;
	      if (predicate(obj[currentKey], currentKey, obj)) return true;
	    }
	    return false;
	  };
	
	  // Determine if the array or object contains a given item (using `===`).
	  // Aliased as `includes` and `include`.
	  _.contains = _.includes = _.include = function(obj, item, fromIndex, guard) {
	    if (!isArrayLike(obj)) obj = _.values(obj);
	    if (typeof fromIndex != 'number' || guard) fromIndex = 0;
	    return _.indexOf(obj, item, fromIndex) >= 0;
	  };
	
	  // Invoke a method (with arguments) on every item in a collection.
	  _.invoke = function(obj, method) {
	    var args = slice.call(arguments, 2);
	    var isFunc = _.isFunction(method);
	    return _.map(obj, function(value) {
	      var func = isFunc ? method : value[method];
	      return func == null ? func : func.apply(value, args);
	    });
	  };
	
	  // Convenience version of a common use case of `map`: fetching a property.
	  _.pluck = function(obj, key) {
	    return _.map(obj, _.property(key));
	  };
	
	  // Convenience version of a common use case of `filter`: selecting only objects
	  // containing specific `key:value` pairs.
	  _.where = function(obj, attrs) {
	    return _.filter(obj, _.matcher(attrs));
	  };
	
	  // Convenience version of a common use case of `find`: getting the first object
	  // containing specific `key:value` pairs.
	  _.findWhere = function(obj, attrs) {
	    return _.find(obj, _.matcher(attrs));
	  };
	
	  // Return the maximum element (or element-based computation).
	  _.max = function(obj, iteratee, context) {
	    var result = -Infinity, lastComputed = -Infinity,
	        value, computed;
	    if (iteratee == null && obj != null) {
	      obj = isArrayLike(obj) ? obj : _.values(obj);
	      for (var i = 0, length = obj.length; i < length; i++) {
	        value = obj[i];
	        if (value > result) {
	          result = value;
	        }
	      }
	    } else {
	      iteratee = cb(iteratee, context);
	      _.each(obj, function(value, index, list) {
	        computed = iteratee(value, index, list);
	        if (computed > lastComputed || computed === -Infinity && result === -Infinity) {
	          result = value;
	          lastComputed = computed;
	        }
	      });
	    }
	    return result;
	  };
	
	  // Return the minimum element (or element-based computation).
	  _.min = function(obj, iteratee, context) {
	    var result = Infinity, lastComputed = Infinity,
	        value, computed;
	    if (iteratee == null && obj != null) {
	      obj = isArrayLike(obj) ? obj : _.values(obj);
	      for (var i = 0, length = obj.length; i < length; i++) {
	        value = obj[i];
	        if (value < result) {
	          result = value;
	        }
	      }
	    } else {
	      iteratee = cb(iteratee, context);
	      _.each(obj, function(value, index, list) {
	        computed = iteratee(value, index, list);
	        if (computed < lastComputed || computed === Infinity && result === Infinity) {
	          result = value;
	          lastComputed = computed;
	        }
	      });
	    }
	    return result;
	  };
	
	  // Shuffle a collection, using the modern version of the
	  // [Fisher-Yates shuffle](http://en.wikipedia.org/wiki/Fisher–Yates_shuffle).
	  _.shuffle = function(obj) {
	    var set = isArrayLike(obj) ? obj : _.values(obj);
	    var length = set.length;
	    var shuffled = Array(length);
	    for (var index = 0, rand; index < length; index++) {
	      rand = _.random(0, index);
	      if (rand !== index) shuffled[index] = shuffled[rand];
	      shuffled[rand] = set[index];
	    }
	    return shuffled;
	  };
	
	  // Sample **n** random values from a collection.
	  // If **n** is not specified, returns a single random element.
	  // The internal `guard` argument allows it to work with `map`.
	  _.sample = function(obj, n, guard) {
	    if (n == null || guard) {
	      if (!isArrayLike(obj)) obj = _.values(obj);
	      return obj[_.random(obj.length - 1)];
	    }
	    return _.shuffle(obj).slice(0, Math.max(0, n));
	  };
	
	  // Sort the object's values by a criterion produced by an iteratee.
	  _.sortBy = function(obj, iteratee, context) {
	    iteratee = cb(iteratee, context);
	    return _.pluck(_.map(obj, function(value, index, list) {
	      return {
	        value: value,
	        index: index,
	        criteria: iteratee(value, index, list)
	      };
	    }).sort(function(left, right) {
	      var a = left.criteria;
	      var b = right.criteria;
	      if (a !== b) {
	        if (a > b || a === void 0) return 1;
	        if (a < b || b === void 0) return -1;
	      }
	      return left.index - right.index;
	    }), 'value');
	  };
	
	  // An internal function used for aggregate "group by" operations.
	  var group = function(behavior) {
	    return function(obj, iteratee, context) {
	      var result = {};
	      iteratee = cb(iteratee, context);
	      _.each(obj, function(value, index) {
	        var key = iteratee(value, index, obj);
	        behavior(result, value, key);
	      });
	      return result;
	    };
	  };
	
	  // Groups the object's values by a criterion. Pass either a string attribute
	  // to group by, or a function that returns the criterion.
	  _.groupBy = group(function(result, value, key) {
	    if (_.has(result, key)) result[key].push(value); else result[key] = [value];
	  });
	
	  // Indexes the object's values by a criterion, similar to `groupBy`, but for
	  // when you know that your index values will be unique.
	  _.indexBy = group(function(result, value, key) {
	    result[key] = value;
	  });
	
	  // Counts instances of an object that group by a certain criterion. Pass
	  // either a string attribute to count by, or a function that returns the
	  // criterion.
	  _.countBy = group(function(result, value, key) {
	    if (_.has(result, key)) result[key]++; else result[key] = 1;
	  });
	
	  // Safely create a real, live array from anything iterable.
	  _.toArray = function(obj) {
	    if (!obj) return [];
	    if (_.isArray(obj)) return slice.call(obj);
	    if (isArrayLike(obj)) return _.map(obj, _.identity);
	    return _.values(obj);
	  };
	
	  // Return the number of elements in an object.
	  _.size = function(obj) {
	    if (obj == null) return 0;
	    return isArrayLike(obj) ? obj.length : _.keys(obj).length;
	  };
	
	  // Split a collection into two arrays: one whose elements all satisfy the given
	  // predicate, and one whose elements all do not satisfy the predicate.
	  _.partition = function(obj, predicate, context) {
	    predicate = cb(predicate, context);
	    var pass = [], fail = [];
	    _.each(obj, function(value, key, obj) {
	      (predicate(value, key, obj) ? pass : fail).push(value);
	    });
	    return [pass, fail];
	  };
	
	  // Array Functions
	  // ---------------
	
	  // Get the first element of an array. Passing **n** will return the first N
	  // values in the array. Aliased as `head` and `take`. The **guard** check
	  // allows it to work with `_.map`.
	  _.first = _.head = _.take = function(array, n, guard) {
	    if (array == null) return void 0;
	    if (n == null || guard) return array[0];
	    return _.initial(array, array.length - n);
	  };
	
	  // Returns everything but the last entry of the array. Especially useful on
	  // the arguments object. Passing **n** will return all the values in
	  // the array, excluding the last N.
	  _.initial = function(array, n, guard) {
	    return slice.call(array, 0, Math.max(0, array.length - (n == null || guard ? 1 : n)));
	  };
	
	  // Get the last element of an array. Passing **n** will return the last N
	  // values in the array.
	  _.last = function(array, n, guard) {
	    if (array == null) return void 0;
	    if (n == null || guard) return array[array.length - 1];
	    return _.rest(array, Math.max(0, array.length - n));
	  };
	
	  // Returns everything but the first entry of the array. Aliased as `tail` and `drop`.
	  // Especially useful on the arguments object. Passing an **n** will return
	  // the rest N values in the array.
	  _.rest = _.tail = _.drop = function(array, n, guard) {
	    return slice.call(array, n == null || guard ? 1 : n);
	  };
	
	  // Trim out all falsy values from an array.
	  _.compact = function(array) {
	    return _.filter(array, _.identity);
	  };
	
	  // Internal implementation of a recursive `flatten` function.
	  var flatten = function(input, shallow, strict, startIndex) {
	    var output = [], idx = 0;
	    for (var i = startIndex || 0, length = getLength(input); i < length; i++) {
	      var value = input[i];
	      if (isArrayLike(value) && (_.isArray(value) || _.isArguments(value))) {
	        //flatten current level of array or arguments object
	        if (!shallow) value = flatten(value, shallow, strict);
	        var j = 0, len = value.length;
	        output.length += len;
	        while (j < len) {
	          output[idx++] = value[j++];
	        }
	      } else if (!strict) {
	        output[idx++] = value;
	      }
	    }
	    return output;
	  };
	
	  // Flatten out an array, either recursively (by default), or just one level.
	  _.flatten = function(array, shallow) {
	    return flatten(array, shallow, false);
	  };
	
	  // Return a version of the array that does not contain the specified value(s).
	  _.without = function(array) {
	    return _.difference(array, slice.call(arguments, 1));
	  };
	
	  // Produce a duplicate-free version of the array. If the array has already
	  // been sorted, you have the option of using a faster algorithm.
	  // Aliased as `unique`.
	  _.uniq = _.unique = function(array, isSorted, iteratee, context) {
	    if (!_.isBoolean(isSorted)) {
	      context = iteratee;
	      iteratee = isSorted;
	      isSorted = false;
	    }
	    if (iteratee != null) iteratee = cb(iteratee, context);
	    var result = [];
	    var seen = [];
	    for (var i = 0, length = getLength(array); i < length; i++) {
	      var value = array[i],
	          computed = iteratee ? iteratee(value, i, array) : value;
	      if (isSorted) {
	        if (!i || seen !== computed) result.push(value);
	        seen = computed;
	      } else if (iteratee) {
	        if (!_.contains(seen, computed)) {
	          seen.push(computed);
	          result.push(value);
	        }
	      } else if (!_.contains(result, value)) {
	        result.push(value);
	      }
	    }
	    return result;
	  };
	
	  // Produce an array that contains the union: each distinct element from all of
	  // the passed-in arrays.
	  _.union = function() {
	    return _.uniq(flatten(arguments, true, true));
	  };
	
	  // Produce an array that contains every item shared between all the
	  // passed-in arrays.
	  _.intersection = function(array) {
	    var result = [];
	    var argsLength = arguments.length;
	    for (var i = 0, length = getLength(array); i < length; i++) {
	      var item = array[i];
	      if (_.contains(result, item)) continue;
	      for (var j = 1; j < argsLength; j++) {
	        if (!_.contains(arguments[j], item)) break;
	      }
	      if (j === argsLength) result.push(item);
	    }
	    return result;
	  };
	
	  // Take the difference between one array and a number of other arrays.
	  // Only the elements present in just the first array will remain.
	  _.difference = function(array) {
	    var rest = flatten(arguments, true, true, 1);
	    return _.filter(array, function(value){
	      return !_.contains(rest, value);
	    });
	  };
	
	  // Zip together multiple lists into a single array -- elements that share
	  // an index go together.
	  _.zip = function() {
	    return _.unzip(arguments);
	  };
	
	  // Complement of _.zip. Unzip accepts an array of arrays and groups
	  // each array's elements on shared indices
	  _.unzip = function(array) {
	    var length = array && _.max(array, getLength).length || 0;
	    var result = Array(length);
	
	    for (var index = 0; index < length; index++) {
	      result[index] = _.pluck(array, index);
	    }
	    return result;
	  };
	
	  // Converts lists into objects. Pass either a single array of `[key, value]`
	  // pairs, or two parallel arrays of the same length -- one of keys, and one of
	  // the corresponding values.
	  _.object = function(list, values) {
	    var result = {};
	    for (var i = 0, length = getLength(list); i < length; i++) {
	      if (values) {
	        result[list[i]] = values[i];
	      } else {
	        result[list[i][0]] = list[i][1];
	      }
	    }
	    return result;
	  };
	
	  // Generator function to create the findIndex and findLastIndex functions
	  function createPredicateIndexFinder(dir) {
	    return function(array, predicate, context) {
	      predicate = cb(predicate, context);
	      var length = getLength(array);
	      var index = dir > 0 ? 0 : length - 1;
	      for (; index >= 0 && index < length; index += dir) {
	        if (predicate(array[index], index, array)) return index;
	      }
	      return -1;
	    };
	  }
	
	  // Returns the first index on an array-like that passes a predicate test
	  _.findIndex = createPredicateIndexFinder(1);
	  _.findLastIndex = createPredicateIndexFinder(-1);
	
	  // Use a comparator function to figure out the smallest index at which
	  // an object should be inserted so as to maintain order. Uses binary search.
	  _.sortedIndex = function(array, obj, iteratee, context) {
	    iteratee = cb(iteratee, context, 1);
	    var value = iteratee(obj);
	    var low = 0, high = getLength(array);
	    while (low < high) {
	      var mid = Math.floor((low + high) / 2);
	      if (iteratee(array[mid]) < value) low = mid + 1; else high = mid;
	    }
	    return low;
	  };
	
	  // Generator function to create the indexOf and lastIndexOf functions
	  function createIndexFinder(dir, predicateFind, sortedIndex) {
	    return function(array, item, idx) {
	      var i = 0, length = getLength(array);
	      if (typeof idx == 'number') {
	        if (dir > 0) {
	            i = idx >= 0 ? idx : Math.max(idx + length, i);
	        } else {
	            length = idx >= 0 ? Math.min(idx + 1, length) : idx + length + 1;
	        }
	      } else if (sortedIndex && idx && length) {
	        idx = sortedIndex(array, item);
	        return array[idx] === item ? idx : -1;
	      }
	      if (item !== item) {
	        idx = predicateFind(slice.call(array, i, length), _.isNaN);
	        return idx >= 0 ? idx + i : -1;
	      }
	      for (idx = dir > 0 ? i : length - 1; idx >= 0 && idx < length; idx += dir) {
	        if (array[idx] === item) return idx;
	      }
	      return -1;
	    };
	  }
	
	  // Return the position of the first occurrence of an item in an array,
	  // or -1 if the item is not included in the array.
	  // If the array is large and already in sort order, pass `true`
	  // for **isSorted** to use binary search.
	  _.indexOf = createIndexFinder(1, _.findIndex, _.sortedIndex);
	  _.lastIndexOf = createIndexFinder(-1, _.findLastIndex);
	
	  // Generate an integer Array containing an arithmetic progression. A port of
	  // the native Python `range()` function. See
	  // [the Python documentation](http://docs.python.org/library/functions.html#range).
	  _.range = function(start, stop, step) {
	    if (stop == null) {
	      stop = start || 0;
	      start = 0;
	    }
	    step = step || 1;
	
	    var length = Math.max(Math.ceil((stop - start) / step), 0);
	    var range = Array(length);
	
	    for (var idx = 0; idx < length; idx++, start += step) {
	      range[idx] = start;
	    }
	
	    return range;
	  };
	
	  // Function (ahem) Functions
	  // ------------------
	
	  // Determines whether to execute a function as a constructor
	  // or a normal function with the provided arguments
	  var executeBound = function(sourceFunc, boundFunc, context, callingContext, args) {
	    if (!(callingContext instanceof boundFunc)) return sourceFunc.apply(context, args);
	    var self = baseCreate(sourceFunc.prototype);
	    var result = sourceFunc.apply(self, args);
	    if (_.isObject(result)) return result;
	    return self;
	  };
	
	  // Create a function bound to a given object (assigning `this`, and arguments,
	  // optionally). Delegates to **ECMAScript 5**'s native `Function.bind` if
	  // available.
	  _.bind = function(func, context) {
	    if (nativeBind && func.bind === nativeBind) return nativeBind.apply(func, slice.call(arguments, 1));
	    if (!_.isFunction(func)) throw new TypeError('Bind must be called on a function');
	    var args = slice.call(arguments, 2);
	    var bound = function() {
	      return executeBound(func, bound, context, this, args.concat(slice.call(arguments)));
	    };
	    return bound;
	  };
	
	  // Partially apply a function by creating a version that has had some of its
	  // arguments pre-filled, without changing its dynamic `this` context. _ acts
	  // as a placeholder, allowing any combination of arguments to be pre-filled.
	  _.partial = function(func) {
	    var boundArgs = slice.call(arguments, 1);
	    var bound = function() {
	      var position = 0, length = boundArgs.length;
	      var args = Array(length);
	      for (var i = 0; i < length; i++) {
	        args[i] = boundArgs[i] === _ ? arguments[position++] : boundArgs[i];
	      }
	      while (position < arguments.length) args.push(arguments[position++]);
	      return executeBound(func, bound, this, this, args);
	    };
	    return bound;
	  };
	
	  // Bind a number of an object's methods to that object. Remaining arguments
	  // are the method names to be bound. Useful for ensuring that all callbacks
	  // defined on an object belong to it.
	  _.bindAll = function(obj) {
	    var i, length = arguments.length, key;
	    if (length <= 1) throw new Error('bindAll must be passed function names');
	    for (i = 1; i < length; i++) {
	      key = arguments[i];
	      obj[key] = _.bind(obj[key], obj);
	    }
	    return obj;
	  };
	
	  // Memoize an expensive function by storing its results.
	  _.memoize = function(func, hasher) {
	    var memoize = function(key) {
	      var cache = memoize.cache;
	      var address = '' + (hasher ? hasher.apply(this, arguments) : key);
	      if (!_.has(cache, address)) cache[address] = func.apply(this, arguments);
	      return cache[address];
	    };
	    memoize.cache = {};
	    return memoize;
	  };
	
	  // Delays a function for the given number of milliseconds, and then calls
	  // it with the arguments supplied.
	  _.delay = function(func, wait) {
	    var args = slice.call(arguments, 2);
	    return setTimeout(function(){
	      return func.apply(null, args);
	    }, wait);
	  };
	
	  // Defers a function, scheduling it to run after the current call stack has
	  // cleared.
	  _.defer = _.partial(_.delay, _, 1);
	
	  // Returns a function, that, when invoked, will only be triggered at most once
	  // during a given window of time. Normally, the throttled function will run
	  // as much as it can, without ever going more than once per `wait` duration;
	  // but if you'd like to disable the execution on the leading edge, pass
	  // `{leading: false}`. To disable execution on the trailing edge, ditto.
	  _.throttle = function(func, wait, options) {
	    var context, args, result;
	    var timeout = null;
	    var previous = 0;
	    if (!options) options = {};
	    var later = function() {
	      previous = options.leading === false ? 0 : _.now();
	      timeout = null;
	      result = func.apply(context, args);
	      if (!timeout) context = args = null;
	    };
	    return function() {
	      var now = _.now();
	      if (!previous && options.leading === false) previous = now;
	      var remaining = wait - (now - previous);
	      context = this;
	      args = arguments;
	      if (remaining <= 0 || remaining > wait) {
	        if (timeout) {
	          clearTimeout(timeout);
	          timeout = null;
	        }
	        previous = now;
	        result = func.apply(context, args);
	        if (!timeout) context = args = null;
	      } else if (!timeout && options.trailing !== false) {
	        timeout = setTimeout(later, remaining);
	      }
	      return result;
	    };
	  };
	
	  // Returns a function, that, as long as it continues to be invoked, will not
	  // be triggered. The function will be called after it stops being called for
	  // N milliseconds. If `immediate` is passed, trigger the function on the
	  // leading edge, instead of the trailing.
	  _.debounce = function(func, wait, immediate) {
	    var timeout, args, context, timestamp, result;
	
	    var later = function() {
	      var last = _.now() - timestamp;
	
	      if (last < wait && last >= 0) {
	        timeout = setTimeout(later, wait - last);
	      } else {
	        timeout = null;
	        if (!immediate) {
	          result = func.apply(context, args);
	          if (!timeout) context = args = null;
	        }
	      }
	    };
	
	    return function() {
	      context = this;
	      args = arguments;
	      timestamp = _.now();
	      var callNow = immediate && !timeout;
	      if (!timeout) timeout = setTimeout(later, wait);
	      if (callNow) {
	        result = func.apply(context, args);
	        context = args = null;
	      }
	
	      return result;
	    };
	  };
	
	  // Returns the first function passed as an argument to the second,
	  // allowing you to adjust arguments, run code before and after, and
	  // conditionally execute the original function.
	  _.wrap = function(func, wrapper) {
	    return _.partial(wrapper, func);
	  };
	
	  // Returns a negated version of the passed-in predicate.
	  _.negate = function(predicate) {
	    return function() {
	      return !predicate.apply(this, arguments);
	    };
	  };
	
	  // Returns a function that is the composition of a list of functions, each
	  // consuming the return value of the function that follows.
	  _.compose = function() {
	    var args = arguments;
	    var start = args.length - 1;
	    return function() {
	      var i = start;
	      var result = args[start].apply(this, arguments);
	      while (i--) result = args[i].call(this, result);
	      return result;
	    };
	  };
	
	  // Returns a function that will only be executed on and after the Nth call.
	  _.after = function(times, func) {
	    return function() {
	      if (--times < 1) {
	        return func.apply(this, arguments);
	      }
	    };
	  };
	
	  // Returns a function that will only be executed up to (but not including) the Nth call.
	  _.before = function(times, func) {
	    var memo;
	    return function() {
	      if (--times > 0) {
	        memo = func.apply(this, arguments);
	      }
	      if (times <= 1) func = null;
	      return memo;
	    };
	  };
	
	  // Returns a function that will be executed at most one time, no matter how
	  // often you call it. Useful for lazy initialization.
	  _.once = _.partial(_.before, 2);
	
	  // Object Functions
	  // ----------------
	
	  // Keys in IE < 9 that won't be iterated by `for key in ...` and thus missed.
	  var hasEnumBug = !{toString: null}.propertyIsEnumerable('toString');
	  var nonEnumerableProps = ['valueOf', 'isPrototypeOf', 'toString',
	                      'propertyIsEnumerable', 'hasOwnProperty', 'toLocaleString'];
	
	  function collectNonEnumProps(obj, keys) {
	    var nonEnumIdx = nonEnumerableProps.length;
	    var constructor = obj.constructor;
	    var proto = (_.isFunction(constructor) && constructor.prototype) || ObjProto;
	
	    // Constructor is a special case.
	    var prop = 'constructor';
	    if (_.has(obj, prop) && !_.contains(keys, prop)) keys.push(prop);
	
	    while (nonEnumIdx--) {
	      prop = nonEnumerableProps[nonEnumIdx];
	      if (prop in obj && obj[prop] !== proto[prop] && !_.contains(keys, prop)) {
	        keys.push(prop);
	      }
	    }
	  }
	
	  // Retrieve the names of an object's own properties.
	  // Delegates to **ECMAScript 5**'s native `Object.keys`
	  _.keys = function(obj) {
	    if (!_.isObject(obj)) return [];
	    if (nativeKeys) return nativeKeys(obj);
	    var keys = [];
	    for (var key in obj) if (_.has(obj, key)) keys.push(key);
	    // Ahem, IE < 9.
	    if (hasEnumBug) collectNonEnumProps(obj, keys);
	    return keys;
	  };
	
	  // Retrieve all the property names of an object.
	  _.allKeys = function(obj) {
	    if (!_.isObject(obj)) return [];
	    var keys = [];
	    for (var key in obj) keys.push(key);
	    // Ahem, IE < 9.
	    if (hasEnumBug) collectNonEnumProps(obj, keys);
	    return keys;
	  };
	
	  // Retrieve the values of an object's properties.
	  _.values = function(obj) {
	    var keys = _.keys(obj);
	    var length = keys.length;
	    var values = Array(length);
	    for (var i = 0; i < length; i++) {
	      values[i] = obj[keys[i]];
	    }
	    return values;
	  };
	
	  // Returns the results of applying the iteratee to each element of the object
	  // In contrast to _.map it returns an object
	  _.mapObject = function(obj, iteratee, context) {
	    iteratee = cb(iteratee, context);
	    var keys =  _.keys(obj),
	          length = keys.length,
	          results = {},
	          currentKey;
	      for (var index = 0; index < length; index++) {
	        currentKey = keys[index];
	        results[currentKey] = iteratee(obj[currentKey], currentKey, obj);
	      }
	      return results;
	  };
	
	  // Convert an object into a list of `[key, value]` pairs.
	  _.pairs = function(obj) {
	    var keys = _.keys(obj);
	    var length = keys.length;
	    var pairs = Array(length);
	    for (var i = 0; i < length; i++) {
	      pairs[i] = [keys[i], obj[keys[i]]];
	    }
	    return pairs;
	  };
	
	  // Invert the keys and values of an object. The values must be serializable.
	  _.invert = function(obj) {
	    var result = {};
	    var keys = _.keys(obj);
	    for (var i = 0, length = keys.length; i < length; i++) {
	      result[obj[keys[i]]] = keys[i];
	    }
	    return result;
	  };
	
	  // Return a sorted list of the function names available on the object.
	  // Aliased as `methods`
	  _.functions = _.methods = function(obj) {
	    var names = [];
	    for (var key in obj) {
	      if (_.isFunction(obj[key])) names.push(key);
	    }
	    return names.sort();
	  };
	
	  // Extend a given object with all the properties in passed-in object(s).
	  _.extend = createAssigner(_.allKeys);
	
	  // Assigns a given object with all the own properties in the passed-in object(s)
	  // (https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/assign)
	  _.extendOwn = _.assign = createAssigner(_.keys);
	
	  // Returns the first key on an object that passes a predicate test
	  _.findKey = function(obj, predicate, context) {
	    predicate = cb(predicate, context);
	    var keys = _.keys(obj), key;
	    for (var i = 0, length = keys.length; i < length; i++) {
	      key = keys[i];
	      if (predicate(obj[key], key, obj)) return key;
	    }
	  };
	
	  // Return a copy of the object only containing the whitelisted properties.
	  _.pick = function(object, oiteratee, context) {
	    var result = {}, obj = object, iteratee, keys;
	    if (obj == null) return result;
	    if (_.isFunction(oiteratee)) {
	      keys = _.allKeys(obj);
	      iteratee = optimizeCb(oiteratee, context);
	    } else {
	      keys = flatten(arguments, false, false, 1);
	      iteratee = function(value, key, obj) { return key in obj; };
	      obj = Object(obj);
	    }
	    for (var i = 0, length = keys.length; i < length; i++) {
	      var key = keys[i];
	      var value = obj[key];
	      if (iteratee(value, key, obj)) result[key] = value;
	    }
	    return result;
	  };
	
	   // Return a copy of the object without the blacklisted properties.
	  _.omit = function(obj, iteratee, context) {
	    if (_.isFunction(iteratee)) {
	      iteratee = _.negate(iteratee);
	    } else {
	      var keys = _.map(flatten(arguments, false, false, 1), String);
	      iteratee = function(value, key) {
	        return !_.contains(keys, key);
	      };
	    }
	    return _.pick(obj, iteratee, context);
	  };
	
	  // Fill in a given object with default properties.
	  _.defaults = createAssigner(_.allKeys, true);
	
	  // Creates an object that inherits from the given prototype object.
	  // If additional properties are provided then they will be added to the
	  // created object.
	  _.create = function(prototype, props) {
	    var result = baseCreate(prototype);
	    if (props) _.extendOwn(result, props);
	    return result;
	  };
	
	  // Create a (shallow-cloned) duplicate of an object.
	  _.clone = function(obj) {
	    if (!_.isObject(obj)) return obj;
	    return _.isArray(obj) ? obj.slice() : _.extend({}, obj);
	  };
	
	  // Invokes interceptor with the obj, and then returns obj.
	  // The primary purpose of this method is to "tap into" a method chain, in
	  // order to perform operations on intermediate results within the chain.
	  _.tap = function(obj, interceptor) {
	    interceptor(obj);
	    return obj;
	  };
	
	  // Returns whether an object has a given set of `key:value` pairs.
	  _.isMatch = function(object, attrs) {
	    var keys = _.keys(attrs), length = keys.length;
	    if (object == null) return !length;
	    var obj = Object(object);
	    for (var i = 0; i < length; i++) {
	      var key = keys[i];
	      if (attrs[key] !== obj[key] || !(key in obj)) return false;
	    }
	    return true;
	  };
	
	
	  // Internal recursive comparison function for `isEqual`.
	  var eq = function(a, b, aStack, bStack) {
	    // Identical objects are equal. `0 === -0`, but they aren't identical.
	    // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
	    if (a === b) return a !== 0 || 1 / a === 1 / b;
	    // A strict comparison is necessary because `null == undefined`.
	    if (a == null || b == null) return a === b;
	    // Unwrap any wrapped objects.
	    if (a instanceof _) a = a._wrapped;
	    if (b instanceof _) b = b._wrapped;
	    // Compare `[[Class]]` names.
	    var className = toString.call(a);
	    if (className !== toString.call(b)) return false;
	    switch (className) {
	      // Strings, numbers, regular expressions, dates, and booleans are compared by value.
	      case '[object RegExp]':
	      // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
	      case '[object String]':
	        // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
	        // equivalent to `new String("5")`.
	        return '' + a === '' + b;
	      case '[object Number]':
	        // `NaN`s are equivalent, but non-reflexive.
	        // Object(NaN) is equivalent to NaN
	        if (+a !== +a) return +b !== +b;
	        // An `egal` comparison is performed for other numeric values.
	        return +a === 0 ? 1 / +a === 1 / b : +a === +b;
	      case '[object Date]':
	      case '[object Boolean]':
	        // Coerce dates and booleans to numeric primitive values. Dates are compared by their
	        // millisecond representations. Note that invalid dates with millisecond representations
	        // of `NaN` are not equivalent.
	        return +a === +b;
	    }
	
	    var areArrays = className === '[object Array]';
	    if (!areArrays) {
	      if (typeof a != 'object' || typeof b != 'object') return false;
	
	      // Objects with different constructors are not equivalent, but `Object`s or `Array`s
	      // from different frames are.
	      var aCtor = a.constructor, bCtor = b.constructor;
	      if (aCtor !== bCtor && !(_.isFunction(aCtor) && aCtor instanceof aCtor &&
	                               _.isFunction(bCtor) && bCtor instanceof bCtor)
	                          && ('constructor' in a && 'constructor' in b)) {
	        return false;
	      }
	    }
	    // Assume equality for cyclic structures. The algorithm for detecting cyclic
	    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.
	
	    // Initializing stack of traversed objects.
	    // It's done here since we only need them for objects and arrays comparison.
	    aStack = aStack || [];
	    bStack = bStack || [];
	    var length = aStack.length;
	    while (length--) {
	      // Linear search. Performance is inversely proportional to the number of
	      // unique nested structures.
	      if (aStack[length] === a) return bStack[length] === b;
	    }
	
	    // Add the first object to the stack of traversed objects.
	    aStack.push(a);
	    bStack.push(b);
	
	    // Recursively compare objects and arrays.
	    if (areArrays) {
	      // Compare array lengths to determine if a deep comparison is necessary.
	      length = a.length;
	      if (length !== b.length) return false;
	      // Deep compare the contents, ignoring non-numeric properties.
	      while (length--) {
	        if (!eq(a[length], b[length], aStack, bStack)) return false;
	      }
	    } else {
	      // Deep compare objects.
	      var keys = _.keys(a), key;
	      length = keys.length;
	      // Ensure that both objects contain the same number of properties before comparing deep equality.
	      if (_.keys(b).length !== length) return false;
	      while (length--) {
	        // Deep compare each member
	        key = keys[length];
	        if (!(_.has(b, key) && eq(a[key], b[key], aStack, bStack))) return false;
	      }
	    }
	    // Remove the first object from the stack of traversed objects.
	    aStack.pop();
	    bStack.pop();
	    return true;
	  };
	
	  // Perform a deep comparison to check if two objects are equal.
	  _.isEqual = function(a, b) {
	    return eq(a, b);
	  };
	
	  // Is a given array, string, or object empty?
	  // An "empty" object has no enumerable own-properties.
	  _.isEmpty = function(obj) {
	    if (obj == null) return true;
	    if (isArrayLike(obj) && (_.isArray(obj) || _.isString(obj) || _.isArguments(obj))) return obj.length === 0;
	    return _.keys(obj).length === 0;
	  };
	
	  // Is a given value a DOM element?
	  _.isElement = function(obj) {
	    return !!(obj && obj.nodeType === 1);
	  };
	
	  // Is a given value an array?
	  // Delegates to ECMA5's native Array.isArray
	  _.isArray = nativeIsArray || function(obj) {
	    return toString.call(obj) === '[object Array]';
	  };
	
	  // Is a given variable an object?
	  _.isObject = function(obj) {
	    var type = typeof obj;
	    return type === 'function' || type === 'object' && !!obj;
	  };
	
	  // Add some isType methods: isArguments, isFunction, isString, isNumber, isDate, isRegExp, isError.
	  _.each(['Arguments', 'Function', 'String', 'Number', 'Date', 'RegExp', 'Error'], function(name) {
	    _['is' + name] = function(obj) {
	      return toString.call(obj) === '[object ' + name + ']';
	    };
	  });
	
	  // Define a fallback version of the method in browsers (ahem, IE < 9), where
	  // there isn't any inspectable "Arguments" type.
	  if (!_.isArguments(arguments)) {
	    _.isArguments = function(obj) {
	      return _.has(obj, 'callee');
	    };
	  }
	
	  // Optimize `isFunction` if appropriate. Work around some typeof bugs in old v8,
	  // IE 11 (#1621), and in Safari 8 (#1929).
	  if (typeof /./ != 'function' && typeof Int8Array != 'object') {
	    _.isFunction = function(obj) {
	      return typeof obj == 'function' || false;
	    };
	  }
	
	  // Is a given object a finite number?
	  _.isFinite = function(obj) {
	    return isFinite(obj) && !isNaN(parseFloat(obj));
	  };
	
	  // Is the given value `NaN`? (NaN is the only number which does not equal itself).
	  _.isNaN = function(obj) {
	    return _.isNumber(obj) && obj !== +obj;
	  };
	
	  // Is a given value a boolean?
	  _.isBoolean = function(obj) {
	    return obj === true || obj === false || toString.call(obj) === '[object Boolean]';
	  };
	
	  // Is a given value equal to null?
	  _.isNull = function(obj) {
	    return obj === null;
	  };
	
	  // Is a given variable undefined?
	  _.isUndefined = function(obj) {
	    return obj === void 0;
	  };
	
	  // Shortcut function for checking if an object has a given property directly
	  // on itself (in other words, not on a prototype).
	  _.has = function(obj, key) {
	    return obj != null && hasOwnProperty.call(obj, key);
	  };
	
	  // Utility Functions
	  // -----------------
	
	  // Run Underscore.js in *noConflict* mode, returning the `_` variable to its
	  // previous owner. Returns a reference to the Underscore object.
	  _.noConflict = function() {
	    root._ = previousUnderscore;
	    return this;
	  };
	
	  // Keep the identity function around for default iteratees.
	  _.identity = function(value) {
	    return value;
	  };
	
	  // Predicate-generating functions. Often useful outside of Underscore.
	  _.constant = function(value) {
	    return function() {
	      return value;
	    };
	  };
	
	  _.noop = function(){};
	
	  _.property = property;
	
	  // Generates a function for a given object that returns a given property.
	  _.propertyOf = function(obj) {
	    return obj == null ? function(){} : function(key) {
	      return obj[key];
	    };
	  };
	
	  // Returns a predicate for checking whether an object has a given set of
	  // `key:value` pairs.
	  _.matcher = _.matches = function(attrs) {
	    attrs = _.extendOwn({}, attrs);
	    return function(obj) {
	      return _.isMatch(obj, attrs);
	    };
	  };
	
	  // Run a function **n** times.
	  _.times = function(n, iteratee, context) {
	    var accum = Array(Math.max(0, n));
	    iteratee = optimizeCb(iteratee, context, 1);
	    for (var i = 0; i < n; i++) accum[i] = iteratee(i);
	    return accum;
	  };
	
	  // Return a random integer between min and max (inclusive).
	  _.random = function(min, max) {
	    if (max == null) {
	      max = min;
	      min = 0;
	    }
	    return min + Math.floor(Math.random() * (max - min + 1));
	  };
	
	  // A (possibly faster) way to get the current timestamp as an integer.
	  _.now = Date.now || function() {
	    return new Date().getTime();
	  };
	
	   // List of HTML entities for escaping.
	  var escapeMap = {
	    '&': '&amp;',
	    '<': '&lt;',
	    '>': '&gt;',
	    '"': '&quot;',
	    "'": '&#x27;',
	    '`': '&#x60;'
	  };
	  var unescapeMap = _.invert(escapeMap);
	
	  // Functions for escaping and unescaping strings to/from HTML interpolation.
	  var createEscaper = function(map) {
	    var escaper = function(match) {
	      return map[match];
	    };
	    // Regexes for identifying a key that needs to be escaped
	    var source = '(?:' + _.keys(map).join('|') + ')';
	    var testRegexp = RegExp(source);
	    var replaceRegexp = RegExp(source, 'g');
	    return function(string) {
	      string = string == null ? '' : '' + string;
	      return testRegexp.test(string) ? string.replace(replaceRegexp, escaper) : string;
	    };
	  };
	  _.escape = createEscaper(escapeMap);
	  _.unescape = createEscaper(unescapeMap);
	
	  // If the value of the named `property` is a function then invoke it with the
	  // `object` as context; otherwise, return it.
	  _.result = function(object, property, fallback) {
	    var value = object == null ? void 0 : object[property];
	    if (value === void 0) {
	      value = fallback;
	    }
	    return _.isFunction(value) ? value.call(object) : value;
	  };
	
	  // Generate a unique integer id (unique within the entire client session).
	  // Useful for temporary DOM ids.
	  var idCounter = 0;
	  _.uniqueId = function(prefix) {
	    var id = ++idCounter + '';
	    return prefix ? prefix + id : id;
	  };
	
	  // By default, Underscore uses ERB-style template delimiters, change the
	  // following template settings to use alternative delimiters.
	  _.templateSettings = {
	    evaluate    : /<%([\s\S]+?)%>/g,
	    interpolate : /<%=([\s\S]+?)%>/g,
	    escape      : /<%-([\s\S]+?)%>/g
	  };
	
	  // When customizing `templateSettings`, if you don't want to define an
	  // interpolation, evaluation or escaping regex, we need one that is
	  // guaranteed not to match.
	  var noMatch = /(.)^/;
	
	  // Certain characters need to be escaped so that they can be put into a
	  // string literal.
	  var escapes = {
	    "'":      "'",
	    '\\':     '\\',
	    '\r':     'r',
	    '\n':     'n',
	    '\u2028': 'u2028',
	    '\u2029': 'u2029'
	  };
	
	  var escaper = /\\|'|\r|\n|\u2028|\u2029/g;
	
	  var escapeChar = function(match) {
	    return '\\' + escapes[match];
	  };
	
	  // JavaScript micro-templating, similar to John Resig's implementation.
	  // Underscore templating handles arbitrary delimiters, preserves whitespace,
	  // and correctly escapes quotes within interpolated code.
	  // NB: `oldSettings` only exists for backwards compatibility.
	  _.template = function(text, settings, oldSettings) {
	    if (!settings && oldSettings) settings = oldSettings;
	    settings = _.defaults({}, settings, _.templateSettings);
	
	    // Combine delimiters into one regular expression via alternation.
	    var matcher = RegExp([
	      (settings.escape || noMatch).source,
	      (settings.interpolate || noMatch).source,
	      (settings.evaluate || noMatch).source
	    ].join('|') + '|$', 'g');
	
	    // Compile the template source, escaping string literals appropriately.
	    var index = 0;
	    var source = "__p+='";
	    text.replace(matcher, function(match, escape, interpolate, evaluate, offset) {
	      source += text.slice(index, offset).replace(escaper, escapeChar);
	      index = offset + match.length;
	
	      if (escape) {
	        source += "'+\n((__t=(" + escape + "))==null?'':_.escape(__t))+\n'";
	      } else if (interpolate) {
	        source += "'+\n((__t=(" + interpolate + "))==null?'':__t)+\n'";
	      } else if (evaluate) {
	        source += "';\n" + evaluate + "\n__p+='";
	      }
	
	      // Adobe VMs need the match returned to produce the correct offest.
	      return match;
	    });
	    source += "';\n";
	
	    // If a variable is not specified, place data values in local scope.
	    if (!settings.variable) source = 'with(obj||{}){\n' + source + '}\n';
	
	    source = "var __t,__p='',__j=Array.prototype.join," +
	      "print=function(){__p+=__j.call(arguments,'');};\n" +
	      source + 'return __p;\n';
	
	    try {
	      var render = new Function(settings.variable || 'obj', '_', source);
	    } catch (e) {
	      e.source = source;
	      throw e;
	    }
	
	    var template = function(data) {
	      return render.call(this, data, _);
	    };
	
	    // Provide the compiled source as a convenience for precompilation.
	    var argument = settings.variable || 'obj';
	    template.source = 'function(' + argument + '){\n' + source + '}';
	
	    return template;
	  };
	
	  // Add a "chain" function. Start chaining a wrapped Underscore object.
	  _.chain = function(obj) {
	    var instance = _(obj);
	    instance._chain = true;
	    return instance;
	  };
	
	  // OOP
	  // ---------------
	  // If Underscore is called as a function, it returns a wrapped object that
	  // can be used OO-style. This wrapper holds altered versions of all the
	  // underscore functions. Wrapped objects may be chained.
	
	  // Helper function to continue chaining intermediate results.
	  var result = function(instance, obj) {
	    return instance._chain ? _(obj).chain() : obj;
	  };
	
	  // Add your own custom functions to the Underscore object.
	  _.mixin = function(obj) {
	    _.each(_.functions(obj), function(name) {
	      var func = _[name] = obj[name];
	      _.prototype[name] = function() {
	        var args = [this._wrapped];
	        push.apply(args, arguments);
	        return result(this, func.apply(_, args));
	      };
	    });
	  };
	
	  // Add all of the Underscore functions to the wrapper object.
	  _.mixin(_);
	
	  // Add all mutator Array functions to the wrapper.
	  _.each(['pop', 'push', 'reverse', 'shift', 'sort', 'splice', 'unshift'], function(name) {
	    var method = ArrayProto[name];
	    _.prototype[name] = function() {
	      var obj = this._wrapped;
	      method.apply(obj, arguments);
	      if ((name === 'shift' || name === 'splice') && obj.length === 0) delete obj[0];
	      return result(this, obj);
	    };
	  });
	
	  // Add all accessor Array functions to the wrapper.
	  _.each(['concat', 'join', 'slice'], function(name) {
	    var method = ArrayProto[name];
	    _.prototype[name] = function() {
	      return result(this, method.apply(this._wrapped, arguments));
	    };
	  });
	
	  // Extracts the result from a wrapped and chained object.
	  _.prototype.value = function() {
	    return this._wrapped;
	  };
	
	  // Provide unwrapping proxy for some methods used in engine operations
	  // such as arithmetic and JSON stringification.
	  _.prototype.valueOf = _.prototype.toJSON = _.prototype.value;
	
	  _.prototype.toString = function() {
	    return '' + this._wrapped;
	  };
	
	  // AMD registration happens at the end for compatibility with AMD loaders
	  // that may not enforce next-turn semantics on modules. Even though general
	  // practice for AMD registration is to be anonymous, underscore registers
	  // as a named module because, like jQuery, it is a base library that is
	  // popular enough to be bundled in a third party lib, but not be part of
	  // an AMD load request. Those cases could generate an error when an
	  // anonymous define() is called outside of a loader request.
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return _;
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
					__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	}.call(this));
	
	
	/***/ }),
	/* 1 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/*eslint no-console: ["error", { allow: ["warn", "error"] }] */
	
	var _ = __webpack_require__(0);
	var util = {};
	
	var MAX_ARRAY_INDEX = Math.pow(2, 53) - 1;
	util.isArrayLike = function (obj) {
	    if ((typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) !== 'object' || !obj) {
	        return false;
	    }
	    var length = obj.length;
	    return typeof length === 'number' && length % 1 === 0 && length >= 0 && length <= MAX_ARRAY_INDEX;
	};
	
	util.get = function (obj, accessor) {
	    var ret = undefined;
	    if (!_.isObject(obj)) {
	        return obj;
	    }
	    if (accessor == undefined) {
	        return obj;
	    }
	    if (_.isString(accessor)) {
	        accessor = accessor.split('.');
	        ret = obj;
	        try {
	            for (var i = 0; i < accessor.length; i++) {
	                ret = ret[accessor[i]];
	            }
	        } catch (e) {
	            ret = undefined;
	        }
	    } else if (_.isFunction(accessor)) {
	        ret = accessor(obj);
	    }
	    return ret;
	};
	
	util.deprecated = function (filter, msg) {
	    console.warn('[filter - ' + filter + ']:this filter has deprecated, it will be remove at next minor version. ' + msg);
	};
	
	util.type = function (filter, input, type) {
	    console.warn('[filter - ' + filter + ']: expect input type is :' + type + 'but got ' + (typeof input === 'undefined' ? 'undefined' : _typeof(input)));
	};
	
	module.exports = util;
	
	/***/ }),
	/* 2 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	var collection = __webpack_require__(5);
	var math = __webpack_require__(10);
	var string = __webpack_require__(22);
	var other = __webpack_require__(19);
	var number = __webpack_require__(15);
	var _ = __webpack_require__(0);
	
	var filters = {};
	
	['map', 'reduce', 'find', 'filter', 'reject', 'every', 'some', 'contains', 'pluck', 'max', 'min', 'sortBy', 'groupBy', 'indexBy', 'countBy', 'shuffle', 'sample', 'toArray', 'size', 'first', 'initial', 'last', 'rest', 'flatten', 'without', 'union', 'intersection', 'difference', 'uniq', 'keys', 'allKeys', 'values', 'pairs', 'invert', 'extend', 'pick', 'omit', 'defaults', 'has', 'escape', 'unescape', 'result', 'nl2br'].forEach(function (key) {
	    filters[key] = _[key];
	});
	
	filters = _.extend(filters, collection, string, math, number, other);
	
	module.exports = filters;
	
	/***/ }),
	/* 3 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	var _ = __webpack_require__(0);
	/**
	 * @filter at
	 * @description Return the item at the specified index in an array or a string.
	 * @example
	 * ```
	 * {{ ['a','b','c'] | at(1) }} => 'b'
	 * {{ 'hello' | at(0) }} => 'h'
	 * {{ 'js' | at(10) }} => undefined
	 * ```
	 */
	
	function at(collection, index) {
	    if (_.isArray(collection) || _.isString(collection)) {
	        index = Number(index);
	        return collection[index];
	    }
	    return undefined;
	}
	
	module.exports = at;
	
	/***/ }),
	/* 4 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	var _ = __webpack_require__(0);
	var util = __webpack_require__(1);
	
	var base = {};
	
	/**
	 * @filter push, pop, shift, unshift
	 * @description return a new array with those native array method. notice: those filter won't change origin array.
	 * @example
	 * ```
	 * {{ [1,2,3] | push(4) }}  => [1,2,3,4]
	 * {{ [1,2,3,4] | shift }}  => [2,3,4]
	 * ```
	 */
	['push', 'pop', 'shift', 'unshift'].forEach(function (method) {
	    base[method] = function (collection) {
	        if (util.isArrayLike(collection)) {
	            collection = _.toArray(collection);
	        }
	        if (_.isArray(collection)) {
	            collection[method].apply(collection, _.rest(arguments));
	            return collection;
	        } else {
	            util.type(collection, 'array');
	            return collection;
	        }
	    };
	});
	
	/**
	 * @filter slice, indexOf, concat, join
	 * @description the same way with native array method.
	 * @example
	 * ```
	 * {{ [1,2,3] | indexOf(2) }}  => 1
	 * {{ [1,2] | concat([3,4]) }}  => [1,2,3,4]
	 * {{ [1,2,3] | join('-) }} => '1-2-3'
	 * {{ [1,2,3] | slice(1) }} => [2,3]
	 * ```
	 */
	['slice', 'indexOf', 'concat', 'join'].forEach(function (method) {
	    base[method] = function (collection) {
	        if (!_.isArray(collection)) {
	            collection = _.toArray(collection);
	        }
	        return collection[method].apply(collection, _.rest(arguments));
	    };
	});
	
	module.exports = base;
	
	/***/ }),
	/* 5 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	var base = __webpack_require__(4);
	var at = __webpack_require__(3);
	var reverse = __webpack_require__(7);
	var range = __webpack_require__(6);
	var _ = __webpack_require__(0);
	
	module.exports = _.extend({
	    at: at,
	    reverse: reverse,
	    range: range
	}, base);
	
	/***/ }),
	/* 6 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	var util = __webpack_require__(1);
	var _ = __webpack_require__(0);
	/**
	 *  Return a new collection from a given length
	 *
	 *  {{ [] | range 4 }} => [0,1,2,3]
	 */
	
	function range(arr, n) {
	  util.deprecated('range', 'Because range is use to generate an array, it doesn\'t need a input, you can use _.range(n) generate an array directly.');
	  return _.range(n);
	}
	module.exports = range;
	
	/***/ }),
	/* 7 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	var _ = __webpack_require__(0);
	/**
	 * reverse an array or a string
	 *
	 * {{ 'abc' | reverse }} => 'cba'
	 * {{ [1,2,3] | reverse }} => [3,2,1]
	 */
	
	function reverse(collection) {
	    if (typeof collection === 'string') {
	        return collection.split('').reverse().join('');
	    }
	    if (_.isArray(collection)) {
	        return collection.concat().reverse();
	    }
	    return collection;
	}
	
	module.exports = reverse;
	
	/***/ }),
	/* 8 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	/*eslint no-console: ["error", { allow: ["warn", "error"] }] */
	
	var filters = __webpack_require__(2);
	var _ = __webpack_require__(0);
	
	function install(Vue) {
	    _.each(filters, function (value, key) {
	        if (Vue.filter(key)) {
	            console.warn('[filter duplication]: A filter named ' + key + 'has already been installed.');
	        } else {
	            Vue.filter(key, value);
	        }
	    });
	}
	
	if (typeof window !== 'undefined' && window.Vue) {
	    Vue.use(install);
	}
	
	module.exports = install;
	
	/***/ }),
	/* 9 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	/**
	 * 
	 * @description all the method in Math without random
	 * @example
	 * ```
	 * {{ -1.2 | abs }}  => 1.2
	 * {{ 1 | acos }}  => 0
	 * {{ 1.3 | ceil }} => 2
	 * {{ 3 | pow(2) }} => 9  i.e: Math.pow(3,2)
	 * ```
	 */
	
	var base = {};
	
	['abs', 'acos', 'asin', 'atan', 'atan2', 'ceil', 'cos', 'exp', 'floor', 'log', 'pow', 'round', 'sin', 'sqrt', 'tan'].forEach(function (method) {
	    base[method] = function (value, n) {
	        if (typeof value === 'number') {
	            return Math[method](value, n);
	        } else {
	            return value;
	        }
	    };
	});
	
	module.exports = base;
	
	/***/ }),
	/* 10 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	var base = __webpack_require__(9);
	var operator = __webpack_require__(12);
	
	var sum = __webpack_require__(13);
	var mean = __webpack_require__(11);
	
	var _ = __webpack_require__(0);
	
	module.exports = _.extend({
	    sum: sum,
	    mean: mean
	}, operator, base);
	
	/***/ }),
	/* 11 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	var _ = __webpack_require__(0);
	
	/**
	 * @param {array} arr - The array to iterate over.
	 * @description Returns the mean.
	 * @example
	 * ```
	 * {{ [1,2,3,4] | mean }} => 2.5
	 * ```
	 */
	
	function mean(arr) {
	    if (_.isArray(arr)) {
	        var sum = arr.reduce(function (prev, curr) {
	            return prev + curr;
	        }, 0);
	
	        var len = arr.length;
	        if (_.isNumber(sum) && len != 0) {
	            return sum / len;
	        } else {
	            return 0;
	        }
	    } else {
	        return arr;
	    }
	}
	
	module.exports = mean;
	
	/***/ }),
	/* 12 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	/*eslint no-console: ["error", { allow: ["warn", "error"] }] */
	
	/**
	 *
	 * @filter divide, minus, plus, multiply, mod, or, xor, and, not
	 * @description some math operator.
	 * @example
	 * ```
	 * {{ 10 | plus(1) }} => 11
	 * {{ 2 | or(1) }} => 3
	 * {{ 255 | not() }} => -256
	 * ```
	 */
	var operator = {};
	
	['divide', 'minus', 'plus', 'multiply', 'mod'].forEach(function (method) {
	    operator[method] = function (a, b) {
	        a = Number(a);
	        b = Number(b);
	
	        switch (method) {
	            case 'divide':
	                if (b === 0) {
	                    console.error('0 can\'t as a divisor');
	                }
	                return a / b;
	            case 'minus':
	                return a - b;
	            case 'plus':
	                return a + b;
	            case 'multiply':
	                return a * b;
	            case 'mod':
	                return a % b;
	            // case 'or':
	            //     return a | b;
	            // case 'xor':
	            //     return a ^ b;
	            // case 'and':
	            //     return a & b;
	        }
	    };
	});
	
	module.exports = operator;
	
	/***/ }),
	/* 13 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	var _ = __webpack_require__(0);
	/**
	 * 
	 * @param {Array} list - the array to be summed.
	 * @param {number} base - base value(default 0).
	 * @return {number} Returns the sum.
	 * @example
	 * ```
	 * {{ [1,2,3,4] | sum }} => 10
	 * {{ [1,2,3,4] | sum 20 }} => 30
	 * ```
	 */
	
	function sum(list, base) {
	
	    if (!_.isArray(list)) {
	        return Number(list);
	    }
	
	    var ret = base || 0;
	    for (var i = 0; i < list.length; i++) {
	        var val = list[i];
	        if (_.isNumber(val)) {
	            ret = ret + val;
	        } else {
	            return NaN;
	        }
	    }
	    return ret;
	}
	module.exports = sum;
	
	/***/ }),
	/* 14 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _ = __webpack_require__(0);
	var util = __webpack_require__(1);
	
	var base = {};
	
	['toFixed', 'toPrecision'].forEach(function (method) {
	    base[method] = function (num) {
	        var type = typeof num === 'undefined' ? 'undefined' : _typeof(num);
	        if (type === 'number') {
	            return Number.prototype[method].apply(num, _.rest(arguments));
	        } else {
	            util.type(num, 'number');
	            return num;
	        }
	    };
	});
	
	module.exports = base;
	
	/***/ }),
	/* 15 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	var base = __webpack_require__(14);
	
	module.exports = base;
	
	/***/ }),
	/* 16 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	/**
	Converts a timestamp into another date format.
	
	```html
	{{ Date.now() | date '%T' }}  => '13:34:36'
	{{ 'Wed Jan 20 2016 13:34:36 GMT+0800' | date '%T' }} => '13:34:36'
	{{ 1453268193752 | date '%Y-%m-%d' }} => '2016-01-20'
	{{ new Date | date '%I:%M:%s %p' }} => '1:39:22 PM'
	```
	
	**more date parameters are listed below:**
	
	
	| param | explanation | example |
	|:--:|:--|:--|
	|%a | Abbreviated weekday. |`{{ timestamp | date "%a" }} => "Sat" `|
	|%A |Full weekday name. |`{{ timestamp | date "%A" }} => "Tuesday" `|
	|%b |Abbreviated month name. |`{{ timestamp | date "%b" }} => "Jan" `|
	|%B |Full month name |`{{ timestamp | date "%B" }} => "January" `|
	|%c |Preferred local date and time representation |`{{ timestamp | date "%c" }} => "Tue Apr 22 11:16:09 2014" `|
	|%d |Day of the month, zero-padded (01, 02, 03, etc.). |`{{ timestamp | date "%d" }} => "04" `|
	%-d |Day of the month, not zero-padded (1,2,3, etc.). |`{{ timestamp | date "%-d" }} => "4" `|
	|%D |Formats the date (dd/mm/yy). |`{{ timestamp | date "%D" }} => "04/22/14" `|
	|%e |Day of the month, blank-padded ( 1, 2, 3, etc.). |`{{ timestamp | date "%e" }} => "3" `|
	|%F |Returns the date in ISO 8601 format (yyyy-mm-dd). |`{{ timestamp | date "%F" }} => "2014-04-22" `|
	|%H |Hour of the day, 24-hour clock (00 - 23). |`{{ timestamp | date "%H" }} => "15" `|
	|%I |Hour of the day, 12-hour clock (1 - 12). |`{{ timestamp | date "%I" }} => "7" `|
	|%j |Day of the year (001 - 366). |`{{ timestamp | date "%j" }} => "245" `|
	|%k |Hour of the day, 24-hour clock (1 - 24). |`{{ timestamp | date "%k" }} => "14" `|
	|%m |Month of the year (01 - 12). |`{{ timestamp | date "%m" }} => "04" `|
	|%M |Minute of the hour (00 - 59). |`{{ timestamp | date "%M" }} => "53" `|
	|%p |Meridian indicator (AM/PM). |`{{ timestamp | date "%p" }} => "PM" `|
	|%r |12-hour time (%I:%M:%S %p) |`{{ timestamp | date "%r" }} => "03:20:07 PM" `|
	|%R |24-hour time (%H:%M) |`{{ timestamp | date "%R" }} => "15:21" `|
	|%T |24-hour time (%H:%M:%S) |`{{ timestamp | date "%T" }} => "15:22:13" `|
	|%U |The number of the week in the current year, starting with the first Sunday as the first day of the first week. |`{{ timestamp | date "%U" }} => "16" `|
	|%W |The number of the week in the current year, starting with the first Monday as the first day of the first week. |`{{ timestamp | date "%W" }} => "16" `|
	|%w |Day of the week (0 - 6, with Sunday being 0). |`{{ timestamp | date "%w" }} => "2" `|
	|%x |Preferred representation for the date alone, no time. (mm/dd/yy). |`{{ timestamp | date "%x" }} => "04/22/14" `|
	|%X |Preferred representation for the time. (hh:mm:ss). |`{{ timestamp | date "%X" }} => "13:17:24" `|
	|%y |Year without a century (00.99). |`{{ timestamp | date "%y" }} => "14" `|
	|%Y |Year with a century. |`{{ timestamp | date "%Y" }} => "2014" `|
	
	 */
	var weekdays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
	var months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
	
	function date(date, formatString) {
	    var d = new Date(date);
	    var hours = 0;
	    var month = 0;
	
	    var zeroize = function zeroize(value, length) {
	
	        if (!length) length = 2;
	
	        value = '' + value;
	
	        for (var i = 0, zeros = ''; i < length - value.length; i++) {
	            zeros += '0';
	        }
	
	        return zeros + value;
	    };
	
	    function getDays() {
	        var days = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
	            year = d.getFullYear(),
	            month = d.getMonth(),
	            day = d.getDate();
	
	        if (year % 100 == 0 && year % 400 == 0 || year % 4 == 0) {
	            days[1] = 29;
	        }
	        var n = 0;
	        for (var i = 0; i < month; i++) {
	            n += days[i];
	        }
	        return n + day;
	    }
	
	    function cb(c) {
	        var ret = '';
	        switch (c) {
	            case '%a':
	                ret = weekdays[d.getDay()].slice(0, 3);
	                break;
	            case '%A':
	                ret = weekdays[d.getDay()];
	                break;
	            case '%b':
	                ret = months[d.getMonth()].slice(0, 3);
	                break;
	            case '%B':
	                ret = months[d.getMonth()];
	                break;
	            case '%c':
	                ret = d.toLocaleDateString() + ' ' + d.toLocaleTimeString();
	                break;
	            case '%d':
	                var day = d.getDate();
	                ret = zeroize(day);
	                break;
	            case '%-d':
	                ret = d.getDate();
	                break;
	            case '%D':
	                ret = '%m/%d/%Y';
	                break;
	            case '%e':
	                ret = d.getDate();
	                break;
	            case '%F':
	                ret = '%Y-%m-%d';
	                break;
	            case '%H':
	                hours = d.getHours();
	                ret = zeroize(hours);
	                break;
	            case '%I':
	                hours = d.getHours();
	                if (hours != 12) {
	                    hours = hours % 12;
	                }
	                ret = zeroize(hours);
	                break;
	            case '%j':
	                ret = zeroize(getDays(), 3);
	                break;
	            case 'k':
	                ret = d.getHours();
	                break;
	            case '%m':
	                month = d.getMonth() + 1;
	                ret = zeroize(month, 2);
	                break;
	            case '%M':
	                ret = zeroize(d.getMinutes(), 2);
	                break;
	            case '%s':
	                ret = zeroize(d.getSeconds(), 2);
	                break;
	            case '%p':
	                ret = d.getHours() < 12 ? 'AM' : 'PM';
	                break;
	            case '%r':
	                ret = '%I:%M:%s %p';
	                break;
	            case '%R':
	                ret = '%H:%M';
	                break;
	            case '%T':
	                ret = '%H:%M:%s';
	                break;
	            case '%U':
	                ret = Math.ceil(getDays() / 7);
	                break;
	            case '%w':
	                ret = d.getDay();
	                break;
	            case '%x':
	                ret = '%m/%d/%y';
	                break;
	            case '%X':
	                ret = '%H:%M:%s';
	                break;
	            case '%y':
	                ret = d.getFullYear() % 100;
	                break;
	            case '%Y':
	                ret = d.getFullYear();
	                break;
	            default:
	                ret = c;
	        }
	        return ret;
	    }
	    var re = /%-?[\w]/g;
	    if (!formatString) {
	        formatString = '%c';
	    }
	    formatString = formatString.replace(re, cb);
	    formatString = formatString.replace(re, cb);
	    return formatString;
	}
	
	module.exports = date;
	
	/***/ }),
	/* 17 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	var _ = __webpack_require__(0);
	
	/**
	 * debounce a function, the default dalay is 300ms
	 * 
	 * {{ func | debounce(300) }}
	 */
	
	function debounce(handler, delay) {
	    if (!handler) {
	        return;
	    }
	    if (!delay) {
	        delay = 300;
	    }
	    return _.debounce(handler, delay);
	}
	module.exports = debounce;
	
	/***/ }),
	/* 18 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	var util = __webpack_require__(1);
	
	/**
	 * Get a property inside an Object
	 * 
	 * james = {
	 *     contact:{
	 *         tel: 187xxxx0001
	 *     }
	 * }
	 * {{ james | get 'contact.tel' }} => 187xxxx0001
	 */
	
	function get(obj, accessor) {
	  return util.get(obj, accessor);
	}
	
	module.exports = get;
	
	/***/ }),
	/* 19 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	var date = __webpack_require__(16);
	var get = __webpack_require__(18);
	var debounce = __webpack_require__(17);
	
	module.exports = {
	    date: date,
	    debounce: debounce,
	    get: get
	};
	
	/***/ }),
	/* 20 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	/**
	 * Appends characters to a string.
	 *
	 * {{ 'sky' | append '.jpg' }} => 'sky.jpg'
	 */
	
	function append(str, postfix) {
	    if (!str && str !== 0) {
	        str = '';
	    } else {
	        str = str.toString();
	    }
	    return str + postfix;
	}
	
	module.exports = append;
	
	/***/ }),
	/* 21 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _ = __webpack_require__(0);
	var util = __webpack_require__(1);
	
	/**
	 *
	 * @description some native method in string
	 * @example
	 * ```
	 * {{ 'ab-cd' | replace('-', '') }}  => 'abcd'
	 * {{ 'a-b-c' | split('-') }}  => ['a','b','c']
	 * {{ 'javascript' | substr(0, 4) }} => 'java'
	 * {{ 'javascript' | substring(0,2) }} => 'jav'
	 * ```
	 */
	
	var base = {};
	
	['replace', 'split', 'substr', 'substring'].forEach(function (method) {
	    base[method] = function (str) {
	        var type = typeof str === 'undefined' ? 'undefined' : _typeof(str);
	        if (type === 'string') {
	            return String.prototype[method].apply(str, _.rest(arguments));
	        } else {
	            util.type(method, str, 'string'.substring);
	            return str;
	        }
	    };
	});
	
	module.exports = base;
	
	/***/ }),
	/* 22 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	var append = __webpack_require__(20);
	var prepend = __webpack_require__(24);
	var remove = __webpack_require__(25);
	var base = __webpack_require__(21);
	var test = __webpack_require__(27);
	var trimx = __webpack_require__(28);
	var truncate = __webpack_require__(29);
	var xpad = __webpack_require__(31);
	var repeat = __webpack_require__(26);
	var xcase = __webpack_require__(30);
	var nl2br = __webpack_require__(23);
	var _ = __webpack_require__(0);
	
	module.exports = _.extend({
	    append: append,
	    prepend: prepend,
	    remove: remove, // enhance
	    test: test,
	    truncate: truncate,
	    repeat: repeat,
	    nl2br: nl2br
	}, base, xcase, xpad, trimx);
	
	/***/ }),
	/* 23 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	/**
	 * Replaces new line to br tag based on regex /\r\n/g -> this can be overwritten by passing
	 * your own regex as second param.
	 *
	 * returns a single sting best printed as raw html.
	 *
	 * Vue 1.0  <p> {{{ text | nl2br }}} </p>
	 *
	 * Vue 2.0  <p v-html="$options.filters.nl2br(text)"></p>
	 * NOTE: v-html does not support the piped filter syntax so directly access the filter function.
	 */
	
	function nl2br(text) {
	  var reg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : /\n\r/g;
	
	  if (text && text !== null) {
	    var i = void 0,
	        s = '',
	        lines = text.split(reg),
	        l = lines.length;
	
	    for (i = 0; i < l; ++i) {
	      s += lines[i];
	      i !== l - 1 && (s += '<br/>');
	    }
	
	    return s;
	  }
	  return text;
	}
	
	module.exports = nl2br;
	
	/***/ }),
	/* 24 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	/**
	 * Prepends characters to a string.
	 *
	 * {{ 'world' | prepend 'hello ' }} => 'hello world'
	 */
	
	function prepend(str, prefix) {
	    if (!str && str !== 0) {
	        str = '';
	    } else {
	        str = str.toString();
	    }
	    return prefix + str;
	}
	
	module.exports = prepend;
	
	/***/ }),
	/* 25 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	var _ = __webpack_require__(0);
	var util = __webpack_require__(1);
	/**
	 * @description Removes all occurrences of a substring from a string.
	 * @example
	 * ```
	 * {{ 'Hello JavaScript' | remove 'Hello' }} => ' JavaScript'
	 * ```
	 */
	
	function remove(str, substr) {
	    util.deprecated('remove', 'You can use `replace(substr, \'\')` instead of remove');
	    if (_.isString(str)) {
	        str = str.split(substr).join('');
	    }
	    return str;
	}
	
	module.exports = remove;
	
	/***/ }),
	/* 26 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	/**
	 * @description return a string which build by repeat the given str n times.
	 *
	 * {{ 'abc' | repeat 3 }} => 'abcabcabc'
	 */
	
	function repeat(str, n) {
	    n = n ? Number(n) : 0;
	    if (n != n) {
	        // NAN
	        n = 0;
	    }
	
	    n = Math.floor(n);
	
	    if (n <= -1) {
	        n = 0;
	    }
	
	    str = '' + str;
	
	    var ret = '';
	    while (n !== 0) {
	        if (n & 1 === 1) {
	            ret += str;
	        }
	        str += str;
	        n >>>= 1;
	    }
	    return ret;
	}
	
	module.exports = repeat;
	
	/***/ }),
	/* 27 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	/**
	 * Test if a string match a pattern
	 *
	 * {{ "http://vuejs.org" | test /^http/ }} => true
	 */
	
	function test(str, re, flag) {
	  re = new RegExp(re, flag);
	  return re.test(str);
	}
	
	module.exports = test;
	
	/***/ }),
	/* 28 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	var util = __webpack_require__(1);
	var _ = __webpack_require__(0);
	/**
	 * Strips tabs, spaces, and newlines (all whitespace)
	 * from the left or right or both side of a string.
	 * which depends on second argument. if it is 'r' will only
	 * trim right side,if it is 'l' will only trim left side
	 * otherwise trim both left and right side.
	 *
	 * {{ '   some spaces   ' | trim }} => 'some spaces'
	 * {{ '   some spaces   ' | trimRight }} => '   some spaces'
	 * {{ '   some spaces   ' | trimLeft }} => 'some spaces   '
	 */
	
	function _trim(str, re) {
	    if (_.isString(str)) {
	        return str.replace(re, '');
	    } else {
	        util.type('trim', str, 'string');
	        return str;
	    }
	}
	
	function trim(str) {
	    return _trim(str, /^\s+|\s+$/g);
	}
	
	function trimLeft(str) {
	    return _trim(str, /^\s+/);
	}
	
	function trimRight(str) {
	    return _trim(str, /\s+$/);
	}
	
	module.exports = {
	    trim: trim,
	    trimLeft: trimLeft,
	    trimRight: trimRight
	};
	
	/***/ }),
	/* 29 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	/**
	 * @description truncate text to a specified length.
	 * **notice: the length donot include the length of ellipses string, 
	 * this mean the origin string will but cat to specific length and then append the ellipses string**
	 * the default length is 30, default ellipses string is `'...'`
	 * @example
	 * ```
	 * {{ 'this is a big city!' | truncate(12) }} => 'this is a bi...`
	 * {{ 'this is a big city!' | truncate(12, '~~~') }} => 'this is a bi~~~`
	 * ```
	 */
	
	function truncate(str, length, ellipses) {
	    length = length || 30;
	
	    if (str.length <= length) {
	        return str;
	    }
	
	    if (ellipses === undefined) {
	        ellipses = '...';
	    }
	    ellipses = '' + ellipses;
	
	    str = str.slice(0, length);
	
	    return str + ellipses;
	}
	
	module.exports = truncate;
	
	/***/ }),
	/* 30 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	/**
	 * @description Uppercase a string
	 * @example
	 * ```
	 * {{ 'abC' | uppercase }} => 'ABC'
	 * ```
	 */
	function uppercase(value) {
	    return value || value === 0 ? value.toString().toUpperCase() : '';
	}
	
	/**
	 * @description Lowercase a string
	 * @example
	 * ```
	 * {{ 'abC' | uppercase }} => 'ABC'
	 * ```
	 */
	function lowercase(value) {
	    return value || value === 0 ? value.toString().toLowerCase() : '';
	}
	
	/**
	 * @description Converts a string into CamelCase.
	 * @example
	 * ```
	 * {{ 'some_else' | camelcase }} => 'SomeElse'
	 * {{ 'some-else' | camelcase }} => 'SomeElse'
	 * ```
	 */
	function camelcase(str) {
	    var re = /(?:^|[-_\/])(\w)/g;
	    return str.toString().replace(re, function (_, c) {
	        return c.toUpperCase();
	    });
	}
	
	module.exports = {
	    uppercase: uppercase,
	    lowercase: lowercase,
	    camelcase: camelcase
	};
	
	/***/ }),
	/* 31 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	/**
	 * return a string by repeat a char n times
	 */
	
	function padding(size, ch) {
	    var str = '';
	    if (!ch && ch !== 0) {
	        ch = ' ';
	    }
	    while (size !== 0) {
	        if (size & 1 === 1) {
	            str += ch;
	        }
	        ch += ch;
	        size >>>= 1;
	    }
	    return str;
	}
	
	/**
	 * @description leftPad
	 * @example
	 * ```
	 * {{ 'abc' | leftPad(5, '*') }} => '**abc'
	 * ```
	 */
	function leftPad(str, size, ch) {
	    size = +size || 0;
	    var padLength = size - str.length;
	    if (padLength <= 0) {
	        return str;
	    }
	    return padding(padLength, ch).concat(str);
	}
	
	/**
	 * @description rightPad
	 * ```
	 * {{ 'abc' | leftPad(5, '*') }} => 'abc**'
	 * ```
	 */
	function rightPad(str, size, ch) {
	    size = +size || 0;
	    var padLength = size - str.length;
	    if (padLength <= 0) {
	        return str;
	    }
	    return str.concat(padding(padLength, ch));
	}
	
	module.exports = {
	    leftPad: leftPad,
	    rightPad: rightPad
	};
	
	/***/ })
	/******/ ]);
	});

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

	/*!
	 * Vue-Lazyload.js v1.3.3
	 * (c) 2019 Awe <hilongjw@gmail.com>
	 * Released under the MIT License.
	 */
	!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define(t):e.VueLazyload=t()}(this,function(){"use strict";function e(e){return e.constructor&&"function"==typeof e.constructor.isBuffer&&e.constructor.isBuffer(e)}function t(e){e=e||{};var t=arguments.length,i=0;if(1===t)return e;for(;++i<t;){var o=arguments[i];g(e)&&(e=o),r(o)&&n(e,o)}return e}function n(e,n){m(e,n);for(var o in n)if("__proto__"!==o&&i(n,o)){var a=n[o];r(a)?("undefined"===L(e[o])&&"function"===L(a)&&(e[o]=a),e[o]=t(e[o]||{},a)):e[o]=a}return e}function r(e){return"object"===L(e)||"function"===L(e)}function i(e,t){return Object.prototype.hasOwnProperty.call(e,t)}function o(e,t){if(e.length){var n=e.indexOf(t);return n>-1?e.splice(n,1):void 0}}function a(e,t){for(var n=!1,r=0,i=e.length;r<i;r++)if(t(e[r])){n=!0;break}return n}function s(e,t){if("IMG"===e.tagName&&e.getAttribute("data-srcset")){var n=e.getAttribute("data-srcset"),r=[],i=e.parentNode,o=i.offsetWidth*t,a=void 0,s=void 0,u=void 0;n=n.trim().split(","),n.map(function(e){e=e.trim(),a=e.lastIndexOf(" "),-1===a?(s=e,u=999998):(s=e.substr(0,a),u=parseInt(e.substr(a+1,e.length-a-2),10)),r.push([u,s])}),r.sort(function(e,t){if(e[0]<t[0])return 1;if(e[0]>t[0])return-1;if(e[0]===t[0]){if(-1!==t[1].indexOf(".webp",t[1].length-5))return 1;if(-1!==e[1].indexOf(".webp",e[1].length-5))return-1}return 0});for(var d="",l=void 0,c=0;c<r.length;c++){l=r[c],d=l[1];var h=r[c+1];if(h&&h[0]<o){d=l[1];break}if(!h){d=l[1];break}}return d}}function u(e,t){for(var n=void 0,r=0,i=e.length;r<i;r++)if(t(e[r])){n=e[r];break}return n}function d(){if(!E)return!1;var e=!0,t=document;try{var n=t.createElement("object");n.type="image/webp",n.style.visibility="hidden",n.innerHTML="!",t.body.appendChild(n),e=!n.offsetWidth,t.body.removeChild(n)}catch(t){e=!1}return e}function l(e,t){var n=null,r=0;return function(){if(!n){var i=Date.now()-r,o=this,a=arguments,s=function(){r=Date.now(),n=!1,e.apply(o,a)};i>=t?s():n=setTimeout(s,t)}}}function c(e){return null!==e&&"object"===(void 0===e?"undefined":p(e))}function h(e){if(!(e instanceof Object))return[];if(Object.keys)return Object.keys(e);var t=[];for(var n in e)e.hasOwnProperty(n)&&t.push(n);return t}function f(e){for(var t=e.length,n=[],r=0;r<t;r++)n.push(e[r]);return n}function v(){}var p="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},y=function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")},b=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),g=function(e){return null==e||"function"!=typeof e&&"object"!==(void 0===e?"undefined":p(e))},m=function(e,t){if(null===e||void 0===e)throw new TypeError("expected first argument to be an object.");if(void 0===t||"undefined"==typeof Symbol)return e;if("function"!=typeof Object.getOwnPropertySymbols)return e;for(var n=Object.prototype.propertyIsEnumerable,r=Object(e),i=arguments.length,o=0;++o<i;)for(var a=Object(arguments[o]),s=Object.getOwnPropertySymbols(a),u=0;u<s.length;u++){var d=s[u];n.call(a,d)&&(r[d]=a[d])}return r},w=Object.prototype.toString,L=function(t){var n=void 0===t?"undefined":p(t);return"undefined"===n?"undefined":null===t?"null":!0===t||!1===t||t instanceof Boolean?"boolean":"string"===n||t instanceof String?"string":"number"===n||t instanceof Number?"number":"function"===n||t instanceof Function?void 0!==t.constructor.name&&"Generator"===t.constructor.name.slice(0,9)?"generatorfunction":"function":void 0!==Array.isArray&&Array.isArray(t)?"array":t instanceof RegExp?"regexp":t instanceof Date?"date":(n=w.call(t),"[object RegExp]"===n?"regexp":"[object Date]"===n?"date":"[object Arguments]"===n?"arguments":"[object Error]"===n?"error":"[object Promise]"===n?"promise":e(t)?"buffer":"[object Set]"===n?"set":"[object WeakSet]"===n?"weakset":"[object Map]"===n?"map":"[object WeakMap]"===n?"weakmap":"[object Symbol]"===n?"symbol":"[object Map Iterator]"===n?"mapiterator":"[object Set Iterator]"===n?"setiterator":"[object String Iterator]"===n?"stringiterator":"[object Array Iterator]"===n?"arrayiterator":"[object Int8Array]"===n?"int8array":"[object Uint8Array]"===n?"uint8array":"[object Uint8ClampedArray]"===n?"uint8clampedarray":"[object Int16Array]"===n?"int16array":"[object Uint16Array]"===n?"uint16array":"[object Int32Array]"===n?"int32array":"[object Uint32Array]"===n?"uint32array":"[object Float32Array]"===n?"float32array":"[object Float64Array]"===n?"float64array":"object")},_=t,E="undefined"!=typeof window,k=function(){return!!(E&&"IntersectionObserver"in window&&"IntersectionObserverEntry"in window&&"intersectionRatio"in window.IntersectionObserverEntry.prototype)&&("isIntersecting"in window.IntersectionObserverEntry.prototype||Object.defineProperty(window.IntersectionObserverEntry.prototype,"isIntersecting",{get:function(){return this.intersectionRatio>0}}),!0)}(),A={event:"event",observer:"observer"},j=function(){function e(e,t){t=t||{bubbles:!1,cancelable:!1,detail:void 0};var n=document.createEvent("CustomEvent");return n.initCustomEvent(e,t.bubbles,t.cancelable,t.detail),n}if(E)return"function"==typeof window.CustomEvent?window.CustomEvent:(e.prototype=window.Event.prototype,e)}(),z=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:1;return E?window.devicePixelRatio||e:e},I=function(){if(E){var e=!1;try{var t=Object.defineProperty({},"passive",{get:function(){e=!0}});window.addEventListener("test",null,t)}catch(e){}return e}}(),O={on:function(e,t,n){var r=arguments.length>3&&void 0!==arguments[3]&&arguments[3];I?e.addEventListener(t,n,{capture:r,passive:!0}):e.addEventListener(t,n,r)},off:function(e,t,n){var r=arguments.length>3&&void 0!==arguments[3]&&arguments[3];e.removeEventListener(t,n,r)}},T=function(e,t,n){var r=new Image;if(!e||!e.src){var i=new Error("image src is required");return n(i)}r.src=e.src,r.onload=function(){t({naturalHeight:r.naturalHeight,naturalWidth:r.naturalWidth,src:r.src})},r.onerror=function(e){n(e)}},S=function(e,t){return"undefined"!=typeof getComputedStyle?getComputedStyle(e,null).getPropertyValue(t):e.style[t]},x=function(e){return S(e,"overflow")+S(e,"overflow-y")+S(e,"overflow-x")},$=function(e){if(E){if(!(e instanceof HTMLElement))return window;for(var t=e;t&&t!==document.body&&t!==document.documentElement&&t.parentNode;){if(/(scroll|auto)/.test(x(t)))return t;t=t.parentNode}return window}},C=function(){function e(t){var n=t.max;y(this,e),this.options={max:n||100},this._caches=[]}return b(e,[{key:"has",value:function(e){return this._caches.indexOf(e)>-1}},{key:"add",value:function(e){this.has(e)||(this._caches.push(e),this._caches.length>this.options.max&&this.free())}},{key:"free",value:function(){this._caches.shift()}}]),e}(),H=function(){function e(t){var n=t.el,r=t.src,i=t.error,o=t.loading,a=t.bindType,s=t.$parent,u=t.options,d=t.elRenderer,l=t.imageCache;y(this,e),this.el=n,this.src=r,this.error=i,this.loading=o,this.bindType=a,this.attempt=0,this.naturalHeight=0,this.naturalWidth=0,this.options=u,this.rect=null,this.$parent=s,this.elRenderer=d,this._imageCache=l,this.performanceData={init:Date.now(),loadStart:0,loadEnd:0},this.filter(),this.initState(),this.render("loading",!1)}return b(e,[{key:"initState",value:function(){"dataset"in this.el?this.el.dataset.src=this.src:this.el.setAttribute("data-src",this.src),this.state={loading:!1,error:!1,loaded:!1,rendered:!1}}},{key:"record",value:function(e){this.performanceData[e]=Date.now()}},{key:"update",value:function(e){var t=e.src,n=e.loading,r=e.error,i=this.src;this.src=t,this.loading=n,this.error=r,this.filter(),i!==this.src&&(this.attempt=0,this.initState())}},{key:"getRect",value:function(){this.rect=this.el.getBoundingClientRect()}},{key:"checkInView",value:function(){return this.getRect(),this.rect.top<window.innerHeight*this.options.preLoad&&this.rect.bottom>this.options.preLoadTop&&this.rect.left<window.innerWidth*this.options.preLoad&&this.rect.right>0}},{key:"filter",value:function(){var e=this;h(this.options.filter).map(function(t){e.options.filter[t](e,e.options)})}},{key:"renderLoading",value:function(e){var t=this;this.state.loading=!0,T({src:this.loading},function(n){t.render("loading",!1),t.state.loading=!1,e()},function(){e(),t.state.loading=!1,t.options.silent||console.warn("VueLazyload log: load failed with loading image("+t.loading+")")})}},{key:"load",value:function(){var e=this,t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:v;return this.attempt>this.options.attempt-1&&this.state.error?(this.options.silent||console.log("VueLazyload log: "+this.src+" tried too more than "+this.options.attempt+" times"),void t()):this.state.rendered&&this.state.loaded?void 0:this._imageCache.has(this.src)?(this.state.loaded=!0,this.render("loaded",!0),this.state.rendered=!0,t()):void this.renderLoading(function(){e.attempt++,e.options.adapter.beforeLoad&&e.options.adapter.beforeLoad(e,e.options),e.record("loadStart"),T({src:e.src},function(n){e.naturalHeight=n.naturalHeight,e.naturalWidth=n.naturalWidth,e.state.loaded=!0,e.state.error=!1,e.record("loadEnd"),e.render("loaded",!1),e.state.rendered=!0,e._imageCache.add(e.src),t()},function(t){!e.options.silent&&console.error(t),e.state.error=!0,e.state.loaded=!1,e.render("error",!1)})})}},{key:"render",value:function(e,t){this.elRenderer(this,e,t)}},{key:"performance",value:function(){var e="loading",t=0;return this.state.loaded&&(e="loaded",t=(this.performanceData.loadEnd-this.performanceData.loadStart)/1e3),this.state.error&&(e="error"),{src:this.src,state:e,time:t}}},{key:"$destroy",value:function(){this.el=null,this.src=null,this.error=null,this.loading=null,this.bindType=null,this.attempt=0}}]),e}(),Q="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7",R=["scroll","wheel","mousewheel","resize","animationend","transitionend","touchmove"],W={rootMargin:"0px",threshold:0},B=function(e){return function(){function t(e){var n=e.preLoad,r=e.error,i=e.throttleWait,o=e.preLoadTop,a=e.dispatchEvent,s=e.loading,u=e.attempt,c=e.silent,h=void 0===c||c,f=e.scale,v=e.listenEvents,p=(e.hasbind,e.filter),b=e.adapter,g=e.observer,m=e.observerOptions;y(this,t),this.version="1.3.3",this.mode=A.event,this.ListenerQueue=[],this.TargetIndex=0,this.TargetQueue=[],this.options={silent:h,dispatchEvent:!!a,throttleWait:i||200,preLoad:n||1.3,preLoadTop:o||0,error:r||Q,loading:s||Q,attempt:u||3,scale:f||z(f),ListenEvents:v||R,hasbind:!1,supportWebp:d(),filter:p||{},adapter:b||{},observer:!!g,observerOptions:m||W},this._initEvent(),this._imageCache=new C({max:200}),this.lazyLoadHandler=l(this._lazyLoadHandler.bind(this),this.options.throttleWait),this.setMode(this.options.observer?A.observer:A.event)}return b(t,[{key:"config",value:function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};_(this.options,e)}},{key:"performance",value:function(){var e=[];return this.ListenerQueue.map(function(t){e.push(t.performance())}),e}},{key:"addLazyBox",value:function(e){this.ListenerQueue.push(e),E&&(this._addListenerTarget(window),this._observer&&this._observer.observe(e.el),e.$el&&e.$el.parentNode&&this._addListenerTarget(e.$el.parentNode))}},{key:"add",value:function(t,n,r){var i=this;if(a(this.ListenerQueue,function(e){return e.el===t}))return this.update(t,n),e.nextTick(this.lazyLoadHandler);var o=this._valueFormatter(n.value),u=o.src,d=o.loading,l=o.error;e.nextTick(function(){u=s(t,i.options.scale)||u,i._observer&&i._observer.observe(t);var o=Object.keys(n.modifiers)[0],a=void 0;o&&(a=r.context.$refs[o],a=a?a.$el||a:document.getElementById(o)),a||(a=$(t));var c=new H({bindType:n.arg,$parent:a,el:t,loading:d,error:l,src:u,elRenderer:i._elRenderer.bind(i),options:i.options,imageCache:i._imageCache});i.ListenerQueue.push(c),E&&(i._addListenerTarget(window),i._addListenerTarget(a)),i.lazyLoadHandler(),e.nextTick(function(){return i.lazyLoadHandler()})})}},{key:"update",value:function(t,n,r){var i=this,o=this._valueFormatter(n.value),a=o.src,d=o.loading,l=o.error;a=s(t,this.options.scale)||a;var c=u(this.ListenerQueue,function(e){return e.el===t});c?c.update({src:a,loading:d,error:l}):this.add(t,n,r),this._observer&&(this._observer.unobserve(t),this._observer.observe(t)),this.lazyLoadHandler(),e.nextTick(function(){return i.lazyLoadHandler()})}},{key:"remove",value:function(e){if(e){this._observer&&this._observer.unobserve(e);var t=u(this.ListenerQueue,function(t){return t.el===e});t&&(this._removeListenerTarget(t.$parent),this._removeListenerTarget(window),o(this.ListenerQueue,t),t.$destroy())}}},{key:"removeComponent",value:function(e){e&&(o(this.ListenerQueue,e),this._observer&&this._observer.unobserve(e.el),e.$parent&&e.$el.parentNode&&this._removeListenerTarget(e.$el.parentNode),this._removeListenerTarget(window))}},{key:"setMode",value:function(e){var t=this;k||e!==A.observer||(e=A.event),this.mode=e,e===A.event?(this._observer&&(this.ListenerQueue.forEach(function(e){t._observer.unobserve(e.el)}),this._observer=null),this.TargetQueue.forEach(function(e){t._initListen(e.el,!0)})):(this.TargetQueue.forEach(function(e){t._initListen(e.el,!1)}),this._initIntersectionObserver())}},{key:"_addListenerTarget",value:function(e){if(e){var t=u(this.TargetQueue,function(t){return t.el===e});return t?t.childrenCount++:(t={el:e,id:++this.TargetIndex,childrenCount:1,listened:!0},this.mode===A.event&&this._initListen(t.el,!0),this.TargetQueue.push(t)),this.TargetIndex}}},{key:"_removeListenerTarget",value:function(e){var t=this;this.TargetQueue.forEach(function(n,r){n.el===e&&(--n.childrenCount||(t._initListen(n.el,!1),t.TargetQueue.splice(r,1),n=null))})}},{key:"_initListen",value:function(e,t){var n=this;this.options.ListenEvents.forEach(function(r){return O[t?"on":"off"](e,r,n.lazyLoadHandler)})}},{key:"_initEvent",value:function(){var e=this;this.Event={listeners:{loading:[],loaded:[],error:[]}},this.$on=function(t,n){e.Event.listeners[t]||(e.Event.listeners[t]=[]),e.Event.listeners[t].push(n)},this.$once=function(t,n){function r(){i.$off(t,r),n.apply(i,arguments)}var i=e;e.$on(t,r)},this.$off=function(t,n){if(!n){if(!e.Event.listeners[t])return;return void(e.Event.listeners[t].length=0)}o(e.Event.listeners[t],n)},this.$emit=function(t,n,r){e.Event.listeners[t]&&e.Event.listeners[t].forEach(function(e){return e(n,r)})}}},{key:"_lazyLoadHandler",value:function(){var e=this,t=[];this.ListenerQueue.forEach(function(e,n){e.el&&e.el.parentNode||t.push(e),e.checkInView()&&e.load()}),t.forEach(function(t){o(e.ListenerQueue,t),t.$destroy()})}},{key:"_initIntersectionObserver",value:function(){var e=this;k&&(this._observer=new IntersectionObserver(this._observerHandler.bind(this),this.options.observerOptions),this.ListenerQueue.length&&this.ListenerQueue.forEach(function(t){e._observer.observe(t.el)}))}},{key:"_observerHandler",value:function(e,t){var n=this;e.forEach(function(e){e.isIntersecting&&n.ListenerQueue.forEach(function(t){if(t.el===e.target){if(t.state.loaded)return n._observer.unobserve(t.el);t.load()}})})}},{key:"_elRenderer",value:function(e,t,n){if(e.el){var r=e.el,i=e.bindType,o=void 0;switch(t){case"loading":o=e.loading;break;case"error":o=e.error;break;default:o=e.src}if(i?r.style[i]='url("'+o+'")':r.getAttribute("src")!==o&&r.setAttribute("src",o),r.setAttribute("lazy",t),this.$emit(t,e,n),this.options.adapter[t]&&this.options.adapter[t](e,this.options),this.options.dispatchEvent){var a=new j(t,{detail:e});r.dispatchEvent(a)}}}},{key:"_valueFormatter",value:function(e){var t=e,n=this.options.loading,r=this.options.error;return c(e)&&(e.src||this.options.silent||console.error("Vue Lazyload warning: miss src with "+e),t=e.src,n=e.loading||this.options.loading,r=e.error||this.options.error),{src:t,loading:n,error:r}}}]),t}()},D=function(e){return{props:{tag:{type:String,default:"div"}},render:function(e){return!1===this.show?e(this.tag):e(this.tag,null,this.$slots.default)},data:function(){return{el:null,state:{loaded:!1},rect:{},show:!1}},mounted:function(){this.el=this.$el,e.addLazyBox(this),e.lazyLoadHandler()},beforeDestroy:function(){e.removeComponent(this)},methods:{getRect:function(){this.rect=this.$el.getBoundingClientRect()},checkInView:function(){return this.getRect(),E&&this.rect.top<window.innerHeight*e.options.preLoad&&this.rect.bottom>0&&this.rect.left<window.innerWidth*e.options.preLoad&&this.rect.right>0},load:function(){this.show=!0,this.state.loaded=!0,this.$emit("show",this)},destroy:function(){return this.$destroy}}}},V=function(){function e(t){var n=t.lazy;y(this,e),this.lazy=n,n.lazyContainerMananger=this,this._queue=[]}return b(e,[{key:"bind",value:function(e,t,n){var r=new P({el:e,binding:t,vnode:n,lazy:this.lazy});this._queue.push(r)}},{key:"update",value:function(e,t,n){var r=u(this._queue,function(t){return t.el===e});r&&r.update({el:e,binding:t,vnode:n})}},{key:"unbind",value:function(e,t,n){var r=u(this._queue,function(t){return t.el===e});r&&(r.clear(),o(this._queue,r))}}]),e}(),N={selector:"img"},P=function(){function e(t){var n=t.el,r=t.binding,i=t.vnode,o=t.lazy;y(this,e),this.el=null,this.vnode=i,this.binding=r,this.options={},this.lazy=o,this._queue=[],this.update({el:n,binding:r})}return b(e,[{key:"update",value:function(e){var t=this,n=e.el,r=e.binding;this.el=n,this.options=_({},N,r.value),this.getImgs().forEach(function(e){t.lazy.add(e,_({},t.binding,{value:{src:"dataset"in e?e.dataset.src:e.getAttribute("data-src"),error:("dataset"in e?e.dataset.error:e.getAttribute("data-error"))||t.options.error,loading:("dataset"in e?e.dataset.loading:e.getAttribute("data-loading"))||t.options.loading}}),t.vnode)})}},{key:"getImgs",value:function(){return f(this.el.querySelectorAll(this.options.selector))}},{key:"clear",value:function(){var e=this;this.getImgs().forEach(function(t){return e.lazy.remove(t)}),this.vnode=null,this.binding=null,this.lazy=null}}]),e}(),M=function(e){return{props:{src:[String,Object],tag:{type:String,default:"img"}},render:function(e){return e(this.tag,{attrs:{src:this.renderSrc}},this.$slots.default)},data:function(){return{el:null,options:{src:"",error:"",loading:"",attempt:e.options.attempt},state:{loaded:!1,error:!1,attempt:0},rect:{},renderSrc:""}},watch:{src:function(){this.init(),e.addLazyBox(this),e.lazyLoadHandler()}},created:function(){this.init(),this.renderSrc=this.options.loading},mounted:function(){this.el=this.$el,e.addLazyBox(this),e.lazyLoadHandler()},beforeDestroy:function(){e.removeComponent(this)},methods:{init:function(){var t=e._valueFormatter(this.src),n=t.src,r=t.loading,i=t.error;this.state.loaded=!1,this.options.src=n,this.options.error=i,this.options.loading=r,this.renderSrc=this.options.loading},getRect:function(){this.rect=this.$el.getBoundingClientRect()},checkInView:function(){return this.getRect(),E&&this.rect.top<window.innerHeight*e.options.preLoad&&this.rect.bottom>0&&this.rect.left<window.innerWidth*e.options.preLoad&&this.rect.right>0},load:function(){var t=this,n=arguments.length>0&&void 0!==arguments[0]?arguments[0]:v;if(this.state.attempt>this.options.attempt-1&&this.state.error)return e.options.silent||console.log("VueLazyload log: "+this.options.src+" tried too more than "+this.options.attempt+" times"),void n();var r=this.options.src;T({src:r},function(e){var n=e.src;t.renderSrc=n,t.state.loaded=!0},function(e){t.state.attempt++,t.renderSrc=t.options.error,t.state.error=!0})}}}};return{install:function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},n=B(e),r=new n(t),i=new V({lazy:r}),o="2"===e.version.split(".")[0];e.prototype.$Lazyload=r,t.lazyComponent&&e.component("lazy-component",D(r)),t.lazyImage&&e.component("lazy-image",M(r)),o?(e.directive("lazy",{bind:r.add.bind(r),update:r.update.bind(r),componentUpdated:r.lazyLoadHandler.bind(r),unbind:r.remove.bind(r)}),e.directive("lazy-container",{bind:i.bind.bind(i),componentUpdated:i.update.bind(i),unbind:i.unbind.bind(i)})):(e.directive("lazy",{bind:r.lazyLoadHandler.bind(r),update:function(e,t){_(this.vm.$refs,this.vm.$els),r.add(this.el,{modifiers:this.modifiers||{},arg:this.arg,value:e,oldValue:t},{context:this.vm})},unbind:function(){r.remove(this.el)}}),e.directive("lazy-container",{update:function(e,t){i.update(this.el,{modifiers:this.modifiers||{},arg:this.arg,value:e,oldValue:t},{context:this.vm})},unbind:function(){i.unbind(this.el)}}))}}});


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(60),
	  /* template */
	  __webpack_require__(203),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(136)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(61),
	  /* template */
	  __webpack_require__(204),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(143)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(62),
	  /* template */
	  __webpack_require__(211),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(63),
	  /* template */
	  __webpack_require__(202),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(64),
	  /* template */
	  __webpack_require__(213),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(140)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(65),
	  /* template */
	  __webpack_require__(208),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(148)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(66),
	  /* template */
	  __webpack_require__(217),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(154)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(67),
	  /* template */
	  __webpack_require__(223),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(137)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(68),
	  /* template */
	  __webpack_require__(205),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(149)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(69),
	  /* template */
	  __webpack_require__(218),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(141)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(70),
	  /* template */
	  __webpack_require__(209),
	  /* scopeId */
	  "data-v-41b7e802",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(145)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(71),
	  /* template */
	  __webpack_require__(214),
	  /* scopeId */
	  "data-v-6a18aad7",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(144)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(72),
	  /* template */
	  __webpack_require__(212),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(155)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(73),
	  /* template */
	  __webpack_require__(224),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(153)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(74),
	  /* template */
	  __webpack_require__(222),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(150)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(75),
	  /* template */
	  __webpack_require__(219),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(139)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(76),
	  /* template */
	  __webpack_require__(207),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(138)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(77),
	  /* template */
	  __webpack_require__(206),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(152)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(78),
	  /* template */
	  __webpack_require__(221),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(151)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(79),
	  /* template */
	  __webpack_require__(220),
	  /* scopeId */
	  "data-v-8f459844",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(146)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(80),
	  /* template */
	  __webpack_require__(215),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(142)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(81),
	  /* template */
	  __webpack_require__(210),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(147)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(82),
	  /* template */
	  __webpack_require__(216),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 202 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "modal fade",
	    class: _vm.classes
	  }, [_c('div', {
	    staticClass: "modal-dialog modal-lg"
	  }, [_c('div', {
	    staticClass: "modal-content"
	  }, [_c('div', {
	    staticClass: "modal-header"
	  }, [_c('button', {
	    staticClass: "close",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.close
	    }
	  }, [_c('span', [_vm._v("×")]), _c('span', {
	    staticClass: "sr-only"
	  }, [_vm._v("Close")])]), _vm._v(" "), _c('h4', {
	    staticClass: "modal-title"
	  }, [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), (_vm.opened) ? _c('div', [_vm._t("default")], 2) : _vm._e()])])])
	},staticRenderFns: []}

/***/ }),
/* 203 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row wrapper border-bottom white-bg page-heading"
	  }, [_c('div', {
	    staticClass: "col-lg-8"
	  }, [_c('h2', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), (_vm.count > 0) ? _c('ol', {
	    staticClass: "breadcrumb"
	  }, _vm._l((_vm.paths), function(val, index) {
	    return _c('li', {
	      class: {
	        'active': index == (_vm.count - 1)
	      }
	    }, [(index == (_vm.count - 1)) ? _c('strong', [(index == 0) ? _c('span', [_vm._v("位置：")]) : _vm._e(), _vm._v(_vm._s(val.name))]) : _vm._e(), _vm._v(" "), (index == 0 && index != (_vm.count - 1)) ? _c('a', [_c('span', [_vm._v("位置：")]), _vm._v(_vm._s(val.name))]) : _vm._e()])
	  }), 0) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "col-lg-4"
	  }, [_vm._t("default")], 2)])
	},staticRenderFns: []}

/***/ }),
/* 204 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _vm._m(0)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "icons"
	    }
	  }, [_c('input', {
	    attrs: {
	      "type": "hidden",
	      "id": "icon",
	      "value": "${value}"
	    }
	  }), _vm._v(" "), _c('h2', {
	    staticClass: "page-header"
	  }, [_vm._v("Web Application Icons")]), _vm._v(" "), _c('ul', {
	    staticClass: "the-icons"
	  }, [_c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-adjust"
	  }), _vm._v(" adjust")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-anchor"
	  }), _vm._v(" anchor")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-archive"
	  }), _vm._v(" archive")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-area-chart"
	  }), _vm._v(" area-chart")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-arrows"
	  }), _vm._v(" arrows")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-arrows-h"
	  }), _vm._v(" arrows-h")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-arrows-v"
	  }), _vm._v(" arrows-v")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-asterisk"
	  }), _vm._v(" asterisk")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-at"
	  }), _vm._v(" at")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-automobile"
	  }), _vm._v(" automobile "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-balance-scale"
	  }), _vm._v(" balance-scale")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-ban"
	  }), _vm._v(" ban")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-bank"
	  }), _vm._v(" bank "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-bar-chart"
	  }), _vm._v(" bar-chart")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-bar-chart-o"
	  }), _vm._v(" bar-chart-o "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-barcode"
	  }), _vm._v(" barcode")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-bars"
	  }), _vm._v(" bars")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-battery-0"
	  }), _vm._v(" battery-0 "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-battery-1"
	  }), _vm._v(" battery-1 "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-battery-2"
	  }), _vm._v(" battery-2 "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-battery-3"
	  }), _vm._v(" battery-3 "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-battery-4"
	  }), _vm._v(" battery-4 "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-battery-empty"
	  }), _vm._v(" battery-empty")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-battery-full"
	  }), _vm._v(" battery-full")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-battery-half"
	  }), _vm._v(" battery-half")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-battery-quarter"
	  }), _vm._v(" battery-quarter")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-battery-three-quarters"
	  }), _vm._v(" battery-three-quarters")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-bed"
	  }), _vm._v(" bed")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-beer"
	  }), _vm._v(" beer")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-bell"
	  }), _vm._v(" bell")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-bell-o"
	  }), _vm._v(" bell-o")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-bell-slash"
	  }), _vm._v(" bell-slash")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-bell-slash-o"
	  }), _vm._v(" bell-slash-o")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-bicycle"
	  }), _vm._v(" bicycle")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-binoculars"
	  }), _vm._v(" binoculars")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-birthday-cake"
	  }), _vm._v(" birthday-cake")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-bolt"
	  }), _vm._v(" bolt")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-bomb"
	  }), _vm._v(" bomb")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-book"
	  }), _vm._v(" book")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-bookmark"
	  }), _vm._v(" bookmark")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-bookmark-o"
	  }), _vm._v(" bookmark-o")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-briefcase"
	  }), _vm._v(" briefcase")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-bug"
	  }), _vm._v(" bug")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-building"
	  }), _vm._v(" building")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-building-o"
	  }), _vm._v(" building-o")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-bullhorn"
	  }), _vm._v(" bullhorn")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-bullseye"
	  }), _vm._v(" bullseye")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-bus"
	  }), _vm._v(" bus")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-cab"
	  }), _vm._v(" cab "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-calculator"
	  }), _vm._v(" calculator")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-calendar"
	  }), _vm._v(" calendar")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-calendar-check-o"
	  }), _vm._v(" calendar-check-o")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-calendar-minus-o"
	  }), _vm._v(" calendar-minus-o")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-calendar-o"
	  }), _vm._v(" calendar-o")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-calendar-plus-o"
	  }), _vm._v(" calendar-plus-o")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-calendar-times-o"
	  }), _vm._v(" calendar-times-o")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-camera"
	  }), _vm._v(" camera")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-camera-retro"
	  }), _vm._v(" camera-retro")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-car"
	  }), _vm._v(" car")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-caret-square-o-down"
	  }), _vm._v(" caret-square-o-down")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-caret-square-o-left"
	  }), _vm._v(" caret-square-o-left")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-caret-square-o-right"
	  }), _vm._v(" caret-square-o-right")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-caret-square-o-up"
	  }), _vm._v(" caret-square-o-up")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-cart-arrow-down"
	  }), _vm._v(" cart-arrow-down")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-cart-plus"
	  }), _vm._v(" cart-plus")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-cc"
	  }), _vm._v(" cc")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-certificate"
	  }), _vm._v(" certificate")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-check"
	  }), _vm._v(" check")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-check-circle"
	  }), _vm._v(" check-circle")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-check-circle-o"
	  }), _vm._v(" check-circle-o")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-check-square"
	  }), _vm._v(" check-square")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-check-square-o"
	  }), _vm._v(" check-square-o")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-child"
	  }), _vm._v(" child")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-circle"
	  }), _vm._v(" circle")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-circle-o"
	  }), _vm._v(" circle-o")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-circle-o-notch"
	  }), _vm._v(" circle-o-notch")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-circle-thin"
	  }), _vm._v(" circle-thin")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-clock-o"
	  }), _vm._v(" clock-o")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-clone"
	  }), _vm._v(" clone")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-close"
	  }), _vm._v(" close "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-cloud"
	  }), _vm._v(" cloud")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-cloud-download"
	  }), _vm._v(" cloud-download")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-cloud-upload"
	  }), _vm._v(" cloud-upload")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-code"
	  }), _vm._v(" code")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-code-fork"
	  }), _vm._v(" code-fork")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-coffee"
	  }), _vm._v(" coffee")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-cog"
	  }), _vm._v(" cog")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-cogs"
	  }), _vm._v(" cogs")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-comment"
	  }), _vm._v(" comment")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-comment-o"
	  }), _vm._v(" comment-o")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-commenting"
	  }), _vm._v(" commenting")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-commenting-o"
	  }), _vm._v(" commenting-o")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-comments"
	  }), _vm._v(" comments")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-comments-o"
	  }), _vm._v(" comments-o")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-compass"
	  }), _vm._v(" compass")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-copyright"
	  }), _vm._v(" copyright")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-creative-commons"
	  }), _vm._v(" creative-commons")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-credit-card"
	  }), _vm._v(" credit-card")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-crop"
	  }), _vm._v(" crop")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-crosshairs"
	  }), _vm._v(" crosshairs")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-cube"
	  }), _vm._v(" cube")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-cubes"
	  }), _vm._v(" cubes")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-cutlery"
	  }), _vm._v(" cutlery")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-dashboard"
	  }), _vm._v(" dashboard "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-database"
	  }), _vm._v(" database")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-desktop"
	  }), _vm._v(" desktop")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-diamond"
	  }), _vm._v(" diamond")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-dot-circle-o"
	  }), _vm._v(" dot-circle-o")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-download"
	  }), _vm._v(" download")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-edit"
	  }), _vm._v(" edit "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-ellipsis-h"
	  }), _vm._v(" ellipsis-h")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-ellipsis-v"
	  }), _vm._v(" ellipsis-v")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-envelope"
	  }), _vm._v(" envelope")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-envelope-o"
	  }), _vm._v(" envelope-o")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-envelope-square"
	  }), _vm._v(" envelope-square")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-eraser"
	  }), _vm._v(" eraser")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-exchange"
	  }), _vm._v(" exchange")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-exclamation"
	  }), _vm._v(" exclamation")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-exclamation-circle"
	  }), _vm._v(" exclamation-circle")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-exclamation-triangle"
	  }), _vm._v(" exclamation-triangle")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-external-link"
	  }), _vm._v(" external-link")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-external-link-square"
	  }), _vm._v(" external-link-square")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-eye"
	  }), _vm._v(" eye")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-eye-slash"
	  }), _vm._v(" eye-slash")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-eyedropper"
	  }), _vm._v(" eyedropper")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fax"
	  }), _vm._v(" fax")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-feed"
	  }), _vm._v(" feed "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-female"
	  }), _vm._v(" female")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fighter-jet"
	  }), _vm._v(" fighter-jet")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-file-archive-o"
	  }), _vm._v(" file-archive-o")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-file-audio-o"
	  }), _vm._v(" file-audio-o")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-file-code-o"
	  }), _vm._v(" file-code-o")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-file-excel-o"
	  }), _vm._v(" file-excel-o")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-file-image-o"
	  }), _vm._v(" file-image-o")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-file-movie-o"
	  }), _vm._v(" file-movie-o "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-file-pdf-o"
	  }), _vm._v(" file-pdf-o")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-file-photo-o"
	  }), _vm._v(" file-photo-o "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-file-picture-o"
	  }), _vm._v(" file-picture-o "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-file-powerpoint-o"
	  }), _vm._v(" file-powerpoint-o")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-file-sound-o"
	  }), _vm._v(" file-sound-o "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-file-video-o"
	  }), _vm._v(" file-video-o")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-file-word-o"
	  }), _vm._v(" file-word-o")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-file-zip-o"
	  }), _vm._v(" file-zip-o "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-film"
	  }), _vm._v(" film")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-filter"
	  }), _vm._v(" filter")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fire"
	  }), _vm._v(" fire")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fire-extinguisher"
	  }), _vm._v(" fire-extinguisher")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-flag"
	  }), _vm._v(" flag")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-flag-checkered"
	  }), _vm._v(" flag-checkered")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-flag-o"
	  }), _vm._v(" flag-o")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-flash"
	  }), _vm._v(" flash "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-flask"
	  }), _vm._v(" flask")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-folder"
	  }), _vm._v(" folder")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-folder-o"
	  }), _vm._v(" folder-o")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-folder-open"
	  }), _vm._v(" folder-open")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-folder-open-o"
	  }), _vm._v(" folder-open-o")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-frown-o"
	  }), _vm._v(" frown-o")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-futbol-o"
	  }), _vm._v(" futbol-o")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-gamepad"
	  }), _vm._v(" gamepad")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-gavel"
	  }), _vm._v(" gavel")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-gear"
	  }), _vm._v(" gear "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-gears"
	  }), _vm._v(" gears "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-gift"
	  }), _vm._v(" gift")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-glass"
	  }), _vm._v(" glass")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-globe"
	  }), _vm._v(" globe")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-graduation-cap"
	  }), _vm._v(" graduation-cap")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-group"
	  }), _vm._v(" group "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-hand-grab-o"
	  }), _vm._v(" hand-grab-o "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-hand-lizard-o"
	  }), _vm._v(" hand-lizard-o")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-hand-paper-o"
	  }), _vm._v(" hand-paper-o")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-hand-peace-o"
	  }), _vm._v(" hand-peace-o")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-hand-pointer-o"
	  }), _vm._v(" hand-pointer-o")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-hand-rock-o"
	  }), _vm._v(" hand-rock-o")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-hand-scissors-o"
	  }), _vm._v(" hand-scissors-o")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-hand-spock-o"
	  }), _vm._v(" hand-spock-o")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-hand-stop-o"
	  }), _vm._v(" hand-stop-o "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-hdd-o"
	  }), _vm._v(" hdd-o")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-headphones"
	  }), _vm._v(" headphones")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-heart"
	  }), _vm._v(" heart")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-heart-o"
	  }), _vm._v(" heart-o")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-heartbeat"
	  }), _vm._v(" heartbeat")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-history"
	  }), _vm._v(" history")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-home"
	  }), _vm._v(" home")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-hotel"
	  }), _vm._v(" hotel "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-hourglass"
	  }), _vm._v(" hourglass")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-hourglass-1"
	  }), _vm._v(" hourglass-1 "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-hourglass-2"
	  }), _vm._v(" hourglass-2 "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-hourglass-3"
	  }), _vm._v(" hourglass-3 "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-hourglass-end"
	  }), _vm._v(" hourglass-end")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-hourglass-half"
	  }), _vm._v(" hourglass-half")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-hourglass-o"
	  }), _vm._v(" hourglass-o")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-hourglass-start"
	  }), _vm._v(" hourglass-start")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-i-cursor"
	  }), _vm._v(" i-cursor")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-image"
	  }), _vm._v(" image "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-inbox"
	  }), _vm._v(" inbox")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-industry"
	  }), _vm._v(" industry")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-info"
	  }), _vm._v(" info")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-info-circle"
	  }), _vm._v(" info-circle")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-institution"
	  }), _vm._v(" institution "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-key"
	  }), _vm._v(" key")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-keyboard-o"
	  }), _vm._v(" keyboard-o")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-language"
	  }), _vm._v(" language")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-laptop"
	  }), _vm._v(" laptop")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-leaf"
	  }), _vm._v(" leaf")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-legal"
	  }), _vm._v(" legal "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-lemon-o"
	  }), _vm._v(" lemon-o")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-level-down"
	  }), _vm._v(" level-down")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-level-up"
	  }), _vm._v(" level-up")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-life-bouy"
	  }), _vm._v(" life-bouy "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-life-buoy"
	  }), _vm._v(" life-buoy "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-life-ring"
	  }), _vm._v(" life-ring")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-life-saver"
	  }), _vm._v(" life-saver "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-lightbulb-o"
	  }), _vm._v(" lightbulb-o")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-line-chart"
	  }), _vm._v(" line-chart")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-location-arrow"
	  }), _vm._v(" location-arrow")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-lock"
	  }), _vm._v(" lock")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-magic"
	  }), _vm._v(" magic")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-magnet"
	  }), _vm._v(" magnet")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-mail-forward"
	  }), _vm._v(" mail-forward "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-mail-reply"
	  }), _vm._v(" mail-reply "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-mail-reply-all"
	  }), _vm._v(" mail-reply-all "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-male"
	  }), _vm._v(" male")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-map"
	  }), _vm._v(" map")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-map-marker"
	  }), _vm._v(" map-marker")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-map-o"
	  }), _vm._v(" map-o")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-map-pin"
	  }), _vm._v(" map-pin")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-map-signs"
	  }), _vm._v(" map-signs")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-meh-o"
	  }), _vm._v(" meh-o")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-microphone"
	  }), _vm._v(" microphone")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-microphone-slash"
	  }), _vm._v(" microphone-slash")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-minus"
	  }), _vm._v(" minus")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-minus-circle"
	  }), _vm._v(" minus-circle")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-minus-square"
	  }), _vm._v(" minus-square")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-minus-square-o"
	  }), _vm._v(" minus-square-o")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-mobile"
	  }), _vm._v(" mobile")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-mobile-phone"
	  }), _vm._v(" mobile-phone "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-money"
	  }), _vm._v(" money")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-moon-o"
	  }), _vm._v(" moon-o")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-mortar-board"
	  }), _vm._v(" mortar-board "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-motorcycle"
	  }), _vm._v(" motorcycle")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-mouse-pointer"
	  }), _vm._v(" mouse-pointer")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-music"
	  }), _vm._v(" music")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-navicon"
	  }), _vm._v(" navicon "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-newspaper-o"
	  }), _vm._v(" newspaper-o")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-object-group"
	  }), _vm._v(" object-group")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-object-ungroup"
	  }), _vm._v(" object-ungroup")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-paint-brush"
	  }), _vm._v(" paint-brush")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-paper-plane"
	  }), _vm._v(" paper-plane")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-paper-plane-o"
	  }), _vm._v(" paper-plane-o")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-paw"
	  }), _vm._v(" paw")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-pencil"
	  }), _vm._v(" pencil")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-pencil-square"
	  }), _vm._v(" pencil-square")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-pencil-square-o"
	  }), _vm._v(" pencil-square-o")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-phone"
	  }), _vm._v(" phone")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-phone-square"
	  }), _vm._v(" phone-square")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-photo"
	  }), _vm._v(" photo "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-picture-o"
	  }), _vm._v(" picture-o")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-pie-chart"
	  }), _vm._v(" pie-chart")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-plane"
	  }), _vm._v(" plane")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-plug"
	  }), _vm._v(" plug")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-plus"
	  }), _vm._v(" plus")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-plus-circle"
	  }), _vm._v(" plus-circle")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-plus-square"
	  }), _vm._v(" plus-square")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-plus-square-o"
	  }), _vm._v(" plus-square-o")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-power-off"
	  }), _vm._v(" power-off")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-print"
	  }), _vm._v(" print")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-puzzle-piece"
	  }), _vm._v(" puzzle-piece")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-qrcode"
	  }), _vm._v(" qrcode")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-question"
	  }), _vm._v(" question")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-question-circle"
	  }), _vm._v(" question-circle")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-quote-left"
	  }), _vm._v(" quote-left")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-quote-right"
	  }), _vm._v(" quote-right")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-random"
	  }), _vm._v(" random")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-recycle"
	  }), _vm._v(" recycle")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-refresh"
	  }), _vm._v(" refresh")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-registered"
	  }), _vm._v(" registered")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-remove"
	  }), _vm._v(" remove "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-reorder"
	  }), _vm._v(" reorder "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-reply"
	  }), _vm._v(" reply")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-reply-all"
	  }), _vm._v(" reply-all")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-retweet"
	  }), _vm._v(" retweet")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-road"
	  }), _vm._v(" road")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-rocket"
	  }), _vm._v(" rocket")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-rss"
	  }), _vm._v(" rss")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-rss-square"
	  }), _vm._v(" rss-square")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-search"
	  }), _vm._v(" search")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-search-minus"
	  }), _vm._v(" search-minus")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-search-plus"
	  }), _vm._v(" search-plus")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-send"
	  }), _vm._v(" send "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-send-o"
	  }), _vm._v(" send-o "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-server"
	  }), _vm._v(" server")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-share"
	  }), _vm._v(" share")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-share-alt"
	  }), _vm._v(" share-alt")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-share-alt-square"
	  }), _vm._v(" share-alt-square")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-share-square"
	  }), _vm._v(" share-square")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-share-square-o"
	  }), _vm._v(" share-square-o")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-shield"
	  }), _vm._v(" shield")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-ship"
	  }), _vm._v(" ship")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-shopping-cart"
	  }), _vm._v(" shopping-cart")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-sign-in"
	  }), _vm._v(" sign-in")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-sign-out"
	  }), _vm._v(" sign-out")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-signal"
	  }), _vm._v(" signal")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-sitemap"
	  }), _vm._v(" sitemap")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-sliders"
	  }), _vm._v(" sliders")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-smile-o"
	  }), _vm._v(" smile-o")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-soccer-ball-o"
	  }), _vm._v(" soccer-ball-o "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-sort"
	  }), _vm._v(" sort")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-sort-alpha-asc"
	  }), _vm._v(" sort-alpha-asc")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-sort-alpha-desc"
	  }), _vm._v(" sort-alpha-desc")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-sort-amount-asc"
	  }), _vm._v(" sort-amount-asc")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-sort-amount-desc"
	  }), _vm._v(" sort-amount-desc")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-sort-asc"
	  }), _vm._v(" sort-asc")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-sort-desc"
	  }), _vm._v(" sort-desc")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-sort-down"
	  }), _vm._v(" sort-down "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-sort-numeric-asc"
	  }), _vm._v(" sort-numeric-asc")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-sort-numeric-desc"
	  }), _vm._v(" sort-numeric-desc")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-sort-up"
	  }), _vm._v(" sort-up "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-space-shuttle"
	  }), _vm._v(" space-shuttle")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-spinner"
	  }), _vm._v(" spinner")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-spoon"
	  }), _vm._v(" spoon")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-square"
	  }), _vm._v(" square")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-square-o"
	  }), _vm._v(" square-o")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-star"
	  }), _vm._v(" star")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-star-half"
	  }), _vm._v(" star-half")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-star-half-empty"
	  }), _vm._v(" star-half-empty "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-star-half-full"
	  }), _vm._v(" star-half-full "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-star-half-o"
	  }), _vm._v(" star-half-o")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-star-o"
	  }), _vm._v(" star-o")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-sticky-note"
	  }), _vm._v(" sticky-note")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-sticky-note-o"
	  }), _vm._v(" sticky-note-o")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-street-view"
	  }), _vm._v(" street-view")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-suitcase"
	  }), _vm._v(" suitcase")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-sun-o"
	  }), _vm._v(" sun-o")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-support"
	  }), _vm._v(" support "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-tablet"
	  }), _vm._v(" tablet")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-tachometer"
	  }), _vm._v(" tachometer")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-tag"
	  }), _vm._v(" tag")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-tags"
	  }), _vm._v(" tags")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-tasks"
	  }), _vm._v(" tasks")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-taxi"
	  }), _vm._v(" taxi")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-television"
	  }), _vm._v(" television")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-terminal"
	  }), _vm._v(" terminal")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-thumb-tack"
	  }), _vm._v(" thumb-tack")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-thumbs-down"
	  }), _vm._v(" thumbs-down")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-thumbs-o-down"
	  }), _vm._v(" thumbs-o-down")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-thumbs-o-up"
	  }), _vm._v(" thumbs-o-up")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-thumbs-up"
	  }), _vm._v(" thumbs-up")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-ticket"
	  }), _vm._v(" ticket")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-times"
	  }), _vm._v(" times")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-times-circle"
	  }), _vm._v(" times-circle")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-times-circle-o"
	  }), _vm._v(" times-circle-o")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-tint"
	  }), _vm._v(" tint")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-toggle-down"
	  }), _vm._v(" toggle-down "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-toggle-left"
	  }), _vm._v(" toggle-left "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-toggle-off"
	  }), _vm._v(" toggle-off")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-toggle-on"
	  }), _vm._v(" toggle-on")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-toggle-right"
	  }), _vm._v(" toggle-right "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-toggle-up"
	  }), _vm._v(" toggle-up "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-trademark"
	  }), _vm._v(" trademark")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-trash"
	  }), _vm._v(" trash")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-trash-o"
	  }), _vm._v(" trash-o")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-tree"
	  }), _vm._v(" tree")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-trophy"
	  }), _vm._v(" trophy")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-truck"
	  }), _vm._v(" truck")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-tty"
	  }), _vm._v(" tty")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-tv"
	  }), _vm._v(" tv "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-umbrella"
	  }), _vm._v(" umbrella")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-university"
	  }), _vm._v(" university")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-unlock"
	  }), _vm._v(" unlock")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-unlock-alt"
	  }), _vm._v(" unlock-alt")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-unsorted"
	  }), _vm._v(" unsorted "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-upload"
	  }), _vm._v(" upload")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-user"
	  }), _vm._v(" user")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-user-plus"
	  }), _vm._v(" user-plus")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-user-secret"
	  }), _vm._v(" user-secret")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-user-times"
	  }), _vm._v(" user-times")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-users"
	  }), _vm._v(" users")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-video-camera"
	  }), _vm._v(" video-camera")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-volume-down"
	  }), _vm._v(" volume-down")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-volume-off"
	  }), _vm._v(" volume-off")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-volume-up"
	  }), _vm._v(" volume-up")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-warning"
	  }), _vm._v(" warning "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-wheelchair"
	  }), _vm._v(" wheelchair")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-wifi"
	  }), _vm._v(" wifi")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-wrench"
	  }), _vm._v(" wrench")])]), _vm._v(" "), _c('h2', {
	    staticClass: "page-header"
	  }, [_vm._v("Hand Icons")]), _vm._v(" "), _c('ul', {
	    staticClass: "the-icons"
	  }, [_c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-hand-grab-o"
	  }), _vm._v(" hand-grab-o "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-hand-lizard-o"
	  }), _vm._v(" hand-lizard-o")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-hand-o-down"
	  }), _vm._v(" hand-o-down")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-hand-o-left"
	  }), _vm._v(" hand-o-left")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-hand-o-right"
	  }), _vm._v(" hand-o-right")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-hand-o-up"
	  }), _vm._v(" hand-o-up")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-hand-paper-o"
	  }), _vm._v(" hand-paper-o")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-hand-peace-o"
	  }), _vm._v(" hand-peace-o")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-hand-pointer-o"
	  }), _vm._v(" hand-pointer-o")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-hand-rock-o"
	  }), _vm._v(" hand-rock-o")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-hand-scissors-o"
	  }), _vm._v(" hand-scissors-o")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-hand-spock-o"
	  }), _vm._v(" hand-spock-o")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-hand-stop-o"
	  }), _vm._v(" hand-stop-o "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-thumbs-down"
	  }), _vm._v(" thumbs-down")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-thumbs-o-down"
	  }), _vm._v(" thumbs-o-down")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-thumbs-o-up"
	  }), _vm._v(" thumbs-o-up")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-thumbs-up"
	  }), _vm._v(" thumbs-up")])]), _vm._v(" "), _c('h2', {
	    staticClass: "page-header"
	  }, [_vm._v("Transportation Icons")]), _vm._v(" "), _c('ul', {
	    staticClass: "the-icons"
	  }, [_c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-ambulance"
	  }), _vm._v(" ambulance")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-automobile"
	  }), _vm._v(" automobile "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-bicycle"
	  }), _vm._v(" bicycle")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-bus"
	  }), _vm._v(" bus")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-cab"
	  }), _vm._v(" cab "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-car"
	  }), _vm._v(" car")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fighter-jet"
	  }), _vm._v(" fighter-jet")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-motorcycle"
	  }), _vm._v(" motorcycle")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-plane"
	  }), _vm._v(" plane")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-rocket"
	  }), _vm._v(" rocket")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-ship"
	  }), _vm._v(" ship")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-space-shuttle"
	  }), _vm._v(" space-shuttle")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-subway"
	  }), _vm._v(" subway")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-taxi"
	  }), _vm._v(" taxi")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-train"
	  }), _vm._v(" train")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-truck"
	  }), _vm._v(" truck")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-wheelchair"
	  }), _vm._v(" wheelchair")])]), _vm._v(" "), _c('h2', {
	    staticClass: "page-header"
	  }, [_vm._v("Gender Icons")]), _vm._v(" "), _c('ul', {
	    staticClass: "the-icons"
	  }, [_c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-genderless"
	  }), _vm._v(" genderless")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-intersex"
	  }), _vm._v(" intersex "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-mars"
	  }), _vm._v(" mars")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-mars-double"
	  }), _vm._v(" mars-double")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-mars-stroke"
	  }), _vm._v(" mars-stroke")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-mars-stroke-h"
	  }), _vm._v(" mars-stroke-h")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-mars-stroke-v"
	  }), _vm._v(" mars-stroke-v")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-mercury"
	  }), _vm._v(" mercury")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-neuter"
	  }), _vm._v(" neuter")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-transgender"
	  }), _vm._v(" transgender")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-transgender-alt"
	  }), _vm._v(" transgender-alt")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-venus"
	  }), _vm._v(" venus")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-venus-double"
	  }), _vm._v(" venus-double")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-venus-mars"
	  }), _vm._v(" venus-mars")])]), _vm._v(" "), _c('h2', {
	    staticClass: "page-header"
	  }, [_vm._v("File Type Icons")]), _vm._v(" "), _c('ul', {
	    staticClass: "the-icons"
	  }, [_c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-file"
	  }), _vm._v(" file")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-file-archive-o"
	  }), _vm._v(" file-archive-o")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-file-audio-o"
	  }), _vm._v(" file-audio-o")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-file-code-o"
	  }), _vm._v(" file-code-o")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-file-excel-o"
	  }), _vm._v(" file-excel-o")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-file-image-o"
	  }), _vm._v(" file-image-o")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-file-movie-o"
	  }), _vm._v(" file-movie-o "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-file-o"
	  }), _vm._v(" file-o")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-file-pdf-o"
	  }), _vm._v(" file-pdf-o")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-file-photo-o"
	  }), _vm._v(" file-photo-o "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-file-picture-o"
	  }), _vm._v(" file-picture-o "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-file-powerpoint-o"
	  }), _vm._v(" file-powerpoint-o")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-file-sound-o"
	  }), _vm._v(" file-sound-o "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-file-text"
	  }), _vm._v(" file-text")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-file-text-o"
	  }), _vm._v(" file-text-o")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-file-video-o"
	  }), _vm._v(" file-video-o")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-file-word-o"
	  }), _vm._v(" file-word-o")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-file-zip-o"
	  }), _vm._v(" file-zip-o "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])])]), _vm._v(" "), _c('h2', {
	    staticClass: "page-header"
	  }, [_vm._v("Spinner Icons")]), _vm._v(" "), _c('ul', {
	    staticClass: "the-icons"
	  }, [_c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-circle-o-notch"
	  }), _vm._v(" circle-o-notch")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-cog"
	  }), _vm._v(" cog")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-gear"
	  }), _vm._v(" gear "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-refresh"
	  }), _vm._v(" refresh")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-spinner"
	  }), _vm._v(" spinner")])]), _vm._v(" "), _c('h2', {
	    staticClass: "page-header"
	  }, [_vm._v("Form Control Icons")]), _vm._v(" "), _c('ul', {
	    staticClass: "the-icons"
	  }, [_c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-check-square"
	  }), _vm._v(" check-square")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-check-square-o"
	  }), _vm._v(" check-square-o")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-circle"
	  }), _vm._v(" circle")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-circle-o"
	  }), _vm._v(" circle-o")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-dot-circle-o"
	  }), _vm._v(" dot-circle-o")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-minus-square"
	  }), _vm._v(" minus-square")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-minus-square-o"
	  }), _vm._v(" minus-square-o")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-plus-square"
	  }), _vm._v(" plus-square")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-plus-square-o"
	  }), _vm._v(" plus-square-o")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-square"
	  }), _vm._v(" square")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-square-o"
	  }), _vm._v(" square-o")])]), _vm._v(" "), _c('h2', {
	    staticClass: "page-header"
	  }, [_vm._v("Payment Icons")]), _vm._v(" "), _c('ul', {
	    staticClass: "the-icons"
	  }, [_c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-cc-amex"
	  }), _vm._v(" cc-amex")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-cc-diners-club"
	  }), _vm._v(" cc-diners-club")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-cc-discover"
	  }), _vm._v(" cc-discover")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-cc-jcb"
	  }), _vm._v(" cc-jcb")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-cc-mastercard"
	  }), _vm._v(" cc-mastercard")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-cc-paypal"
	  }), _vm._v(" cc-paypal")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-cc-stripe"
	  }), _vm._v(" cc-stripe")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-cc-visa"
	  }), _vm._v(" cc-visa")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-credit-card"
	  }), _vm._v(" credit-card")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-google-wallet"
	  }), _vm._v(" google-wallet")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-paypal"
	  }), _vm._v(" paypal")])]), _vm._v(" "), _c('h2', {
	    staticClass: "page-header"
	  }, [_vm._v("Chart Icons")]), _vm._v(" "), _c('ul', {
	    staticClass: "the-icons"
	  }, [_c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-area-chart"
	  }), _vm._v(" area-chart")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-bar-chart"
	  }), _vm._v(" bar-chart")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-bar-chart-o"
	  }), _vm._v(" bar-chart-o "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-line-chart"
	  }), _vm._v(" line-chart")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-pie-chart"
	  }), _vm._v(" pie-chart")])]), _vm._v(" "), _c('h2', {
	    staticClass: "page-header"
	  }, [_vm._v("Currency Icons")]), _vm._v(" "), _c('ul', {
	    staticClass: "the-icons"
	  }, [_c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-bitcoin"
	  }), _vm._v(" bitcoin "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-btc"
	  }), _vm._v(" btc")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-cny"
	  }), _vm._v(" cny "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-dollar"
	  }), _vm._v(" dollar "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-eur"
	  }), _vm._v(" eur")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-euro"
	  }), _vm._v(" euro "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-gbp"
	  }), _vm._v(" gbp")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-gg"
	  }), _vm._v(" gg")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-gg-circle"
	  }), _vm._v(" gg-circle")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-ils"
	  }), _vm._v(" ils")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-inr"
	  }), _vm._v(" inr")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-jpy"
	  }), _vm._v(" jpy")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-krw"
	  }), _vm._v(" krw")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-money"
	  }), _vm._v(" money")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-rmb"
	  }), _vm._v(" rmb "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-rouble"
	  }), _vm._v(" rouble "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-rub"
	  }), _vm._v(" rub")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-ruble"
	  }), _vm._v(" ruble "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-rupee"
	  }), _vm._v(" rupee "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-shekel"
	  }), _vm._v(" shekel "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-sheqel"
	  }), _vm._v(" sheqel "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-try"
	  }), _vm._v(" try")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-turkish-lira"
	  }), _vm._v(" turkish-lira "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-usd"
	  }), _vm._v(" usd")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-won"
	  }), _vm._v(" won "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-yen"
	  }), _vm._v(" yen "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])])]), _vm._v(" "), _c('h2', {
	    staticClass: "page-header"
	  }, [_vm._v("Text Editor Icons")]), _vm._v(" "), _c('ul', {
	    staticClass: "the-icons"
	  }, [_c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-align-center"
	  }), _vm._v(" align-center")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-align-justify"
	  }), _vm._v(" align-justify")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-align-left"
	  }), _vm._v(" align-left")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-align-right"
	  }), _vm._v(" align-right")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-bold"
	  }), _vm._v(" bold")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-chain"
	  }), _vm._v(" chain "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-chain-broken"
	  }), _vm._v(" chain-broken")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-clipboard"
	  }), _vm._v(" clipboard")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-columns"
	  }), _vm._v(" columns")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-copy"
	  }), _vm._v(" copy "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-cut"
	  }), _vm._v(" cut "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-dedent"
	  }), _vm._v(" dedent "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-eraser"
	  }), _vm._v(" eraser")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-file"
	  }), _vm._v(" file")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-file-o"
	  }), _vm._v(" file-o")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-file-text"
	  }), _vm._v(" file-text")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-file-text-o"
	  }), _vm._v(" file-text-o")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-files-o"
	  }), _vm._v(" files-o")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-floppy-o"
	  }), _vm._v(" floppy-o")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-font"
	  }), _vm._v(" font")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-header"
	  }), _vm._v(" header")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-indent"
	  }), _vm._v(" indent")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-italic"
	  }), _vm._v(" italic")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-link"
	  }), _vm._v(" link")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-list"
	  }), _vm._v(" list")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-list-alt"
	  }), _vm._v(" list-alt")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-list-ol"
	  }), _vm._v(" list-ol")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-list-ul"
	  }), _vm._v(" list-ul")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-outdent"
	  }), _vm._v(" outdent")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-paperclip"
	  }), _vm._v(" paperclip")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-paragraph"
	  }), _vm._v(" paragraph")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-paste"
	  }), _vm._v(" paste "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-repeat"
	  }), _vm._v(" repeat")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-rotate-left"
	  }), _vm._v(" rotate-left "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-rotate-right"
	  }), _vm._v(" rotate-right "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-save"
	  }), _vm._v(" save "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-scissors"
	  }), _vm._v(" scissors")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-strikethrough"
	  }), _vm._v(" strikethrough")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-subscript"
	  }), _vm._v(" subscript")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-superscript"
	  }), _vm._v(" superscript")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-table"
	  }), _vm._v(" table")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-text-height"
	  }), _vm._v(" text-height")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-text-width"
	  }), _vm._v(" text-width")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-th"
	  }), _vm._v(" th")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-th-large"
	  }), _vm._v(" th-large")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-th-list"
	  }), _vm._v(" th-list")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-underline"
	  }), _vm._v(" underline")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-undo"
	  }), _vm._v(" undo")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-unlink"
	  }), _vm._v(" unlink "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])])]), _vm._v(" "), _c('h2', {
	    staticClass: "page-header"
	  }, [_vm._v("Directional Icons")]), _vm._v(" "), _c('ul', {
	    staticClass: "the-icons"
	  }, [_c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-angle-double-down"
	  }), _vm._v(" angle-double-down")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-angle-double-left"
	  }), _vm._v(" angle-double-left")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-angle-double-right"
	  }), _vm._v(" angle-double-right")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-angle-double-up"
	  }), _vm._v(" angle-double-up")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-angle-down"
	  }), _vm._v(" angle-down")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-angle-left"
	  }), _vm._v(" angle-left")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-angle-right"
	  }), _vm._v(" angle-right")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-angle-up"
	  }), _vm._v(" angle-up")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-arrow-circle-down"
	  }), _vm._v(" arrow-circle-down")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-arrow-circle-left"
	  }), _vm._v(" arrow-circle-left")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-arrow-circle-o-down"
	  }), _vm._v(" arrow-circle-o-down")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-arrow-circle-o-left"
	  }), _vm._v(" arrow-circle-o-left")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-arrow-circle-o-right"
	  }), _vm._v(" arrow-circle-o-right")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-arrow-circle-o-up"
	  }), _vm._v(" arrow-circle-o-up")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-arrow-circle-right"
	  }), _vm._v(" arrow-circle-right")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-arrow-circle-up"
	  }), _vm._v(" arrow-circle-up")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-arrow-down"
	  }), _vm._v(" arrow-down")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-arrow-left"
	  }), _vm._v(" arrow-left")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-arrow-right"
	  }), _vm._v(" arrow-right")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-arrow-up"
	  }), _vm._v(" arrow-up")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-arrows"
	  }), _vm._v(" arrows")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-arrows-alt"
	  }), _vm._v(" arrows-alt")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-arrows-h"
	  }), _vm._v(" arrows-h")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-arrows-v"
	  }), _vm._v(" arrows-v")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-caret-down"
	  }), _vm._v(" caret-down")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-caret-left"
	  }), _vm._v(" caret-left")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-caret-right"
	  }), _vm._v(" caret-right")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-caret-square-o-down"
	  }), _vm._v(" caret-square-o-down")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-caret-square-o-left"
	  }), _vm._v(" caret-square-o-left")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-caret-square-o-right"
	  }), _vm._v(" caret-square-o-right")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-caret-square-o-up"
	  }), _vm._v(" caret-square-o-up")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-caret-up"
	  }), _vm._v(" caret-up")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-chevron-circle-down"
	  }), _vm._v(" chevron-circle-down")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-chevron-circle-left"
	  }), _vm._v(" chevron-circle-left")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-chevron-circle-right"
	  }), _vm._v(" chevron-circle-right")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-chevron-circle-up"
	  }), _vm._v(" chevron-circle-up")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-chevron-down"
	  }), _vm._v(" chevron-down")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-chevron-left"
	  }), _vm._v(" chevron-left")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-chevron-right"
	  }), _vm._v(" chevron-right")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-chevron-up"
	  }), _vm._v(" chevron-up")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-exchange"
	  }), _vm._v(" exchange")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-hand-o-down"
	  }), _vm._v(" hand-o-down")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-hand-o-left"
	  }), _vm._v(" hand-o-left")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-hand-o-right"
	  }), _vm._v(" hand-o-right")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-hand-o-up"
	  }), _vm._v(" hand-o-up")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-long-arrow-down"
	  }), _vm._v(" long-arrow-down")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-long-arrow-left"
	  }), _vm._v(" long-arrow-left")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-long-arrow-right"
	  }), _vm._v(" long-arrow-right")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-long-arrow-up"
	  }), _vm._v(" long-arrow-up")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-toggle-down"
	  }), _vm._v(" toggle-down "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-toggle-left"
	  }), _vm._v(" toggle-left "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-toggle-right"
	  }), _vm._v(" toggle-right "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-toggle-up"
	  }), _vm._v(" toggle-up "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])])]), _vm._v(" "), _c('h2', {
	    staticClass: "page-header"
	  }, [_vm._v("Video Player Icons")]), _vm._v(" "), _c('ul', {
	    staticClass: "the-icons"
	  }, [_c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-arrows-alt"
	  }), _vm._v(" arrows-alt")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-backward"
	  }), _vm._v(" backward")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-compress"
	  }), _vm._v(" compress")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-eject"
	  }), _vm._v(" eject")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-expand"
	  }), _vm._v(" expand")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fast-backward"
	  }), _vm._v(" fast-backward")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fast-forward"
	  }), _vm._v(" fast-forward")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-forward"
	  }), _vm._v(" forward")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-pause"
	  }), _vm._v(" pause")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-play"
	  }), _vm._v(" play")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-play-circle"
	  }), _vm._v(" play-circle")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-play-circle-o"
	  }), _vm._v(" play-circle-o")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-random"
	  }), _vm._v(" random")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-step-backward"
	  }), _vm._v(" step-backward")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-step-forward"
	  }), _vm._v(" step-forward")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-stop"
	  }), _vm._v(" stop")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-youtube-play"
	  }), _vm._v(" youtube-play")])]), _vm._v(" "), _c('h2', {
	    staticClass: "page-header"
	  }, [_vm._v("Brand Icons")]), _vm._v(" "), _c('ul', {
	    staticClass: "the-icons"
	  }, [_c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-500px"
	  }), _vm._v(" 500px")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-adn"
	  }), _vm._v(" adn")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-amazon"
	  }), _vm._v(" amazon")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-android"
	  }), _vm._v(" android")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-angellist"
	  }), _vm._v(" angellist")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-apple"
	  }), _vm._v(" apple")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-behance"
	  }), _vm._v(" behance")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-behance-square"
	  }), _vm._v(" behance-square")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-bitbucket"
	  }), _vm._v(" bitbucket")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-bitbucket-square"
	  }), _vm._v(" bitbucket-square")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-bitcoin"
	  }), _vm._v(" bitcoin "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-black-tie"
	  }), _vm._v(" black-tie")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-btc"
	  }), _vm._v(" btc")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-buysellads"
	  }), _vm._v(" buysellads")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-cc-amex"
	  }), _vm._v(" cc-amex")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-cc-diners-club"
	  }), _vm._v(" cc-diners-club")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-cc-discover"
	  }), _vm._v(" cc-discover")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-cc-jcb"
	  }), _vm._v(" cc-jcb")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-cc-mastercard"
	  }), _vm._v(" cc-mastercard")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-cc-paypal"
	  }), _vm._v(" cc-paypal")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-cc-stripe"
	  }), _vm._v(" cc-stripe")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-cc-visa"
	  }), _vm._v(" cc-visa")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-chrome"
	  }), _vm._v(" chrome")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-codepen"
	  }), _vm._v(" codepen")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-connectdevelop"
	  }), _vm._v(" connectdevelop")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-contao"
	  }), _vm._v(" contao")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-css3"
	  }), _vm._v(" css3")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-dashcube"
	  }), _vm._v(" dashcube")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-delicious"
	  }), _vm._v(" delicious")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-deviantart"
	  }), _vm._v(" deviantart")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-digg"
	  }), _vm._v(" digg")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-dribbble"
	  }), _vm._v(" dribbble")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-dropbox"
	  }), _vm._v(" dropbox")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-drupal"
	  }), _vm._v(" drupal")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-empire"
	  }), _vm._v(" empire")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-expeditedssl"
	  }), _vm._v(" expeditedssl")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-facebook"
	  }), _vm._v(" facebook")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-facebook-f"
	  }), _vm._v(" facebook-f "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-facebook-official"
	  }), _vm._v(" facebook-official")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-facebook-square"
	  }), _vm._v(" facebook-square")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-firefox"
	  }), _vm._v(" firefox")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-flickr"
	  }), _vm._v(" flickr")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-fonticons"
	  }), _vm._v(" fonticons")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-forumbee"
	  }), _vm._v(" forumbee")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-foursquare"
	  }), _vm._v(" foursquare")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-ge"
	  }), _vm._v(" ge "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-get-pocket"
	  }), _vm._v(" get-pocket")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-gg"
	  }), _vm._v(" gg")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-gg-circle"
	  }), _vm._v(" gg-circle")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-git"
	  }), _vm._v(" git")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-git-square"
	  }), _vm._v(" git-square")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-github"
	  }), _vm._v(" github")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-github-alt"
	  }), _vm._v(" github-alt")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-github-square"
	  }), _vm._v(" github-square")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-gittip"
	  }), _vm._v(" gittip "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-google"
	  }), _vm._v(" google")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-google-plus"
	  }), _vm._v(" google-plus")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-google-plus-square"
	  }), _vm._v(" google-plus-square")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-google-wallet"
	  }), _vm._v(" google-wallet")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-gratipay"
	  }), _vm._v(" gratipay")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-hacker-news"
	  }), _vm._v(" hacker-news")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-houzz"
	  }), _vm._v(" houzz")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-html5"
	  }), _vm._v(" html5")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-instagram"
	  }), _vm._v(" instagram")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-internet-explorer"
	  }), _vm._v(" internet-explorer")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-ioxhost"
	  }), _vm._v(" ioxhost")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-joomla"
	  }), _vm._v(" joomla")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-jsfiddle"
	  }), _vm._v(" jsfiddle")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-lastfm"
	  }), _vm._v(" lastfm")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-lastfm-square"
	  }), _vm._v(" lastfm-square")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-leanpub"
	  }), _vm._v(" leanpub")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-linkedin"
	  }), _vm._v(" linkedin")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-linkedin-square"
	  }), _vm._v(" linkedin-square")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-linux"
	  }), _vm._v(" linux")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-maxcdn"
	  }), _vm._v(" maxcdn")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-meanpath"
	  }), _vm._v(" meanpath")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-medium"
	  }), _vm._v(" medium")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-odnoklassniki"
	  }), _vm._v(" odnoklassniki")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-odnoklassniki-square"
	  }), _vm._v(" odnoklassniki-square")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-opencart"
	  }), _vm._v(" opencart")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-openid"
	  }), _vm._v(" openid")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-opera"
	  }), _vm._v(" opera")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-optin-monster"
	  }), _vm._v(" optin-monster")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-pagelines"
	  }), _vm._v(" pagelines")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-paypal"
	  }), _vm._v(" paypal")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-pied-piper"
	  }), _vm._v(" pied-piper")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-pied-piper-alt"
	  }), _vm._v(" pied-piper-alt")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-pinterest"
	  }), _vm._v(" pinterest")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-pinterest-p"
	  }), _vm._v(" pinterest-p")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-pinterest-square"
	  }), _vm._v(" pinterest-square")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-qq"
	  }), _vm._v(" qq")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-ra"
	  }), _vm._v(" ra "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-rebel"
	  }), _vm._v(" rebel")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-reddit"
	  }), _vm._v(" reddit")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-reddit-square"
	  }), _vm._v(" reddit-square")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-renren"
	  }), _vm._v(" renren")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-safari"
	  }), _vm._v(" safari")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-sellsy"
	  }), _vm._v(" sellsy")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-share-alt"
	  }), _vm._v(" share-alt")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-share-alt-square"
	  }), _vm._v(" share-alt-square")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-shirtsinbulk"
	  }), _vm._v(" shirtsinbulk")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-simplybuilt"
	  }), _vm._v(" simplybuilt")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-skyatlas"
	  }), _vm._v(" skyatlas")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-skype"
	  }), _vm._v(" skype")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-slack"
	  }), _vm._v(" slack")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-slideshare"
	  }), _vm._v(" slideshare")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-soundcloud"
	  }), _vm._v(" soundcloud")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-spotify"
	  }), _vm._v(" spotify")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-stack-exchange"
	  }), _vm._v(" stack-exchange")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-stack-overflow"
	  }), _vm._v(" stack-overflow")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-steam"
	  }), _vm._v(" steam")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-steam-square"
	  }), _vm._v(" steam-square")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-stumbleupon"
	  }), _vm._v(" stumbleupon")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-stumbleupon-circle"
	  }), _vm._v(" stumbleupon-circle")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-tencent-weibo"
	  }), _vm._v(" tencent-weibo")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-trello"
	  }), _vm._v(" trello")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-tripadvisor"
	  }), _vm._v(" tripadvisor")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-tumblr"
	  }), _vm._v(" tumblr")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-tumblr-square"
	  }), _vm._v(" tumblr-square")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-twitch"
	  }), _vm._v(" twitch")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-twitter"
	  }), _vm._v(" twitter")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-twitter-square"
	  }), _vm._v(" twitter-square")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-viacoin"
	  }), _vm._v(" viacoin")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-vimeo"
	  }), _vm._v(" vimeo")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-vimeo-square"
	  }), _vm._v(" vimeo-square")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-vine"
	  }), _vm._v(" vine")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-vk"
	  }), _vm._v(" vk")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-wechat"
	  }), _vm._v(" wechat "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-weibo"
	  }), _vm._v(" weibo")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-weixin"
	  }), _vm._v(" weixin")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-whatsapp"
	  }), _vm._v(" whatsapp")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-wikipedia-w"
	  }), _vm._v(" wikipedia-w")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-windows"
	  }), _vm._v(" windows")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-wordpress"
	  }), _vm._v(" wordpress")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-xing"
	  }), _vm._v(" xing")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-xing-square"
	  }), _vm._v(" xing-square")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-y-combinator"
	  }), _vm._v(" y-combinator")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-y-combinator-square"
	  }), _vm._v(" y-combinator-square "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-yahoo"
	  }), _vm._v(" yahoo")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-yc"
	  }), _vm._v(" yc "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-yc-square"
	  }), _vm._v(" yc-square "), _c('span', {
	    staticClass: "text-muted"
	  }, [_vm._v("(alias)")])]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-yelp"
	  }), _vm._v(" yelp")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-youtube"
	  }), _vm._v(" youtube")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-youtube-play"
	  }), _vm._v(" youtube-play")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-youtube-square"
	  }), _vm._v(" youtube-square")])]), _vm._v(" "), _c('h2', {
	    staticClass: "page-header"
	  }, [_vm._v("Medical Icons")]), _vm._v(" "), _c('ul', {
	    staticClass: "the-icons"
	  }, [_c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-ambulance"
	  }), _vm._v(" ambulance")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-h-square"
	  }), _vm._v(" h-square")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-heart"
	  }), _vm._v(" heart")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-heart-o"
	  }), _vm._v(" heart-o")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-heartbeat"
	  }), _vm._v(" heartbeat")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-hospital-o"
	  }), _vm._v(" hospital-o")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-medkit"
	  }), _vm._v(" medkit")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-plus-square"
	  }), _vm._v(" plus-square")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-stethoscope"
	  }), _vm._v(" stethoscope")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-user-md"
	  }), _vm._v(" user-md")]), _vm._v(" "), _c('li', {
	    staticClass: "fa-hover col-md-3 col-sm-4"
	  }, [_c('i', {
	    staticClass: "fa fa-wheelchair"
	  }), _vm._v(" wheelchair")])]), _vm._v(" "), _c('br'), _c('br')])
	}]}

/***/ }),
/* 205 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('li', [_c('div', {
	    staticStyle: {
	      "font-size": "16px"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.toggle()
	      }
	    }
	  }, [(_vm.isFolder) ? _c('i', {
	    staticClass: "fa ",
	    class: [_vm.open ? 'fa-minus-square-o' : 'fa-plus-square-o']
	  }) : _vm._e(), _vm._v(" "), (_vm.isFolder) ? _c('i', {
	    staticClass: "fa ",
	    class: [_vm.open ? 'fa-folder-open' : 'fa-folder']
	  }) : _vm._e(), _vm._v(" "), (!_vm.isFolder) ? _c('i', {
	    staticClass: "fa fa-file-text"
	  }) : _vm._e(), _vm._v(" "), _c('i', {
	    staticClass: "menuname"
	  }, [_vm._v(_vm._s(_vm.model.name))])]), _vm._v(" "), (_vm.isFolder) ? _c('ul', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.open),
	      expression: "open"
	    }]
	  }, _vm._l((_vm.model.children), function(item) {
	    return _c('items', {
	      attrs: {
	        "model": item
	      }
	    })
	  }), 1) : _vm._e()])])
	},staticRenderFns: []}

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "load-hide"
	  }, [_c('div', {
	    staticClass: "load-hide",
	    staticStyle: {
	      "height": "100%"
	    }
	  }, [_c('div', {
	    staticClass: "context cq_context"
	  }, [_c('div', {
	    staticClass: "title two-picture"
	  }, [_c('div', {
	    staticClass: "setup_icon"
	  }, [_c('span', {
	    on: {
	      "click": _vm.goSetup
	    }
	  })]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "erweima-img",
	    staticStyle: {
	      "display": "inline-block"
	    },
	    attrs: {
	      "id": "qrCodeImg"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "two_bottom"
	  }, [_c('p', {
	    staticClass: "the_number_card"
	  }, [_vm._v("No." + _vm._s(_vm.card_num))]), _vm._v(" "), _c('p', {
	    staticStyle: {
	      "color": "#cb0000",
	      "margin": "0"
	    }
	  }, [_c('span', {
	    staticClass: "card_making_icon",
	    on: {
	      "click": _vm.reloads
	    }
	  }), _vm._v("¥ " + _vm._s(_vm.ava_balance))])])]), _vm._v(" "), _c('div', {
	    staticClass: "get_now"
	  }, [_c('input', {
	    attrs: {
	      "type": "button",
	      "value": "充值"
	    },
	    on: {
	      "click": _vm.goRecharge
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "get_now"
	  }, [_c('input', {
	    attrs: {
	      "type": "button",
	      "value": "账单"
	    },
	    on: {
	      "click": _vm.goBill
	    }
	  })])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "title_img"
	  }, [_c('hr'), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": __webpack_require__(171)
	    }
	  }), _vm._v(" "), _c('hr')])
	}]}

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "load-hide"
	  }, [_c('div', {
	    staticClass: "recharge_types card_online"
	  }, [_c('div', [_c('mt-datetime-picker', {
	    ref: "picker",
	    attrs: {
	      "type": "date",
	      "startDate": _vm.startDate,
	      "endDate": _vm.endDate
	    },
	    model: {
	      value: (_vm.pickerValue),
	      callback: function($$v) {
	        _vm.pickerValue = $$v
	      },
	      expression: "pickerValue"
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "co_in"
	  }, [_c('div', {
	    staticClass: "before_title"
	  }, [_vm._v("请填写您的手机号码")]), _vm._v(" "), _c('div', {
	    staticClass: "after_context"
	  }, [_c('div', {
	    staticClass: "more_num"
	  }, [_vm._v("+86")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.phoneNumber),
	      expression: "phoneNumber"
	    }],
	    staticClass: "phone_ipt",
	    attrs: {
	      "type": "text",
	      "placeholder": "请填写手机号码"
	    },
	    domProps: {
	      "value": (_vm.phoneNumber)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.phoneNumber = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "before_title"
	  }, [_vm._v("请点击\"获取验证码\"按钮，填写您收到的验证码")]), _vm._v(" "), _c('div', {
	    staticClass: "after_context ac_message"
	  }, [_c('div', {
	    staticClass: "more_message"
	  }, [_vm._v("验证码")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.msg),
	      expression: "msg"
	    }],
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.msg)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.msg = $event.target.value
	      }
	    }
	  }), _vm._v(" "), (!_vm.sendMsgDisabled) ? _c('input', {
	    staticClass: "getMessage",
	    attrs: {
	      "type": "button",
	      "value": "获取验证码"
	    },
	    on: {
	      "click": _vm.getMessage
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.sendMsgDisabled) ? _c('input', {
	    staticClass: "getMessage",
	    attrs: {
	      "type": "button",
	      "value": _vm.time + 's'
	    }
	  }) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "before_title"
	  }, [_vm._v("请选择您的性别(选填)")]), _vm._v(" "), _c('div', {
	    staticClass: "after_context ac_gender"
	  }, [_c('div', {
	    staticClass: "more_gender"
	  }, [_vm._v("性别")]), _vm._v(" "), _c('div', {
	    staticClass: "more_img",
	    on: {
	      "click": _vm.goGender
	    }
	  }, [_c('span', {
	    staticClass: "finallGender"
	  }, [_vm._v(_vm._s(_vm.getCG[_vm.isWhatGender]))]), _vm._v(" "), _c('img', {
	    attrs: {
	      "width": "8px",
	      "height": "12.5px",
	      "src": __webpack_require__(172)
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "before_title"
	  }, [_vm._v("请选择您的生日(选填)")]), _vm._v(" "), _c('div', {
	    staticClass: "after_context ac_message"
	  }, [_c('div', {
	    staticClass: "more_date"
	  }, [_vm._v("年/月/日")]), _vm._v(" "), (_vm.pickerValue.length > 0) ? _c('div', {
	    staticClass: "dpss",
	    on: {
	      "click": _vm.openPicker
	    }
	  }, [_vm._v(_vm._s(_vm._f("date")(_vm.pickerValue, '%Y-%m-%d')))]) : _c('div', {
	    staticClass: "dpss",
	    on: {
	      "click": _vm.openPicker
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "co_input"
	  }, [_c('div', [_c('input', {
	    staticClass: "co_card",
	    attrs: {
	      "type": "button",
	      "value": "办理"
	    },
	    on: {
	      "click": _vm.confirm
	    }
	  })])]), _vm._v(" "), (_vm.isGender == true) ? _c('div', {
	    staticClass: "overUp"
	  }, [_c('div', {
	    staticClass: "black"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "white_div"
	  }, [_c('div', {
	    staticClass: "co_tip"
	  }, [_vm._v("请选择性别")]), _vm._v(" "), _c('div', {
	    staticClass: "ch_one"
	  }, [_c('input', {
	    class: {
	      green_border: _vm.isWhatGender == 'N'
	    },
	    attrs: {
	      "value": "保密",
	      "type": "button"
	    },
	    on: {
	      "click": _vm.ch_none
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "ch_one"
	  }, [_c('input', {
	    class: {
	      green_border: _vm.isWhatGender == 'M'
	    },
	    attrs: {
	      "value": "男",
	      "type": "button"
	    },
	    on: {
	      "click": _vm.ch_b
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "ch_one"
	  }, [_c('input', {
	    class: {
	      green_border: _vm.isWhatGender == 'G'
	    },
	    attrs: {
	      "value": "女",
	      "type": "button"
	    },
	    on: {
	      "click": _vm.ch_g
	    }
	  })])])]) : _vm._e()])])
	},staticRenderFns: []}

/***/ }),
/* 208 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('nav', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.isShow),
	      expression: "isShow"
	    }],
	    staticClass: "pull-right"
	  }, [_c('ul', {
	    staticClass: "pagination"
	  }, [(_vm.showPrev) ? _c('li', {
	    on: {
	      "click": function($event) {
	        return _vm.action(_vm.page - 1)
	      }
	    }
	  }, [_c('a', [_vm._v("«")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.pages), function(i) {
	    return _c('li', {
	      class: {
	        active: _vm.page == i
	      },
	      on: {
	        "click": function($event) {
	          return _vm.action(i)
	        }
	      }
	    }, [_c('a', [_vm._v(_vm._s(i))])])
	  }), _vm._v(" "), (_vm.showNext) ? _c('li', {
	    on: {
	      "click": function($event) {
	        return _vm.action(_vm.page + 1)
	      }
	    }
	  }, [_c('a', [_vm._v("»")])]) : _vm._e()], 2)])
	},staticRenderFns: []}

/***/ }),
/* 209 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "pull-container",
	    attrs: {
	      "id": _vm.eleId
	    }
	  }, [_c('div', {
	    staticClass: "scroller"
	  }, [_c('div', {
	    staticClass: "pulldown",
	    class: [_vm.pulldownChangeStyle, {
	      'hide': !_vm.displaypullDownDiv
	    }],
	    style: ({
	      'margin-top': '-' + _vm.pullDownDiff + 'px'
	    })
	  }, [_c('div', {
	    staticClass: "pulldown-icon"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "pulldown-label"
	  }, [_vm._v(_vm._s(_vm.pullDownTip))])]), _vm._v(" "), _vm._t("default"), _vm._v(" "), _c('div', {
	    staticClass: "pullup",
	    class: [_vm.pullupChangeStyle, {
	      'hide': !_vm.displaypullUpDiv
	    }]
	  }, [_c('div', {
	    staticClass: "pullup-icon"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "pullup-label"
	  }, [_vm._v(_vm._s(_vm.pullUpTip))])])], 2)])
	},staticRenderFns: []}

/***/ }),
/* 210 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "load-hide recharge"
	  }, [_c('div', {
	    staticClass: "recharge_type",
	    staticStyle: {
	      "padding": "0.075rem 0.19rem 0"
	    }
	  }, _vm._l((_vm.codeList), function(item, index) {
	    return _c('div', {
	      staticClass: "typeList",
	      class: {
	        greenStyle: index == _vm.nowIndex, nochoosed: index !== _vm.nowIndex
	      },
	      on: {
	        "click": function($event) {
	          return _vm.choosePrice(item.id, index)
	        }
	      }
	    }, [_c('div', {
	      staticClass: "left-text"
	    }, [_vm._v("¥ " + _vm._s(item.title)), _c('span', {
	      staticClass: "middle-text"
	    }, [_vm._v(_vm._s(item.content))])])])
	  }), 0)])
	},staticRenderFns: []}

/***/ }),
/* 211 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.show),
	      expression: "show"
	    }],
	    staticClass: "loading-mask"
	  }, [_vm._m(0)])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "sk-spinner sk-spinner-wave"
	  }, [_c('div', {
	    staticClass: "sk-rect1"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "sk-rect2"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "sk-rect3"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "sk-rect4"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "sk-rect5"
	  })])
	}]}

/***/ }),
/* 212 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c("div")
	},staticRenderFns: []}

/***/ }),
/* 213 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "modal fade",
	    class: _vm.classes
	  }, [_c('div', {
	    staticClass: "modal-dialog modal-lg"
	  }, [_c('div', {
	    staticClass: "modal-content",
	    staticStyle: {
	      "width": "500px",
	      "margin": "auto"
	    }
	  }, [_c('div', {
	    staticClass: "modal-header"
	  }, [_c('button', {
	    staticClass: "close",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.close
	    }
	  }, [_c('span', [_vm._v("×")]), _c('span', {
	    staticClass: "sr-only"
	  }, [_vm._v("Close")])]), _vm._v(" "), _c('h4', {
	    staticClass: "modal-title"
	  }, [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), (_vm.opened) ? _c('div', [_vm._t("default")], 2) : _vm._e()])])])
	},staticRenderFns: []}

/***/ }),
/* 214 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('router-view')
	},staticRenderFns: []}

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "login-box"
	  }, [_c('div', {
	    staticClass: "middle-box text-center animated fadeInDown"
	  }, [_c('div', [_vm._m(0), _vm._v(" "), _c('h3', {
	    staticClass: "login-title"
	  }, [_vm._v("领鲜收银（商户端）")]), _vm._v(" "), _c('form', {
	    staticClass: "m-t",
	    attrs: {
	      "role": "form",
	      "onsubmit": "return false"
	    }
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_vm._m(1), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.credentials.name),
	      expression: "credentials.name"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "placeholder": "账号",
	      "required": ""
	    },
	    domProps: {
	      "value": (_vm.credentials.name)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.credentials, "name", $event.target.value)
	      }
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_vm._m(2), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.credentials.password),
	      expression: "credentials.password"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "password",
	      "placeholder": "密码",
	      "required": ""
	    },
	    domProps: {
	      "value": (_vm.credentials.password)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.credentials, "password", $event.target.value)
	      }
	    }
	  })])]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-primary block full-width m-b",
	    attrs: {
	      "type": "submit"
	    },
	    on: {
	      "click": _vm.login
	    }
	  }, [_vm._v("立即登录")])])])])]), _vm._v(" "), _c('p', {
	    staticClass: "footer back-bor-null"
	  }, [_vm._v(" © 2017 freshone all rights reserved ")])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('img', {
	    staticClass: "login-logo",
	    attrs: {
	      "src": __webpack_require__(174)
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "input-group-addon"
	  }, [_c('i', {
	    staticClass: "fa fa-user"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "input-group-addon"
	  }, [_c('i', {
	    staticClass: "fa fa-lock"
	  })])
	}]}

/***/ }),
/* 216 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "load-hide"
	  }, [_c('div', {
	    staticClass: "recharge_types setup",
	    staticStyle: {
	      "padding": "0.125rem 0.19rem 0"
	    }
	  }, [_c('div', [_c('mt-datetime-picker', {
	    ref: "picker",
	    attrs: {
	      "type": "date",
	      "startDate": _vm.startDate,
	      "endDate": _vm.endDate
	    },
	    on: {
	      "confirm": _vm.dealentity
	    },
	    model: {
	      value: (_vm.pickerValue),
	      callback: function($$v) {
	        _vm.pickerValue = $$v
	      },
	      expression: "pickerValue"
	    }
	  })], 1), _vm._v(" "), _c('table', {
	    staticClass: "table table-bordered table-condensed dataTables-example dataTable no-footer",
	    staticStyle: {
	      "white-space": "nowrap"
	    }
	  }, [_c('tbody', [_c('tr', [_vm._m(0), _vm._v(" "), _c('td', {
	    staticClass: "td_bottom"
	  }, [_vm._v(_vm._s(_vm.cardMember.uid))])]), _vm._v(" "), _c('tr', [_vm._m(1), _vm._v(" "), _c('td', {
	    staticClass: "td_bottom",
	    model: {
	      value: (_vm.card_num),
	      callback: function($$v) {
	        _vm.card_num = $$v
	      },
	      expression: "card_num"
	    }
	  }, [_vm._v(_vm._s(_vm.card.card_num))])]), _vm._v(" "), _c('tr', [_vm._m(2), _vm._v(" "), _c('td', {
	    staticClass: "td_bottom",
	    on: {
	      "click": _vm.editN
	    },
	    model: {
	      value: (_vm.cust_name),
	      callback: function($$v) {
	        _vm.cust_name = $$v
	      },
	      expression: "cust_name"
	    }
	  }, [_vm._v(_vm._s(_vm.card.cust_name))])]), _vm._v(" "), _c('tr', [_vm._m(3), _vm._v(" "), _c('td', {
	    staticClass: "td_bottom",
	    model: {
	      value: (_vm.cust_mobile),
	      callback: function($$v) {
	        _vm.cust_mobile = $$v
	      },
	      expression: "cust_mobile"
	    }
	  }, [_vm._v(_vm._s(_vm.card.cust_mobile))])]), _vm._v(" "), _c('tr', [_vm._m(4), _vm._v(" "), _c('td', {
	    staticClass: "td_bottom",
	    on: {
	      "click": _vm.editG
	    },
	    model: {
	      value: (_vm.cust_gender),
	      callback: function($$v) {
	        _vm.cust_gender = $$v
	      },
	      expression: "cust_gender"
	    }
	  }, [_vm._v(_vm._s(_vm.getGender[_vm.card.cust_gender]))])]), _vm._v(" "), _c('tr', [_vm._m(5), _vm._v(" "), (_vm.card.cust_birthday) ? _c('td', {
	    staticClass: "td_bottom tb_birth",
	    on: {
	      "click": _vm.openPicker
	    },
	    model: {
	      value: (_vm.cust_birthday),
	      callback: function($$v) {
	        _vm.cust_birthday = $$v
	      },
	      expression: "cust_birthday"
	    }
	  }, [_vm._v("\n          " + _vm._s(_vm._f("date")(_vm.card.cust_birthday, '%Y-%m-%d')) + "\n          ")]) : _c('td')])])]), _vm._v(" "), _c('div', {
	    staticClass: "unbind_input"
	  }, [_c('input', {
	    attrs: {
	      "type": "button",
	      "value": "解绑"
	    },
	    on: {
	      "click": _vm.unBind
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "out-all",
	    staticStyle: {
	      "display": "none"
	    }
	  }, [_c('div', {
	    staticClass: "include-black"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "include-text"
	  }, [_c('p', [_vm._v("确认解绑电子卡？")]), _vm._v(" "), _c('div', [_c('input', {
	    staticClass: "choose-no",
	    attrs: {
	      "type": "button",
	      "value": "取消"
	    },
	    on: {
	      "click": _vm.closeQ
	    }
	  }), _vm._v(" "), _c('input', {
	    staticClass: "choose-yes",
	    attrs: {
	      "type": "button",
	      "value": "确认"
	    },
	    on: {
	      "click": _vm.unBindOk
	    }
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "out-alln",
	    staticStyle: {
	      "display": "none"
	    }
	  }, [_c('div', {
	    staticClass: "include-black"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "include-text"
	  }, [_c('p', [_vm._v("请填入您的姓名")]), _vm._v(" "), _c('div', {
	    staticClass: "inContext"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.newName),
	      expression: "newName"
	    }],
	    staticClass: "nps",
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.newName)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.newName = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('div', [_c('input', {
	    staticClass: "choose-no",
	    attrs: {
	      "type": "button",
	      "value": "取消"
	    },
	    on: {
	      "click": _vm.closeQ
	    }
	  }), _vm._v(" "), _c('input', {
	    staticClass: "choose-yes",
	    attrs: {
	      "type": "button",
	      "value": "确认"
	    },
	    on: {
	      "click": _vm.dealentity
	    }
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "out-allg",
	    staticStyle: {
	      "display": "none"
	    }
	  }, [_c('div', {
	    staticClass: "include-black"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "include-text"
	  }, [_c('p', {
	    staticStyle: {
	      "color": "#000"
	    }
	  }, [_vm._v("请选择性别")]), _vm._v(" "), _c('div', {
	    staticClass: "inContext",
	    staticStyle: {
	      "margin": "0.1rem 0 !important"
	    }
	  }, [_c('div', {
	    staticClass: "ch_what"
	  }, [_c('input', {
	    class: {
	      green_choosed: _vm.isWhatGender == 'N'
	    },
	    attrs: {
	      "value": "保密",
	      "type": "button"
	    },
	    on: {
	      "click": _vm.ch_none
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "ch_what"
	  }, [_c('input', {
	    class: {
	      green_choosed: _vm.isWhatGender == 'M'
	    },
	    attrs: {
	      "value": "男",
	      "type": "button"
	    },
	    on: {
	      "click": _vm.ch_b
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "ch_what"
	  }, [_c('input', {
	    class: {
	      green_choosed: _vm.isWhatGender == 'G'
	    },
	    attrs: {
	      "value": "女",
	      "type": "button"
	    },
	    on: {
	      "click": _vm.ch_g
	    }
	  })])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('td', {
	    staticClass: "width-35"
	  }, [_c('label', {
	    staticStyle: {
	      "color": "#252525"
	    }
	  }, [_vm._v("UID")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('td', {
	    staticClass: "width-35"
	  }, [_c('label', {
	    staticStyle: {
	      "color": "#252525"
	    }
	  }, [_vm._v("卡号")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('td', {
	    staticClass: "width-35"
	  }, [_c('label', {
	    staticStyle: {
	      "color": "#252525"
	    }
	  }, [_vm._v("姓名")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('td', {
	    staticClass: "width-35"
	  }, [_c('label', {
	    staticStyle: {
	      "color": "#252525"
	    }
	  }, [_vm._v("手机")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('td', {
	    staticClass: "width-35"
	  }, [_c('label', {
	    staticStyle: {
	      "color": "#252525"
	    }
	  }, [_vm._v("性别")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('td', {
	    staticClass: "width-35"
	  }, [_c('label', {
	    staticStyle: {
	      "color": "#252525"
	    }
	  }, [_vm._v("生日")])])
	}]}

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticStyle: {
	      "border-bottom": "1px solid #e8e8e8",
	      "padding": "5px 0"
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(175)
	    },
	    on: {
	      "click": _vm.goBack
	    }
	  })])
	},staticRenderFns: []}

/***/ }),
/* 218 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "app"
	    }
	  }, [_c('dropzone', {
	    attrs: {
	      "id": "myVueDropzone",
	      "url": _vm.url
	    },
	    on: {
	      "vdropzone-success": _vm.showSuccess
	    }
	  }, [_c('input', {
	    attrs: {
	      "type": "hidden",
	      "name": "token",
	      "value": "xxx"
	    }
	  })])], 1)
	},staticRenderFns: []}

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "load-hide"
	  }, [_c('div', {
	    staticClass: "recharge_types card_choose"
	  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
	    staticClass: "vip_input"
	  }, [_c('div', [_c('input', {
	    staticClass: "ol_card",
	    attrs: {
	      "type": "button",
	      "value": "线上办卡"
	    },
	    on: {
	      "click": _vm.goOnline
	    }
	  })]), _vm._v(" "), _c('div', [_c('input', {
	    staticClass: "r_card",
	    attrs: {
	      "type": "button",
	      "value": "绑定会员卡"
	    },
	    on: {
	      "click": _vm.goMain
	    }
	  })])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "vip_card"
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(176)
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "vip_p"
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(170)
	    }
	  })])
	}]}

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "enter-login"
	  }, [_c('div', {
	    staticClass: "top"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "phone-login"
	  }, [_c('div', {
	    staticClass: "text-center animated fadeInDown"
	  }, [_vm._m(0), _vm._v(" "), _c('p', {
	    staticClass: "welcome"
	  }, [_vm._v("欢迎登录")]), _vm._v(" "), _c('form', {
	    attrs: {
	      "action": "",
	      "role": "form",
	      "onsubmit": "return false"
	    }
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.credentials.name),
	      expression: "credentials.name"
	    }],
	    staticClass: "form-control phone numkeyboard",
	    attrs: {
	      "type": "text",
	      "placeholder": "请输入注册手机号",
	      "required": "required"
	    },
	    domProps: {
	      "value": (_vm.credentials.name)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.credentials, "name", $event.target.value)
	      }
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.credentials.password),
	      expression: "credentials.password"
	    }],
	    staticClass: "form-control psw numkeyboard",
	    attrs: {
	      "type": "password",
	      "placeholder": "请输入账号密码",
	      "required": "required"
	    },
	    domProps: {
	      "value": (_vm.credentials.password)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.credentials, "password", $event.target.value)
	      }
	    }
	  })])]), _vm._v(" "), _c('router-link', {
	    attrs: {
	      "to": "/psw_forgot"
	    }
	  }, [_c('button', {
	    staticClass: "btn btn-forget block full-width",
	    attrs: {
	      "type": "button"
	    }
	  }, [_vm._v("忘记密码")])]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-login block full-width",
	    attrs: {
	      "type": "submit"
	    },
	    on: {
	      "click": _vm.login
	    }
	  }, [_vm._v("登录")])], 1)])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "login"
	  }, [_c('img', {
	    staticClass: "img-responsive",
	    attrs: {
	      "src": __webpack_require__(173),
	      "alt": ""
	    }
	  })])
	}]}

/***/ }),
/* 221 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "load-hide bbh",
	    staticStyle: {
	      "text-align": "center",
	      "padding-top": "40%",
	      "font-size": "35px",
	      "color": "#50a200"
	    }
	  }, [_vm._v("\n  错误\n")])
	},staticRenderFns: []}

/***/ }),
/* 222 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "load-hide"
	  }, [_c('div', {
	    staticClass: "context card_bind_context"
	  }, [_c('div', {
	    staticClass: "top-context-parent"
	  }, [_c('div', {
	    staticClass: "top-context"
	  }, [_c('div', {
	    staticClass: "top-from"
	  }, [_c('div', {
	    staticClass: "btop_tip"
	  }, [_vm._v("请输入您的会员卡号")]), _vm._v(" "), _c('div', {
	    staticClass: "button-one card-in"
	  }, [_c('div', {
	    staticClass: "in_tip"
	  }, [_vm._v("卡号")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.card_num),
	      expression: "card_num"
	    }],
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.card_num)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.card_num = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "btop_tip"
	  }, [_vm._v("请输入您的手机号码")]), _vm._v(" "), _c('div', {
	    staticClass: "button-two phone-in"
	  }, [_c('div', {
	    staticClass: "in_tip"
	  }, [_vm._v("手机号")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.cust_mobile),
	      expression: "cust_mobile"
	    }],
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.cust_mobile)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.cust_mobile = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "btop_tip"
	  }, [_vm._v("请点击“获取验证码”按钮，填写您收到的验证码")]), _vm._v(" "), _c('div', {
	    staticClass: "button-three "
	  }, [_c('div', {
	    staticClass: "in_tip"
	  }, [_vm._v("验证码")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.card_bind_vcode),
	      expression: "card_bind_vcode"
	    }],
	    staticClass: "input-text",
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.card_bind_vcode)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.card_bind_vcode = $event.target.value
	      }
	    }
	  }), _vm._v(" "), (!_vm.sendMsgDisabled) ? _c('div', {
	    staticClass: "button-four",
	    on: {
	      "click": _vm.getSession
	    }
	  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), (_vm.sendMsgDisabled) ? _c('div', {
	    staticClass: "button-four"
	  }, [_c('a', {
	    staticClass: "waitTime"
	  }, [_vm._v(_vm._s(_vm.time + '秒'))])]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
	    staticClass: "next-button"
	  }, [_c('input', {
	    staticClass: "bangding",
	    attrs: {
	      "type": "button",
	      "value": "绑定"
	    },
	    on: {
	      "click": _vm.bindup
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "success hdiv"
	  }, [_c('div', {
	    staticClass: "cover"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "cover-content"
	  }, [_c('div', {
	    staticClass: "success-text"
	  }, [_c('p', [_vm._v("绑定成功")]), _vm._v(" "), _c('input', {
	    attrs: {
	      "type": "button",
	      "value": "确定"
	    },
	    on: {
	      "click": _vm.goQrcode
	    }
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "fail hdiv"
	  }, [_c('div', {
	    staticClass: "cover"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "cover-content"
	  }, [_c('img', {
	    attrs: {
	      "src": "http://style.cdn.juhaomai.net/style/game/huiyuanbangding/images/v2/sorry.png"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "fail-text"
	  }, [_c('p', [_vm._v(_vm._s(_vm.err_msg))]), _vm._v(" "), _c('p'), _vm._v(" "), _c('input', {
	    attrs: {
	      "type": "button",
	      "value": "确定"
	    },
	    on: {
	      "click": _vm.closeAgain
	    }
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "again hdiv"
	  }, [_c('div', {
	    staticClass: "cover"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "cover-content"
	  }, [_c('img', {
	    attrs: {
	      "src": "http://style.cdn.juhaomai.net/style/game/huiyuanbangding/images/v2/again.png"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "again-text"
	  }, [_c('input', {
	    attrs: {
	      "type": "button",
	      "value": "电话告诉我验证码"
	    }
	  }), _vm._v(" "), _c('input', {
	    staticClass: "pass",
	    attrs: {
	      "type": "button",
	      "value": "取消"
	    },
	    on: {
	      "click": _vm.closePhone
	    }
	  })])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('a', {
	    staticClass: "get-start"
	  }, [_vm._v("获取验证码"), _c('br')])
	}]}

/***/ }),
/* 223 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "menuTree"
	    }
	  }, [_c('li', [_c('div', {
	    staticStyle: {
	      "font-size": "16px"
	    }
	  }, [(_vm.isFolder) ? _c('i', {
	    staticClass: "fa ",
	    class: [_vm.open ? 'fa-minus-square-o' : 'fa-plus-square-o'],
	    on: {
	      "click": function($event) {
	        return _vm.toggle()
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), _c('input', {
	    staticClass: "menuTree_1_check",
	    attrs: {
	      "type": "checkbox",
	      "data-id": _vm.model.id
	    }
	  }), _vm._v(" "), _c('i', {
	    staticClass: "menuname"
	  }, [_vm._v(_vm._s(_vm.model.name))])]), _vm._v(" "), (_vm.isFolder) ? _c('ul', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.open),
	      expression: "open"
	    }]
	  }, _vm._l((_vm.model.children), function(item) {
	    return _c('items', {
	      attrs: {
	        "model": item
	      }
	    })
	  }), 1) : _vm._e()])])
	},staticRenderFns: []}

/***/ }),
/* 224 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "load-hide bill"
	  }, [_c('div', {
	    staticClass: "recharge_types",
	    staticStyle: {
	      "padding-top": "60px"
	    }
	  }, [_c('pull-to-refresh', {
	    staticClass: "page",
	    attrs: {
	      "disable-pulldown": ""
	    },
	    on: {
	      "on-pullup": _vm.onPullup
	    }
	  }, [_c('div', {
	    staticStyle: {
	      "padding": "0 0.19rem 0.05rem"
	    }
	  }, [_c('table', {
	    staticClass: "table table-bordered table-condensed dataTables-example dataTable no-footer"
	  }, [_c('tbody', _vm._l((_vm.recordList), function(item) {
	    return _c('tr', [(item.detail_type == 'deposit') ? _c('td', {
	      staticClass: "shoppingtype redD"
	    }, [_c('p', [_vm._v(_vm._s(_vm.getType[item.detail_type]))])]) : (item.detail_type == 'consume') ? _c('td', {
	      staticClass: "shoppingtype greenC"
	    }, [_c('p', [_vm._v(_vm._s(_vm.getType[item.detail_type]))])]) : (item.detail_type == 'refund') ? _c('td', {
	      staticClass: "shoppingtype greyR"
	    }, [_c('p', [_vm._v(_vm._s(_vm.getType[item.detail_type]))])]) : _vm._e(), _vm._v(" "), _c('td', [_c('div', {
	      staticClass: "givetype"
	    }, [_vm._v(_vm._s(_vm.getKinds[item.coCode]))]), _vm._v(" "), _c('div', {
	      staticStyle: {
	        "text-align": "left",
	        "color": "#9e9e9e"
	      }
	    }, [_vm._v(_vm._s(_vm._f("date")(item.gmt_create, '%Y-%m-%d %H:%M:%s')))])]), _vm._v(" "), (item.detail_type == 'consume') ? _c('td', {
	      staticClass: "givetype",
	      staticStyle: {
	        "color": "#6ab82d"
	      }
	    }, [_vm._v("-" + _vm._s(item.fee))]) : (item.detail_type == 'deposit' && item.fee >= 0) ? _c('td', {
	      staticClass: "givetype",
	      staticStyle: {
	        "color": "#bd0000"
	      }
	    }, [_vm._v("+" + _vm._s(item.fee))]) : (item.detail_type == 'deposit' && item.fee < 0) ? _c('td', {
	      staticClass: "givetype",
	      staticStyle: {
	        "color": "#bd0000"
	      }
	    }, [_vm._v(_vm._s(item.fee))]) : (item.detail_type == 'refund') ? _c('td', {
	      staticClass: "givetype",
	      staticStyle: {
	        "color": "#999999"
	      }
	    }, [_vm._v("+" + _vm._s(item.fee))]) : _vm._e()])
	  }), 0)]), _vm._v(" "), (_vm.recordList.length == 0) ? _c('div', {
	    staticStyle: {
	      "width": "100%",
	      "text-align": "center",
	      "font-size": "0.18rem"
	    }
	  }, [_vm._v("暂无记录")]) : _vm._e()])])], 1)])
	},staticRenderFns: []}

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

	/*!
	 * vue-resource v1.5.3
	 * https://github.com/pagekit/vue-resource
	 * Released under the MIT License.
	 */
	
	'use strict';
	
	/**
	 * Promises/A+ polyfill v1.1.4 (https://github.com/bramstein/promis)
	 */
	var RESOLVED = 0;
	var REJECTED = 1;
	var PENDING = 2;
	function Promise$1(executor) {
	  this.state = PENDING;
	  this.value = undefined;
	  this.deferred = [];
	  var promise = this;
	
	  try {
	    executor(function (x) {
	      promise.resolve(x);
	    }, function (r) {
	      promise.reject(r);
	    });
	  } catch (e) {
	    promise.reject(e);
	  }
	}
	
	Promise$1.reject = function (r) {
	  return new Promise$1(function (resolve, reject) {
	    reject(r);
	  });
	};
	
	Promise$1.resolve = function (x) {
	  return new Promise$1(function (resolve, reject) {
	    resolve(x);
	  });
	};
	
	Promise$1.all = function all(iterable) {
	  return new Promise$1(function (resolve, reject) {
	    var count = 0,
	        result = [];
	
	    if (iterable.length === 0) {
	      resolve(result);
	    }
	
	    function resolver(i) {
	      return function (x) {
	        result[i] = x;
	        count += 1;
	
	        if (count === iterable.length) {
	          resolve(result);
	        }
	      };
	    }
	
	    for (var i = 0; i < iterable.length; i += 1) {
	      Promise$1.resolve(iterable[i]).then(resolver(i), reject);
	    }
	  });
	};
	
	Promise$1.race = function race(iterable) {
	  return new Promise$1(function (resolve, reject) {
	    for (var i = 0; i < iterable.length; i += 1) {
	      Promise$1.resolve(iterable[i]).then(resolve, reject);
	    }
	  });
	};
	
	var p = Promise$1.prototype;
	
	p.resolve = function resolve(x) {
	  var promise = this;
	
	  if (promise.state === PENDING) {
	    if (x === promise) {
	      throw new TypeError('Promise settled with itself.');
	    }
	
	    var called = false;
	
	    try {
	      var then = x && x['then'];
	
	      if (x !== null && typeof x === 'object' && typeof then === 'function') {
	        then.call(x, function (x) {
	          if (!called) {
	            promise.resolve(x);
	          }
	
	          called = true;
	        }, function (r) {
	          if (!called) {
	            promise.reject(r);
	          }
	
	          called = true;
	        });
	        return;
	      }
	    } catch (e) {
	      if (!called) {
	        promise.reject(e);
	      }
	
	      return;
	    }
	
	    promise.state = RESOLVED;
	    promise.value = x;
	    promise.notify();
	  }
	};
	
	p.reject = function reject(reason) {
	  var promise = this;
	
	  if (promise.state === PENDING) {
	    if (reason === promise) {
	      throw new TypeError('Promise settled with itself.');
	    }
	
	    promise.state = REJECTED;
	    promise.value = reason;
	    promise.notify();
	  }
	};
	
	p.notify = function notify() {
	  var promise = this;
	  nextTick(function () {
	    if (promise.state !== PENDING) {
	      while (promise.deferred.length) {
	        var deferred = promise.deferred.shift(),
	            onResolved = deferred[0],
	            onRejected = deferred[1],
	            resolve = deferred[2],
	            reject = deferred[3];
	
	        try {
	          if (promise.state === RESOLVED) {
	            if (typeof onResolved === 'function') {
	              resolve(onResolved.call(undefined, promise.value));
	            } else {
	              resolve(promise.value);
	            }
	          } else if (promise.state === REJECTED) {
	            if (typeof onRejected === 'function') {
	              resolve(onRejected.call(undefined, promise.value));
	            } else {
	              reject(promise.value);
	            }
	          }
	        } catch (e) {
	          reject(e);
	        }
	      }
	    }
	  });
	};
	
	p.then = function then(onResolved, onRejected) {
	  var promise = this;
	  return new Promise$1(function (resolve, reject) {
	    promise.deferred.push([onResolved, onRejected, resolve, reject]);
	    promise.notify();
	  });
	};
	
	p["catch"] = function (onRejected) {
	  return this.then(undefined, onRejected);
	};
	
	/**
	 * Promise adapter.
	 */
	
	if (typeof Promise === 'undefined') {
	  window.Promise = Promise$1;
	}
	
	function PromiseObj(executor, context) {
	  if (executor instanceof Promise) {
	    this.promise = executor;
	  } else {
	    this.promise = new Promise(executor.bind(context));
	  }
	
	  this.context = context;
	}
	
	PromiseObj.all = function (iterable, context) {
	  return new PromiseObj(Promise.all(iterable), context);
	};
	
	PromiseObj.resolve = function (value, context) {
	  return new PromiseObj(Promise.resolve(value), context);
	};
	
	PromiseObj.reject = function (reason, context) {
	  return new PromiseObj(Promise.reject(reason), context);
	};
	
	PromiseObj.race = function (iterable, context) {
	  return new PromiseObj(Promise.race(iterable), context);
	};
	
	var p$1 = PromiseObj.prototype;
	
	p$1.bind = function (context) {
	  this.context = context;
	  return this;
	};
	
	p$1.then = function (fulfilled, rejected) {
	  if (fulfilled && fulfilled.bind && this.context) {
	    fulfilled = fulfilled.bind(this.context);
	  }
	
	  if (rejected && rejected.bind && this.context) {
	    rejected = rejected.bind(this.context);
	  }
	
	  return new PromiseObj(this.promise.then(fulfilled, rejected), this.context);
	};
	
	p$1["catch"] = function (rejected) {
	  if (rejected && rejected.bind && this.context) {
	    rejected = rejected.bind(this.context);
	  }
	
	  return new PromiseObj(this.promise["catch"](rejected), this.context);
	};
	
	p$1["finally"] = function (callback) {
	  return this.then(function (value) {
	    callback.call(this);
	    return value;
	  }, function (reason) {
	    callback.call(this);
	    return Promise.reject(reason);
	  });
	};
	
	/**
	 * Utility functions.
	 */
	var _ref = {},
	    hasOwnProperty = _ref.hasOwnProperty,
	    slice = [].slice,
	    debug = false,
	    ntick;
	var inBrowser = typeof window !== 'undefined';
	function Util (_ref2) {
	  var config = _ref2.config,
	      nextTick = _ref2.nextTick;
	  ntick = nextTick;
	  debug = config.debug || !config.silent;
	}
	function warn(msg) {
	  if (typeof console !== 'undefined' && debug) {
	    console.warn('[VueResource warn]: ' + msg);
	  }
	}
	function error(msg) {
	  if (typeof console !== 'undefined') {
	    console.error(msg);
	  }
	}
	function nextTick(cb, ctx) {
	  return ntick(cb, ctx);
	}
	function trim(str) {
	  return str ? str.replace(/^\s*|\s*$/g, '') : '';
	}
	function trimEnd(str, chars) {
	  if (str && chars === undefined) {
	    return str.replace(/\s+$/, '');
	  }
	
	  if (!str || !chars) {
	    return str;
	  }
	
	  return str.replace(new RegExp("[" + chars + "]+$"), '');
	}
	function toLower(str) {
	  return str ? str.toLowerCase() : '';
	}
	function toUpper(str) {
	  return str ? str.toUpperCase() : '';
	}
	var isArray = Array.isArray;
	function isString(val) {
	  return typeof val === 'string';
	}
	function isFunction(val) {
	  return typeof val === 'function';
	}
	function isObject(obj) {
	  return obj !== null && typeof obj === 'object';
	}
	function isPlainObject(obj) {
	  return isObject(obj) && Object.getPrototypeOf(obj) == Object.prototype;
	}
	function isBlob(obj) {
	  return typeof Blob !== 'undefined' && obj instanceof Blob;
	}
	function isFormData(obj) {
	  return typeof FormData !== 'undefined' && obj instanceof FormData;
	}
	function when(value, fulfilled, rejected) {
	  var promise = PromiseObj.resolve(value);
	
	  if (arguments.length < 2) {
	    return promise;
	  }
	
	  return promise.then(fulfilled, rejected);
	}
	function options(fn, obj, opts) {
	  opts = opts || {};
	
	  if (isFunction(opts)) {
	    opts = opts.call(obj);
	  }
	
	  return merge(fn.bind({
	    $vm: obj,
	    $options: opts
	  }), fn, {
	    $options: opts
	  });
	}
	function each(obj, iterator) {
	  var i, key;
	
	  if (isArray(obj)) {
	    for (i = 0; i < obj.length; i++) {
	      iterator.call(obj[i], obj[i], i);
	    }
	  } else if (isObject(obj)) {
	    for (key in obj) {
	      if (hasOwnProperty.call(obj, key)) {
	        iterator.call(obj[key], obj[key], key);
	      }
	    }
	  }
	
	  return obj;
	}
	var assign = Object.assign || _assign;
	function merge(target) {
	  var args = slice.call(arguments, 1);
	  args.forEach(function (source) {
	    _merge(target, source, true);
	  });
	  return target;
	}
	function defaults(target) {
	  var args = slice.call(arguments, 1);
	  args.forEach(function (source) {
	    for (var key in source) {
	      if (target[key] === undefined) {
	        target[key] = source[key];
	      }
	    }
	  });
	  return target;
	}
	
	function _assign(target) {
	  var args = slice.call(arguments, 1);
	  args.forEach(function (source) {
	    _merge(target, source);
	  });
	  return target;
	}
	
	function _merge(target, source, deep) {
	  for (var key in source) {
	    if (deep && (isPlainObject(source[key]) || isArray(source[key]))) {
	      if (isPlainObject(source[key]) && !isPlainObject(target[key])) {
	        target[key] = {};
	      }
	
	      if (isArray(source[key]) && !isArray(target[key])) {
	        target[key] = [];
	      }
	
	      _merge(target[key], source[key], deep);
	    } else if (source[key] !== undefined) {
	      target[key] = source[key];
	    }
	  }
	}
	
	/**
	 * Root Prefix Transform.
	 */
	function root (options$$1, next) {
	  var url = next(options$$1);
	
	  if (isString(options$$1.root) && !/^(https?:)?\//.test(url)) {
	    url = trimEnd(options$$1.root, '/') + '/' + url;
	  }
	
	  return url;
	}
	
	/**
	 * Query Parameter Transform.
	 */
	function query (options$$1, next) {
	  var urlParams = Object.keys(Url.options.params),
	      query = {},
	      url = next(options$$1);
	  each(options$$1.params, function (value, key) {
	    if (urlParams.indexOf(key) === -1) {
	      query[key] = value;
	    }
	  });
	  query = Url.params(query);
	
	  if (query) {
	    url += (url.indexOf('?') == -1 ? '?' : '&') + query;
	  }
	
	  return url;
	}
	
	/**
	 * URL Template v2.0.6 (https://github.com/bramstein/url-template)
	 */
	function expand(url, params, variables) {
	  var tmpl = parse(url),
	      expanded = tmpl.expand(params);
	
	  if (variables) {
	    variables.push.apply(variables, tmpl.vars);
	  }
	
	  return expanded;
	}
	function parse(template) {
	  var operators = ['+', '#', '.', '/', ';', '?', '&'],
	      variables = [];
	  return {
	    vars: variables,
	    expand: function expand(context) {
	      return template.replace(/\{([^{}]+)\}|([^{}]+)/g, function (_, expression, literal) {
	        if (expression) {
	          var operator = null,
	              values = [];
	
	          if (operators.indexOf(expression.charAt(0)) !== -1) {
	            operator = expression.charAt(0);
	            expression = expression.substr(1);
	          }
	
	          expression.split(/,/g).forEach(function (variable) {
	            var tmp = /([^:*]*)(?::(\d+)|(\*))?/.exec(variable);
	            values.push.apply(values, getValues(context, operator, tmp[1], tmp[2] || tmp[3]));
	            variables.push(tmp[1]);
	          });
	
	          if (operator && operator !== '+') {
	            var separator = ',';
	
	            if (operator === '?') {
	              separator = '&';
	            } else if (operator !== '#') {
	              separator = operator;
	            }
	
	            return (values.length !== 0 ? operator : '') + values.join(separator);
	          } else {
	            return values.join(',');
	          }
	        } else {
	          return encodeReserved(literal);
	        }
	      });
	    }
	  };
	}
	
	function getValues(context, operator, key, modifier) {
	  var value = context[key],
	      result = [];
	
	  if (isDefined(value) && value !== '') {
	    if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
	      value = value.toString();
	
	      if (modifier && modifier !== '*') {
	        value = value.substring(0, parseInt(modifier, 10));
	      }
	
	      result.push(encodeValue(operator, value, isKeyOperator(operator) ? key : null));
	    } else {
	      if (modifier === '*') {
	        if (Array.isArray(value)) {
	          value.filter(isDefined).forEach(function (value) {
	            result.push(encodeValue(operator, value, isKeyOperator(operator) ? key : null));
	          });
	        } else {
	          Object.keys(value).forEach(function (k) {
	            if (isDefined(value[k])) {
	              result.push(encodeValue(operator, value[k], k));
	            }
	          });
	        }
	      } else {
	        var tmp = [];
	
	        if (Array.isArray(value)) {
	          value.filter(isDefined).forEach(function (value) {
	            tmp.push(encodeValue(operator, value));
	          });
	        } else {
	          Object.keys(value).forEach(function (k) {
	            if (isDefined(value[k])) {
	              tmp.push(encodeURIComponent(k));
	              tmp.push(encodeValue(operator, value[k].toString()));
	            }
	          });
	        }
	
	        if (isKeyOperator(operator)) {
	          result.push(encodeURIComponent(key) + '=' + tmp.join(','));
	        } else if (tmp.length !== 0) {
	          result.push(tmp.join(','));
	        }
	      }
	    }
	  } else {
	    if (operator === ';') {
	      result.push(encodeURIComponent(key));
	    } else if (value === '' && (operator === '&' || operator === '?')) {
	      result.push(encodeURIComponent(key) + '=');
	    } else if (value === '') {
	      result.push('');
	    }
	  }
	
	  return result;
	}
	
	function isDefined(value) {
	  return value !== undefined && value !== null;
	}
	
	function isKeyOperator(operator) {
	  return operator === ';' || operator === '&' || operator === '?';
	}
	
	function encodeValue(operator, value, key) {
	  value = operator === '+' || operator === '#' ? encodeReserved(value) : encodeURIComponent(value);
	
	  if (key) {
	    return encodeURIComponent(key) + '=' + value;
	  } else {
	    return value;
	  }
	}
	
	function encodeReserved(str) {
	  return str.split(/(%[0-9A-Fa-f]{2})/g).map(function (part) {
	    if (!/%[0-9A-Fa-f]/.test(part)) {
	      part = encodeURI(part);
	    }
	
	    return part;
	  }).join('');
	}
	
	/**
	 * URL Template (RFC 6570) Transform.
	 */
	function template (options) {
	  var variables = [],
	      url = expand(options.url, options.params, variables);
	  variables.forEach(function (key) {
	    delete options.params[key];
	  });
	  return url;
	}
	
	/**
	 * Service for URL templating.
	 */
	function Url(url, params) {
	  var self = this || {},
	      options$$1 = url,
	      transform;
	
	  if (isString(url)) {
	    options$$1 = {
	      url: url,
	      params: params
	    };
	  }
	
	  options$$1 = merge({}, Url.options, self.$options, options$$1);
	  Url.transforms.forEach(function (handler) {
	    if (isString(handler)) {
	      handler = Url.transform[handler];
	    }
	
	    if (isFunction(handler)) {
	      transform = factory(handler, transform, self.$vm);
	    }
	  });
	  return transform(options$$1);
	}
	/**
	 * Url options.
	 */
	
	Url.options = {
	  url: '',
	  root: null,
	  params: {}
	};
	/**
	 * Url transforms.
	 */
	
	Url.transform = {
	  template: template,
	  query: query,
	  root: root
	};
	Url.transforms = ['template', 'query', 'root'];
	/**
	 * Encodes a Url parameter string.
	 *
	 * @param {Object} obj
	 */
	
	Url.params = function (obj) {
	  var params = [],
	      escape = encodeURIComponent;
	
	  params.add = function (key, value) {
	    if (isFunction(value)) {
	      value = value();
	    }
	
	    if (value === null) {
	      value = '';
	    }
	
	    this.push(escape(key) + '=' + escape(value));
	  };
	
	  serialize(params, obj);
	  return params.join('&').replace(/%20/g, '+');
	};
	/**
	 * Parse a URL and return its components.
	 *
	 * @param {String} url
	 */
	
	
	Url.parse = function (url) {
	  var el = document.createElement('a');
	
	  if (document.documentMode) {
	    el.href = url;
	    url = el.href;
	  }
	
	  el.href = url;
	  return {
	    href: el.href,
	    protocol: el.protocol ? el.protocol.replace(/:$/, '') : '',
	    port: el.port,
	    host: el.host,
	    hostname: el.hostname,
	    pathname: el.pathname.charAt(0) === '/' ? el.pathname : '/' + el.pathname,
	    search: el.search ? el.search.replace(/^\?/, '') : '',
	    hash: el.hash ? el.hash.replace(/^#/, '') : ''
	  };
	};
	
	function factory(handler, next, vm) {
	  return function (options$$1) {
	    return handler.call(vm, options$$1, next);
	  };
	}
	
	function serialize(params, obj, scope) {
	  var array = isArray(obj),
	      plain = isPlainObject(obj),
	      hash;
	  each(obj, function (value, key) {
	    hash = isObject(value) || isArray(value);
	
	    if (scope) {
	      key = scope + '[' + (plain || hash ? key : '') + ']';
	    }
	
	    if (!scope && array) {
	      params.add(value.name, value.value);
	    } else if (hash) {
	      serialize(params, value, key);
	    } else {
	      params.add(key, value);
	    }
	  });
	}
	
	/**
	 * XDomain client (Internet Explorer).
	 */
	function xdrClient (request) {
	  return new PromiseObj(function (resolve) {
	    var xdr = new XDomainRequest(),
	        handler = function handler(_ref) {
	      var type = _ref.type;
	      var status = 0;
	
	      if (type === 'load') {
	        status = 200;
	      } else if (type === 'error') {
	        status = 500;
	      }
	
	      resolve(request.respondWith(xdr.responseText, {
	        status: status
	      }));
	    };
	
	    request.abort = function () {
	      return xdr.abort();
	    };
	
	    xdr.open(request.method, request.getUrl());
	
	    if (request.timeout) {
	      xdr.timeout = request.timeout;
	    }
	
	    xdr.onload = handler;
	    xdr.onabort = handler;
	    xdr.onerror = handler;
	    xdr.ontimeout = handler;
	
	    xdr.onprogress = function () {};
	
	    xdr.send(request.getBody());
	  });
	}
	
	/**
	 * CORS Interceptor.
	 */
	var SUPPORTS_CORS = inBrowser && 'withCredentials' in new XMLHttpRequest();
	function cors (request) {
	  if (inBrowser) {
	    var orgUrl = Url.parse(location.href);
	    var reqUrl = Url.parse(request.getUrl());
	
	    if (reqUrl.protocol !== orgUrl.protocol || reqUrl.host !== orgUrl.host) {
	      request.crossOrigin = true;
	      request.emulateHTTP = false;
	
	      if (!SUPPORTS_CORS) {
	        request.client = xdrClient;
	      }
	    }
	  }
	}
	
	/**
	 * Form data Interceptor.
	 */
	function form (request) {
	  if (isFormData(request.body)) {
	    request.headers["delete"]('Content-Type');
	  } else if (isObject(request.body) && request.emulateJSON) {
	    request.body = Url.params(request.body);
	    request.headers.set('Content-Type', 'application/x-www-form-urlencoded');
	  }
	}
	
	/**
	 * JSON Interceptor.
	 */
	function json (request) {
	  var type = request.headers.get('Content-Type') || '';
	
	  if (isObject(request.body) && type.indexOf('application/json') === 0) {
	    request.body = JSON.stringify(request.body);
	  }
	
	  return function (response) {
	    return response.bodyText ? when(response.text(), function (text) {
	      var type = response.headers.get('Content-Type') || '';
	
	      if (type.indexOf('application/json') === 0 || isJson(text)) {
	        try {
	          response.body = JSON.parse(text);
	        } catch (e) {
	          response.body = null;
	        }
	      } else {
	        response.body = text;
	      }
	
	      return response;
	    }) : response;
	  };
	}
	
	function isJson(str) {
	  var start = str.match(/^\s*(\[|\{)/);
	  var end = {
	    '[': /]\s*$/,
	    '{': /}\s*$/
	  };
	  return start && end[start[1]].test(str);
	}
	
	/**
	 * JSONP client (Browser).
	 */
	function jsonpClient (request) {
	  return new PromiseObj(function (resolve) {
	    var name = request.jsonp || 'callback',
	        callback = request.jsonpCallback || '_jsonp' + Math.random().toString(36).substr(2),
	        body = null,
	        handler,
	        script;
	
	    handler = function handler(_ref) {
	      var type = _ref.type;
	      var status = 0;
	
	      if (type === 'load' && body !== null) {
	        status = 200;
	      } else if (type === 'error') {
	        status = 500;
	      }
	
	      if (status && window[callback]) {
	        delete window[callback];
	        document.body.removeChild(script);
	      }
	
	      resolve(request.respondWith(body, {
	        status: status
	      }));
	    };
	
	    window[callback] = function (result) {
	      body = JSON.stringify(result);
	    };
	
	    request.abort = function () {
	      handler({
	        type: 'abort'
	      });
	    };
	
	    request.params[name] = callback;
	
	    if (request.timeout) {
	      setTimeout(request.abort, request.timeout);
	    }
	
	    script = document.createElement('script');
	    script.src = request.getUrl();
	    script.type = 'text/javascript';
	    script.async = true;
	    script.onload = handler;
	    script.onerror = handler;
	    document.body.appendChild(script);
	  });
	}
	
	/**
	 * JSONP Interceptor.
	 */
	function jsonp (request) {
	  if (request.method == 'JSONP') {
	    request.client = jsonpClient;
	  }
	}
	
	/**
	 * Before Interceptor.
	 */
	function before (request) {
	  if (isFunction(request.before)) {
	    request.before.call(this, request);
	  }
	}
	
	/**
	 * HTTP method override Interceptor.
	 */
	function method (request) {
	  if (request.emulateHTTP && /^(PUT|PATCH|DELETE)$/i.test(request.method)) {
	    request.headers.set('X-HTTP-Method-Override', request.method);
	    request.method = 'POST';
	  }
	}
	
	/**
	 * Header Interceptor.
	 */
	function header (request) {
	  var headers = assign({}, Http.headers.common, !request.crossOrigin ? Http.headers.custom : {}, Http.headers[toLower(request.method)]);
	  each(headers, function (value, name) {
	    if (!request.headers.has(name)) {
	      request.headers.set(name, value);
	    }
	  });
	}
	
	/**
	 * XMLHttp client (Browser).
	 */
	function xhrClient (request) {
	  return new PromiseObj(function (resolve) {
	    var xhr = new XMLHttpRequest(),
	        handler = function handler(event) {
	      var response = request.respondWith('response' in xhr ? xhr.response : xhr.responseText, {
	        status: xhr.status === 1223 ? 204 : xhr.status,
	        // IE9 status bug
	        statusText: xhr.status === 1223 ? 'No Content' : trim(xhr.statusText)
	      });
	      each(trim(xhr.getAllResponseHeaders()).split('\n'), function (row) {
	        response.headers.append(row.slice(0, row.indexOf(':')), row.slice(row.indexOf(':') + 1));
	      });
	      resolve(response);
	    };
	
	    request.abort = function () {
	      return xhr.abort();
	    };
	
	    xhr.open(request.method, request.getUrl(), true);
	
	    if (request.timeout) {
	      xhr.timeout = request.timeout;
	    }
	
	    if (request.responseType && 'responseType' in xhr) {
	      xhr.responseType = request.responseType;
	    }
	
	    if (request.withCredentials || request.credentials) {
	      xhr.withCredentials = true;
	    }
	
	    if (!request.crossOrigin) {
	      request.headers.set('X-Requested-With', 'XMLHttpRequest');
	    } // deprecated use downloadProgress
	
	
	    if (isFunction(request.progress) && request.method === 'GET') {
	      xhr.addEventListener('progress', request.progress);
	    }
	
	    if (isFunction(request.downloadProgress)) {
	      xhr.addEventListener('progress', request.downloadProgress);
	    } // deprecated use uploadProgress
	
	
	    if (isFunction(request.progress) && /^(POST|PUT)$/i.test(request.method)) {
	      xhr.upload.addEventListener('progress', request.progress);
	    }
	
	    if (isFunction(request.uploadProgress) && xhr.upload) {
	      xhr.upload.addEventListener('progress', request.uploadProgress);
	    }
	
	    request.headers.forEach(function (value, name) {
	      xhr.setRequestHeader(name, value);
	    });
	    xhr.onload = handler;
	    xhr.onabort = handler;
	    xhr.onerror = handler;
	    xhr.ontimeout = handler;
	    xhr.send(request.getBody());
	  });
	}
	
	/**
	 * Http client (Node).
	 */
	function nodeClient (request) {
	  var client = __webpack_require__(229);
	
	  return new PromiseObj(function (resolve) {
	    var url = request.getUrl();
	    var body = request.getBody();
	    var method = request.method;
	    var headers = {},
	        handler;
	    request.headers.forEach(function (value, name) {
	      headers[name] = value;
	    });
	    client(url, {
	      body: body,
	      method: method,
	      headers: headers
	    }).then(handler = function handler(resp) {
	      var response = request.respondWith(resp.body, {
	        status: resp.statusCode,
	        statusText: trim(resp.statusMessage)
	      });
	      each(resp.headers, function (value, name) {
	        response.headers.set(name, value);
	      });
	      resolve(response);
	    }, function (error$$1) {
	      return handler(error$$1.response);
	    });
	  });
	}
	
	/**
	 * Base client.
	 */
	function Client (context) {
	  var reqHandlers = [sendRequest],
	      resHandlers = [];
	
	  if (!isObject(context)) {
	    context = null;
	  }
	
	  function Client(request) {
	    while (reqHandlers.length) {
	      var handler = reqHandlers.pop();
	
	      if (isFunction(handler)) {
	        var _ret = function () {
	          var response = void 0,
	              next = void 0;
	          response = handler.call(context, request, function (val) {
	            return next = val;
	          }) || next;
	
	          if (isObject(response)) {
	            return {
	              v: new PromiseObj(function (resolve, reject) {
	                resHandlers.forEach(function (handler) {
	                  response = when(response, function (response) {
	                    return handler.call(context, response) || response;
	                  }, reject);
	                });
	                when(response, resolve, reject);
	              }, context)
	            };
	          }
	
	          if (isFunction(response)) {
	            resHandlers.unshift(response);
	          }
	        }();
	
	        if (typeof _ret === "object") return _ret.v;
	      } else {
	        warn("Invalid interceptor of type " + typeof handler + ", must be a function");
	      }
	    }
	  }
	
	  Client.use = function (handler) {
	    reqHandlers.push(handler);
	  };
	
	  return Client;
	}
	
	function sendRequest(request) {
	  var client = request.client || (inBrowser ? xhrClient : nodeClient);
	  return client(request);
	}
	
	/**
	 * HTTP Headers.
	 */
	
	var Headers = /*#__PURE__*/function () {
	  function Headers(headers) {
	    var _this = this;
	
	    this.map = {};
	    each(headers, function (value, name) {
	      return _this.append(name, value);
	    });
	  }
	
	  var _proto = Headers.prototype;
	
	  _proto.has = function has(name) {
	    return getName(this.map, name) !== null;
	  };
	
	  _proto.get = function get(name) {
	    var list = this.map[getName(this.map, name)];
	    return list ? list.join() : null;
	  };
	
	  _proto.getAll = function getAll(name) {
	    return this.map[getName(this.map, name)] || [];
	  };
	
	  _proto.set = function set(name, value) {
	    this.map[normalizeName(getName(this.map, name) || name)] = [trim(value)];
	  };
	
	  _proto.append = function append(name, value) {
	    var list = this.map[getName(this.map, name)];
	
	    if (list) {
	      list.push(trim(value));
	    } else {
	      this.set(name, value);
	    }
	  };
	
	  _proto["delete"] = function _delete(name) {
	    delete this.map[getName(this.map, name)];
	  };
	
	  _proto.deleteAll = function deleteAll() {
	    this.map = {};
	  };
	
	  _proto.forEach = function forEach(callback, thisArg) {
	    var _this2 = this;
	
	    each(this.map, function (list, name) {
	      each(list, function (value) {
	        return callback.call(thisArg, value, name, _this2);
	      });
	    });
	  };
	
	  return Headers;
	}();
	
	function getName(map, name) {
	  return Object.keys(map).reduce(function (prev, curr) {
	    return toLower(name) === toLower(curr) ? curr : prev;
	  }, null);
	}
	
	function normalizeName(name) {
	  if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) {
	    throw new TypeError('Invalid character in header field name');
	  }
	
	  return trim(name);
	}
	
	/**
	 * HTTP Response.
	 */
	
	var Response = /*#__PURE__*/function () {
	  function Response(body, _ref) {
	    var url = _ref.url,
	        headers = _ref.headers,
	        status = _ref.status,
	        statusText = _ref.statusText;
	    this.url = url;
	    this.ok = status >= 200 && status < 300;
	    this.status = status || 0;
	    this.statusText = statusText || '';
	    this.headers = new Headers(headers);
	    this.body = body;
	
	    if (isString(body)) {
	      this.bodyText = body;
	    } else if (isBlob(body)) {
	      this.bodyBlob = body;
	
	      if (isBlobText(body)) {
	        this.bodyText = blobText(body);
	      }
	    }
	  }
	
	  var _proto = Response.prototype;
	
	  _proto.blob = function blob() {
	    return when(this.bodyBlob);
	  };
	
	  _proto.text = function text() {
	    return when(this.bodyText);
	  };
	
	  _proto.json = function json() {
	    return when(this.text(), function (text) {
	      return JSON.parse(text);
	    });
	  };
	
	  return Response;
	}();
	Object.defineProperty(Response.prototype, 'data', {
	  get: function get() {
	    return this.body;
	  },
	  set: function set(body) {
	    this.body = body;
	  }
	});
	
	function blobText(body) {
	  return new PromiseObj(function (resolve) {
	    var reader = new FileReader();
	    reader.readAsText(body);
	
	    reader.onload = function () {
	      resolve(reader.result);
	    };
	  });
	}
	
	function isBlobText(body) {
	  return body.type.indexOf('text') === 0 || body.type.indexOf('json') !== -1;
	}
	
	/**
	 * HTTP Request.
	 */
	
	var Request = /*#__PURE__*/function () {
	  function Request(options$$1) {
	    this.body = null;
	    this.params = {};
	    assign(this, options$$1, {
	      method: toUpper(options$$1.method || 'GET')
	    });
	
	    if (!(this.headers instanceof Headers)) {
	      this.headers = new Headers(this.headers);
	    }
	  }
	
	  var _proto = Request.prototype;
	
	  _proto.getUrl = function getUrl() {
	    return Url(this);
	  };
	
	  _proto.getBody = function getBody() {
	    return this.body;
	  };
	
	  _proto.respondWith = function respondWith(body, options$$1) {
	    return new Response(body, assign(options$$1 || {}, {
	      url: this.getUrl()
	    }));
	  };
	
	  return Request;
	}();
	
	/**
	 * Service for sending network requests.
	 */
	var COMMON_HEADERS = {
	  'Accept': 'application/json, text/plain, */*'
	};
	var JSON_CONTENT_TYPE = {
	  'Content-Type': 'application/json;charset=utf-8'
	};
	function Http(options$$1) {
	  var self = this || {},
	      client = Client(self.$vm);
	  defaults(options$$1 || {}, self.$options, Http.options);
	  Http.interceptors.forEach(function (handler) {
	    if (isString(handler)) {
	      handler = Http.interceptor[handler];
	    }
	
	    if (isFunction(handler)) {
	      client.use(handler);
	    }
	  });
	  return client(new Request(options$$1)).then(function (response) {
	    return response.ok ? response : PromiseObj.reject(response);
	  }, function (response) {
	    if (response instanceof Error) {
	      error(response);
	    }
	
	    return PromiseObj.reject(response);
	  });
	}
	Http.options = {};
	Http.headers = {
	  put: JSON_CONTENT_TYPE,
	  post: JSON_CONTENT_TYPE,
	  patch: JSON_CONTENT_TYPE,
	  "delete": JSON_CONTENT_TYPE,
	  common: COMMON_HEADERS,
	  custom: {}
	};
	Http.interceptor = {
	  before: before,
	  method: method,
	  jsonp: jsonp,
	  json: json,
	  form: form,
	  header: header,
	  cors: cors
	};
	Http.interceptors = ['before', 'method', 'jsonp', 'json', 'form', 'header', 'cors'];
	['get', 'delete', 'head', 'jsonp'].forEach(function (method$$1) {
	  Http[method$$1] = function (url, options$$1) {
	    return this(assign(options$$1 || {}, {
	      url: url,
	      method: method$$1
	    }));
	  };
	});
	['post', 'put', 'patch'].forEach(function (method$$1) {
	  Http[method$$1] = function (url, body, options$$1) {
	    return this(assign(options$$1 || {}, {
	      url: url,
	      method: method$$1,
	      body: body
	    }));
	  };
	});
	
	/**
	 * Service for interacting with RESTful services.
	 */
	function Resource(url, params, actions, options$$1) {
	  var self = this || {},
	      resource = {};
	  actions = assign({}, Resource.actions, actions);
	  each(actions, function (action, name) {
	    action = merge({
	      url: url,
	      params: assign({}, params)
	    }, options$$1, action);
	
	    resource[name] = function () {
	      return (self.$http || Http)(opts(action, arguments));
	    };
	  });
	  return resource;
	}
	
	function opts(action, args) {
	  var options$$1 = assign({}, action),
	      params = {},
	      body;
	
	  switch (args.length) {
	    case 2:
	      params = args[0];
	      body = args[1];
	      break;
	
	    case 1:
	      if (/^(POST|PUT|PATCH)$/i.test(options$$1.method)) {
	        body = args[0];
	      } else {
	        params = args[0];
	      }
	
	      break;
	
	    case 0:
	      break;
	
	    default:
	      throw 'Expected up to 2 arguments [params, body], got ' + args.length + ' arguments';
	  }
	
	  options$$1.body = body;
	  options$$1.params = assign({}, options$$1.params, params);
	  return options$$1;
	}
	
	Resource.actions = {
	  get: {
	    method: 'GET'
	  },
	  save: {
	    method: 'POST'
	  },
	  query: {
	    method: 'GET'
	  },
	  update: {
	    method: 'PUT'
	  },
	  remove: {
	    method: 'DELETE'
	  },
	  "delete": {
	    method: 'DELETE'
	  }
	};
	
	/**
	 * Install plugin.
	 */
	
	function plugin(Vue) {
	  if (plugin.installed) {
	    return;
	  }
	
	  Util(Vue);
	  Vue.url = Url;
	  Vue.http = Http;
	  Vue.resource = Resource;
	  Vue.Promise = PromiseObj;
	  Object.defineProperties(Vue.prototype, {
	    $url: {
	      get: function get() {
	        return options(Vue.url, this, this.$options.url);
	      }
	    },
	    $http: {
	      get: function get() {
	        return options(Vue.http, this, this.$options.http);
	      }
	    },
	    $resource: {
	      get: function get() {
	        return Vue.resource.bind(this);
	      }
	    },
	    $promise: {
	      get: function get() {
	        var _this = this;
	
	        return function (executor) {
	          return new Vue.Promise(executor, _this);
	        };
	      }
	    }
	  });
	}
	
	if (typeof window !== 'undefined' && window.Vue && !window.Vue.resource) {
	  window.Vue.use(plugin);
	}
	
	module.exports = plugin;


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	  * vue-router v2.8.1
	  * (c) 2017 Evan You
	  * @license MIT
	  */
	'use strict';
	
	/*  */
	
	function assert (condition, message) {
	  if (!condition) {
	    throw new Error(("[vue-router] " + message))
	  }
	}
	
	function warn (condition, message) {
	  if (false) {
	    typeof console !== 'undefined' && console.warn(("[vue-router] " + message));
	  }
	}
	
	function isError (err) {
	  return Object.prototype.toString.call(err).indexOf('Error') > -1
	}
	
	var View = {
	  name: 'router-view',
	  functional: true,
	  props: {
	    name: {
	      type: String,
	      default: 'default'
	    }
	  },
	  render: function render (_, ref) {
	    var props = ref.props;
	    var children = ref.children;
	    var parent = ref.parent;
	    var data = ref.data;
	
	    data.routerView = true;
	
	    // directly use parent context's createElement() function
	    // so that components rendered by router-view can resolve named slots
	    var h = parent.$createElement;
	    var name = props.name;
	    var route = parent.$route;
	    var cache = parent._routerViewCache || (parent._routerViewCache = {});
	
	    // determine current view depth, also check to see if the tree
	    // has been toggled inactive but kept-alive.
	    var depth = 0;
	    var inactive = false;
	    while (parent && parent._routerRoot !== parent) {
	      if (parent.$vnode && parent.$vnode.data.routerView) {
	        depth++;
	      }
	      if (parent._inactive) {
	        inactive = true;
	      }
	      parent = parent.$parent;
	    }
	    data.routerViewDepth = depth;
	
	    // render previous view if the tree is inactive and kept-alive
	    if (inactive) {
	      return h(cache[name], data, children)
	    }
	
	    var matched = route.matched[depth];
	    // render empty node if no matched route
	    if (!matched) {
	      cache[name] = null;
	      return h()
	    }
	
	    var component = cache[name] = matched.components[name];
	
	    // attach instance registration hook
	    // this will be called in the instance's injected lifecycle hooks
	    data.registerRouteInstance = function (vm, val) {
	      // val could be undefined for unregistration
	      var current = matched.instances[name];
	      if (
	        (val && current !== vm) ||
	        (!val && current === vm)
	      ) {
	        matched.instances[name] = val;
	      }
	    }
	
	    // also register instance in prepatch hook
	    // in case the same component instance is reused across different routes
	    ;(data.hook || (data.hook = {})).prepatch = function (_, vnode) {
	      matched.instances[name] = vnode.componentInstance;
	    };
	
	    // resolve props
	    var propsToPass = data.props = resolveProps(route, matched.props && matched.props[name]);
	    if (propsToPass) {
	      // clone to prevent mutation
	      propsToPass = data.props = extend({}, propsToPass);
	      // pass non-declared props as attrs
	      var attrs = data.attrs = data.attrs || {};
	      for (var key in propsToPass) {
	        if (!component.props || !(key in component.props)) {
	          attrs[key] = propsToPass[key];
	          delete propsToPass[key];
	        }
	      }
	    }
	
	    return h(component, data, children)
	  }
	};
	
	function resolveProps (route, config) {
	  switch (typeof config) {
	    case 'undefined':
	      return
	    case 'object':
	      return config
	    case 'function':
	      return config(route)
	    case 'boolean':
	      return config ? route.params : undefined
	    default:
	      if (false) {
	        warn(
	          false,
	          "props in \"" + (route.path) + "\" is a " + (typeof config) + ", " +
	          "expecting an object, function or boolean."
	        );
	      }
	  }
	}
	
	function extend (to, from) {
	  for (var key in from) {
	    to[key] = from[key];
	  }
	  return to
	}
	
	/*  */
	
	var encodeReserveRE = /[!'()*]/g;
	var encodeReserveReplacer = function (c) { return '%' + c.charCodeAt(0).toString(16); };
	var commaRE = /%2C/g;
	
	// fixed encodeURIComponent which is more conformant to RFC3986:
	// - escapes [!'()*]
	// - preserve commas
	var encode = function (str) { return encodeURIComponent(str)
	  .replace(encodeReserveRE, encodeReserveReplacer)
	  .replace(commaRE, ','); };
	
	var decode = decodeURIComponent;
	
	function resolveQuery (
	  query,
	  extraQuery,
	  _parseQuery
	) {
	  if ( extraQuery === void 0 ) extraQuery = {};
	
	  var parse = _parseQuery || parseQuery;
	  var parsedQuery;
	  try {
	    parsedQuery = parse(query || '');
	  } catch (e) {
	    ("production") !== 'production' && warn(false, e.message);
	    parsedQuery = {};
	  }
	  for (var key in extraQuery) {
	    parsedQuery[key] = extraQuery[key];
	  }
	  return parsedQuery
	}
	
	function parseQuery (query) {
	  var res = {};
	
	  query = query.trim().replace(/^(\?|#|&)/, '');
	
	  if (!query) {
	    return res
	  }
	
	  query.split('&').forEach(function (param) {
	    var parts = param.replace(/\+/g, ' ').split('=');
	    var key = decode(parts.shift());
	    var val = parts.length > 0
	      ? decode(parts.join('='))
	      : null;
	
	    if (res[key] === undefined) {
	      res[key] = val;
	    } else if (Array.isArray(res[key])) {
	      res[key].push(val);
	    } else {
	      res[key] = [res[key], val];
	    }
	  });
	
	  return res
	}
	
	function stringifyQuery (obj) {
	  var res = obj ? Object.keys(obj).map(function (key) {
	    var val = obj[key];
	
	    if (val === undefined) {
	      return ''
	    }
	
	    if (val === null) {
	      return encode(key)
	    }
	
	    if (Array.isArray(val)) {
	      var result = [];
	      val.forEach(function (val2) {
	        if (val2 === undefined) {
	          return
	        }
	        if (val2 === null) {
	          result.push(encode(key));
	        } else {
	          result.push(encode(key) + '=' + encode(val2));
	        }
	      });
	      return result.join('&')
	    }
	
	    return encode(key) + '=' + encode(val)
	  }).filter(function (x) { return x.length > 0; }).join('&') : null;
	  return res ? ("?" + res) : ''
	}
	
	/*  */
	
	
	var trailingSlashRE = /\/?$/;
	
	function createRoute (
	  record,
	  location,
	  redirectedFrom,
	  router
	) {
	  var stringifyQuery$$1 = router && router.options.stringifyQuery;
	
	  var query = location.query || {};
	  try {
	    query = clone(query);
	  } catch (e) {}
	
	  var route = {
	    name: location.name || (record && record.name),
	    meta: (record && record.meta) || {},
	    path: location.path || '/',
	    hash: location.hash || '',
	    query: query,
	    params: location.params || {},
	    fullPath: getFullPath(location, stringifyQuery$$1),
	    matched: record ? formatMatch(record) : []
	  };
	  if (redirectedFrom) {
	    route.redirectedFrom = getFullPath(redirectedFrom, stringifyQuery$$1);
	  }
	  return Object.freeze(route)
	}
	
	function clone (value) {
	  if (Array.isArray(value)) {
	    return value.map(clone)
	  } else if (value && typeof value === 'object') {
	    var res = {};
	    for (var key in value) {
	      res[key] = clone(value[key]);
	    }
	    return res
	  } else {
	    return value
	  }
	}
	
	// the starting route that represents the initial state
	var START = createRoute(null, {
	  path: '/'
	});
	
	function formatMatch (record) {
	  var res = [];
	  while (record) {
	    res.unshift(record);
	    record = record.parent;
	  }
	  return res
	}
	
	function getFullPath (
	  ref,
	  _stringifyQuery
	) {
	  var path = ref.path;
	  var query = ref.query; if ( query === void 0 ) query = {};
	  var hash = ref.hash; if ( hash === void 0 ) hash = '';
	
	  var stringify = _stringifyQuery || stringifyQuery;
	  return (path || '/') + stringify(query) + hash
	}
	
	function isSameRoute (a, b) {
	  if (b === START) {
	    return a === b
	  } else if (!b) {
	    return false
	  } else if (a.path && b.path) {
	    return (
	      a.path.replace(trailingSlashRE, '') === b.path.replace(trailingSlashRE, '') &&
	      a.hash === b.hash &&
	      isObjectEqual(a.query, b.query)
	    )
	  } else if (a.name && b.name) {
	    return (
	      a.name === b.name &&
	      a.hash === b.hash &&
	      isObjectEqual(a.query, b.query) &&
	      isObjectEqual(a.params, b.params)
	    )
	  } else {
	    return false
	  }
	}
	
	function isObjectEqual (a, b) {
	  if ( a === void 0 ) a = {};
	  if ( b === void 0 ) b = {};
	
	  // handle null value #1566
	  if (!a || !b) { return a === b }
	  var aKeys = Object.keys(a);
	  var bKeys = Object.keys(b);
	  if (aKeys.length !== bKeys.length) {
	    return false
	  }
	  return aKeys.every(function (key) {
	    var aVal = a[key];
	    var bVal = b[key];
	    // check nested equality
	    if (typeof aVal === 'object' && typeof bVal === 'object') {
	      return isObjectEqual(aVal, bVal)
	    }
	    return String(aVal) === String(bVal)
	  })
	}
	
	function isIncludedRoute (current, target) {
	  return (
	    current.path.replace(trailingSlashRE, '/').indexOf(
	      target.path.replace(trailingSlashRE, '/')
	    ) === 0 &&
	    (!target.hash || current.hash === target.hash) &&
	    queryIncludes(current.query, target.query)
	  )
	}
	
	function queryIncludes (current, target) {
	  for (var key in target) {
	    if (!(key in current)) {
	      return false
	    }
	  }
	  return true
	}
	
	/*  */
	
	// work around weird flow bug
	var toTypes = [String, Object];
	var eventTypes = [String, Array];
	
	var Link = {
	  name: 'router-link',
	  props: {
	    to: {
	      type: toTypes,
	      required: true
	    },
	    tag: {
	      type: String,
	      default: 'a'
	    },
	    exact: Boolean,
	    append: Boolean,
	    replace: Boolean,
	    activeClass: String,
	    exactActiveClass: String,
	    event: {
	      type: eventTypes,
	      default: 'click'
	    }
	  },
	  render: function render (h) {
	    var this$1 = this;
	
	    var router = this.$router;
	    var current = this.$route;
	    var ref = router.resolve(this.to, current, this.append);
	    var location = ref.location;
	    var route = ref.route;
	    var href = ref.href;
	
	    var classes = {};
	    var globalActiveClass = router.options.linkActiveClass;
	    var globalExactActiveClass = router.options.linkExactActiveClass;
	    // Support global empty active class
	    var activeClassFallback = globalActiveClass == null
	            ? 'router-link-active'
	            : globalActiveClass;
	    var exactActiveClassFallback = globalExactActiveClass == null
	            ? 'router-link-exact-active'
	            : globalExactActiveClass;
	    var activeClass = this.activeClass == null
	            ? activeClassFallback
	            : this.activeClass;
	    var exactActiveClass = this.exactActiveClass == null
	            ? exactActiveClassFallback
	            : this.exactActiveClass;
	    var compareTarget = location.path
	      ? createRoute(null, location, null, router)
	      : route;
	
	    classes[exactActiveClass] = isSameRoute(current, compareTarget);
	    classes[activeClass] = this.exact
	      ? classes[exactActiveClass]
	      : isIncludedRoute(current, compareTarget);
	
	    var handler = function (e) {
	      if (guardEvent(e)) {
	        if (this$1.replace) {
	          router.replace(location);
	        } else {
	          router.push(location);
	        }
	      }
	    };
	
	    var on = { click: guardEvent };
	    if (Array.isArray(this.event)) {
	      this.event.forEach(function (e) { on[e] = handler; });
	    } else {
	      on[this.event] = handler;
	    }
	
	    var data = {
	      class: classes
	    };
	
	    if (this.tag === 'a') {
	      data.on = on;
	      data.attrs = { href: href };
	    } else {
	      // find the first <a> child and apply listener and href
	      var a = findAnchor(this.$slots.default);
	      if (a) {
	        // in case the <a> is a static node
	        a.isStatic = false;
	        var extend = _Vue.util.extend;
	        var aData = a.data = extend({}, a.data);
	        aData.on = on;
	        var aAttrs = a.data.attrs = extend({}, a.data.attrs);
	        aAttrs.href = href;
	      } else {
	        // doesn't have <a> child, apply listener to self
	        data.on = on;
	      }
	    }
	
	    return h(this.tag, data, this.$slots.default)
	  }
	};
	
	function guardEvent (e) {
	  // don't redirect with control keys
	  if (e.metaKey || e.altKey || e.ctrlKey || e.shiftKey) { return }
	  // don't redirect when preventDefault called
	  if (e.defaultPrevented) { return }
	  // don't redirect on right click
	  if (e.button !== undefined && e.button !== 0) { return }
	  // don't redirect if `target="_blank"`
	  if (e.currentTarget && e.currentTarget.getAttribute) {
	    var target = e.currentTarget.getAttribute('target');
	    if (/\b_blank\b/i.test(target)) { return }
	  }
	  // this may be a Weex event which doesn't have this method
	  if (e.preventDefault) {
	    e.preventDefault();
	  }
	  return true
	}
	
	function findAnchor (children) {
	  if (children) {
	    var child;
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      if (child.tag === 'a') {
	        return child
	      }
	      if (child.children && (child = findAnchor(child.children))) {
	        return child
	      }
	    }
	  }
	}
	
	var _Vue;
	
	function install (Vue) {
	  if (install.installed && _Vue === Vue) { return }
	  install.installed = true;
	
	  _Vue = Vue;
	
	  var isDef = function (v) { return v !== undefined; };
	
	  var registerInstance = function (vm, callVal) {
	    var i = vm.$options._parentVnode;
	    if (isDef(i) && isDef(i = i.data) && isDef(i = i.registerRouteInstance)) {
	      i(vm, callVal);
	    }
	  };
	
	  Vue.mixin({
	    beforeCreate: function beforeCreate () {
	      if (isDef(this.$options.router)) {
	        this._routerRoot = this;
	        this._router = this.$options.router;
	        this._router.init(this);
	        Vue.util.defineReactive(this, '_route', this._router.history.current);
	      } else {
	        this._routerRoot = (this.$parent && this.$parent._routerRoot) || this;
	      }
	      registerInstance(this, this);
	    },
	    destroyed: function destroyed () {
	      registerInstance(this);
	    }
	  });
	
	  Object.defineProperty(Vue.prototype, '$router', {
	    get: function get () { return this._routerRoot._router }
	  });
	
	  Object.defineProperty(Vue.prototype, '$route', {
	    get: function get () { return this._routerRoot._route }
	  });
	
	  Vue.component('router-view', View);
	  Vue.component('router-link', Link);
	
	  var strats = Vue.config.optionMergeStrategies;
	  // use the same hook merging strategy for route hooks
	  strats.beforeRouteEnter = strats.beforeRouteLeave = strats.beforeRouteUpdate = strats.created;
	}
	
	/*  */
	
	var inBrowser = typeof window !== 'undefined';
	
	/*  */
	
	function resolvePath (
	  relative,
	  base,
	  append
	) {
	  var firstChar = relative.charAt(0);
	  if (firstChar === '/') {
	    return relative
	  }
	
	  if (firstChar === '?' || firstChar === '#') {
	    return base + relative
	  }
	
	  var stack = base.split('/');
	
	  // remove trailing segment if:
	  // - not appending
	  // - appending to trailing slash (last segment is empty)
	  if (!append || !stack[stack.length - 1]) {
	    stack.pop();
	  }
	
	  // resolve relative path
	  var segments = relative.replace(/^\//, '').split('/');
	  for (var i = 0; i < segments.length; i++) {
	    var segment = segments[i];
	    if (segment === '..') {
	      stack.pop();
	    } else if (segment !== '.') {
	      stack.push(segment);
	    }
	  }
	
	  // ensure leading slash
	  if (stack[0] !== '') {
	    stack.unshift('');
	  }
	
	  return stack.join('/')
	}
	
	function parsePath (path) {
	  var hash = '';
	  var query = '';
	
	  var hashIndex = path.indexOf('#');
	  if (hashIndex >= 0) {
	    hash = path.slice(hashIndex);
	    path = path.slice(0, hashIndex);
	  }
	
	  var queryIndex = path.indexOf('?');
	  if (queryIndex >= 0) {
	    query = path.slice(queryIndex + 1);
	    path = path.slice(0, queryIndex);
	  }
	
	  return {
	    path: path,
	    query: query,
	    hash: hash
	  }
	}
	
	function cleanPath (path) {
	  return path.replace(/\/\//g, '/')
	}
	
	var isarray = Array.isArray || function (arr) {
	  return Object.prototype.toString.call(arr) == '[object Array]';
	};
	
	/**
	 * Expose `pathToRegexp`.
	 */
	var pathToRegexp_1 = pathToRegexp;
	var parse_1 = parse;
	var compile_1 = compile;
	var tokensToFunction_1 = tokensToFunction;
	var tokensToRegExp_1 = tokensToRegExp;
	
	/**
	 * The main path matching regexp utility.
	 *
	 * @type {RegExp}
	 */
	var PATH_REGEXP = new RegExp([
	  // Match escaped characters that would otherwise appear in future matches.
	  // This allows the user to escape special characters that won't transform.
	  '(\\\\.)',
	  // Match Express-style parameters and un-named parameters with a prefix
	  // and optional suffixes. Matches appear as:
	  //
	  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
	  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
	  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
	  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
	].join('|'), 'g');
	
	/**
	 * Parse a string for the raw tokens.
	 *
	 * @param  {string}  str
	 * @param  {Object=} options
	 * @return {!Array}
	 */
	function parse (str, options) {
	  var tokens = [];
	  var key = 0;
	  var index = 0;
	  var path = '';
	  var defaultDelimiter = options && options.delimiter || '/';
	  var res;
	
	  while ((res = PATH_REGEXP.exec(str)) != null) {
	    var m = res[0];
	    var escaped = res[1];
	    var offset = res.index;
	    path += str.slice(index, offset);
	    index = offset + m.length;
	
	    // Ignore already escaped sequences.
	    if (escaped) {
	      path += escaped[1];
	      continue
	    }
	
	    var next = str[index];
	    var prefix = res[2];
	    var name = res[3];
	    var capture = res[4];
	    var group = res[5];
	    var modifier = res[6];
	    var asterisk = res[7];
	
	    // Push the current path onto the tokens.
	    if (path) {
	      tokens.push(path);
	      path = '';
	    }
	
	    var partial = prefix != null && next != null && next !== prefix;
	    var repeat = modifier === '+' || modifier === '*';
	    var optional = modifier === '?' || modifier === '*';
	    var delimiter = res[2] || defaultDelimiter;
	    var pattern = capture || group;
	
	    tokens.push({
	      name: name || key++,
	      prefix: prefix || '',
	      delimiter: delimiter,
	      optional: optional,
	      repeat: repeat,
	      partial: partial,
	      asterisk: !!asterisk,
	      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
	    });
	  }
	
	  // Match any characters still remaining.
	  if (index < str.length) {
	    path += str.substr(index);
	  }
	
	  // If the path exists, push it onto the end.
	  if (path) {
	    tokens.push(path);
	  }
	
	  return tokens
	}
	
	/**
	 * Compile a string to a template function for the path.
	 *
	 * @param  {string}             str
	 * @param  {Object=}            options
	 * @return {!function(Object=, Object=)}
	 */
	function compile (str, options) {
	  return tokensToFunction(parse(str, options))
	}
	
	/**
	 * Prettier encoding of URI path segments.
	 *
	 * @param  {string}
	 * @return {string}
	 */
	function encodeURIComponentPretty (str) {
	  return encodeURI(str).replace(/[\/?#]/g, function (c) {
	    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
	  })
	}
	
	/**
	 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
	 *
	 * @param  {string}
	 * @return {string}
	 */
	function encodeAsterisk (str) {
	  return encodeURI(str).replace(/[?#]/g, function (c) {
	    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
	  })
	}
	
	/**
	 * Expose a method for transforming tokens into the path function.
	 */
	function tokensToFunction (tokens) {
	  // Compile all the tokens into regexps.
	  var matches = new Array(tokens.length);
	
	  // Compile all the patterns before compilation.
	  for (var i = 0; i < tokens.length; i++) {
	    if (typeof tokens[i] === 'object') {
	      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$');
	    }
	  }
	
	  return function (obj, opts) {
	    var path = '';
	    var data = obj || {};
	    var options = opts || {};
	    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent;
	
	    for (var i = 0; i < tokens.length; i++) {
	      var token = tokens[i];
	
	      if (typeof token === 'string') {
	        path += token;
	
	        continue
	      }
	
	      var value = data[token.name];
	      var segment;
	
	      if (value == null) {
	        if (token.optional) {
	          // Prepend partial segment prefixes.
	          if (token.partial) {
	            path += token.prefix;
	          }
	
	          continue
	        } else {
	          throw new TypeError('Expected "' + token.name + '" to be defined')
	        }
	      }
	
	      if (isarray(value)) {
	        if (!token.repeat) {
	          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
	        }
	
	        if (value.length === 0) {
	          if (token.optional) {
	            continue
	          } else {
	            throw new TypeError('Expected "' + token.name + '" to not be empty')
	          }
	        }
	
	        for (var j = 0; j < value.length; j++) {
	          segment = encode(value[j]);
	
	          if (!matches[i].test(segment)) {
	            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
	          }
	
	          path += (j === 0 ? token.prefix : token.delimiter) + segment;
	        }
	
	        continue
	      }
	
	      segment = token.asterisk ? encodeAsterisk(value) : encode(value);
	
	      if (!matches[i].test(segment)) {
	        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
	      }
	
	      path += token.prefix + segment;
	    }
	
	    return path
	  }
	}
	
	/**
	 * Escape a regular expression string.
	 *
	 * @param  {string} str
	 * @return {string}
	 */
	function escapeString (str) {
	  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
	}
	
	/**
	 * Escape the capturing group by escaping special characters and meaning.
	 *
	 * @param  {string} group
	 * @return {string}
	 */
	function escapeGroup (group) {
	  return group.replace(/([=!:$\/()])/g, '\\$1')
	}
	
	/**
	 * Attach the keys as a property of the regexp.
	 *
	 * @param  {!RegExp} re
	 * @param  {Array}   keys
	 * @return {!RegExp}
	 */
	function attachKeys (re, keys) {
	  re.keys = keys;
	  return re
	}
	
	/**
	 * Get the flags for a regexp from the options.
	 *
	 * @param  {Object} options
	 * @return {string}
	 */
	function flags (options) {
	  return options.sensitive ? '' : 'i'
	}
	
	/**
	 * Pull out keys from a regexp.
	 *
	 * @param  {!RegExp} path
	 * @param  {!Array}  keys
	 * @return {!RegExp}
	 */
	function regexpToRegexp (path, keys) {
	  // Use a negative lookahead to match only capturing groups.
	  var groups = path.source.match(/\((?!\?)/g);
	
	  if (groups) {
	    for (var i = 0; i < groups.length; i++) {
	      keys.push({
	        name: i,
	        prefix: null,
	        delimiter: null,
	        optional: false,
	        repeat: false,
	        partial: false,
	        asterisk: false,
	        pattern: null
	      });
	    }
	  }
	
	  return attachKeys(path, keys)
	}
	
	/**
	 * Transform an array into a regexp.
	 *
	 * @param  {!Array}  path
	 * @param  {Array}   keys
	 * @param  {!Object} options
	 * @return {!RegExp}
	 */
	function arrayToRegexp (path, keys, options) {
	  var parts = [];
	
	  for (var i = 0; i < path.length; i++) {
	    parts.push(pathToRegexp(path[i], keys, options).source);
	  }
	
	  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options));
	
	  return attachKeys(regexp, keys)
	}
	
	/**
	 * Create a path regexp from string input.
	 *
	 * @param  {string}  path
	 * @param  {!Array}  keys
	 * @param  {!Object} options
	 * @return {!RegExp}
	 */
	function stringToRegexp (path, keys, options) {
	  return tokensToRegExp(parse(path, options), keys, options)
	}
	
	/**
	 * Expose a function for taking tokens and returning a RegExp.
	 *
	 * @param  {!Array}          tokens
	 * @param  {(Array|Object)=} keys
	 * @param  {Object=}         options
	 * @return {!RegExp}
	 */
	function tokensToRegExp (tokens, keys, options) {
	  if (!isarray(keys)) {
	    options = /** @type {!Object} */ (keys || options);
	    keys = [];
	  }
	
	  options = options || {};
	
	  var strict = options.strict;
	  var end = options.end !== false;
	  var route = '';
	
	  // Iterate over the tokens and create our regexp string.
	  for (var i = 0; i < tokens.length; i++) {
	    var token = tokens[i];
	
	    if (typeof token === 'string') {
	      route += escapeString(token);
	    } else {
	      var prefix = escapeString(token.prefix);
	      var capture = '(?:' + token.pattern + ')';
	
	      keys.push(token);
	
	      if (token.repeat) {
	        capture += '(?:' + prefix + capture + ')*';
	      }
	
	      if (token.optional) {
	        if (!token.partial) {
	          capture = '(?:' + prefix + '(' + capture + '))?';
	        } else {
	          capture = prefix + '(' + capture + ')?';
	        }
	      } else {
	        capture = prefix + '(' + capture + ')';
	      }
	
	      route += capture;
	    }
	  }
	
	  var delimiter = escapeString(options.delimiter || '/');
	  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;
	
	  // In non-strict mode we allow a slash at the end of match. If the path to
	  // match already ends with a slash, we remove it for consistency. The slash
	  // is valid at the end of a path match, not in the middle. This is important
	  // in non-ending mode, where "/test/" shouldn't match "/test//route".
	  if (!strict) {
	    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?';
	  }
	
	  if (end) {
	    route += '$';
	  } else {
	    // In non-ending mode, we need the capturing groups to match as much as
	    // possible by using a positive lookahead to the end or next path segment.
	    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)';
	  }
	
	  return attachKeys(new RegExp('^' + route, flags(options)), keys)
	}
	
	/**
	 * Normalize the given path string, returning a regular expression.
	 *
	 * An empty array can be passed in for the keys, which will hold the
	 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
	 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
	 *
	 * @param  {(string|RegExp|Array)} path
	 * @param  {(Array|Object)=}       keys
	 * @param  {Object=}               options
	 * @return {!RegExp}
	 */
	function pathToRegexp (path, keys, options) {
	  if (!isarray(keys)) {
	    options = /** @type {!Object} */ (keys || options);
	    keys = [];
	  }
	
	  options = options || {};
	
	  if (path instanceof RegExp) {
	    return regexpToRegexp(path, /** @type {!Array} */ (keys))
	  }
	
	  if (isarray(path)) {
	    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
	  }
	
	  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
	}
	
	pathToRegexp_1.parse = parse_1;
	pathToRegexp_1.compile = compile_1;
	pathToRegexp_1.tokensToFunction = tokensToFunction_1;
	pathToRegexp_1.tokensToRegExp = tokensToRegExp_1;
	
	/*  */
	
	// $flow-disable-line
	var regexpCompileCache = Object.create(null);
	
	function fillParams (
	  path,
	  params,
	  routeMsg
	) {
	  try {
	    var filler =
	      regexpCompileCache[path] ||
	      (regexpCompileCache[path] = pathToRegexp_1.compile(path));
	    return filler(params || {}, { pretty: true })
	  } catch (e) {
	    if (false) {
	      warn(false, ("missing param for " + routeMsg + ": " + (e.message)));
	    }
	    return ''
	  }
	}
	
	/*  */
	
	function createRouteMap (
	  routes,
	  oldPathList,
	  oldPathMap,
	  oldNameMap
	) {
	  // the path list is used to control path matching priority
	  var pathList = oldPathList || [];
	  // $flow-disable-line
	  var pathMap = oldPathMap || Object.create(null);
	  // $flow-disable-line
	  var nameMap = oldNameMap || Object.create(null);
	
	  routes.forEach(function (route) {
	    addRouteRecord(pathList, pathMap, nameMap, route);
	  });
	
	  // ensure wildcard routes are always at the end
	  for (var i = 0, l = pathList.length; i < l; i++) {
	    if (pathList[i] === '*') {
	      pathList.push(pathList.splice(i, 1)[0]);
	      l--;
	      i--;
	    }
	  }
	
	  return {
	    pathList: pathList,
	    pathMap: pathMap,
	    nameMap: nameMap
	  }
	}
	
	function addRouteRecord (
	  pathList,
	  pathMap,
	  nameMap,
	  route,
	  parent,
	  matchAs
	) {
	  var path = route.path;
	  var name = route.name;
	  if (false) {
	    assert(path != null, "\"path\" is required in a route configuration.");
	    assert(
	      typeof route.component !== 'string',
	      "route config \"component\" for path: " + (String(path || name)) + " cannot be a " +
	      "string id. Use an actual component instead."
	    );
	  }
	
	  var pathToRegexpOptions = route.pathToRegexpOptions || {};
	  var normalizedPath = normalizePath(
	    path,
	    parent,
	    pathToRegexpOptions.strict
	  );
	
	  if (typeof route.caseSensitive === 'boolean') {
	    pathToRegexpOptions.sensitive = route.caseSensitive;
	  }
	
	  var record = {
	    path: normalizedPath,
	    regex: compileRouteRegex(normalizedPath, pathToRegexpOptions),
	    components: route.components || { default: route.component },
	    instances: {},
	    name: name,
	    parent: parent,
	    matchAs: matchAs,
	    redirect: route.redirect,
	    beforeEnter: route.beforeEnter,
	    meta: route.meta || {},
	    props: route.props == null
	      ? {}
	      : route.components
	        ? route.props
	        : { default: route.props }
	  };
	
	  if (route.children) {
	    // Warn if route is named, does not redirect and has a default child route.
	    // If users navigate to this route by name, the default child will
	    // not be rendered (GH Issue #629)
	    if (false) {
	      if (route.name && !route.redirect && route.children.some(function (child) { return /^\/?$/.test(child.path); })) {
	        warn(
	          false,
	          "Named Route '" + (route.name) + "' has a default child route. " +
	          "When navigating to this named route (:to=\"{name: '" + (route.name) + "'\"), " +
	          "the default child route will not be rendered. Remove the name from " +
	          "this route and use the name of the default child route for named " +
	          "links instead."
	        );
	      }
	    }
	    route.children.forEach(function (child) {
	      var childMatchAs = matchAs
	        ? cleanPath((matchAs + "/" + (child.path)))
	        : undefined;
	      addRouteRecord(pathList, pathMap, nameMap, child, record, childMatchAs);
	    });
	  }
	
	  if (route.alias !== undefined) {
	    var aliases = Array.isArray(route.alias)
	      ? route.alias
	      : [route.alias];
	
	    aliases.forEach(function (alias) {
	      var aliasRoute = {
	        path: alias,
	        children: route.children
	      };
	      addRouteRecord(
	        pathList,
	        pathMap,
	        nameMap,
	        aliasRoute,
	        parent,
	        record.path || '/' // matchAs
	      );
	    });
	  }
	
	  if (!pathMap[record.path]) {
	    pathList.push(record.path);
	    pathMap[record.path] = record;
	  }
	
	  if (name) {
	    if (!nameMap[name]) {
	      nameMap[name] = record;
	    } else if (false) {
	      warn(
	        false,
	        "Duplicate named routes definition: " +
	        "{ name: \"" + name + "\", path: \"" + (record.path) + "\" }"
	      );
	    }
	  }
	}
	
	function compileRouteRegex (path, pathToRegexpOptions) {
	  var regex = pathToRegexp_1(path, [], pathToRegexpOptions);
	  if (false) {
	    var keys = Object.create(null);
	    regex.keys.forEach(function (key) {
	      warn(!keys[key.name], ("Duplicate param keys in route with path: \"" + path + "\""));
	      keys[key.name] = true;
	    });
	  }
	  return regex
	}
	
	function normalizePath (path, parent, strict) {
	  if (!strict) { path = path.replace(/\/$/, ''); }
	  if (path[0] === '/') { return path }
	  if (parent == null) { return path }
	  return cleanPath(((parent.path) + "/" + path))
	}
	
	/*  */
	
	
	function normalizeLocation (
	  raw,
	  current,
	  append,
	  router
	) {
	  var next = typeof raw === 'string' ? { path: raw } : raw;
	  // named target
	  if (next.name || next._normalized) {
	    return next
	  }
	
	  // relative params
	  if (!next.path && next.params && current) {
	    next = assign({}, next);
	    next._normalized = true;
	    var params = assign(assign({}, current.params), next.params);
	    if (current.name) {
	      next.name = current.name;
	      next.params = params;
	    } else if (current.matched.length) {
	      var rawPath = current.matched[current.matched.length - 1].path;
	      next.path = fillParams(rawPath, params, ("path " + (current.path)));
	    } else if (false) {
	      warn(false, "relative params navigation requires a current route.");
	    }
	    return next
	  }
	
	  var parsedPath = parsePath(next.path || '');
	  var basePath = (current && current.path) || '/';
	  var path = parsedPath.path
	    ? resolvePath(parsedPath.path, basePath, append || next.append)
	    : basePath;
	
	  var query = resolveQuery(
	    parsedPath.query,
	    next.query,
	    router && router.options.parseQuery
	  );
	
	  var hash = next.hash || parsedPath.hash;
	  if (hash && hash.charAt(0) !== '#') {
	    hash = "#" + hash;
	  }
	
	  return {
	    _normalized: true,
	    path: path,
	    query: query,
	    hash: hash
	  }
	}
	
	function assign (a, b) {
	  for (var key in b) {
	    a[key] = b[key];
	  }
	  return a
	}
	
	/*  */
	
	
	function createMatcher (
	  routes,
	  router
	) {
	  var ref = createRouteMap(routes);
	  var pathList = ref.pathList;
	  var pathMap = ref.pathMap;
	  var nameMap = ref.nameMap;
	
	  function addRoutes (routes) {
	    createRouteMap(routes, pathList, pathMap, nameMap);
	  }
	
	  function match (
	    raw,
	    currentRoute,
	    redirectedFrom
	  ) {
	    var location = normalizeLocation(raw, currentRoute, false, router);
	    var name = location.name;
	
	    if (name) {
	      var record = nameMap[name];
	      if (false) {
	        warn(record, ("Route with name '" + name + "' does not exist"));
	      }
	      if (!record) { return _createRoute(null, location) }
	      var paramNames = record.regex.keys
	        .filter(function (key) { return !key.optional; })
	        .map(function (key) { return key.name; });
	
	      if (typeof location.params !== 'object') {
	        location.params = {};
	      }
	
	      if (currentRoute && typeof currentRoute.params === 'object') {
	        for (var key in currentRoute.params) {
	          if (!(key in location.params) && paramNames.indexOf(key) > -1) {
	            location.params[key] = currentRoute.params[key];
	          }
	        }
	      }
	
	      if (record) {
	        location.path = fillParams(record.path, location.params, ("named route \"" + name + "\""));
	        return _createRoute(record, location, redirectedFrom)
	      }
	    } else if (location.path) {
	      location.params = {};
	      for (var i = 0; i < pathList.length; i++) {
	        var path = pathList[i];
	        var record$1 = pathMap[path];
	        if (matchRoute(record$1.regex, location.path, location.params)) {
	          return _createRoute(record$1, location, redirectedFrom)
	        }
	      }
	    }
	    // no match
	    return _createRoute(null, location)
	  }
	
	  function redirect (
	    record,
	    location
	  ) {
	    var originalRedirect = record.redirect;
	    var redirect = typeof originalRedirect === 'function'
	        ? originalRedirect(createRoute(record, location, null, router))
	        : originalRedirect;
	
	    if (typeof redirect === 'string') {
	      redirect = { path: redirect };
	    }
	
	    if (!redirect || typeof redirect !== 'object') {
	      if (false) {
	        warn(
	          false, ("invalid redirect option: " + (JSON.stringify(redirect)))
	        );
	      }
	      return _createRoute(null, location)
	    }
	
	    var re = redirect;
	    var name = re.name;
	    var path = re.path;
	    var query = location.query;
	    var hash = location.hash;
	    var params = location.params;
	    query = re.hasOwnProperty('query') ? re.query : query;
	    hash = re.hasOwnProperty('hash') ? re.hash : hash;
	    params = re.hasOwnProperty('params') ? re.params : params;
	
	    if (name) {
	      // resolved named direct
	      var targetRecord = nameMap[name];
	      if (false) {
	        assert(targetRecord, ("redirect failed: named route \"" + name + "\" not found."));
	      }
	      return match({
	        _normalized: true,
	        name: name,
	        query: query,
	        hash: hash,
	        params: params
	      }, undefined, location)
	    } else if (path) {
	      // 1. resolve relative redirect
	      var rawPath = resolveRecordPath(path, record);
	      // 2. resolve params
	      var resolvedPath = fillParams(rawPath, params, ("redirect route with path \"" + rawPath + "\""));
	      // 3. rematch with existing query and hash
	      return match({
	        _normalized: true,
	        path: resolvedPath,
	        query: query,
	        hash: hash
	      }, undefined, location)
	    } else {
	      if (false) {
	        warn(false, ("invalid redirect option: " + (JSON.stringify(redirect))));
	      }
	      return _createRoute(null, location)
	    }
	  }
	
	  function alias (
	    record,
	    location,
	    matchAs
	  ) {
	    var aliasedPath = fillParams(matchAs, location.params, ("aliased route with path \"" + matchAs + "\""));
	    var aliasedMatch = match({
	      _normalized: true,
	      path: aliasedPath
	    });
	    if (aliasedMatch) {
	      var matched = aliasedMatch.matched;
	      var aliasedRecord = matched[matched.length - 1];
	      location.params = aliasedMatch.params;
	      return _createRoute(aliasedRecord, location)
	    }
	    return _createRoute(null, location)
	  }
	
	  function _createRoute (
	    record,
	    location,
	    redirectedFrom
	  ) {
	    if (record && record.redirect) {
	      return redirect(record, redirectedFrom || location)
	    }
	    if (record && record.matchAs) {
	      return alias(record, location, record.matchAs)
	    }
	    return createRoute(record, location, redirectedFrom, router)
	  }
	
	  return {
	    match: match,
	    addRoutes: addRoutes
	  }
	}
	
	function matchRoute (
	  regex,
	  path,
	  params
	) {
	  var m = path.match(regex);
	
	  if (!m) {
	    return false
	  } else if (!params) {
	    return true
	  }
	
	  for (var i = 1, len = m.length; i < len; ++i) {
	    var key = regex.keys[i - 1];
	    var val = typeof m[i] === 'string' ? decodeURIComponent(m[i]) : m[i];
	    if (key) {
	      params[key.name] = val;
	    }
	  }
	
	  return true
	}
	
	function resolveRecordPath (path, record) {
	  return resolvePath(path, record.parent ? record.parent.path : '/', true)
	}
	
	/*  */
	
	
	var positionStore = Object.create(null);
	
	function setupScroll () {
	  // Fix for #1585 for Firefox
	  window.history.replaceState({ key: getStateKey() }, '');
	  window.addEventListener('popstate', function (e) {
	    saveScrollPosition();
	    if (e.state && e.state.key) {
	      setStateKey(e.state.key);
	    }
	  });
	}
	
	function handleScroll (
	  router,
	  to,
	  from,
	  isPop
	) {
	  if (!router.app) {
	    return
	  }
	
	  var behavior = router.options.scrollBehavior;
	  if (!behavior) {
	    return
	  }
	
	  if (false) {
	    assert(typeof behavior === 'function', "scrollBehavior must be a function");
	  }
	
	  // wait until re-render finishes before scrolling
	  router.app.$nextTick(function () {
	    var position = getScrollPosition();
	    var shouldScroll = behavior(to, from, isPop ? position : null);
	
	    if (!shouldScroll) {
	      return
	    }
	
	    if (typeof shouldScroll.then === 'function') {
	      shouldScroll.then(function (shouldScroll) {
	        scrollToPosition((shouldScroll), position);
	      }).catch(function (err) {
	        if (false) {
	          assert(false, err.toString());
	        }
	      });
	    } else {
	      scrollToPosition(shouldScroll, position);
	    }
	  });
	}
	
	function saveScrollPosition () {
	  var key = getStateKey();
	  if (key) {
	    positionStore[key] = {
	      x: window.pageXOffset,
	      y: window.pageYOffset
	    };
	  }
	}
	
	function getScrollPosition () {
	  var key = getStateKey();
	  if (key) {
	    return positionStore[key]
	  }
	}
	
	function getElementPosition (el, offset) {
	  var docEl = document.documentElement;
	  var docRect = docEl.getBoundingClientRect();
	  var elRect = el.getBoundingClientRect();
	  return {
	    x: elRect.left - docRect.left - offset.x,
	    y: elRect.top - docRect.top - offset.y
	  }
	}
	
	function isValidPosition (obj) {
	  return isNumber(obj.x) || isNumber(obj.y)
	}
	
	function normalizePosition (obj) {
	  return {
	    x: isNumber(obj.x) ? obj.x : window.pageXOffset,
	    y: isNumber(obj.y) ? obj.y : window.pageYOffset
	  }
	}
	
	function normalizeOffset (obj) {
	  return {
	    x: isNumber(obj.x) ? obj.x : 0,
	    y: isNumber(obj.y) ? obj.y : 0
	  }
	}
	
	function isNumber (v) {
	  return typeof v === 'number'
	}
	
	function scrollToPosition (shouldScroll, position) {
	  var isObject = typeof shouldScroll === 'object';
	  if (isObject && typeof shouldScroll.selector === 'string') {
	    var el = document.querySelector(shouldScroll.selector);
	    if (el) {
	      var offset = shouldScroll.offset && typeof shouldScroll.offset === 'object' ? shouldScroll.offset : {};
	      offset = normalizeOffset(offset);
	      position = getElementPosition(el, offset);
	    } else if (isValidPosition(shouldScroll)) {
	      position = normalizePosition(shouldScroll);
	    }
	  } else if (isObject && isValidPosition(shouldScroll)) {
	    position = normalizePosition(shouldScroll);
	  }
	
	  if (position) {
	    window.scrollTo(position.x, position.y);
	  }
	}
	
	/*  */
	
	var supportsPushState = inBrowser && (function () {
	  var ua = window.navigator.userAgent;
	
	  if (
	    (ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) &&
	    ua.indexOf('Mobile Safari') !== -1 &&
	    ua.indexOf('Chrome') === -1 &&
	    ua.indexOf('Windows Phone') === -1
	  ) {
	    return false
	  }
	
	  return window.history && 'pushState' in window.history
	})();
	
	// use User Timing api (if present) for more accurate key precision
	var Time = inBrowser && window.performance && window.performance.now
	  ? window.performance
	  : Date;
	
	var _key = genKey();
	
	function genKey () {
	  return Time.now().toFixed(3)
	}
	
	function getStateKey () {
	  return _key
	}
	
	function setStateKey (key) {
	  _key = key;
	}
	
	function pushState (url, replace) {
	  saveScrollPosition();
	  // try...catch the pushState call to get around Safari
	  // DOM Exception 18 where it limits to 100 pushState calls
	  var history = window.history;
	  try {
	    if (replace) {
	      history.replaceState({ key: _key }, '', url);
	    } else {
	      _key = genKey();
	      history.pushState({ key: _key }, '', url);
	    }
	  } catch (e) {
	    window.location[replace ? 'replace' : 'assign'](url);
	  }
	}
	
	function replaceState (url) {
	  pushState(url, true);
	}
	
	/*  */
	
	function runQueue (queue, fn, cb) {
	  var step = function (index) {
	    if (index >= queue.length) {
	      cb();
	    } else {
	      if (queue[index]) {
	        fn(queue[index], function () {
	          step(index + 1);
	        });
	      } else {
	        step(index + 1);
	      }
	    }
	  };
	  step(0);
	}
	
	/*  */
	
	function resolveAsyncComponents (matched) {
	  return function (to, from, next) {
	    var hasAsync = false;
	    var pending = 0;
	    var error = null;
	
	    flatMapComponents(matched, function (def, _, match, key) {
	      // if it's a function and doesn't have cid attached,
	      // assume it's an async component resolve function.
	      // we are not using Vue's default async resolving mechanism because
	      // we want to halt the navigation until the incoming component has been
	      // resolved.
	      if (typeof def === 'function' && def.cid === undefined) {
	        hasAsync = true;
	        pending++;
	
	        var resolve = once(function (resolvedDef) {
	          if (isESModule(resolvedDef)) {
	            resolvedDef = resolvedDef.default;
	          }
	          // save resolved on async factory in case it's used elsewhere
	          def.resolved = typeof resolvedDef === 'function'
	            ? resolvedDef
	            : _Vue.extend(resolvedDef);
	          match.components[key] = resolvedDef;
	          pending--;
	          if (pending <= 0) {
	            next();
	          }
	        });
	
	        var reject = once(function (reason) {
	          var msg = "Failed to resolve async component " + key + ": " + reason;
	          ("production") !== 'production' && warn(false, msg);
	          if (!error) {
	            error = isError(reason)
	              ? reason
	              : new Error(msg);
	            next(error);
	          }
	        });
	
	        var res;
	        try {
	          res = def(resolve, reject);
	        } catch (e) {
	          reject(e);
	        }
	        if (res) {
	          if (typeof res.then === 'function') {
	            res.then(resolve, reject);
	          } else {
	            // new syntax in Vue 2.3
	            var comp = res.component;
	            if (comp && typeof comp.then === 'function') {
	              comp.then(resolve, reject);
	            }
	          }
	        }
	      }
	    });
	
	    if (!hasAsync) { next(); }
	  }
	}
	
	function flatMapComponents (
	  matched,
	  fn
	) {
	  return flatten(matched.map(function (m) {
	    return Object.keys(m.components).map(function (key) { return fn(
	      m.components[key],
	      m.instances[key],
	      m, key
	    ); })
	  }))
	}
	
	function flatten (arr) {
	  return Array.prototype.concat.apply([], arr)
	}
	
	var hasSymbol =
	  typeof Symbol === 'function' &&
	  typeof Symbol.toStringTag === 'symbol';
	
	function isESModule (obj) {
	  return obj.__esModule || (hasSymbol && obj[Symbol.toStringTag] === 'Module')
	}
	
	// in Webpack 2, require.ensure now also returns a Promise
	// so the resolve/reject functions may get called an extra time
	// if the user uses an arrow function shorthand that happens to
	// return that Promise.
	function once (fn) {
	  var called = false;
	  return function () {
	    var args = [], len = arguments.length;
	    while ( len-- ) args[ len ] = arguments[ len ];
	
	    if (called) { return }
	    called = true;
	    return fn.apply(this, args)
	  }
	}
	
	/*  */
	
	var History = function History (router, base) {
	  this.router = router;
	  this.base = normalizeBase(base);
	  // start with a route object that stands for "nowhere"
	  this.current = START;
	  this.pending = null;
	  this.ready = false;
	  this.readyCbs = [];
	  this.readyErrorCbs = [];
	  this.errorCbs = [];
	};
	
	History.prototype.listen = function listen (cb) {
	  this.cb = cb;
	};
	
	History.prototype.onReady = function onReady (cb, errorCb) {
	  if (this.ready) {
	    cb();
	  } else {
	    this.readyCbs.push(cb);
	    if (errorCb) {
	      this.readyErrorCbs.push(errorCb);
	    }
	  }
	};
	
	History.prototype.onError = function onError (errorCb) {
	  this.errorCbs.push(errorCb);
	};
	
	History.prototype.transitionTo = function transitionTo (location, onComplete, onAbort) {
	    var this$1 = this;
	
	  var route = this.router.match(location, this.current);
	  this.confirmTransition(route, function () {
	    this$1.updateRoute(route);
	    onComplete && onComplete(route);
	    this$1.ensureURL();
	
	    // fire ready cbs once
	    if (!this$1.ready) {
	      this$1.ready = true;
	      this$1.readyCbs.forEach(function (cb) { cb(route); });
	    }
	  }, function (err) {
	    if (onAbort) {
	      onAbort(err);
	    }
	    if (err && !this$1.ready) {
	      this$1.ready = true;
	      this$1.readyErrorCbs.forEach(function (cb) { cb(err); });
	    }
	  });
	};
	
	History.prototype.confirmTransition = function confirmTransition (route, onComplete, onAbort) {
	    var this$1 = this;
	
	  var current = this.current;
	  var abort = function (err) {
	    if (isError(err)) {
	      if (this$1.errorCbs.length) {
	        this$1.errorCbs.forEach(function (cb) { cb(err); });
	      } else {
	        warn(false, 'uncaught error during route navigation:');
	        console.error(err);
	      }
	    }
	    onAbort && onAbort(err);
	  };
	  if (
	    isSameRoute(route, current) &&
	    // in the case the route map has been dynamically appended to
	    route.matched.length === current.matched.length
	  ) {
	    this.ensureURL();
	    return abort()
	  }
	
	  var ref = resolveQueue(this.current.matched, route.matched);
	    var updated = ref.updated;
	    var deactivated = ref.deactivated;
	    var activated = ref.activated;
	
	  var queue = [].concat(
	    // in-component leave guards
	    extractLeaveGuards(deactivated),
	    // global before hooks
	    this.router.beforeHooks,
	    // in-component update hooks
	    extractUpdateHooks(updated),
	    // in-config enter guards
	    activated.map(function (m) { return m.beforeEnter; }),
	    // async components
	    resolveAsyncComponents(activated)
	  );
	
	  this.pending = route;
	  var iterator = function (hook, next) {
	    if (this$1.pending !== route) {
	      return abort()
	    }
	    try {
	      hook(route, current, function (to) {
	        if (to === false || isError(to)) {
	          // next(false) -> abort navigation, ensure current URL
	          this$1.ensureURL(true);
	          abort(to);
	        } else if (
	          typeof to === 'string' ||
	          (typeof to === 'object' && (
	            typeof to.path === 'string' ||
	            typeof to.name === 'string'
	          ))
	        ) {
	          // next('/') or next({ path: '/' }) -> redirect
	          abort();
	          if (typeof to === 'object' && to.replace) {
	            this$1.replace(to);
	          } else {
	            this$1.push(to);
	          }
	        } else {
	          // confirm transition and pass on the value
	          next(to);
	        }
	      });
	    } catch (e) {
	      abort(e);
	    }
	  };
	
	  runQueue(queue, iterator, function () {
	    var postEnterCbs = [];
	    var isValid = function () { return this$1.current === route; };
	    // wait until async components are resolved before
	    // extracting in-component enter guards
	    var enterGuards = extractEnterGuards(activated, postEnterCbs, isValid);
	    var queue = enterGuards.concat(this$1.router.resolveHooks);
	    runQueue(queue, iterator, function () {
	      if (this$1.pending !== route) {
	        return abort()
	      }
	      this$1.pending = null;
	      onComplete(route);
	      if (this$1.router.app) {
	        this$1.router.app.$nextTick(function () {
	          postEnterCbs.forEach(function (cb) { cb(); });
	        });
	      }
	    });
	  });
	};
	
	History.prototype.updateRoute = function updateRoute (route) {
	  var prev = this.current;
	  this.current = route;
	  this.cb && this.cb(route);
	  this.router.afterHooks.forEach(function (hook) {
	    hook && hook(route, prev);
	  });
	};
	
	function normalizeBase (base) {
	  if (!base) {
	    if (inBrowser) {
	      // respect <base> tag
	      var baseEl = document.querySelector('base');
	      base = (baseEl && baseEl.getAttribute('href')) || '/';
	      // strip full URL origin
	      base = base.replace(/^https?:\/\/[^\/]+/, '');
	    } else {
	      base = '/';
	    }
	  }
	  // make sure there's the starting slash
	  if (base.charAt(0) !== '/') {
	    base = '/' + base;
	  }
	  // remove trailing slash
	  return base.replace(/\/$/, '')
	}
	
	function resolveQueue (
	  current,
	  next
	) {
	  var i;
	  var max = Math.max(current.length, next.length);
	  for (i = 0; i < max; i++) {
	    if (current[i] !== next[i]) {
	      break
	    }
	  }
	  return {
	    updated: next.slice(0, i),
	    activated: next.slice(i),
	    deactivated: current.slice(i)
	  }
	}
	
	function extractGuards (
	  records,
	  name,
	  bind,
	  reverse
	) {
	  var guards = flatMapComponents(records, function (def, instance, match, key) {
	    var guard = extractGuard(def, name);
	    if (guard) {
	      return Array.isArray(guard)
	        ? guard.map(function (guard) { return bind(guard, instance, match, key); })
	        : bind(guard, instance, match, key)
	    }
	  });
	  return flatten(reverse ? guards.reverse() : guards)
	}
	
	function extractGuard (
	  def,
	  key
	) {
	  if (typeof def !== 'function') {
	    // extend now so that global mixins are applied.
	    def = _Vue.extend(def);
	  }
	  return def.options[key]
	}
	
	function extractLeaveGuards (deactivated) {
	  return extractGuards(deactivated, 'beforeRouteLeave', bindGuard, true)
	}
	
	function extractUpdateHooks (updated) {
	  return extractGuards(updated, 'beforeRouteUpdate', bindGuard)
	}
	
	function bindGuard (guard, instance) {
	  if (instance) {
	    return function boundRouteGuard () {
	      return guard.apply(instance, arguments)
	    }
	  }
	}
	
	function extractEnterGuards (
	  activated,
	  cbs,
	  isValid
	) {
	  return extractGuards(activated, 'beforeRouteEnter', function (guard, _, match, key) {
	    return bindEnterGuard(guard, match, key, cbs, isValid)
	  })
	}
	
	function bindEnterGuard (
	  guard,
	  match,
	  key,
	  cbs,
	  isValid
	) {
	  return function routeEnterGuard (to, from, next) {
	    return guard(to, from, function (cb) {
	      next(cb);
	      if (typeof cb === 'function') {
	        cbs.push(function () {
	          // #750
	          // if a router-view is wrapped with an out-in transition,
	          // the instance may not have been registered at this time.
	          // we will need to poll for registration until current route
	          // is no longer valid.
	          poll(cb, match.instances, key, isValid);
	        });
	      }
	    })
	  }
	}
	
	function poll (
	  cb, // somehow flow cannot infer this is a function
	  instances,
	  key,
	  isValid
	) {
	  if (instances[key]) {
	    cb(instances[key]);
	  } else if (isValid()) {
	    setTimeout(function () {
	      poll(cb, instances, key, isValid);
	    }, 16);
	  }
	}
	
	/*  */
	
	
	var HTML5History = (function (History$$1) {
	  function HTML5History (router, base) {
	    var this$1 = this;
	
	    History$$1.call(this, router, base);
	
	    var expectScroll = router.options.scrollBehavior;
	
	    if (expectScroll) {
	      setupScroll();
	    }
	
	    var initLocation = getLocation(this.base);
	    window.addEventListener('popstate', function (e) {
	      var current = this$1.current;
	
	      // Avoiding first `popstate` event dispatched in some browsers but first
	      // history route not updated since async guard at the same time.
	      var location = getLocation(this$1.base);
	      if (this$1.current === START && location === initLocation) {
	        return
	      }
	
	      this$1.transitionTo(location, function (route) {
	        if (expectScroll) {
	          handleScroll(router, route, current, true);
	        }
	      });
	    });
	  }
	
	  if ( History$$1 ) HTML5History.__proto__ = History$$1;
	  HTML5History.prototype = Object.create( History$$1 && History$$1.prototype );
	  HTML5History.prototype.constructor = HTML5History;
	
	  HTML5History.prototype.go = function go (n) {
	    window.history.go(n);
	  };
	
	  HTML5History.prototype.push = function push (location, onComplete, onAbort) {
	    var this$1 = this;
	
	    var ref = this;
	    var fromRoute = ref.current;
	    this.transitionTo(location, function (route) {
	      pushState(cleanPath(this$1.base + route.fullPath));
	      handleScroll(this$1.router, route, fromRoute, false);
	      onComplete && onComplete(route);
	    }, onAbort);
	  };
	
	  HTML5History.prototype.replace = function replace (location, onComplete, onAbort) {
	    var this$1 = this;
	
	    var ref = this;
	    var fromRoute = ref.current;
	    this.transitionTo(location, function (route) {
	      replaceState(cleanPath(this$1.base + route.fullPath));
	      handleScroll(this$1.router, route, fromRoute, false);
	      onComplete && onComplete(route);
	    }, onAbort);
	  };
	
	  HTML5History.prototype.ensureURL = function ensureURL (push) {
	    if (getLocation(this.base) !== this.current.fullPath) {
	      var current = cleanPath(this.base + this.current.fullPath);
	      push ? pushState(current) : replaceState(current);
	    }
	  };
	
	  HTML5History.prototype.getCurrentLocation = function getCurrentLocation () {
	    return getLocation(this.base)
	  };
	
	  return HTML5History;
	}(History));
	
	function getLocation (base) {
	  var path = window.location.pathname;
	  if (base && path.indexOf(base) === 0) {
	    path = path.slice(base.length);
	  }
	  return (path || '/') + window.location.search + window.location.hash
	}
	
	/*  */
	
	
	var HashHistory = (function (History$$1) {
	  function HashHistory (router, base, fallback) {
	    History$$1.call(this, router, base);
	    // check history fallback deeplinking
	    if (fallback && checkFallback(this.base)) {
	      return
	    }
	    ensureSlash();
	  }
	
	  if ( History$$1 ) HashHistory.__proto__ = History$$1;
	  HashHistory.prototype = Object.create( History$$1 && History$$1.prototype );
	  HashHistory.prototype.constructor = HashHistory;
	
	  // this is delayed until the app mounts
	  // to avoid the hashchange listener being fired too early
	  HashHistory.prototype.setupListeners = function setupListeners () {
	    var this$1 = this;
	
	    var router = this.router;
	    var expectScroll = router.options.scrollBehavior;
	    var supportsScroll = supportsPushState && expectScroll;
	
	    if (supportsScroll) {
	      setupScroll();
	    }
	
	    window.addEventListener(supportsPushState ? 'popstate' : 'hashchange', function () {
	      var current = this$1.current;
	      if (!ensureSlash()) {
	        return
	      }
	      this$1.transitionTo(getHash(), function (route) {
	        if (supportsScroll) {
	          handleScroll(this$1.router, route, current, true);
	        }
	        if (!supportsPushState) {
	          replaceHash(route.fullPath);
	        }
	      });
	    });
	  };
	
	  HashHistory.prototype.push = function push (location, onComplete, onAbort) {
	    var this$1 = this;
	
	    var ref = this;
	    var fromRoute = ref.current;
	    this.transitionTo(location, function (route) {
	      pushHash(route.fullPath);
	      handleScroll(this$1.router, route, fromRoute, false);
	      onComplete && onComplete(route);
	    }, onAbort);
	  };
	
	  HashHistory.prototype.replace = function replace (location, onComplete, onAbort) {
	    var this$1 = this;
	
	    var ref = this;
	    var fromRoute = ref.current;
	    this.transitionTo(location, function (route) {
	      replaceHash(route.fullPath);
	      handleScroll(this$1.router, route, fromRoute, false);
	      onComplete && onComplete(route);
	    }, onAbort);
	  };
	
	  HashHistory.prototype.go = function go (n) {
	    window.history.go(n);
	  };
	
	  HashHistory.prototype.ensureURL = function ensureURL (push) {
	    var current = this.current.fullPath;
	    if (getHash() !== current) {
	      push ? pushHash(current) : replaceHash(current);
	    }
	  };
	
	  HashHistory.prototype.getCurrentLocation = function getCurrentLocation () {
	    return getHash()
	  };
	
	  return HashHistory;
	}(History));
	
	function checkFallback (base) {
	  var location = getLocation(base);
	  if (!/^\/#/.test(location)) {
	    window.location.replace(
	      cleanPath(base + '/#' + location)
	    );
	    return true
	  }
	}
	
	function ensureSlash () {
	  var path = getHash();
	  if (path.charAt(0) === '/') {
	    return true
	  }
	  replaceHash('/' + path);
	  return false
	}
	
	function getHash () {
	  // We can't use window.location.hash here because it's not
	  // consistent across browsers - Firefox will pre-decode it!
	  var href = window.location.href;
	  var index = href.indexOf('#');
	  return index === -1 ? '' : href.slice(index + 1)
	}
	
	function getUrl (path) {
	  var href = window.location.href;
	  var i = href.indexOf('#');
	  var base = i >= 0 ? href.slice(0, i) : href;
	  return (base + "#" + path)
	}
	
	function pushHash (path) {
	  if (supportsPushState) {
	    pushState(getUrl(path));
	  } else {
	    window.location.hash = path;
	  }
	}
	
	function replaceHash (path) {
	  if (supportsPushState) {
	    replaceState(getUrl(path));
	  } else {
	    window.location.replace(getUrl(path));
	  }
	}
	
	/*  */
	
	
	var AbstractHistory = (function (History$$1) {
	  function AbstractHistory (router, base) {
	    History$$1.call(this, router, base);
	    this.stack = [];
	    this.index = -1;
	  }
	
	  if ( History$$1 ) AbstractHistory.__proto__ = History$$1;
	  AbstractHistory.prototype = Object.create( History$$1 && History$$1.prototype );
	  AbstractHistory.prototype.constructor = AbstractHistory;
	
	  AbstractHistory.prototype.push = function push (location, onComplete, onAbort) {
	    var this$1 = this;
	
	    this.transitionTo(location, function (route) {
	      this$1.stack = this$1.stack.slice(0, this$1.index + 1).concat(route);
	      this$1.index++;
	      onComplete && onComplete(route);
	    }, onAbort);
	  };
	
	  AbstractHistory.prototype.replace = function replace (location, onComplete, onAbort) {
	    var this$1 = this;
	
	    this.transitionTo(location, function (route) {
	      this$1.stack = this$1.stack.slice(0, this$1.index).concat(route);
	      onComplete && onComplete(route);
	    }, onAbort);
	  };
	
	  AbstractHistory.prototype.go = function go (n) {
	    var this$1 = this;
	
	    var targetIndex = this.index + n;
	    if (targetIndex < 0 || targetIndex >= this.stack.length) {
	      return
	    }
	    var route = this.stack[targetIndex];
	    this.confirmTransition(route, function () {
	      this$1.index = targetIndex;
	      this$1.updateRoute(route);
	    });
	  };
	
	  AbstractHistory.prototype.getCurrentLocation = function getCurrentLocation () {
	    var current = this.stack[this.stack.length - 1];
	    return current ? current.fullPath : '/'
	  };
	
	  AbstractHistory.prototype.ensureURL = function ensureURL () {
	    // noop
	  };
	
	  return AbstractHistory;
	}(History));
	
	/*  */
	
	var VueRouter = function VueRouter (options) {
	  if ( options === void 0 ) options = {};
	
	  this.app = null;
	  this.apps = [];
	  this.options = options;
	  this.beforeHooks = [];
	  this.resolveHooks = [];
	  this.afterHooks = [];
	  this.matcher = createMatcher(options.routes || [], this);
	
	  var mode = options.mode || 'hash';
	  this.fallback = mode === 'history' && !supportsPushState && options.fallback !== false;
	  if (this.fallback) {
	    mode = 'hash';
	  }
	  if (!inBrowser) {
	    mode = 'abstract';
	  }
	  this.mode = mode;
	
	  switch (mode) {
	    case 'history':
	      this.history = new HTML5History(this, options.base);
	      break
	    case 'hash':
	      this.history = new HashHistory(this, options.base, this.fallback);
	      break
	    case 'abstract':
	      this.history = new AbstractHistory(this, options.base);
	      break
	    default:
	      if (false) {
	        assert(false, ("invalid mode: " + mode));
	      }
	  }
	};
	
	var prototypeAccessors = { currentRoute: { configurable: true } };
	
	VueRouter.prototype.match = function match (
	  raw,
	  current,
	  redirectedFrom
	) {
	  return this.matcher.match(raw, current, redirectedFrom)
	};
	
	prototypeAccessors.currentRoute.get = function () {
	  return this.history && this.history.current
	};
	
	VueRouter.prototype.init = function init (app /* Vue component instance */) {
	    var this$1 = this;
	
	  ("production") !== 'production' && assert(
	    install.installed,
	    "not installed. Make sure to call `Vue.use(VueRouter)` " +
	    "before creating root instance."
	  );
	
	  this.apps.push(app);
	
	  // main app already initialized.
	  if (this.app) {
	    return
	  }
	
	  this.app = app;
	
	  var history = this.history;
	
	  if (history instanceof HTML5History) {
	    history.transitionTo(history.getCurrentLocation());
	  } else if (history instanceof HashHistory) {
	    var setupHashListener = function () {
	      history.setupListeners();
	    };
	    history.transitionTo(
	      history.getCurrentLocation(),
	      setupHashListener,
	      setupHashListener
	    );
	  }
	
	  history.listen(function (route) {
	    this$1.apps.forEach(function (app) {
	      app._route = route;
	    });
	  });
	};
	
	VueRouter.prototype.beforeEach = function beforeEach (fn) {
	  return registerHook(this.beforeHooks, fn)
	};
	
	VueRouter.prototype.beforeResolve = function beforeResolve (fn) {
	  return registerHook(this.resolveHooks, fn)
	};
	
	VueRouter.prototype.afterEach = function afterEach (fn) {
	  return registerHook(this.afterHooks, fn)
	};
	
	VueRouter.prototype.onReady = function onReady (cb, errorCb) {
	  this.history.onReady(cb, errorCb);
	};
	
	VueRouter.prototype.onError = function onError (errorCb) {
	  this.history.onError(errorCb);
	};
	
	VueRouter.prototype.push = function push (location, onComplete, onAbort) {
	  this.history.push(location, onComplete, onAbort);
	};
	
	VueRouter.prototype.replace = function replace (location, onComplete, onAbort) {
	  this.history.replace(location, onComplete, onAbort);
	};
	
	VueRouter.prototype.go = function go (n) {
	  this.history.go(n);
	};
	
	VueRouter.prototype.back = function back () {
	  this.go(-1);
	};
	
	VueRouter.prototype.forward = function forward () {
	  this.go(1);
	};
	
	VueRouter.prototype.getMatchedComponents = function getMatchedComponents (to) {
	  var route = to
	    ? to.matched
	      ? to
	      : this.resolve(to).route
	    : this.currentRoute;
	  if (!route) {
	    return []
	  }
	  return [].concat.apply([], route.matched.map(function (m) {
	    return Object.keys(m.components).map(function (key) {
	      return m.components[key]
	    })
	  }))
	};
	
	VueRouter.prototype.resolve = function resolve (
	  to,
	  current,
	  append
	) {
	  var location = normalizeLocation(
	    to,
	    current || this.history.current,
	    append,
	    this
	  );
	  var route = this.match(location, current);
	  var fullPath = route.redirectedFrom || route.fullPath;
	  var base = this.history.base;
	  var href = createHref(base, fullPath, this.mode);
	  return {
	    location: location,
	    route: route,
	    href: href,
	    // for backwards compat
	    normalizedTo: location,
	    resolved: route
	  }
	};
	
	VueRouter.prototype.addRoutes = function addRoutes (routes) {
	  this.matcher.addRoutes(routes);
	  if (this.history.current !== START) {
	    this.history.transitionTo(this.history.getCurrentLocation());
	  }
	};
	
	Object.defineProperties( VueRouter.prototype, prototypeAccessors );
	
	function registerHook (list, fn) {
	  list.push(fn);
	  return function () {
	    var i = list.indexOf(fn);
	    if (i > -1) { list.splice(i, 1); }
	  }
	}
	
	function createHref (base, fullPath, mode) {
	  var path = mode === 'hash' ? '#' + fullPath : fullPath;
	  return base ? cleanPath(base + '/' + path) : path
	}
	
	VueRouter.install = install;
	VueRouter.version = '2.8.1';
	
	if (inBrowser && window.Vue) {
	  window.Vue.use(VueRouter);
	}
	
	module.exports = VueRouter;


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, setImmediate) {/*!
	 * Vue.js v2.6.14
	 * (c) 2014-2021 Evan You
	 * Released under the MIT License.
	 */
	"use strict";var e=Object.freeze({});function t(e){return null==e}function n(e){return null!=e}function r(e){return!0===e}function i(e){return"string"==typeof e||"number"==typeof e||"symbol"==typeof e||"boolean"==typeof e}function o(e){return null!==e&&"object"==typeof e}var a=Object.prototype.toString;function s(e){return"[object Object]"===a.call(e)}function c(e){var t=parseFloat(String(e));return t>=0&&Math.floor(t)===t&&isFinite(e)}function u(e){return n(e)&&"function"==typeof e.then&&"function"==typeof e.catch}function l(e){return null==e?"":Array.isArray(e)||s(e)&&e.toString===a?JSON.stringify(e,null,2):String(e)}function f(e){var t=parseFloat(e);return isNaN(t)?e:t}function p(e,t){for(var n=Object.create(null),r=e.split(","),i=0;i<r.length;i++)n[r[i]]=!0;return t?function(e){return n[e.toLowerCase()]}:function(e){return n[e]}}var d=p("slot,component",!0),v=p("key,ref,slot,slot-scope,is");function h(e,t){if(e.length){var n=e.indexOf(t);if(n>-1)return e.splice(n,1)}}var m=Object.prototype.hasOwnProperty;function y(e,t){return m.call(e,t)}function g(e){var t=Object.create(null);return function(n){return t[n]||(t[n]=e(n))}}var _=/-(\w)/g,b=g(function(e){return e.replace(_,function(e,t){return t?t.toUpperCase():""})}),$=g(function(e){return e.charAt(0).toUpperCase()+e.slice(1)}),w=/\B([A-Z])/g,C=g(function(e){return e.replace(w,"-$1").toLowerCase()});var x=Function.prototype.bind?function(e,t){return e.bind(t)}:function(e,t){function n(n){var r=arguments.length;return r?r>1?e.apply(t,arguments):e.call(t,n):e.call(t)}return n._length=e.length,n};function k(e,t){t=t||0;for(var n=e.length-t,r=new Array(n);n--;)r[n]=e[n+t];return r}function A(e,t){for(var n in t)e[n]=t[n];return e}function O(e){for(var t={},n=0;n<e.length;n++)e[n]&&A(t,e[n]);return t}function S(e,t,n){}var T=function(e,t,n){return!1},N=function(e){return e};function E(e,t){if(e===t)return!0;var n=o(e),r=o(t);if(!n||!r)return!n&&!r&&String(e)===String(t);try{var i=Array.isArray(e),a=Array.isArray(t);if(i&&a)return e.length===t.length&&e.every(function(e,n){return E(e,t[n])});if(e instanceof Date&&t instanceof Date)return e.getTime()===t.getTime();if(i||a)return!1;var s=Object.keys(e),c=Object.keys(t);return s.length===c.length&&s.every(function(n){return E(e[n],t[n])})}catch(e){return!1}}function j(e,t){for(var n=0;n<e.length;n++)if(E(e[n],t))return n;return-1}function D(e){var t=!1;return function(){t||(t=!0,e.apply(this,arguments))}}var L="data-server-rendered",I=["component","directive","filter"],M=["beforeCreate","created","beforeMount","mounted","beforeUpdate","updated","beforeDestroy","destroyed","activated","deactivated","errorCaptured","serverPrefetch"],F={optionMergeStrategies:Object.create(null),silent:!1,productionTip:!1,devtools:!1,performance:!1,errorHandler:null,warnHandler:null,ignoredElements:[],keyCodes:Object.create(null),isReservedTag:T,isReservedAttr:T,isUnknownElement:T,getTagNamespace:S,parsePlatformTagName:N,mustUseProp:T,async:!0,_lifecycleHooks:M},P=/a-zA-Z\u00B7\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u037D\u037F-\u1FFF\u200C-\u200D\u203F-\u2040\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD/;function R(e,t,n,r){Object.defineProperty(e,t,{value:n,enumerable:!!r,writable:!0,configurable:!0})}var H=new RegExp("[^"+P.source+".$_\\d]");var B,U="__proto__"in{},V="undefined"!=typeof window,z="undefined"!=typeof WXEnvironment&&!!WXEnvironment.platform,K=z&&WXEnvironment.platform.toLowerCase(),J=V&&window.navigator.userAgent.toLowerCase(),q=J&&/msie|trident/.test(J),W=J&&J.indexOf("msie 9.0")>0,Z=J&&J.indexOf("edge/")>0,G=(J&&J.indexOf("android"),J&&/iphone|ipad|ipod|ios/.test(J)||"ios"===K),X=(J&&/chrome\/\d+/.test(J),J&&/phantomjs/.test(J),J&&J.match(/firefox\/(\d+)/)),Y={}.watch,Q=!1;if(V)try{var ee={};Object.defineProperty(ee,"passive",{get:function(){Q=!0}}),window.addEventListener("test-passive",null,ee)}catch(e){}var te=function(){return void 0===B&&(B=!V&&!z&&"undefined"!=typeof global&&(global.process&&"server"===global.process.env.VUE_ENV)),B},ne=V&&window.__VUE_DEVTOOLS_GLOBAL_HOOK__;function re(e){return"function"==typeof e&&/native code/.test(e.toString())}var ie,oe="undefined"!=typeof Symbol&&re(Symbol)&&"undefined"!=typeof Reflect&&re(Reflect.ownKeys);ie="undefined"!=typeof Set&&re(Set)?Set:function(){function e(){this.set=Object.create(null)}return e.prototype.has=function(e){return!0===this.set[e]},e.prototype.add=function(e){this.set[e]=!0},e.prototype.clear=function(){this.set=Object.create(null)},e}();var ae=S,se=0,ce=function(){this.id=se++,this.subs=[]};ce.prototype.addSub=function(e){this.subs.push(e)},ce.prototype.removeSub=function(e){h(this.subs,e)},ce.prototype.depend=function(){ce.target&&ce.target.addDep(this)},ce.prototype.notify=function(){for(var e=this.subs.slice(),t=0,n=e.length;t<n;t++)e[t].update()},ce.target=null;var ue=[];function le(e){ue.push(e),ce.target=e}function fe(){ue.pop(),ce.target=ue[ue.length-1]}var pe=function(e,t,n,r,i,o,a,s){this.tag=e,this.data=t,this.children=n,this.text=r,this.elm=i,this.ns=void 0,this.context=o,this.fnContext=void 0,this.fnOptions=void 0,this.fnScopeId=void 0,this.key=t&&t.key,this.componentOptions=a,this.componentInstance=void 0,this.parent=void 0,this.raw=!1,this.isStatic=!1,this.isRootInsert=!0,this.isComment=!1,this.isCloned=!1,this.isOnce=!1,this.asyncFactory=s,this.asyncMeta=void 0,this.isAsyncPlaceholder=!1},de={child:{configurable:!0}};de.child.get=function(){return this.componentInstance},Object.defineProperties(pe.prototype,de);var ve=function(e){void 0===e&&(e="");var t=new pe;return t.text=e,t.isComment=!0,t};function he(e){return new pe(void 0,void 0,void 0,String(e))}function me(e){var t=new pe(e.tag,e.data,e.children&&e.children.slice(),e.text,e.elm,e.context,e.componentOptions,e.asyncFactory);return t.ns=e.ns,t.isStatic=e.isStatic,t.key=e.key,t.isComment=e.isComment,t.fnContext=e.fnContext,t.fnOptions=e.fnOptions,t.fnScopeId=e.fnScopeId,t.asyncMeta=e.asyncMeta,t.isCloned=!0,t}var ye=Array.prototype,ge=Object.create(ye);["push","pop","shift","unshift","splice","sort","reverse"].forEach(function(e){var t=ye[e];R(ge,e,function(){for(var n=[],r=arguments.length;r--;)n[r]=arguments[r];var i,o=t.apply(this,n),a=this.__ob__;switch(e){case"push":case"unshift":i=n;break;case"splice":i=n.slice(2)}return i&&a.observeArray(i),a.dep.notify(),o})});var _e=Object.getOwnPropertyNames(ge),be=!0;function $e(e){be=e}var we=function(e){var t;this.value=e,this.dep=new ce,this.vmCount=0,R(e,"__ob__",this),Array.isArray(e)?(U?(t=ge,e.__proto__=t):function(e,t,n){for(var r=0,i=n.length;r<i;r++){var o=n[r];R(e,o,t[o])}}(e,ge,_e),this.observeArray(e)):this.walk(e)};function Ce(e,t){var n;if(o(e)&&!(e instanceof pe))return y(e,"__ob__")&&e.__ob__ instanceof we?n=e.__ob__:be&&!te()&&(Array.isArray(e)||s(e))&&Object.isExtensible(e)&&!e._isVue&&(n=new we(e)),t&&n&&n.vmCount++,n}function xe(e,t,n,r,i){var o=new ce,a=Object.getOwnPropertyDescriptor(e,t);if(!a||!1!==a.configurable){var s=a&&a.get,c=a&&a.set;s&&!c||2!==arguments.length||(n=e[t]);var u=!i&&Ce(n);Object.defineProperty(e,t,{enumerable:!0,configurable:!0,get:function(){var t=s?s.call(e):n;return ce.target&&(o.depend(),u&&(u.dep.depend(),Array.isArray(t)&&function e(t){for(var n=void 0,r=0,i=t.length;r<i;r++)(n=t[r])&&n.__ob__&&n.__ob__.dep.depend(),Array.isArray(n)&&e(n)}(t))),t},set:function(t){var r=s?s.call(e):n;t===r||t!=t&&r!=r||s&&!c||(c?c.call(e,t):n=t,u=!i&&Ce(t),o.notify())}})}}function ke(e,t,n){if(Array.isArray(e)&&c(t))return e.length=Math.max(e.length,t),e.splice(t,1,n),n;if(t in e&&!(t in Object.prototype))return e[t]=n,n;var r=e.__ob__;return e._isVue||r&&r.vmCount?n:r?(xe(r.value,t,n),r.dep.notify(),n):(e[t]=n,n)}function Ae(e,t){if(Array.isArray(e)&&c(t))e.splice(t,1);else{var n=e.__ob__;e._isVue||n&&n.vmCount||y(e,t)&&(delete e[t],n&&n.dep.notify())}}we.prototype.walk=function(e){for(var t=Object.keys(e),n=0;n<t.length;n++)xe(e,t[n])},we.prototype.observeArray=function(e){for(var t=0,n=e.length;t<n;t++)Ce(e[t])};var Oe=F.optionMergeStrategies;function Se(e,t){if(!t)return e;for(var n,r,i,o=oe?Reflect.ownKeys(t):Object.keys(t),a=0;a<o.length;a++)"__ob__"!==(n=o[a])&&(r=e[n],i=t[n],y(e,n)?r!==i&&s(r)&&s(i)&&Se(r,i):ke(e,n,i));return e}function Te(e,t,n){return n?function(){var r="function"==typeof t?t.call(n,n):t,i="function"==typeof e?e.call(n,n):e;return r?Se(r,i):i}:t?e?function(){return Se("function"==typeof t?t.call(this,this):t,"function"==typeof e?e.call(this,this):e)}:t:e}function Ne(e,t){var n=t?e?e.concat(t):Array.isArray(t)?t:[t]:e;return n?function(e){for(var t=[],n=0;n<e.length;n++)-1===t.indexOf(e[n])&&t.push(e[n]);return t}(n):n}function Ee(e,t,n,r){var i=Object.create(e||null);return t?A(i,t):i}Oe.data=function(e,t,n){return n?Te(e,t,n):t&&"function"!=typeof t?e:Te(e,t)},M.forEach(function(e){Oe[e]=Ne}),I.forEach(function(e){Oe[e+"s"]=Ee}),Oe.watch=function(e,t,n,r){if(e===Y&&(e=void 0),t===Y&&(t=void 0),!t)return Object.create(e||null);if(!e)return t;var i={};for(var o in A(i,e),t){var a=i[o],s=t[o];a&&!Array.isArray(a)&&(a=[a]),i[o]=a?a.concat(s):Array.isArray(s)?s:[s]}return i},Oe.props=Oe.methods=Oe.inject=Oe.computed=function(e,t,n,r){if(!e)return t;var i=Object.create(null);return A(i,e),t&&A(i,t),i},Oe.provide=Te;var je=function(e,t){return void 0===t?e:t};function De(e,t,n){if("function"==typeof t&&(t=t.options),function(e,t){var n=e.props;if(n){var r,i,o={};if(Array.isArray(n))for(r=n.length;r--;)"string"==typeof(i=n[r])&&(o[b(i)]={type:null});else if(s(n))for(var a in n)i=n[a],o[b(a)]=s(i)?i:{type:i};e.props=o}}(t),function(e,t){var n=e.inject;if(n){var r=e.inject={};if(Array.isArray(n))for(var i=0;i<n.length;i++)r[n[i]]={from:n[i]};else if(s(n))for(var o in n){var a=n[o];r[o]=s(a)?A({from:o},a):{from:a}}}}(t),function(e){var t=e.directives;if(t)for(var n in t){var r=t[n];"function"==typeof r&&(t[n]={bind:r,update:r})}}(t),!t._base&&(t.extends&&(e=De(e,t.extends,n)),t.mixins))for(var r=0,i=t.mixins.length;r<i;r++)e=De(e,t.mixins[r],n);var o,a={};for(o in e)c(o);for(o in t)y(e,o)||c(o);function c(r){var i=Oe[r]||je;a[r]=i(e[r],t[r],n,r)}return a}function Le(e,t,n,r){if("string"==typeof n){var i=e[t];if(y(i,n))return i[n];var o=b(n);if(y(i,o))return i[o];var a=$(o);return y(i,a)?i[a]:i[n]||i[o]||i[a]}}function Ie(e,t,n,r){var i=t[e],o=!y(n,e),a=n[e],s=Re(Boolean,i.type);if(s>-1)if(o&&!y(i,"default"))a=!1;else if(""===a||a===C(e)){var c=Re(String,i.type);(c<0||s<c)&&(a=!0)}if(void 0===a){a=function(e,t,n){if(!y(t,"default"))return;var r=t.default;if(e&&e.$options.propsData&&void 0===e.$options.propsData[n]&&void 0!==e._props[n])return e._props[n];return"function"==typeof r&&"Function"!==Fe(t.type)?r.call(e):r}(r,i,e);var u=be;$e(!0),Ce(a),$e(u)}return a}var Me=/^\s*function (\w+)/;function Fe(e){var t=e&&e.toString().match(Me);return t?t[1]:""}function Pe(e,t){return Fe(e)===Fe(t)}function Re(e,t){if(!Array.isArray(t))return Pe(t,e)?0:-1;for(var n=0,r=t.length;n<r;n++)if(Pe(t[n],e))return n;return-1}function He(e,t,n){le();try{if(t)for(var r=t;r=r.$parent;){var i=r.$options.errorCaptured;if(i)for(var o=0;o<i.length;o++)try{if(!1===i[o].call(r,e,t,n))return}catch(e){Ue(e,r,"errorCaptured hook")}}Ue(e,t,n)}finally{fe()}}function Be(e,t,n,r,i){var o;try{(o=n?e.apply(t,n):e.call(t))&&!o._isVue&&u(o)&&!o._handled&&(o.catch(function(e){return He(e,r,i+" (Promise/async)")}),o._handled=!0)}catch(e){He(e,r,i)}return o}function Ue(e,t,n){if(F.errorHandler)try{return F.errorHandler.call(null,e,t,n)}catch(t){t!==e&&Ve(t,null,"config.errorHandler")}Ve(e,t,n)}function Ve(e,t,n){if(!V&&!z||"undefined"==typeof console)throw e;console.error(e)}var ze,Ke=!1,Je=[],qe=!1;function We(){qe=!1;var e=Je.slice(0);Je.length=0;for(var t=0;t<e.length;t++)e[t]()}if("undefined"!=typeof Promise&&re(Promise)){var Ze=Promise.resolve();ze=function(){Ze.then(We),G&&setTimeout(S)},Ke=!0}else if(q||"undefined"==typeof MutationObserver||!re(MutationObserver)&&"[object MutationObserverConstructor]"!==MutationObserver.toString())ze="undefined"!=typeof setImmediate&&re(setImmediate)?function(){setImmediate(We)}:function(){setTimeout(We,0)};else{var Ge=1,Xe=new MutationObserver(We),Ye=document.createTextNode(String(Ge));Xe.observe(Ye,{characterData:!0}),ze=function(){Ge=(Ge+1)%2,Ye.data=String(Ge)},Ke=!0}function Qe(e,t){var n;if(Je.push(function(){if(e)try{e.call(t)}catch(e){He(e,t,"nextTick")}else n&&n(t)}),qe||(qe=!0,ze()),!e&&"undefined"!=typeof Promise)return new Promise(function(e){n=e})}var et=new ie;function tt(e){!function e(t,n){var r,i;var a=Array.isArray(t);if(!a&&!o(t)||Object.isFrozen(t)||t instanceof pe)return;if(t.__ob__){var s=t.__ob__.dep.id;if(n.has(s))return;n.add(s)}if(a)for(r=t.length;r--;)e(t[r],n);else for(i=Object.keys(t),r=i.length;r--;)e(t[i[r]],n)}(e,et),et.clear()}var nt=g(function(e){var t="&"===e.charAt(0),n="~"===(e=t?e.slice(1):e).charAt(0),r="!"===(e=n?e.slice(1):e).charAt(0);return{name:e=r?e.slice(1):e,once:n,capture:r,passive:t}});function rt(e,t){function n(){var e=arguments,r=n.fns;if(!Array.isArray(r))return Be(r,null,arguments,t,"v-on handler");for(var i=r.slice(),o=0;o<i.length;o++)Be(i[o],null,e,t,"v-on handler")}return n.fns=e,n}function it(e,n,i,o,a,s){var c,u,l,f;for(c in e)u=e[c],l=n[c],f=nt(c),t(u)||(t(l)?(t(u.fns)&&(u=e[c]=rt(u,s)),r(f.once)&&(u=e[c]=a(f.name,u,f.capture)),i(f.name,u,f.capture,f.passive,f.params)):u!==l&&(l.fns=u,e[c]=l));for(c in n)t(e[c])&&o((f=nt(c)).name,n[c],f.capture)}function ot(e,i,o){var a;e instanceof pe&&(e=e.data.hook||(e.data.hook={}));var s=e[i];function c(){o.apply(this,arguments),h(a.fns,c)}t(s)?a=rt([c]):n(s.fns)&&r(s.merged)?(a=s).fns.push(c):a=rt([s,c]),a.merged=!0,e[i]=a}function at(e,t,r,i,o){if(n(t)){if(y(t,r))return e[r]=t[r],o||delete t[r],!0;if(y(t,i))return e[r]=t[i],o||delete t[i],!0}return!1}function st(e){return i(e)?[he(e)]:Array.isArray(e)?function e(o,a){var s=[];var c,u,l,f;for(c=0;c<o.length;c++)t(u=o[c])||"boolean"==typeof u||(l=s.length-1,f=s[l],Array.isArray(u)?u.length>0&&(ct((u=e(u,(a||"")+"_"+c))[0])&&ct(f)&&(s[l]=he(f.text+u[0].text),u.shift()),s.push.apply(s,u)):i(u)?ct(f)?s[l]=he(f.text+u):""!==u&&s.push(he(u)):ct(u)&&ct(f)?s[l]=he(f.text+u.text):(r(o._isVList)&&n(u.tag)&&t(u.key)&&n(a)&&(u.key="__vlist"+a+"_"+c+"__"),s.push(u)));return s}(e):void 0}function ct(e){return n(e)&&n(e.text)&&!1===e.isComment}function ut(e,t){if(e){for(var n=Object.create(null),r=oe?Reflect.ownKeys(e):Object.keys(e),i=0;i<r.length;i++){var o=r[i];if("__ob__"!==o){for(var a=e[o].from,s=t;s;){if(s._provided&&y(s._provided,a)){n[o]=s._provided[a];break}s=s.$parent}if(!s&&"default"in e[o]){var c=e[o].default;n[o]="function"==typeof c?c.call(t):c}}}return n}}function lt(e,t){if(!e||!e.length)return{};for(var n={},r=0,i=e.length;r<i;r++){var o=e[r],a=o.data;if(a&&a.attrs&&a.attrs.slot&&delete a.attrs.slot,o.context!==t&&o.fnContext!==t||!a||null==a.slot)(n.default||(n.default=[])).push(o);else{var s=a.slot,c=n[s]||(n[s]=[]);"template"===o.tag?c.push.apply(c,o.children||[]):c.push(o)}}for(var u in n)n[u].every(ft)&&delete n[u];return n}function ft(e){return e.isComment&&!e.asyncFactory||" "===e.text}function pt(e){return e.isComment&&e.asyncFactory}function dt(t,n,r){var i,o=Object.keys(n).length>0,a=t?!!t.$stable:!o,s=t&&t.$key;if(t){if(t._normalized)return t._normalized;if(a&&r&&r!==e&&s===r.$key&&!o&&!r.$hasNormal)return r;for(var c in i={},t)t[c]&&"$"!==c[0]&&(i[c]=vt(n,c,t[c]))}else i={};for(var u in n)u in i||(i[u]=ht(n,u));return t&&Object.isExtensible(t)&&(t._normalized=i),R(i,"$stable",a),R(i,"$key",s),R(i,"$hasNormal",o),i}function vt(e,t,n){var r=function(){var e=arguments.length?n.apply(null,arguments):n({}),t=(e=e&&"object"==typeof e&&!Array.isArray(e)?[e]:st(e))&&e[0];return e&&(!t||1===e.length&&t.isComment&&!pt(t))?void 0:e};return n.proxy&&Object.defineProperty(e,t,{get:r,enumerable:!0,configurable:!0}),r}function ht(e,t){return function(){return e[t]}}function mt(e,t){var r,i,a,s,c;if(Array.isArray(e)||"string"==typeof e)for(r=new Array(e.length),i=0,a=e.length;i<a;i++)r[i]=t(e[i],i);else if("number"==typeof e)for(r=new Array(e),i=0;i<e;i++)r[i]=t(i+1,i);else if(o(e))if(oe&&e[Symbol.iterator]){r=[];for(var u=e[Symbol.iterator](),l=u.next();!l.done;)r.push(t(l.value,r.length)),l=u.next()}else for(s=Object.keys(e),r=new Array(s.length),i=0,a=s.length;i<a;i++)c=s[i],r[i]=t(e[c],c,i);return n(r)||(r=[]),r._isVList=!0,r}function yt(e,t,n,r){var i,o=this.$scopedSlots[e];o?(n=n||{},r&&(n=A(A({},r),n)),i=o(n)||("function"==typeof t?t():t)):i=this.$slots[e]||("function"==typeof t?t():t);var a=n&&n.slot;return a?this.$createElement("template",{slot:a},i):i}function gt(e){return Le(this.$options,"filters",e)||N}function _t(e,t){return Array.isArray(e)?-1===e.indexOf(t):e!==t}function bt(e,t,n,r,i){var o=F.keyCodes[t]||n;return i&&r&&!F.keyCodes[t]?_t(i,r):o?_t(o,e):r?C(r)!==t:void 0===e}function $t(e,t,n,r,i){if(n)if(o(n)){var a;Array.isArray(n)&&(n=O(n));var s=function(o){if("class"===o||"style"===o||v(o))a=e;else{var s=e.attrs&&e.attrs.type;a=r||F.mustUseProp(t,s,o)?e.domProps||(e.domProps={}):e.attrs||(e.attrs={})}var c=b(o),u=C(o);c in a||u in a||(a[o]=n[o],i&&((e.on||(e.on={}))["update:"+o]=function(e){n[o]=e}))};for(var c in n)s(c)}else;return e}function wt(e,t){var n=this._staticTrees||(this._staticTrees=[]),r=n[e];return r&&!t?r:(xt(r=n[e]=this.$options.staticRenderFns[e].call(this._renderProxy,null,this),"__static__"+e,!1),r)}function Ct(e,t,n){return xt(e,"__once__"+t+(n?"_"+n:""),!0),e}function xt(e,t,n){if(Array.isArray(e))for(var r=0;r<e.length;r++)e[r]&&"string"!=typeof e[r]&&kt(e[r],t+"_"+r,n);else kt(e,t,n)}function kt(e,t,n){e.isStatic=!0,e.key=t,e.isOnce=n}function At(e,t){if(t)if(s(t)){var n=e.on=e.on?A({},e.on):{};for(var r in t){var i=n[r],o=t[r];n[r]=i?[].concat(i,o):o}}else;return e}function Ot(e,t,n,r){t=t||{$stable:!n};for(var i=0;i<e.length;i++){var o=e[i];Array.isArray(o)?Ot(o,t,n):o&&(o.proxy&&(o.fn.proxy=!0),t[o.key]=o.fn)}return r&&(t.$key=r),t}function St(e,t){for(var n=0;n<t.length;n+=2){var r=t[n];"string"==typeof r&&r&&(e[t[n]]=t[n+1])}return e}function Tt(e,t){return"string"==typeof e?t+e:e}function Nt(e){e._o=Ct,e._n=f,e._s=l,e._l=mt,e._t=yt,e._q=E,e._i=j,e._m=wt,e._f=gt,e._k=bt,e._b=$t,e._v=he,e._e=ve,e._u=Ot,e._g=At,e._d=St,e._p=Tt}function Et(t,n,i,o,a){var s,c=this,u=a.options;y(o,"_uid")?(s=Object.create(o))._original=o:(s=o,o=o._original);var l=r(u._compiled),f=!l;this.data=t,this.props=n,this.children=i,this.parent=o,this.listeners=t.on||e,this.injections=ut(u.inject,o),this.slots=function(){return c.$slots||dt(t.scopedSlots,c.$slots=lt(i,o)),c.$slots},Object.defineProperty(this,"scopedSlots",{enumerable:!0,get:function(){return dt(t.scopedSlots,this.slots())}}),l&&(this.$options=u,this.$slots=this.slots(),this.$scopedSlots=dt(t.scopedSlots,this.$slots)),u._scopeId?this._c=function(e,t,n,r){var i=Ht(s,e,t,n,r,f);return i&&!Array.isArray(i)&&(i.fnScopeId=u._scopeId,i.fnContext=o),i}:this._c=function(e,t,n,r){return Ht(s,e,t,n,r,f)}}function jt(e,t,n,r,i){var o=me(e);return o.fnContext=n,o.fnOptions=r,t.slot&&((o.data||(o.data={})).slot=t.slot),o}function Dt(e,t){for(var n in t)e[b(n)]=t[n]}Nt(Et.prototype);var Lt={init:function(e,t){if(e.componentInstance&&!e.componentInstance._isDestroyed&&e.data.keepAlive){var r=e;Lt.prepatch(r,r)}else{(e.componentInstance=function(e,t){var r={_isComponent:!0,_parentVnode:e,parent:t},i=e.data.inlineTemplate;n(i)&&(r.render=i.render,r.staticRenderFns=i.staticRenderFns);return new e.componentOptions.Ctor(r)}(e,Zt)).$mount(t?e.elm:void 0,t)}},prepatch:function(t,n){var r=n.componentOptions;!function(t,n,r,i,o){var a=i.data.scopedSlots,s=t.$scopedSlots,c=!!(a&&!a.$stable||s!==e&&!s.$stable||a&&t.$scopedSlots.$key!==a.$key||!a&&t.$scopedSlots.$key),u=!!(o||t.$options._renderChildren||c);t.$options._parentVnode=i,t.$vnode=i,t._vnode&&(t._vnode.parent=i);if(t.$options._renderChildren=o,t.$attrs=i.data.attrs||e,t.$listeners=r||e,n&&t.$options.props){$e(!1);for(var l=t._props,f=t.$options._propKeys||[],p=0;p<f.length;p++){var d=f[p],v=t.$options.props;l[d]=Ie(d,v,n,t)}$e(!0),t.$options.propsData=n}r=r||e;var h=t.$options._parentListeners;t.$options._parentListeners=r,Wt(t,r,h),u&&(t.$slots=lt(o,i.context),t.$forceUpdate())}(n.componentInstance=t.componentInstance,r.propsData,r.listeners,n,r.children)},insert:function(e){var t,n=e.context,r=e.componentInstance;r._isMounted||(r._isMounted=!0,Qt(r,"mounted")),e.data.keepAlive&&(n._isMounted?((t=r)._inactive=!1,tn.push(t)):Yt(r,!0))},destroy:function(e){var t=e.componentInstance;t._isDestroyed||(e.data.keepAlive?function e(t,n){if(n&&(t._directInactive=!0,Xt(t)))return;if(!t._inactive){t._inactive=!0;for(var r=0;r<t.$children.length;r++)e(t.$children[r]);Qt(t,"deactivated")}}(t,!0):t.$destroy())}},It=Object.keys(Lt);function Mt(i,a,s,c,l){if(!t(i)){var f=s.$options._base;if(o(i)&&(i=f.extend(i)),"function"==typeof i){var p;if(t(i.cid)&&void 0===(i=function(e,i){if(r(e.error)&&n(e.errorComp))return e.errorComp;if(n(e.resolved))return e.resolved;var a=Ut;a&&n(e.owners)&&-1===e.owners.indexOf(a)&&e.owners.push(a);if(r(e.loading)&&n(e.loadingComp))return e.loadingComp;if(a&&!n(e.owners)){var s=e.owners=[a],c=!0,l=null,f=null;a.$on("hook:destroyed",function(){return h(s,a)});var p=function(e){for(var t=0,n=s.length;t<n;t++)s[t].$forceUpdate();e&&(s.length=0,null!==l&&(clearTimeout(l),l=null),null!==f&&(clearTimeout(f),f=null))},d=D(function(t){e.resolved=Vt(t,i),c?s.length=0:p(!0)}),v=D(function(t){n(e.errorComp)&&(e.error=!0,p(!0))}),m=e(d,v);return o(m)&&(u(m)?t(e.resolved)&&m.then(d,v):u(m.component)&&(m.component.then(d,v),n(m.error)&&(e.errorComp=Vt(m.error,i)),n(m.loading)&&(e.loadingComp=Vt(m.loading,i),0===m.delay?e.loading=!0:l=setTimeout(function(){l=null,t(e.resolved)&&t(e.error)&&(e.loading=!0,p(!1))},m.delay||200)),n(m.timeout)&&(f=setTimeout(function(){f=null,t(e.resolved)&&v(null)},m.timeout)))),c=!1,e.loading?e.loadingComp:e.resolved}}(p=i,f)))return function(e,t,n,r,i){var o=ve();return o.asyncFactory=e,o.asyncMeta={data:t,context:n,children:r,tag:i},o}(p,a,s,c,l);a=a||{},wn(i),n(a.model)&&function(e,t){var r=e.model&&e.model.prop||"value",i=e.model&&e.model.event||"input";(t.attrs||(t.attrs={}))[r]=t.model.value;var o=t.on||(t.on={}),a=o[i],s=t.model.callback;n(a)?(Array.isArray(a)?-1===a.indexOf(s):a!==s)&&(o[i]=[s].concat(a)):o[i]=s}(i.options,a);var d=function(e,r,i){var o=r.options.props;if(!t(o)){var a={},s=e.attrs,c=e.props;if(n(s)||n(c))for(var u in o){var l=C(u);at(a,c,u,l,!0)||at(a,s,u,l,!1)}return a}}(a,i);if(r(i.options.functional))return function(t,r,i,o,a){var s=t.options,c={},u=s.props;if(n(u))for(var l in u)c[l]=Ie(l,u,r||e);else n(i.attrs)&&Dt(c,i.attrs),n(i.props)&&Dt(c,i.props);var f=new Et(i,c,a,o,t),p=s.render.call(null,f._c,f);if(p instanceof pe)return jt(p,i,f.parent,s);if(Array.isArray(p)){for(var d=st(p)||[],v=new Array(d.length),h=0;h<d.length;h++)v[h]=jt(d[h],i,f.parent,s);return v}}(i,d,a,s,c);var v=a.on;if(a.on=a.nativeOn,r(i.options.abstract)){var m=a.slot;a={},m&&(a.slot=m)}!function(e){for(var t=e.hook||(e.hook={}),n=0;n<It.length;n++){var r=It[n],i=t[r],o=Lt[r];i===o||i&&i._merged||(t[r]=i?Ft(o,i):o)}}(a);var y=i.options.name||l;return new pe("vue-component-"+i.cid+(y?"-"+y:""),a,void 0,void 0,void 0,s,{Ctor:i,propsData:d,listeners:v,tag:l,children:c},p)}}}function Ft(e,t){var n=function(n,r){e(n,r),t(n,r)};return n._merged=!0,n}var Pt=1,Rt=2;function Ht(e,a,s,c,u,l){return(Array.isArray(s)||i(s))&&(u=c,c=s,s=void 0),r(l)&&(u=Rt),function(e,i,a,s,c){if(n(a)&&n(a.__ob__))return ve();n(a)&&n(a.is)&&(i=a.is);if(!i)return ve();Array.isArray(s)&&"function"==typeof s[0]&&((a=a||{}).scopedSlots={default:s[0]},s.length=0);c===Rt?s=st(s):c===Pt&&(s=function(e){for(var t=0;t<e.length;t++)if(Array.isArray(e[t]))return Array.prototype.concat.apply([],e);return e}(s));var u,l;if("string"==typeof i){var f;l=e.$vnode&&e.$vnode.ns||F.getTagNamespace(i),u=F.isReservedTag(i)?new pe(F.parsePlatformTagName(i),a,s,void 0,void 0,e):a&&a.pre||!n(f=Le(e.$options,"components",i))?new pe(i,a,s,void 0,void 0,e):Mt(f,a,e,s,i)}else u=Mt(i,a,e,s);return Array.isArray(u)?u:n(u)?(n(l)&&function e(i,o,a){i.ns=o;"foreignObject"===i.tag&&(o=void 0,a=!0);if(n(i.children))for(var s=0,c=i.children.length;s<c;s++){var u=i.children[s];n(u.tag)&&(t(u.ns)||r(a)&&"svg"!==u.tag)&&e(u,o,a)}}(u,l),n(a)&&function(e){o(e.style)&&tt(e.style);o(e.class)&&tt(e.class)}(a),u):ve()}(e,a,s,c,u)}var Bt,Ut=null;function Vt(e,t){return(e.__esModule||oe&&"Module"===e[Symbol.toStringTag])&&(e=e.default),o(e)?t.extend(e):e}function zt(e){if(Array.isArray(e))for(var t=0;t<e.length;t++){var r=e[t];if(n(r)&&(n(r.componentOptions)||pt(r)))return r}}function Kt(e,t){Bt.$on(e,t)}function Jt(e,t){Bt.$off(e,t)}function qt(e,t){var n=Bt;return function r(){null!==t.apply(null,arguments)&&n.$off(e,r)}}function Wt(e,t,n){Bt=e,it(t,n||{},Kt,Jt,qt,e),Bt=void 0}var Zt=null;function Gt(e){var t=Zt;return Zt=e,function(){Zt=t}}function Xt(e){for(;e&&(e=e.$parent);)if(e._inactive)return!0;return!1}function Yt(e,t){if(t){if(e._directInactive=!1,Xt(e))return}else if(e._directInactive)return;if(e._inactive||null===e._inactive){e._inactive=!1;for(var n=0;n<e.$children.length;n++)Yt(e.$children[n]);Qt(e,"activated")}}function Qt(e,t){le();var n=e.$options[t],r=t+" hook";if(n)for(var i=0,o=n.length;i<o;i++)Be(n[i],e,null,e,r);e._hasHookEvent&&e.$emit("hook:"+t),fe()}var en=[],tn=[],nn={},rn=!1,on=!1,an=0;var sn=0,cn=Date.now;if(V&&!q){var un=window.performance;un&&"function"==typeof un.now&&cn()>document.createEvent("Event").timeStamp&&(cn=function(){return un.now()})}function ln(){var e,t;for(sn=cn(),on=!0,en.sort(function(e,t){return e.id-t.id}),an=0;an<en.length;an++)(e=en[an]).before&&e.before(),t=e.id,nn[t]=null,e.run();var n=tn.slice(),r=en.slice();an=en.length=tn.length=0,nn={},rn=on=!1,function(e){for(var t=0;t<e.length;t++)e[t]._inactive=!0,Yt(e[t],!0)}(n),function(e){var t=e.length;for(;t--;){var n=e[t],r=n.vm;r._watcher===n&&r._isMounted&&!r._isDestroyed&&Qt(r,"updated")}}(r),ne&&F.devtools&&ne.emit("flush")}var fn=0,pn=function(e,t,n,r,i){this.vm=e,i&&(e._watcher=this),e._watchers.push(this),r?(this.deep=!!r.deep,this.user=!!r.user,this.lazy=!!r.lazy,this.sync=!!r.sync,this.before=r.before):this.deep=this.user=this.lazy=this.sync=!1,this.cb=n,this.id=++fn,this.active=!0,this.dirty=this.lazy,this.deps=[],this.newDeps=[],this.depIds=new ie,this.newDepIds=new ie,this.expression="","function"==typeof t?this.getter=t:(this.getter=function(e){if(!H.test(e)){var t=e.split(".");return function(e){for(var n=0;n<t.length;n++){if(!e)return;e=e[t[n]]}return e}}}(t),this.getter||(this.getter=S)),this.value=this.lazy?void 0:this.get()};pn.prototype.get=function(){var e;le(this);var t=this.vm;try{e=this.getter.call(t,t)}catch(e){if(!this.user)throw e;He(e,t,'getter for watcher "'+this.expression+'"')}finally{this.deep&&tt(e),fe(),this.cleanupDeps()}return e},pn.prototype.addDep=function(e){var t=e.id;this.newDepIds.has(t)||(this.newDepIds.add(t),this.newDeps.push(e),this.depIds.has(t)||e.addSub(this))},pn.prototype.cleanupDeps=function(){for(var e=this.deps.length;e--;){var t=this.deps[e];this.newDepIds.has(t.id)||t.removeSub(this)}var n=this.depIds;this.depIds=this.newDepIds,this.newDepIds=n,this.newDepIds.clear(),n=this.deps,this.deps=this.newDeps,this.newDeps=n,this.newDeps.length=0},pn.prototype.update=function(){this.lazy?this.dirty=!0:this.sync?this.run():function(e){var t=e.id;if(null==nn[t]){if(nn[t]=!0,on){for(var n=en.length-1;n>an&&en[n].id>e.id;)n--;en.splice(n+1,0,e)}else en.push(e);rn||(rn=!0,Qe(ln))}}(this)},pn.prototype.run=function(){if(this.active){var e=this.get();if(e!==this.value||o(e)||this.deep){var t=this.value;if(this.value=e,this.user){var n='callback for watcher "'+this.expression+'"';Be(this.cb,this.vm,[e,t],this.vm,n)}else this.cb.call(this.vm,e,t)}}},pn.prototype.evaluate=function(){this.value=this.get(),this.dirty=!1},pn.prototype.depend=function(){for(var e=this.deps.length;e--;)this.deps[e].depend()},pn.prototype.teardown=function(){if(this.active){this.vm._isBeingDestroyed||h(this.vm._watchers,this);for(var e=this.deps.length;e--;)this.deps[e].removeSub(this);this.active=!1}};var dn={enumerable:!0,configurable:!0,get:S,set:S};function vn(e,t,n){dn.get=function(){return this[t][n]},dn.set=function(e){this[t][n]=e},Object.defineProperty(e,n,dn)}function hn(e){e._watchers=[];var t=e.$options;t.props&&function(e,t){var n=e.$options.propsData||{},r=e._props={},i=e.$options._propKeys=[];e.$parent&&$e(!1);var o=function(o){i.push(o);var a=Ie(o,t,n,e);xe(r,o,a),o in e||vn(e,"_props",o)};for(var a in t)o(a);$e(!0)}(e,t.props),t.methods&&function(e,t){e.$options.props;for(var n in t)e[n]="function"!=typeof t[n]?S:x(t[n],e)}(e,t.methods),t.data?function(e){var t=e.$options.data;s(t=e._data="function"==typeof t?function(e,t){le();try{return e.call(t,t)}catch(e){return He(e,t,"data()"),{}}finally{fe()}}(t,e):t||{})||(t={});var n=Object.keys(t),r=e.$options.props,i=(e.$options.methods,n.length);for(;i--;){var o=n[i];r&&y(r,o)||(a=void 0,36!==(a=(o+"").charCodeAt(0))&&95!==a&&vn(e,"_data",o))}var a;Ce(t,!0)}(e):Ce(e._data={},!0),t.computed&&function(e,t){var n=e._computedWatchers=Object.create(null),r=te();for(var i in t){var o=t[i],a="function"==typeof o?o:o.get;r||(n[i]=new pn(e,a||S,S,mn)),i in e||yn(e,i,o)}}(e,t.computed),t.watch&&t.watch!==Y&&function(e,t){for(var n in t){var r=t[n];if(Array.isArray(r))for(var i=0;i<r.length;i++)bn(e,n,r[i]);else bn(e,n,r)}}(e,t.watch)}var mn={lazy:!0};function yn(e,t,n){var r=!te();"function"==typeof n?(dn.get=r?gn(t):_n(n),dn.set=S):(dn.get=n.get?r&&!1!==n.cache?gn(t):_n(n.get):S,dn.set=n.set||S),Object.defineProperty(e,t,dn)}function gn(e){return function(){var t=this._computedWatchers&&this._computedWatchers[e];if(t)return t.dirty&&t.evaluate(),ce.target&&t.depend(),t.value}}function _n(e){return function(){return e.call(this,this)}}function bn(e,t,n,r){return s(n)&&(r=n,n=n.handler),"string"==typeof n&&(n=e[n]),e.$watch(t,n,r)}var $n=0;function wn(e){var t=e.options;if(e.super){var n=wn(e.super);if(n!==e.superOptions){e.superOptions=n;var r=function(e){var t,n=e.options,r=e.sealedOptions;for(var i in n)n[i]!==r[i]&&(t||(t={}),t[i]=n[i]);return t}(e);r&&A(e.extendOptions,r),(t=e.options=De(n,e.extendOptions)).name&&(t.components[t.name]=e)}}return t}function Cn(e){this._init(e)}function xn(e){e.cid=0;var t=1;e.extend=function(e){e=e||{};var n=this,r=n.cid,i=e._Ctor||(e._Ctor={});if(i[r])return i[r];var o=e.name||n.options.name,a=function(e){this._init(e)};return(a.prototype=Object.create(n.prototype)).constructor=a,a.cid=t++,a.options=De(n.options,e),a.super=n,a.options.props&&function(e){var t=e.options.props;for(var n in t)vn(e.prototype,"_props",n)}(a),a.options.computed&&function(e){var t=e.options.computed;for(var n in t)yn(e.prototype,n,t[n])}(a),a.extend=n.extend,a.mixin=n.mixin,a.use=n.use,I.forEach(function(e){a[e]=n[e]}),o&&(a.options.components[o]=a),a.superOptions=n.options,a.extendOptions=e,a.sealedOptions=A({},a.options),i[r]=a,a}}function kn(e){return e&&(e.Ctor.options.name||e.tag)}function An(e,t){return Array.isArray(e)?e.indexOf(t)>-1:"string"==typeof e?e.split(",").indexOf(t)>-1:(n=e,"[object RegExp]"===a.call(n)&&e.test(t));var n}function On(e,t){var n=e.cache,r=e.keys,i=e._vnode;for(var o in n){var a=n[o];if(a){var s=a.name;s&&!t(s)&&Sn(n,o,r,i)}}}function Sn(e,t,n,r){var i=e[t];!i||r&&i.tag===r.tag||i.componentInstance.$destroy(),e[t]=null,h(n,t)}!function(t){t.prototype._init=function(t){var n=this;n._uid=$n++,n._isVue=!0,t&&t._isComponent?function(e,t){var n=e.$options=Object.create(e.constructor.options),r=t._parentVnode;n.parent=t.parent,n._parentVnode=r;var i=r.componentOptions;n.propsData=i.propsData,n._parentListeners=i.listeners,n._renderChildren=i.children,n._componentTag=i.tag,t.render&&(n.render=t.render,n.staticRenderFns=t.staticRenderFns)}(n,t):n.$options=De(wn(n.constructor),t||{},n),n._renderProxy=n,n._self=n,function(e){var t=e.$options,n=t.parent;if(n&&!t.abstract){for(;n.$options.abstract&&n.$parent;)n=n.$parent;n.$children.push(e)}e.$parent=n,e.$root=n?n.$root:e,e.$children=[],e.$refs={},e._watcher=null,e._inactive=null,e._directInactive=!1,e._isMounted=!1,e._isDestroyed=!1,e._isBeingDestroyed=!1}(n),function(e){e._events=Object.create(null),e._hasHookEvent=!1;var t=e.$options._parentListeners;t&&Wt(e,t)}(n),function(t){t._vnode=null,t._staticTrees=null;var n=t.$options,r=t.$vnode=n._parentVnode,i=r&&r.context;t.$slots=lt(n._renderChildren,i),t.$scopedSlots=e,t._c=function(e,n,r,i){return Ht(t,e,n,r,i,!1)},t.$createElement=function(e,n,r,i){return Ht(t,e,n,r,i,!0)};var o=r&&r.data;xe(t,"$attrs",o&&o.attrs||e,null,!0),xe(t,"$listeners",n._parentListeners||e,null,!0)}(n),Qt(n,"beforeCreate"),function(e){var t=ut(e.$options.inject,e);t&&($e(!1),Object.keys(t).forEach(function(n){xe(e,n,t[n])}),$e(!0))}(n),hn(n),function(e){var t=e.$options.provide;t&&(e._provided="function"==typeof t?t.call(e):t)}(n),Qt(n,"created"),n.$options.el&&n.$mount(n.$options.el)}}(Cn),function(e){var t={get:function(){return this._data}},n={get:function(){return this._props}};Object.defineProperty(e.prototype,"$data",t),Object.defineProperty(e.prototype,"$props",n),e.prototype.$set=ke,e.prototype.$delete=Ae,e.prototype.$watch=function(e,t,n){if(s(t))return bn(this,e,t,n);(n=n||{}).user=!0;var r=new pn(this,e,t,n);if(n.immediate){var i='callback for immediate watcher "'+r.expression+'"';le(),Be(t,this,[r.value],this,i),fe()}return function(){r.teardown()}}}(Cn),function(e){var t=/^hook:/;e.prototype.$on=function(e,n){var r=this;if(Array.isArray(e))for(var i=0,o=e.length;i<o;i++)r.$on(e[i],n);else(r._events[e]||(r._events[e]=[])).push(n),t.test(e)&&(r._hasHookEvent=!0);return r},e.prototype.$once=function(e,t){var n=this;function r(){n.$off(e,r),t.apply(n,arguments)}return r.fn=t,n.$on(e,r),n},e.prototype.$off=function(e,t){var n=this;if(!arguments.length)return n._events=Object.create(null),n;if(Array.isArray(e)){for(var r=0,i=e.length;r<i;r++)n.$off(e[r],t);return n}var o,a=n._events[e];if(!a)return n;if(!t)return n._events[e]=null,n;for(var s=a.length;s--;)if((o=a[s])===t||o.fn===t){a.splice(s,1);break}return n},e.prototype.$emit=function(e){var t=this._events[e];if(t){t=t.length>1?k(t):t;for(var n=k(arguments,1),r='event handler for "'+e+'"',i=0,o=t.length;i<o;i++)Be(t[i],this,n,this,r)}return this}}(Cn),function(e){e.prototype._update=function(e,t){var n=this,r=n.$el,i=n._vnode,o=Gt(n);n._vnode=e,n.$el=i?n.__patch__(i,e):n.__patch__(n.$el,e,t,!1),o(),r&&(r.__vue__=null),n.$el&&(n.$el.__vue__=n),n.$vnode&&n.$parent&&n.$vnode===n.$parent._vnode&&(n.$parent.$el=n.$el)},e.prototype.$forceUpdate=function(){this._watcher&&this._watcher.update()},e.prototype.$destroy=function(){var e=this;if(!e._isBeingDestroyed){Qt(e,"beforeDestroy"),e._isBeingDestroyed=!0;var t=e.$parent;!t||t._isBeingDestroyed||e.$options.abstract||h(t.$children,e),e._watcher&&e._watcher.teardown();for(var n=e._watchers.length;n--;)e._watchers[n].teardown();e._data.__ob__&&e._data.__ob__.vmCount--,e._isDestroyed=!0,e.__patch__(e._vnode,null),Qt(e,"destroyed"),e.$off(),e.$el&&(e.$el.__vue__=null),e.$vnode&&(e.$vnode.parent=null)}}}(Cn),function(e){Nt(e.prototype),e.prototype.$nextTick=function(e){return Qe(e,this)},e.prototype._render=function(){var e,t=this,n=t.$options,r=n.render,i=n._parentVnode;i&&(t.$scopedSlots=dt(i.data.scopedSlots,t.$slots,t.$scopedSlots)),t.$vnode=i;try{Ut=t,e=r.call(t._renderProxy,t.$createElement)}catch(n){He(n,t,"render"),e=t._vnode}finally{Ut=null}return Array.isArray(e)&&1===e.length&&(e=e[0]),e instanceof pe||(e=ve()),e.parent=i,e}}(Cn);var Tn=[String,RegExp,Array],Nn={KeepAlive:{name:"keep-alive",abstract:!0,props:{include:Tn,exclude:Tn,max:[String,Number]},methods:{cacheVNode:function(){var e=this.cache,t=this.keys,n=this.vnodeToCache,r=this.keyToCache;if(n){var i=n.tag,o=n.componentInstance,a=n.componentOptions;e[r]={name:kn(a),tag:i,componentInstance:o},t.push(r),this.max&&t.length>parseInt(this.max)&&Sn(e,t[0],t,this._vnode),this.vnodeToCache=null}}},created:function(){this.cache=Object.create(null),this.keys=[]},destroyed:function(){for(var e in this.cache)Sn(this.cache,e,this.keys)},mounted:function(){var e=this;this.cacheVNode(),this.$watch("include",function(t){On(e,function(e){return An(t,e)})}),this.$watch("exclude",function(t){On(e,function(e){return!An(t,e)})})},updated:function(){this.cacheVNode()},render:function(){var e=this.$slots.default,t=zt(e),n=t&&t.componentOptions;if(n){var r=kn(n),i=this.include,o=this.exclude;if(i&&(!r||!An(i,r))||o&&r&&An(o,r))return t;var a=this.cache,s=this.keys,c=null==t.key?n.Ctor.cid+(n.tag?"::"+n.tag:""):t.key;a[c]?(t.componentInstance=a[c].componentInstance,h(s,c),s.push(c)):(this.vnodeToCache=t,this.keyToCache=c),t.data.keepAlive=!0}return t||e&&e[0]}}};!function(e){var t={get:function(){return F}};Object.defineProperty(e,"config",t),e.util={warn:ae,extend:A,mergeOptions:De,defineReactive:xe},e.set=ke,e.delete=Ae,e.nextTick=Qe,e.observable=function(e){return Ce(e),e},e.options=Object.create(null),I.forEach(function(t){e.options[t+"s"]=Object.create(null)}),e.options._base=e,A(e.options.components,Nn),function(e){e.use=function(e){var t=this._installedPlugins||(this._installedPlugins=[]);if(t.indexOf(e)>-1)return this;var n=k(arguments,1);return n.unshift(this),"function"==typeof e.install?e.install.apply(e,n):"function"==typeof e&&e.apply(null,n),t.push(e),this}}(e),function(e){e.mixin=function(e){return this.options=De(this.options,e),this}}(e),xn(e),function(e){I.forEach(function(t){e[t]=function(e,n){return n?("component"===t&&s(n)&&(n.name=n.name||e,n=this.options._base.extend(n)),"directive"===t&&"function"==typeof n&&(n={bind:n,update:n}),this.options[t+"s"][e]=n,n):this.options[t+"s"][e]}})}(e)}(Cn),Object.defineProperty(Cn.prototype,"$isServer",{get:te}),Object.defineProperty(Cn.prototype,"$ssrContext",{get:function(){return this.$vnode&&this.$vnode.ssrContext}}),Object.defineProperty(Cn,"FunctionalRenderContext",{value:Et}),Cn.version="2.6.14";var En=p("style,class"),jn=p("input,textarea,option,select,progress"),Dn=function(e,t,n){return"value"===n&&jn(e)&&"button"!==t||"selected"===n&&"option"===e||"checked"===n&&"input"===e||"muted"===n&&"video"===e},Ln=p("contenteditable,draggable,spellcheck"),In=p("events,caret,typing,plaintext-only"),Mn=function(e,t){return Bn(t)||"false"===t?"false":"contenteditable"===e&&In(t)?t:"true"},Fn=p("allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,default,defaultchecked,defaultmuted,defaultselected,defer,disabled,enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,required,reversed,scoped,seamless,selected,sortable,truespeed,typemustmatch,visible"),Pn="http://www.w3.org/1999/xlink",Rn=function(e){return":"===e.charAt(5)&&"xlink"===e.slice(0,5)},Hn=function(e){return Rn(e)?e.slice(6,e.length):""},Bn=function(e){return null==e||!1===e};function Un(e){for(var t=e.data,r=e,i=e;n(i.componentInstance);)(i=i.componentInstance._vnode)&&i.data&&(t=Vn(i.data,t));for(;n(r=r.parent);)r&&r.data&&(t=Vn(t,r.data));return function(e,t){if(n(e)||n(t))return zn(e,Kn(t));return""}(t.staticClass,t.class)}function Vn(e,t){return{staticClass:zn(e.staticClass,t.staticClass),class:n(e.class)?[e.class,t.class]:t.class}}function zn(e,t){return e?t?e+" "+t:e:t||""}function Kn(e){return Array.isArray(e)?function(e){for(var t,r="",i=0,o=e.length;i<o;i++)n(t=Kn(e[i]))&&""!==t&&(r&&(r+=" "),r+=t);return r}(e):o(e)?function(e){var t="";for(var n in e)e[n]&&(t&&(t+=" "),t+=n);return t}(e):"string"==typeof e?e:""}var Jn={svg:"http://www.w3.org/2000/svg",math:"http://www.w3.org/1998/Math/MathML"},qn=p("html,body,base,head,link,meta,style,title,address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,s,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,embed,object,param,source,canvas,script,noscript,del,ins,caption,col,colgroup,table,thead,tbody,td,th,tr,button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,output,progress,select,textarea,details,dialog,menu,menuitem,summary,content,element,shadow,template,blockquote,iframe,tfoot"),Wn=p("svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,foreignobject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view",!0),Zn=function(e){return qn(e)||Wn(e)};function Gn(e){return Wn(e)?"svg":"math"===e?"math":void 0}var Xn=Object.create(null);var Yn=p("text,number,password,search,email,tel,url");function Qn(e){if("string"==typeof e){var t=document.querySelector(e);return t||document.createElement("div")}return e}var er=Object.freeze({createElement:function(e,t){var n=document.createElement(e);return"select"!==e?n:(t.data&&t.data.attrs&&void 0!==t.data.attrs.multiple&&n.setAttribute("multiple","multiple"),n)},createElementNS:function(e,t){return document.createElementNS(Jn[e],t)},createTextNode:function(e){return document.createTextNode(e)},createComment:function(e){return document.createComment(e)},insertBefore:function(e,t,n){e.insertBefore(t,n)},removeChild:function(e,t){e.removeChild(t)},appendChild:function(e,t){e.appendChild(t)},parentNode:function(e){return e.parentNode},nextSibling:function(e){return e.nextSibling},tagName:function(e){return e.tagName},setTextContent:function(e,t){e.textContent=t},setStyleScope:function(e,t){e.setAttribute(t,"")}}),tr={create:function(e,t){nr(t)},update:function(e,t){e.data.ref!==t.data.ref&&(nr(e,!0),nr(t))},destroy:function(e){nr(e,!0)}};function nr(e,t){var r=e.data.ref;if(n(r)){var i=e.context,o=e.componentInstance||e.elm,a=i.$refs;t?Array.isArray(a[r])?h(a[r],o):a[r]===o&&(a[r]=void 0):e.data.refInFor?Array.isArray(a[r])?a[r].indexOf(o)<0&&a[r].push(o):a[r]=[o]:a[r]=o}}var rr=new pe("",{},[]),ir=["create","activate","update","remove","destroy"];function or(e,i){return e.key===i.key&&e.asyncFactory===i.asyncFactory&&(e.tag===i.tag&&e.isComment===i.isComment&&n(e.data)===n(i.data)&&function(e,t){if("input"!==e.tag)return!0;var r,i=n(r=e.data)&&n(r=r.attrs)&&r.type,o=n(r=t.data)&&n(r=r.attrs)&&r.type;return i===o||Yn(i)&&Yn(o)}(e,i)||r(e.isAsyncPlaceholder)&&t(i.asyncFactory.error))}function ar(e,t,r){var i,o,a={};for(i=t;i<=r;++i)n(o=e[i].key)&&(a[o]=i);return a}var sr={create:cr,update:cr,destroy:function(e){cr(e,rr)}};function cr(e,t){(e.data.directives||t.data.directives)&&function(e,t){var n,r,i,o=e===rr,a=t===rr,s=lr(e.data.directives,e.context),c=lr(t.data.directives,t.context),u=[],l=[];for(n in c)r=s[n],i=c[n],r?(i.oldValue=r.value,i.oldArg=r.arg,pr(i,"update",t,e),i.def&&i.def.componentUpdated&&l.push(i)):(pr(i,"bind",t,e),i.def&&i.def.inserted&&u.push(i));if(u.length){var f=function(){for(var n=0;n<u.length;n++)pr(u[n],"inserted",t,e)};o?ot(t,"insert",f):f()}l.length&&ot(t,"postpatch",function(){for(var n=0;n<l.length;n++)pr(l[n],"componentUpdated",t,e)});if(!o)for(n in s)c[n]||pr(s[n],"unbind",e,e,a)}(e,t)}var ur=Object.create(null);function lr(e,t){var n,r,i=Object.create(null);if(!e)return i;for(n=0;n<e.length;n++)(r=e[n]).modifiers||(r.modifiers=ur),i[fr(r)]=r,r.def=Le(t.$options,"directives",r.name);return i}function fr(e){return e.rawName||e.name+"."+Object.keys(e.modifiers||{}).join(".")}function pr(e,t,n,r,i){var o=e.def&&e.def[t];if(o)try{o(n.elm,e,n,r,i)}catch(r){He(r,n.context,"directive "+e.name+" "+t+" hook")}}var dr=[tr,sr];function vr(e,r){var i=r.componentOptions;if(!(n(i)&&!1===i.Ctor.options.inheritAttrs||t(e.data.attrs)&&t(r.data.attrs))){var o,a,s=r.elm,c=e.data.attrs||{},u=r.data.attrs||{};for(o in n(u.__ob__)&&(u=r.data.attrs=A({},u)),u)a=u[o],c[o]!==a&&hr(s,o,a,r.data.pre);for(o in(q||Z)&&u.value!==c.value&&hr(s,"value",u.value),c)t(u[o])&&(Rn(o)?s.removeAttributeNS(Pn,Hn(o)):Ln(o)||s.removeAttribute(o))}}function hr(e,t,n,r){r||e.tagName.indexOf("-")>-1?mr(e,t,n):Fn(t)?Bn(n)?e.removeAttribute(t):(n="allowfullscreen"===t&&"EMBED"===e.tagName?"true":t,e.setAttribute(t,n)):Ln(t)?e.setAttribute(t,Mn(t,n)):Rn(t)?Bn(n)?e.removeAttributeNS(Pn,Hn(t)):e.setAttributeNS(Pn,t,n):mr(e,t,n)}function mr(e,t,n){if(Bn(n))e.removeAttribute(t);else{if(q&&!W&&"TEXTAREA"===e.tagName&&"placeholder"===t&&""!==n&&!e.__ieph){var r=function(t){t.stopImmediatePropagation(),e.removeEventListener("input",r)};e.addEventListener("input",r),e.__ieph=!0}e.setAttribute(t,n)}}var yr={create:vr,update:vr};function gr(e,r){var i=r.elm,o=r.data,a=e.data;if(!(t(o.staticClass)&&t(o.class)&&(t(a)||t(a.staticClass)&&t(a.class)))){var s=Un(r),c=i._transitionClasses;n(c)&&(s=zn(s,Kn(c))),s!==i._prevClass&&(i.setAttribute("class",s),i._prevClass=s)}}var _r,br,$r,wr,Cr,xr,kr={create:gr,update:gr},Ar=/[\w).+\-_$\]]/;function Or(e){var t,n,r,i,o,a=!1,s=!1,c=!1,u=!1,l=0,f=0,p=0,d=0;for(r=0;r<e.length;r++)if(n=t,t=e.charCodeAt(r),a)39===t&&92!==n&&(a=!1);else if(s)34===t&&92!==n&&(s=!1);else if(c)96===t&&92!==n&&(c=!1);else if(u)47===t&&92!==n&&(u=!1);else if(124!==t||124===e.charCodeAt(r+1)||124===e.charCodeAt(r-1)||l||f||p){switch(t){case 34:s=!0;break;case 39:a=!0;break;case 96:c=!0;break;case 40:p++;break;case 41:p--;break;case 91:f++;break;case 93:f--;break;case 123:l++;break;case 125:l--}if(47===t){for(var v=r-1,h=void 0;v>=0&&" "===(h=e.charAt(v));v--);h&&Ar.test(h)||(u=!0)}}else void 0===i?(d=r+1,i=e.slice(0,r).trim()):m();function m(){(o||(o=[])).push(e.slice(d,r).trim()),d=r+1}if(void 0===i?i=e.slice(0,r).trim():0!==d&&m(),o)for(r=0;r<o.length;r++)i=Sr(i,o[r]);return i}function Sr(e,t){var n=t.indexOf("(");if(n<0)return'_f("'+t+'")('+e+")";var r=t.slice(0,n),i=t.slice(n+1);return'_f("'+r+'")('+e+(")"!==i?","+i:i)}function Tr(e,t){console.error("[Vue compiler]: "+e)}function Nr(e,t){return e?e.map(function(e){return e[t]}).filter(function(e){return e}):[]}function Er(e,t,n,r,i){(e.props||(e.props=[])).push(Hr({name:t,value:n,dynamic:i},r)),e.plain=!1}function jr(e,t,n,r,i){(i?e.dynamicAttrs||(e.dynamicAttrs=[]):e.attrs||(e.attrs=[])).push(Hr({name:t,value:n,dynamic:i},r)),e.plain=!1}function Dr(e,t,n,r){e.attrsMap[t]=n,e.attrsList.push(Hr({name:t,value:n},r))}function Lr(e,t,n,r,i,o,a,s){(e.directives||(e.directives=[])).push(Hr({name:t,rawName:n,value:r,arg:i,isDynamicArg:o,modifiers:a},s)),e.plain=!1}function Ir(e,t,n){return n?"_p("+t+',"'+e+'")':e+t}function Mr(t,n,r,i,o,a,s,c){var u;(i=i||e).right?c?n="("+n+")==='click'?'contextmenu':("+n+")":"click"===n&&(n="contextmenu",delete i.right):i.middle&&(c?n="("+n+")==='click'?'mouseup':("+n+")":"click"===n&&(n="mouseup")),i.capture&&(delete i.capture,n=Ir("!",n,c)),i.once&&(delete i.once,n=Ir("~",n,c)),i.passive&&(delete i.passive,n=Ir("&",n,c)),i.native?(delete i.native,u=t.nativeEvents||(t.nativeEvents={})):u=t.events||(t.events={});var l=Hr({value:r.trim(),dynamic:c},s);i!==e&&(l.modifiers=i);var f=u[n];Array.isArray(f)?o?f.unshift(l):f.push(l):u[n]=f?o?[l,f]:[f,l]:l,t.plain=!1}function Fr(e,t,n){var r=Pr(e,":"+t)||Pr(e,"v-bind:"+t);if(null!=r)return Or(r);if(!1!==n){var i=Pr(e,t);if(null!=i)return JSON.stringify(i)}}function Pr(e,t,n){var r;if(null!=(r=e.attrsMap[t]))for(var i=e.attrsList,o=0,a=i.length;o<a;o++)if(i[o].name===t){i.splice(o,1);break}return n&&delete e.attrsMap[t],r}function Rr(e,t){for(var n=e.attrsList,r=0,i=n.length;r<i;r++){var o=n[r];if(t.test(o.name))return n.splice(r,1),o}}function Hr(e,t){return t&&(null!=t.start&&(e.start=t.start),null!=t.end&&(e.end=t.end)),e}function Br(e,t,n){var r=n||{},i=r.number,o="$$v";r.trim&&(o="(typeof $$v === 'string'? $$v.trim(): $$v)"),i&&(o="_n("+o+")");var a=Ur(t,o);e.model={value:"("+t+")",expression:JSON.stringify(t),callback:"function ($$v) {"+a+"}"}}function Ur(e,t){var n=function(e){if(e=e.trim(),_r=e.length,e.indexOf("[")<0||e.lastIndexOf("]")<_r-1)return(wr=e.lastIndexOf("."))>-1?{exp:e.slice(0,wr),key:'"'+e.slice(wr+1)+'"'}:{exp:e,key:null};br=e,wr=Cr=xr=0;for(;!zr();)Kr($r=Vr())?qr($r):91===$r&&Jr($r);return{exp:e.slice(0,Cr),key:e.slice(Cr+1,xr)}}(e);return null===n.key?e+"="+t:"$set("+n.exp+", "+n.key+", "+t+")"}function Vr(){return br.charCodeAt(++wr)}function zr(){return wr>=_r}function Kr(e){return 34===e||39===e}function Jr(e){var t=1;for(Cr=wr;!zr();)if(Kr(e=Vr()))qr(e);else if(91===e&&t++,93===e&&t--,0===t){xr=wr;break}}function qr(e){for(var t=e;!zr()&&(e=Vr())!==t;);}var Wr,Zr="__r",Gr="__c";function Xr(e,t,n){var r=Wr;return function i(){null!==t.apply(null,arguments)&&ei(e,i,n,r)}}var Yr=Ke&&!(X&&Number(X[1])<=53);function Qr(e,t,n,r){if(Yr){var i=sn,o=t;t=o._wrapper=function(e){if(e.target===e.currentTarget||e.timeStamp>=i||e.timeStamp<=0||e.target.ownerDocument!==document)return o.apply(this,arguments)}}Wr.addEventListener(e,t,Q?{capture:n,passive:r}:n)}function ei(e,t,n,r){(r||Wr).removeEventListener(e,t._wrapper||t,n)}function ti(e,r){if(!t(e.data.on)||!t(r.data.on)){var i=r.data.on||{},o=e.data.on||{};Wr=r.elm,function(e){if(n(e[Zr])){var t=q?"change":"input";e[t]=[].concat(e[Zr],e[t]||[]),delete e[Zr]}n(e[Gr])&&(e.change=[].concat(e[Gr],e.change||[]),delete e[Gr])}(i),it(i,o,Qr,ei,Xr,r.context),Wr=void 0}}var ni,ri={create:ti,update:ti};function ii(e,r){if(!t(e.data.domProps)||!t(r.data.domProps)){var i,o,a=r.elm,s=e.data.domProps||{},c=r.data.domProps||{};for(i in n(c.__ob__)&&(c=r.data.domProps=A({},c)),s)i in c||(a[i]="");for(i in c){if(o=c[i],"textContent"===i||"innerHTML"===i){if(r.children&&(r.children.length=0),o===s[i])continue;1===a.childNodes.length&&a.removeChild(a.childNodes[0])}if("value"===i&&"PROGRESS"!==a.tagName){a._value=o;var u=t(o)?"":String(o);oi(a,u)&&(a.value=u)}else if("innerHTML"===i&&Wn(a.tagName)&&t(a.innerHTML)){(ni=ni||document.createElement("div")).innerHTML="<svg>"+o+"</svg>";for(var l=ni.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;l.firstChild;)a.appendChild(l.firstChild)}else if(o!==s[i])try{a[i]=o}catch(e){}}}}function oi(e,t){return!e.composing&&("OPTION"===e.tagName||function(e,t){var n=!0;try{n=document.activeElement!==e}catch(e){}return n&&e.value!==t}(e,t)||function(e,t){var r=e.value,i=e._vModifiers;if(n(i)){if(i.number)return f(r)!==f(t);if(i.trim)return r.trim()!==t.trim()}return r!==t}(e,t))}var ai={create:ii,update:ii},si=g(function(e){var t={},n=/:(.+)/;return e.split(/;(?![^(]*\))/g).forEach(function(e){if(e){var r=e.split(n);r.length>1&&(t[r[0].trim()]=r[1].trim())}}),t});function ci(e){var t=ui(e.style);return e.staticStyle?A(e.staticStyle,t):t}function ui(e){return Array.isArray(e)?O(e):"string"==typeof e?si(e):e}var li,fi=/^--/,pi=/\s*!important$/,di=function(e,t,n){if(fi.test(t))e.style.setProperty(t,n);else if(pi.test(n))e.style.setProperty(C(t),n.replace(pi,""),"important");else{var r=hi(t);if(Array.isArray(n))for(var i=0,o=n.length;i<o;i++)e.style[r]=n[i];else e.style[r]=n}},vi=["Webkit","Moz","ms"],hi=g(function(e){if(li=li||document.createElement("div").style,"filter"!==(e=b(e))&&e in li)return e;for(var t=e.charAt(0).toUpperCase()+e.slice(1),n=0;n<vi.length;n++){var r=vi[n]+t;if(r in li)return r}});function mi(e,r){var i=r.data,o=e.data;if(!(t(i.staticStyle)&&t(i.style)&&t(o.staticStyle)&&t(o.style))){var a,s,c=r.elm,u=o.staticStyle,l=o.normalizedStyle||o.style||{},f=u||l,p=ui(r.data.style)||{};r.data.normalizedStyle=n(p.__ob__)?A({},p):p;var d=function(e,t){var n,r={};if(t)for(var i=e;i.componentInstance;)(i=i.componentInstance._vnode)&&i.data&&(n=ci(i.data))&&A(r,n);(n=ci(e.data))&&A(r,n);for(var o=e;o=o.parent;)o.data&&(n=ci(o.data))&&A(r,n);return r}(r,!0);for(s in f)t(d[s])&&di(c,s,"");for(s in d)(a=d[s])!==f[s]&&di(c,s,null==a?"":a)}}var yi={create:mi,update:mi},gi=/\s+/;function _i(e,t){if(t&&(t=t.trim()))if(e.classList)t.indexOf(" ")>-1?t.split(gi).forEach(function(t){return e.classList.add(t)}):e.classList.add(t);else{var n=" "+(e.getAttribute("class")||"")+" ";n.indexOf(" "+t+" ")<0&&e.setAttribute("class",(n+t).trim())}}function bi(e,t){if(t&&(t=t.trim()))if(e.classList)t.indexOf(" ")>-1?t.split(gi).forEach(function(t){return e.classList.remove(t)}):e.classList.remove(t),e.classList.length||e.removeAttribute("class");else{for(var n=" "+(e.getAttribute("class")||"")+" ",r=" "+t+" ";n.indexOf(r)>=0;)n=n.replace(r," ");(n=n.trim())?e.setAttribute("class",n):e.removeAttribute("class")}}function $i(e){if(e){if("object"==typeof e){var t={};return!1!==e.css&&A(t,wi(e.name||"v")),A(t,e),t}return"string"==typeof e?wi(e):void 0}}var wi=g(function(e){return{enterClass:e+"-enter",enterToClass:e+"-enter-to",enterActiveClass:e+"-enter-active",leaveClass:e+"-leave",leaveToClass:e+"-leave-to",leaveActiveClass:e+"-leave-active"}}),Ci=V&&!W,xi="transition",ki="animation",Ai="transition",Oi="transitionend",Si="animation",Ti="animationend";Ci&&(void 0===window.ontransitionend&&void 0!==window.onwebkittransitionend&&(Ai="WebkitTransition",Oi="webkitTransitionEnd"),void 0===window.onanimationend&&void 0!==window.onwebkitanimationend&&(Si="WebkitAnimation",Ti="webkitAnimationEnd"));var Ni=V?window.requestAnimationFrame?window.requestAnimationFrame.bind(window):setTimeout:function(e){return e()};function Ei(e){Ni(function(){Ni(e)})}function ji(e,t){var n=e._transitionClasses||(e._transitionClasses=[]);n.indexOf(t)<0&&(n.push(t),_i(e,t))}function Di(e,t){e._transitionClasses&&h(e._transitionClasses,t),bi(e,t)}function Li(e,t,n){var r=Mi(e,t),i=r.type,o=r.timeout,a=r.propCount;if(!i)return n();var s=i===xi?Oi:Ti,c=0,u=function(){e.removeEventListener(s,l),n()},l=function(t){t.target===e&&++c>=a&&u()};setTimeout(function(){c<a&&u()},o+1),e.addEventListener(s,l)}var Ii=/\b(transform|all)(,|$)/;function Mi(e,t){var n,r=window.getComputedStyle(e),i=(r[Ai+"Delay"]||"").split(", "),o=(r[Ai+"Duration"]||"").split(", "),a=Fi(i,o),s=(r[Si+"Delay"]||"").split(", "),c=(r[Si+"Duration"]||"").split(", "),u=Fi(s,c),l=0,f=0;return t===xi?a>0&&(n=xi,l=a,f=o.length):t===ki?u>0&&(n=ki,l=u,f=c.length):f=(n=(l=Math.max(a,u))>0?a>u?xi:ki:null)?n===xi?o.length:c.length:0,{type:n,timeout:l,propCount:f,hasTransform:n===xi&&Ii.test(r[Ai+"Property"])}}function Fi(e,t){for(;e.length<t.length;)e=e.concat(e);return Math.max.apply(null,t.map(function(t,n){return Pi(t)+Pi(e[n])}))}function Pi(e){return 1e3*Number(e.slice(0,-1).replace(",","."))}function Ri(e,r){var i=e.elm;n(i._leaveCb)&&(i._leaveCb.cancelled=!0,i._leaveCb());var a=$i(e.data.transition);if(!t(a)&&!n(i._enterCb)&&1===i.nodeType){for(var s=a.css,c=a.type,u=a.enterClass,l=a.enterToClass,p=a.enterActiveClass,d=a.appearClass,v=a.appearToClass,h=a.appearActiveClass,m=a.beforeEnter,y=a.enter,g=a.afterEnter,_=a.enterCancelled,b=a.beforeAppear,$=a.appear,w=a.afterAppear,C=a.appearCancelled,x=a.duration,k=Zt,A=Zt.$vnode;A&&A.parent;)k=A.context,A=A.parent;var O=!k._isMounted||!e.isRootInsert;if(!O||$||""===$){var S=O&&d?d:u,T=O&&h?h:p,N=O&&v?v:l,E=O&&b||m,j=O&&"function"==typeof $?$:y,L=O&&w||g,I=O&&C||_,M=f(o(x)?x.enter:x),F=!1!==s&&!W,P=Ui(j),R=i._enterCb=D(function(){F&&(Di(i,N),Di(i,T)),R.cancelled?(F&&Di(i,S),I&&I(i)):L&&L(i),i._enterCb=null});e.data.show||ot(e,"insert",function(){var t=i.parentNode,n=t&&t._pending&&t._pending[e.key];n&&n.tag===e.tag&&n.elm._leaveCb&&n.elm._leaveCb(),j&&j(i,R)}),E&&E(i),F&&(ji(i,S),ji(i,T),Ei(function(){Di(i,S),R.cancelled||(ji(i,N),P||(Bi(M)?setTimeout(R,M):Li(i,c,R)))})),e.data.show&&(r&&r(),j&&j(i,R)),F||P||R()}}}function Hi(e,r){var i=e.elm;n(i._enterCb)&&(i._enterCb.cancelled=!0,i._enterCb());var a=$i(e.data.transition);if(t(a)||1!==i.nodeType)return r();if(!n(i._leaveCb)){var s=a.css,c=a.type,u=a.leaveClass,l=a.leaveToClass,p=a.leaveActiveClass,d=a.beforeLeave,v=a.leave,h=a.afterLeave,m=a.leaveCancelled,y=a.delayLeave,g=a.duration,_=!1!==s&&!W,b=Ui(v),$=f(o(g)?g.leave:g),w=i._leaveCb=D(function(){i.parentNode&&i.parentNode._pending&&(i.parentNode._pending[e.key]=null),_&&(Di(i,l),Di(i,p)),w.cancelled?(_&&Di(i,u),m&&m(i)):(r(),h&&h(i)),i._leaveCb=null});y?y(C):C()}function C(){w.cancelled||(!e.data.show&&i.parentNode&&((i.parentNode._pending||(i.parentNode._pending={}))[e.key]=e),d&&d(i),_&&(ji(i,u),ji(i,p),Ei(function(){Di(i,u),w.cancelled||(ji(i,l),b||(Bi($)?setTimeout(w,$):Li(i,c,w)))})),v&&v(i,w),_||b||w())}}function Bi(e){return"number"==typeof e&&!isNaN(e)}function Ui(e){if(t(e))return!1;var r=e.fns;return n(r)?Ui(Array.isArray(r)?r[0]:r):(e._length||e.length)>1}function Vi(e,t){!0!==t.data.show&&Ri(t)}var zi=function(e){var o,a,s={},c=e.modules,u=e.nodeOps;for(o=0;o<ir.length;++o)for(s[ir[o]]=[],a=0;a<c.length;++a)n(c[a][ir[o]])&&s[ir[o]].push(c[a][ir[o]]);function l(e){var t=u.parentNode(e);n(t)&&u.removeChild(t,e)}function f(e,t,i,o,a,c,l){if(n(e.elm)&&n(c)&&(e=c[l]=me(e)),e.isRootInsert=!a,!function(e,t,i,o){var a=e.data;if(n(a)){var c=n(e.componentInstance)&&a.keepAlive;if(n(a=a.hook)&&n(a=a.init)&&a(e,!1),n(e.componentInstance))return d(e,t),v(i,e.elm,o),r(c)&&function(e,t,r,i){for(var o,a=e;a.componentInstance;)if(a=a.componentInstance._vnode,n(o=a.data)&&n(o=o.transition)){for(o=0;o<s.activate.length;++o)s.activate[o](rr,a);t.push(a);break}v(r,e.elm,i)}(e,t,i,o),!0}}(e,t,i,o)){var f=e.data,p=e.children,m=e.tag;n(m)?(e.elm=e.ns?u.createElementNS(e.ns,m):u.createElement(m,e),g(e),h(e,p,t),n(f)&&y(e,t),v(i,e.elm,o)):r(e.isComment)?(e.elm=u.createComment(e.text),v(i,e.elm,o)):(e.elm=u.createTextNode(e.text),v(i,e.elm,o))}}function d(e,t){n(e.data.pendingInsert)&&(t.push.apply(t,e.data.pendingInsert),e.data.pendingInsert=null),e.elm=e.componentInstance.$el,m(e)?(y(e,t),g(e)):(nr(e),t.push(e))}function v(e,t,r){n(e)&&(n(r)?u.parentNode(r)===e&&u.insertBefore(e,t,r):u.appendChild(e,t))}function h(e,t,n){if(Array.isArray(t))for(var r=0;r<t.length;++r)f(t[r],n,e.elm,null,!0,t,r);else i(e.text)&&u.appendChild(e.elm,u.createTextNode(String(e.text)))}function m(e){for(;e.componentInstance;)e=e.componentInstance._vnode;return n(e.tag)}function y(e,t){for(var r=0;r<s.create.length;++r)s.create[r](rr,e);n(o=e.data.hook)&&(n(o.create)&&o.create(rr,e),n(o.insert)&&t.push(e))}function g(e){var t;if(n(t=e.fnScopeId))u.setStyleScope(e.elm,t);else for(var r=e;r;)n(t=r.context)&&n(t=t.$options._scopeId)&&u.setStyleScope(e.elm,t),r=r.parent;n(t=Zt)&&t!==e.context&&t!==e.fnContext&&n(t=t.$options._scopeId)&&u.setStyleScope(e.elm,t)}function _(e,t,n,r,i,o){for(;r<=i;++r)f(n[r],o,e,t,!1,n,r)}function b(e){var t,r,i=e.data;if(n(i))for(n(t=i.hook)&&n(t=t.destroy)&&t(e),t=0;t<s.destroy.length;++t)s.destroy[t](e);if(n(t=e.children))for(r=0;r<e.children.length;++r)b(e.children[r])}function $(e,t,r){for(;t<=r;++t){var i=e[t];n(i)&&(n(i.tag)?(w(i),b(i)):l(i.elm))}}function w(e,t){if(n(t)||n(e.data)){var r,i=s.remove.length+1;for(n(t)?t.listeners+=i:t=function(e,t){function n(){0==--n.listeners&&l(e)}return n.listeners=t,n}(e.elm,i),n(r=e.componentInstance)&&n(r=r._vnode)&&n(r.data)&&w(r,t),r=0;r<s.remove.length;++r)s.remove[r](e,t);n(r=e.data.hook)&&n(r=r.remove)?r(e,t):t()}else l(e.elm)}function C(e,t,r,i){for(var o=r;o<i;o++){var a=t[o];if(n(a)&&or(e,a))return o}}function x(e,i,o,a,c,l){if(e!==i){n(i.elm)&&n(a)&&(i=a[c]=me(i));var p=i.elm=e.elm;if(r(e.isAsyncPlaceholder))n(i.asyncFactory.resolved)?O(e.elm,i,o):i.isAsyncPlaceholder=!0;else if(r(i.isStatic)&&r(e.isStatic)&&i.key===e.key&&(r(i.isCloned)||r(i.isOnce)))i.componentInstance=e.componentInstance;else{var d,v=i.data;n(v)&&n(d=v.hook)&&n(d=d.prepatch)&&d(e,i);var h=e.children,y=i.children;if(n(v)&&m(i)){for(d=0;d<s.update.length;++d)s.update[d](e,i);n(d=v.hook)&&n(d=d.update)&&d(e,i)}t(i.text)?n(h)&&n(y)?h!==y&&function(e,r,i,o,a){for(var s,c,l,p=0,d=0,v=r.length-1,h=r[0],m=r[v],y=i.length-1,g=i[0],b=i[y],w=!a;p<=v&&d<=y;)t(h)?h=r[++p]:t(m)?m=r[--v]:or(h,g)?(x(h,g,o,i,d),h=r[++p],g=i[++d]):or(m,b)?(x(m,b,o,i,y),m=r[--v],b=i[--y]):or(h,b)?(x(h,b,o,i,y),w&&u.insertBefore(e,h.elm,u.nextSibling(m.elm)),h=r[++p],b=i[--y]):or(m,g)?(x(m,g,o,i,d),w&&u.insertBefore(e,m.elm,h.elm),m=r[--v],g=i[++d]):(t(s)&&(s=ar(r,p,v)),t(c=n(g.key)?s[g.key]:C(g,r,p,v))?f(g,o,e,h.elm,!1,i,d):or(l=r[c],g)?(x(l,g,o,i,d),r[c]=void 0,w&&u.insertBefore(e,l.elm,h.elm)):f(g,o,e,h.elm,!1,i,d),g=i[++d]);p>v?_(e,t(i[y+1])?null:i[y+1].elm,i,d,y,o):d>y&&$(r,p,v)}(p,h,y,o,l):n(y)?(n(e.text)&&u.setTextContent(p,""),_(p,null,y,0,y.length-1,o)):n(h)?$(h,0,h.length-1):n(e.text)&&u.setTextContent(p,""):e.text!==i.text&&u.setTextContent(p,i.text),n(v)&&n(d=v.hook)&&n(d=d.postpatch)&&d(e,i)}}}function k(e,t,i){if(r(i)&&n(e.parent))e.parent.data.pendingInsert=t;else for(var o=0;o<t.length;++o)t[o].data.hook.insert(t[o])}var A=p("attrs,class,staticClass,staticStyle,key");function O(e,t,i,o){var a,s=t.tag,c=t.data,u=t.children;if(o=o||c&&c.pre,t.elm=e,r(t.isComment)&&n(t.asyncFactory))return t.isAsyncPlaceholder=!0,!0;if(n(c)&&(n(a=c.hook)&&n(a=a.init)&&a(t,!0),n(a=t.componentInstance)))return d(t,i),!0;if(n(s)){if(n(u))if(e.hasChildNodes())if(n(a=c)&&n(a=a.domProps)&&n(a=a.innerHTML)){if(a!==e.innerHTML)return!1}else{for(var l=!0,f=e.firstChild,p=0;p<u.length;p++){if(!f||!O(f,u[p],i,o)){l=!1;break}f=f.nextSibling}if(!l||f)return!1}else h(t,u,i);if(n(c)){var v=!1;for(var m in c)if(!A(m)){v=!0,y(t,i);break}!v&&c.class&&tt(c.class)}}else e.data!==t.text&&(e.data=t.text);return!0}return function(e,i,o,a){if(!t(i)){var c,l=!1,p=[];if(t(e))l=!0,f(i,p);else{var d=n(e.nodeType);if(!d&&or(e,i))x(e,i,p,null,null,a);else{if(d){if(1===e.nodeType&&e.hasAttribute(L)&&(e.removeAttribute(L),o=!0),r(o)&&O(e,i,p))return k(i,p,!0),e;c=e,e=new pe(u.tagName(c).toLowerCase(),{},[],void 0,c)}var v=e.elm,h=u.parentNode(v);if(f(i,p,v._leaveCb?null:h,u.nextSibling(v)),n(i.parent))for(var y=i.parent,g=m(i);y;){for(var _=0;_<s.destroy.length;++_)s.destroy[_](y);if(y.elm=i.elm,g){for(var w=0;w<s.create.length;++w)s.create[w](rr,y);var C=y.data.hook.insert;if(C.merged)for(var A=1;A<C.fns.length;A++)C.fns[A]()}else nr(y);y=y.parent}n(h)?$([e],0,0):n(e.tag)&&b(e)}}return k(i,p,l),i.elm}n(e)&&b(e)}}({nodeOps:er,modules:[yr,kr,ri,ai,yi,V?{create:Vi,activate:Vi,remove:function(e,t){!0!==e.data.show?Hi(e,t):t()}}:{}].concat(dr)});W&&document.addEventListener("selectionchange",function(){var e=document.activeElement;e&&e.vmodel&&Yi(e,"input")});var Ki={inserted:function(e,t,n,r){"select"===n.tag?(r.elm&&!r.elm._vOptions?ot(n,"postpatch",function(){Ki.componentUpdated(e,t,n)}):Ji(e,t,n.context),e._vOptions=[].map.call(e.options,Zi)):("textarea"===n.tag||Yn(e.type))&&(e._vModifiers=t.modifiers,t.modifiers.lazy||(e.addEventListener("compositionstart",Gi),e.addEventListener("compositionend",Xi),e.addEventListener("change",Xi),W&&(e.vmodel=!0)))},componentUpdated:function(e,t,n){if("select"===n.tag){Ji(e,t,n.context);var r=e._vOptions,i=e._vOptions=[].map.call(e.options,Zi);if(i.some(function(e,t){return!E(e,r[t])}))(e.multiple?t.value.some(function(e){return Wi(e,i)}):t.value!==t.oldValue&&Wi(t.value,i))&&Yi(e,"change")}}};function Ji(e,t,n){qi(e,t,n),(q||Z)&&setTimeout(function(){qi(e,t,n)},0)}function qi(e,t,n){var r=t.value,i=e.multiple;if(!i||Array.isArray(r)){for(var o,a,s=0,c=e.options.length;s<c;s++)if(a=e.options[s],i)o=j(r,Zi(a))>-1,a.selected!==o&&(a.selected=o);else if(E(Zi(a),r))return void(e.selectedIndex!==s&&(e.selectedIndex=s));i||(e.selectedIndex=-1)}}function Wi(e,t){return t.every(function(t){return!E(t,e)})}function Zi(e){return"_value"in e?e._value:e.value}function Gi(e){e.target.composing=!0}function Xi(e){e.target.composing&&(e.target.composing=!1,Yi(e.target,"input"))}function Yi(e,t){var n=document.createEvent("HTMLEvents");n.initEvent(t,!0,!0),e.dispatchEvent(n)}function Qi(e){return!e.componentInstance||e.data&&e.data.transition?e:Qi(e.componentInstance._vnode)}var eo={model:Ki,show:{bind:function(e,t,n){var r=t.value,i=(n=Qi(n)).data&&n.data.transition,o=e.__vOriginalDisplay="none"===e.style.display?"":e.style.display;r&&i?(n.data.show=!0,Ri(n,function(){e.style.display=o})):e.style.display=r?o:"none"},update:function(e,t,n){var r=t.value;!r!=!t.oldValue&&((n=Qi(n)).data&&n.data.transition?(n.data.show=!0,r?Ri(n,function(){e.style.display=e.__vOriginalDisplay}):Hi(n,function(){e.style.display="none"})):e.style.display=r?e.__vOriginalDisplay:"none")},unbind:function(e,t,n,r,i){i||(e.style.display=e.__vOriginalDisplay)}}},to={name:String,appear:Boolean,css:Boolean,mode:String,type:String,enterClass:String,leaveClass:String,enterToClass:String,leaveToClass:String,enterActiveClass:String,leaveActiveClass:String,appearClass:String,appearActiveClass:String,appearToClass:String,duration:[Number,String,Object]};function no(e){var t=e&&e.componentOptions;return t&&t.Ctor.options.abstract?no(zt(t.children)):e}function ro(e){var t={},n=e.$options;for(var r in n.propsData)t[r]=e[r];var i=n._parentListeners;for(var o in i)t[b(o)]=i[o];return t}function io(e,t){if(/\d-keep-alive$/.test(t.tag))return e("keep-alive",{props:t.componentOptions.propsData})}var oo=function(e){return e.tag||pt(e)},ao=function(e){return"show"===e.name},so={name:"transition",props:to,abstract:!0,render:function(e){var t=this,n=this.$slots.default;if(n&&(n=n.filter(oo)).length){var r=this.mode,o=n[0];if(function(e){for(;e=e.parent;)if(e.data.transition)return!0}(this.$vnode))return o;var a=no(o);if(!a)return o;if(this._leaving)return io(e,o);var s="__transition-"+this._uid+"-";a.key=null==a.key?a.isComment?s+"comment":s+a.tag:i(a.key)?0===String(a.key).indexOf(s)?a.key:s+a.key:a.key;var c=(a.data||(a.data={})).transition=ro(this),u=this._vnode,l=no(u);if(a.data.directives&&a.data.directives.some(ao)&&(a.data.show=!0),l&&l.data&&!function(e,t){return t.key===e.key&&t.tag===e.tag}(a,l)&&!pt(l)&&(!l.componentInstance||!l.componentInstance._vnode.isComment)){var f=l.data.transition=A({},c);if("out-in"===r)return this._leaving=!0,ot(f,"afterLeave",function(){t._leaving=!1,t.$forceUpdate()}),io(e,o);if("in-out"===r){if(pt(a))return u;var p,d=function(){p()};ot(c,"afterEnter",d),ot(c,"enterCancelled",d),ot(f,"delayLeave",function(e){p=e})}}return o}}},co=A({tag:String,moveClass:String},to);function uo(e){e.elm._moveCb&&e.elm._moveCb(),e.elm._enterCb&&e.elm._enterCb()}function lo(e){e.data.newPos=e.elm.getBoundingClientRect()}function fo(e){var t=e.data.pos,n=e.data.newPos,r=t.left-n.left,i=t.top-n.top;if(r||i){e.data.moved=!0;var o=e.elm.style;o.transform=o.WebkitTransform="translate("+r+"px,"+i+"px)",o.transitionDuration="0s"}}delete co.mode;var po={Transition:so,TransitionGroup:{props:co,beforeMount:function(){var e=this,t=this._update;this._update=function(n,r){var i=Gt(e);e.__patch__(e._vnode,e.kept,!1,!0),e._vnode=e.kept,i(),t.call(e,n,r)}},render:function(e){for(var t=this.tag||this.$vnode.data.tag||"span",n=Object.create(null),r=this.prevChildren=this.children,i=this.$slots.default||[],o=this.children=[],a=ro(this),s=0;s<i.length;s++){var c=i[s];c.tag&&null!=c.key&&0!==String(c.key).indexOf("__vlist")&&(o.push(c),n[c.key]=c,(c.data||(c.data={})).transition=a)}if(r){for(var u=[],l=[],f=0;f<r.length;f++){var p=r[f];p.data.transition=a,p.data.pos=p.elm.getBoundingClientRect(),n[p.key]?u.push(p):l.push(p)}this.kept=e(t,null,u),this.removed=l}return e(t,null,o)},updated:function(){var e=this.prevChildren,t=this.moveClass||(this.name||"v")+"-move";e.length&&this.hasMove(e[0].elm,t)&&(e.forEach(uo),e.forEach(lo),e.forEach(fo),this._reflow=document.body.offsetHeight,e.forEach(function(e){if(e.data.moved){var n=e.elm,r=n.style;ji(n,t),r.transform=r.WebkitTransform=r.transitionDuration="",n.addEventListener(Oi,n._moveCb=function e(r){r&&r.target!==n||r&&!/transform$/.test(r.propertyName)||(n.removeEventListener(Oi,e),n._moveCb=null,Di(n,t))})}}))},methods:{hasMove:function(e,t){if(!Ci)return!1;if(this._hasMove)return this._hasMove;var n=e.cloneNode();e._transitionClasses&&e._transitionClasses.forEach(function(e){bi(n,e)}),_i(n,t),n.style.display="none",this.$el.appendChild(n);var r=Mi(n);return this.$el.removeChild(n),this._hasMove=r.hasTransform}}}};Cn.config.mustUseProp=Dn,Cn.config.isReservedTag=Zn,Cn.config.isReservedAttr=En,Cn.config.getTagNamespace=Gn,Cn.config.isUnknownElement=function(e){if(!V)return!0;if(Zn(e))return!1;if(e=e.toLowerCase(),null!=Xn[e])return Xn[e];var t=document.createElement(e);return e.indexOf("-")>-1?Xn[e]=t.constructor===window.HTMLUnknownElement||t.constructor===window.HTMLElement:Xn[e]=/HTMLUnknownElement/.test(t.toString())},A(Cn.options.directives,eo),A(Cn.options.components,po),Cn.prototype.__patch__=V?zi:S,Cn.prototype.$mount=function(e,t){return function(e,t,n){var r;return e.$el=t,e.$options.render||(e.$options.render=ve),Qt(e,"beforeMount"),r=function(){e._update(e._render(),n)},new pn(e,r,S,{before:function(){e._isMounted&&!e._isDestroyed&&Qt(e,"beforeUpdate")}},!0),n=!1,null==e.$vnode&&(e._isMounted=!0,Qt(e,"mounted")),e}(this,e=e&&V?Qn(e):void 0,t)},V&&setTimeout(function(){F.devtools&&ne&&ne.emit("init",Cn)},0);var vo=/\{\{((?:.|\r?\n)+?)\}\}/g,ho=/[-.*+?^${}()|[\]\/\\]/g,mo=g(function(e){var t=e[0].replace(ho,"\\$&"),n=e[1].replace(ho,"\\$&");return new RegExp(t+"((?:.|\\n)+?)"+n,"g")});var yo={staticKeys:["staticClass"],transformNode:function(e,t){t.warn;var n=Pr(e,"class");n&&(e.staticClass=JSON.stringify(n));var r=Fr(e,"class",!1);r&&(e.classBinding=r)},genData:function(e){var t="";return e.staticClass&&(t+="staticClass:"+e.staticClass+","),e.classBinding&&(t+="class:"+e.classBinding+","),t}};var go,_o={staticKeys:["staticStyle"],transformNode:function(e,t){t.warn;var n=Pr(e,"style");n&&(e.staticStyle=JSON.stringify(si(n)));var r=Fr(e,"style",!1);r&&(e.styleBinding=r)},genData:function(e){var t="";return e.staticStyle&&(t+="staticStyle:"+e.staticStyle+","),e.styleBinding&&(t+="style:("+e.styleBinding+"),"),t}},bo=function(e){return(go=go||document.createElement("div")).innerHTML=e,go.textContent},$o=p("area,base,br,col,embed,frame,hr,img,input,isindex,keygen,link,meta,param,source,track,wbr"),wo=p("colgroup,dd,dt,li,options,p,td,tfoot,th,thead,tr,source"),Co=p("address,article,aside,base,blockquote,body,caption,col,colgroup,dd,details,dialog,div,dl,dt,fieldset,figcaption,figure,footer,form,h1,h2,h3,h4,h5,h6,head,header,hgroup,hr,html,legend,li,menuitem,meta,optgroup,option,param,rp,rt,source,style,summary,tbody,td,tfoot,th,thead,title,tr,track"),xo=/^\s*([^\s"'<>\/=]+)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/,ko=/^\s*((?:v-[\w-]+:|@|:|#)\[[^=]+?\][^\s"'<>\/=]*)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/,Ao="[a-zA-Z_][\\-\\.0-9_a-zA-Z"+P.source+"]*",Oo="((?:"+Ao+"\\:)?"+Ao+")",So=new RegExp("^<"+Oo),To=/^\s*(\/?)>/,No=new RegExp("^<\\/"+Oo+"[^>]*>"),Eo=/^<!DOCTYPE [^>]+>/i,jo=/^<!\--/,Do=/^<!\[/,Lo=p("script,style,textarea",!0),Io={},Mo={"&lt;":"<","&gt;":">","&quot;":'"',"&amp;":"&","&#10;":"\n","&#9;":"\t","&#39;":"'"},Fo=/&(?:lt|gt|quot|amp|#39);/g,Po=/&(?:lt|gt|quot|amp|#39|#10|#9);/g,Ro=p("pre,textarea",!0),Ho=function(e,t){return e&&Ro(e)&&"\n"===t[0]};function Bo(e,t){var n=t?Po:Fo;return e.replace(n,function(e){return Mo[e]})}var Uo,Vo,zo,Ko,Jo,qo,Wo,Zo,Go=/^@|^v-on:/,Xo=/^v-|^@|^:|^#/,Yo=/([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/,Qo=/,([^,\}\]]*)(?:,([^,\}\]]*))?$/,ea=/^\(|\)$/g,ta=/^\[.*\]$/,na=/:(.*)$/,ra=/^:|^\.|^v-bind:/,ia=/\.[^.\]]+(?=[^\]]*$)/g,oa=/^v-slot(:|$)|^#/,aa=/[\r\n]/,sa=/[ \f\t\r\n]+/g,ca=g(bo),ua="_empty_";function la(e,t,n){return{type:1,tag:e,attrsList:t,attrsMap:ya(t),rawAttrsMap:{},parent:n,children:[]}}function fa(e,t){Uo=t.warn||Tr,qo=t.isPreTag||T,Wo=t.mustUseProp||T,Zo=t.getTagNamespace||T;t.isReservedTag;zo=Nr(t.modules,"transformNode"),Ko=Nr(t.modules,"preTransformNode"),Jo=Nr(t.modules,"postTransformNode"),Vo=t.delimiters;var n,r,i=[],o=!1!==t.preserveWhitespace,a=t.whitespace,s=!1,c=!1;function u(e){if(l(e),s||e.processed||(e=pa(e,t)),i.length||e===n||n.if&&(e.elseif||e.else)&&va(n,{exp:e.elseif,block:e}),r&&!e.forbidden)if(e.elseif||e.else)a=e,(u=function(e){var t=e.length;for(;t--;){if(1===e[t].type)return e[t];e.pop()}}(r.children))&&u.if&&va(u,{exp:a.elseif,block:a});else{if(e.slotScope){var o=e.slotTarget||'"default"';(r.scopedSlots||(r.scopedSlots={}))[o]=e}r.children.push(e),e.parent=r}var a,u;e.children=e.children.filter(function(e){return!e.slotScope}),l(e),e.pre&&(s=!1),qo(e.tag)&&(c=!1);for(var f=0;f<Jo.length;f++)Jo[f](e,t)}function l(e){if(!c)for(var t;(t=e.children[e.children.length-1])&&3===t.type&&" "===t.text;)e.children.pop()}return function(e,t){for(var n,r,i=[],o=t.expectHTML,a=t.isUnaryTag||T,s=t.canBeLeftOpenTag||T,c=0;e;){if(n=e,r&&Lo(r)){var u=0,l=r.toLowerCase(),f=Io[l]||(Io[l]=new RegExp("([\\s\\S]*?)(</"+l+"[^>]*>)","i")),p=e.replace(f,function(e,n,r){return u=r.length,Lo(l)||"noscript"===l||(n=n.replace(/<!\--([\s\S]*?)-->/g,"$1").replace(/<!\[CDATA\[([\s\S]*?)]]>/g,"$1")),Ho(l,n)&&(n=n.slice(1)),t.chars&&t.chars(n),""});c+=e.length-p.length,e=p,A(l,c-u,c)}else{var d=e.indexOf("<");if(0===d){if(jo.test(e)){var v=e.indexOf("--\x3e");if(v>=0){t.shouldKeepComment&&t.comment(e.substring(4,v),c,c+v+3),C(v+3);continue}}if(Do.test(e)){var h=e.indexOf("]>");if(h>=0){C(h+2);continue}}var m=e.match(Eo);if(m){C(m[0].length);continue}var y=e.match(No);if(y){var g=c;C(y[0].length),A(y[1],g,c);continue}var _=x();if(_){k(_),Ho(_.tagName,e)&&C(1);continue}}var b=void 0,$=void 0,w=void 0;if(d>=0){for($=e.slice(d);!(No.test($)||So.test($)||jo.test($)||Do.test($)||(w=$.indexOf("<",1))<0);)d+=w,$=e.slice(d);b=e.substring(0,d)}d<0&&(b=e),b&&C(b.length),t.chars&&b&&t.chars(b,c-b.length,c)}if(e===n){t.chars&&t.chars(e);break}}function C(t){c+=t,e=e.substring(t)}function x(){var t=e.match(So);if(t){var n,r,i={tagName:t[1],attrs:[],start:c};for(C(t[0].length);!(n=e.match(To))&&(r=e.match(ko)||e.match(xo));)r.start=c,C(r[0].length),r.end=c,i.attrs.push(r);if(n)return i.unarySlash=n[1],C(n[0].length),i.end=c,i}}function k(e){var n=e.tagName,c=e.unarySlash;o&&("p"===r&&Co(n)&&A(r),s(n)&&r===n&&A(n));for(var u=a(n)||!!c,l=e.attrs.length,f=new Array(l),p=0;p<l;p++){var d=e.attrs[p],v=d[3]||d[4]||d[5]||"",h="a"===n&&"href"===d[1]?t.shouldDecodeNewlinesForHref:t.shouldDecodeNewlines;f[p]={name:d[1],value:Bo(v,h)}}u||(i.push({tag:n,lowerCasedTag:n.toLowerCase(),attrs:f,start:e.start,end:e.end}),r=n),t.start&&t.start(n,f,u,e.start,e.end)}function A(e,n,o){var a,s;if(null==n&&(n=c),null==o&&(o=c),e)for(s=e.toLowerCase(),a=i.length-1;a>=0&&i[a].lowerCasedTag!==s;a--);else a=0;if(a>=0){for(var u=i.length-1;u>=a;u--)t.end&&t.end(i[u].tag,n,o);i.length=a,r=a&&i[a-1].tag}else"br"===s?t.start&&t.start(e,[],!0,n,o):"p"===s&&(t.start&&t.start(e,[],!1,n,o),t.end&&t.end(e,n,o))}A()}(e,{warn:Uo,expectHTML:t.expectHTML,isUnaryTag:t.isUnaryTag,canBeLeftOpenTag:t.canBeLeftOpenTag,shouldDecodeNewlines:t.shouldDecodeNewlines,shouldDecodeNewlinesForHref:t.shouldDecodeNewlinesForHref,shouldKeepComment:t.comments,outputSourceRange:t.outputSourceRange,start:function(e,o,a,l,f){var p=r&&r.ns||Zo(e);q&&"svg"===p&&(o=function(e){for(var t=[],n=0;n<e.length;n++){var r=e[n];ga.test(r.name)||(r.name=r.name.replace(_a,""),t.push(r))}return t}(o));var d,v=la(e,o,r);p&&(v.ns=p),"style"!==(d=v).tag&&("script"!==d.tag||d.attrsMap.type&&"text/javascript"!==d.attrsMap.type)||te()||(v.forbidden=!0);for(var h=0;h<Ko.length;h++)v=Ko[h](v,t)||v;s||(!function(e){null!=Pr(e,"v-pre")&&(e.pre=!0)}(v),v.pre&&(s=!0)),qo(v.tag)&&(c=!0),s?function(e){var t=e.attrsList,n=t.length;if(n)for(var r=e.attrs=new Array(n),i=0;i<n;i++)r[i]={name:t[i].name,value:JSON.stringify(t[i].value)},null!=t[i].start&&(r[i].start=t[i].start,r[i].end=t[i].end);else e.pre||(e.plain=!0)}(v):v.processed||(da(v),function(e){var t=Pr(e,"v-if");if(t)e.if=t,va(e,{exp:t,block:e});else{null!=Pr(e,"v-else")&&(e.else=!0);var n=Pr(e,"v-else-if");n&&(e.elseif=n)}}(v),function(e){null!=Pr(e,"v-once")&&(e.once=!0)}(v)),n||(n=v),a?u(v):(r=v,i.push(v))},end:function(e,t,n){var o=i[i.length-1];i.length-=1,r=i[i.length-1],u(o)},chars:function(e,t,n){if(r&&(!q||"textarea"!==r.tag||r.attrsMap.placeholder!==e)){var i,u,l,f=r.children;if(e=c||e.trim()?"script"===(i=r).tag||"style"===i.tag?e:ca(e):f.length?a?"condense"===a&&aa.test(e)?"":" ":o?" ":"":"")c||"condense"!==a||(e=e.replace(sa," ")),!s&&" "!==e&&(u=function(e,t){var n=t?mo(t):vo;if(n.test(e)){for(var r,i,o,a=[],s=[],c=n.lastIndex=0;r=n.exec(e);){(i=r.index)>c&&(s.push(o=e.slice(c,i)),a.push(JSON.stringify(o)));var u=Or(r[1].trim());a.push("_s("+u+")"),s.push({"@binding":u}),c=i+r[0].length}return c<e.length&&(s.push(o=e.slice(c)),a.push(JSON.stringify(o))),{expression:a.join("+"),tokens:s}}}(e,Vo))?l={type:2,expression:u.expression,tokens:u.tokens,text:e}:" "===e&&f.length&&" "===f[f.length-1].text||(l={type:3,text:e}),l&&f.push(l)}},comment:function(e,t,n){if(r){var i={type:3,text:e,isComment:!0};r.children.push(i)}}}),n}function pa(e,t){var n,r;(r=Fr(n=e,"key"))&&(n.key=r),e.plain=!e.key&&!e.scopedSlots&&!e.attrsList.length,function(e){var t=Fr(e,"ref");t&&(e.ref=t,e.refInFor=function(e){var t=e;for(;t;){if(void 0!==t.for)return!0;t=t.parent}return!1}(e))}(e),function(e){var t;"template"===e.tag?(t=Pr(e,"scope"),e.slotScope=t||Pr(e,"slot-scope")):(t=Pr(e,"slot-scope"))&&(e.slotScope=t);var n=Fr(e,"slot");n&&(e.slotTarget='""'===n?'"default"':n,e.slotTargetDynamic=!(!e.attrsMap[":slot"]&&!e.attrsMap["v-bind:slot"]),"template"===e.tag||e.slotScope||jr(e,"slot",n,function(e,t){return e.rawAttrsMap[":"+t]||e.rawAttrsMap["v-bind:"+t]||e.rawAttrsMap[t]}(e,"slot")));if("template"===e.tag){var r=Rr(e,oa);if(r){var i=ha(r),o=i.name,a=i.dynamic;e.slotTarget=o,e.slotTargetDynamic=a,e.slotScope=r.value||ua}}else{var s=Rr(e,oa);if(s){var c=e.scopedSlots||(e.scopedSlots={}),u=ha(s),l=u.name,f=u.dynamic,p=c[l]=la("template",[],e);p.slotTarget=l,p.slotTargetDynamic=f,p.children=e.children.filter(function(e){if(!e.slotScope)return e.parent=p,!0}),p.slotScope=s.value||ua,e.children=[],e.plain=!1}}}(e),function(e){"slot"===e.tag&&(e.slotName=Fr(e,"name"))}(e),function(e){var t;(t=Fr(e,"is"))&&(e.component=t);null!=Pr(e,"inline-template")&&(e.inlineTemplate=!0)}(e);for(var i=0;i<zo.length;i++)e=zo[i](e,t)||e;return function(e){var t,n,r,i,o,a,s,c,u=e.attrsList;for(t=0,n=u.length;t<n;t++)if(r=i=u[t].name,o=u[t].value,Xo.test(r))if(e.hasBindings=!0,(a=ma(r.replace(Xo,"")))&&(r=r.replace(ia,"")),ra.test(r))r=r.replace(ra,""),o=Or(o),(c=ta.test(r))&&(r=r.slice(1,-1)),a&&(a.prop&&!c&&"innerHtml"===(r=b(r))&&(r="innerHTML"),a.camel&&!c&&(r=b(r)),a.sync&&(s=Ur(o,"$event"),c?Mr(e,'"update:"+('+r+")",s,null,!1,0,u[t],!0):(Mr(e,"update:"+b(r),s,null,!1,0,u[t]),C(r)!==b(r)&&Mr(e,"update:"+C(r),s,null,!1,0,u[t])))),a&&a.prop||!e.component&&Wo(e.tag,e.attrsMap.type,r)?Er(e,r,o,u[t],c):jr(e,r,o,u[t],c);else if(Go.test(r))r=r.replace(Go,""),(c=ta.test(r))&&(r=r.slice(1,-1)),Mr(e,r,o,a,!1,0,u[t],c);else{var l=(r=r.replace(Xo,"")).match(na),f=l&&l[1];c=!1,f&&(r=r.slice(0,-(f.length+1)),ta.test(f)&&(f=f.slice(1,-1),c=!0)),Lr(e,r,i,o,f,c,a,u[t])}else jr(e,r,JSON.stringify(o),u[t]),!e.component&&"muted"===r&&Wo(e.tag,e.attrsMap.type,r)&&Er(e,r,"true",u[t])}(e),e}function da(e){var t;if(t=Pr(e,"v-for")){var n=function(e){var t=e.match(Yo);if(!t)return;var n={};n.for=t[2].trim();var r=t[1].trim().replace(ea,""),i=r.match(Qo);i?(n.alias=r.replace(Qo,"").trim(),n.iterator1=i[1].trim(),i[2]&&(n.iterator2=i[2].trim())):n.alias=r;return n}(t);n&&A(e,n)}}function va(e,t){e.ifConditions||(e.ifConditions=[]),e.ifConditions.push(t)}function ha(e){var t=e.name.replace(oa,"");return t||"#"!==e.name[0]&&(t="default"),ta.test(t)?{name:t.slice(1,-1),dynamic:!0}:{name:'"'+t+'"',dynamic:!1}}function ma(e){var t=e.match(ia);if(t){var n={};return t.forEach(function(e){n[e.slice(1)]=!0}),n}}function ya(e){for(var t={},n=0,r=e.length;n<r;n++)t[e[n].name]=e[n].value;return t}var ga=/^xmlns:NS\d+/,_a=/^NS\d+:/;function ba(e){return la(e.tag,e.attrsList.slice(),e.parent)}var $a=[yo,_o,{preTransformNode:function(e,t){if("input"===e.tag){var n,r=e.attrsMap;if(!r["v-model"])return;if((r[":type"]||r["v-bind:type"])&&(n=Fr(e,"type")),r.type||n||!r["v-bind"]||(n="("+r["v-bind"]+").type"),n){var i=Pr(e,"v-if",!0),o=i?"&&("+i+")":"",a=null!=Pr(e,"v-else",!0),s=Pr(e,"v-else-if",!0),c=ba(e);da(c),Dr(c,"type","checkbox"),pa(c,t),c.processed=!0,c.if="("+n+")==='checkbox'"+o,va(c,{exp:c.if,block:c});var u=ba(e);Pr(u,"v-for",!0),Dr(u,"type","radio"),pa(u,t),va(c,{exp:"("+n+")==='radio'"+o,block:u});var l=ba(e);return Pr(l,"v-for",!0),Dr(l,":type",n),pa(l,t),va(c,{exp:i,block:l}),a?c.else=!0:s&&(c.elseif=s),c}}}}];var wa,Ca,xa={expectHTML:!0,modules:$a,directives:{model:function(e,t,n){var r=t.value,i=t.modifiers,o=e.tag,a=e.attrsMap.type;if(e.component)return Br(e,r,i),!1;if("select"===o)!function(e,t,n){var r='var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return '+(n&&n.number?"_n(val)":"val")+"});";r=r+" "+Ur(t,"$event.target.multiple ? $$selectedVal : $$selectedVal[0]"),Mr(e,"change",r,null,!0)}(e,r,i);else if("input"===o&&"checkbox"===a)!function(e,t,n){var r=n&&n.number,i=Fr(e,"value")||"null",o=Fr(e,"true-value")||"true",a=Fr(e,"false-value")||"false";Er(e,"checked","Array.isArray("+t+")?_i("+t+","+i+")>-1"+("true"===o?":("+t+")":":_q("+t+","+o+")")),Mr(e,"change","var $$a="+t+",$$el=$event.target,$$c=$$el.checked?("+o+"):("+a+");if(Array.isArray($$a)){var $$v="+(r?"_n("+i+")":i)+",$$i=_i($$a,$$v);if($$el.checked){$$i<0&&("+Ur(t,"$$a.concat([$$v])")+")}else{$$i>-1&&("+Ur(t,"$$a.slice(0,$$i).concat($$a.slice($$i+1))")+")}}else{"+Ur(t,"$$c")+"}",null,!0)}(e,r,i);else if("input"===o&&"radio"===a)!function(e,t,n){var r=n&&n.number,i=Fr(e,"value")||"null";Er(e,"checked","_q("+t+","+(i=r?"_n("+i+")":i)+")"),Mr(e,"change",Ur(t,i),null,!0)}(e,r,i);else if("input"===o||"textarea"===o)!function(e,t,n){var r=e.attrsMap.type,i=n||{},o=i.lazy,a=i.number,s=i.trim,c=!o&&"range"!==r,u=o?"change":"range"===r?Zr:"input",l="$event.target.value";s&&(l="$event.target.value.trim()"),a&&(l="_n("+l+")");var f=Ur(t,l);c&&(f="if($event.target.composing)return;"+f),Er(e,"value","("+t+")"),Mr(e,u,f,null,!0),(s||a)&&Mr(e,"blur","$forceUpdate()")}(e,r,i);else if(!F.isReservedTag(o))return Br(e,r,i),!1;return!0},text:function(e,t){t.value&&Er(e,"textContent","_s("+t.value+")",t)},html:function(e,t){t.value&&Er(e,"innerHTML","_s("+t.value+")",t)}},isPreTag:function(e){return"pre"===e},isUnaryTag:$o,mustUseProp:Dn,canBeLeftOpenTag:wo,isReservedTag:Zn,getTagNamespace:Gn,staticKeys:function(e){return e.reduce(function(e,t){return e.concat(t.staticKeys||[])},[]).join(",")}($a)},ka=g(function(e){return p("type,tag,attrsList,attrsMap,plain,parent,children,attrs,start,end,rawAttrsMap"+(e?","+e:""))});function Aa(e,t){e&&(wa=ka(t.staticKeys||""),Ca=t.isReservedTag||T,function e(t){t.static=function(e){if(2===e.type)return!1;if(3===e.type)return!0;return!(!e.pre&&(e.hasBindings||e.if||e.for||d(e.tag)||!Ca(e.tag)||function(e){for(;e.parent;){if("template"!==(e=e.parent).tag)return!1;if(e.for)return!0}return!1}(e)||!Object.keys(e).every(wa)))}(t);if(1===t.type){if(!Ca(t.tag)&&"slot"!==t.tag&&null==t.attrsMap["inline-template"])return;for(var n=0,r=t.children.length;n<r;n++){var i=t.children[n];e(i),i.static||(t.static=!1)}if(t.ifConditions)for(var o=1,a=t.ifConditions.length;o<a;o++){var s=t.ifConditions[o].block;e(s),s.static||(t.static=!1)}}}(e),function e(t,n){if(1===t.type){if((t.static||t.once)&&(t.staticInFor=n),t.static&&t.children.length&&(1!==t.children.length||3!==t.children[0].type))return void(t.staticRoot=!0);if(t.staticRoot=!1,t.children)for(var r=0,i=t.children.length;r<i;r++)e(t.children[r],n||!!t.for);if(t.ifConditions)for(var o=1,a=t.ifConditions.length;o<a;o++)e(t.ifConditions[o].block,n)}}(e,!1))}var Oa=/^([\w$_]+|\([^)]*?\))\s*=>|^function(?:\s+[\w$]+)?\s*\(/,Sa=/\([^)]*?\);*$/,Ta=/^[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*|\['[^']*?']|\["[^"]*?"]|\[\d+]|\[[A-Za-z_$][\w$]*])*$/,Na={esc:27,tab:9,enter:13,space:32,up:38,left:37,right:39,down:40,delete:[8,46]},Ea={esc:["Esc","Escape"],tab:"Tab",enter:"Enter",space:[" ","Spacebar"],up:["Up","ArrowUp"],left:["Left","ArrowLeft"],right:["Right","ArrowRight"],down:["Down","ArrowDown"],delete:["Backspace","Delete","Del"]},ja=function(e){return"if("+e+")return null;"},Da={stop:"$event.stopPropagation();",prevent:"$event.preventDefault();",self:ja("$event.target !== $event.currentTarget"),ctrl:ja("!$event.ctrlKey"),shift:ja("!$event.shiftKey"),alt:ja("!$event.altKey"),meta:ja("!$event.metaKey"),left:ja("'button' in $event && $event.button !== 0"),middle:ja("'button' in $event && $event.button !== 1"),right:ja("'button' in $event && $event.button !== 2")};function La(e,t){var n=t?"nativeOn:":"on:",r="",i="";for(var o in e){var a=Ia(e[o]);e[o]&&e[o].dynamic?i+=o+","+a+",":r+='"'+o+'":'+a+","}return r="{"+r.slice(0,-1)+"}",i?n+"_d("+r+",["+i.slice(0,-1)+"])":n+r}function Ia(e){if(!e)return"function(){}";if(Array.isArray(e))return"["+e.map(function(e){return Ia(e)}).join(",")+"]";var t=Ta.test(e.value),n=Oa.test(e.value),r=Ta.test(e.value.replace(Sa,""));if(e.modifiers){var i="",o="",a=[];for(var s in e.modifiers)if(Da[s])o+=Da[s],Na[s]&&a.push(s);else if("exact"===s){var c=e.modifiers;o+=ja(["ctrl","shift","alt","meta"].filter(function(e){return!c[e]}).map(function(e){return"$event."+e+"Key"}).join("||"))}else a.push(s);return a.length&&(i+=function(e){return"if(!$event.type.indexOf('key')&&"+e.map(Ma).join("&&")+")return null;"}(a)),o&&(i+=o),"function($event){"+i+(t?"return "+e.value+".apply(null, arguments)":n?"return ("+e.value+").apply(null, arguments)":r?"return "+e.value:e.value)+"}"}return t||n?e.value:"function($event){"+(r?"return "+e.value:e.value)+"}"}function Ma(e){var t=parseInt(e,10);if(t)return"$event.keyCode!=="+t;var n=Na[e],r=Ea[e];return"_k($event.keyCode,"+JSON.stringify(e)+","+JSON.stringify(n)+",$event.key,"+JSON.stringify(r)+")"}var Fa={on:function(e,t){e.wrapListeners=function(e){return"_g("+e+","+t.value+")"}},bind:function(e,t){e.wrapData=function(n){return"_b("+n+",'"+e.tag+"',"+t.value+","+(t.modifiers&&t.modifiers.prop?"true":"false")+(t.modifiers&&t.modifiers.sync?",true":"")+")"}},cloak:S},Pa=function(e){this.options=e,this.warn=e.warn||Tr,this.transforms=Nr(e.modules,"transformCode"),this.dataGenFns=Nr(e.modules,"genData"),this.directives=A(A({},Fa),e.directives);var t=e.isReservedTag||T;this.maybeComponent=function(e){return!!e.component||!t(e.tag)},this.onceId=0,this.staticRenderFns=[],this.pre=!1};function Ra(e,t){var n=new Pa(t);return{render:"with(this){return "+(e?"script"===e.tag?"null":Ha(e,n):'_c("div")')+"}",staticRenderFns:n.staticRenderFns}}function Ha(e,t){if(e.parent&&(e.pre=e.pre||e.parent.pre),e.staticRoot&&!e.staticProcessed)return Ba(e,t);if(e.once&&!e.onceProcessed)return Ua(e,t);if(e.for&&!e.forProcessed)return za(e,t);if(e.if&&!e.ifProcessed)return Va(e,t);if("template"!==e.tag||e.slotTarget||t.pre){if("slot"===e.tag)return function(e,t){var n=e.slotName||'"default"',r=Wa(e,t),i="_t("+n+(r?",function(){return "+r+"}":""),o=e.attrs||e.dynamicAttrs?Xa((e.attrs||[]).concat(e.dynamicAttrs||[]).map(function(e){return{name:b(e.name),value:e.value,dynamic:e.dynamic}})):null,a=e.attrsMap["v-bind"];!o&&!a||r||(i+=",null");o&&(i+=","+o);a&&(i+=(o?"":",null")+","+a);return i+")"}(e,t);var n;if(e.component)n=function(e,t,n){var r=t.inlineTemplate?null:Wa(t,n,!0);return"_c("+e+","+Ka(t,n)+(r?","+r:"")+")"}(e.component,e,t);else{var r;(!e.plain||e.pre&&t.maybeComponent(e))&&(r=Ka(e,t));var i=e.inlineTemplate?null:Wa(e,t,!0);n="_c('"+e.tag+"'"+(r?","+r:"")+(i?","+i:"")+")"}for(var o=0;o<t.transforms.length;o++)n=t.transforms[o](e,n);return n}return Wa(e,t)||"void 0"}function Ba(e,t){e.staticProcessed=!0;var n=t.pre;return e.pre&&(t.pre=e.pre),t.staticRenderFns.push("with(this){return "+Ha(e,t)+"}"),t.pre=n,"_m("+(t.staticRenderFns.length-1)+(e.staticInFor?",true":"")+")"}function Ua(e,t){if(e.onceProcessed=!0,e.if&&!e.ifProcessed)return Va(e,t);if(e.staticInFor){for(var n="",r=e.parent;r;){if(r.for){n=r.key;break}r=r.parent}return n?"_o("+Ha(e,t)+","+t.onceId+++","+n+")":Ha(e,t)}return Ba(e,t)}function Va(e,t,n,r){return e.ifProcessed=!0,function e(t,n,r,i){if(!t.length)return i||"_e()";var o=t.shift();return o.exp?"("+o.exp+")?"+a(o.block)+":"+e(t,n,r,i):""+a(o.block);function a(e){return r?r(e,n):e.once?Ua(e,n):Ha(e,n)}}(e.ifConditions.slice(),t,n,r)}function za(e,t,n,r){var i=e.for,o=e.alias,a=e.iterator1?","+e.iterator1:"",s=e.iterator2?","+e.iterator2:"";return e.forProcessed=!0,(r||"_l")+"(("+i+"),function("+o+a+s+"){return "+(n||Ha)(e,t)+"})"}function Ka(e,t){var n="{",r=function(e,t){var n=e.directives;if(!n)return;var r,i,o,a,s="directives:[",c=!1;for(r=0,i=n.length;r<i;r++){o=n[r],a=!0;var u=t.directives[o.name];u&&(a=!!u(e,o,t.warn)),a&&(c=!0,s+='{name:"'+o.name+'",rawName:"'+o.rawName+'"'+(o.value?",value:("+o.value+"),expression:"+JSON.stringify(o.value):"")+(o.arg?",arg:"+(o.isDynamicArg?o.arg:'"'+o.arg+'"'):"")+(o.modifiers?",modifiers:"+JSON.stringify(o.modifiers):"")+"},")}if(c)return s.slice(0,-1)+"]"}(e,t);r&&(n+=r+","),e.key&&(n+="key:"+e.key+","),e.ref&&(n+="ref:"+e.ref+","),e.refInFor&&(n+="refInFor:true,"),e.pre&&(n+="pre:true,"),e.component&&(n+='tag:"'+e.tag+'",');for(var i=0;i<t.dataGenFns.length;i++)n+=t.dataGenFns[i](e);if(e.attrs&&(n+="attrs:"+Xa(e.attrs)+","),e.props&&(n+="domProps:"+Xa(e.props)+","),e.events&&(n+=La(e.events,!1)+","),e.nativeEvents&&(n+=La(e.nativeEvents,!0)+","),e.slotTarget&&!e.slotScope&&(n+="slot:"+e.slotTarget+","),e.scopedSlots&&(n+=function(e,t,n){var r=e.for||Object.keys(t).some(function(e){var n=t[e];return n.slotTargetDynamic||n.if||n.for||Ja(n)}),i=!!e.if;if(!r)for(var o=e.parent;o;){if(o.slotScope&&o.slotScope!==ua||o.for){r=!0;break}o.if&&(i=!0),o=o.parent}var a=Object.keys(t).map(function(e){return qa(t[e],n)}).join(",");return"scopedSlots:_u(["+a+"]"+(r?",null,true":"")+(!r&&i?",null,false,"+function(e){var t=5381,n=e.length;for(;n;)t=33*t^e.charCodeAt(--n);return t>>>0}(a):"")+")"}(e,e.scopedSlots,t)+","),e.model&&(n+="model:{value:"+e.model.value+",callback:"+e.model.callback+",expression:"+e.model.expression+"},"),e.inlineTemplate){var o=function(e,t){var n=e.children[0];if(n&&1===n.type){var r=Ra(n,t.options);return"inlineTemplate:{render:function(){"+r.render+"},staticRenderFns:["+r.staticRenderFns.map(function(e){return"function(){"+e+"}"}).join(",")+"]}"}}(e,t);o&&(n+=o+",")}return n=n.replace(/,$/,"")+"}",e.dynamicAttrs&&(n="_b("+n+',"'+e.tag+'",'+Xa(e.dynamicAttrs)+")"),e.wrapData&&(n=e.wrapData(n)),e.wrapListeners&&(n=e.wrapListeners(n)),n}function Ja(e){return 1===e.type&&("slot"===e.tag||e.children.some(Ja))}function qa(e,t){var n=e.attrsMap["slot-scope"];if(e.if&&!e.ifProcessed&&!n)return Va(e,t,qa,"null");if(e.for&&!e.forProcessed)return za(e,t,qa);var r=e.slotScope===ua?"":String(e.slotScope),i="function("+r+"){return "+("template"===e.tag?e.if&&n?"("+e.if+")?"+(Wa(e,t)||"undefined")+":undefined":Wa(e,t)||"undefined":Ha(e,t))+"}",o=r?"":",proxy:true";return"{key:"+(e.slotTarget||'"default"')+",fn:"+i+o+"}"}function Wa(e,t,n,r,i){var o=e.children;if(o.length){var a=o[0];if(1===o.length&&a.for&&"template"!==a.tag&&"slot"!==a.tag){var s=n?t.maybeComponent(a)?",1":",0":"";return""+(r||Ha)(a,t)+s}var c=n?function(e,t){for(var n=0,r=0;r<e.length;r++){var i=e[r];if(1===i.type){if(Za(i)||i.ifConditions&&i.ifConditions.some(function(e){return Za(e.block)})){n=2;break}(t(i)||i.ifConditions&&i.ifConditions.some(function(e){return t(e.block)}))&&(n=1)}}return n}(o,t.maybeComponent):0,u=i||Ga;return"["+o.map(function(e){return u(e,t)}).join(",")+"]"+(c?","+c:"")}}function Za(e){return void 0!==e.for||"template"===e.tag||"slot"===e.tag}function Ga(e,t){return 1===e.type?Ha(e,t):3===e.type&&e.isComment?(r=e,"_e("+JSON.stringify(r.text)+")"):"_v("+(2===(n=e).type?n.expression:Ya(JSON.stringify(n.text)))+")";var n,r}function Xa(e){for(var t="",n="",r=0;r<e.length;r++){var i=e[r],o=Ya(i.value);i.dynamic?n+=i.name+","+o+",":t+='"'+i.name+'":'+o+","}return t="{"+t.slice(0,-1)+"}",n?"_d("+t+",["+n.slice(0,-1)+"])":t}function Ya(e){return e.replace(/\u2028/g,"\\u2028").replace(/\u2029/g,"\\u2029")}new RegExp("\\b"+"do,if,for,let,new,try,var,case,else,with,await,break,catch,class,const,super,throw,while,yield,delete,export,import,return,switch,default,extends,finally,continue,debugger,function,arguments".split(",").join("\\b|\\b")+"\\b");function Qa(e,t){try{return new Function(e)}catch(n){return t.push({err:n,code:e}),S}}function es(e){var t=Object.create(null);return function(n,r,i){(r=A({},r)).warn;delete r.warn;var o=r.delimiters?String(r.delimiters)+n:n;if(t[o])return t[o];var a=e(n,r),s={},c=[];return s.render=Qa(a.render,c),s.staticRenderFns=a.staticRenderFns.map(function(e){return Qa(e,c)}),t[o]=s}}var ts,ns,rs=(ts=function(e,t){var n=fa(e.trim(),t);!1!==t.optimize&&Aa(n,t);var r=Ra(n,t);return{ast:n,render:r.render,staticRenderFns:r.staticRenderFns}},function(e){function t(t,n){var r=Object.create(e),i=[],o=[];if(n)for(var a in n.modules&&(r.modules=(e.modules||[]).concat(n.modules)),n.directives&&(r.directives=A(Object.create(e.directives||null),n.directives)),n)"modules"!==a&&"directives"!==a&&(r[a]=n[a]);r.warn=function(e,t,n){(n?o:i).push(e)};var s=ts(t.trim(),r);return s.errors=i,s.tips=o,s}return{compile:t,compileToFunctions:es(t)}})(xa),is=(rs.compile,rs.compileToFunctions);function os(e){return(ns=ns||document.createElement("div")).innerHTML=e?'<a href="\n"/>':'<div a="\n"/>',ns.innerHTML.indexOf("&#10;")>0}var as=!!V&&os(!1),ss=!!V&&os(!0),cs=g(function(e){var t=Qn(e);return t&&t.innerHTML}),us=Cn.prototype.$mount;Cn.prototype.$mount=function(e,t){if((e=e&&Qn(e))===document.body||e===document.documentElement)return this;var n=this.$options;if(!n.render){var r=n.template;if(r)if("string"==typeof r)"#"===r.charAt(0)&&(r=cs(r));else{if(!r.nodeType)return this;r=r.innerHTML}else e&&(r=function(e){if(e.outerHTML)return e.outerHTML;var t=document.createElement("div");return t.appendChild(e.cloneNode(!0)),t.innerHTML}(e));if(r){var i=is(r,{outputSourceRange:!1,shouldDecodeNewlines:as,shouldDecodeNewlinesForHref:ss,delimiters:n.delimiters,comments:n.comments},this),o=i.render,a=i.staticRenderFns;n.render=o,n.staticRenderFns=a}}return us.call(this,e,t)},Cn.compile=is,module.exports=Cn;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(169).setImmediate))

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define([],t):"object"==typeof exports?exports["vue2-dropzone"]=t():e["vue2-dropzone"]=t()}(this,function(){return function(e){function t(n){if(i[n])return i[n].exports;var o=i[n]={exports:{},id:n,loaded:!1};return e[n].call(o.exports,o,o.exports,t),o.loaded=!0,o.exports}var i={};return t.m=e,t.c=i,t.p="",t(0)}([function(e,t,i){var n,o,r={};i(8),n=i(2),o=i(6),e.exports=n||{},e.exports.__esModule&&(e.exports=e.exports.default);var s="function"==typeof e.exports?e.exports.options||(e.exports.options={}):e.exports;o&&(s.template=o),s.computed||(s.computed={}),Object.keys(r).forEach(function(e){var t=r[e];s.computed[e]=function(){return t}})},function(e,t){e.exports=function(){var e=[];return e.toString=function(){for(var e=[],t=0;t<this.length;t++){var i=this[t];i[2]?e.push("@media "+i[2]+"{"+i[1]+"}"):e.push(i[1])}return e.join("")},e.i=function(t,i){"string"==typeof t&&(t=[[null,t,""]]);for(var n={},o=0;o<this.length;o++){var r=this[o][0];"number"==typeof r&&(n[r]=!0)}for(o=0;o<t.length;o++){var s=t[o];"number"==typeof s[0]&&n[s[0]]||(i&&!s[2]?s[2]=i:i&&(s[2]="("+s[2]+") and ("+i+")"),e.push(s))}},e}},function(e,t,i){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.default={props:{id:{type:String,required:!0},url:{type:String,required:!0},clickable:{type:[Boolean,String],default:!0},confirm:{type:Function,default:void 0},paramName:{type:String,default:"file"},acceptedFileTypes:{type:String},thumbnailHeight:{type:Number,default:200},thumbnailWidth:{type:Number,default:200},showRemoveLink:{type:Boolean,default:!0},maxFileSizeInMB:{type:Number,default:2},maxNumberOfFiles:{type:Number,default:5},autoProcessQueue:{type:Boolean,default:!0},useFontAwesome:{type:Boolean,default:!1},headers:{type:Object},language:{type:Object,default:function(){return{}}},previewTemplate:{type:Function,default:function(e){return'\n                    <div class="dz-preview dz-file-preview">\n                        <div class="dz-image" style="width: '+e.thumbnailWidth+"px;height: "+e.thumbnailHeight+'px">\n                        <img data-dz-thumbnail /></div>\n                        <div class="dz-details">\n                            <div class="dz-size"><span data-dz-size></span></div>\n                            <div class="dz-filename"><span data-dz-name></span></div>\n                        </div>\n                        <div class="dz-progress"><span class="dz-upload" data-dz-uploadprogress></span></div>\n                        <div class="dz-error-message"><span data-dz-errormessage></span></div>\n                        <div class="dz-success-mark">'+e.doneIcon+'</div>\n                        <div class="dz-error-mark">'+e.errorIcon+"</div>\n                    </div>\n                "}},useCustomDropzoneOptions:{type:Boolean,default:!1},dropzoneOptions:{type:Object,default:function(){return{}}},resizeWidth:{type:Number,default:null},resizeHeight:{type:Number,default:null},resizeMimeType:{type:String,default:null},resizeQuality:{type:Number,default:.8},resizeMethod:{type:String,default:"contain"},uploadMultiple:{type:Boolean,default:!1},duplicateCheck:{type:Boolean,default:!1},parallelUploads:{type:Number,default:2},timeout:{type:Number,default:3e4},method:{type:String,default:"POST"},withCredentials:{type:Boolean,default:!1},capture:{type:String,default:null},hiddenInputContainer:{type:String,default:"body"}},methods:{manuallyAddFile:function(e,t,i,n,o){this.dropzone.emit("addedfile",e),this.dropzone.emit("thumbnail",e,t),this.dropzone.createThumbnailFromUrl(e,t,i,n),this.dropzone.emit("complete",e),"undefined"!=typeof o.dontSubstractMaxFiles&&o.dontSubstractMaxFiles||(this.dropzone.options.maxFiles=this.dropzone.options.maxFiles-1),"undefined"!=typeof o.addToFiles&&o.addToFiles&&this.dropzone.files.push(e),this.$emit("vdropzone-file-added-manually",e)},setOption:function(e,t){this.dropzone.options[e]=t},removeAllFiles:function(){this.dropzone.removeAllFiles(!0)},processQueue:function(){var e=this.dropzone;this.dropzone.processQueue(),this.dropzone.on("success",function(){e.options.autoProcessQueue=!0}),this.dropzone.on("queuecomplete",function(){e.options.autoProcessQueue=!1})},removeFile:function(e){this.dropzone.removeFile(e)},getAcceptedFiles:function(){return this.dropzone.getAcceptedFiles()},getRejectedFiles:function(){return this.dropzone.getRejectedFiles()},getUploadingFiles:function(){return this.dropzone.getUploadingFiles()},getQueuedFiles:function(){return this.dropzone.getQueuedFiles()},getProp:function(e,t){return this.useCustomDropzoneOptions&&void 0!==t&&null!==t&&""!==t?t:e}},computed:{languageSettings:function(){var e={dictDefaultMessage:"<br>Drop files here to upload",dictCancelUpload:"Cancel upload",dictCancelUploadConfirmation:"Are you sure you want to cancel this upload?",dictFallbackMessage:"Your browser does not support drag and drop file uploads.",dictFallbackText:"Please use the fallback form below to upload your files like in the olden days.",dictFileTooBig:"File is too big ({{filesize}}MiB). Max filesize: {{maxFilesize}}MiB.",dictInvalidFileType:"You can't upload files of this type.",dictMaxFilesExceeded:"You can not upload any more files. (max: {{maxFiles}})",dictRemoveFile:"Remove",dictRemoveFileConfirmation:null,dictResponseError:"Server responded with {{statusCode}} code."};for(var t in this.language)e[t]=this.language[t];if(this.useCustomDropzoneOptions&&this.dropzoneOptions.language)for(var i in this.dropzoneOptions.language)e[i]=this.dropzoneOptions.language[i];return e},cloudIcon:function(){return this.useFontAwesome?'<i class="fa fa-cloud-upload"></i>':'<i class="material-icons">cloud_upload</i>'},doneIcon:function(){return this.useFontAwesome?'<i class="fa fa-check"></i>':' <i class="material-icons">done</i>'},errorIcon:function(){return this.useFontAwesome?'<i class="fa fa-close"></i>':' <i class="material-icons">error</i>'}},mounted:function(){if(!this.$isServer){var e=i(5);e.autoDiscover=!1,this.confirm&&(e.confirm=this.getProp(this.confirm,this.dropzoneOptions.confirm));var t=document.getElementById(this.id);this.dropzone=new e(t,{clickable:this.getProp(this.clickable,this.dropzoneOptions.clickable),paramName:this.getProp(this.paramName,this.dropzoneOptions.paramName),thumbnailWidth:this.getProp(this.thumbnailWidth,this.dropzoneOptions.thumbnailWidth),thumbnailHeight:this.getProp(this.thumbnailHeight,this.dropzoneOptions.thumbnailHeight),maxFiles:this.getProp(this.maxNumberOfFiles,this.dropzoneOptions.maxNumberOfFiles),maxFilesize:this.getProp(this.maxFileSizeInMB,this.dropzoneOptions.maxFileSizeInMB),addRemoveLinks:this.getProp(this.showRemoveLink,this.dropzoneOptions.showRemoveLink),acceptedFiles:this.getProp(this.acceptedFileTypes,this.dropzoneOptions.acceptedFileTypes),autoProcessQueue:this.getProp(this.autoProcessQueue,this.dropzoneOptions.autoProcessQueue),headers:this.getProp(this.headers,this.dropzoneOptions.headers),previewTemplate:this.previewTemplate(this),dictDefaultMessage:this.cloudIcon+this.languageSettings.dictDefaultMessage,dictCancelUpload:this.languageSettings.dictCancelUpload,dictCancelUploadConfirmation:this.languageSettings.dictCancelUploadConfirmation,dictFallbackMessage:this.languageSettings.dictFallbackMessage,dictFallbackText:this.languageSettings.dictFallbackText,dictFileTooBig:this.languageSettings.dictFileTooBig,dictInvalidFileType:this.languageSettings.dictInvalidFileType,dictMaxFilesExceeded:this.languageSettings.dictMaxFilesExceeded,dictRemoveFile:this.languageSettings.dictRemoveFile,dictRemoveFileConfirmation:this.languageSettings.dictRemoveFileConfirmation,dictResponseError:this.languageSettings.dictResponseError,resizeWidth:this.getProp(this.resizeWidth,this.dropzoneOptions.resizeWidth),resizeHeight:this.getProp(this.resizeHeight,this.dropzoneOptions.resizeHeight),resizeMimeType:this.getProp(this.resizeMimeType,this.dropzoneOptions.resizeMimeType),resizeQuality:this.getProp(this.resizeQuality,this.dropzoneOptions.resizeQuality),resizeMethod:this.getProp(this.resizeMethod,this.dropzoneOptions.resizeMethod),uploadMultiple:this.getProp(this.uploadMultiple,this.dropzoneOptions.uploadMultiple),parallelUploads:this.getProp(this.parallelUploads,this.dropzoneOptions.parallelUploads),timeout:this.getProp(this.timeout,this.dropzoneOptions.timeout),method:this.getProp(this.method,this.dropzoneOptions.method),capture:this.getProp(this.capture,this.dropzoneOptions.capture),hiddenInputContainer:this.getProp(this.hiddenInputContainer,this.dropzoneOptions.hiddenInputContainer),withCredentials:this.getProp(this.withCredentials,this.dropzoneOptions.withCredentials)});var n=this;this.dropzone.on("thumbnail",function(e,t){n.$emit("vdropzone-thumbnail",e,t)}),this.dropzone.on("addedfile",function(e){if(n.duplicateCheck&&this.files.length){var t,i;for(t=0,i=this.files.length;t<i-1;t++)this.files[t].name===e.name&&(this.removeFile(e),n.$emit("duplicate-file",e))}n.$emit("vdropzone-file-added",e)}),this.dropzone.on("addedfiles",function(e){n.$emit("vdropzone-files-added",e)}),this.dropzone.on("removedfile",function(e){n.$emit("vdropzone-removed-file",e)}),this.dropzone.on("success",function(e,t){n.$emit("vdropzone-success",e,t)}),this.dropzone.on("successmultiple",function(e,t){n.$emit("vdropzone-success-multiple",e,t)}),this.dropzone.on("error",function(e,t,i){n.$emit("vdropzone-error",e,t,i)}),this.dropzone.on("sending",function(e,t,i){n.$emit("vdropzone-sending",e,t,i)}),this.dropzone.on("sendingmultiple",function(e,t,i){n.$emit("vdropzone-sending-multiple",e,t,i)}),this.dropzone.on("queuecomplete",function(e,t,i){n.$emit("vdropzone-queue-complete",e,t,i)}),this.dropzone.on("totaluploadprogress",function(e,t,i){n.$emit("vdropzone-total-upload-progress",e,t,i)}),n.$emit("vdropzone-mounted")}},beforeDestroy:function(){this.dropzone.destroy()}}},function(e,t,i){t=e.exports=i(1)(),t.push([e.id,'@-webkit-keyframes passing-through{0%{opacity:0;-webkit-transform:translateY(40px);transform:translateY(40px)}30%,70%{opacity:1;-webkit-transform:translateY(0);transform:translateY(0)}to{opacity:0;-webkit-transform:translateY(-40px);transform:translateY(-40px)}}@keyframes passing-through{0%{opacity:0;-webkit-transform:translateY(40px);transform:translateY(40px)}30%,70%{opacity:1;-webkit-transform:translateY(0);transform:translateY(0)}to{opacity:0;-webkit-transform:translateY(-40px);transform:translateY(-40px)}}@-webkit-keyframes slide-in{0%{opacity:0;-webkit-transform:translateY(40px);transform:translateY(40px)}30%{opacity:1;-webkit-transform:translateY(0);transform:translateY(0)}}@keyframes slide-in{0%{opacity:0;-webkit-transform:translateY(40px);transform:translateY(40px)}30%{opacity:1;-webkit-transform:translateY(0);transform:translateY(0)}}@-webkit-keyframes pulse{0%{-webkit-transform:scale(1);transform:scale(1)}10%{-webkit-transform:scale(1.1);transform:scale(1.1)}20%{-webkit-transform:scale(1);transform:scale(1)}}@keyframes pulse{0%{-webkit-transform:scale(1);transform:scale(1)}10%{-webkit-transform:scale(1.1);transform:scale(1.1)}20%{-webkit-transform:scale(1);transform:scale(1)}}.dropzone,.dropzone *{box-sizing:border-box}.dropzone{min-height:150px;border:2px solid rgba(0,0,0,.3);background:#fff;padding:20px}.dropzone.dz-clickable{cursor:pointer}.dropzone.dz-clickable *{cursor:default}.dropzone.dz-clickable .dz-message,.dropzone.dz-clickable .dz-message *{cursor:pointer}.dropzone.dz-started .dz-message{display:none}.dropzone.dz-drag-hover{border-style:solid}.dropzone.dz-drag-hover .dz-message{opacity:.5}.dropzone .dz-message{text-align:center;margin:2em 0}.dropzone .dz-preview{position:relative;display:inline-block;vertical-align:top;margin:16px;min-height:100px}.dropzone .dz-preview:hover{z-index:1000}.dropzone .dz-preview.dz-file-preview .dz-image{border-radius:20px;background:#999;background:linear-gradient(180deg,#eee,#ddd)}.dropzone .dz-preview.dz-file-preview .dz-details{opacity:1}.dropzone .dz-preview.dz-image-preview{background:#fff}.dropzone .dz-preview.dz-image-preview .dz-details{transition:opacity .2s linear}.dropzone .dz-preview .dz-remove{font-size:14px;text-align:center;display:block;cursor:pointer;border:none}.dropzone .dz-preview .dz-remove:hover{text-decoration:underline}.dropzone .dz-preview:hover .dz-details{opacity:1}.dropzone .dz-preview .dz-details{z-index:20;position:absolute;top:0;left:0;opacity:0;font-size:13px;min-width:100%;max-width:100%;padding:2em 1em;text-align:center;color:rgba(0,0,0,.9);line-height:150%}.dropzone .dz-preview .dz-details .dz-size{margin-bottom:1em;font-size:16px}.dropzone .dz-preview .dz-details .dz-filename{white-space:nowrap}.dropzone .dz-preview .dz-details .dz-filename:hover span{border:1px solid hsla(0,0%,78%,.8);background-color:hsla(0,0%,100%,.8)}.dropzone .dz-preview .dz-details .dz-filename:not(:hover){overflow:hidden;text-overflow:ellipsis}.dropzone .dz-preview .dz-details .dz-filename:not(:hover) span{border:1px solid transparent}.dropzone .dz-preview .dz-details .dz-filename span,.dropzone .dz-preview .dz-details .dz-size span{background-color:hsla(0,0%,100%,.4);padding:0 .4em;border-radius:3px}.dropzone .dz-preview:hover .dz-image img{-webkit-transform:scale(1.05);transform:scale(1.05);-webkit-filter:blur(8px);filter:blur(8px)}.dropzone .dz-preview .dz-image{border-radius:20px;overflow:hidden;width:120px;height:120px;position:relative;display:block;z-index:10}.dropzone .dz-preview .dz-image img{display:block}.dropzone .dz-preview.dz-success .dz-success-mark{-webkit-animation:passing-through 3s cubic-bezier(.77,0,.175,1);animation:passing-through 3s cubic-bezier(.77,0,.175,1)}.dropzone .dz-preview.dz-error .dz-error-mark{opacity:1;-webkit-animation:slide-in 3s cubic-bezier(.77,0,.175,1);animation:slide-in 3s cubic-bezier(.77,0,.175,1)}.dropzone .dz-preview .dz-error-mark,.dropzone .dz-preview .dz-success-mark{pointer-events:none;opacity:0;z-index:500;position:absolute;display:block;top:50%;left:50%;margin-left:-27px;margin-top:-27px}.dropzone .dz-preview .dz-error-mark svg,.dropzone .dz-preview .dz-success-mark svg{display:block;width:54px;height:54px}.dropzone .dz-preview.dz-processing .dz-progress{opacity:1;transition:all .2s linear}.dropzone .dz-preview.dz-complete .dz-progress{opacity:0;transition:opacity .4s ease-in}.dropzone .dz-preview:not(.dz-processing) .dz-progress{-webkit-animation:pulse 6s ease infinite;animation:pulse 6s ease infinite}.dropzone .dz-preview .dz-progress{opacity:1;z-index:1000;pointer-events:none;position:absolute;height:16px;left:50%;top:50%;margin-top:-8px;width:80px;margin-left:-40px;background:hsla(0,0%,100%,.9);-webkit-transform:scale(1);border-radius:8px;overflow:hidden}.dropzone .dz-preview .dz-progress .dz-upload{background:#333;background:linear-gradient(180deg,#666,#444);position:absolute;top:0;left:0;bottom:0;width:0;transition:width .3s ease-in-out}.dropzone .dz-preview.dz-error .dz-error-message{display:block}.dropzone .dz-preview.dz-error:hover .dz-error-message{opacity:1;pointer-events:auto}.dropzone .dz-preview .dz-error-message{pointer-events:none;z-index:1000;position:absolute;display:block;display:none;opacity:0;transition:opacity .3s ease;border-radius:8px;font-size:13px;top:130px;left:-10px;width:140px;background:#be2626;background:linear-gradient(180deg,#be2626,#a92222);padding:.5em 1.2em;color:#fff}.dropzone .dz-preview .dz-error-message:after{content:"";position:absolute;top:-6px;left:64px;width:0;height:0;border-left:6px solid transparent;border-right:6px solid transparent;border-bottom:6px solid #be2626}',""])},function(e,t,i){t=e.exports=i(1)(),t.i(i(3),""),t.push([e.id,".vue-dropzone{border:2px solid #e5e5e5;font-family:Arial,sans-serif;letter-spacing:.2px;color:#777;transition:background-color .2s linear}.vue-dropzone:hover{background-color:#f6f6f6}.vue-dropzone i{color:#ccc}.vue-dropzone .dz-preview .dz-image{border-radius:0}.vue-dropzone .dz-preview .dz-image:hover img{-webkit-transform:none;transform:none;-webkit-filter:none}.vue-dropzone .dz-preview .dz-details{bottom:0;top:0;color:#fff;background-color:rgba(33,150,243,.8);transition:opacity .2s linear;text-align:left}.vue-dropzone .dz-preview .dz-details .dz-filename span,.vue-dropzone .dz-preview .dz-details .dz-size span{background-color:transparent}.vue-dropzone .dz-preview .dz-details .dz-filename:not(:hover) span{border:none}.vue-dropzone .dz-preview .dz-details .dz-filename:hover span{background-color:transparent;border:none}.vue-dropzone .dz-preview .dz-progress .dz-upload{background:#ccc}.vue-dropzone .dz-preview .dz-remove{position:absolute;z-index:30;color:#fff;margin-left:15px;padding:10px;top:inherit;bottom:15px;border:2px solid #fff;text-decoration:none;text-transform:uppercase;font-size:.8rem;font-weight:800;letter-spacing:1.1px;opacity:0}.vue-dropzone .dz-preview:hover .dz-remove{opacity:1}.vue-dropzone .dz-preview .dz-error-mark,.vue-dropzone .dz-preview .dz-success-mark{margin-left:auto!important;margin-top:auto!important;width:100%!important;top:35%!important;left:0}.vue-dropzone .dz-preview .dz-error-mark i,.vue-dropzone .dz-preview .dz-success-mark i{color:#fff!important;font-size:5rem!important}.vue-dropzone .dz-preview .dz-error-message{top:75%;left:15%}",""])},function(e,t,i){(function(e){(function(){var t,i,n,o,r,s,a,l,d,p=[].slice,u=function(e,t){function i(){this.constructor=e}for(var n in t)c.call(t,n)&&(e[n]=t[n]);return i.prototype=t.prototype,e.prototype=new i,e.__super__=t.prototype,e},c={}.hasOwnProperty;l=function(){},i=function(){function e(){}return e.prototype.addEventListener=e.prototype.on,e.prototype.on=function(e,t){return this._callbacks=this._callbacks||{},this._callbacks[e]||(this._callbacks[e]=[]),this._callbacks[e].push(t),this},e.prototype.emit=function(){var e,t,i,n,o,r;if(n=arguments[0],e=2<=arguments.length?p.call(arguments,1):[],this._callbacks=this._callbacks||{},i=this._callbacks[n])for(o=0,r=i.length;o<r;o++)t=i[o],t.apply(this,e);return this},e.prototype.removeListener=e.prototype.off,e.prototype.removeAllListeners=e.prototype.off,e.prototype.removeEventListener=e.prototype.off,e.prototype.off=function(e,t){var i,n,o,r,s;if(!this._callbacks||0===arguments.length)return this._callbacks={},this;if(n=this._callbacks[e],!n)return this;if(1===arguments.length)return delete this._callbacks[e],this;for(o=r=0,s=n.length;r<s;o=++r)if(i=n[o],i===t){n.splice(o,1);break}return this},e}(),t=function(e){function t(e,i){var n,r,s;if(this.element=e,this.version=t.version,this.defaultOptions.previewTemplate=this.defaultOptions.previewTemplate.replace(/\n*/g,""),this.clickableElements=[],this.listeners=[],this.files=[],"string"==typeof this.element&&(this.element=document.querySelector(this.element)),!this.element||null==this.element.nodeType)throw new Error("Invalid dropzone element.");if(this.element.dropzone)throw new Error("Dropzone already attached.");if(t.instances.push(this),this.element.dropzone=this,n=null!=(s=t.optionsForElement(this.element))?s:{},this.options=o({},this.defaultOptions,n,null!=i?i:{}),this.options.forceFallback||!t.isBrowserSupported())return this.options.fallback.call(this);if(null==this.options.url&&(this.options.url=this.element.getAttribute("action")),!this.options.url)throw new Error("No URL provided.");if(this.options.acceptedFiles&&this.options.acceptedMimeTypes)throw new Error("You can't provide both 'acceptedFiles' and 'acceptedMimeTypes'. 'acceptedMimeTypes' is deprecated.");this.options.acceptedMimeTypes&&(this.options.acceptedFiles=this.options.acceptedMimeTypes,delete this.options.acceptedMimeTypes),null!=this.options.renameFilename&&(this.options.renameFile=function(e){return function(t){return e.options.renameFilename.call(e,t.name,t)}}(this)),this.options.method=this.options.method.toUpperCase(),(r=this.getExistingFallback())&&r.parentNode&&r.parentNode.removeChild(r),this.options.previewsContainer!==!1&&(this.options.previewsContainer?this.previewsContainer=t.getElement(this.options.previewsContainer,"previewsContainer"):this.previewsContainer=this.element),this.options.clickable&&(this.options.clickable===!0?this.clickableElements=[this.element]:this.clickableElements=t.getElements(this.options.clickable,"clickable")),this.init()}var o,r;return u(t,e),t.prototype.Emitter=i,t.prototype.events=["drop","dragstart","dragend","dragenter","dragover","dragleave","addedfile","addedfiles","removedfile","thumbnail","error","errormultiple","processing","processingmultiple","uploadprogress","totaluploadprogress","sending","sendingmultiple","success","successmultiple","canceled","canceledmultiple","complete","completemultiple","reset","maxfilesexceeded","maxfilesreached","queuecomplete"],t.prototype.defaultOptions={url:null,method:"post",withCredentials:!1,timeout:3e4,parallelUploads:2,uploadMultiple:!1,maxFilesize:256,paramName:"file",createImageThumbnails:!0,maxThumbnailFilesize:10,thumbnailWidth:120,thumbnailHeight:120,thumbnailMethod:"crop",resizeWidth:null,resizeHeight:null,resizeMimeType:null,resizeQuality:.8,resizeMethod:"contain",filesizeBase:1e3,maxFiles:null,params:{},headers:null,clickable:!0,ignoreHiddenFiles:!0,acceptedFiles:null,acceptedMimeTypes:null,autoProcessQueue:!0,autoQueue:!0,addRemoveLinks:!1,previewsContainer:null,hiddenInputContainer:"body",capture:null,renameFilename:null,renameFile:null,forceFallback:!1,dictDefaultMessage:"Drop files here to upload",dictFallbackMessage:"Your browser does not support drag'n'drop file uploads.",dictFallbackText:"Please use the fallback form below to upload your files like in the olden days.",dictFileTooBig:"File is too big ({{filesize}}MiB). Max filesize: {{maxFilesize}}MiB.",dictInvalidFileType:"You can't upload files of this type.",dictResponseError:"Server responded with {{statusCode}} code.",dictCancelUpload:"Cancel upload",dictCancelUploadConfirmation:"Are you sure you want to cancel this upload?",dictRemoveFile:"Remove file",dictRemoveFileConfirmation:null,dictMaxFilesExceeded:"You can not upload any more files.",dictFileSizeUnits:{tb:"TB",gb:"GB",mb:"MB",kb:"KB",b:"b"},init:function(){return l},accept:function(e,t){return t()},fallback:function(){var e,i,n,o,r,s;for(this.element.className=this.element.className+" dz-browser-not-supported",r=this.element.getElementsByTagName("div"),i=0,n=r.length;i<n;i++)e=r[i],/(^| )dz-message($| )/.test(e.className)&&(o=e,e.className="dz-message");return o||(o=t.createElement('<div class="dz-message"><span></span></div>'),this.element.appendChild(o)),s=o.getElementsByTagName("span")[0],s&&(null!=s.textContent?s.textContent=this.options.dictFallbackMessage:null!=s.innerText&&(s.innerText=this.options.dictFallbackMessage)),this.element.appendChild(this.getFallbackForm())},resize:function(e,t,i,n){var o,r,s;if(o={srcX:0,srcY:0,srcWidth:e.width,srcHeight:e.height},r=e.width/e.height,null==t&&null==i?(t=o.srcWidth,i=o.srcHeight):null==t?t=i*r:null==i&&(i=t/r),t=Math.min(t,o.srcWidth),i=Math.min(i,o.srcHeight),s=t/i,o.srcWidth>t||o.srcHeight>i)if("crop"===n)r>s?(o.srcHeight=e.height,o.srcWidth=o.srcHeight*s):(o.srcWidth=e.width,o.srcHeight=o.srcWidth/s);else{if("contain"!==n)throw new Error("Unknown resizeMethod '"+n+"'");r>s?i=t/r:t=i*r}return o.srcX=(e.width-o.srcWidth)/2,o.srcY=(e.height-o.srcHeight)/2,o.trgWidth=t,o.trgHeight=i,o},transformFile:function(e,t){return(this.options.resizeWidth||this.options.resizeHeight)&&e.type.match(/image.*/)?this.resizeImage(e,this.options.resizeWidth,this.options.resizeHeight,this.options.resizeMethod,t):t(e)},previewTemplate:'<div class="dz-preview dz-file-preview">\n  <div class="dz-image"><img data-dz-thumbnail /></div>\n  <div class="dz-details">\n    <div class="dz-size"><span data-dz-size></span></div>\n    <div class="dz-filename"><span data-dz-name></span></div>\n  </div>\n  <div class="dz-progress"><span class="dz-upload" data-dz-uploadprogress></span></div>\n  <div class="dz-error-message"><span data-dz-errormessage></span></div>\n  <div class="dz-success-mark">\n    <svg width="54px" height="54px" viewBox="0 0 54 54" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:sketch="http://www.bohemiancoding.com/sketch/ns">\n      <title>Check</title>\n      <defs></defs>\n      <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" sketch:type="MSPage">\n        <path d="M23.5,31.8431458 L17.5852419,25.9283877 C16.0248253,24.3679711 13.4910294,24.366835 11.9289322,25.9289322 C10.3700136,27.4878508 10.3665912,30.0234455 11.9283877,31.5852419 L20.4147581,40.0716123 C20.5133999,40.1702541 20.6159315,40.2626649 20.7218615,40.3488435 C22.2835669,41.8725651 24.794234,41.8626202 26.3461564,40.3106978 L43.3106978,23.3461564 C44.8771021,21.7797521 44.8758057,19.2483887 43.3137085,17.6862915 C41.7547899,16.1273729 39.2176035,16.1255422 37.6538436,17.6893022 L23.5,31.8431458 Z M27,53 C41.3594035,53 53,41.3594035 53,27 C53,12.6405965 41.3594035,1 27,1 C12.6405965,1 1,12.6405965 1,27 C1,41.3594035 12.6405965,53 27,53 Z" id="Oval-2" stroke-opacity="0.198794158" stroke="#747474" fill-opacity="0.816519475" fill="#FFFFFF" sketch:type="MSShapeGroup"></path>\n      </g>\n    </svg>\n  </div>\n  <div class="dz-error-mark">\n    <svg width="54px" height="54px" viewBox="0 0 54 54" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:sketch="http://www.bohemiancoding.com/sketch/ns">\n      <title>Error</title>\n      <defs></defs>\n      <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" sketch:type="MSPage">\n        <g id="Check-+-Oval-2" sketch:type="MSLayerGroup" stroke="#747474" stroke-opacity="0.198794158" fill="#FFFFFF" fill-opacity="0.816519475">\n          <path d="M32.6568542,29 L38.3106978,23.3461564 C39.8771021,21.7797521 39.8758057,19.2483887 38.3137085,17.6862915 C36.7547899,16.1273729 34.2176035,16.1255422 32.6538436,17.6893022 L27,23.3431458 L21.3461564,17.6893022 C19.7823965,16.1255422 17.2452101,16.1273729 15.6862915,17.6862915 C14.1241943,19.2483887 14.1228979,21.7797521 15.6893022,23.3461564 L21.3431458,29 L15.6893022,34.6538436 C14.1228979,36.2202479 14.1241943,38.7516113 15.6862915,40.3137085 C17.2452101,41.8726271 19.7823965,41.8744578 21.3461564,40.3106978 L27,34.6568542 L32.6538436,40.3106978 C34.2176035,41.8744578 36.7547899,41.8726271 38.3137085,40.3137085 C39.8758057,38.7516113 39.8771021,36.2202479 38.3106978,34.6538436 L32.6568542,29 Z M27,53 C41.3594035,53 53,41.3594035 53,27 C53,12.6405965 41.3594035,1 27,1 C12.6405965,1 1,12.6405965 1,27 C1,41.3594035 12.6405965,53 27,53 Z" id="Oval-2" sketch:type="MSShapeGroup"></path>\n        </g>\n      </g>\n    </svg>\n  </div>\n</div>',drop:function(e){return this.element.classList.remove("dz-drag-hover")},dragstart:l,dragend:function(e){return this.element.classList.remove("dz-drag-hover")},dragenter:function(e){return this.element.classList.add("dz-drag-hover")},dragover:function(e){return this.element.classList.add("dz-drag-hover")},dragleave:function(e){return this.element.classList.remove("dz-drag-hover")},paste:l,reset:function(){return this.element.classList.remove("dz-started")},addedfile:function(e){var i,n,o,r,s,a,l,d,p,u,c,h,f;if(this.element===this.previewsContainer&&this.element.classList.add("dz-started"),this.previewsContainer){for(e.previewElement=t.createElement(this.options.previewTemplate.trim()),e.previewTemplate=e.previewElement,this.previewsContainer.appendChild(e.previewElement),d=e.previewElement.querySelectorAll("[data-dz-name]"),i=0,r=d.length;i<r;i++)l=d[i],l.textContent=e.name;for(p=e.previewElement.querySelectorAll("[data-dz-size]"),n=0,s=p.length;n<s;n++)l=p[n],l.innerHTML=this.filesize(e.size);for(this.options.addRemoveLinks&&(e._removeLink=t.createElement('<a class="dz-remove" href="javascript:undefined;" data-dz-remove>'+this.options.dictRemoveFile+"</a>"),e.previewElement.appendChild(e._removeLink)),c=function(i){return function(n){return n.preventDefault(),n.stopPropagation(),e.status===t.UPLOADING?t.confirm(i.options.dictCancelUploadConfirmation,function(){return i.removeFile(e)}):i.options.dictRemoveFileConfirmation?t.confirm(i.options.dictRemoveFileConfirmation,function(){return i.removeFile(e)}):i.removeFile(e)}}(this),u=e.previewElement.querySelectorAll("[data-dz-remove]"),f=[],o=0,a=u.length;o<a;o++)h=u[o],f.push(h.addEventListener("click",c));return f}},removedfile:function(e){var t;return e.previewElement&&null!=(t=e.previewElement)&&t.parentNode.removeChild(e.previewElement),this._updateMaxFilesReachedClass()},thumbnail:function(e,t){var i,n,o,r;if(e.previewElement){for(e.previewElement.classList.remove("dz-file-preview"),o=e.previewElement.querySelectorAll("[data-dz-thumbnail]"),i=0,n=o.length;i<n;i++)r=o[i],r.alt=e.name,r.src=t;return setTimeout(function(t){return function(){return e.previewElement.classList.add("dz-image-preview")}}(this),1)}},error:function(e,t){var i,n,o,r,s;if(e.previewElement){for(e.previewElement.classList.add("dz-error"),"String"!=typeof t&&t.error&&(t=t.error),r=e.previewElement.querySelectorAll("[data-dz-errormessage]"),s=[],i=0,n=r.length;i<n;i++)o=r[i],s.push(o.textContent=t);return s}},errormultiple:l,processing:function(e){if(e.previewElement&&(e.previewElement.classList.add("dz-processing"),e._removeLink))return e._removeLink.textContent=this.options.dictCancelUpload},processingmultiple:l,uploadprogress:function(e,t,i){var n,o,r,s,a;if(e.previewElement){for(s=e.previewElement.querySelectorAll("[data-dz-uploadprogress]"),a=[],n=0,o=s.length;n<o;n++)r=s[n],"PROGRESS"===r.nodeName?a.push(r.value=t):a.push(r.style.width=t+"%");return a}},totaluploadprogress:l,sending:l,sendingmultiple:l,success:function(e){if(e.previewElement)return e.previewElement.classList.add("dz-success")},successmultiple:l,canceled:function(e){return this.emit("error",e,"Upload canceled.")},canceledmultiple:l,complete:function(e){if(e._removeLink&&(e._removeLink.textContent=this.options.dictRemoveFile),e.previewElement)return e.previewElement.classList.add("dz-complete")},completemultiple:l,maxfilesexceeded:l,maxfilesreached:l,queuecomplete:l,addedfiles:l},o=function(){var e,t,i,n,o,r,s;for(r=arguments[0],o=2<=arguments.length?p.call(arguments,1):[],e=0,i=o.length;e<i;e++){n=o[e];for(t in n)s=n[t],r[t]=s}return r},t.prototype.getAcceptedFiles=function(){var e,t,i,n,o;for(n=this.files,o=[],t=0,i=n.length;t<i;t++)e=n[t],e.accepted&&o.push(e);return o},t.prototype.getRejectedFiles=function(){var e,t,i,n,o;for(n=this.files,o=[],t=0,i=n.length;t<i;t++)e=n[t],e.accepted||o.push(e);return o},t.prototype.getFilesWithStatus=function(e){var t,i,n,o,r;for(o=this.files,r=[],i=0,n=o.length;i<n;i++)t=o[i],t.status===e&&r.push(t);return r},t.prototype.getQueuedFiles=function(){return this.getFilesWithStatus(t.QUEUED)},t.prototype.getUploadingFiles=function(){return this.getFilesWithStatus(t.UPLOADING)},t.prototype.getAddedFiles=function(){return this.getFilesWithStatus(t.ADDED)},t.prototype.getActiveFiles=function(){var e,i,n,o,r;for(o=this.files,r=[],i=0,n=o.length;i<n;i++)e=o[i],e.status!==t.UPLOADING&&e.status!==t.QUEUED||r.push(e);return r},t.prototype.init=function(){var e,i,n,o,r,s,a;for("form"===this.element.tagName&&this.element.setAttribute("enctype","multipart/form-data"),this.element.classList.contains("dropzone")&&!this.element.querySelector(".dz-message")&&this.element.appendChild(t.createElement('<div class="dz-default dz-message"><span>'+this.options.dictDefaultMessage+"</span></div>")),this.clickableElements.length&&(a=function(e){return function(){return e.hiddenFileInput&&e.hiddenFileInput.parentNode.removeChild(e.hiddenFileInput),e.hiddenFileInput=document.createElement("input"),e.hiddenFileInput.setAttribute("type","file"),(null==e.options.maxFiles||e.options.maxFiles>1)&&e.hiddenFileInput.setAttribute("multiple","multiple"),e.hiddenFileInput.className="dz-hidden-input",null!=e.options.acceptedFiles&&e.hiddenFileInput.setAttribute("accept",e.options.acceptedFiles),null!=e.options.capture&&e.hiddenFileInput.setAttribute("capture",e.options.capture),
	e.hiddenFileInput.style.visibility="hidden",e.hiddenFileInput.style.position="absolute",e.hiddenFileInput.style.top="0",e.hiddenFileInput.style.left="0",e.hiddenFileInput.style.height="0",e.hiddenFileInput.style.width="0",document.querySelector(e.options.hiddenInputContainer).appendChild(e.hiddenFileInput),e.hiddenFileInput.addEventListener("change",function(){var t,i,n,o;if(i=e.hiddenFileInput.files,i.length)for(n=0,o=i.length;n<o;n++)t=i[n],e.addFile(t);return e.emit("addedfiles",i),a()})}}(this))(),this.URL=null!=(r=window.URL)?r:window.webkitURL,s=this.events,i=0,n=s.length;i<n;i++)e=s[i],this.on(e,this.options[e]);return this.on("uploadprogress",function(e){return function(){return e.updateTotalUploadProgress()}}(this)),this.on("removedfile",function(e){return function(){return e.updateTotalUploadProgress()}}(this)),this.on("canceled",function(e){return function(t){return e.emit("complete",t)}}(this)),this.on("complete",function(e){return function(t){if(0===e.getAddedFiles().length&&0===e.getUploadingFiles().length&&0===e.getQueuedFiles().length)return setTimeout(function(){return e.emit("queuecomplete")},0)}}(this)),o=function(e){return e.stopPropagation(),e.preventDefault?e.preventDefault():e.returnValue=!1},this.listeners=[{element:this.element,events:{dragstart:function(e){return function(t){return e.emit("dragstart",t)}}(this),dragenter:function(e){return function(t){return o(t),e.emit("dragenter",t)}}(this),dragover:function(e){return function(t){var i;try{i=t.dataTransfer.effectAllowed}catch(e){}return t.dataTransfer.dropEffect="move"===i||"linkMove"===i?"move":"copy",o(t),e.emit("dragover",t)}}(this),dragleave:function(e){return function(t){return e.emit("dragleave",t)}}(this),drop:function(e){return function(t){return o(t),e.drop(t)}}(this),dragend:function(e){return function(t){return e.emit("dragend",t)}}(this)}}],this.clickableElements.forEach(function(e){return function(i){return e.listeners.push({element:i,events:{click:function(n){return(i!==e.element||n.target===e.element||t.elementInside(n.target,e.element.querySelector(".dz-message")))&&e.hiddenFileInput.click(),!0}}})}}(this)),this.enable(),this.options.init.call(this)},t.prototype.destroy=function(){var e;return this.disable(),this.removeAllFiles(!0),(null!=(e=this.hiddenFileInput)?e.parentNode:void 0)&&(this.hiddenFileInput.parentNode.removeChild(this.hiddenFileInput),this.hiddenFileInput=null),delete this.element.dropzone,t.instances.splice(t.instances.indexOf(this),1)},t.prototype.updateTotalUploadProgress=function(){var e,t,i,n,o,r,s,a;if(s=0,r=0,e=this.getActiveFiles(),e.length){for(o=this.getActiveFiles(),i=0,n=o.length;i<n;i++)t=o[i],s+=t.upload.bytesSent,r+=t.upload.total;a=100*s/r}else a=100;return this.emit("totaluploadprogress",a,r,s)},t.prototype._getParamName=function(e){return"function"==typeof this.options.paramName?this.options.paramName(e):""+this.options.paramName+(this.options.uploadMultiple?"["+e+"]":"")},t.prototype._renameFile=function(e){return"function"!=typeof this.options.renameFile?e.name:this.options.renameFile(e)},t.prototype.getFallbackForm=function(){var e,i,n,o;return(e=this.getExistingFallback())?e:(n='<div class="dz-fallback">',this.options.dictFallbackText&&(n+="<p>"+this.options.dictFallbackText+"</p>"),n+='<input type="file" name="'+this._getParamName(0)+'" '+(this.options.uploadMultiple?'multiple="multiple"':void 0)+' /><input type="submit" value="Upload!"></div>',i=t.createElement(n),"FORM"!==this.element.tagName?(o=t.createElement('<form action="'+this.options.url+'" enctype="multipart/form-data" method="'+this.options.method+'"></form>'),o.appendChild(i)):(this.element.setAttribute("enctype","multipart/form-data"),this.element.setAttribute("method",this.options.method)),null!=o?o:i)},t.prototype.getExistingFallback=function(){var e,t,i,n,o,r;for(t=function(e){var t,i,n;for(i=0,n=e.length;i<n;i++)if(t=e[i],/(^| )fallback($| )/.test(t.className))return t},o=["div","form"],i=0,n=o.length;i<n;i++)if(r=o[i],e=t(this.element.getElementsByTagName(r)))return e},t.prototype.setupEventListeners=function(){var e,t,i,n,o,r,s;for(r=this.listeners,s=[],i=0,n=r.length;i<n;i++)e=r[i],s.push(function(){var i,n;i=e.events,n=[];for(t in i)o=i[t],n.push(e.element.addEventListener(t,o,!1));return n}());return s},t.prototype.removeEventListeners=function(){var e,t,i,n,o,r,s;for(r=this.listeners,s=[],i=0,n=r.length;i<n;i++)e=r[i],s.push(function(){var i,n;i=e.events,n=[];for(t in i)o=i[t],n.push(e.element.removeEventListener(t,o,!1));return n}());return s},t.prototype.disable=function(){var e,t,i,n,o;for(this.clickableElements.forEach(function(e){return e.classList.remove("dz-clickable")}),this.removeEventListeners(),n=this.files,o=[],t=0,i=n.length;t<i;t++)e=n[t],o.push(this.cancelUpload(e));return o},t.prototype.enable=function(){return this.clickableElements.forEach(function(e){return e.classList.add("dz-clickable")}),this.setupEventListeners()},t.prototype.filesize=function(e){var t,i,n,o,r,s,a,l;if(r=0,s="b",e>0){for(l=["tb","gb","mb","kb","b"],i=n=0,o=l.length;n<o;i=++n)if(a=l[i],t=Math.pow(this.options.filesizeBase,4-i)/10,e>=t){r=e/Math.pow(this.options.filesizeBase,4-i),s=a;break}r=Math.round(10*r)/10}return"<strong>"+r+"</strong> "+this.options.dictFileSizeUnits[s]},t.prototype._updateMaxFilesReachedClass=function(){return null!=this.options.maxFiles&&this.getAcceptedFiles().length>=this.options.maxFiles?(this.getAcceptedFiles().length===this.options.maxFiles&&this.emit("maxfilesreached",this.files),this.element.classList.add("dz-max-files-reached")):this.element.classList.remove("dz-max-files-reached")},t.prototype.drop=function(e){var t,i;e.dataTransfer&&(this.emit("drop",e),t=e.dataTransfer.files,this.emit("addedfiles",t),t.length&&(i=e.dataTransfer.items,i&&i.length&&null!=i[0].webkitGetAsEntry?this._addFilesFromItems(i):this.handleFiles(t)))},t.prototype.paste=function(e){var t,i;if(null!=(null!=e&&null!=(i=e.clipboardData)?i.items:void 0))return this.emit("paste",e),t=e.clipboardData.items,t.length?this._addFilesFromItems(t):void 0},t.prototype.handleFiles=function(e){var t,i,n,o;for(o=[],i=0,n=e.length;i<n;i++)t=e[i],o.push(this.addFile(t));return o},t.prototype._addFilesFromItems=function(e){var t,i,n,o,r;for(r=[],n=0,o=e.length;n<o;n++)i=e[n],null!=i.webkitGetAsEntry&&(t=i.webkitGetAsEntry())?t.isFile?r.push(this.addFile(i.getAsFile())):t.isDirectory?r.push(this._addFilesFromDirectory(t,t.name)):r.push(void 0):null!=i.getAsFile&&(null==i.kind||"file"===i.kind)?r.push(this.addFile(i.getAsFile())):r.push(void 0);return r},t.prototype._addFilesFromDirectory=function(e,t){var i,n,o;return i=e.createReader(),n=function(e){return"undefined"!=typeof console&&null!==console&&"function"==typeof console.log?console.log(e):void 0},(o=function(e){return function(){return i.readEntries(function(i){var n,r,s;if(i.length>0){for(r=0,s=i.length;r<s;r++)n=i[r],n.isFile?n.file(function(i){if(!e.options.ignoreHiddenFiles||"."!==i.name.substring(0,1))return i.fullPath=t+"/"+i.name,e.addFile(i)}):n.isDirectory&&e._addFilesFromDirectory(n,t+"/"+n.name);o()}return null},n)}}(this))()},t.prototype.accept=function(e,i){return e.size>1024*this.options.maxFilesize*1024?i(this.options.dictFileTooBig.replace("{{filesize}}",Math.round(e.size/1024/10.24)/100).replace("{{maxFilesize}}",this.options.maxFilesize)):t.isValidFile(e,this.options.acceptedFiles)?null!=this.options.maxFiles&&this.getAcceptedFiles().length>=this.options.maxFiles?(i(this.options.dictMaxFilesExceeded.replace("{{maxFiles}}",this.options.maxFiles)),this.emit("maxfilesexceeded",e)):this.options.accept.call(this,e,i):i(this.options.dictInvalidFileType)},t.prototype.addFile=function(e){return e.upload={progress:0,total:e.size,bytesSent:0,filename:this._renameFile(e)},this.files.push(e),e.status=t.ADDED,this.emit("addedfile",e),this._enqueueThumbnail(e),this.accept(e,function(t){return function(i){return i?(e.accepted=!1,t._errorProcessing([e],i)):(e.accepted=!0,t.options.autoQueue&&t.enqueueFile(e)),t._updateMaxFilesReachedClass()}}(this))},t.prototype.enqueueFiles=function(e){var t,i,n;for(i=0,n=e.length;i<n;i++)t=e[i],this.enqueueFile(t);return null},t.prototype.enqueueFile=function(e){if(e.status!==t.ADDED||e.accepted!==!0)throw new Error("This file can't be queued because it has already been processed or was rejected.");if(e.status=t.QUEUED,this.options.autoProcessQueue)return setTimeout(function(e){return function(){return e.processQueue()}}(this),0)},t.prototype._thumbnailQueue=[],t.prototype._processingThumbnail=!1,t.prototype._enqueueThumbnail=function(e){if(this.options.createImageThumbnails&&e.type.match(/image.*/)&&e.size<=1024*this.options.maxThumbnailFilesize*1024)return this._thumbnailQueue.push(e),setTimeout(function(e){return function(){return e._processThumbnailQueue()}}(this),0)},t.prototype._processThumbnailQueue=function(){var e;if(!this._processingThumbnail&&0!==this._thumbnailQueue.length)return this._processingThumbnail=!0,e=this._thumbnailQueue.shift(),this.createThumbnail(e,this.options.thumbnailWidth,this.options.thumbnailHeight,this.options.thumbnailMethod,!0,function(t){return function(i){return t.emit("thumbnail",e,i),t._processingThumbnail=!1,t._processThumbnailQueue()}}(this))},t.prototype.removeFile=function(e){if(e.status===t.UPLOADING&&this.cancelUpload(e),this.files=d(this.files,e),this.emit("removedfile",e),0===this.files.length)return this.emit("reset")},t.prototype.removeAllFiles=function(e){var i,n,o,r;for(null==e&&(e=!1),r=this.files.slice(),n=0,o=r.length;n<o;n++)i=r[n],(i.status!==t.UPLOADING||e)&&this.removeFile(i);return null},t.prototype.resizeImage=function(e,i,o,r,s){return this.createThumbnail(e,i,o,r,!1,function(i){return function(o,r){var a,l;return null===r?s(e):(a=i.options.resizeMimeType,null==a&&(a=e.type),l=r.toDataURL(a,i.options.resizeQuality),"image/jpeg"!==a&&"image/jpg"!==a||(l=n.restore(e.dataURL,l)),s(t.dataURItoBlob(l)))}}(this))},t.prototype.createThumbnail=function(e,t,i,n,o,r){var s;return s=new FileReader,s.onload=function(a){return function(){return e.dataURL=s.result,"image/svg+xml"===e.type?void(null!=r&&r(s.result)):a.createThumbnailFromUrl(e,t,i,n,o,r)}}(this),s.readAsDataURL(e)},t.prototype.createThumbnailFromUrl=function(e,t,i,n,o,r,s){var l;return l=document.createElement("img"),s&&(l.crossOrigin=s),l.onload=function(s){return function(){var d;return d=function(e){return e(1)},"undefined"!=typeof EXIF&&null!==EXIF&&o&&(d=function(e){return EXIF.getData(l,function(){return e(EXIF.getTag(this,"Orientation"))})}),d(function(o){var d,p,u,c,h,f,m,g;switch(e.width=l.width,e.height=l.height,m=s.options.resize.call(s,e,t,i,n),d=document.createElement("canvas"),p=d.getContext("2d"),d.width=m.trgWidth,d.height=m.trgHeight,o>4&&(d.width=m.trgHeight,d.height=m.trgWidth),o){case 2:p.translate(d.width,0),p.scale(-1,1);break;case 3:p.translate(d.width,d.height),p.rotate(Math.PI);break;case 4:p.translate(0,d.height),p.scale(1,-1);break;case 5:p.rotate(.5*Math.PI),p.scale(1,-1);break;case 6:p.rotate(.5*Math.PI),p.translate(0,-d.height);break;case 7:p.rotate(.5*Math.PI),p.translate(d.width,-d.height),p.scale(-1,1);break;case 8:p.rotate(-.5*Math.PI),p.translate(-d.width,0)}if(a(p,l,null!=(u=m.srcX)?u:0,null!=(c=m.srcY)?c:0,m.srcWidth,m.srcHeight,null!=(h=m.trgX)?h:0,null!=(f=m.trgY)?f:0,m.trgWidth,m.trgHeight),g=d.toDataURL("image/png"),null!=r)return r(g,d)})}}(this),null!=r&&(l.onerror=r),l.src=e.dataURL},t.prototype.processQueue=function(){var e,t,i,n;if(t=this.options.parallelUploads,i=this.getUploadingFiles().length,e=i,!(i>=t)&&(n=this.getQueuedFiles(),n.length>0)){if(this.options.uploadMultiple)return this.processFiles(n.slice(0,t-i));for(;e<t;){if(!n.length)return;this.processFile(n.shift()),e++}}},t.prototype.processFile=function(e){return this.processFiles([e])},t.prototype.processFiles=function(e){var i,n,o;for(n=0,o=e.length;n<o;n++)i=e[n],i.processing=!0,i.status=t.UPLOADING,this.emit("processing",i);return this.options.uploadMultiple&&this.emit("processingmultiple",e),this.uploadFiles(e)},t.prototype._getFilesWithXhr=function(e){var t,i;return i=function(){var i,n,o,r;for(o=this.files,r=[],i=0,n=o.length;i<n;i++)t=o[i],t.xhr===e&&r.push(t);return r}.call(this)},t.prototype.cancelUpload=function(e){var i,n,o,r,s,a,l;if(e.status===t.UPLOADING){for(n=this._getFilesWithXhr(e.xhr),o=0,s=n.length;o<s;o++)i=n[o],i.status=t.CANCELED;for(e.xhr.abort(),r=0,a=n.length;r<a;r++)i=n[r],this.emit("canceled",i);this.options.uploadMultiple&&this.emit("canceledmultiple",n)}else(l=e.status)!==t.ADDED&&l!==t.QUEUED||(e.status=t.CANCELED,this.emit("canceled",e),this.options.uploadMultiple&&this.emit("canceledmultiple",[e]));if(this.options.autoProcessQueue)return this.processQueue()},r=function(){var e,t;return t=arguments[0],e=2<=arguments.length?p.call(arguments,1):[],"function"==typeof t?t.apply(this,e):t},t.prototype.uploadFile=function(e){return this.uploadFiles([e])},t.prototype.uploadFiles=function(e){var i,n,s,a,l,d,p,u,c,h,f,m,g,v,z,b,y,w,F,x,k,E,C,T,S,M,A,L,I,O,U,N,P,R,D,_,B;for(B=new XMLHttpRequest,g=0,y=e.length;g<y;g++)s=e[g],s.xhr=B;E=r(this.options.method,e),D=r(this.options.url,e),B.open(E,D,!0),B.timeout=r(this.options.timeout,e),B.withCredentials=!!this.options.withCredentials,N=null,l=function(t){return function(){var i,n,o;for(o=[],i=0,n=e.length;i<n;i++)s=e[i],o.push(t._errorProcessing(e,N||t.options.dictResponseError.replace("{{statusCode}}",B.status),B));return o}}(this),R=function(t){return function(i){var n,o,r,a,l,d,p,u,c;if(null!=i)for(u=100*i.loaded/i.total,o=0,a=e.length;o<a;o++)s=e[o],s.upload.progress=u,s.upload.total=i.total,s.upload.bytesSent=i.loaded;else{for(n=!0,u=100,r=0,l=e.length;r<l;r++)s=e[r],100===s.upload.progress&&s.upload.bytesSent===s.upload.total||(n=!1),s.upload.progress=u,s.upload.bytesSent=s.upload.total;if(n)return}for(c=[],p=0,d=e.length;p<d;p++)s=e[p],c.push(t.emit("uploadprogress",s,u,s.upload.bytesSent));return c}}(this),B.onload=function(i){return function(n){var o;if(e[0].status!==t.CANCELED&&4===B.readyState){if("arraybuffer"!==B.responseType&&"blob"!==B.responseType&&(N=B.responseText,B.getResponseHeader("content-type")&&~B.getResponseHeader("content-type").indexOf("application/json")))try{N=JSON.parse(N)}catch(e){n=e,N="Invalid JSON response from server."}return R(),200<=(o=B.status)&&o<300?i._finished(e,N,n):l()}}}(this),B.onerror=function(i){return function(){if(e[0].status!==t.CANCELED)return l()}}(this),S=null!=(M=B.upload)?M:B,S.onprogress=R,u={Accept:"application/json","Cache-Control":"no-cache","X-Requested-With":"XMLHttpRequest"},this.options.headers&&o(u,this.options.headers);for(d in u)p=u[d],p&&B.setRequestHeader(d,p);if(a=new FormData,this.options.params){A=this.options.params;for(z in A)_=A[z],a.append(z,_)}for(v=0,w=e.length;v<w;v++)s=e[v],this.emit("sending",s,B,a);if(this.options.uploadMultiple&&this.emit("sendingmultiple",e,B,a),"FORM"===this.element.tagName)for(L=this.element.querySelectorAll("input, textarea, select, button"),b=0,F=L.length;b<F;b++)if(h=L[b],f=h.getAttribute("name"),m=h.getAttribute("type"),"SELECT"===h.tagName&&h.hasAttribute("multiple"))for(I=h.options,k=0,x=I.length;k<x;k++)T=I[k],T.selected&&a.append(f,T.value);else(!m||"checkbox"!==(O=m.toLowerCase())&&"radio"!==O||h.checked)&&a.append(f,h.value);for(i=0,P=[],c=C=0,U=e.length-1;0<=U?C<=U:C>=U;c=0<=U?++C:--C)n=function(t){return function(n,o,r){return function(n){if(a.append(o,n,r),++i===e.length)return t.submitRequest(B,a,e)}}}(this),P.push(this.options.transformFile.call(this,e[c],n(e[c],this._getParamName(c),e[c].upload.filename)));return P},t.prototype.submitRequest=function(e,t,i){return e.send(t)},t.prototype._finished=function(e,i,n){var o,r,s;for(r=0,s=e.length;r<s;r++)o=e[r],o.status=t.SUCCESS,this.emit("success",o,i,n),this.emit("complete",o);if(this.options.uploadMultiple&&(this.emit("successmultiple",e,i,n),this.emit("completemultiple",e)),this.options.autoProcessQueue)return this.processQueue()},t.prototype._errorProcessing=function(e,i,n){var o,r,s;for(r=0,s=e.length;r<s;r++)o=e[r],o.status=t.ERROR,this.emit("error",o,i,n),this.emit("complete",o);if(this.options.uploadMultiple&&(this.emit("errormultiple",e,i,n),this.emit("completemultiple",e)),this.options.autoProcessQueue)return this.processQueue()},t}(i),t.version="5.1.1",t.options={},t.optionsForElement=function(e){return e.getAttribute("id")?t.options[o(e.getAttribute("id"))]:void 0},t.instances=[],t.forElement=function(e){if("string"==typeof e&&(e=document.querySelector(e)),null==(null!=e?e.dropzone:void 0))throw new Error("No Dropzone found for given element. This is probably because you're trying to access it before Dropzone had the time to initialize. Use the `init` option to setup any additional observers on your Dropzone.");return e.dropzone},t.autoDiscover=!0,t.discover=function(){var e,i,n,o,r,s;for(document.querySelectorAll?n=document.querySelectorAll(".dropzone"):(n=[],e=function(e){var t,i,o,r;for(r=[],i=0,o=e.length;i<o;i++)t=e[i],/(^| )dropzone($| )/.test(t.className)?r.push(n.push(t)):r.push(void 0);return r},e(document.getElementsByTagName("div")),e(document.getElementsByTagName("form"))),s=[],o=0,r=n.length;o<r;o++)i=n[o],t.optionsForElement(i)!==!1?s.push(new t(i)):s.push(void 0);return s},t.blacklistedBrowsers=[/opera.*Macintosh.*version\/12/i],t.isBrowserSupported=function(){var e,i,n,o,r;if(e=!0,window.File&&window.FileReader&&window.FileList&&window.Blob&&window.FormData&&document.querySelector)if("classList"in document.createElement("a"))for(o=t.blacklistedBrowsers,i=0,n=o.length;i<n;i++)r=o[i],r.test(navigator.userAgent)&&(e=!1);else e=!1;else e=!1;return e},t.dataURItoBlob=function(e){var t,i,n,o,r,s,a;for(i=atob(e.split(",")[1]),s=e.split(",")[0].split(":")[1].split(";")[0],t=new ArrayBuffer(i.length),o=new Uint8Array(t),n=r=0,a=i.length;0<=a?r<=a:r>=a;n=0<=a?++r:--r)o[n]=i.charCodeAt(n);return new Blob([t],{type:s})},d=function(e,t){var i,n,o,r;for(r=[],n=0,o=e.length;n<o;n++)i=e[n],i!==t&&r.push(i);return r},o=function(e){return e.replace(/[\-_](\w)/g,function(e){return e.charAt(1).toUpperCase()})},t.createElement=function(e){var t;return t=document.createElement("div"),t.innerHTML=e,t.childNodes[0]},t.elementInside=function(e,t){if(e===t)return!0;for(;e=e.parentNode;)if(e===t)return!0;return!1},t.getElement=function(e,t){var i;if("string"==typeof e?i=document.querySelector(e):null!=e.nodeType&&(i=e),null==i)throw new Error("Invalid `"+t+"` option provided. Please provide a CSS selector or a plain HTML element.");return i},t.getElements=function(e,t){var i,n,o,r,s,a,l,d;if(e instanceof Array){o=[];try{for(r=0,a=e.length;r<a;r++)n=e[r],o.push(this.getElement(n,t))}catch(e){i=e,o=null}}else if("string"==typeof e)for(o=[],d=document.querySelectorAll(e),s=0,l=d.length;s<l;s++)n=d[s],o.push(n);else null!=e.nodeType&&(o=[e]);if(null==o||!o.length)throw new Error("Invalid `"+t+"` option provided. Please provide a CSS selector, a plain HTML element or a list of those.");return o},t.confirm=function(e,t,i){return window.confirm(e)?t():null!=i?i():void 0},t.isValidFile=function(e,t){var i,n,o,r,s;if(!t)return!0;for(t=t.split(","),r=e.type,i=r.replace(/\/.*$/,""),n=0,o=t.length;n<o;n++)if(s=t[n],s=s.trim(),"."===s.charAt(0)){if(e.name.toLowerCase().indexOf(s.toLowerCase(),e.name.length-s.length)!==-1)return!0}else if(/\/\*$/.test(s)){if(i===s.replace(/\/.*$/,""))return!0}else if(r===s)return!0;return!1},"undefined"!=typeof jQuery&&null!==jQuery&&(jQuery.fn.dropzone=function(e){return this.each(function(){return new t(this,e)})}),"undefined"!=typeof e&&null!==e?e.exports=t:window.Dropzone=t,t.ADDED="added",t.QUEUED="queued",t.ACCEPTED=t.QUEUED,t.UPLOADING="uploading",t.PROCESSING=t.UPLOADING,t.CANCELED="canceled",t.ERROR="error",t.SUCCESS="success",s=function(e){var t,i,n,o,r,s,a,l,d,p;for(a=e.naturalWidth,s=e.naturalHeight,i=document.createElement("canvas"),i.width=1,i.height=s,n=i.getContext("2d"),n.drawImage(e,0,0),o=n.getImageData(1,0,1,s).data,p=0,r=s,l=s;l>p;)t=o[4*(l-1)+3],0===t?r=l:p=l,l=r+p>>1;return d=l/s,0===d?1:d},a=function(e,t,i,n,o,r,a,l,d,p){var u;return u=s(t),e.drawImage(t,i,n,o,r,a,l,d,p/u)},n=function(){function e(){}return e.KEY_STR="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",e.encode64=function(e){var t,i,n,o,r,s,a,l,d;for(d="",t=void 0,i=void 0,n="",o=void 0,r=void 0,s=void 0,a="",l=0;;)if(t=e[l++],i=e[l++],n=e[l++],o=t>>2,r=(3&t)<<4|i>>4,s=(15&i)<<2|n>>6,a=63&n,isNaN(i)?s=a=64:isNaN(n)&&(a=64),d=d+this.KEY_STR.charAt(o)+this.KEY_STR.charAt(r)+this.KEY_STR.charAt(s)+this.KEY_STR.charAt(a),t=i=n="",o=r=s=a="",!(l<e.length))break;return d},e.restore=function(e,t){var i,n,o;return e.match("data:image/jpeg;base64,")?(n=this.decode64(e.replace("data:image/jpeg;base64,","")),o=this.slice2Segments(n),i=this.exifManipulation(t,o),"data:image/jpeg;base64,"+this.encode64(i)):t},e.exifManipulation=function(e,t){var i,n,o;return n=this.getExifArray(t),o=this.insertExif(e,n),i=new Uint8Array(o)},e.getExifArray=function(e){var t,i;for(t=void 0,i=0;i<e.length;){if(t=e[i],255===t[0]&225===t[1])return t;i++}return[]},e.insertExif=function(e,t){var i,n,o,r,s,a;return r=e.replace("data:image/jpeg;base64,",""),o=this.decode64(r),a=o.indexOf(255,3),s=o.slice(0,a),n=o.slice(a),i=s,i=i.concat(t),i=i.concat(n)},e.slice2Segments=function(e){var t,i,n,o,r;for(i=0,r=[];;){if(255===e[i]&218===e[i+1])break;if(255===e[i]&216===e[i+1]?i+=2:(n=256*e[i+2]+e[i+3],t=i+n+2,o=e.slice(i,t),r.push(o),i=t),i>e.length)break}return r},e.decode64=function(e){var t,i,n,o,r,s,a,l,d,p,u;for(u="",n=void 0,o=void 0,r="",s=void 0,a=void 0,l=void 0,d="",p=0,i=[],t=/[^A-Za-z0-9\+\/\=]/g,t.exec(e)&&console.warning("There were invalid base64 characters in the input text.\nValid base64 characters are A-Z, a-z, 0-9, '+', '/',and '='\nExpect errors in decoding."),e=e.replace(/[^A-Za-z0-9\+\/\=]/g,"");;)if(s=this.KEY_STR.indexOf(e.charAt(p++)),a=this.KEY_STR.indexOf(e.charAt(p++)),l=this.KEY_STR.indexOf(e.charAt(p++)),d=this.KEY_STR.indexOf(e.charAt(p++)),n=s<<2|a>>4,o=(15&a)<<4|l>>2,r=(3&l)<<6|d,i.push(n),64!==l&&i.push(o),64!==d&&i.push(r),n=o=r="",s=a=l=d="",!(p<e.length))break;return i},e}(),r=function(e,t){var i,n,o,r,s,a,l,d,p;if(o=!1,p=!0,n=e.document,d=n.documentElement,i=n.addEventListener?"addEventListener":"attachEvent",l=n.addEventListener?"removeEventListener":"detachEvent",a=n.addEventListener?"":"on",r=function(i){if("readystatechange"!==i.type||"complete"===n.readyState)return("load"===i.type?e:n)[l](a+i.type,r,!1),!o&&(o=!0)?t.call(e,i.type||i):void 0},s=function(){var e;try{d.doScroll("left")}catch(t){return e=t,void setTimeout(s,50)}return r("poll")},"complete"!==n.readyState){if(n.createEventObject&&d.doScroll){try{p=!e.frameElement}catch(e){}p&&s()}return n[i](a+"DOMContentLoaded",r,!1),n[i](a+"readystatechange",r,!1),e[i](a+"load",r,!1)}},t._autoDiscoverFunction=function(){if(t.autoDiscover)return t.discover()},r(window,t._autoDiscoverFunction)}).call(this)}).call(t,i(9)(e))},function(e,t){e.exports=' <form :action=url class="vue-dropzone dropzone" :id=id> <slot></slot> </form> '},function(e,t,i){function n(e,t){for(var i=0;i<e.length;i++){var n=e[i],o=u[n.id];if(o){o.refs++;for(var r=0;r<o.parts.length;r++)o.parts[r](n.parts[r]);for(;r<n.parts.length;r++)o.parts.push(l(n.parts[r],t))}else{for(var s=[],r=0;r<n.parts.length;r++)s.push(l(n.parts[r],t));u[n.id]={id:n.id,refs:1,parts:s}}}}function o(e){for(var t=[],i={},n=0;n<e.length;n++){var o=e[n],r=o[0],s=o[1],a=o[2],l=o[3],d={css:s,media:a,sourceMap:l};i[r]?i[r].parts.push(d):t.push(i[r]={id:r,parts:[d]})}return t}function r(e,t){var i=f(),n=v[v.length-1];if("top"===e.insertAt)n?n.nextSibling?i.insertBefore(t,n.nextSibling):i.appendChild(t):i.insertBefore(t,i.firstChild),v.push(t);else{if("bottom"!==e.insertAt)throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");i.appendChild(t)}}function s(e){e.parentNode.removeChild(e);var t=v.indexOf(e);t>=0&&v.splice(t,1)}function a(e){var t=document.createElement("style");return t.type="text/css",r(e,t),t}function l(e,t){var i,n,o;if(t.singleton){var r=g++;i=m||(m=a(t)),n=d.bind(null,i,r,!1),o=d.bind(null,i,r,!0)}else i=a(t),n=p.bind(null,i),o=function(){s(i)};return n(e),function(t){if(t){if(t.css===e.css&&t.media===e.media&&t.sourceMap===e.sourceMap)return;n(e=t)}else o()}}function d(e,t,i,n){var o=i?"":n.css;if(e.styleSheet)e.styleSheet.cssText=z(t,o);else{var r=document.createTextNode(o),s=e.childNodes;s[t]&&e.removeChild(s[t]),s.length?e.insertBefore(r,s[t]):e.appendChild(r)}}function p(e,t){var i=t.css,n=t.media,o=t.sourceMap;if(n&&e.setAttribute("media",n),o&&(i+="\n/*# sourceURL="+o.sources[0]+" */",i+="\n/*# sourceMappingURL=data:application/json;base64,"+btoa(unescape(encodeURIComponent(JSON.stringify(o))))+" */"),e.styleSheet)e.styleSheet.cssText=i;else{for(;e.firstChild;)e.removeChild(e.firstChild);e.appendChild(document.createTextNode(i))}}var u={},c=function(e){var t;return function(){return"undefined"==typeof t&&(t=e.apply(this,arguments)),t}},h=c(function(){return/msie [6-9]\b/.test(window.navigator.userAgent.toLowerCase())}),f=c(function(){return document.head||document.getElementsByTagName("head")[0]}),m=null,g=0,v=[];e.exports=function(e,t){t=t||{},"undefined"==typeof t.singleton&&(t.singleton=h()),"undefined"==typeof t.insertAt&&(t.insertAt="bottom");var i=o(e);return n(i,t),function(e){for(var r=[],s=0;s<i.length;s++){var a=i[s],l=u[a.id];l.refs--,r.push(l)}if(e){var d=o(e);n(d,t)}for(var s=0;s<r.length;s++){var l=r[s];if(0===l.refs){for(var p=0;p<l.parts.length;p++)l.parts[p]();delete u[l.id]}}}};var z=function(){var e=[];return function(t,i){return e[t]=i,e.filter(Boolean).join("\n")}}()},function(e,t,i){var n=i(4);"string"==typeof n&&(n=[[e.id,n,""]]);i(7)(n,{});n.locals&&(e.exports=n.locals)},function(e,t){e.exports=function(e){return e.webpackPolyfill||(e.deprecate=function(){},e.paths=[],e.children=[],e.webpackPolyfill=1),e}}])});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 229 */
/***/ (function(module, exports) {

	/* (ignored) */

/***/ })
]);


// WEBPACK FOOTER //
// static/js/main.5b1b8ea9d19dbadd2e23.js